import _classCallCheck from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _defineProperty from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

var _mxLib;

window.mxLoadStylesheets = !0, window.mxLoadResources = !0, window.mxForceIncludes = !1, window.mxResourceExtension = ".txt", window.urlParams = function (t) {
  var e = new Object(),
      i = t.lastIndexOf("?");
  if (i > 0) for (var n = t.substring(i + 1).split("&"), s = 0; s < n.length; s++) {
    (i = n[s].indexOf("=")) > 0 && (e[n[s].substring(0, i)] = n[s].substring(i + 1));
  }
  return e;
}(window.location.href), function () {
  var t,
      e,
      i,
      n = void 0,
      s = !0,
      o = null,
      l = !1,
      r = ["aliceblue,antiquewhite,aqua,aquamarine,azure,beige,bisque,black,blanchedalmond,blue,blueviolet,brown,burlywood,cadetblue,chartreuse,chocolate,coral,cornflowerblue,cornsilk,crimson,cyan,darkblue,darkcyan,darkgoldenrod,darkgray,darkgreen,darkkhaki,darkmagenta,darkolivegreen,darkorange,darkorchid,darkred,darksalmon,darkseagreen,darkslateblue,darkslategray,darkturquoise,darkviolet,deeppink,deepskyblue,dimgray,dodgerblue,firebrick,floralwhite,forestgreen,fuchsia,gainsboro,ghostwhite,gold,goldenrod,gray,green,greenyellow,honeydew,hotpink,indianred,indigo,ivory,khaki,lavender,lavenderblush,lawngreen,lemonchiffon,lightblue,lightcoral,lightcyan,lightgoldenrodyellow,lightgreen,lightgrey,lightpink,lightsalmon,lightseagreen,lightskyblue,lightslategray,lightsteelblue,lightyellow,lime,limegreen,linen,magenta,maroon,mediumaquamarine,mediumblue,mediumorchid,mediumpurple,mediumseagreen,mediumslateblue,mediumspringgreen,mediumturquoise,mediumvioletred,midnightblue,mintcream,mistyrose,moccasin,navajowhite,navy,oldlace,olive,olivedrab,orange,orangered,orchid,palegoldenrod,palegreen,paleturquoise,palevioletred,papayawhip,peachpuff,peru,pink,plum,powderblue,purple,red,rosybrown,royalblue,saddlebrown,salmon,sandybrown,seagreen,seashell,sienna,silver,skyblue,slateblue,slategray,snow,springgreen,steelblue,tan,teal,thistle,tomato,transparent,turquoise,violet,wheat,white,whitesmoke,yellow,yellowgreen".split(","), "all-scroll,col-resize,crosshair,default,e-resize,hand,help,move,n-resize,ne-resize,no-drop,not-allowed,nw-resize,pointer,progress,row-resize,s-resize,se-resize,sw-resize,text,vertical-text,w-resize,wait".split(","), "armenian,decimal,decimal-leading-zero,disc,georgian,lower-alpha,lower-greek,lower-latin,lower-roman,square,upper-alpha,upper-latin,upper-roman".split(","), "100,200,300,400,500,600,700,800,900,bold,bolder,lighter".split(","), "block-level,inline-level,table-caption,table-cell,table-column,table-column-group,table-footer-group,table-header-group,table-row,table-row-group".split(","), "condensed,expanded,extra-condensed,extra-expanded,narrower,semi-condensed,semi-expanded,ultra-condensed,ultra-expanded,wider".split(","), "inherit,inline,inline-block,inline-box,inline-flex,inline-grid,inline-list-item,inline-stack,inline-table,run-in".split(","), "behind,center-left,center-right,far-left,far-right,left-side,leftwards,right-side,rightwards".split(","), "large,larger,small,smaller,x-large,x-small,xx-large,xx-small".split(","), "dashed,dotted,double,groove,outset,ridge,solid".split(","), "ease,ease-in,ease-in-out,ease-out,linear,step-end,step-start".split(","), "at,closest-corner,closest-side,ellipse,farthest-corner,farthest-side".split(","), "baseline,middle,sub,super,text-bottom,text-top".split(","), "caption,icon,menu,message-box,small-caption,status-bar".split(","), "fast,faster,slow,slower,x-fast,x-slow".split(","), ["above", "below", "higher", "level", "lower"], ["cursive", "fantasy", "monospace", "sans-serif", "serif"], ["loud", "silent", "soft", "x-loud", "x-soft"], ["no-repeat", "repeat-x", "repeat-y", "round", "space"], ["blink", "line-through", "overline", "underline"], ["block", "flex", "grid", "table"], ["high", "low", "x-high", "x-low"], ["nowrap", "pre", "pre-line", "pre-wrap"], ["absolute", "relative", "static"], ["alternate", "alternate-reverse", "reverse"], ["border-box", "content-box", "padding-box"], ["capitalize", "lowercase", "uppercase"], ["child", "female", "male"], ["=", "opacity"], ["backwards", "forwards"], ["bidi-override", "embed"], ["bottom", "top"], ["break-all", "keep-all"], ["clip", "ellipsis"], ["contain", "cover"], ["continuous", "digits"], ["end", "start"], ["flat", "preserve-3d"], ["hide", "show"], ["horizontal", "vertical"], ["inside", "outside"], ["italic", "oblique"], ["left", "right"], ["ltr", "rtl"], ["no-content", "no-display"], ["paused", "running"], ["suppress", "unrestricted"], ["thick", "thin"], [","], ["/"], ["all"], ["always"], ["auto"], ["avoid"], ["both"], ["break-word"], ["center"], ["circle"], ["code"], ["collapse"], ["contents"], ["fixed"], ["hidden"], ["infinite"], ["inset"], ["invert"], ["justify"], ["list-item"], ["local"], ["medium"], ["mix"], ["none"], ["normal"], ["once"], ["repeat"], ["scroll"], ["separate"], ["small-caps"], ["spell-out"], ["to"], ["visible"]],
      a = {
    animation: {
      cssPropBits: 517,
      cssLitGroup: [r[10], r[24], r[29], r[45], r[48], r[54], r[63], r[71], r[72]],
      cssFns: ["cubic-bezier()", "steps()"]
    },
    "animation-delay": {
      cssPropBits: 5,
      cssLitGroup: [r[48]],
      cssFns: []
    },
    "animation-direction": {
      cssPropBits: 0,
      cssLitGroup: [r[24], r[48], r[72]],
      cssFns: []
    },
    "animation-duration": "animation-delay",
    "animation-fill-mode": {
      cssPropBits: 0,
      cssLitGroup: [r[29], r[48], r[54], r[71]],
      cssFns: []
    },
    "animation-iteration-count": {
      cssPropBits: 5,
      cssLitGroup: [r[48], r[63]],
      cssFns: []
    },
    "animation-name": {
      cssPropBits: 512,
      cssLitGroup: [r[48], r[71]],
      cssFns: []
    },
    "animation-play-state": {
      cssPropBits: 0,
      cssLitGroup: [r[45], r[48]],
      cssFns: []
    },
    "animation-timing-function": {
      cssPropBits: 0,
      cssLitGroup: [r[10], r[48]],
      cssFns: ["cubic-bezier()", "steps()"]
    },
    appearance: {
      cssPropBits: 0,
      cssLitGroup: [r[71]],
      cssFns: []
    },
    azimuth: {
      cssPropBits: 5,
      cssLitGroup: [r[7], r[42], r[56]],
      cssFns: []
    },
    "backface-visibility": {
      cssPropBits: 0,
      cssLitGroup: [r[59], r[62], r[80]],
      cssFns: []
    },
    background: {
      cssPropBits: 23,
      cssLitGroup: [r[0], r[18], r[25], r[31], r[34], r[42], r[48], r[49], r[52], r[56], r[61], r[68], r[71], r[74], r[75]],
      cssFns: "image(),linear-gradient(),radial-gradient(),repeating-linear-gradient(),repeating-radial-gradient(),rgb(),rgba()".split(",")
    },
    "background-attachment": {
      cssPropBits: 0,
      cssLitGroup: [r[48], r[61], r[68], r[75]],
      cssFns: []
    },
    "background-color": {
      cssPropBits: 2,
      cssLitGroup: [r[0]],
      cssFns: ["rgb()", "rgba()"]
    },
    "background-image": {
      cssPropBits: 16,
      cssLitGroup: [r[48], r[71]],
      cssFns: ["image()", "linear-gradient()", "radial-gradient()", "repeating-linear-gradient()", "repeating-radial-gradient()"]
    },
    "background-position": {
      cssPropBits: 5,
      cssLitGroup: [r[31], r[42], r[48], r[56]],
      cssFns: []
    },
    "background-repeat": {
      cssPropBits: 0,
      cssLitGroup: [r[18], r[48], r[74]],
      cssFns: []
    },
    "background-size": {
      cssPropBits: 5,
      cssLitGroup: [r[34], r[48], r[52]],
      cssFns: []
    },
    border: {
      cssPropBits: 7,
      cssLitGroup: [r[0], r[9], r[47], r[62], r[64], r[69], r[71]],
      cssFns: ["rgb()", "rgba()"]
    },
    "border-bottom": "border",
    "border-bottom-color": "background-color",
    "border-bottom-left-radius": {
      cssPropBits: 5,
      cssFns: []
    },
    "border-bottom-right-radius": "border-bottom-left-radius",
    "border-bottom-style": {
      cssPropBits: 0,
      cssLitGroup: [r[9], r[62], r[64], r[71]],
      cssFns: []
    },
    "border-bottom-width": {
      cssPropBits: 5,
      cssLitGroup: [r[47], r[69]],
      cssFns: []
    },
    "border-collapse": {
      cssPropBits: 0,
      cssLitGroup: [r[59], r[76]],
      cssFns: []
    },
    "border-color": "background-color",
    "border-left": "border",
    "border-left-color": "background-color",
    "border-left-style": "border-bottom-style",
    "border-left-width": "border-bottom-width",
    "border-radius": {
      cssPropBits: 5,
      cssLitGroup: [r[49]],
      cssFns: []
    },
    "border-right": "border",
    "border-right-color": "background-color",
    "border-right-style": "border-bottom-style",
    "border-right-width": "border-bottom-width",
    "border-spacing": "border-bottom-left-radius",
    "border-style": "border-bottom-style",
    "border-top": "border",
    "border-top-color": "background-color",
    "border-top-left-radius": "border-bottom-left-radius",
    "border-top-right-radius": "border-bottom-left-radius",
    "border-top-style": "border-bottom-style",
    "border-top-width": "border-bottom-width",
    "border-width": "border-bottom-width",
    bottom: {
      cssPropBits: 5,
      cssLitGroup: [r[52]],
      cssFns: []
    },
    box: {
      cssPropBits: 0,
      cssLitGroup: [r[60], r[71], r[72]],
      cssFns: []
    },
    "box-shadow": {
      cssPropBits: 7,
      cssLitGroup: [r[0], r[48], r[64], r[71]],
      cssFns: ["rgb()", "rgba()"]
    },
    "box-sizing": {
      cssPropBits: 0,
      cssLitGroup: [r[25]],
      cssFns: []
    },
    "caption-side": {
      cssPropBits: 0,
      cssLitGroup: [r[31]],
      cssFns: []
    },
    clear: {
      cssPropBits: 0,
      cssLitGroup: [r[42], r[54], r[71]],
      cssFns: []
    },
    clip: {
      cssPropBits: 0,
      cssLitGroup: [r[52]],
      cssFns: ["rect()"]
    },
    color: "background-color",
    content: {
      cssPropBits: 8,
      cssLitGroup: [r[71], r[72]],
      cssFns: []
    },
    cue: {
      cssPropBits: 16,
      cssLitGroup: [r[71]],
      cssFns: []
    },
    "cue-after": "cue",
    "cue-before": "cue",
    cursor: {
      cssPropBits: 16,
      cssLitGroup: [r[1], r[48], r[52]],
      cssFns: []
    },
    direction: {
      cssPropBits: 0,
      cssLitGroup: [r[43]],
      cssFns: []
    },
    display: {
      cssPropBits: 0,
      cssLitGroup: [r[4], r[6], r[20], r[52], r[67], r[71]],
      cssFns: []
    },
    "display-extras": {
      cssPropBits: 0,
      cssLitGroup: [r[67], r[71]],
      cssFns: []
    },
    "display-inside": {
      cssPropBits: 0,
      cssLitGroup: [r[20], r[52]],
      cssFns: []
    },
    "display-outside": {
      cssPropBits: 0,
      cssLitGroup: [r[4], r[71]],
      cssFns: []
    },
    elevation: {
      cssPropBits: 5,
      cssLitGroup: [r[15]],
      cssFns: []
    },
    "empty-cells": {
      cssPropBits: 0,
      cssLitGroup: [r[38]],
      cssFns: []
    },
    filter: {
      cssPropBits: 0,
      cssFns: ["alpha()"]
    },
    float: {
      cssPropBits: 0,
      cssLitGroup: [r[42], r[71]],
      cssFns: []
    },
    font: {
      cssPropBits: 73,
      cssLitGroup: [r[3], r[8], r[13], r[16], r[41], r[48], r[49], r[69], r[72], r[77]],
      cssFns: []
    },
    "font-family": {
      cssPropBits: 72,
      cssLitGroup: [r[16], r[48]],
      cssFns: []
    },
    "font-size": {
      cssPropBits: 1,
      cssLitGroup: [r[8], r[69]],
      cssFns: []
    },
    "font-stretch": {
      cssPropBits: 0,
      cssLitGroup: [r[5], r[72]],
      cssFns: []
    },
    "font-style": {
      cssPropBits: 0,
      cssLitGroup: [r[41], r[72]],
      cssFns: []
    },
    "font-variant": {
      cssPropBits: 0,
      cssLitGroup: [r[72], r[77]],
      cssFns: []
    },
    "font-weight": {
      cssPropBits: 0,
      cssLitGroup: [r[3], r[72]],
      cssFns: []
    },
    height: "bottom",
    left: "bottom",
    "letter-spacing": {
      cssPropBits: 5,
      cssLitGroup: [r[72]],
      cssFns: []
    },
    "line-height": {
      cssPropBits: 1,
      cssLitGroup: [r[72]],
      cssFns: []
    },
    "list-style": {
      cssPropBits: 16,
      cssLitGroup: [r[2], r[40], r[57], r[71]],
      cssFns: ["image()", "linear-gradient()", "radial-gradient()", "repeating-linear-gradient()", "repeating-radial-gradient()"]
    },
    "list-style-image": {
      cssPropBits: 16,
      cssLitGroup: [r[71]],
      cssFns: ["image()", "linear-gradient()", "radial-gradient()", "repeating-linear-gradient()", "repeating-radial-gradient()"]
    },
    "list-style-position": {
      cssPropBits: 0,
      cssLitGroup: [r[40]],
      cssFns: []
    },
    "list-style-type": {
      cssPropBits: 0,
      cssLitGroup: [r[2], r[57], r[71]],
      cssFns: []
    },
    margin: "bottom",
    "margin-bottom": "bottom",
    "margin-left": "bottom",
    "margin-right": "bottom",
    "margin-top": "bottom",
    "max-height": {
      cssPropBits: 1,
      cssLitGroup: [r[52], r[71]],
      cssFns: []
    },
    "max-width": "max-height",
    "min-height": {
      cssPropBits: 1,
      cssLitGroup: [r[52]],
      cssFns: []
    },
    "min-width": "min-height",
    opacity: {
      cssPropBits: 1,
      cssFns: []
    },
    outline: {
      cssPropBits: 7,
      cssLitGroup: [r[0], r[9], r[47], r[62], r[64], r[65], r[69], r[71]],
      cssFns: ["rgb()", "rgba()"]
    },
    "outline-color": {
      cssPropBits: 2,
      cssLitGroup: [r[0], r[65]],
      cssFns: ["rgb()", "rgba()"]
    },
    "outline-style": "border-bottom-style",
    "outline-width": "border-bottom-width",
    overflow: {
      cssPropBits: 0,
      cssLitGroup: [r[52], r[62], r[75], r[80]],
      cssFns: []
    },
    "overflow-wrap": {
      cssPropBits: 0,
      cssLitGroup: [r[55], r[72]],
      cssFns: []
    },
    "overflow-x": {
      cssPropBits: 0,
      cssLitGroup: [r[44], r[52], r[62], r[75], r[80]],
      cssFns: []
    },
    "overflow-y": "overflow-x",
    padding: "opacity",
    "padding-bottom": "opacity",
    "padding-left": "opacity",
    "padding-right": "opacity",
    "padding-top": "opacity",
    "page-break-after": {
      cssPropBits: 0,
      cssLitGroup: [r[42], r[51], r[52], r[53]],
      cssFns: []
    },
    "page-break-before": "page-break-after",
    "page-break-inside": {
      cssPropBits: 0,
      cssLitGroup: [r[52], r[53]],
      cssFns: []
    },
    pause: "border-bottom-left-radius",
    "pause-after": "border-bottom-left-radius",
    "pause-before": "border-bottom-left-radius",
    perspective: {
      cssPropBits: 5,
      cssLitGroup: [r[71]],
      cssFns: []
    },
    "perspective-origin": {
      cssPropBits: 5,
      cssLitGroup: [r[31], r[42], r[56]],
      cssFns: []
    },
    pitch: {
      cssPropBits: 5,
      cssLitGroup: [r[21], r[69]],
      cssFns: []
    },
    "pitch-range": "border-bottom-left-radius",
    "play-during": {
      cssPropBits: 16,
      cssLitGroup: [r[52], r[70], r[71], r[74]],
      cssFns: []
    },
    position: {
      cssPropBits: 0,
      cssLitGroup: [r[23]],
      cssFns: []
    },
    quotes: {
      cssPropBits: 8,
      cssLitGroup: [r[71]],
      cssFns: []
    },
    resize: {
      cssPropBits: 0,
      cssLitGroup: [r[39], r[54], r[71]],
      cssFns: []
    },
    richness: "border-bottom-left-radius",
    right: "bottom",
    speak: {
      cssPropBits: 0,
      cssLitGroup: [r[71], r[72], r[78]],
      cssFns: []
    },
    "speak-header": {
      cssPropBits: 0,
      cssLitGroup: [r[51], r[73]],
      cssFns: []
    },
    "speak-numeral": {
      cssPropBits: 0,
      cssLitGroup: [r[35]],
      cssFns: []
    },
    "speak-punctuation": {
      cssPropBits: 0,
      cssLitGroup: [r[58], r[71]],
      cssFns: []
    },
    "speech-rate": {
      cssPropBits: 5,
      cssLitGroup: [r[14], r[69]],
      cssFns: []
    },
    stress: "border-bottom-left-radius",
    "table-layout": {
      cssPropBits: 0,
      cssLitGroup: [r[52], r[61]],
      cssFns: []
    },
    "text-align": {
      cssPropBits: 0,
      cssLitGroup: [r[42], r[56], r[66]],
      cssFns: []
    },
    "text-decoration": {
      cssPropBits: 0,
      cssLitGroup: [r[19], r[71]],
      cssFns: []
    },
    "text-indent": "border-bottom-left-radius",
    "text-overflow": {
      cssPropBits: 8,
      cssLitGroup: [r[33]],
      cssFns: []
    },
    "text-shadow": "box-shadow",
    "text-transform": {
      cssPropBits: 0,
      cssLitGroup: [r[26], r[71]],
      cssFns: []
    },
    "text-wrap": {
      cssPropBits: 0,
      cssLitGroup: [r[46], r[71], r[72]],
      cssFns: []
    },
    top: "bottom",
    transform: {
      cssPropBits: 0,
      cssLitGroup: [r[71]],
      cssFns: "matrix(),perspective(),rotate(),rotate3d(),rotatex(),rotatey(),rotatez(),scale(),scale3d(),scalex(),scaley(),scalez(),skew(),skewx(),skewy(),translate(),translate3d(),translatex(),translatey(),translatez()".split(",")
    },
    "transform-origin": "perspective-origin",
    "transform-style": {
      cssPropBits: 0,
      cssLitGroup: [r[37]],
      cssFns: []
    },
    transition: {
      cssPropBits: 1029,
      cssLitGroup: [r[10], r[48], r[50], r[71]],
      cssFns: ["cubic-bezier()", "steps()"]
    },
    "transition-delay": "animation-delay",
    "transition-duration": "animation-delay",
    "transition-property": {
      cssPropBits: 1024,
      cssLitGroup: [r[48], r[50]],
      cssFns: []
    },
    "transition-timing-function": "animation-timing-function",
    "unicode-bidi": {
      cssPropBits: 0,
      cssLitGroup: [r[30], r[72]],
      cssFns: []
    },
    "vertical-align": {
      cssPropBits: 5,
      cssLitGroup: [r[12], r[31]],
      cssFns: []
    },
    visibility: "backface-visibility",
    "voice-family": {
      cssPropBits: 8,
      cssLitGroup: [r[27], r[48]],
      cssFns: []
    },
    volume: {
      cssPropBits: 1,
      cssLitGroup: [r[17], r[69]],
      cssFns: []
    },
    "white-space": {
      cssPropBits: 0,
      cssLitGroup: [r[22], r[72]],
      cssFns: []
    },
    width: "min-height",
    "word-break": {
      cssPropBits: 0,
      cssLitGroup: [r[32], r[72], r[55]],
      cssFns: []
    },
    "word-spacing": "letter-spacing",
    "word-wrap": "overflow-wrap",
    "z-index": "bottom",
    zoom: "line-height",
    "cubic-bezier()": "animation-delay",
    "steps()": {
      cssPropBits: 5,
      cssLitGroup: [r[36], r[48]],
      cssFns: []
    },
    "image()": {
      cssPropBits: 18,
      cssLitGroup: [r[0], r[48]],
      cssFns: ["rgb()", "rgba()"]
    },
    "linear-gradient()": {
      cssPropBits: 7,
      cssLitGroup: [r[0], r[31], r[42], r[48], r[79]],
      cssFns: ["rgb()", "rgba()"]
    },
    "radial-gradient()": {
      cssPropBits: 7,
      cssLitGroup: [r[0], r[11], r[31], r[42], r[48], r[56], r[57]],
      cssFns: ["rgb()", "rgba()"]
    },
    "repeating-linear-gradient()": "linear-gradient()",
    "repeating-radial-gradient()": "radial-gradient()",
    "rgb()": {
      cssPropBits: 1,
      cssLitGroup: [r[48]],
      cssFns: []
    },
    "rgba()": "rgb()",
    "rect()": {
      cssPropBits: 5,
      cssLitGroup: [r[48], r[52]],
      cssFns: []
    },
    "alpha()": {
      cssPropBits: 1,
      cssLitGroup: [r[28]],
      cssFns: []
    },
    "matrix()": "animation-delay",
    "perspective()": "border-bottom-left-radius",
    "rotate()": "border-bottom-left-radius",
    "rotate3d()": "animation-delay",
    "rotatex()": "border-bottom-left-radius",
    "rotatey()": "border-bottom-left-radius",
    "rotatez()": "border-bottom-left-radius",
    "scale()": "animation-delay",
    "scale3d()": "animation-delay",
    "scalex()": "border-bottom-left-radius",
    "scaley()": "border-bottom-left-radius",
    "scalez()": "border-bottom-left-radius",
    "skew()": "animation-delay",
    "skewx()": "border-bottom-left-radius",
    "skewy()": "border-bottom-left-radius",
    "translate()": "animation-delay",
    "translate3d()": "animation-delay",
    "translatex()": "border-bottom-left-radius",
    "translatey()": "border-bottom-left-radius",
    "translatez()": "border-bottom-left-radius"
  };

  for (t in a) {
    "string" == typeof a[t] && Object.hasOwnProperty.call(a, t) && (a[t] = a[a[t]]);
  }

  "undefined" != typeof window && (window.cssSchema = a), function () {
    function t(t) {
      var e = parseInt(t.substring(1), 16);
      return 65535 < e ? (e -= 65536, String.fromCharCode(55296 + (e >> 10), 56320 + (1023 & e))) : e == e ? String.fromCharCode(e) : " " > t[1] ? "" : t[1];
    }

    function n(t, e) {
      return '"' + t.replace(/[\u0000-\u001f\\\"<>]/g, e) + '"';
    }

    function s(t) {
      return l[t] || (l[t] = "\\" + t.charCodeAt(0).toString(16) + " ");
    }

    function o(t) {
      return r[t] || (r[t] = ("" > t ? "%0" : "%") + t.charCodeAt(0).toString(16));
    }

    var l = {
      "\\": "\\\\"
    },
        r = {
      "\\": "%5c"
    },
        a = RegExp("\\uFEFF|U[+][0-9A-F?]{1,6}(?:-[0-9A-F]{1,6})?|url[(][\\t\\n\\f ]*(?:\"(?:'|[^'\"\\n\\f\\\\]|\\\\[\\s\\S])*\"|'(?:\"|[^'\"\\n\\f\\\\]|\\\\[\\s\\S])*'|(?:[\\t\\x21\\x23-\\x26\\x28-\\x5b\\x5d-\\x7e]|[\\u0080-\\ud7ff\\ue000-\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]|\\\\(?:[0-9a-fA-F]{1,6}[\\t\\n\\f ]?|[\\u0020-\\u007e\\u0080-\\ud7ff\\ue000\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]))*)[\\t\\n\\f ]*[)]|(?!url[(])-?(?:[a-zA-Z_]|[\\u0080-\\ud7ff\\ue000-\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]|\\\\(?:[0-9a-fA-F]{1,6}[\\t\\n\\f ]?|[\\u0020-\\u007e\\u0080-\\ud7ff\\ue000\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]))(?:[a-zA-Z0-9_-]|[\\u0080-\\ud7ff\\ue000-\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]|\\\\(?:[0-9a-fA-F]{1,6}[\\t\\n\\f ]?|[\\u0020-\\u007e\\u0080-\\ud7ff\\ue000\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]))*[(]|(?:@?-?(?:[a-zA-Z_]|[\\u0080-\\ud7ff\\ue000-\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]|\\\\(?:[0-9a-fA-F]{1,6}[\\t\\n\\f ]?|[\\u0020-\\u007e\\u0080-\\ud7ff\\ue000\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]))|#)(?:[a-zA-Z0-9_-]|[\\u0080-\\ud7ff\\ue000-\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]|\\\\(?:[0-9a-fA-F]{1,6}[\\t\\n\\f ]?|[\\u0020-\\u007e\\u0080-\\ud7ff\\ue000\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]))*|\"(?:'|[^'\"\\n\\f\\\\]|\\\\[\\s\\S])*\"|'(?:\"|[^'\"\\n\\f\\\\]|\\\\[\\s\\S])*'|[-+]?(?:[0-9]+(?:[.][0-9]+)?|[.][0-9]+)(?:%|-?(?:[a-zA-Z_]|[\\u0080-\\ud7ff\\ue000-\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]|\\\\(?:[0-9a-fA-F]{1,6}[\\t\\n\\f ]?|[\\u0020-\\u007e\\u0080-\\ud7ff\\ue000\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]))(?:[a-zA-Z0-9_-]|[\\u0080-\\ud7ff\\ue000-\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]|\\\\(?:[0-9a-fA-F]{1,6}[\\t\\n\\f ]?|[\\u0020-\\u007e\\u0080-\\ud7ff\\ue000\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff]))*)?|<!--|-->|[\\t\\n\\f ]+|/(?:[*][^*]*[*]+(?:[^/][^*]*[*]+)*/|/[^\\n\\f]*)|[~|^$*]=|[^\"'\\\\/]|/(?![/*])", "gi"),
        h = RegExp("\\\\(?:(?:[0-9a-fA-F]{1,6}[\\t\\n\\f ]?|[\\u0020-\\u007e\\u0080-\\ud7ff\\ue000\\ufffd]|[\\ud800-\\udbff][\\udc00-\\udfff])|[\\n\\f])", "g"),
        u = RegExp("^url\\([\\t\\n\\f ]*[\"']?|[\"']?[\\t\\n\\f ]*\\)$", "gi");
    i = function i(e) {
      return e.replace(h, t);
    }, e = function e(t) {
      for (var e = 0, l = " ", r = 0, h = (t = ("" + t).replace(/\r\n?/g, "\n").match(a) || []).length; r < h; ++r) {
        var d,
            p = (d = i(t[r])).length,
            c = d.charCodeAt(0);
        l == (d = 34 == c || 39 == c ? n(d.substring(1, p - 1), s) : 47 == c && 1 < p || "\\" == d || "--\x3e" == d || "\x3c!--" == d || "\uFEFF" == d || 32 >= c ? " " : /url\(/i.test(d) ? "url(" + n(d.replace(u, ""), o) + ")" : d) && " " == d || (t[e++] = l = d);
      }

      return t.length = e, t;
    };
  }(), "undefined" != typeof window && (window.lexCss = e, window.decodeCss = i);

  var h = function () {
    function t(t) {
      return (t = ("" + t).match(u)) ? new l(r(t[1]), r(t[2]), r(t[3]), r(t[4]), r(t[5]), r(t[6]), r(t[7])) : o;
    }

    function e(t, e) {
      return "string" == typeof t ? encodeURI(t).replace(e, i) : o;
    }

    function i(t) {
      return t = t.charCodeAt(0), "%" + "0123456789ABCDEF".charAt(t >> 4 & 15) + "0123456789ABCDEF".charAt(15 & t);
    }

    function n(t) {
      if (t === o) return o;
      t = t.replace(/(^|\/)\.(?:\/|$)/g, "$1").replace(/\/{2,}/g, "/");

      for (var e, i = a; (e = t.replace(i, "$1")) != t; t = e) {
        ;
      }

      return t;
    }

    function s(t, e) {
      var i = t.T(),
          s = e.K();
      s ? i.ga(e.j) : s = e.X(), s ? i.da(e.n) : s = e.Y(), s ? i.ea(e.k) : s = e.$();
      var o = e.g,
          l = n(o);
      if (s) i.ca(e.V()), l = l && l.replace(h, "");else if (s = !!o) {
        if (47 !== l.charCodeAt(0)) {
          var r = (l = n(i.g || "").replace(h, "")).lastIndexOf("/") + 1;
          l = n((r ? l.substring(0, r) : "") + n(o)).replace(h, "");
        }
      } else (l = l && l.replace(h, "")) !== o && i.G(l);
      return s ? i.G(l) : s = e.aa(), s ? i.O(e.l) : s = e.Z(), s && i.fa(e.o), i;
    }

    function l(t, e, i, n, s, o, l) {
      this.j = t, this.n = e, this.k = i, this.h = n, this.g = s, this.l = o, this.o = l;
    }

    function r(t) {
      return "string" == typeof t && 0 < t.length ? t : o;
    }

    var a = RegExp(/(\/|^)(?:[^.\/][^\/]*|\.{2,}(?:[^.\/][^\/]*)|\.{3,}[^\/]*)\/\.\.(?:\/|$)/),
        h = /^(?:\.\.\/)*(?:\.\.$)?/;
    l.prototype.toString = function () {
      var t = [];
      return o !== this.j && t.push(this.j, ":"), o !== this.k && (t.push("//"), o !== this.n && t.push(this.n, "@"), t.push(this.k), o !== this.h && t.push(":", this.h.toString())), o !== this.g && t.push(this.g), o !== this.l && t.push("?", this.l), o !== this.o && t.push("#", this.o), t.join("");
    }, l.prototype.T = function () {
      return new l(this.j, this.n, this.k, this.h, this.g, this.l, this.o);
    }, l.prototype.W = function () {
      return this.j && decodeURIComponent(this.j).toLowerCase();
    }, l.prototype.ga = function (t) {
      this.j = t || o;
    }, l.prototype.K = function () {
      return o !== this.j;
    }, l.prototype.da = function (t) {
      this.n = t || o;
    }, l.prototype.X = function () {
      return o !== this.n;
    }, l.prototype.ea = function (t) {
      this.k = t || o, this.G(this.g);
    }, l.prototype.Y = function () {
      return o !== this.k;
    }, l.prototype.V = function () {
      return this.h && decodeURIComponent(this.h);
    }, l.prototype.ca = function (t) {
      if (t) {
        if ((t = Number(t)) !== (65535 & t)) throw Error("Bad port number " + t);
        this.h = "" + t;
      } else this.h = o;
    }, l.prototype.$ = function () {
      return o !== this.h;
    }, l.prototype.U = function () {
      return this.g && decodeURIComponent(this.g);
    }, l.prototype.G = function (t) {
      t ? (t = "" + t, this.g = !this.k || /^\//.test(t) ? t : "/" + t) : this.g = o;
    }, l.prototype.O = function (t) {
      this.l = t || o;
    }, l.prototype.aa = function () {
      return o !== this.l;
    }, l.prototype.ba = function (t) {
      if ("object" == typeof t && !(t instanceof Array) && (t instanceof Object || "[object Array]" !== Object.prototype.toString.call(t))) {
        var e,
            i = [],
            n = -1;

        for (e in t) {
          var s = t[e];
          "string" == typeof s && (i[++n] = e, i[++n] = s);
        }

        t = i;
      }

      i = [], n = "";

      for (var o = 0; o < t.length;) {
        e = t[o++], s = t[o++], i.push(n, encodeURIComponent(e.toString())), n = "&", s && i.push("=", encodeURIComponent(s.toString()));
      }

      this.l = i.join("");
    }, l.prototype.fa = function (t) {
      this.o = t || o;
    }, l.prototype.Z = function () {
      return o !== this.o;
    };
    var u = /^(?:([^:\/?#]+):)?(?:\/\/(?:([^\/?#]*)@)?([^\/?#:@]*)(?::([0-9]+))?)?([^?#]+)?(?:\?([^#]*))?(?:#(.*))?$/,
        d = /[#\/\?@]/g,
        p = /[\#\?]/g;
    return l.parse = t, l.create = function (t, n, s, r, a, h, u) {
      return t = new l(e(t, d), e(n, d), "string" == typeof s ? encodeURIComponent(s) : o, 0 < r ? r.toString() : o, e(a, p), o, "string" == typeof u ? encodeURIComponent(u) : o), h && ("string" == typeof h ? t.O(h.replace(/[^?&=0-9A-Za-z_\-~.%]/g, i)) : t.ba(h)), t;
    }, l.N = s, l.ma = n, l.ha = {
      ua: function ua(e) {
        return /\.html$/.test(t(e).U()) ? "text/html" : "application/javascript";
      },
      N: function N(e, i) {
        return e ? s(t(e), t(i)).toString() : "" + i;
      }
    }, l;
  }();

  "undefined" != typeof window && (window.URI = h);
  var u,
      d,
      p = n,
      c = n,
      m = n,
      g = n;
  !function () {
    function t(t) {
      return "string" == typeof t ? 'url("' + t.replace(f, e) + '")' : 'url("about:blank")';
    }

    function e(t) {
      return v[t];
    }

    function r(t, e) {
      return t ? h.ha.N(t, e) : e;
    }

    function d(t, e, i) {
      if (!i) return o;
      var n = ("" + t).match(C);
      return !n || n[1] && !E.test(n[1]) ? o : i(t, e);
    }

    function y(t) {
      return t.replace(/^-(?:apple|css|epub|khtml|moz|mso?|o|rim|wap|webkit|xv)-(?=[a-z])/, "");
    }

    var f = /[\n\f\r\"\'()*<>]/g,
        v = {
      "\n": "%0a",
      "\f": "%0c",
      "\r": "%0d",
      '"': "%22",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "*": "%2a",
      "<": "%3c",
      ">": "%3e"
    },
        C = /^(?:([^:\/?# ]+):)?/,
        E = /^(?:https?|mailto|data)$/i;

    p = function () {
      var e = {};
      return function n(s, o, l, h, u) {
        s = y(s);
        var p = a[s];

        if (p && "object" == typeof p) {
          for (var c = p.cssPropBits, m = 80 & c, g = 1536 & c, x = NaN, f = 0, v = 0; f < o.length; ++f) {
            var C,
                E,
                S,
                b,
                w,
                T = o[f].toLowerCase(),
                A = T.charCodeAt(0);
            if (32 === A) T = "";else if (34 === A) T = 16 === m ? l ? t(d(r(h, i(o[f].substring(1, T.length - 1))), s, l)) : "" : 8 & c && !(m & m - 1) ? T : "";else if ("inherit" !== T) {
              if (w = p.cssLitGroup) {
                var L;

                if (!(L = p.cssLitMap)) {
                  L = {};

                  for (var M = w.length; 0 <= --M;) {
                    for (var I = w[M], R = I.length; 0 <= --R;) {
                      L[I[R]] = e;
                    }
                  }

                  L = p.cssLitMap = L;
                }

                w = L;
              } else w = e;

              if (w[y(T)] !== e) if (35 === A && /^#(?:[0-9a-f]{3}){1,2}$/.test(T)) T = 2 & c ? T : "";else if (48 <= A && 57 >= A) T = 1 & c ? T : "";else if (S = 48 <= (C = T.charCodeAt(1)) && 57 >= C, b = 48 <= (E = T.charCodeAt(2)) && 57 >= E, 43 === A && (S || 46 === C && b)) T = 1 & c ? (S ? "" : "0") + T.substring(1) : "";else if (45 === A && (S || 46 === C && b)) T = 4 & c ? (S ? "-" : "-0") + T.substring(1) : 1 & c ? "0" : "";else if (46 === A && S) T = 1 & c ? "0" + T : "";else if ('url("' === T.substring(0, 5)) T = l && 16 & c ? t(d(r(h, o[f].substring(5, T.length - 2)), s, l)) : "";else if ("(" === T.charAt(T.length - 1)) t: {
                for (T = 1, M = (L = f) + 1, A = (w = o).length; M < A && T;) {
                  T += ")" === (I = w[M++]) ? -1 : /^[^"']*\($/.test(I);
                }

                if (!T) for (A = y(T = w[L].toLowerCase()), w = w.splice(L, M - L, ""), M = 0, I = (L = p.cssFns).length; M < I; ++M) {
                  if (L[M].substring(0, A.length) == A) {
                    w[0] = w[w.length - 1] = "", n(L[M], w, l, h), T = T + w.join(" ") + ")";
                    break t;
                  }
                }
                T = "";
              } else T = g && /^-?[a-z_][\w\-]*$/.test(T) && !/__$/.test(T) ? u && 512 === g ? o[f] + u : 1024 === g && a[T] && "number" == typeof a[T].oa ? T : "" : /^\w+$/.test(T) && 64 === m && 8 & c ? x + 1 === v ? (o[x] = o[x].substring(0, o[x].length - 1) + " " + T + '"', "") : (x = v, '"' + T + '"') : "";
            }
            T && (o[v++] = T);
          }

          1 === v && 'url("about:blank")' === o[0] && (v = 0), o.length = v;
        } else o.length = 0;
      };
    }();

    var S = RegExp("^(active|after|before|blank|checked|default|disabled|drop|empty|enabled|first|first-child|first-letter|first-line|first-of-type|fullscreen|focus|hover|in-range|indeterminate|invalid|last-child|last-of-type|left|link|only-child|only-of-type|optional|out-of-range|placeholder-shown|read-only|read-write|required|right|root|scope|user-error|valid|visited)$"),
        b = {};
    b[">"] = b["+"] = b["~"] = b, c = function c(t, e, i) {
      function n(n, r) {
        function a(i, n, o) {
          var r,
              a,
              h,
              p,
              m,
              g = s;
          r = "", i < n && ("*" === (m = t[i]) ? (++i, r = m) : /^[a-zA-Z]/.test(m) && (a = d(m.toLowerCase(), [])) && ("tagName" in a && (m = a.tagName), ++i, r = m));

          for (p = h = a = ""; g && i < n; ++i) {
            if ("#" === (m = t[i]).charAt(0)) /^#_|__$|[^\w#:\-]/.test(m) ? g = l : a += m + u;else if ("." === m) ++i < n && /^[0-9A-Za-z:_\-]+$/.test(m = t[i]) && !/^_|__$/.test(m) ? a += "." + m : g = l;else if (i + 1 < n && "[" === t[i]) {
              ++i;
              var y,
                  f = t[i++].toLowerCase();
              (m = x.m[r + "::" + f]) !== +m && (m = x.m["*::" + f]), e.ia ? ("string" != typeof (y = e.ia(r, f)) && (g = l, y = f), g && m !== +m && (m = x.d.NONE)) : (y = f, m !== +m && (g = l));
              var v = f = "",
                  C = l;

              switch (/^[~^$*|]?=$/.test(t[i]) && (f = t[i++], v = t[i++], /^[0-9A-Za-z:_\-]+$/.test(v) ? v = '"' + v + '"' : "]" === v && (v = '""', --i), /^"([^\"\\]|\\.)*"$/.test(v) || (g = l), (C = "i" === t[i]) && ++i), "]" !== t[i] && (++i, g = l), m) {
                case x.d.CLASSES:
                case x.d.LOCAL_NAME:
                case x.d.NONE:
                  break;

                case x.d.GLOBAL_NAME:
                case x.d.ID:
                case x.d.IDREF:
                  "=" !== f && "~=" !== f && "$=" !== f || '""' == v || C ? "|=" === f || "" === f || (g = l) : v = '"' + v.substring(1, v.length - 1) + u + '"';
                  break;

                case x.d.URI:
                case x.d.URI_FRAGMENT:
                  "" !== f && (g = l);
                  break;

                default:
                  g = l;
              }

              g && (h += "[" + y.replace(/[^\w-]/g, "\\$&") + f + v + (C ? " i]" : "]"));
            } else {
              if (!(i < n && ":" === t[i])) break;
              if (m = t[++i], !S.test(m)) break;
              p += ":" + m;
            }
          }

          return i !== n && (g = l), g && (i = (r + a).replace(/[^ .*#\w-]/g, "\\$&") + h + p + o) && c.push(i), g;
        }

        " " === t[n] && ++n, r - 1 !== n && " " === t[r] && --r;

        for (var c = [], m = n, g = s, y = n; g && y < r; ++y) {
          var f = t[y];
          b[f] !== b && " " !== f || (a(m, y, f) ? m = y + 1 : g = l);
        }

        return a(m, r, "") || (g = l), g ? (c.length && (m = c.join(""), h !== o && (m = "." + h + " " + m), p.push(m)), s) : !i || i(t.slice(n, r));
      }

      var r,
          a,
          h = e.na,
          u = e.L,
          d = e.Aa,
          p = [],
          c = 0,
          m = 0;

      for (r = 0; r < t.length; ++r) {
        ("(" == (a = t[r]) || "[" == a ? (++m, s) : ")" == a || "]" == a ? (m && --m, s) : " " != t[r] || !m && b[t[r - 1]] !== b && b[t[r + 1]] !== b) && (t[c++] = t[r]);
      }

      for (t.length = c, c = t.length, r = m = 0; r < c; ++r) {
        if ("," === t[r]) {
          if (!n(m, r)) return o;
          m = r + 1;
        }
      }

      return n(m, c) ? p : o;
    }, function () {
      var t = /^\w/,
          e = RegExp("^(?:(?:(?:(?:only|not) )?(?:all|aural|braille|embossed|handheld|print|projection|screen|speech|tty|tv)|\\( (?:(?:min-|max-)?(?:(?:device-)?(?:aspect-ratio|height|width)|color(?:-index)?|monochrome|orientation|resolution)|grid|hover|luminosity|pointer|scan|script) (?:: -?(?:[a-z]\\w+(?:-\\w+)*|\\d+(?: / \\d+|(?:\\.\\d+)?(?:p[cxt]|[cem]m|in|dpi|dppx|dpcm|%)?)) )?\\))(?: and ?\\( (?:(?:min-|max-)?(?:(?:device-)?(?:aspect-ratio|height|width)|color(?:-index)?|monochrome|orientation|resolution)|grid|hover|luminosity|pointer|scan|script) (?:: -?(?:[a-z]\\w+(?:-\\w+)*|\\d+(?: / \\d+|(?:\\.\\d+)?(?:p[cxt]|[cem]m|in|dpi|dppx|dpcm|%)?)) )?\\))*)(?: , (?:(?:(?:(?:only|not) )?(?:all|aural|braille|embossed|handheld|print|projection|screen|speech|tty|tv)|\\( (?:(?:min-|max-)?(?:(?:device-)?(?:aspect-ratio|height|width)|color(?:-index)?|monochrome|orientation|resolution)|grid|hover|luminosity|pointer|scan|script) (?:: -?(?:[a-z]\\w+(?:-\\w+)*|\\d+(?: / \\d+|(?:\\.\\d+)?(?:p[cxt]|[cem]m|in|dpi|dppx|dpcm|%)?)) )?\\))(?: and ?\\( (?:(?:min-|max-)?(?:(?:device-)?(?:aspect-ratio|height|width)|color(?:-index)?|monochrome|orientation|resolution)|grid|hover|luminosity|pointer|scan|script) (?:: -?(?:[a-z]\\w+(?:-\\w+)*|\\d+(?: / \\d+|(?:\\.\\d+)?(?:p[cxt]|[cem]m|in|dpi|dppx|dpcm|%)?)) )?\\))*))*$", "i");

      g = function g(i) {
        for (var n = (i = i.slice()).length, s = 0, o = 0; o < n; ++o) {
          var l = i[o];
          " " != l && (i[s++] = l);
        }

        return i.length = s, (i = i.join(" ")).length ? e.test(i) ? t.test(i) ? i : "not all , " + i : "not all" : "";
      };
    }(), function () {
      function t(e, i, a, h, m, x, y) {
        function f() {
          S = E.length && E[E.length - 1] === o;
        }

        var v = n,
            C = y || [0],
            E = [],
            S = l;
        return u(i, {
          startStylesheet: function startStylesheet() {
            v = [];
          },
          endStylesheet: function endStylesheet() {},
          startAtrule: function startAtrule(i, n) {
            if (S) i = o;else if ("@media" === i) v.push("@media", " ", g(n));else if ("@keyframes" === i || "@-webkit-keyframes" === i) {
              var s = n[0];
              1 !== n.length || /__$|[^\w\-]/.test(s) ? i = o : (v.push(i, " ", s + a.L), i = "@keyframes");
            } else if ("@import" === i && 0 < n.length) if (i = o, "function" == typeof x) {
              var l = g(n.slice(1));

              if ("not all" !== l) {
                ++C[0];
                var u = [];
                v.push(u);
                var p = d(r(e, function (t) {
                  var e;
                  return (e = /^\s*["]([^"]*)["]\s*$/.exec(t)) || (e = /^\s*[']([^']*)[']\s*$/.exec(t)) || (e = /^\s*url\s*[(]["]([^"]*)["][)]\s*$/.exec(t)) || (e = /^\s*url\s*[(][']([^']*)['][)]\s*$/.exec(t)) || (e = /^\s*url\s*[(]([^)]*)[)]\s*$/.exec(t)) ? e[1] : o;
                }(n[0])), function (e) {
                  var i = t(p, e.qa, a, h, m, x, C);
                  --C[0], e = l ? {
                    toString: function toString() {
                      return "@media " + l + " {" + i.result + "}";
                    }
                  } : i.result, u[0] = e, x(e, !!C[0]);
                }, m);
              }
            } else window.console && window.console.log("@import " + n.join(" ") + " elided");
            S = !i, E.push(i);
          },
          endAtrule: function endAtrule() {
            E.pop(), S || v.push(";"), f();
          },
          startBlock: function startBlock() {
            S || v.push("{");
          },
          endBlock: function endBlock() {
            S || (v.push("}"), S = s);
          },
          startRuleset: function startRuleset(t) {
            if (!S) {
              var e = n;
              "@keyframes" === E[E.length - 1] ? (e = t.join(" ").match(/^ *(?:from|to|\d+(?:\.\d+)?%) *(?:, *(?:from|to|\d+(?:\.\d+)?%) *)*$/i), S = !e, e && (e = e[0].replace(/ +/g, ""))) : (t = c(t, a)) && t.length ? e = t.join(", ") : S = s, S || v.push(e, "{");
            }

            E.push(o);
          },
          endRuleset: function endRuleset() {
            E.pop(), S || v.push("}"), f();
          },
          declaration: function declaration(t, i) {
            if (!S) {
              var n = l,
                  o = i.length;
              2 <= o && "!" === i[o - 2] && "important" === i[o - 1].toLowerCase() && (n = s, i.length -= 2), p(t, i, h, e, a.L), i.length && v.push(t, ":", i.join(" "), n ? " !important;" : ";");
            }
          }
        }), {
          result: {
            toString: function toString() {
              return v.join("");
            }
          },
          va: !!C[0]
        };
      }

      m = function m(e, i, s, o) {
        return t(e, i, s, o, n, n).result.toString();
      };
    }();
  }(), "undefined" != typeof window && (window.sanitizeCssProperty = p, window.sanitizeCssSelectorList = c, window.sanitizeStylesheet = m, window.sanitizeMediaQuery = g), function () {
    function t(t, e, n, s, o) {
      for (var l = e++; e < n && "{" !== t[e] && ";" !== t[e];) {
        ++e;
      }

      if (e < n && (o || ";" === t[e])) {
        var r = e;
        (o = l + 1) < n && " " === t[o] && ++o, r > o && " " === t[r - 1] && --r, s.startAtrule && s.startAtrule(t[l].toLowerCase(), t.slice(o, r)), e = "{" === t[e] ? i(t, e, n, s) : e + 1, s.endAtrule && s.endAtrule();
      }

      return e;
    }

    function i(e, s, o, r) {
      for (++s, r.startBlock && r.startBlock(); s < o;) {
        var a = e[s].charAt(0);

        if ("}" == a) {
          ++s;
          break;
        }

        s = " " === a || ";" === a ? s + 1 : "@" === a ? t(e, s, o, r, l) : "{" === a ? i(e, s, o, r) : n(e, s, o, r);
      }

      return r.endBlock && r.endBlock(), s;
    }

    function n(t, e, i, n) {
      var l = e,
          r = o(t, e, i, s);
      if (0 > r) return (r = ~r) === l ? r + 1 : r;
      var h = t[r];
      if ("{" !== h) return r === l ? r + 1 : r;

      for (e = r + 1, r > l && " " === t[r - 1] && --r, n.startRuleset && n.startRuleset(t.slice(l, r)); e < i;) {
        if ("}" === (h = t[e])) {
          ++e;
          break;
        }

        e = " " === h ? e + 1 : a(t, e, i, n);
      }

      return n.endRuleset && n.endRuleset(), e;
    }

    function o(t, e, i, n) {
      for (var s, o = [], l = -1; e < i; ++e) {
        if ("[" === (s = t[e].charAt(0)) || "(" === s) o[++l] = s;else if ("]" === s && "[" === o[l] || ")" === s && "(" === o[l]) --l;else if ("{" === s || "}" === s || ";" === s || "@" === s || ":" === s && !n) break;
      }

      return 0 <= l && (e = ~(e + 1)), e;
    }

    function r(t, e, i) {
      for (; e < i && ";" !== t[e] && "}" !== t[e];) {
        ++e;
      }

      return e < i && ";" === t[e] ? e + 1 : e;
    }

    function a(t, e, i, n) {
      var s = t[e++];
      if (!h.test(s)) return r(t, e, i);
      if (e < i && " " === t[e] && ++e, e == i || ":" !== t[e]) return r(t, e, i);
      ++e < i && " " === t[e] && ++e;
      var a = o(t, e, i, l);
      if (0 > a) a = ~a;else {
        for (var u = [], d = 0, p = e; p < a; ++p) {
          " " !== (e = t[p]) && (u[d++] = e);
        }

        if (a < i) {
          do {
            if (";" === (e = t[a]) || "}" === e) break;
            d = 0;
          } while (++a < i);

          ";" === e && ++a;
        }

        d && n.declaration && n.declaration(s.toLowerCase(), u);
      }
      return a;
    }

    u = function u(i, o) {
      var l = e(i);
      o.startStylesheet && o.startStylesheet();

      for (var r = 0, a = l.length; r < a;) {
        r = " " === l[r] ? r + 1 : r < a ? "@" === l[r].charAt(0) ? t(l, r, a, o, s) : n(l, r, a, o) : r;
      }

      o.endStylesheet && o.endStylesheet();
    };

    var h = /^-?[a-z]/i;

    d = function d(t, i) {
      for (var n = e(t), s = 0, o = n.length; s < o;) {
        s = " " !== n[s] ? a(n, s, o, i) : s + 1;
      }
    };
  }(), "undefined" != typeof window && (window.parseCssStylesheet = u, window.parseCssDeclarations = d);
  var x = {
    d: {
      NONE: 0,
      URI: 1,
      URI_FRAGMENT: 11,
      SCRIPT: 2,
      STYLE: 3,
      HTML: 12,
      ID: 4,
      IDREF: 5,
      IDREFS: 6,
      GLOBAL_NAME: 7,
      LOCAL_NAME: 8,
      CLASSES: 9,
      FRAME_TARGET: 10,
      MEDIA_QUERY: 13
    }
  };
  x.atype = x.d, x.m = {
    "*::class": 9,
    "*::dir": 0,
    "*::draggable": 0,
    "*::hidden": 0,
    "*::id": 4,
    "*::inert": 0,
    "*::itemprop": 0,
    "*::itemref": 6,
    "*::itemscope": 0,
    "*::lang": 0,
    "*::onblur": 2,
    "*::onchange": 2,
    "*::onclick": 2,
    "*::ondblclick": 2,
    "*::onerror": 2,
    "*::onfocus": 2,
    "*::onkeydown": 2,
    "*::onkeypress": 2,
    "*::onkeyup": 2,
    "*::onload": 2,
    "*::onmousedown": 2,
    "*::onmousemove": 2,
    "*::onmouseout": 2,
    "*::onmouseover": 2,
    "*::onmouseup": 2,
    "*::onreset": 2,
    "*::onscroll": 2,
    "*::onselect": 2,
    "*::onsubmit": 2,
    "*::ontouchcancel": 2,
    "*::ontouchend": 2,
    "*::ontouchenter": 2,
    "*::ontouchleave": 2,
    "*::ontouchmove": 2,
    "*::ontouchstart": 2,
    "*::onunload": 2,
    "*::spellcheck": 0,
    "*::style": 3,
    "*::tabindex": 0,
    "*::title": 0,
    "*::translate": 0,
    "a::accesskey": 0,
    "a::coords": 0,
    "a::href": 1,
    "a::hreflang": 0,
    "a::name": 7,
    "a::onblur": 2,
    "a::onfocus": 2,
    "a::shape": 0,
    "a::target": 10,
    "a::type": 0,
    "area::accesskey": 0,
    "area::alt": 0,
    "area::coords": 0,
    "area::href": 1,
    "area::nohref": 0,
    "area::onblur": 2,
    "area::onfocus": 2,
    "area::shape": 0,
    "area::target": 10,
    "audio::controls": 0,
    "audio::loop": 0,
    "audio::mediagroup": 5,
    "audio::muted": 0,
    "audio::preload": 0,
    "audio::src": 1,
    "bdo::dir": 0,
    "blockquote::cite": 1,
    "br::clear": 0,
    "button::accesskey": 0,
    "button::disabled": 0,
    "button::name": 8,
    "button::onblur": 2,
    "button::onfocus": 2,
    "button::type": 0,
    "button::value": 0,
    "canvas::height": 0,
    "canvas::width": 0,
    "caption::align": 0,
    "col::align": 0,
    "col::char": 0,
    "col::charoff": 0,
    "col::span": 0,
    "col::valign": 0,
    "col::width": 0,
    "colgroup::align": 0,
    "colgroup::char": 0,
    "colgroup::charoff": 0,
    "colgroup::span": 0,
    "colgroup::valign": 0,
    "colgroup::width": 0,
    "command::checked": 0,
    "command::command": 5,
    "command::disabled": 0,
    "command::icon": 1,
    "command::label": 0,
    "command::radiogroup": 0,
    "command::type": 0,
    "data::value": 0,
    "del::cite": 1,
    "del::datetime": 0,
    "details::open": 0,
    "dir::compact": 0,
    "div::align": 0,
    "dl::compact": 0,
    "fieldset::disabled": 0,
    "font::color": 0,
    "font::face": 0,
    "font::size": 0,
    "form::accept": 0,
    "form::action": 1,
    "form::autocomplete": 0,
    "form::enctype": 0,
    "form::method": 0,
    "form::name": 7,
    "form::novalidate": 0,
    "form::onreset": 2,
    "form::onsubmit": 2,
    "form::target": 10,
    "h1::align": 0,
    "h2::align": 0,
    "h3::align": 0,
    "h4::align": 0,
    "h5::align": 0,
    "h6::align": 0,
    "hr::align": 0,
    "hr::noshade": 0,
    "hr::size": 0,
    "hr::width": 0,
    "iframe::align": 0,
    "iframe::frameborder": 0,
    "iframe::height": 0,
    "iframe::marginheight": 0,
    "iframe::marginwidth": 0,
    "iframe::width": 0,
    "img::align": 0,
    "img::alt": 0,
    "img::border": 0,
    "img::height": 0,
    "img::hspace": 0,
    "img::ismap": 0,
    "img::name": 7,
    "img::src": 1,
    "img::usemap": 11,
    "img::vspace": 0,
    "img::width": 0,
    "input::accept": 0,
    "input::accesskey": 0,
    "input::align": 0,
    "input::alt": 0,
    "input::autocomplete": 0,
    "input::checked": 0,
    "input::disabled": 0,
    "input::inputmode": 0,
    "input::ismap": 0,
    "input::list": 5,
    "input::max": 0,
    "input::maxlength": 0,
    "input::min": 0,
    "input::multiple": 0,
    "input::name": 8,
    "input::onblur": 2,
    "input::onchange": 2,
    "input::onfocus": 2,
    "input::onselect": 2,
    "input::pattern": 0,
    "input::placeholder": 0,
    "input::readonly": 0,
    "input::required": 0,
    "input::size": 0,
    "input::src": 1,
    "input::step": 0,
    "input::type": 0,
    "input::usemap": 11,
    "input::value": 0,
    "ins::cite": 1,
    "ins::datetime": 0,
    "label::accesskey": 0,
    "label::for": 5,
    "label::onblur": 2,
    "label::onfocus": 2,
    "legend::accesskey": 0,
    "legend::align": 0,
    "li::type": 0,
    "li::value": 0,
    "map::name": 7,
    "menu::compact": 0,
    "menu::label": 0,
    "menu::type": 0,
    "meter::high": 0,
    "meter::low": 0,
    "meter::max": 0,
    "meter::min": 0,
    "meter::value": 0,
    "ol::compact": 0,
    "ol::reversed": 0,
    "ol::start": 0,
    "ol::type": 0,
    "optgroup::disabled": 0,
    "optgroup::label": 0,
    "option::disabled": 0,
    "option::label": 0,
    "option::selected": 0,
    "option::value": 0,
    "output::for": 6,
    "output::name": 8,
    "p::align": 0,
    "pre::width": 0,
    "progress::max": 0,
    "progress::min": 0,
    "progress::value": 0,
    "q::cite": 1,
    "select::autocomplete": 0,
    "select::disabled": 0,
    "select::multiple": 0,
    "select::name": 8,
    "select::onblur": 2,
    "select::onchange": 2,
    "select::onfocus": 2,
    "select::required": 0,
    "select::size": 0,
    "source::type": 0,
    "table::align": 0,
    "table::bgcolor": 0,
    "table::border": 0,
    "table::cellpadding": 0,
    "table::cellspacing": 0,
    "table::frame": 0,
    "table::rules": 0,
    "table::summary": 0,
    "table::width": 0,
    "tbody::align": 0,
    "tbody::char": 0,
    "tbody::charoff": 0,
    "tbody::valign": 0,
    "td::abbr": 0,
    "td::align": 0,
    "td::axis": 0,
    "td::bgcolor": 0,
    "td::char": 0,
    "td::charoff": 0,
    "td::colspan": 0,
    "td::headers": 6,
    "td::height": 0,
    "td::nowrap": 0,
    "td::rowspan": 0,
    "td::scope": 0,
    "td::valign": 0,
    "td::width": 0,
    "textarea::accesskey": 0,
    "textarea::autocomplete": 0,
    "textarea::cols": 0,
    "textarea::disabled": 0,
    "textarea::inputmode": 0,
    "textarea::name": 8,
    "textarea::onblur": 2,
    "textarea::onchange": 2,
    "textarea::onfocus": 2,
    "textarea::onselect": 2,
    "textarea::placeholder": 0,
    "textarea::readonly": 0,
    "textarea::required": 0,
    "textarea::rows": 0,
    "textarea::wrap": 0,
    "tfoot::align": 0,
    "tfoot::char": 0,
    "tfoot::charoff": 0,
    "tfoot::valign": 0,
    "th::abbr": 0,
    "th::align": 0,
    "th::axis": 0,
    "th::bgcolor": 0,
    "th::char": 0,
    "th::charoff": 0,
    "th::colspan": 0,
    "th::headers": 6,
    "th::height": 0,
    "th::nowrap": 0,
    "th::rowspan": 0,
    "th::scope": 0,
    "th::valign": 0,
    "th::width": 0,
    "thead::align": 0,
    "thead::char": 0,
    "thead::charoff": 0,
    "thead::valign": 0,
    "tr::align": 0,
    "tr::bgcolor": 0,
    "tr::char": 0,
    "tr::charoff": 0,
    "tr::valign": 0,
    "track::default": 0,
    "track::kind": 0,
    "track::label": 0,
    "track::srclang": 0,
    "ul::compact": 0,
    "ul::type": 0,
    "video::controls": 0,
    "video::height": 0,
    "video::loop": 0,
    "video::mediagroup": 5,
    "video::muted": 0,
    "video::poster": 1,
    "video::preload": 0,
    "video::src": 1,
    "video::width": 0
  }, x.ATTRIBS = x.m, x.c = {
    OPTIONAL_ENDTAG: 1,
    EMPTY: 2,
    CDATA: 4,
    RCDATA: 8,
    UNSAFE: 16,
    FOLDABLE: 32,
    SCRIPT: 64,
    STYLE: 128,
    VIRTUALIZED: 256
  }, x.eflags = x.c, x.f = {
    a: 0,
    abbr: 0,
    acronym: 0,
    address: 0,
    applet: 272,
    area: 2,
    article: 0,
    aside: 0,
    audio: 0,
    b: 0,
    base: 274,
    basefont: 274,
    bdi: 0,
    bdo: 0,
    big: 0,
    blockquote: 0,
    body: 305,
    br: 2,
    button: 0,
    canvas: 0,
    caption: 0,
    center: 0,
    cite: 0,
    code: 0,
    col: 2,
    colgroup: 1,
    command: 2,
    data: 0,
    datalist: 0,
    dd: 1,
    del: 0,
    details: 0,
    dfn: 0,
    dialog: 272,
    dir: 0,
    div: 0,
    dl: 0,
    dt: 1,
    em: 0,
    fieldset: 0,
    figcaption: 0,
    figure: 0,
    font: 0,
    footer: 0,
    form: 0,
    frame: 274,
    frameset: 272,
    h1: 0,
    h2: 0,
    h3: 0,
    h4: 0,
    h5: 0,
    h6: 0,
    head: 305,
    header: 0,
    hgroup: 0,
    hr: 2,
    html: 305,
    i: 0,
    iframe: 4,
    img: 2,
    input: 2,
    ins: 0,
    isindex: 274,
    kbd: 0,
    keygen: 274,
    label: 0,
    legend: 0,
    li: 1,
    link: 274,
    map: 0,
    mark: 0,
    menu: 0,
    meta: 274,
    meter: 0,
    nav: 0,
    nobr: 0,
    noembed: 276,
    noframes: 276,
    noscript: 276,
    object: 272,
    ol: 0,
    optgroup: 0,
    option: 1,
    output: 0,
    p: 1,
    param: 274,
    pre: 0,
    progress: 0,
    q: 0,
    s: 0,
    samp: 0,
    script: 84,
    section: 0,
    select: 0,
    small: 0,
    source: 2,
    span: 0,
    strike: 0,
    strong: 0,
    style: 148,
    sub: 0,
    summary: 0,
    sup: 0,
    table: 0,
    tbody: 1,
    td: 1,
    textarea: 8,
    tfoot: 1,
    th: 1,
    thead: 1,
    time: 0,
    title: 280,
    tr: 1,
    track: 2,
    tt: 0,
    u: 0,
    ul: 0,
    var: 0,
    video: 0,
    wbr: 2
  }, x.ELEMENTS = x.f, x.Q = {
    a: "HTMLAnchorElement",
    abbr: "HTMLElement",
    acronym: "HTMLElement",
    address: "HTMLElement",
    applet: "HTMLAppletElement",
    area: "HTMLAreaElement",
    article: "HTMLElement",
    aside: "HTMLElement",
    audio: "HTMLAudioElement",
    b: "HTMLElement",
    base: "HTMLBaseElement",
    basefont: "HTMLBaseFontElement",
    bdi: "HTMLElement",
    bdo: "HTMLElement",
    big: "HTMLElement",
    blockquote: "HTMLQuoteElement",
    body: "HTMLBodyElement",
    br: "HTMLBRElement",
    button: "HTMLButtonElement",
    canvas: "HTMLCanvasElement",
    caption: "HTMLTableCaptionElement",
    center: "HTMLElement",
    cite: "HTMLElement",
    code: "HTMLElement",
    col: "HTMLTableColElement",
    colgroup: "HTMLTableColElement",
    command: "HTMLCommandElement",
    data: "HTMLElement",
    datalist: "HTMLDataListElement",
    dd: "HTMLElement",
    del: "HTMLModElement",
    details: "HTMLDetailsElement",
    dfn: "HTMLElement",
    dialog: "HTMLDialogElement",
    dir: "HTMLDirectoryElement",
    div: "HTMLDivElement",
    dl: "HTMLDListElement",
    dt: "HTMLElement",
    em: "HTMLElement",
    fieldset: "HTMLFieldSetElement",
    figcaption: "HTMLElement",
    figure: "HTMLElement",
    font: "HTMLFontElement",
    footer: "HTMLElement",
    form: "HTMLFormElement",
    frame: "HTMLFrameElement",
    frameset: "HTMLFrameSetElement",
    h1: "HTMLHeadingElement",
    h2: "HTMLHeadingElement",
    h3: "HTMLHeadingElement",
    h4: "HTMLHeadingElement",
    h5: "HTMLHeadingElement",
    h6: "HTMLHeadingElement",
    head: "HTMLHeadElement",
    header: "HTMLElement",
    hgroup: "HTMLElement",
    hr: "HTMLHRElement",
    html: "HTMLHtmlElement",
    i: "HTMLElement",
    iframe: "HTMLIFrameElement",
    img: "HTMLImageElement",
    input: "HTMLInputElement",
    ins: "HTMLModElement",
    isindex: "HTMLUnknownElement",
    kbd: "HTMLElement",
    keygen: "HTMLKeygenElement",
    label: "HTMLLabelElement",
    legend: "HTMLLegendElement",
    li: "HTMLLIElement",
    link: "HTMLLinkElement",
    map: "HTMLMapElement",
    mark: "HTMLElement",
    menu: "HTMLMenuElement",
    meta: "HTMLMetaElement",
    meter: "HTMLMeterElement",
    nav: "HTMLElement",
    nobr: "HTMLElement",
    noembed: "HTMLElement",
    noframes: "HTMLElement",
    noscript: "HTMLElement",
    object: "HTMLObjectElement",
    ol: "HTMLOListElement",
    optgroup: "HTMLOptGroupElement",
    option: "HTMLOptionElement",
    output: "HTMLOutputElement",
    p: "HTMLParagraphElement",
    param: "HTMLParamElement",
    pre: "HTMLPreElement",
    progress: "HTMLProgressElement",
    q: "HTMLQuoteElement",
    s: "HTMLElement",
    samp: "HTMLElement",
    script: "HTMLScriptElement",
    section: "HTMLElement",
    select: "HTMLSelectElement",
    small: "HTMLElement",
    source: "HTMLSourceElement",
    span: "HTMLSpanElement",
    strike: "HTMLElement",
    strong: "HTMLElement",
    style: "HTMLStyleElement",
    sub: "HTMLElement",
    summary: "HTMLElement",
    sup: "HTMLElement",
    table: "HTMLTableElement",
    tbody: "HTMLTableSectionElement",
    td: "HTMLTableDataCellElement",
    textarea: "HTMLTextAreaElement",
    tfoot: "HTMLTableSectionElement",
    th: "HTMLTableHeaderCellElement",
    thead: "HTMLTableSectionElement",
    time: "HTMLTimeElement",
    title: "HTMLTitleElement",
    tr: "HTMLTableRowElement",
    track: "HTMLTrackElement",
    tt: "HTMLElement",
    u: "HTMLElement",
    ul: "HTMLUListElement",
    var: "HTMLElement",
    video: "HTMLVideoElement",
    wbr: "HTMLElement"
  }, x.ELEMENT_DOM_INTERFACES = x.Q, x.P = {
    NOT_LOADED: 0,
    SAME_DOCUMENT: 1,
    NEW_DOCUMENT: 2
  }, x.ueffects = x.P, x.J = {
    "a::href": 2,
    "area::href": 2,
    "audio::src": 1,
    "blockquote::cite": 0,
    "command::icon": 1,
    "del::cite": 0,
    "form::action": 2,
    "img::src": 1,
    "input::src": 1,
    "ins::cite": 0,
    "q::cite": 0,
    "video::poster": 1,
    "video::src": 1
  }, x.URIEFFECTS = x.J, x.M = {
    UNSANDBOXED: 2,
    SANDBOXED: 1,
    DATA: 0
  }, x.ltypes = x.M, x.I = {
    "a::href": 2,
    "area::href": 2,
    "audio::src": 2,
    "blockquote::cite": 2,
    "command::icon": 1,
    "del::cite": 2,
    "form::action": 2,
    "img::src": 1,
    "input::src": 1,
    "ins::cite": 2,
    "q::cite": 2,
    "video::poster": 1,
    "video::src": 2
  }, x.LOADERTYPES = x.I, "undefined" != typeof window && (window.html4 = x);

  var y = function (t) {
    function e(t, e) {
      return function (t) {
        if (w.hasOwnProperty(t)) return w[t];
        var e = t.match(T);
        return e ? String.fromCharCode(parseInt(e[1], 10)) : (e = t.match(A)) ? String.fromCharCode(parseInt(e[1], 16)) : M && L.test(t) ? (M.innerHTML = "&" + t + ";", e = M.textContent, w[t] = e) : "&" + t + ";";
      }(e);
    }

    function i(t) {
      return t.replace(R, e);
    }

    function r(t) {
      return ("" + t).replace(O, "&amp;").replace(N, "&lt;").replace(D, "&gt;").replace(G, "&#34;");
    }

    function a(t) {
      return t.replace(H, "&amp;$1").replace(N, "&lt;").replace(D, "&gt;");
    }

    function u(t) {
      var e = {
        z: t.z || t.cdata,
        A: t.A || t.comment,
        B: t.B || t.endDoc,
        t: t.t || t.endTag,
        e: t.e || t.pcdata,
        F: t.F || t.rcdata,
        H: t.H || t.startDoc,
        w: t.w || t.startTag
      };
      return function (t, i) {
        var n,
            s = /(<\/|<\!--|<[!?]|[&<>])/g;
        if (n = t + "", U) n = n.split(s);else {
          for (var r, a = [], h = 0; (r = s.exec(n)) !== o;) {
            a.push(n.substring(h, r.index)), a.push(r[0]), h = r.index + r[0].length;
          }

          a.push(n.substring(h)), n = a;
        }
        p(e, n, 0, {
          r: l,
          C: l
        }, i);
      };
    }

    function d(t, e, i, n, s) {
      return function () {
        p(t, e, i, n, s);
      };
    }

    function p(e, i, n, o, l) {
      try {
        e.H && 0 == n && e.H(l);

        for (var r, a, h, u = i.length; n < u;) {
          var p = i[n++],
              g = i[n];

          switch (p) {
            case "&":
              P.test(g) ? (e.e && e.e("&" + g, l, V, d(e, i, n, o, l)), n++) : e.e && e.e("&amp;", l, V, d(e, i, n, o, l));
              break;

            case "</":
              if (r = /^([-\w:]+)[^\'\"]*/.exec(g)) {
                if (r[0].length === g.length && ">" === i[n + 1]) n += 2, h = r[1].toLowerCase(), e.t && e.t(h, l, V, d(e, i, n, o, l));else {
                  var x = e,
                      y = l,
                      f = V,
                      v = o,
                      C = m(S = i, b = n);
                  C ? (x.t && x.t(C.name, y, f, d(x, S, b, v, y)), n = C.next) : n = S.length;
                }
              } else e.e && e.e("&lt;/", l, V, d(e, i, n, o, l));
              break;

            case "<":
              if (r = /^([-\w:]+)\s*\/?/.exec(g)) {
                if (r[0].length === g.length && ">" === i[n + 1]) {
                  n += 2, h = r[1].toLowerCase(), e.w && e.w(h, [], l, V, d(e, i, n, o, l));
                  var E = t.f[h];
                  E & k && (n = c(i, {
                    name: h,
                    next: n,
                    c: E
                  }, e, l, V, o));
                } else {
                  var S,
                      b = e,
                      w = (x = l, y = V, f = o, m(S = i, n));
                  w ? (b.w && b.w(w.name, w.R, x, y, d(b, S, w.next, f, x)), n = w.c & k ? c(S, w, b, x, y, f) : w.next) : n = S.length;
                }
              } else e.e && e.e("&lt;", l, V, d(e, i, n, o, l));
              break;

            case "\x3c!--":
              if (!o.C) {
                for (a = n + 1; a < u && (">" !== i[a] || !/--$/.test(i[a - 1])); a++) {
                  ;
                }

                if (a < u) {
                  if (e.A) {
                    var T = i.slice(n, a).join("");
                    e.A(T.substr(0, T.length - 2), l, V, d(e, i, a + 1, o, l));
                  }

                  n = a + 1;
                } else o.C = s;
              }

              o.C && e.e && e.e("&lt;!--", l, V, d(e, i, n, o, l));
              break;

            case "<!":
              if (/^\w/.test(g)) {
                if (!o.r) {
                  for (a = n + 1; a < u && ">" !== i[a]; a++) {
                    ;
                  }

                  a < u ? n = a + 1 : o.r = s;
                }

                o.r && e.e && e.e("&lt;!", l, V, d(e, i, n, o, l));
              } else e.e && e.e("&lt;!", l, V, d(e, i, n, o, l));

              break;

            case "<?":
              if (!o.r) {
                for (a = n + 1; a < u && ">" !== i[a]; a++) {
                  ;
                }

                a < u ? n = a + 1 : o.r = s;
              }

              o.r && e.e && e.e("&lt;?", l, V, d(e, i, n, o, l));
              break;

            case ">":
              e.e && e.e("&gt;", l, V, d(e, i, n, o, l));
              break;

            case "":
              break;

            default:
              e.e && e.e(p, l, V, d(e, i, n, o, l));
          }
        }

        e.B && e.B(l);
      } catch (t) {
        if (t !== V) throw t;
      }
    }

    function c(e, i, n, s, o, l) {
      var r = e.length;
      B.hasOwnProperty(i.name) || (B[i.name] = RegExp("^" + i.name + "(?:[\\s\\/]|$)", "i"));

      for (var h = B[i.name], u = i.next, p = i.next + 1; p < r && ("</" !== e[p - 1] || !h.test(e[p])); p++) {
        ;
      }

      if (p < r && (p -= 1), r = e.slice(u, p).join(""), i.c & t.c.CDATA) n.z && n.z(r, s, o, d(n, e, p, l, s));else {
        if (!(i.c & t.c.RCDATA)) throw Error("bug");
        n.F && n.F(a(r), s, o, d(n, e, p, l, s));
      }
      return p;
    }

    function m(e, n) {
      var o = /^([-\w:]+)/.exec(e[n]),
          r = {};
      r.name = o[1].toLowerCase(), r.c = t.f[r.name];

      for (var a = e[n].substr(o[0].length), h = n + 1, u = e.length; h < u && ">" !== e[h]; h++) {
        a += e[h];
      }

      if (!(u <= h)) {
        for (var d = []; "" !== a;) {
          if (o = _.exec(a)) {
            if (o[4] && !o[5] || o[6] && !o[7]) {
              o = o[4] || o[6];
              var p = l;

              for (a = [a, e[h++]]; h < u; h++) {
                if (p) {
                  if (">" === e[h]) break;
                } else 0 <= e[h].indexOf(o) && (p = s);

                a.push(e[h]);
              }

              if (u <= h) break;
              a = a.join("");
            } else {
              var c;
              p = o[1].toLowerCase();

              if (o[2]) {
                var m = (c = o[3]).charCodeAt(0);
                34 !== m && 39 !== m || (c = c.substr(1, c.length - 2)), c = i(c.replace(I, ""));
              } else c = "";

              d.push(p, c), a = a.substr(o[0].length);
            }
          } else a = a.replace(/^[\s\S][^a-z\s]*/, "");
        }

        return r.R = d, r.next = h + 1, r;
      }
    }

    function g(e) {
      function i(t, e) {
        a || e.push(t);
      }

      var s, a;
      return u({
        startDoc: function startDoc() {
          s = [], a = l;
        },
        startTag: function startTag(i, l, h) {
          if (!a && t.f.hasOwnProperty(i)) {
            var u = t.f[i];

            if (!(u & t.c.FOLDABLE)) {
              var d = e(i, l);

              if (d) {
                if ("object" != typeof d) throw Error("tagPolicy did not return object (old API?)");
                if (!("attribs" in d)) throw Error("tagPolicy gave no attribs");
                var p;

                if (l = d.attribs, "tagName" in d ? (p = d.tagName, d = t.f[p]) : (p = i, d = u), u & t.c.OPTIONAL_ENDTAG) {
                  var c = s[s.length - 1];
                  c && c.D === i && (c.v !== p || i !== p) && h.push("</", c.v, ">");
                }

                for (u & t.c.EMPTY || s.push({
                  D: i,
                  v: p
                }), h.push("<", p), i = 0, c = l.length; i < c; i += 2) {
                  var m = l[i],
                      g = l[i + 1];
                  g !== o && g !== n && h.push(" ", m, '="', r(g), '"');
                }

                h.push(">"), u & t.c.EMPTY && !(d & t.c.EMPTY) && h.push("</", p, ">");
              } else a = !(u & t.c.EMPTY);
            }
          }
        },
        endTag: function endTag(e, i) {
          if (a) a = l;else if (t.f.hasOwnProperty(e)) {
            var n = t.f[e];

            if (!(n & (t.c.EMPTY | t.c.FOLDABLE))) {
              if (n & t.c.OPTIONAL_ENDTAG) for (n = s.length; 0 <= --n;) {
                var o = s[n].D;
                if (o === e) break;
                if (!(t.f[o] & t.c.OPTIONAL_ENDTAG)) return;
              } else for (n = s.length; 0 <= --n && s[n].D !== e;) {
                ;
              }

              if (!(0 > n)) {
                for (o = s.length; --o > n;) {
                  var r = s[o].v;
                  t.f[r] & t.c.OPTIONAL_ENDTAG || i.push("</", r, ">");
                }

                n < s.length && (e = s[n].v), s.length = n, i.push("</", e, ">");
              }
            }
          }
        },
        pcdata: i,
        rcdata: i,
        cdata: i,
        endDoc: function endDoc(t) {
          for (; s.length; s.length--) {
            t.push("</", s[s.length - 1].v, ">");
          }
        }
      });
    }

    function x(t, e, i, n, s) {
      if (!s) return o;

      try {
        var l = h.parse("" + t);

        if (l && (!l.K() || F.test(l.W()))) {
          var r = s(l, e, i, n);
          return r ? r.toString() : o;
        }
      } catch (t) {}

      return o;
    }

    function y(t, e, i, n, s) {
      if (i || t(e + " removed", {
        S: "removed",
        tagName: e
      }), n !== s) {
        var o = "changed";
        n && !s ? o = "removed" : !n && s && (o = "added"), t(e + "." + i + " " + o, {
          S: o,
          tagName: e,
          la: i,
          oldValue: n,
          newValue: s
        });
      }
    }

    function f(t, e, i) {
      return e = e + "::" + i, t.hasOwnProperty(e) ? t[e] : (e = "*::" + i, t.hasOwnProperty(e) ? t[e] : void 0);
    }

    function v(e, i, s, l, r) {
      for (var a = 0; a < i.length; a += 2) {
        var h,
            u = i[a],
            d = i[a + 1],
            p = d,
            c = o;
        if (h = e + "::" + u, (t.m.hasOwnProperty(h) || (h = "*::" + u, t.m.hasOwnProperty(h))) && (c = t.m[h]), c !== o) switch (c) {
          case t.d.NONE:
            break;

          case t.d.SCRIPT:
            d = o, r && y(r, e, u, p, d);
            break;

          case t.d.STYLE:
            if (void 0 === S) {
              d = o, r && y(r, e, u, p, d);
              break;
            }

            var m = [];
            S(d, {
              declaration: function declaration(e, i) {
                var n = e.toLowerCase();
                b(n, i, s ? function (e) {
                  return x(e, t.P.ja, t.M.ka, {
                    TYPE: "CSS",
                    CSS_PROP: n
                  }, s);
                } : o), i.length && m.push(n + ": " + i.join(" "));
              }
            }), d = 0 < m.length ? m.join(" ; ") : o, r && y(r, e, u, p, d);
            break;

          case t.d.ID:
          case t.d.IDREF:
          case t.d.IDREFS:
          case t.d.GLOBAL_NAME:
          case t.d.LOCAL_NAME:
          case t.d.CLASSES:
            d = l ? l(d) : d, r && y(r, e, u, p, d);
            break;

          case t.d.URI:
            d = x(d, f(t.J, e, u), f(t.I, e, u), {
              TYPE: "MARKUP",
              XML_ATTR: u,
              XML_TAG: e
            }, s), r && y(r, e, u, p, d);
            break;

          case t.d.URI_FRAGMENT:
            d && "#" === d.charAt(0) ? (d = d.substring(1), (d = l ? l(d) : d) !== o && d !== n && (d = "#" + d)) : d = o, r && y(r, e, u, p, d);
            break;

          default:
            d = o, r && y(r, e, u, p, d);
        } else d = o, r && y(r, e, u, p, d);
        i[a + 1] = d;
      }

      return i;
    }

    function C(e, i, s) {
      return function (o, l) {
        if (!(t.f[o] & t.c.UNSAFE)) return {
          attribs: v(o, l, e, i, s)
        };
        s && y(s, o, n, n, n);
      };
    }

    function E(t, e) {
      var i = [];
      return g(e)(t, i), i.join("");
    }

    var S, b;
    "undefined" != typeof window && (S = window.parseCssDeclarations, b = window.sanitizeCssProperty);
    var w = {
      lt: "<",
      LT: "<",
      gt: ">",
      GT: ">",
      amp: "&",
      AMP: "&",
      quot: '"',
      apos: "'",
      nbsp: " "
    },
        T = /^#(\d+)$/,
        A = /^#x([0-9A-Fa-f]+)$/,
        L = /^[A-Za-z][A-za-z0-9]+$/,
        M = "undefined" != typeof window && window.document ? window.document.createElement("textarea") : o,
        I = /\0/g,
        R = /&(#[0-9]+|#[xX][0-9A-Fa-f]+|\w+);/g,
        P = /^(#[0-9]+|#[xX][0-9A-Fa-f]+|\w+);/,
        O = /&/g,
        H = /&([^a-z#]|#(?:[^0-9x]|x(?:[^0-9a-f]|$)|$)|$)/gi,
        N = /[<]/g,
        D = />/g,
        G = /\"/g,
        _ = /^\s*([-.:\w]+)(?:\s*(=)\s*((")[^"]*("|$)|(')[^']*('|$)|(?=[a-z][-\w]*\s*=)|[^"'\s]*))?/i,
        U = 3 === "a,b".split(/(,)/).length,
        k = t.c.CDATA | t.c.RCDATA,
        V = {},
        B = {},
        F = /^(?:https?|mailto|data)$/i,
        Y = {};
    return Y.pa = Y.escapeAttrib = r, Y.ra = Y.makeHtmlSanitizer = g, Y.sa = Y.makeSaxParser = u, Y.ta = Y.makeTagPolicy = C, Y.wa = Y.normalizeRCData = a, Y.xa = Y.sanitize = function (t, e, i, n) {
      return E(t, C(e, i, n));
    }, Y.ya = Y.sanitizeAttribs = v, Y.za = Y.sanitizeWithPolicy = E, Y.Ba = Y.unescapeEntities = i, Y;
  }(x),
      f = y.sanitize;

  "undefined" != typeof window && (window.html = y, window.html_sanitize = f);
}();
var mxClient = {
  VERSION: "3.9.12",
  IS_IE: 0 <= navigator.userAgent.indexOf("MSIE"),
  IS_IE6: 0 <= navigator.userAgent.indexOf("MSIE 6"),
  IS_IE11: !!navigator.userAgent.match(/Trident\/7\./),
  IS_EDGE: !!navigator.userAgent.match(/Edge\//),
  IS_QUIRKS: 0 <= navigator.userAgent.indexOf("MSIE") && (null == document.documentMode || 5 == document.documentMode),
  IS_EM: "spellcheck" in document.createElement("textarea") && 8 == document.documentMode,
  VML_PREFIX: "v",
  OFFICE_PREFIX: "o",
  IS_NS: 0 <= navigator.userAgent.indexOf("Mozilla/") && 0 > navigator.userAgent.indexOf("MSIE") && 0 > navigator.userAgent.indexOf("Edge/"),
  IS_OP: 0 <= navigator.userAgent.indexOf("Opera/") || 0 <= navigator.userAgent.indexOf("OPR/"),
  IS_OT: 0 <= navigator.userAgent.indexOf("Presto/") && 0 > navigator.userAgent.indexOf("Presto/2.4.") && 0 > navigator.userAgent.indexOf("Presto/2.3.") && 0 > navigator.userAgent.indexOf("Presto/2.2.") && 0 > navigator.userAgent.indexOf("Presto/2.1.") && 0 > navigator.userAgent.indexOf("Presto/2.0.") && 0 > navigator.userAgent.indexOf("Presto/1."),
  IS_SF: 0 <= navigator.userAgent.indexOf("AppleWebKit/") && 0 > navigator.userAgent.indexOf("Chrome/") && 0 > navigator.userAgent.indexOf("Edge/"),
  IS_IOS: !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
  IS_GC: 0 <= navigator.userAgent.indexOf("Chrome/") && 0 > navigator.userAgent.indexOf("Edge/"),
  IS_CHROMEAPP: null != window.chrome && null != chrome.app && null != chrome.app.runtime,
  IS_FF: 0 <= navigator.userAgent.indexOf("Firefox/"),
  IS_MT: 0 <= navigator.userAgent.indexOf("Firefox/") && 0 > navigator.userAgent.indexOf("Firefox/1.") && 0 > navigator.userAgent.indexOf("Firefox/2.") || 0 <= navigator.userAgent.indexOf("Iceweasel/") && 0 > navigator.userAgent.indexOf("Iceweasel/1.") && 0 > navigator.userAgent.indexOf("Iceweasel/2.") || 0 <= navigator.userAgent.indexOf("SeaMonkey/") && 0 > navigator.userAgent.indexOf("SeaMonkey/1.") || 0 <= navigator.userAgent.indexOf("Iceape/") && 0 > navigator.userAgent.indexOf("Iceape/1."),
  IS_SVG: 0 <= navigator.userAgent.indexOf("Firefox/") || 0 <= navigator.userAgent.indexOf("Iceweasel/") || 0 <= navigator.userAgent.indexOf("Seamonkey/") || 0 <= navigator.userAgent.indexOf("Iceape/") || 0 <= navigator.userAgent.indexOf("Galeon/") || 0 <= navigator.userAgent.indexOf("Epiphany/") || 0 <= navigator.userAgent.indexOf("AppleWebKit/") || 0 <= navigator.userAgent.indexOf("Gecko/") || 0 <= navigator.userAgent.indexOf("Opera/") || null != document.documentMode && 9 <= document.documentMode,
  NO_FO: !document.createElementNS || "[object SVGForeignObjectElement]" != document.createElementNS("http://www.w3.org/2000/svg", "foreignObject") || 0 <= navigator.userAgent.indexOf("Opera/"),
  IS_VML: "MICROSOFT INTERNET EXPLORER" == navigator.appName.toUpperCase(),
  IS_WIN: 0 < navigator.appVersion.indexOf("Win"),
  IS_MAC: 0 < navigator.appVersion.indexOf("Mac"),
  IS_TOUCH: "ontouchstart" in document.documentElement,
  IS_POINTER: null != window.PointerEvent && !(0 < navigator.appVersion.indexOf("Mac")),
  IS_LOCAL: 0 > document.location.href.indexOf("http://") && 0 > document.location.href.indexOf("https://"),
  defaultBundles: [],
  isBrowserSupported: function isBrowserSupported() {
    return mxClient.IS_VML || mxClient.IS_SVG;
  },
  link: function link(t, e, i) {
    if (i = i || document, mxClient.IS_IE6) i.write('<link rel="' + t + '" href="' + e + '" charset="UTF-8" type="text/css"/>');else {
      var n = i.createElement("link");
      n.setAttribute("rel", t), n.setAttribute("href", e), n.setAttribute("charset", "UTF-8"), n.setAttribute("type", "text/css"), i.getElementsByTagName("head")[0].appendChild(n);
    }
  },
  loadResources: function loadResources(t, e) {
    function i() {
      0 == --n && t();
    }

    for (var n = mxClient.defaultBundles.length, s = 0; s < mxClient.defaultBundles.length; s++) {
      mxResources.add(mxClient.defaultBundles[s], e, i);
    }
  },
  include: function include(t) {
    document.write('<script src="' + t + '"><\/script>');
  }
},
    a;
"undefined" == typeof mxLoadResources && (mxLoadResources = !0), "undefined" == typeof mxForceIncludes && (mxForceIncludes = !1), "undefined" == typeof mxResourceExtension && (mxResourceExtension = ".txt"), "undefined" == typeof mxLoadStylesheets && (mxLoadStylesheets = !0), "undefined" != typeof mxBasePath && 0 < mxBasePath.length ? ("/" == mxBasePath.substring(mxBasePath.length - 1) && (mxBasePath = mxBasePath.substring(0, mxBasePath.length - 1)), mxClient.basePath = mxBasePath) : mxClient.basePath = ".", "undefined" != typeof mxImageBasePath && 0 < mxImageBasePath.length ? ("/" == mxImageBasePath.substring(mxImageBasePath.length - 1) && (mxImageBasePath = mxImageBasePath.substring(0, mxImageBasePath.length - 1)), mxClient.imageBasePath = mxImageBasePath) : mxClient.imageBasePath = mxClient.basePath + "/images", mxClient.language = "undefined" != typeof mxLanguage && null != mxLanguage ? mxLanguage : mxClient.IS_IE ? navigator.userLanguage : navigator.language, mxClient.defaultLanguage = "undefined" != typeof mxDefaultLanguage && null != mxDefaultLanguage ? mxDefaultLanguage : "en", mxLoadStylesheets && mxClient.link("stylesheet", mxClient.basePath + "/css/common.css"), "undefined" != typeof mxLanguages && null != mxLanguages && (mxClient.languages = mxLanguages), mxClient.IS_VML && (mxClient.IS_SVG ? mxClient.IS_VML = !1 : (8 == document.documentMode ? (document.namespaces.add(mxClient.VML_PREFIX, "urn:schemas-microsoft-com:vml", "#default#VML"), document.namespaces.add(mxClient.OFFICE_PREFIX, "urn:schemas-microsoft-com:office:office", "#default#VML")) : (document.namespaces.add(mxClient.VML_PREFIX, "urn:schemas-microsoft-com:vml"), document.namespaces.add(mxClient.OFFICE_PREFIX, "urn:schemas-microsoft-com:office:office")), mxClient.IS_QUIRKS && 30 <= document.styleSheets.length ? (a = document.createElement("style"), a.type = "text/css", a.styleSheet.cssText = mxClient.VML_PREFIX + "\\:*{behavior:url(#default#VML)}" + mxClient.OFFICE_PREFIX + "\\:*{behavior:url(#default#VML)}", document.getElementsByTagName("head")[0].appendChild(a)) : document.createStyleSheet().cssText = mxClient.VML_PREFIX + "\\:*{behavior:url(#default#VML)}" + mxClient.OFFICE_PREFIX + "\\:*{behavior:url(#default#VML)}", mxLoadStylesheets && mxClient.link("stylesheet", mxClient.basePath + "/css/explorer.css")));
var mxLog = {
  consoleName: "Console",
  TRACE: !1,
  DEBUG: !0,
  WARN: !0,
  buffer: "",
  init: function init() {
    if (null == mxLog.window && null != document.body) {
      var t = mxLog.consoleName + " - mxGraph " + mxClient.VERSION,
          e = document.createElement("table");
      e.setAttribute("width", "100%"), e.setAttribute("height", "100%");
      var i = document.createElement("tbody"),
          n = document.createElement("tr"),
          s = document.createElement("td");

      if (s.style.verticalAlign = "top", mxLog.textarea = document.createElement("textarea"), mxLog.textarea.setAttribute("wrap", "off"), mxLog.textarea.setAttribute("readOnly", "true"), mxLog.textarea.style.height = "100%", mxLog.textarea.style.resize = "none", mxLog.textarea.value = mxLog.buffer, mxLog.textarea.style.width = mxClient.IS_NS && "BackCompat" != document.compatMode ? "99%" : "100%", s.appendChild(mxLog.textarea), n.appendChild(s), i.appendChild(n), n = document.createElement("tr"), mxLog.td = document.createElement("td"), mxLog.td.style.verticalAlign = "top", mxLog.td.setAttribute("height", "30px"), n.appendChild(mxLog.td), i.appendChild(n), e.appendChild(i), mxLog.addButton("Info", function (t) {
        mxLog.info();
      }), mxLog.addButton("DOM", function (t) {
        t = mxUtils.getInnerHtml(document.body), mxLog.debug(t);
      }), mxLog.addButton("Trace", function (t) {
        mxLog.TRACE = !mxLog.TRACE, mxLog.TRACE ? mxLog.debug("Tracing enabled") : mxLog.debug("Tracing disabled");
      }), mxLog.addButton("Copy", function (t) {
        try {
          mxUtils.copy(mxLog.textarea.value);
        } catch (t) {
          mxUtils.alert(t);
        }
      }), mxLog.addButton("Show", function (t) {
        try {
          mxUtils.popup(mxLog.textarea.value);
        } catch (t) {
          mxUtils.alert(t);
        }
      }), mxLog.addButton("Clear", function (t) {
        mxLog.textarea.value = "";
      }), n = i = 0, "number" == typeof window.innerWidth ? (i = window.innerHeight, n = window.innerWidth) : (i = document.documentElement.clientHeight || document.body.clientHeight, n = document.body.clientWidth), mxLog.window = new mxWindow(t, e, Math.max(0, n - 320), Math.max(0, i - 210), 300, 160), mxLog.window.setMaximizable(!0), mxLog.window.setScrollable(!1), mxLog.window.setResizable(!0), mxLog.window.setClosable(!0), mxLog.window.destroyOnClose = !1, (mxClient.IS_NS || mxClient.IS_IE) && !mxClient.IS_GC && !mxClient.IS_SF && "BackCompat" != document.compatMode || 11 == document.documentMode) {
        var o = mxLog.window.getElement();

        t = function t(_t, e) {
          mxLog.textarea.style.height = Math.max(0, o.offsetHeight - 70) + "px";
        };

        mxLog.window.addListener(mxEvent.RESIZE_END, t), mxLog.window.addListener(mxEvent.MAXIMIZE, t), mxLog.window.addListener(mxEvent.NORMALIZE, t), mxLog.textarea.style.height = "92px";
      }
    }
  },
  info: function info() {
    mxLog.writeln(mxUtils.toString(navigator));
  },
  addButton: function addButton(t, e) {
    var i = document.createElement("button");
    mxUtils.write(i, t), mxEvent.addListener(i, "click", e), mxLog.td.appendChild(i);
  },
  isVisible: function isVisible() {
    return null != mxLog.window && mxLog.window.isVisible();
  },
  show: function show() {
    mxLog.setVisible(!0);
  },
  setVisible: function setVisible(t) {
    null == mxLog.window && mxLog.init(), null != mxLog.window && mxLog.window.setVisible(t);
  },
  enter: function enter(t) {
    if (mxLog.TRACE) return mxLog.writeln("Entering " + t), new Date().getTime();
  },
  leave: function leave(t, e) {
    if (mxLog.TRACE) {
      var i = 0 != e ? " (" + (new Date().getTime() - e) + " ms)" : "";
      mxLog.writeln("Leaving " + t + i);
    }
  },
  debug: function debug() {
    mxLog.DEBUG && mxLog.writeln.apply(this, arguments);
  },
  warn: function warn() {
    mxLog.WARN && mxLog.writeln.apply(this, arguments);
  },
  write: function write() {
    for (var t = "", e = 0; e < arguments.length; e++) {
      t += arguments[e], e < arguments.length - 1 && (t += " ");
    }

    null != mxLog.textarea ? (mxLog.textarea.value += t, 0 <= navigator.userAgent.indexOf("Presto/2.5") && (mxLog.textarea.style.visibility = "hidden", mxLog.textarea.style.visibility = "visible"), mxLog.textarea.scrollTop = mxLog.textarea.scrollHeight) : mxLog.buffer += t;
  },
  writeln: function writeln() {
    for (var t = "", e = 0; e < arguments.length; e++) {
      t += arguments[e], e < arguments.length - 1 && (t += " ");
    }

    mxLog.write(t + "\n");
  }
},
    mxObjectIdentity = {
  FIELD_NAME: "mxObjectId",
  counter: 0,
  get: function get(t) {
    if (null != t) {
      if (null == t[mxObjectIdentity.FIELD_NAME]) if ("object" == typeof t) {
        var e = mxUtils.getFunctionName(t.constructor);
        t[mxObjectIdentity.FIELD_NAME] = e + "#" + mxObjectIdentity.counter++;
      } else "function" == typeof t && (t[mxObjectIdentity.FIELD_NAME] = "Function#" + mxObjectIdentity.counter++);
      return t[mxObjectIdentity.FIELD_NAME];
    }

    return null;
  },
  clear: function clear(t) {
    "object" != typeof t && "function" != typeof t || delete t[mxObjectIdentity.FIELD_NAME];
  }
};

function mxDictionary() {
  this.clear();
}

mxDictionary.prototype.map = null, mxDictionary.prototype.clear = function () {
  this.map = {};
}, mxDictionary.prototype.get = function (t) {
  return t = mxObjectIdentity.get(t), this.map[t];
}, mxDictionary.prototype.put = function (t, e) {
  var i = mxObjectIdentity.get(t),
      n = this.map[i];
  return this.map[i] = e, n;
}, mxDictionary.prototype.remove = function (t) {
  t = mxObjectIdentity.get(t);
  var e = this.map[t];
  return delete this.map[t], e;
}, mxDictionary.prototype.getKeys = function () {
  var t,
      e = [];

  for (t in this.map) {
    e.push(t);
  }

  return e;
}, mxDictionary.prototype.getValues = function () {
  var t,
      e = [];

  for (t in this.map) {
    e.push(this.map[t]);
  }

  return e;
}, mxDictionary.prototype.visit = function (t) {
  for (var e in this.map) {
    t(e, this.map[e]);
  }
};
var mxResources = {
  resources: {},
  extension: mxResourceExtension,
  resourcesEncoded: !1,
  loadDefaultBundle: !0,
  loadSpecialBundle: !0,
  isLanguageSupported: function isLanguageSupported(t) {
    return null == mxClient.languages || 0 <= mxUtils.indexOf(mxClient.languages, t);
  },
  getDefaultBundle: function getDefaultBundle(t, e) {
    return mxResources.loadDefaultBundle || !mxResources.isLanguageSupported(e) ? t + mxResources.extension : null;
  },
  getSpecialBundle: function getSpecialBundle(t, e) {
    if (null == mxClient.languages || !this.isLanguageSupported(e)) {
      var i = e.indexOf("-");
      0 < i && (e = e.substring(0, i));
    }

    return mxResources.loadSpecialBundle && mxResources.isLanguageSupported(e) && e != mxClient.defaultLanguage ? t + "_" + e + mxResources.extension : null;
  },
  add: function add(t, e, i) {
    if ((e = null != e ? e : null != mxClient.language ? mxClient.language.toLowerCase() : mxConstants.NONE) != mxConstants.NONE) {
      var n = mxResources.getDefaultBundle(t, e),
          s = mxResources.getSpecialBundle(t, e),
          o = function o() {
        if (null != s) {
          if (i) mxUtils.get(s, function (t) {
            mxResources.parse(t.getText()), i();
          }, function () {
            i();
          });else try {
            var t = mxUtils.load(s);
            t.isReady() && mxResources.parse(t.getText());
          } catch (t) {}
        } else null != i && i();
      };

      if (null != n) {
        if (i) mxUtils.get(n, function (t) {
          mxResources.parse(t.getText()), o();
        }, function () {
          o();
        });else try {
          var l = mxUtils.load(n);
          l.isReady() && mxResources.parse(l.getText()), o();
        } catch (t) {}
      } else o();
    }
  },
  parse: function parse(t) {
    if (null != t) {
      t = t.split("\n");

      for (var e = 0; e < t.length; e++) {
        if ("#" != t[e].charAt(0)) {
          var i = t[e].indexOf("=");

          if (0 < i) {
            var n = t[e].substring(0, i),
                s = t[e].length;
            13 == t[e].charCodeAt(s - 1) && s--, i = t[e].substring(i + 1, s), this.resourcesEncoded ? (i = i.replace(/\\(?=u[a-fA-F\d]{4})/g, "%"), mxResources.resources[n] = unescape(i)) : mxResources.resources[n] = i;
          }
        }
      }
    }
  },
  get: function get(t, e, i) {
    return null == (t = mxResources.resources[t]) && (t = i), null != t && null != e && (t = mxResources.replacePlaceholders(t, e)), t;
  },
  replacePlaceholders: function replacePlaceholders(t, e) {
    for (var i = [], n = null, s = 0; s < t.length; s++) {
      var o = t.charAt(s);
      "{" == o ? n = "" : null != n && "}" == o ? (0 <= (n = parseInt(n) - 1) && n < e.length && i.push(e[n]), n = null) : null != n ? n += o : i.push(o);
    }

    return i.join("");
  },
  loadResources: function loadResources(t) {
    mxResources.add(mxClient.basePath + "/resources/editor", null, function () {
      mxResources.add(mxClient.basePath + "/resources/graph", null, t);
    });
  }
};

function mxPoint(t, e) {
  this.x = null != t ? t : 0, this.y = null != e ? e : 0;
}

function mxRectangle(t, e, i, n) {
  mxPoint.call(this, t, e), this.width = null != i ? i : 0, this.height = null != n ? n : 0;
}

mxPoint.prototype.x = null, mxPoint.prototype.y = null, mxPoint.prototype.equals = function (t) {
  return null != t && t.x == this.x && t.y == this.y;
}, mxPoint.prototype.clone = function () {
  return mxUtils.clone(this);
}, mxRectangle.prototype = new mxPoint(), mxRectangle.prototype.constructor = mxRectangle, mxRectangle.prototype.width = null, mxRectangle.prototype.height = null, mxRectangle.prototype.setRect = function (t, e, i, n) {
  this.x = t, this.y = e, this.width = i, this.height = n;
}, mxRectangle.prototype.getCenterX = function () {
  return this.x + this.width / 2;
}, mxRectangle.prototype.getCenterY = function () {
  return this.y + this.height / 2;
}, mxRectangle.prototype.add = function (t) {
  if (null != t) {
    var e = Math.min(this.x, t.x),
        i = Math.min(this.y, t.y),
        n = Math.max(this.x + this.width, t.x + t.width);
    t = Math.max(this.y + this.height, t.y + t.height), this.x = e, this.y = i, this.width = n - e, this.height = t - i;
  }
}, mxRectangle.prototype.intersect = function (t) {
  if (null != t) {
    var e = this.x + this.width,
        i = t.x + t.width,
        n = this.y + this.height,
        s = t.y + t.height;
    this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.width = Math.min(e, i) - this.x, this.height = Math.min(n, s) - this.y;
  }
}, mxRectangle.prototype.grow = function (t) {
  this.x -= t, this.y -= t, this.width += 2 * t, this.height += 2 * t;
}, mxRectangle.prototype.getPoint = function () {
  return new mxPoint(this.x, this.y);
}, mxRectangle.prototype.rotate90 = function () {
  var t = (this.width - this.height) / 2;
  this.x += t, this.y -= t, t = this.width, this.width = this.height, this.height = t;
}, mxRectangle.prototype.equals = function (t) {
  return null != t && t.x == this.x && t.y == this.y && t.width == this.width && t.height == this.height;
}, mxRectangle.fromRectangle = function (t) {
  return new mxRectangle(t.x, t.y, t.width, t.height);
};
var mxEffects = {
  animateChanges: function animateChanges(t, e, i) {
    var n = 0,
        s = function s() {
      for (var l = !1, r = 0; r < e.length; r++) {
        var a = e[r];

        if (a instanceof mxGeometryChange || a instanceof mxTerminalChange || a instanceof mxValueChange || a instanceof mxChildChange || a instanceof mxStyleChange) {
          var h = t.getView().getState(a.cell || a.child, !1);
          if (null != h) if (l = !0, a.constructor != mxGeometryChange || t.model.isEdge(a.cell)) mxUtils.setOpacity(h.shape.node, 100 * n / 10);else {
            var u = t.getView().scale,
                d = (a.geometry.x - a.previous.x) * u,
                p = (a.geometry.y - a.previous.y) * u,
                c = (a.geometry.width - a.previous.width) * u;
            u = (a.geometry.height - a.previous.height) * u;
            0 == n ? (h.x -= d, h.y -= p, h.width -= c, h.height -= u) : (h.x += d / 10, h.y += p / 10, h.width += c / 10, h.height += u / 10), t.cellRenderer.redraw(h), mxEffects.cascadeOpacity(t, a.cell, 100 * n / 10);
          }
        }
      }

      10 > n && l ? (n++, window.setTimeout(s, o)) : null != i && i();
    },
        o = 30;

    s();
  },
  cascadeOpacity: function cascadeOpacity(t, e, i) {
    for (var n = t.model.getChildCount(e), s = 0; s < n; s++) {
      var o = t.model.getChildAt(e, s),
          l = t.getView().getState(o);
      null != l && (mxUtils.setOpacity(l.shape.node, i), mxEffects.cascadeOpacity(t, o, i));
    }

    if (null != (e = t.model.getEdges(e))) for (s = 0; s < e.length; s++) {
      null != (n = t.getView().getState(e[s])) && mxUtils.setOpacity(n.shape.node, i);
    }
  },
  fadeOut: function fadeOut(t, e, i, n, s, o) {
    n = n || 40, s = s || 30;
    var l = e || 100;

    if (mxUtils.setOpacity(t, l), o || null == o) {
      var r = function r() {
        l = Math.max(l - n, 0), mxUtils.setOpacity(t, l), 0 < l ? window.setTimeout(r, s) : (t.style.visibility = "hidden", i && t.parentNode && t.parentNode.removeChild(t));
      };

      window.setTimeout(r, s);
    } else t.style.visibility = "hidden", i && t.parentNode && t.parentNode.removeChild(t);
  }
},
    mxUtils = {
  errorResource: "none" != mxClient.language ? "error" : "",
  closeResource: "none" != mxClient.language ? "close" : "",
  errorImage: mxClient.imageBasePath + "/error.gif",
  removeCursors: function removeCursors(t) {
    if (null != t.style && (t.style.cursor = ""), null != (t = t.childNodes)) for (var e = t.length, i = 0; i < e; i += 1) {
      mxUtils.removeCursors(t[i]);
    }
  },
  getCurrentStyle: mxClient.IS_IE && (null == document.documentMode || 9 > document.documentMode) ? function (t) {
    return null != t ? t.currentStyle : null;
  } : function (t) {
    return null != t ? window.getComputedStyle(t, "") : null;
  },
  parseCssNumber: function parseCssNumber(t) {
    return "thin" == t ? t = "2" : "medium" == t ? t = "4" : "thick" == t && (t = "6"), t = parseFloat(t), isNaN(t) && (t = 0), t;
  },
  setPrefixedStyle: function () {
    var t = null;
    return mxClient.IS_OT ? t = "O" : mxClient.IS_SF || mxClient.IS_GC ? t = "Webkit" : mxClient.IS_MT ? t = "Moz" : mxClient.IS_IE && 9 <= document.documentMode && 10 > document.documentMode && (t = "ms"), function (e, i, n) {
      e[i] = n, null != t && 0 < i.length && (e[i = t + i.substring(0, 1).toUpperCase() + i.substring(1)] = n);
    };
  }(),
  hasScrollbars: function hasScrollbars(t) {
    return null != (t = mxUtils.getCurrentStyle(t)) && ("scroll" == t.overflow || "auto" == t.overflow);
  },
  bind: function bind(t, e) {
    return function () {
      return e.apply(t, arguments);
    };
  },
  eval: function _eval(a) {
    var b = null;
    if (0 <= a.indexOf("function")) try {
      eval("var _mxJavaScriptExpression=" + a), b = _mxJavaScriptExpression, _mxJavaScriptExpression = null;
    } catch (t) {
      mxLog.warn(t.message + " while evaluating " + a);
    } else try {
      b = eval(a);
    } catch (t) {
      mxLog.warn(t.message + " while evaluating " + a);
    }
    return b;
  },
  findNode: function findNode(t, e, i) {
    if (t.nodeType == mxConstants.NODETYPE_ELEMENT) {
      var n = t.getAttribute(e);
      if (null != n && n == i) return t;
    }

    for (t = t.firstChild; null != t;) {
      if (null != (n = mxUtils.findNode(t, e, i))) return n;
      t = t.nextSibling;
    }

    return null;
  },
  getFunctionName: function getFunctionName(t) {
    var e = null;
    return null != t && (null != t.name ? e = t.name : (e = mxUtils.trim(t.toString()), /^function\s/.test(e) && 0 < (t = (e = mxUtils.ltrim(e.substring(9))).indexOf("(")) && (e = e.substring(0, t)))), e;
  },
  indexOf: function indexOf(t, e) {
    if (null != t && null != e) for (var i = 0; i < t.length; i++) {
      if (t[i] == e) return i;
    }
    return -1;
  },
  forEach: function forEach(t, e) {
    if (null != t && null != e) for (var i = 0; i < t.length; i++) {
      e(t[i]);
    }
    return t;
  },
  remove: function remove(t, e) {
    var i = null;
    if ("object" == typeof e) for (var n = mxUtils.indexOf(e, t); 0 <= n;) {
      e.splice(n, 1), i = t, n = mxUtils.indexOf(e, t);
    }

    for (var s in e) {
      e[s] == t && (delete e[s], i = t);
    }

    return i;
  },
  isNode: function isNode(t, e, i, n) {
    return !(null == t || isNaN(t.nodeType) || null != e && t.nodeName.toLowerCase() != e.toLowerCase()) && (null == i || t.getAttribute(i) == n);
  },
  isAncestorNode: function isAncestorNode(t, e) {
    for (var i = e; null != i;) {
      if (i == t) return !0;
      i = i.parentNode;
    }

    return !1;
  },
  getChildNodes: function getChildNodes(t, e) {
    e = e || mxConstants.NODETYPE_ELEMENT;

    for (var i = [], n = t.firstChild; null != n;) {
      n.nodeType == e && i.push(n), n = n.nextSibling;
    }

    return i;
  },
  importNode: function importNode(t, e, i) {
    if (!mxClient.IS_IE || !(null == document.documentMode || 10 > document.documentMode)) return t.importNode(e, i);

    switch (e.nodeType) {
      case 1:
        var n = t.createElement(e.nodeName);

        if (e.attributes && 0 < e.attributes.length) {
          for (var s = 0; s < e.attributes.length; s++) {
            n.setAttribute(e.attributes[s].nodeName, e.getAttribute(e.attributes[s].nodeName));
          }

          if (i && e.childNodes && 0 < e.childNodes.length) for (s = 0; s < e.childNodes.length; s++) {
            n.appendChild(mxUtils.importNode(t, e.childNodes[s], i));
          }
        }

        return n;

      case 3:
      case 4:
      case 8:
        return t.createTextNode(e.value);
    }
  },
  createXmlDocument: function createXmlDocument() {
    var t = null;
    return document.implementation && document.implementation.createDocument ? t = document.implementation.createDocument("", "", null) : window.ActiveXObject && (t = new ActiveXObject("Microsoft.XMLDOM")), t;
  },
  parseXml: window.DOMParser ? function (t) {
    return new DOMParser().parseFromString(t, "text/xml");
  } : function (t) {
    var e = mxUtils.createXmlDocument();
    return e.async = !1, e.validateOnParse = !1, e.resolveExternals = !1, e.loadXML(t), e;
  },
  clearSelection: document.selection ? function () {
    document.selection.empty();
  } : window.getSelection ? function () {
    window.getSelection().empty ? window.getSelection().empty() : window.getSelection().removeAllRanges && window.getSelection().removeAllRanges();
  } : function () {},
  getPrettyXml: function getPrettyXml(t, e, i) {
    var n = [];
    if (null != t) if (e = e || "  ", i = i || "", t.nodeType == mxConstants.NODETYPE_TEXT) 0 < (t = mxUtils.trim(mxUtils.getTextContent(t))).length && n.push(i + mxUtils.htmlEntities(t) + "\n");else {
      n.push(i + "<" + t.nodeName);
      var s = t.attributes;
      if (null != s) for (var o = 0; o < s.length; o++) {
        var l = mxUtils.htmlEntities(s[o].value);
        n.push(" " + s[o].nodeName + '="' + l + '"');
      }

      if (null != (s = t.firstChild)) {
        for (n.push(">\n"); null != s;) {
          n.push(mxUtils.getPrettyXml(s, e, i + e)), s = s.nextSibling;
        }

        n.push(i + "</" + t.nodeName + ">\n");
      } else n.push("/>\n");
    }
    return n.join("");
  },
  removeWhitespace: function removeWhitespace(t, e) {
    for (var i = e ? t.previousSibling : t.nextSibling; null != i && i.nodeType == mxConstants.NODETYPE_TEXT;) {
      var n = e ? i.previousSibling : i.nextSibling,
          s = mxUtils.getTextContent(i);
      0 == mxUtils.trim(s).length && i.parentNode.removeChild(i), i = n;
    }
  },
  htmlEntities: function htmlEntities(t, e) {
    return t = (t = (t = (t = (t = (t = String(t || "")).replace(/&/g, "&amp;")).replace(/"/g, "&quot;")).replace(/\'/g, "&#39;")).replace(/</g, "&lt;")).replace(/>/g, "&gt;"), (null == e || e) && (t = t.replace(/\n/g, "&#xa;")), t;
  },
  isVml: function isVml(t) {
    return null != t && "urn:schemas-microsoft-com:vml" == t.tagUrn;
  },
  getXml: function getXml(t, e) {
    var i = "";
    return null != window.XMLSerializer ? i = new XMLSerializer().serializeToString(t) : null != t.xml && (i = t.xml.replace(/\r\n\t[\t]*/g, "").replace(/>\r\n/g, ">").replace(/\r\n/g, "\n")), i.replace(/\n/g, e || "&#xa;");
  },
  extractTextWithWhitespace: function extractTextWithWhitespace(t) {
    var e = "BLOCKQUOTE DIV H1 H2 H3 H4 H5 H6 OL P PRE TABLE UL".split(" "),
        i = [];
    return function t(n) {
      if (1 != n.length || "BR" != n[0].nodeName && "\n" != n[0].innerHTML) for (var s = 0; s < n.length; s++) {
        var o = n[s];
        "BR" == o.nodeName || "\n" == o.innerHTML || (1 == n.length || 0 == s) && "DIV" == o.nodeName && "<br>" == o.innerHTML.toLowerCase() ? i.push("\n") : (3 === o.nodeType || 4 === o.nodeType ? 0 < o.nodeValue.length && i.push(o.nodeValue) : 8 !== o.nodeType && 0 < o.childNodes.length && t(o.childNodes), s < n.length - 1 && 0 <= mxUtils.indexOf(e, n[s + 1].nodeName) && i.push("\n"));
      }
    }(t), i.join("");
  },
  replaceTrailingNewlines: function replaceTrailingNewlines(t, e) {
    for (var i = ""; 0 < t.length && "\n" == t.charAt(t.length - 1);) {
      t = t.substring(0, t.length - 1), i += e;
    }

    return t + i;
  },
  getTextContent: function getTextContent(t) {
    return mxClient.IS_IE && void 0 !== t.innerText ? t.innerText : null != t ? t[void 0 === t.textContent ? "text" : "textContent"] : "";
  },
  setTextContent: function setTextContent(t, e) {
    void 0 !== t.innerText ? t.innerText = e : t[void 0 === t.textContent ? "text" : "textContent"] = e;
  },
  getInnerHtml: mxClient.IS_IE ? function (t) {
    return null != t ? t.innerHTML : "";
  } : function (t) {
    return null != t ? new XMLSerializer().serializeToString(t) : "";
  },
  getOuterHtml: mxClient.IS_IE ? function (t) {
    if (null != t) {
      if (null != t.outerHTML) return t.outerHTML;
      var e = [];
      e.push("<" + t.nodeName);
      var i = t.attributes;
      if (null != i) for (var n = 0; n < i.length; n++) {
        var s = i[n].value;
        null != s && 0 < s.length && (e.push(" "), e.push(i[n].nodeName), e.push('="'), e.push(s), e.push('"'));
      }
      return 0 == t.innerHTML.length ? e.push("/>") : (e.push(">"), e.push(t.innerHTML), e.push("</" + t.nodeName + ">")), e.join("");
    }

    return "";
  } : function (t) {
    return null != t ? new XMLSerializer().serializeToString(t) : "";
  },
  write: function write(t, e) {
    var i = t.ownerDocument.createTextNode(e);
    return null != t && t.appendChild(i), i;
  },
  writeln: function writeln(t, e) {
    var i = t.ownerDocument.createTextNode(e);
    return null != t && (t.appendChild(i), t.appendChild(document.createElement("br"))), i;
  },
  br: function br(t, e) {
    e = e || 1;

    for (var i = null, n = 0; n < e; n++) {
      null != t && (i = t.ownerDocument.createElement("br"), t.appendChild(i));
    }

    return i;
  },
  button: function button(t, e, i) {
    return i = (i = null != i ? i : document).createElement("button"), mxUtils.write(i, t), mxEvent.addListener(i, "click", function (t) {
      e(t);
    }), i;
  },
  para: function para(t, e) {
    var i = document.createElement("p");
    return mxUtils.write(i, e), null != t && t.appendChild(i), i;
  },
  addTransparentBackgroundFilter: function addTransparentBackgroundFilter(t) {
    t.style.filter += "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + mxClient.imageBasePath + "/transparent.gif', sizingMethod='scale')";
  },
  linkAction: function linkAction(t, e, i, n, s) {
    return mxUtils.link(t, e, function () {
      i.execute(n);
    }, s);
  },
  linkInvoke: function linkInvoke(t, e, i, n, s, o) {
    return mxUtils.link(t, e, function () {
      i[n](s);
    }, o);
  },
  link: function link(t, e, i, n) {
    var s = document.createElement("span");
    return s.style.color = "blue", s.style.textDecoration = "underline", s.style.cursor = "pointer", null != n && (s.style.paddingLeft = n + "px"), mxEvent.addListener(s, "click", i), mxUtils.write(s, e), null != t && t.appendChild(s), s;
  },
  fit: function fit(t) {
    var e = parseInt(t.offsetLeft),
        i = parseInt(t.offsetWidth),
        n = (s = mxUtils.getDocumentScrollOrigin(t.ownerDocument)).x,
        s = s.y,
        o = document.body,
        l = document.documentElement,
        r = n + (o.clientWidth || l.clientWidth);
    e + i > r && (t.style.left = Math.max(n, r - i) + "px"), (e = parseInt(t.offsetTop)) + (i = parseInt(t.offsetHeight)) > (o = s + Math.max(o.clientHeight || 0, l.clientHeight)) && (t.style.top = Math.max(s, o - i) + "px");
  },
  load: function load(t) {
    return (t = new mxXmlRequest(t, null, "GET", !1)).send(), t;
  },
  get: function get(t, e, i, n, s, o) {
    return t = new mxXmlRequest(t, null, "GET"), null != n && t.setBinary(n), t.send(e, i, s, o), t;
  },
  getAll: function getAll(t, e, i) {
    for (var n = t.length, s = [], o = 0, l = function l() {
      0 == o && null != i && i(), o++;
    }, r = 0; r < t.length; r++) {
      !function (t, i) {
        mxUtils.get(t, function (t) {
          var o = t.getStatus();
          200 > o || 299 < o ? l() : (s[i] = t, 0 == --n && e(s));
        }, l);
      }(t[r], r);
    }

    0 == n && e(s);
  },
  post: function post(t, e, i, n) {
    return new mxXmlRequest(t, e).send(i, n);
  },
  submit: function submit(t, e, i, n) {
    return new mxXmlRequest(t, e).simulate(i, n);
  },
  loadInto: function loadInto(t, e, i) {
    mxClient.IS_IE ? e.onreadystatechange = function () {
      4 == e.readyState && i();
    } : e.addEventListener("load", i, !1), e.load(t);
  },
  getValue: function getValue(t, e, i) {
    return null == (t = null != t ? t[e] : null) && (t = i), t;
  },
  getNumber: function getNumber(t, e, i) {
    return null == (t = null != t ? t[e] : null) && (t = i || 0), Number(t);
  },
  getColor: function getColor(t, e, i) {
    return null == (t = null != t ? t[e] : null) ? t = i : t == mxConstants.NONE && (t = null), t;
  },
  clone: function clone(t, e, i) {
    i = null != i && i;
    var n = null;

    if (null != t && "function" == typeof t.constructor) {
      var s;
      n = new t.constructor();

      for (s in t) {
        s != mxObjectIdentity.FIELD_NAME && (null == e || 0 > mxUtils.indexOf(e, s)) && (n[s] = i || "object" != typeof t[s] ? t[s] : mxUtils.clone(t[s]));
      }
    }

    return n;
  },
  equalPoints: function equalPoints(t, e) {
    if (null == t && null != e || null != t && null == e || null != t && null != e && t.length != e.length) return !1;
    if (null != t && null != e) for (var i = 0; i < t.length; i++) {
      if (t[i] == e[i] || null != t[i] && !t[i].equals(e[i])) return !1;
    }
    return !0;
  },
  equalEntries: function equalEntries(t, e) {
    if (null == t && null != e || null != t && null == e || null != t && null != e && t.length != e.length) return !1;

    if (null != t && null != e) {
      var i,
          n = 0;

      for (i in e) {
        n++;
      }

      for (i in t) {
        if (n--, !(mxUtils.isNaN(t[i]) && mxUtils.isNaN(e[i]) || t[i] == e[i])) return !1;
      }
    }

    return 0 == n;
  },
  removeDuplicates: function removeDuplicates(t) {
    for (var e = new mxDictionary(), i = [], n = 0; n < t.length; n++) {
      e.get(t[n]) || (i.push(t[n]), e.put(t[n], !0));
    }

    return i;
  },
  isNaN: function (_isNaN) {
    function isNaN(_x) {
      return _isNaN.apply(this, arguments);
    }

    isNaN.toString = function () {
      return _isNaN.toString();
    };

    return isNaN;
  }(function (t) {
    return "number" == typeof t && isNaN(t);
  }),
  extend: function extend(t, e) {
    var i = function i() {};

    i.prototype = e.prototype, t.prototype = new i(), t.prototype.constructor = t;
  },
  toString: function toString(t) {
    var e,
        i = "";

    for (e in t) {
      try {
        if (null == t[e]) i += e + " = [null]\n";else if ("function" == typeof t[e]) i += e + " => [Function]\n";else if ("object" == typeof t[e]) i = i + (e + " => [") + mxUtils.getFunctionName(t[e].constructor) + "]\n";else i += e + " = " + t[e] + "\n";
      } catch (t) {
        i += e + "=" + t.message;
      }
    }

    return i;
  },
  toRadians: function toRadians(t) {
    return Math.PI * t / 180;
  },
  toDegree: function toDegree(t) {
    return 180 * t / Math.PI;
  },
  arcToCurves: function arcToCurves(t, e, i, n, s, o, l, r, a) {
    if (r -= t, a -= e, 0 === i || 0 === n) return g;
    i = Math.abs(i), n = Math.abs(n);
    var h = -r / 2,
        u = -a / 2,
        d = Math.cos(s * Math.PI / 180);
    s = d * h + (g = Math.sin(s * Math.PI / 180)) * u;
    h = -1 * g * h + d * u;
    1 < (v = (u = s * s) / (m = i * i) + (c = h * h) / (f = n * n)) ? (i *= Math.sqrt(v), n *= Math.sqrt(v), o = 0) : (v = 1, o === l && (v = -1), o = v * Math.sqrt((m * f - m * c - f * u) / (m * c + f * u))), r = d * (u = o * i * h / n) - g * (c = -1 * o * n * s / i) + r / 2, a = g * u + d * c + a / 2, o = 0 <= (m = Math.atan2((h - c) / n, (s - u) / i) - Math.atan2(0, 1)) ? m : 2 * Math.PI + m, s = 0 <= (m = Math.atan2((-h - c) / n, (-s - u) / i) - Math.atan2((h - c) / n, (s - u) / i)) ? m : 2 * Math.PI + m, 0 == l && 0 < s ? s -= 2 * Math.PI : 0 != l && 0 > s && (s += 2 * Math.PI), l = 2 * s / Math.PI, s /= l = Math.ceil(0 > l ? -1 * l : l), h = 8 / 3 * Math.sin(s / 4) * Math.sin(s / 4) / Math.sin(s / 2), u = d * i, d *= n, i *= g, n *= g;

    for (var p = Math.cos(o), c = -h * (u * (y = Math.sin(o)) + n * p), m = -h * (i * y - d * p), g = [], x = 0; x < l; ++x) {
      o += s;
      var y,
          f = u * (p = Math.cos(o)) - n * (y = Math.sin(o)) + r,
          v = i * p + d * y + a,
          C = -h * (u * y + n * p);
      p = -h * (i * y - d * p);
      g[y = 6 * x] = Number(c + t), g[y + 1] = Number(m + e), g[y + 2] = Number(f - C + t), g[y + 3] = Number(v - p + e), g[y + 4] = Number(f + t), g[y + 5] = Number(v + e), c = f + C, m = v + p;
    }

    return g;
  },
  getBoundingBox: function getBoundingBox(t, e, i) {
    var n = null;

    if (null != t && null != e && 0 != e) {
      e = mxUtils.toRadians(e);
      n = Math.cos(e);
      var s = Math.sin(e);
      i = null != i ? i : new mxPoint(t.x + t.width / 2, t.y + t.height / 2);
      var o = new mxPoint(t.x, t.y);
      e = new mxPoint(t.x + t.width, t.y);
      var l = new mxPoint(e.x, t.y + t.height);
      t = new mxPoint(t.x, l.y), o = mxUtils.getRotatedPoint(o, n, s, i), e = mxUtils.getRotatedPoint(e, n, s, i), l = mxUtils.getRotatedPoint(l, n, s, i), t = mxUtils.getRotatedPoint(t, n, s, i), (n = new mxRectangle(o.x, o.y, 0, 0)).add(new mxRectangle(e.x, e.y, 0, 0)), n.add(new mxRectangle(l.x, l.y, 0, 0)), n.add(new mxRectangle(t.x, t.y, 0, 0));
    }

    return n;
  },
  getRotatedPoint: function getRotatedPoint(t, e, i, n) {
    n = null != n ? n : new mxPoint();
    var s = t.x - n.x;
    return new mxPoint(s * e - (t = t.y - n.y) * i + n.x, t * e + s * i + n.y);
  },
  getPortConstraints: function getPortConstraints(t, e, i, n) {
    if (null == (e = mxUtils.getValue(t.style, mxConstants.STYLE_PORT_CONSTRAINT, mxUtils.getValue(e.style, i ? mxConstants.STYLE_SOURCE_PORT_CONSTRAINT : mxConstants.STYLE_TARGET_PORT_CONSTRAINT, null)))) return n;
    if (n = e.toString(), e = mxConstants.DIRECTION_MASK_NONE, i = 0, 1 == mxUtils.getValue(t.style, mxConstants.STYLE_PORT_CONSTRAINT_ROTATION, 0) && (i = mxUtils.getValue(t.style, mxConstants.STYLE_ROTATION, 0)), t = 0, 45 < i ? (t = 1, 135 <= i && (t = 2)) : -45 > i && (t = 3, -135 >= i && (t = 2)), 0 <= n.indexOf(mxConstants.DIRECTION_NORTH)) switch (t) {
      case 0:
        e |= mxConstants.DIRECTION_MASK_NORTH;
        break;

      case 1:
        e |= mxConstants.DIRECTION_MASK_EAST;
        break;

      case 2:
        e |= mxConstants.DIRECTION_MASK_SOUTH;
        break;

      case 3:
        e |= mxConstants.DIRECTION_MASK_WEST;
    }
    if (0 <= n.indexOf(mxConstants.DIRECTION_WEST)) switch (t) {
      case 0:
        e |= mxConstants.DIRECTION_MASK_WEST;
        break;

      case 1:
        e |= mxConstants.DIRECTION_MASK_NORTH;
        break;

      case 2:
        e |= mxConstants.DIRECTION_MASK_EAST;
        break;

      case 3:
        e |= mxConstants.DIRECTION_MASK_SOUTH;
    }
    if (0 <= n.indexOf(mxConstants.DIRECTION_SOUTH)) switch (t) {
      case 0:
        e |= mxConstants.DIRECTION_MASK_SOUTH;
        break;

      case 1:
        e |= mxConstants.DIRECTION_MASK_WEST;
        break;

      case 2:
        e |= mxConstants.DIRECTION_MASK_NORTH;
        break;

      case 3:
        e |= mxConstants.DIRECTION_MASK_EAST;
    }
    if (0 <= n.indexOf(mxConstants.DIRECTION_EAST)) switch (t) {
      case 0:
        e |= mxConstants.DIRECTION_MASK_EAST;
        break;

      case 1:
        e |= mxConstants.DIRECTION_MASK_SOUTH;
        break;

      case 2:
        e |= mxConstants.DIRECTION_MASK_WEST;
        break;

      case 3:
        e |= mxConstants.DIRECTION_MASK_NORTH;
    }
    return e;
  },
  reversePortConstraints: function reversePortConstraints(t) {
    var e;
    return e = (t & mxConstants.DIRECTION_MASK_WEST) << 3, e |= (t & mxConstants.DIRECTION_MASK_NORTH) << 1, (e |= (t & mxConstants.DIRECTION_MASK_SOUTH) >> 1) | (t & mxConstants.DIRECTION_MASK_EAST) >> 3;
  },
  findNearestSegment: function findNearestSegment(t, e, i) {
    var n = -1;
    if (0 < t.absolutePoints.length) for (var s = t.absolutePoints[0], o = null, l = 1; l < t.absolutePoints.length; l++) {
      var r = t.absolutePoints[l];
      s = mxUtils.ptSegDistSq(s.x, s.y, r.x, r.y, e, i);
      (null == o || s < o) && (o = s, n = l - 1), s = r;
    }
    return n;
  },
  getDirectedBounds: function getDirectedBounds(t, e, i, n, s) {
    var o = mxUtils.getValue(i, mxConstants.STYLE_DIRECTION, mxConstants.DIRECTION_EAST);
    return n = null != n ? n : mxUtils.getValue(i, mxConstants.STYLE_FLIPH, !1), s = null != s ? s : mxUtils.getValue(i, mxConstants.STYLE_FLIPV, !1), e.x = Math.round(Math.max(0, Math.min(t.width, e.x))), e.y = Math.round(Math.max(0, Math.min(t.height, e.y))), e.width = Math.round(Math.max(0, Math.min(t.width, e.width))), e.height = Math.round(Math.max(0, Math.min(t.height, e.height))), (s && (o == mxConstants.DIRECTION_SOUTH || o == mxConstants.DIRECTION_NORTH) || n && (o == mxConstants.DIRECTION_EAST || o == mxConstants.DIRECTION_WEST)) && (i = e.x, e.x = e.width, e.width = i), (n && (o == mxConstants.DIRECTION_SOUTH || o == mxConstants.DIRECTION_NORTH) || s && (o == mxConstants.DIRECTION_EAST || o == mxConstants.DIRECTION_WEST)) && (i = e.y, e.y = e.height, e.height = i), n = mxRectangle.fromRectangle(e), o == mxConstants.DIRECTION_SOUTH ? (n.y = e.x, n.x = e.height, n.width = e.y, n.height = e.width) : o == mxConstants.DIRECTION_WEST ? (n.y = e.height, n.x = e.width, n.width = e.x, n.height = e.y) : o == mxConstants.DIRECTION_NORTH && (n.y = e.width, n.x = e.y, n.width = e.height, n.height = e.x), new mxRectangle(t.x + n.x, t.y + n.y, t.width - n.width - n.x, t.height - n.height - n.y);
  },
  getPerimeterPoint: function getPerimeterPoint(t, e, i) {
    for (var n = null, s = 0; s < t.length - 1; s++) {
      if (null != (o = mxUtils.intersection(t[s].x, t[s].y, t[s + 1].x, t[s + 1].y, e.x, e.y, i.x, i.y))) {
        var o,
            l = i.x - o.x,
            r = i.y - o.y;
        null != (o = {
          p: o,
          distSq: r * r + l * l
        }) && (null == n || n.distSq > o.distSq) && (n = o);
      }
    }

    return null != n ? n.p : null;
  },
  rectangleIntersectsSegment: function rectangleIntersectsSegment(t, e, i) {
    var n = t.y,
        s = t.x,
        o = n + t.height,
        l = s + t.width;
    t = e.x;
    var r = i.x;
    if (e.x > i.x && (t = i.x, r = e.x), r > l && (r = l), t < s && (t = s), t > r) return !1;
    s = e.y, l = i.y;
    var a = i.x - e.x;
    return 1e-7 < Math.abs(a) && (s = (i = (i.y - e.y) / a) * t + (e = e.y - i * e.x), l = i * r + e), s > l && (e = l, l = s, s = e), l > o && (l = o), s < n && (s = n), !(s > l);
  },
  contains: function contains(t, e, i) {
    return t.x <= e && t.x + t.width >= e && t.y <= i && t.y + t.height >= i;
  },
  intersects: function intersects(t, e) {
    var i = t.width,
        n = t.height,
        s = e.width,
        o = e.height;
    if (0 >= s || 0 >= o || 0 >= i || 0 >= n) return !1;
    var l = t.x,
        r = t.y,
        a = e.x,
        h = e.y;
    o += h, i += l, n += r;
    return ((s = s + a) < a || s > l) && (o < h || o > r) && (i < l || i > a) && (n < r || n > h);
  },
  intersectsHotspot: function intersectsHotspot(t, e, i, n, s, o) {
    if (s = null != s ? s : 0, o = null != o ? o : 0, 0 < (n = null != n ? n : 1)) {
      var l = t.getCenterX(),
          r = t.getCenterY(),
          a = t.width,
          h = t.height,
          u = mxUtils.getValue(t.style, mxConstants.STYLE_STARTSIZE) * t.view.scale;
      return 0 < u && (mxUtils.getValue(t.style, mxConstants.STYLE_HORIZONTAL, !0) ? (r = t.y + u / 2, h = u) : (l = t.x + u / 2, a = u)), a = Math.max(s, a * n), h = Math.max(s, h * n), 0 < o && (a = Math.min(a, o), h = Math.min(h, o)), n = new mxRectangle(l - a / 2, r - h / 2, a, h), 0 != (l = mxUtils.toRadians(mxUtils.getValue(t.style, mxConstants.STYLE_ROTATION) || 0)) && (s = Math.cos(-l), o = Math.sin(-l), l = new mxPoint(t.getCenterX(), t.getCenterY()), e = (t = mxUtils.getRotatedPoint(new mxPoint(e, i), s, o, l)).x, i = t.y), mxUtils.contains(n, e, i);
    }

    return !0;
  },
  getOffset: function getOffset(t, e) {
    for (var i = 0, n = 0, s = !1, o = t, l = document.body, r = document.documentElement; null != o && o != l && o != r && !s;) {
      var a = mxUtils.getCurrentStyle(o);
      null != a && (s = s || "fixed" == a.position), o = o.parentNode;
    }

    return e || s || (i += (s = mxUtils.getDocumentScrollOrigin(t.ownerDocument)).x, n += s.y), null != (s = t.getBoundingClientRect()) && (i += s.left, n += s.top), new mxPoint(i, n);
  },
  getDocumentScrollOrigin: function getDocumentScrollOrigin(t) {
    return mxClient.IS_QUIRKS ? new mxPoint(t.body.scrollLeft, t.body.scrollTop) : new mxPoint(null != (t = t.defaultView || t.parentWindow) && void 0 !== window.pageXOffset ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft, null != t && void 0 !== window.pageYOffset ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop);
  },
  getScrollOrigin: function getScrollOrigin(t, e, i) {
    e = null != e && e, i = null == i || i;

    for (var n = null != t ? t.ownerDocument : document, s = n.body, o = n.documentElement, l = new mxPoint(), r = !1; null != t && t != s && t != o;) {
      isNaN(t.scrollLeft) || isNaN(t.scrollTop) || (l.x += t.scrollLeft, l.y += t.scrollTop);
      var a = mxUtils.getCurrentStyle(t);
      null != a && (r = r || "fixed" == a.position), t = e ? t.parentNode : null;
    }

    return !r && i && (t = mxUtils.getDocumentScrollOrigin(n), l.x += t.x, l.y += t.y), l;
  },
  convertPoint: function convertPoint(t, e, i) {
    var n = mxUtils.getScrollOrigin(t, !1);
    return (t = mxUtils.getOffset(t)).x -= n.x, t.y -= n.y, new mxPoint(e - t.x, i - t.y);
  },
  ltrim: function ltrim(t, e) {
    return null != t ? t.replace(new RegExp("^[" + (e || "\\s") + "]+", "g"), "") : null;
  },
  rtrim: function rtrim(t, e) {
    return null != t ? t.replace(new RegExp("[" + (e || "\\s") + "]+$", "g"), "") : null;
  },
  trim: function trim(t, e) {
    return mxUtils.ltrim(mxUtils.rtrim(t, e), e);
  },
  isNumeric: function isNumeric(t) {
    return !isNaN(parseFloat(t)) && isFinite(t) && ("string" != typeof t || 0 > t.toLowerCase().indexOf("0x"));
  },
  isInteger: function isInteger(t) {
    return String(parseInt(t)) === String(t);
  },
  mod: function mod(t, e) {
    return (t % e + e) % e;
  },
  intersection: function intersection(t, e, i, n, s, o, l, r) {
    var a = (r - o) * (i - t) - (l - s) * (n - e);
    return l = ((l - s) * (e - o) - (r - o) * (t - s)) / a, s = ((i - t) * (e - o) - (n - e) * (t - s)) / a, 0 <= l && 1 >= l && 0 <= s && 1 >= s ? new mxPoint(t + l * (i - t), e + l * (n - e)) : null;
  },
  ptSegDistSq: function ptSegDistSq(t, e, i, n, s, o) {
    return 0 >= (s -= t) * (i -= t) + (o -= e) * (n -= e) ? i = 0 : i = 0 >= (t = (s = i - s) * i + (o = n - o) * n) ? 0 : t * t / (i * i + n * n), 0 > (s = s * s + o * o - i) && (s = 0), s;
  },
  ptLineDist: function ptLineDist(t, e, i, n, s, o) {
    return Math.abs((n - e) * s - (i - t) * o + i * e - n * t) / Math.sqrt((n - e) * (n - e) + (i - t) * (i - t));
  },
  relativeCcw: function relativeCcw(t, e, i, n, s, o) {
    return 0 == (t = (s -= t) * (n -= e) - (o -= e) * (i -= t)) && 0 < (t = s * i + o * n) && 0 > (t = (s - i) * i + (o - n) * n) && (t = 0), 0 > t ? -1 : 0 < t ? 1 : 0;
  },
  animateChanges: function animateChanges(t, e) {
    mxEffects.animateChanges.apply(this, arguments);
  },
  cascadeOpacity: function cascadeOpacity(t, e, i) {
    mxEffects.cascadeOpacity.apply(this, arguments);
  },
  fadeOut: function fadeOut(t, e, i, n, s, o) {
    mxEffects.fadeOut.apply(this, arguments);
  },
  setOpacity: function setOpacity(t, e) {
    mxUtils.isVml(t) ? t.style.filter = 100 <= e ? "" : "alpha(opacity=" + e / 5 + ")" : mxClient.IS_IE && (void 0 === document.documentMode || 9 > document.documentMode) ? t.style.filter = 100 <= e ? "" : "alpha(opacity=" + e + ")" : t.style.opacity = e / 100;
  },
  createImage: function createImage(t) {
    var e;
    return mxClient.IS_IE6 && "CSS1Compat" != document.compatMode ? ((e = document.createElement(mxClient.VML_PREFIX + ":image")).setAttribute("src", t), e.style.borderStyle = "none") : ((e = document.createElement("img")).setAttribute("src", t), e.setAttribute("border", "0")), e;
  },
  sortCells: function sortCells(t, e) {
    e = null == e || e;
    var i = new mxDictionary();
    return t.sort(function (t, n) {
      var s = i.get(t);
      null == s && (s = mxCellPath.create(t).split(mxCellPath.PATH_SEPARATOR), i.put(t, s));
      var o = i.get(n);
      return null == o && (o = mxCellPath.create(n).split(mxCellPath.PATH_SEPARATOR), i.put(n, o)), 0 == (s = mxCellPath.compare(s, o)) ? 0 : 0 < s == e ? 1 : -1;
    }), t;
  },
  getStylename: function getStylename(t) {
    return null != t && 0 > (t = t.split(";")[0]).indexOf("=") ? t : "";
  },
  getStylenames: function getStylenames(t) {
    var e = [];

    if (null != t) {
      t = t.split(";");

      for (var i = 0; i < t.length; i++) {
        0 > t[i].indexOf("=") && e.push(t[i]);
      }
    }

    return e;
  },
  indexOfStylename: function indexOfStylename(t, e) {
    if (null != t && null != e) for (var i = t.split(";"), n = 0, s = 0; s < i.length; s++) {
      if (i[s] == e) return n;
      n += i[s].length + 1;
    }
    return -1;
  },
  addStylename: function addStylename(t, e) {
    return 0 > mxUtils.indexOfStylename(t, e) && (null == t ? t = "" : 0 < t.length && ";" != t.charAt(t.length - 1) && (t += ";"), t += e), t;
  },
  removeStylename: function removeStylename(t, e) {
    var i = [];
    if (null != t) for (var n = t.split(";"), s = 0; s < n.length; s++) {
      n[s] != e && i.push(n[s]);
    }
    return i.join(";");
  },
  removeAllStylenames: function removeAllStylenames(t) {
    var e = [];

    if (null != t) {
      t = t.split(";");

      for (var i = 0; i < t.length; i++) {
        0 <= t[i].indexOf("=") && e.push(t[i]);
      }
    }

    return e.join(";");
  },
  setCellStyles: function setCellStyles(t, e, i, n) {
    if (null != e && 0 < e.length) {
      t.beginUpdate();

      try {
        for (var s = 0; s < e.length; s++) {
          if (null != e[s]) {
            var o = mxUtils.setStyle(t.getStyle(e[s]), i, n);
            t.setStyle(e[s], o);
          }
        }
      } finally {
        t.endUpdate();
      }
    }
  },
  setStyle: function setStyle(t, e, i) {
    var n = null != i && (void 0 === i.length || 0 < i.length);
    if (null == t || 0 == t.length) n && (t = e + "=" + i + ";");else if (t.substring(0, e.length + 1) == e + "=") {
      var s = t.indexOf(";");
      t = n ? e + "=" + i + (0 > s ? ";" : t.substring(s)) : 0 > s || s == t.length - 1 ? "" : t.substring(s + 1);
    } else {
      var o = t.indexOf(";" + e + "=");
      0 > o ? n && (n = ";" == t.charAt(t.length - 1) ? "" : ";", t = t + n + e + "=" + i + ";") : (s = t.indexOf(";", o + 1), t = n ? t.substring(0, o + 1) + e + "=" + i + (0 > s ? ";" : t.substring(s)) : t.substring(0, o) + (0 > s ? ";" : t.substring(s)));
    }
    return t;
  },
  setCellStyleFlags: function setCellStyleFlags(t, e, i, n, s) {
    if (null != e && 0 < e.length) {
      t.beginUpdate();

      try {
        for (var o = 0; o < e.length; o++) {
          if (null != e[o]) {
            var l = mxUtils.setStyleFlag(t.getStyle(e[o]), i, n, s);
            t.setStyle(e[o], l);
          }
        }
      } finally {
        t.endUpdate();
      }
    }
  },
  setStyleFlag: function setStyleFlag(t, e, i, n) {
    if (null == t || 0 == t.length) t = n || null == n ? e + "=" + i : e + "=0";else {
      var s = t.indexOf(e + "=");
      if (0 > s) s = ";" == t.charAt(t.length - 1) ? "" : ";", t = n || null == n ? t + s + e + "=" + i : t + s + e + "=0";else {
        var o,
            l = t.indexOf(";", s);
        o = 0 > l ? t.substring(s + e.length + 1) : t.substring(s + e.length + 1, l), o = null == n ? parseInt(o) ^ i : n ? parseInt(o) | i : parseInt(o) & ~i, t = t.substring(0, s) + e + "=" + o + (0 <= l ? t.substring(l) : "");
      }
    }
    return t;
  },
  getAlignmentAsPoint: function getAlignmentAsPoint(t, e) {
    var i = 0,
        n = 0;
    return t == mxConstants.ALIGN_CENTER ? i = -.5 : t == mxConstants.ALIGN_RIGHT && (i = -1), e == mxConstants.ALIGN_MIDDLE ? n = -.5 : e == mxConstants.ALIGN_BOTTOM && (n = -1), new mxPoint(i, n);
  },
  getSizeForString: function getSizeForString(t, e, i, n) {
    e = null != e ? e : mxConstants.DEFAULT_FONTSIZE, i = null != i ? i : mxConstants.DEFAULT_FONTFAMILY;
    var s = document.createElement("div");
    return s.style.fontFamily = i, s.style.fontSize = Math.round(e) + "px", s.style.lineHeight = Math.round(e * mxConstants.LINE_HEIGHT) + "px", s.style.position = "absolute", s.style.visibility = "hidden", s.style.display = mxClient.IS_QUIRKS ? "inline" : "inline-block", s.style.zoom = "1", null != n ? (s.style.width = n + "px", s.style.whiteSpace = "normal") : s.style.whiteSpace = "nowrap", s.innerHTML = t, document.body.appendChild(s), t = new mxRectangle(0, 0, s.offsetWidth, s.offsetHeight), document.body.removeChild(s), t;
  },
  getViewXml: function getViewXml(t, e, i, n, s) {
    n = null != n ? n : 0, s = null != s ? s : 0, e = null != e ? e : 1, null == i && (i = [t.getModel().getRoot()]);
    var o = t.getView(),
        l = null,
        r = o.isEventsEnabled();
    o.setEventsEnabled(!1);
    var a = o.drawPane,
        h = o.overlayPane;
    t.dialect == mxConstants.DIALECT_SVG ? (o.drawPane = document.createElementNS(mxConstants.NS_SVG, "g"), o.canvas.appendChild(o.drawPane), o.overlayPane = document.createElementNS(mxConstants.NS_SVG, "g")) : (o.drawPane = o.drawPane.cloneNode(!1), o.canvas.appendChild(o.drawPane), o.overlayPane = o.overlayPane.cloneNode(!1)), o.canvas.appendChild(o.overlayPane);
    var u = o.getTranslate();
    o.translate = new mxPoint(n, s), e = new mxTemporaryCellStates(t.getView(), e, i);

    try {
      l = new mxCodec().encode(t.getView());
    } finally {
      e.destroy(), o.translate = u, o.canvas.removeChild(o.drawPane), o.canvas.removeChild(o.overlayPane), o.drawPane = a, o.overlayPane = h, o.setEventsEnabled(r);
    }

    return l;
  },
  getScaleForPageCount: function getScaleForPageCount(t, e, i, n) {
    if (1 > t) return 1;
    n = null != n ? n : 0;
    var s = (i = null != i ? i : mxConstants.PAGE_FORMAT_A4_PORTRAIT).width - 2 * n;
    i = i.height - 2 * n, n = e.getGraphBounds().clone(), e = e.getView().getScale(), n.width /= e, n.height /= e, e = n.width;
    var o = Math.sqrt(t);

    if (i = o * (n = Math.sqrt(e / n.height / (s / i))), n = o / n, 1 > i && n > t) {
      var l = n / t;
      n = t, i /= l;
    }

    for (1 > n && i > t && (l = i / t, i = t, n /= l), l = Math.ceil(i) * Math.ceil(n), o = 0; l > t;) {
      l = Math.floor(i) / i;
      var r = Math.floor(n) / n;
      if (1 == l && (l = Math.floor(i - 1) / i), 1 == r && (r = Math.floor(n - 1) / n), i *= l = l > r ? l : r, n *= l, l = Math.ceil(i) * Math.ceil(n), 10 < ++o) break;
    }

    return s * i / e * .99999;
  },
  show: function show(t, e, i, n, s, o) {
    i = null != i ? i : 0, n = null != n ? n : 0, null == e ? e = window.open().document : e.open(), 9 == document.documentMode && e.writeln('\x3c!--[if IE]><meta http-equiv="X-UA-Compatible" content="IE=9"><![endif]--\x3e');
    var l = t.getGraphBounds(),
        r = Math.ceil(i - l.x),
        a = Math.ceil(n - l.y);

    if (null == s && (s = Math.ceil(l.width + i) + Math.ceil(Math.ceil(l.x) - l.x)), null == o && (o = Math.ceil(l.height + n) + Math.ceil(Math.ceil(l.y) - l.y)), mxClient.IS_IE || 11 == document.documentMode) {
      for (n = "<html><head>", l = document.getElementsByTagName("base"), i = 0; i < l.length; i++) {
        n += l[i].outerHTML;
      }

      for (n += "<style>", i = 0; i < document.styleSheets.length; i++) {
        try {
          n += document.styleSheets[i].cssText;
        } catch (t) {}
      }

      n = n + '</style></head><body style="margin:0px;"><div style="position:absolute;overflow:hidden;width:' + s + "px;height:" + o + 'px;"><div style="position:relative;left:' + r + "px;top:" + a + 'px;">' + t.container.innerHTML, e.writeln(n + "</div></div></body><html>"), e.close();
    } else {
      for (e.writeln("<html><head>"), l = document.getElementsByTagName("base"), i = 0; i < l.length; i++) {
        e.writeln(mxUtils.getOuterHtml(l[i]));
      }

      for (n = document.getElementsByTagName("link"), i = 0; i < n.length; i++) {
        e.writeln(mxUtils.getOuterHtml(n[i]));
      }

      for (n = document.getElementsByTagName("style"), i = 0; i < n.length; i++) {
        e.writeln(mxUtils.getOuterHtml(n[i]));
      }

      for (e.writeln('</head><body style="margin:0px;"></body></html>'), e.close(), (i = e.createElement("div")).position = "absolute", i.overflow = "hidden", i.style.width = s + "px", i.style.height = o + "px", (s = e.createElement("div")).style.position = "absolute", s.style.left = r + "px", s.style.top = a + "px", o = t.container.firstChild, n = null; null != o;) {
        l = o.cloneNode(!0), o == t.view.drawPane.ownerSVGElement ? (i.appendChild(l), n = l) : s.appendChild(l), o = o.nextSibling;
      }

      e.body.appendChild(i), null != s.firstChild && e.body.appendChild(s), null != n && (n.style.minWidth = "", n.style.minHeight = "", n.firstChild.setAttribute("transform", "translate(" + r + "," + a + ")"));
    }

    return mxUtils.removeCursors(e.body), e;
  },
  printScreen: function printScreen(t) {
    var e = window.open();
    t.getGraphBounds(), mxUtils.show(t, e.document), t = function t() {
      e.focus(), e.print(), e.close();
    }, mxClient.IS_GC ? e.setTimeout(t, 500) : t();
  },
  popup: function popup(t, e) {
    if (e) {
      var i = document.createElement("div");
      i.style.overflow = "scroll", i.style.width = "636px", i.style.height = "460px";
      var n = document.createElement("pre");
      n.innerHTML = mxUtils.htmlEntities(t, !1).replace(/\n/g, "<br>").replace(/ /g, "&nbsp;"), i.appendChild(n), (i = new mxWindow("Popup Window", i, document.body.clientWidth / 2 - 320, Math.max(document.body.clientHeight || 0, document.documentElement.clientHeight) / 2 - 240, 640, 480, !1, !0)).setClosable(!0), i.setVisible(!0);
    } else mxClient.IS_NS ? ((i = window.open()).document.writeln("<pre>" + mxUtils.htmlEntities(t) + "</pre"), i.document.close()) : ((n = (i = window.open()).document.createElement("pre")).innerHTML = mxUtils.htmlEntities(t, !1).replace(/\n/g, "<br>").replace(/ /g, "&nbsp;"), i.document.body.appendChild(n));
  },
  alert: function (_alert) {
    function alert(_x2) {
      return _alert.apply(this, arguments);
    }

    alert.toString = function () {
      return _alert.toString();
    };

    return alert;
  }(function (t) {
    alert(t);
  }),
  prompt: function (_prompt) {
    function prompt(_x3, _x4) {
      return _prompt.apply(this, arguments);
    }

    prompt.toString = function () {
      return _prompt.toString();
    };

    return prompt;
  }(function (t, e) {
    return prompt(t, null != e ? e : "");
  }),
  confirm: function (_confirm) {
    function confirm(_x5) {
      return _confirm.apply(this, arguments);
    }

    confirm.toString = function () {
      return _confirm.toString();
    };

    return confirm;
  }(function (t) {
    return confirm(t);
  }),
  error: function error(t, e, i, n) {
    var s = document.createElement("div");
    s.style.padding = "20px";
    var o = document.createElement("img");
    o.setAttribute("src", n || mxUtils.errorImage), o.setAttribute("valign", "bottom"), o.style.verticalAlign = "middle", s.appendChild(o), s.appendChild(document.createTextNode(" ")), s.appendChild(document.createTextNode(" ")), s.appendChild(document.createTextNode(" ")), mxUtils.write(s, t), t = document.body.clientWidth, n = document.body.clientHeight || document.documentElement.clientHeight;
    var l = new mxWindow(mxResources.get(mxUtils.errorResource) || mxUtils.errorResource, s, (t - e) / 2, n / 4, e, null, !1, !0);
    return i && (mxUtils.br(s), e = document.createElement("p"), i = document.createElement("button"), mxClient.IS_IE ? i.style.cssText = "float:right" : i.setAttribute("style", "float:right"), mxEvent.addListener(i, "click", function (t) {
      l.destroy();
    }), mxUtils.write(i, mxResources.get(mxUtils.closeResource) || mxUtils.closeResource), e.appendChild(i), s.appendChild(e), mxUtils.br(s), l.setClosable(!0)), l.setVisible(!0), l;
  },
  makeDraggable: function makeDraggable(t, e, i, n, s, o, l, r, a, h) {
    return (t = new mxDragSource(t, i)).dragOffset = new mxPoint(null != s ? s : 0, null != o ? o : mxConstants.TOOLTIP_VERTICAL_OFFSET), t.autoscroll = l, t.setGuidesEnabled(!1), null != a && (t.highlightDropTargets = a), null != h && (t.getDropTarget = h), t.getGraphForEvent = function (t) {
      return "function" == typeof e ? e(t) : e;
    }, null != n && (t.createDragElement = function () {
      return n.cloneNode(!0);
    }, r && (t.createPreviewElement = function (t) {
      var e = n.cloneNode(!0),
          i = parseInt(e.style.width),
          s = parseInt(e.style.height);
      return e.style.width = Math.round(i * t.view.scale) + "px", e.style.height = Math.round(s * t.view.scale) + "px", e;
    })), t;
  }
},
    mxConstants = {
  DEFAULT_HOTSPOT: .3,
  MIN_HOTSPOT_SIZE: 8,
  MAX_HOTSPOT_SIZE: 0,
  RENDERING_HINT_EXACT: "exact",
  RENDERING_HINT_FASTER: "faster",
  RENDERING_HINT_FASTEST: "fastest",
  DIALECT_SVG: "svg",
  DIALECT_VML: "vml",
  DIALECT_MIXEDHTML: "mixedHtml",
  DIALECT_PREFERHTML: "preferHtml",
  DIALECT_STRICTHTML: "strictHtml",
  NS_SVG: "http://www.w3.org/2000/svg",
  NS_XHTML: "http://www.w3.org/1999/xhtml",
  NS_XLINK: "http://www.w3.org/1999/xlink",
  SHADOWCOLOR: "gray",
  VML_SHADOWCOLOR: "gray",
  SHADOW_OFFSET_X: 2,
  SHADOW_OFFSET_Y: 3,
  SHADOW_OPACITY: 1,
  NODETYPE_ELEMENT: 1,
  NODETYPE_ATTRIBUTE: 2,
  NODETYPE_TEXT: 3,
  NODETYPE_CDATA: 4,
  NODETYPE_ENTITY_REFERENCE: 5,
  NODETYPE_ENTITY: 6,
  NODETYPE_PROCESSING_INSTRUCTION: 7,
  NODETYPE_COMMENT: 8,
  NODETYPE_DOCUMENT: 9,
  NODETYPE_DOCUMENTTYPE: 10,
  NODETYPE_DOCUMENT_FRAGMENT: 11,
  NODETYPE_NOTATION: 12,
  TOOLTIP_VERTICAL_OFFSET: 16,
  DEFAULT_VALID_COLOR: "#00FF00",
  DEFAULT_INVALID_COLOR: "#FF0000",
  OUTLINE_HIGHLIGHT_COLOR: "#00FF00",
  OUTLINE_HIGHLIGHT_STROKEWIDTH: 5,
  HIGHLIGHT_STROKEWIDTH: 3,
  HIGHLIGHT_SIZE: 2,
  HIGHLIGHT_OPACITY: 100,
  CURSOR_MOVABLE_VERTEX: "move",
  CURSOR_MOVABLE_EDGE: "move",
  CURSOR_LABEL_HANDLE: "default",
  CURSOR_TERMINAL_HANDLE: "pointer",
  CURSOR_BEND_HANDLE: "crosshair",
  CURSOR_VIRTUAL_BEND_HANDLE: "crosshair",
  CURSOR_CONNECT: "pointer",
  HIGHLIGHT_COLOR: "#00FF00",
  CONNECT_TARGET_COLOR: "#0000FF",
  INVALID_CONNECT_TARGET_COLOR: "#FF0000",
  DROP_TARGET_COLOR: "#0000FF",
  VALID_COLOR: "#00FF00",
  INVALID_COLOR: "#FF0000",
  EDGE_SELECTION_COLOR: "#00FF00",
  VERTEX_SELECTION_COLOR: "#00FF00",
  VERTEX_SELECTION_STROKEWIDTH: 1,
  EDGE_SELECTION_STROKEWIDTH: 1,
  VERTEX_SELECTION_DASHED: !0,
  EDGE_SELECTION_DASHED: !0,
  GUIDE_COLOR: "#FF0000",
  GUIDE_STROKEWIDTH: 1,
  OUTLINE_COLOR: "#0099FF",
  OUTLINE_STROKEWIDTH: mxClient.IS_IE ? 2 : 3,
  HANDLE_SIZE: 6,
  LABEL_HANDLE_SIZE: 4,
  HANDLE_FILLCOLOR: "#00FF00",
  HANDLE_STROKECOLOR: "black",
  LABEL_HANDLE_FILLCOLOR: "yellow",
  CONNECT_HANDLE_FILLCOLOR: "#0000FF",
  LOCKED_HANDLE_FILLCOLOR: "#FF0000",
  OUTLINE_HANDLE_FILLCOLOR: "#00FFFF",
  OUTLINE_HANDLE_STROKECOLOR: "#0033FF",
  DEFAULT_FONTFAMILY: "Arial,Helvetica",
  DEFAULT_FONTSIZE: 11,
  DEFAULT_TEXT_DIRECTION: "",
  LINE_HEIGHT: 1.2,
  WORD_WRAP: "normal",
  ABSOLUTE_LINE_HEIGHT: !1,
  DEFAULT_FONTSTYLE: 0,
  DEFAULT_STARTSIZE: 40,
  DEFAULT_MARKERSIZE: 6,
  DEFAULT_IMAGESIZE: 24,
  ENTITY_SEGMENT: 30,
  RECTANGLE_ROUNDING_FACTOR: .15,
  LINE_ARCSIZE: 20,
  ARROW_SPACING: 0,
  ARROW_WIDTH: 30,
  ARROW_SIZE: 30,
  PAGE_FORMAT_A4_PORTRAIT: new mxRectangle(0, 0, 827, 1169),
  PAGE_FORMAT_A4_LANDSCAPE: new mxRectangle(0, 0, 1169, 827),
  PAGE_FORMAT_LETTER_PORTRAIT: new mxRectangle(0, 0, 850, 1100),
  PAGE_FORMAT_LETTER_LANDSCAPE: new mxRectangle(0, 0, 1100, 850),
  NONE: "none",
  STYLE_PERIMETER: "perimeter",
  STYLE_SOURCE_PORT: "sourcePort",
  STYLE_TARGET_PORT: "targetPort",
  STYLE_PORT_CONSTRAINT: "portConstraint",
  STYLE_PORT_CONSTRAINT_ROTATION: "portConstraintRotation",
  STYLE_SOURCE_PORT_CONSTRAINT: "sourcePortConstraint",
  STYLE_TARGET_PORT_CONSTRAINT: "targetPortConstraint",
  STYLE_OPACITY: "opacity",
  STYLE_FILL_OPACITY: "fillOpacity",
  STYLE_STROKE_OPACITY: "strokeOpacity",
  STYLE_TEXT_OPACITY: "textOpacity",
  STYLE_TEXT_DIRECTION: "textDirection",
  STYLE_OVERFLOW: "overflow",
  STYLE_ORTHOGONAL: "orthogonal",
  STYLE_EXIT_X: "exitX",
  STYLE_EXIT_Y: "exitY",
  STYLE_EXIT_PERIMETER: "exitPerimeter",
  STYLE_ENTRY_X: "entryX",
  STYLE_ENTRY_Y: "entryY",
  STYLE_ENTRY_PERIMETER: "entryPerimeter",
  STYLE_WHITE_SPACE: "whiteSpace",
  STYLE_ROTATION: "rotation",
  STYLE_FILLCOLOR: "fillColor",
  STYLE_POINTER_EVENTS: "pointerEvents",
  STYLE_SWIMLANE_FILLCOLOR: "swimlaneFillColor",
  STYLE_MARGIN: "margin",
  STYLE_GRADIENTCOLOR: "gradientColor",
  STYLE_GRADIENT_DIRECTION: "gradientDirection",
  STYLE_STROKECOLOR: "strokeColor",
  STYLE_SEPARATORCOLOR: "separatorColor",
  STYLE_STROKEWIDTH: "strokeWidth",
  STYLE_ALIGN: "align",
  STYLE_VERTICAL_ALIGN: "verticalAlign",
  STYLE_LABEL_WIDTH: "labelWidth",
  STYLE_LABEL_POSITION: "labelPosition",
  STYLE_VERTICAL_LABEL_POSITION: "verticalLabelPosition",
  STYLE_IMAGE_ASPECT: "imageAspect",
  STYLE_IMAGE_ALIGN: "imageAlign",
  STYLE_IMAGE_VERTICAL_ALIGN: "imageVerticalAlign",
  STYLE_GLASS: "glass",
  STYLE_IMAGE: "image",
  STYLE_IMAGE_WIDTH: "imageWidth",
  STYLE_IMAGE_HEIGHT: "imageHeight",
  STYLE_IMAGE_BACKGROUND: "imageBackground",
  STYLE_IMAGE_BORDER: "imageBorder",
  STYLE_FLIPH: "flipH",
  STYLE_FLIPV: "flipV",
  STYLE_NOLABEL: "noLabel",
  STYLE_NOEDGESTYLE: "noEdgeStyle",
  STYLE_LABEL_BACKGROUNDCOLOR: "labelBackgroundColor",
  STYLE_LABEL_BORDERCOLOR: "labelBorderColor",
  STYLE_LABEL_PADDING: "labelPadding",
  STYLE_INDICATOR_SHAPE: "indicatorShape",
  STYLE_INDICATOR_IMAGE: "indicatorImage",
  STYLE_INDICATOR_COLOR: "indicatorColor",
  STYLE_INDICATOR_STROKECOLOR: "indicatorStrokeColor",
  STYLE_INDICATOR_GRADIENTCOLOR: "indicatorGradientColor",
  STYLE_INDICATOR_SPACING: "indicatorSpacing",
  STYLE_INDICATOR_WIDTH: "indicatorWidth",
  STYLE_INDICATOR_HEIGHT: "indicatorHeight",
  STYLE_INDICATOR_DIRECTION: "indicatorDirection",
  STYLE_SHADOW: "shadow",
  STYLE_SEGMENT: "segment",
  STYLE_ENDARROW: "endArrow",
  STYLE_STARTARROW: "startArrow",
  STYLE_ENDSIZE: "endSize",
  STYLE_STARTSIZE: "startSize",
  STYLE_SWIMLANE_LINE: "swimlaneLine",
  STYLE_ENDFILL: "endFill",
  STYLE_STARTFILL: "startFill",
  STYLE_DASHED: "dashed",
  STYLE_DASH_PATTERN: "dashPattern",
  STYLE_FIX_DASH: "fixDash",
  STYLE_ROUNDED: "rounded",
  STYLE_CURVED: "curved",
  STYLE_ARCSIZE: "arcSize",
  STYLE_ABSOLUTE_ARCSIZE: "absoluteArcSize",
  STYLE_SOURCE_PERIMETER_SPACING: "sourcePerimeterSpacing",
  STYLE_TARGET_PERIMETER_SPACING: "targetPerimeterSpacing",
  STYLE_PERIMETER_SPACING: "perimeterSpacing",
  STYLE_SPACING: "spacing",
  STYLE_SPACING_TOP: "spacingTop",
  STYLE_SPACING_LEFT: "spacingLeft",
  STYLE_SPACING_BOTTOM: "spacingBottom",
  STYLE_SPACING_RIGHT: "spacingRight",
  STYLE_HORIZONTAL: "horizontal",
  STYLE_DIRECTION: "direction",
  STYLE_ANCHOR_POINT_DIRECTION: "anchorPointDirection",
  STYLE_ELBOW: "elbow",
  STYLE_FONTCOLOR: "fontColor",
  STYLE_FONTFAMILY: "fontFamily",
  STYLE_FONTSIZE: "fontSize",
  STYLE_FONTSTYLE: "fontStyle",
  STYLE_ASPECT: "aspect",
  STYLE_AUTOSIZE: "autosize",
  STYLE_FOLDABLE: "foldable",
  STYLE_EDITABLE: "editable",
  STYLE_BACKGROUND_OUTLINE: "backgroundOutline",
  STYLE_BENDABLE: "bendable",
  STYLE_MOVABLE: "movable",
  STYLE_RESIZABLE: "resizable",
  STYLE_RESIZE_WIDTH: "resizeWidth",
  STYLE_RESIZE_HEIGHT: "resizeHeight",
  STYLE_ROTATABLE: "rotatable",
  STYLE_CLONEABLE: "cloneable",
  STYLE_DELETABLE: "deletable",
  STYLE_SHAPE: "shape",
  STYLE_EDGE: "edgeStyle",
  STYLE_JETTY_SIZE: "jettySize",
  STYLE_SOURCE_JETTY_SIZE: "sourceJettySize",
  STYLE_TARGET_JETTY_SIZE: "targetJettySize",
  STYLE_LOOP: "loopStyle",
  STYLE_ORTHOGONAL_LOOP: "orthogonalLoop",
  STYLE_ROUTING_CENTER_X: "routingCenterX",
  STYLE_ROUTING_CENTER_Y: "routingCenterY",
  FONT_BOLD: 1,
  FONT_ITALIC: 2,
  FONT_UNDERLINE: 4,
  SHAPE_RECTANGLE: "rectangle",
  SHAPE_ELLIPSE: "ellipse",
  SHAPE_DOUBLE_ELLIPSE: "doubleEllipse",
  SHAPE_RHOMBUS: "rhombus",
  SHAPE_LINE: "line",
  SHAPE_IMAGE: "image",
  SHAPE_ARROW: "arrow",
  SHAPE_ARROW_CONNECTOR: "arrowConnector",
  SHAPE_LABEL: "label",
  SHAPE_CYLINDER: "cylinder",
  SHAPE_SWIMLANE: "swimlane",
  SHAPE_CONNECTOR: "connector",
  SHAPE_ACTOR: "actor",
  SHAPE_CLOUD: "cloud",
  SHAPE_TRIANGLE: "triangle",
  SHAPE_HEXAGON: "hexagon",
  ARROW_CLASSIC: "classic",
  ARROW_CLASSIC_THIN: "classicThin",
  ARROW_BLOCK: "block",
  ARROW_BLOCK_THIN: "blockThin",
  ARROW_OPEN: "open",
  ARROW_OPEN_THIN: "openThin",
  ARROW_OVAL: "oval",
  ARROW_DIAMOND: "diamond",
  ARROW_DIAMOND_THIN: "diamondThin",
  ALIGN_LEFT: "left",
  ALIGN_CENTER: "center",
  ALIGN_RIGHT: "right",
  ALIGN_TOP: "top",
  ALIGN_MIDDLE: "middle",
  ALIGN_BOTTOM: "bottom",
  DIRECTION_NORTH: "north",
  DIRECTION_SOUTH: "south",
  DIRECTION_EAST: "east",
  DIRECTION_WEST: "west",
  TEXT_DIRECTION_DEFAULT: "",
  TEXT_DIRECTION_AUTO: "auto",
  TEXT_DIRECTION_LTR: "ltr",
  TEXT_DIRECTION_RTL: "rtl",
  DIRECTION_MASK_NONE: 0,
  DIRECTION_MASK_WEST: 1,
  DIRECTION_MASK_NORTH: 2,
  DIRECTION_MASK_SOUTH: 4,
  DIRECTION_MASK_EAST: 8,
  DIRECTION_MASK_ALL: 15,
  ELBOW_VERTICAL: "vertical",
  ELBOW_HORIZONTAL: "horizontal",
  EDGESTYLE_ELBOW: "elbowEdgeStyle",
  EDGESTYLE_ENTITY_RELATION: "entityRelationEdgeStyle",
  EDGESTYLE_LOOP: "loopEdgeStyle",
  EDGESTYLE_SIDETOSIDE: "sideToSideEdgeStyle",
  EDGESTYLE_TOPTOBOTTOM: "topToBottomEdgeStyle",
  EDGESTYLE_ORTHOGONAL: "orthogonalEdgeStyle",
  EDGESTYLE_SEGMENT: "segmentEdgeStyle",
  PERIMETER_ELLIPSE: "ellipsePerimeter",
  PERIMETER_RECTANGLE: "rectanglePerimeter",
  PERIMETER_RHOMBUS: "rhombusPerimeter",
  PERIMETER_HEXAGON: "hexagonPerimeter",
  PERIMETER_TRIANGLE: "trianglePerimeter"
};

function mxEventObject(t) {
  this.name = t, this.properties = [];

  for (var e = 1; e < arguments.length; e += 2) {
    null != arguments[e + 1] && (this.properties[arguments[e]] = arguments[e + 1]);
  }
}

function mxMouseEvent(t, e) {
  this.evt = t, this.sourceState = this.state = e;
}

function mxEventSource(t) {
  this.setEventSource(t);
}

mxEventObject.prototype.name = null, mxEventObject.prototype.properties = null, mxEventObject.prototype.consumed = !1, mxEventObject.prototype.getName = function () {
  return this.name;
}, mxEventObject.prototype.getProperties = function () {
  return this.properties;
}, mxEventObject.prototype.getProperty = function (t) {
  return this.properties[t];
}, mxEventObject.prototype.isConsumed = function () {
  return this.consumed;
}, mxEventObject.prototype.consume = function () {
  this.consumed = !0;
}, mxMouseEvent.prototype.consumed = !1, mxMouseEvent.prototype.evt = null, mxMouseEvent.prototype.graphX = null, mxMouseEvent.prototype.graphY = null, mxMouseEvent.prototype.state = null, mxMouseEvent.prototype.sourceState = null, mxMouseEvent.prototype.getEvent = function () {
  return this.evt;
}, mxMouseEvent.prototype.getSource = function () {
  return mxEvent.getSource(this.evt);
}, mxMouseEvent.prototype.isSource = function (t) {
  return null != t && mxUtils.isAncestorNode(t.node, this.getSource());
}, mxMouseEvent.prototype.getX = function () {
  return mxEvent.getClientX(this.getEvent());
}, mxMouseEvent.prototype.getY = function () {
  return mxEvent.getClientY(this.getEvent());
}, mxMouseEvent.prototype.getGraphX = function () {
  return this.graphX;
}, mxMouseEvent.prototype.getGraphY = function () {
  return this.graphY;
}, mxMouseEvent.prototype.getState = function () {
  return this.state;
}, mxMouseEvent.prototype.getCell = function () {
  var t = this.getState();
  return null != t ? t.cell : null;
}, mxMouseEvent.prototype.isPopupTrigger = function () {
  return mxEvent.isPopupTrigger(this.getEvent());
}, mxMouseEvent.prototype.isConsumed = function () {
  return this.consumed;
}, mxMouseEvent.prototype.consume = function (t) {
  (null == t || t) && this.evt.preventDefault && this.evt.preventDefault(), mxClient.IS_IE && (this.evt.returnValue = !0), this.consumed = !0;
}, mxEventSource.prototype.eventListeners = null, mxEventSource.prototype.eventsEnabled = !0, mxEventSource.prototype.eventSource = null, mxEventSource.prototype.isEventsEnabled = function () {
  return this.eventsEnabled;
}, mxEventSource.prototype.setEventsEnabled = function (t) {
  this.eventsEnabled = t;
}, mxEventSource.prototype.getEventSource = function () {
  return this.eventSource;
}, mxEventSource.prototype.setEventSource = function (t) {
  this.eventSource = t;
}, mxEventSource.prototype.addListener = function (t, e) {
  null == this.eventListeners && (this.eventListeners = []), this.eventListeners.push(t), this.eventListeners.push(e);
}, mxEventSource.prototype.removeListener = function (t) {
  if (null != this.eventListeners) for (var e = 0; e < this.eventListeners.length;) {
    this.eventListeners[e + 1] == t ? this.eventListeners.splice(e, 2) : e += 2;
  }
}, mxEventSource.prototype.fireEvent = function (t, e) {
  if (null != this.eventListeners && this.isEventsEnabled()) {
    null == t && (t = new mxEventObject()), null == e && (e = this.getEventSource()), null == e && (e = this);

    for (var i = [e, t], n = 0; n < this.eventListeners.length; n += 2) {
      var s = this.eventListeners[n];
      null != s && s != t.getName() || this.eventListeners[n + 1].apply(this, i);
    }
  }
};
var mxEvent = {
  addListener: window.addEventListener ? function (t, e, i) {
    t.addEventListener(e, i, !1), null == t.mxListenerList && (t.mxListenerList = []), t.mxListenerList.push({
      name: e,
      f: i
    });
  } : function (t, e, i) {
    t.attachEvent("on" + e, i), null == t.mxListenerList && (t.mxListenerList = []), t.mxListenerList.push({
      name: e,
      f: i
    });
  },
  removeListener: function () {
    var t = function t(_t2, e, i) {
      if (null != _t2.mxListenerList) {
        e = _t2.mxListenerList.length;

        for (var n = 0; n < e; n++) {
          if (_t2.mxListenerList[n].f == i) {
            _t2.mxListenerList.splice(n, 1);

            break;
          }
        }

        0 == _t2.mxListenerList.length && (_t2.mxListenerList = null);
      }
    };

    return window.removeEventListener ? function (e, i, n) {
      e.removeEventListener(i, n, !1), t(e, i, n);
    } : function (e, i, n) {
      e.detachEvent("on" + i, n), t(e, i, n);
    };
  }(),
  removeAllListeners: function removeAllListeners(t) {
    var e = t.mxListenerList;
    if (null != e) for (; 0 < e.length;) {
      var i = e[0];
      mxEvent.removeListener(t, i.name, i.f);
    }
  },
  addGestureListeners: function addGestureListeners(t, e, i, n) {
    null != e && mxEvent.addListener(t, mxClient.IS_POINTER ? "pointerdown" : "mousedown", e), null != i && mxEvent.addListener(t, mxClient.IS_POINTER ? "pointermove" : "mousemove", i), null != n && mxEvent.addListener(t, mxClient.IS_POINTER ? "pointerup" : "mouseup", n), !mxClient.IS_POINTER && mxClient.IS_TOUCH && (null != e && mxEvent.addListener(t, "touchstart", e), null != i && mxEvent.addListener(t, "touchmove", i), null != n && mxEvent.addListener(t, "touchend", n));
  },
  removeGestureListeners: function removeGestureListeners(t, e, i, n) {
    null != e && mxEvent.removeListener(t, mxClient.IS_POINTER ? "pointerdown" : "mousedown", e), null != i && mxEvent.removeListener(t, mxClient.IS_POINTER ? "pointermove" : "mousemove", i), null != n && mxEvent.removeListener(t, mxClient.IS_POINTER ? "pointerup" : "mouseup", n), !mxClient.IS_POINTER && mxClient.IS_TOUCH && (null != e && mxEvent.removeListener(t, "touchstart", e), null != i && mxEvent.removeListener(t, "touchmove", i), null != n && mxEvent.removeListener(t, "touchend", n));
  },
  redirectMouseEvents: function redirectMouseEvents(t, e, i, n, s, o, l) {
    var r = function r(t) {
      return "function" == typeof i ? i(t) : i;
    };

    mxEvent.addGestureListeners(t, function (t) {
      null != n ? n(t) : mxEvent.isConsumed(t) || e.fireMouseEvent(mxEvent.MOUSE_DOWN, new mxMouseEvent(t, r(t)));
    }, function (t) {
      null != s ? s(t) : mxEvent.isConsumed(t) || e.fireMouseEvent(mxEvent.MOUSE_MOVE, new mxMouseEvent(t, r(t)));
    }, function (t) {
      null != o ? o(t) : mxEvent.isConsumed(t) || e.fireMouseEvent(mxEvent.MOUSE_UP, new mxMouseEvent(t, r(t)));
    }), mxEvent.addListener(t, "dblclick", function (t) {
      if (null != l) l(t);else if (!mxEvent.isConsumed(t)) {
        var i = r(t);
        e.dblClick(t, null != i ? i.cell : null);
      }
    });
  },
  release: function release(t) {
    try {
      if (null != t) {
        mxEvent.removeAllListeners(t);
        var e = t.childNodes;

        if (null != e) {
          var i = e.length;

          for (t = 0; t < i; t += 1) {
            mxEvent.release(e[t]);
          }
        }
      }
    } catch (t) {}
  },
  addMouseWheelListener: function addMouseWheelListener(t) {
    if (null != t) {
      var e = function e(_e) {
        var i;
        null == _e && (_e = window.event), 0 != (i = mxClient.IS_FF ? -_e.detail / 2 : _e.wheelDelta / 120) && t(_e, 0 < i);
      };

      mxClient.IS_NS && null == document.documentMode ? mxEvent.addListener(window, mxClient.IS_SF || mxClient.IS_GC ? "mousewheel" : "DOMMouseScroll", e) : mxEvent.addListener(document, "mousewheel", e);
    }
  },
  disableContextMenu: function disableContextMenu(t) {
    mxEvent.addListener(t, "contextmenu", function (t) {
      return t.preventDefault && t.preventDefault(), !1;
    });
  },
  getSource: function getSource(t) {
    return null != t.srcElement ? t.srcElement : t.target;
  },
  isConsumed: function isConsumed(t) {
    return null != t.isConsumed && t.isConsumed;
  },
  isTouchEvent: function isTouchEvent(t) {
    return null != t.pointerType ? "touch" == t.pointerType || t.pointerType === t.MSPOINTER_TYPE_TOUCH : null != t.mozInputSource ? 5 == t.mozInputSource : 0 == t.type.indexOf("touch");
  },
  isPenEvent: function isPenEvent(t) {
    return null != t.pointerType ? "pen" == t.pointerType || t.pointerType === t.MSPOINTER_TYPE_PEN : null != t.mozInputSource ? 2 == t.mozInputSource : 0 == t.type.indexOf("pen");
  },
  isMultiTouchEvent: function isMultiTouchEvent(t) {
    return null != t.type && 0 == t.type.indexOf("touch") && null != t.touches && 1 < t.touches.length;
  },
  isMouseEvent: function isMouseEvent(t) {
    return null != t.pointerType ? "mouse" == t.pointerType || t.pointerType === t.MSPOINTER_TYPE_MOUSE : null != t.mozInputSource ? 1 == t.mozInputSource : 0 == t.type.indexOf("mouse");
  },
  isLeftMouseButton: function isLeftMouseButton(t) {
    return "buttons" in t && ("mousedown" == t.type || "mousemove" == t.type) ? 1 == t.buttons : "which" in t ? 1 === t.which : 1 === t.button;
  },
  isMiddleMouseButton: function isMiddleMouseButton(t) {
    return "which" in t ? 2 === t.which : 4 === t.button;
  },
  isRightMouseButton: function isRightMouseButton(t) {
    return "which" in t ? 3 === t.which : 2 === t.button;
  },
  isPopupTrigger: function isPopupTrigger(t) {
    return mxEvent.isRightMouseButton(t) || mxClient.IS_MAC && mxEvent.isControlDown(t) && !mxEvent.isShiftDown(t) && !mxEvent.isMetaDown(t) && !mxEvent.isAltDown(t);
  },
  isShiftDown: function isShiftDown(t) {
    return null != t && t.shiftKey;
  },
  isAltDown: function isAltDown(t) {
    return null != t && t.altKey;
  },
  isControlDown: function isControlDown(t) {
    return null != t && t.ctrlKey;
  },
  isMetaDown: function isMetaDown(t) {
    return null != t && t.metaKey;
  },
  getMainEvent: function getMainEvent(t) {
    return "touchstart" != t.type && "touchmove" != t.type || null == t.touches || null == t.touches[0] ? "touchend" == t.type && null != t.changedTouches && null != t.changedTouches[0] && (t = t.changedTouches[0]) : t = t.touches[0], t;
  },
  getClientX: function getClientX(t) {
    return mxEvent.getMainEvent(t).clientX;
  },
  getClientY: function getClientY(t) {
    return mxEvent.getMainEvent(t).clientY;
  },
  consume: function consume(t, e, i) {
    i = null == i || i, (null == e || e) && (t.preventDefault ? (i && t.stopPropagation(), t.preventDefault()) : i && (t.cancelBubble = !0)), t.isConsumed = !0, t.preventDefault || (t.returnValue = !1);
  },
  LABEL_HANDLE: -1,
  ROTATION_HANDLE: -2,
  CUSTOM_HANDLE: -100,
  VIRTUAL_HANDLE: -1e5,
  MOUSE_DOWN: "mouseDown",
  MOUSE_MOVE: "mouseMove",
  MOUSE_UP: "mouseUp",
  ACTIVATE: "activate",
  RESIZE_START: "resizeStart",
  RESIZE: "resize",
  RESIZE_END: "resizeEnd",
  MOVE_START: "moveStart",
  MOVE: "move",
  MOVE_END: "moveEnd",
  PAN_START: "panStart",
  PAN: "pan",
  PAN_END: "panEnd",
  MINIMIZE: "minimize",
  NORMALIZE: "normalize",
  MAXIMIZE: "maximize",
  HIDE: "hide",
  SHOW: "show",
  CLOSE: "close",
  DESTROY: "destroy",
  REFRESH: "refresh",
  SIZE: "size",
  SELECT: "select",
  FIRED: "fired",
  FIRE_MOUSE_EVENT: "fireMouseEvent",
  GESTURE: "gesture",
  TAP_AND_HOLD: "tapAndHold",
  GET: "get",
  RECEIVE: "receive",
  CONNECT: "connect",
  DISCONNECT: "disconnect",
  SUSPEND: "suspend",
  RESUME: "resume",
  MARK: "mark",
  ROOT: "root",
  POST: "post",
  OPEN: "open",
  SAVE: "save",
  BEFORE_ADD_VERTEX: "beforeAddVertex",
  ADD_VERTEX: "addVertex",
  AFTER_ADD_VERTEX: "afterAddVertex",
  DONE: "done",
  EXECUTE: "execute",
  EXECUTED: "executed",
  BEGIN_UPDATE: "beginUpdate",
  START_EDIT: "startEdit",
  END_UPDATE: "endUpdate",
  END_EDIT: "endEdit",
  BEFORE_UNDO: "beforeUndo",
  UNDO: "undo",
  REDO: "redo",
  CHANGE: "change",
  NOTIFY: "notify",
  LAYOUT_CELLS: "layoutCells",
  CLICK: "click",
  SCALE: "scale",
  TRANSLATE: "translate",
  SCALE_AND_TRANSLATE: "scaleAndTranslate",
  UP: "up",
  DOWN: "down",
  ADD: "add",
  REMOVE: "remove",
  CLEAR: "clear",
  ADD_CELLS: "addCells",
  CELLS_ADDED: "cellsAdded",
  MOVE_CELLS: "moveCells",
  CELLS_MOVED: "cellsMoved",
  RESIZE_CELLS: "resizeCells",
  CELLS_RESIZED: "cellsResized",
  TOGGLE_CELLS: "toggleCells",
  CELLS_TOGGLED: "cellsToggled",
  ORDER_CELLS: "orderCells",
  CELLS_ORDERED: "cellsOrdered",
  REMOVE_CELLS: "removeCells",
  CELLS_REMOVED: "cellsRemoved",
  GROUP_CELLS: "groupCells",
  UNGROUP_CELLS: "ungroupCells",
  REMOVE_CELLS_FROM_PARENT: "removeCellsFromParent",
  FOLD_CELLS: "foldCells",
  CELLS_FOLDED: "cellsFolded",
  ALIGN_CELLS: "alignCells",
  LABEL_CHANGED: "labelChanged",
  CONNECT_CELL: "connectCell",
  CELL_CONNECTED: "cellConnected",
  SPLIT_EDGE: "splitEdge",
  FLIP_EDGE: "flipEdge",
  START_EDITING: "startEditing",
  EDITING_STARTED: "editingStarted",
  EDITING_STOPPED: "editingStopped",
  ADD_OVERLAY: "addOverlay",
  REMOVE_OVERLAY: "removeOverlay",
  UPDATE_CELL_SIZE: "updateCellSize",
  ESCAPE: "escape",
  DOUBLE_CLICK: "doubleClick",
  START: "start",
  RESET: "reset"
};

function mxXmlRequest(t, e, i, n, s, o) {
  this.url = t, this.params = e, this.method = i || "POST", this.async = null == n || n, this.username = s, this.password = o;
}

mxXmlRequest.prototype.url = null, mxXmlRequest.prototype.params = null, mxXmlRequest.prototype.method = null, mxXmlRequest.prototype.async = null, mxXmlRequest.prototype.binary = !1, mxXmlRequest.prototype.withCredentials = !1, mxXmlRequest.prototype.username = null, mxXmlRequest.prototype.password = null, mxXmlRequest.prototype.request = null, mxXmlRequest.prototype.decodeSimulateValues = !1, mxXmlRequest.prototype.isBinary = function () {
  return this.binary;
}, mxXmlRequest.prototype.setBinary = function (t) {
  this.binary = t;
}, mxXmlRequest.prototype.getText = function () {
  return this.request.responseText;
}, mxXmlRequest.prototype.isReady = function () {
  return 4 == this.request.readyState;
}, mxXmlRequest.prototype.getDocumentElement = function () {
  var t = this.getXml();
  return null != t ? t.documentElement : null;
}, mxXmlRequest.prototype.getXml = function () {
  var t = this.request.responseXML;
  return (9 <= document.documentMode || null == t || null == t.documentElement) && (t = mxUtils.parseXml(this.request.responseText)), t;
}, mxXmlRequest.prototype.getText = function () {
  return this.request.responseText;
}, mxXmlRequest.prototype.getStatus = function () {
  return this.request.status;
}, mxXmlRequest.prototype.create = window.XMLHttpRequest ? function () {
  var t = new XMLHttpRequest();
  return this.isBinary() && t.overrideMimeType && t.overrideMimeType("text/plain; charset=x-user-defined"), t;
} : "undefined" != typeof ActiveXObject ? function () {
  return new ActiveXObject("Microsoft.XMLHTTP");
} : void 0, mxXmlRequest.prototype.send = function (t, e, i, n) {
  this.request = this.create(), null != this.request && (null != t && (this.request.onreadystatechange = mxUtils.bind(this, function () {
    this.isReady() && (t(this), this.request.onreadystatechaange = null);
  })), this.request.open(this.method, this.url, this.async, this.username, this.password), this.setRequestHeaders(this.request, this.params), window.XMLHttpRequest && this.withCredentials && (this.request.withCredentials = "true"), !mxClient.IS_QUIRKS && (null == document.documentMode || 9 < document.documentMode) && window.XMLHttpRequest && null != i && null != n && (this.request.timeout = i, this.request.ontimeout = n), this.request.send(this.params));
}, mxXmlRequest.prototype.setRequestHeaders = function (t, e) {
  null != e && t.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
}, mxXmlRequest.prototype.simulate = function (t, e) {
  var i = null;
  (t = t || document) == document && (i = window.onbeforeunload, window.onbeforeunload = null);
  var n = t.createElement("form");
  n.setAttribute("method", this.method), n.setAttribute("action", this.url), null != e && n.setAttribute("target", e), n.style.display = "none", n.style.visibility = "hidden";

  for (var s = 0 < this.params.indexOf("&") ? this.params.split("&") : this.params.split(), o = 0; o < s.length; o++) {
    if (0 < (r = s[o].indexOf("="))) {
      var l = s[o].substring(0, r),
          r = s[o].substring(r + 1);
      this.decodeSimulateValues && (r = decodeURIComponent(r));
      var a = t.createElement("textarea");
      a.setAttribute("wrap", "off"), a.setAttribute("name", l), mxUtils.write(a, r), n.appendChild(a);
    }
  }

  t.body.appendChild(n), n.submit(), null != n.parentNode && n.parentNode.removeChild(n), null != i && (window.onbeforeunload = i);
};
var mxClipboard = {
  STEPSIZE: 10,
  insertCount: 1,
  cells: null,
  setCells: function setCells(t) {
    mxClipboard.cells = t;
  },
  getCells: function getCells() {
    return mxClipboard.cells;
  },
  isEmpty: function isEmpty() {
    return null == mxClipboard.getCells();
  },
  cut: function cut(t, e) {
    return e = mxClipboard.copy(t, e), mxClipboard.insertCount = 0, mxClipboard.removeCells(t, e), e;
  },
  removeCells: function removeCells(t, e) {
    t.removeCells(e);
  },
  copy: function copy(t, e) {
    e = e || t.getSelectionCells();
    var i = t.getExportableCells(t.model.getTopmostCells(e));
    return mxClipboard.insertCount = 1, mxClipboard.setCells(t.cloneCells(i)), i;
  },
  paste: function paste(t) {
    var e = null;

    if (!mxClipboard.isEmpty()) {
      e = t.getImportableCells(mxClipboard.getCells());
      var i = mxClipboard.insertCount * mxClipboard.STEPSIZE,
          n = t.getDefaultParent();
      e = t.importCells(e, i, i, n);
      mxClipboard.insertCount++, t.setSelectionCells(e);
    }

    return e;
  }
};

function mxWindow(t, e, i, n, s, o, l, r, a, h) {
  null != e && (l = null == l || l, this.content = e, this.init(i, n, s, o, h), this.installMaximizeHandler(), this.installMinimizeHandler(), this.installCloseHandler(), this.setMinimizable(l), this.setTitle(t), (null == r || r) && this.installMoveHandler(), null != a && null != a.parentNode ? a.parentNode.replaceChild(this.div, a) : document.body.appendChild(this.div));
}

function mxForm(t) {
  this.table = document.createElement("table"), this.table.className = t, this.body = document.createElement("tbody"), this.table.appendChild(this.body);
}

function mxImage(t, e, i) {
  this.src = t, this.width = e, this.height = i;
}

function mxDivResizer(t, e) {
  if ("div" == t.nodeName.toLowerCase()) {
    null == e && (e = window), this.div = t;
    var i = mxUtils.getCurrentStyle(t);
    null != i && (this.resizeWidth = "auto" == i.width, this.resizeHeight = "auto" == i.height), mxEvent.addListener(e, "resize", mxUtils.bind(this, function (t) {
      this.handlingResize || (this.handlingResize = !0, this.resize(), this.handlingResize = !1);
    })), this.resize();
  }
}

function mxDragSource(t, e) {
  this.element = t, this.dropHandler = e, mxEvent.addGestureListeners(t, mxUtils.bind(this, function (t) {
    this.mouseDown(t);
  })), mxEvent.addListener(t, "dragstart", function (t) {
    mxEvent.consume(t);
  }), this.eventConsumer = function (t, e) {
    var i = e.getProperty("eventName"),
        n = e.getProperty("event");
    i != mxEvent.MOUSE_DOWN && n.consume();
  };
}

function mxToolbar(t) {
  this.container = t;
}

function mxUndoableEdit(t, e) {
  this.source = t, this.changes = [], this.significant = null == e || e;
}

function mxUndoManager(t) {
  this.size = null != t ? t : 100, this.clear();
}

mxWindow.prototype = new mxEventSource(), mxWindow.prototype.constructor = mxWindow, mxWindow.prototype.closeImage = mxClient.imageBasePath + "/close.gif", mxWindow.prototype.minimizeImage = mxClient.imageBasePath + "/minimize.gif", mxWindow.prototype.normalizeImage = mxClient.imageBasePath + "/normalize.gif", mxWindow.prototype.maximizeImage = mxClient.imageBasePath + "/maximize.gif", mxWindow.prototype.resizeImage = mxClient.imageBasePath + "/resize.gif", mxWindow.prototype.visible = !1, mxWindow.prototype.minimumSize = new mxRectangle(0, 0, 50, 40), mxWindow.prototype.destroyOnClose = !0, mxWindow.prototype.contentHeightCorrection = 8 == document.documentMode || 7 == document.documentMode ? 6 : 2, mxWindow.prototype.title = null, mxWindow.prototype.content = null, mxWindow.prototype.init = function (t, e, i, n, s) {
  s = null != s ? s : "mxWindow", this.div = document.createElement("div"), this.div.className = s, this.div.style.left = t + "px", this.div.style.top = e + "px", this.table = document.createElement("table"), this.table.className = s, mxClient.IS_POINTER && (this.div.style.touchAction = "none"), null != i && (mxClient.IS_QUIRKS || (this.div.style.width = i + "px"), this.table.style.width = i + "px"), null != n && (mxClient.IS_QUIRKS || (this.div.style.height = n + "px"), this.table.style.height = n + "px"), t = document.createElement("tbody"), e = document.createElement("tr"), this.title = document.createElement("td"), this.title.className = s + "Title", this.buttons = document.createElement("div"), this.buttons.style.position = "absolute", this.buttons.style.display = "inline-block", this.buttons.style.right = "4px", this.buttons.style.top = "5px", this.title.appendChild(this.buttons), e.appendChild(this.title), t.appendChild(e), e = document.createElement("tr"), this.td = document.createElement("td"), this.td.className = s + "Pane", 7 == document.documentMode && (this.td.style.height = "100%"), this.contentWrapper = document.createElement("div"), this.contentWrapper.className = s + "Pane", this.contentWrapper.style.width = "100%", this.contentWrapper.appendChild(this.content), (mxClient.IS_QUIRKS || "DIV" != this.content.nodeName.toUpperCase()) && (this.contentWrapper.style.height = "100%"), this.td.appendChild(this.contentWrapper), e.appendChild(this.td), t.appendChild(e), this.table.appendChild(t), this.div.appendChild(this.table), s = mxUtils.bind(this, function (t) {
    this.activate();
  }), mxEvent.addGestureListeners(this.title, s), mxEvent.addGestureListeners(this.table, s), this.hide();
}, mxWindow.prototype.setTitle = function (t) {
  for (var e = this.title.firstChild; null != e;) {
    var i = e.nextSibling;
    e.nodeType == mxConstants.NODETYPE_TEXT && e.parentNode.removeChild(e), e = i;
  }

  mxUtils.write(this.title, t || ""), this.title.appendChild(this.buttons);
}, mxWindow.prototype.setScrollable = function (t) {
  0 > navigator.userAgent.indexOf("Presto/2.5") && (this.contentWrapper.style.overflow = t ? "auto" : "hidden");
}, mxWindow.prototype.activate = function () {
  if (mxWindow.activeWindow != this) {
    var t = null != (t = mxUtils.getCurrentStyle(this.getElement())) ? t.zIndex : 3;

    if (mxWindow.activeWindow) {
      var e = mxWindow.activeWindow.getElement();
      null != e && null != e.style && (e.style.zIndex = t);
    }

    e = mxWindow.activeWindow, this.getElement().style.zIndex = parseInt(t) + 1, mxWindow.activeWindow = this, this.fireEvent(new mxEventObject(mxEvent.ACTIVATE, "previousWindow", e));
  }
}, mxWindow.prototype.getElement = function () {
  return this.div;
}, mxWindow.prototype.fit = function () {
  mxUtils.fit(this.div);
}, mxWindow.prototype.isResizable = function () {
  return null != this.resize && "none" != this.resize.style.display;
}, mxWindow.prototype.setResizable = function (t) {
  if (t) {
    if (null == this.resize) {
      this.resize = document.createElement("img"), this.resize.style.position = "absolute", this.resize.style.bottom = "2px", this.resize.style.right = "2px", this.resize.setAttribute("src", this.resizeImage), this.resize.style.cursor = "nw-resize";
      var e = null,
          i = null,
          n = null,
          s = null;
      t = mxUtils.bind(this, function (t) {
        this.activate(), e = mxEvent.getClientX(t), i = mxEvent.getClientY(t), n = this.div.offsetWidth, s = this.div.offsetHeight, mxEvent.addGestureListeners(document, null, o, l), this.fireEvent(new mxEventObject(mxEvent.RESIZE_START, "event", t)), mxEvent.consume(t);
      });
      var o = mxUtils.bind(this, function (t) {
        if (null != e && null != i) {
          var o = mxEvent.getClientX(t) - e,
              l = mxEvent.getClientY(t) - i;
          this.setSize(n + o, s + l), this.fireEvent(new mxEventObject(mxEvent.RESIZE, "event", t)), mxEvent.consume(t);
        }
      }),
          l = mxUtils.bind(this, function (t) {
        null != e && null != i && (i = e = null, mxEvent.removeGestureListeners(document, null, o, l), this.fireEvent(new mxEventObject(mxEvent.RESIZE_END, "event", t)), mxEvent.consume(t));
      });
      mxEvent.addGestureListeners(this.resize, t, o, l), this.div.appendChild(this.resize);
    } else this.resize.style.display = "inline";
  } else null != this.resize && (this.resize.style.display = "none");
}, mxWindow.prototype.setSize = function (t, e) {
  t = Math.max(this.minimumSize.width, t), e = Math.max(this.minimumSize.height, e), mxClient.IS_QUIRKS || (this.div.style.width = t + "px", this.div.style.height = e + "px"), this.table.style.width = t + "px", this.table.style.height = e + "px", mxClient.IS_QUIRKS || (this.contentWrapper.style.height = this.div.offsetHeight - this.title.offsetHeight - this.contentHeightCorrection + "px");
}, mxWindow.prototype.setMinimizable = function (t) {
  this.minimize.style.display = t ? "" : "none";
}, mxWindow.prototype.getMinimumSize = function () {
  return new mxRectangle(0, 0, 0, this.title.offsetHeight);
}, mxWindow.prototype.installMinimizeHandler = function () {
  this.minimize = document.createElement("img"), this.minimize.setAttribute("src", this.minimizeImage), this.minimize.setAttribute("title", "Minimize"), this.minimize.style.cursor = "pointer", this.minimize.style.marginLeft = "2px", this.minimize.style.display = "none", this.buttons.appendChild(this.minimize);
  var t = !1,
      e = null,
      i = null,
      n = mxUtils.bind(this, function (n) {
    if (this.activate(), t) t = !1, this.minimize.setAttribute("src", this.minimizeImage), this.minimize.setAttribute("title", "Minimize"), this.contentWrapper.style.display = "", this.maximize.style.display = e, mxClient.IS_QUIRKS || (this.div.style.height = i), this.table.style.height = i, null != this.resize && (this.resize.style.visibility = ""), this.fireEvent(new mxEventObject(mxEvent.NORMALIZE, "event", n));else {
      t = !0, this.minimize.setAttribute("src", this.normalizeImage), this.minimize.setAttribute("title", "Normalize"), this.contentWrapper.style.display = "none", e = this.maximize.style.display, this.maximize.style.display = "none", i = this.table.style.height;
      var s = this.getMinimumSize();
      0 < s.height && (mxClient.IS_QUIRKS || (this.div.style.height = s.height + "px"), this.table.style.height = s.height + "px"), 0 < s.width && (mxClient.IS_QUIRKS || (this.div.style.width = s.width + "px"), this.table.style.width = s.width + "px"), null != this.resize && (this.resize.style.visibility = "hidden"), this.fireEvent(new mxEventObject(mxEvent.MINIMIZE, "event", n));
    }
    mxEvent.consume(n);
  });
  mxEvent.addGestureListeners(this.minimize, n);
}, mxWindow.prototype.setMaximizable = function (t) {
  this.maximize.style.display = t ? "" : "none";
}, mxWindow.prototype.installMaximizeHandler = function () {
  this.maximize = document.createElement("img"), this.maximize.setAttribute("src", this.maximizeImage), this.maximize.setAttribute("title", "Maximize"), this.maximize.style.cursor = "default", this.maximize.style.marginLeft = "2px", this.maximize.style.cursor = "pointer", this.maximize.style.display = "none", this.buttons.appendChild(this.maximize);
  var t = !1,
      e = null,
      i = null,
      n = null,
      s = null,
      o = null,
      l = mxUtils.bind(this, function (l) {
    if (this.activate(), "none" != this.maximize.style.display) {
      if (t) t = !1, this.maximize.setAttribute("src", this.maximizeImage), this.maximize.setAttribute("title", "Maximize"), this.contentWrapper.style.display = "", this.minimize.style.display = o, this.div.style.left = e + "px", this.div.style.top = i + "px", mxClient.IS_QUIRKS || (this.div.style.height = n, this.div.style.width = s, "auto" != (r = mxUtils.getCurrentStyle(this.contentWrapper)).overflow && null == this.resize) || (this.contentWrapper.style.height = this.div.offsetHeight - this.title.offsetHeight - this.contentHeightCorrection + "px"), this.table.style.height = n, this.table.style.width = s, null != this.resize && (this.resize.style.visibility = ""), this.fireEvent(new mxEventObject(mxEvent.NORMALIZE, "event", l));else {
        if (t = !0, this.maximize.setAttribute("src", this.normalizeImage), this.maximize.setAttribute("title", "Normalize"), this.contentWrapper.style.display = "", o = this.minimize.style.display, this.minimize.style.display = "none", e = parseInt(this.div.style.left), i = parseInt(this.div.style.top), n = this.table.style.height, s = this.table.style.width, this.div.style.left = "0px", this.div.style.top = "0px", r = Math.max(document.body.clientHeight || 0, document.documentElement.clientHeight || 0), mxClient.IS_QUIRKS || (this.div.style.width = document.body.clientWidth - 2 + "px", this.div.style.height = r - 2 + "px"), this.table.style.width = document.body.clientWidth - 2 + "px", this.table.style.height = r - 2 + "px", null != this.resize && (this.resize.style.visibility = "hidden"), !mxClient.IS_QUIRKS) {
          var r = mxUtils.getCurrentStyle(this.contentWrapper);
          "auto" != r.overflow && null == this.resize || (this.contentWrapper.style.height = this.div.offsetHeight - this.title.offsetHeight - this.contentHeightCorrection + "px");
        }

        this.fireEvent(new mxEventObject(mxEvent.MAXIMIZE, "event", l));
      }
      mxEvent.consume(l);
    }
  });
  mxEvent.addGestureListeners(this.maximize, l), mxEvent.addListener(this.title, "dblclick", l);
}, mxWindow.prototype.installMoveHandler = function () {
  this.title.style.cursor = "move", mxEvent.addGestureListeners(this.title, mxUtils.bind(this, function (t) {
    var e = mxEvent.getClientX(t),
        i = mxEvent.getClientY(t),
        n = this.getX(),
        s = this.getY(),
        o = mxUtils.bind(this, function (t) {
      var o = mxEvent.getClientX(t) - e,
          l = mxEvent.getClientY(t) - i;
      this.setLocation(n + o, s + l), this.fireEvent(new mxEventObject(mxEvent.MOVE, "event", t)), mxEvent.consume(t);
    }),
        l = mxUtils.bind(this, function (t) {
      mxEvent.removeGestureListeners(document, null, o, l), this.fireEvent(new mxEventObject(mxEvent.MOVE_END, "event", t)), mxEvent.consume(t);
    });
    mxEvent.addGestureListeners(document, null, o, l), this.fireEvent(new mxEventObject(mxEvent.MOVE_START, "event", t)), mxEvent.consume(t);
  })), mxClient.IS_POINTER && (this.title.style.touchAction = "none");
}, mxWindow.prototype.setLocation = function (t, e) {
  this.div.style.left = t + "px", this.div.style.top = e + "px";
}, mxWindow.prototype.getX = function () {
  return parseInt(this.div.style.left);
}, mxWindow.prototype.getY = function () {
  return parseInt(this.div.style.top);
}, mxWindow.prototype.installCloseHandler = function () {
  this.closeImg = document.createElement("img"), this.closeImg.setAttribute("src", this.closeImage), this.closeImg.setAttribute("title", "Close"), this.closeImg.style.marginLeft = "2px", this.closeImg.style.cursor = "pointer", this.closeImg.style.display = "none", this.buttons.appendChild(this.closeImg), mxEvent.addGestureListeners(this.closeImg, mxUtils.bind(this, function (t) {
    this.fireEvent(new mxEventObject(mxEvent.CLOSE, "event", t)), this.destroyOnClose ? this.destroy() : this.setVisible(!1), mxEvent.consume(t);
  }));
}, mxWindow.prototype.setImage = function (t) {
  this.image = document.createElement("img"), this.image.setAttribute("src", t), this.image.setAttribute("align", "left"), this.image.style.marginRight = "4px", this.image.style.marginLeft = "0px", this.image.style.marginTop = "-2px", this.title.insertBefore(this.image, this.title.firstChild);
}, mxWindow.prototype.setClosable = function (t) {
  this.closeImg.style.display = t ? "" : "none";
}, mxWindow.prototype.isVisible = function () {
  return null != this.div && "none" != this.div.style.display;
}, mxWindow.prototype.setVisible = function (t) {
  null != this.div && this.isVisible() != t && (t ? this.show() : this.hide());
}, mxWindow.prototype.show = function () {
  this.div.style.display = "", this.activate();
  var t = mxUtils.getCurrentStyle(this.contentWrapper);
  mxClient.IS_QUIRKS || "auto" != t.overflow && null == this.resize || "none" == this.contentWrapper.style.display || (this.contentWrapper.style.height = this.div.offsetHeight - this.title.offsetHeight - this.contentHeightCorrection + "px"), this.fireEvent(new mxEventObject(mxEvent.SHOW));
}, mxWindow.prototype.hide = function () {
  this.div.style.display = "none", this.fireEvent(new mxEventObject(mxEvent.HIDE));
}, mxWindow.prototype.destroy = function () {
  this.fireEvent(new mxEventObject(mxEvent.DESTROY)), null != this.div && (mxEvent.release(this.div), this.div.parentNode.removeChild(this.div), this.div = null), this.contentWrapper = this.content = this.title = null;
}, mxForm.prototype.table = null, mxForm.prototype.body = !1, mxForm.prototype.getTable = function () {
  return this.table;
}, mxForm.prototype.addButtons = function (t, e) {
  var i = document.createElement("tr"),
      n = document.createElement("td");
  i.appendChild(n);
  n = document.createElement("td");
  var s = document.createElement("button");
  mxUtils.write(s, mxResources.get("ok") || "OK"), n.appendChild(s), mxEvent.addListener(s, "click", function () {
    t();
  }), s = document.createElement("button"), mxUtils.write(s, mxResources.get("cancel") || "Cancel"), n.appendChild(s), mxEvent.addListener(s, "click", function () {
    e();
  }), i.appendChild(n), this.body.appendChild(i);
}, mxForm.prototype.addText = function (t, e, i) {
  var n = document.createElement("input");
  return n.setAttribute("type", i || "text"), n.value = e, this.addField(t, n);
}, mxForm.prototype.addCheckbox = function (t, e) {
  var i = document.createElement("input");
  return i.setAttribute("type", "checkbox"), this.addField(t, i), e && (i.checked = !0), i;
}, mxForm.prototype.addTextarea = function (t, e, i) {
  var n = document.createElement("textarea");
  return mxClient.IS_NS && i--, n.setAttribute("rows", i || 2), n.value = e, this.addField(t, n);
}, mxForm.prototype.addCombo = function (t, e, i) {
  var n = document.createElement("select");
  return null != i && n.setAttribute("size", i), e && n.setAttribute("multiple", "true"), this.addField(t, n);
}, mxForm.prototype.addOption = function (t, e, i, n) {
  var s = document.createElement("option");
  mxUtils.writeln(s, e), s.setAttribute("value", i), n && s.setAttribute("selected", n), t.appendChild(s);
}, mxForm.prototype.addField = function (t, e) {
  var i = document.createElement("tr"),
      n = document.createElement("td");
  return mxUtils.write(n, t), i.appendChild(n), (n = document.createElement("td")).appendChild(e), i.appendChild(n), this.body.appendChild(i), e;
}, mxImage.prototype.src = null, mxImage.prototype.width = null, mxImage.prototype.height = null, mxDivResizer.prototype.resizeWidth = !0, mxDivResizer.prototype.resizeHeight = !0, mxDivResizer.prototype.handlingResize = !1, mxDivResizer.prototype.resize = function () {
  var t = this.getDocumentWidth(),
      e = this.getDocumentHeight(),
      i = parseInt(this.div.style.left),
      n = parseInt(this.div.style.right),
      s = parseInt(this.div.style.top),
      o = parseInt(this.div.style.bottom);
  this.resizeWidth && !isNaN(i) && !isNaN(n) && 0 <= i && 0 <= n && 0 < t - n - i && (this.div.style.width = t - n - i + "px"), this.resizeHeight && !isNaN(s) && !isNaN(o) && 0 <= s && 0 <= o && 0 < e - s - o && (this.div.style.height = e - s - o + "px");
}, mxDivResizer.prototype.getDocumentWidth = function () {
  return document.body.clientWidth;
}, mxDivResizer.prototype.getDocumentHeight = function () {
  return document.body.clientHeight;
}, mxDragSource.prototype.element = null, mxDragSource.prototype.dropHandler = null, mxDragSource.prototype.dragOffset = null, mxDragSource.prototype.dragElement = null, mxDragSource.prototype.previewElement = null, mxDragSource.prototype.enabled = !0, mxDragSource.prototype.currentGraph = null, mxDragSource.prototype.currentDropTarget = null, mxDragSource.prototype.currentPoint = null, mxDragSource.prototype.currentGuide = null, mxDragSource.prototype.currentHighlight = null, mxDragSource.prototype.autoscroll = !0, mxDragSource.prototype.guidesEnabled = !0, mxDragSource.prototype.gridEnabled = !0, mxDragSource.prototype.highlightDropTargets = !0, mxDragSource.prototype.dragElementZIndex = 100, mxDragSource.prototype.dragElementOpacity = 70, mxDragSource.prototype.checkEventSource = !0, mxDragSource.prototype.isEnabled = function () {
  return this.enabled;
}, mxDragSource.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxDragSource.prototype.isGuidesEnabled = function () {
  return this.guidesEnabled;
}, mxDragSource.prototype.setGuidesEnabled = function (t) {
  this.guidesEnabled = t;
}, mxDragSource.prototype.isGridEnabled = function () {
  return this.gridEnabled;
}, mxDragSource.prototype.setGridEnabled = function (t) {
  this.gridEnabled = t;
}, mxDragSource.prototype.getGraphForEvent = function (t) {
  return null;
}, mxDragSource.prototype.getDropTarget = function (t, e, i, n) {
  return t.getCellAt(e, i);
}, mxDragSource.prototype.createDragElement = function (t) {
  return this.element.cloneNode(!0);
}, mxDragSource.prototype.createPreviewElement = function (t) {
  return null;
}, mxDragSource.prototype.isActive = function () {
  return null != this.mouseMoveHandler;
}, mxDragSource.prototype.reset = function () {
  null != this.currentGraph && (this.dragExit(this.currentGraph), this.currentGraph = null), this.removeDragElement(), this.removeListeners(), this.stopDrag();
}, mxDragSource.prototype.mouseDown = function (t) {
  this.enabled && !mxEvent.isConsumed(t) && null == this.mouseMoveHandler && (this.startDrag(t), this.mouseMoveHandler = mxUtils.bind(this, this.mouseMove), this.mouseUpHandler = mxUtils.bind(this, this.mouseUp), mxEvent.addGestureListeners(document, null, this.mouseMoveHandler, this.mouseUpHandler), mxClient.IS_TOUCH && !mxEvent.isMouseEvent(t) && (this.eventSource = mxEvent.getSource(t), mxEvent.addGestureListeners(this.eventSource, null, this.mouseMoveHandler, this.mouseUpHandler)));
}, mxDragSource.prototype.startDrag = function (t) {
  this.dragElement = this.createDragElement(t), this.dragElement.style.position = "absolute", this.dragElement.style.zIndex = this.dragElementZIndex, mxUtils.setOpacity(this.dragElement, this.dragElementOpacity), this.checkEventSource && mxClient.IS_SVG && (this.dragElement.style.pointerEvents = "none");
}, mxDragSource.prototype.stopDrag = function () {
  this.removeDragElement();
}, mxDragSource.prototype.removeDragElement = function () {
  null != this.dragElement && (null != this.dragElement.parentNode && this.dragElement.parentNode.removeChild(this.dragElement), this.dragElement = null);
}, mxDragSource.prototype.getElementForEvent = function (t) {
  return mxEvent.isTouchEvent(t) || mxEvent.isPenEvent(t) ? document.elementFromPoint(mxEvent.getClientX(t), mxEvent.getClientY(t)) : mxEvent.getSource(t);
}, mxDragSource.prototype.graphContainsEvent = function (t, e) {
  var i = mxEvent.getClientX(e),
      n = mxEvent.getClientY(e),
      s = mxUtils.getOffset(t.container),
      o = mxUtils.getScrollOrigin(),
      l = this.getElementForEvent(e);
  if (this.checkEventSource) for (; null != l && l != t.container;) {
    l = l.parentNode;
  }
  return null != l && i >= s.x - o.x && n >= s.y - o.y && i <= s.x - o.x + t.container.offsetWidth && n <= s.y - o.y + t.container.offsetHeight;
}, mxDragSource.prototype.mouseMove = function (t) {
  if (null == (e = this.getGraphForEvent(t)) || this.graphContainsEvent(e, t) || (e = null), e != this.currentGraph && (null != this.currentGraph && this.dragExit(this.currentGraph, t), this.currentGraph = e, null != this.currentGraph && this.dragEnter(this.currentGraph, t)), null != this.currentGraph && this.dragOver(this.currentGraph, t), null == this.dragElement || null != this.previewElement && "visible" == this.previewElement.style.visibility) null != this.dragElement && (this.dragElement.style.visibility = "hidden");else {
    var e = mxEvent.getClientX(t),
        i = mxEvent.getClientY(t);
    null == this.dragElement.parentNode && document.body.appendChild(this.dragElement), this.dragElement.style.visibility = "visible", null != this.dragOffset && (e += this.dragOffset.x, i += this.dragOffset.y);
    var n = mxUtils.getDocumentScrollOrigin(document);
    this.dragElement.style.left = e + n.x + "px", this.dragElement.style.top = i + n.y + "px";
  }
  mxEvent.consume(t);
}, mxDragSource.prototype.mouseUp = function (t) {
  if (null != this.currentGraph) {
    if (null != this.currentPoint && (null == this.previewElement || "hidden" != this.previewElement.style.visibility)) {
      var e = this.currentGraph.view.scale,
          i = this.currentGraph.view.translate;
      this.drop(this.currentGraph, t, this.currentDropTarget, this.currentPoint.x / e - i.x, this.currentPoint.y / e - i.y);
    }

    this.dragExit(this.currentGraph), this.currentGraph = null;
  }

  this.stopDrag(), this.removeListeners(), mxEvent.consume(t);
}, mxDragSource.prototype.removeListeners = function () {
  null != this.eventSource && (mxEvent.removeGestureListeners(this.eventSource, null, this.mouseMoveHandler, this.mouseUpHandler), this.eventSource = null), mxEvent.removeGestureListeners(document, null, this.mouseMoveHandler, this.mouseUpHandler), this.mouseUpHandler = this.mouseMoveHandler = null;
}, mxDragSource.prototype.dragEnter = function (t, e) {
  t.isMouseDown = !0, t.isMouseTrigger = mxEvent.isMouseEvent(e), this.previewElement = this.createPreviewElement(t), null != this.previewElement && this.checkEventSource && mxClient.IS_SVG && (this.previewElement.style.pointerEvents = "none"), this.isGuidesEnabled() && null != this.previewElement && (this.currentGuide = new mxGuide(t, t.graphHandler.getGuideStates())), this.highlightDropTargets && (this.currentHighlight = new mxCellHighlight(t, mxConstants.DROP_TARGET_COLOR)), t.addListener(mxEvent.FIRE_MOUSE_EVENT, this.eventConsumer);
}, mxDragSource.prototype.dragExit = function (t, e) {
  this.currentPoint = this.currentDropTarget = null, t.isMouseDown = !1, t.removeListener(this.eventConsumer), null != this.previewElement && (null != this.previewElement.parentNode && this.previewElement.parentNode.removeChild(this.previewElement), this.previewElement = null), null != this.currentGuide && (this.currentGuide.destroy(), this.currentGuide = null), null != this.currentHighlight && (this.currentHighlight.destroy(), this.currentHighlight = null);
}, mxDragSource.prototype.dragOver = function (t, e) {
  var i = mxUtils.getOffset(t.container),
      n = mxUtils.getScrollOrigin(t.container),
      s = mxEvent.getClientX(e) - i.x + n.x - t.panDx;
  i = mxEvent.getClientY(e) - i.y + n.y - t.panDy;

  if (t.autoScroll && (null == this.autoscroll || this.autoscroll) && t.scrollPointToVisible(s, i, t.autoExtend), null != this.currentHighlight && t.isDropEnabled() && (this.currentDropTarget = this.getDropTarget(t, s, i, e), n = t.getView().getState(this.currentDropTarget), this.currentHighlight.highlight(n)), null != this.previewElement) {
    null == this.previewElement.parentNode && (t.container.appendChild(this.previewElement), this.previewElement.style.zIndex = "3", this.previewElement.style.position = "absolute");
    n = this.isGridEnabled() && t.isGridEnabledEvent(e);
    var o = !0;
    if (null != this.currentGuide && this.currentGuide.isEnabledForEvent(e)) o = new mxRectangle(0, 0, o = parseInt(this.previewElement.style.width), l = parseInt(this.previewElement.style.height)), i = new mxPoint(s, i), i = this.currentGuide.move(o, i, n, !0), o = !1, s = i.x, i = i.y;else if (n) {
      n = t.view.scale;
      var l = t.view.translate,
          r = t.gridSize / 2;
      s = (t.snap(s / n - l.x - r) + l.x) * n, i = (t.snap(i / n - l.y - r) + l.y) * n;
    }
    null != this.currentGuide && o && this.currentGuide.hide(), null != this.previewOffset && (s += this.previewOffset.x, i += this.previewOffset.y), this.previewElement.style.left = Math.round(s) + "px", this.previewElement.style.top = Math.round(i) + "px", this.previewElement.style.visibility = "visible";
  }

  this.currentPoint = new mxPoint(s, i);
}, mxDragSource.prototype.drop = function (t, e, i, n, s) {
  this.dropHandler.apply(this, arguments), "hidden" != t.container.style.visibility && t.container.focus();
}, mxToolbar.prototype = new mxEventSource(), mxToolbar.prototype.constructor = mxToolbar, mxToolbar.prototype.container = null, mxToolbar.prototype.enabled = !0, mxToolbar.prototype.noReset = !1, mxToolbar.prototype.updateDefaultMode = !0, mxToolbar.prototype.addItem = function (t, e, i, n, s, o) {
  var l = document.createElement(null != e ? "img" : "button"),
      r = s || (null != o ? "mxToolbarMode" : "mxToolbarItem");
  return l.className = r, l.setAttribute("src", e), null != t && (null != e ? l.setAttribute("title", t) : mxUtils.write(l, t)), this.container.appendChild(l), null != i && (mxEvent.addListener(l, "click", i), mxClient.IS_TOUCH && mxEvent.addListener(l, "touchend", i)), t = mxUtils.bind(this, function (t) {
    null != n ? l.setAttribute("src", e) : l.style.backgroundColor = "";
  }), mxEvent.addGestureListeners(l, mxUtils.bind(this, function (t) {
    if (null != n ? l.setAttribute("src", n) : l.style.backgroundColor = "gray", null != o) {
      null == this.menu && (this.menu = new mxPopupMenu(), this.menu.init());
      var e = this.currentImg;
      this.menu.isMenuShowing() && this.menu.hideMenu(), e != l && (this.currentImg = l, this.menu.factoryMethod = o, e = new mxPoint(l.offsetLeft, l.offsetTop + l.offsetHeight), this.menu.popup(e.x, e.y, null, t), this.menu.isMenuShowing() && (l.className = r + "Selected", this.menu.hideMenu = function () {
        mxPopupMenu.prototype.hideMenu.apply(this), l.className = r, this.currentImg = null;
      }));
    }
  }), null, t), mxEvent.addListener(l, "mouseout", t), l;
}, mxToolbar.prototype.addCombo = function (t) {
  var e = document.createElement("div");
  e.style.display = "inline", e.className = "mxToolbarComboContainer";
  var i = document.createElement("select");
  return i.className = t || "mxToolbarCombo", e.appendChild(i), this.container.appendChild(e), i;
}, mxToolbar.prototype.addActionCombo = function (t, e) {
  var i = document.createElement("select");
  return i.className = e || "mxToolbarCombo", this.addOption(i, t, null), mxEvent.addListener(i, "change", function (t) {
    var e = i.options[i.selectedIndex];
    i.selectedIndex = 0, null != e.funct && e.funct(t);
  }), this.container.appendChild(i), i;
}, mxToolbar.prototype.addOption = function (t, e, i) {
  var n = document.createElement("option");
  return mxUtils.writeln(n, e), "function" == typeof i ? n.funct = i : n.setAttribute("value", i), t.appendChild(n), n;
}, mxToolbar.prototype.addSwitchMode = function (t, e, i, n, s) {
  var o = document.createElement("img");
  return o.initialClassName = s || "mxToolbarMode", o.className = o.initialClassName, o.setAttribute("src", e), o.altIcon = n, null != t && o.setAttribute("title", t), mxEvent.addListener(o, "click", mxUtils.bind(this, function (t) {
    null != (t = this.selectedMode.altIcon) ? (this.selectedMode.altIcon = this.selectedMode.getAttribute("src"), this.selectedMode.setAttribute("src", t)) : this.selectedMode.className = this.selectedMode.initialClassName, this.updateDefaultMode && (this.defaultMode = o), this.selectedMode = o, null != (t = o.altIcon) ? (o.altIcon = o.getAttribute("src"), o.setAttribute("src", t)) : o.className = o.initialClassName + "Selected", this.fireEvent(new mxEventObject(mxEvent.SELECT)), i();
  })), this.container.appendChild(o), null == this.defaultMode && (this.defaultMode = o, this.selectMode(o), i()), o;
}, mxToolbar.prototype.addMode = function (t, e, i, n, s, o) {
  o = null == o || o;
  var l = document.createElement(null != e ? "img" : "button");
  return l.initialClassName = s || "mxToolbarMode", l.className = l.initialClassName, l.setAttribute("src", e), l.altIcon = n, null != t && l.setAttribute("title", t), this.enabled && o && (mxEvent.addListener(l, "click", mxUtils.bind(this, function (t) {
    this.selectMode(l, i), this.noReset = !1;
  })), mxEvent.addListener(l, "dblclick", mxUtils.bind(this, function (t) {
    this.selectMode(l, i), this.noReset = !0;
  })), null == this.defaultMode && (this.defaultMode = l, this.defaultFunction = i, this.selectMode(l, i))), this.container.appendChild(l), l;
}, mxToolbar.prototype.selectMode = function (t, e) {
  if (this.selectedMode != t) {
    if (null != this.selectedMode) {
      var i = this.selectedMode.altIcon;
      null != i ? (this.selectedMode.altIcon = this.selectedMode.getAttribute("src"), this.selectedMode.setAttribute("src", i)) : this.selectedMode.className = this.selectedMode.initialClassName;
    }

    this.selectedMode = t, null != (i = this.selectedMode.altIcon) ? (this.selectedMode.altIcon = this.selectedMode.getAttribute("src"), this.selectedMode.setAttribute("src", i)) : this.selectedMode.className = this.selectedMode.initialClassName + "Selected", this.fireEvent(new mxEventObject(mxEvent.SELECT, "function", e));
  }
}, mxToolbar.prototype.resetMode = function (t) {
  !t && this.noReset || this.selectedMode == this.defaultMode || this.selectMode(this.defaultMode, this.defaultFunction);
}, mxToolbar.prototype.addSeparator = function (t) {
  return this.addItem(null, t, null);
}, mxToolbar.prototype.addBreak = function () {
  mxUtils.br(this.container);
}, mxToolbar.prototype.addLine = function () {
  var t = document.createElement("hr");
  t.style.marginRight = "6px", t.setAttribute("size", "1"), this.container.appendChild(t);
}, mxToolbar.prototype.destroy = function () {
  mxEvent.release(this.container), this.selectedMode = this.defaultFunction = this.defaultMode = this.container = null, null != this.menu && this.menu.destroy();
}, mxUndoableEdit.prototype.source = null, mxUndoableEdit.prototype.changes = null, mxUndoableEdit.prototype.significant = null, mxUndoableEdit.prototype.undone = !1, mxUndoableEdit.prototype.redone = !1, mxUndoableEdit.prototype.isEmpty = function () {
  return 0 == this.changes.length;
}, mxUndoableEdit.prototype.isSignificant = function () {
  return this.significant;
}, mxUndoableEdit.prototype.add = function (t) {
  this.changes.push(t);
}, mxUndoableEdit.prototype.notify = function () {}, mxUndoableEdit.prototype.die = function () {}, mxUndoableEdit.prototype.undo = function () {
  if (!this.undone) {
    this.source.fireEvent(new mxEventObject(mxEvent.START_EDIT));

    for (var t = this.changes.length - 1; 0 <= t; t--) {
      var e = this.changes[t];
      null != e.execute ? e.execute() : null != e.undo && e.undo(), this.source.fireEvent(new mxEventObject(mxEvent.EXECUTED, "change", e));
    }

    this.undone = !0, this.redone = !1, this.source.fireEvent(new mxEventObject(mxEvent.END_EDIT));
  }

  this.notify();
}, mxUndoableEdit.prototype.redo = function () {
  if (!this.redone) {
    this.source.fireEvent(new mxEventObject(mxEvent.START_EDIT));

    for (var t = this.changes.length, e = 0; e < t; e++) {
      var i = this.changes[e];
      null != i.execute ? i.execute() : null != i.redo && i.redo(), this.source.fireEvent(new mxEventObject(mxEvent.EXECUTED, "change", i));
    }

    this.undone = !1, this.redone = !0, this.source.fireEvent(new mxEventObject(mxEvent.END_EDIT));
  }

  this.notify();
}, mxUndoManager.prototype = new mxEventSource(), mxUndoManager.prototype.constructor = mxUndoManager, mxUndoManager.prototype.size = null, mxUndoManager.prototype.history = null, mxUndoManager.prototype.indexOfNextAdd = 0, mxUndoManager.prototype.isEmpty = function () {
  return 0 == this.history.length;
}, mxUndoManager.prototype.clear = function () {
  this.history = [], this.indexOfNextAdd = 0, this.fireEvent(new mxEventObject(mxEvent.CLEAR));
}, mxUndoManager.prototype.canUndo = function () {
  return 0 < this.indexOfNextAdd;
}, mxUndoManager.prototype.undo = function () {
  for (; 0 < this.indexOfNextAdd;) {
    var t = this.history[--this.indexOfNextAdd];

    if (t.undo(), t.isSignificant()) {
      this.fireEvent(new mxEventObject(mxEvent.UNDO, "edit", t));
      break;
    }
  }
}, mxUndoManager.prototype.canRedo = function () {
  return this.indexOfNextAdd < this.history.length;
}, mxUndoManager.prototype.redo = function () {
  for (var t = this.history.length; this.indexOfNextAdd < t;) {
    var e = this.history[this.indexOfNextAdd++];

    if (e.redo(), e.isSignificant()) {
      this.fireEvent(new mxEventObject(mxEvent.REDO, "edit", e));
      break;
    }
  }
}, mxUndoManager.prototype.undoableEditHappened = function (t) {
  this.trim(), 0 < this.size && this.size == this.history.length && this.history.shift(), this.history.push(t), this.indexOfNextAdd = this.history.length, this.fireEvent(new mxEventObject(mxEvent.ADD, "edit", t));
}, mxUndoManager.prototype.trim = function () {
  if (this.history.length > this.indexOfNextAdd) for (var t = this.history.splice(this.indexOfNextAdd, this.history.length - this.indexOfNextAdd), e = 0; e < t.length; e++) {
    t[e].die();
  }
};

var mxUrlConverter = function mxUrlConverter() {};

function mxPanningManager(t) {
  this.thread = null, this.active = !1, this.dy = this.dx = this.t0y = this.t0x = this.tdy = this.tdx = 0, this.scrollbars = !1, this.scrollTop = this.scrollLeft = 0, this.mouseListener = {
    mouseDown: function mouseDown(t, e) {},
    mouseMove: function mouseMove(t, e) {},
    mouseUp: mxUtils.bind(this, function (t, e) {
      this.active && this.stop();
    })
  }, t.addMouseListener(this.mouseListener), this.mouseUpListener = mxUtils.bind(this, function () {
    this.active && this.stop();
  }), mxEvent.addListener(document, "mouseup", this.mouseUpListener);
  var e = mxUtils.bind(this, function () {
    return this.scrollbars = mxUtils.hasScrollbars(t.container), this.scrollLeft = t.container.scrollLeft, this.scrollTop = t.container.scrollTop, window.setInterval(mxUtils.bind(this, function () {
      this.tdx -= this.dx, this.tdy -= this.dy, this.scrollbars ? (t.panGraph(-t.container.scrollLeft - Math.ceil(this.dx), -t.container.scrollTop - Math.ceil(this.dy)), t.panDx = this.scrollLeft - t.container.scrollLeft, t.panDy = this.scrollTop - t.container.scrollTop, t.fireEvent(new mxEventObject(mxEvent.PAN))) : t.panGraph(this.getDx(), this.getDy());
    }), this.delay);
  });
  this.isActive = function () {
    return active;
  }, this.getDx = function () {
    return Math.round(this.tdx);
  }, this.getDy = function () {
    return Math.round(this.tdy);
  }, this.start = function () {
    this.t0x = t.view.translate.x, this.t0y = t.view.translate.y, this.active = !0;
  }, this.panTo = function (i, n, s, o) {
    this.active || this.start(), this.scrollLeft = t.container.scrollLeft, this.scrollTop = t.container.scrollTop;
    var l = t.container;
    this.dx = i + (null != s ? s : 0) - l.scrollLeft - l.clientWidth, this.dx = 0 > this.dx && Math.abs(this.dx) < this.border ? this.border + this.dx : this.handleMouseOut ? Math.max(this.dx, 0) : 0, 0 == this.dx && (this.dx = i - l.scrollLeft, this.dx = 0 < this.dx && this.dx < this.border ? this.dx - this.border : this.handleMouseOut ? Math.min(0, this.dx) : 0), this.dy = n + (null != o ? o : 0) - l.scrollTop - l.clientHeight, this.dy = 0 > this.dy && Math.abs(this.dy) < this.border ? this.border + this.dy : this.handleMouseOut ? Math.max(this.dy, 0) : 0, 0 == this.dy && (this.dy = n - l.scrollTop, this.dy = 0 < this.dy && this.dy < this.border ? this.dy - this.border : this.handleMouseOut ? Math.min(0, this.dy) : 0), 0 != this.dx || 0 != this.dy ? (this.dx *= this.damper, this.dy *= this.damper, null == this.thread && (this.thread = e())) : null != this.thread && (window.clearInterval(this.thread), this.thread = null);
  }, this.stop = function () {
    if (this.active) if (this.active = !1, null != this.thread && (window.clearInterval(this.thread), this.thread = null), this.tdy = this.tdx = 0, this.scrollbars) t.panDx = 0, t.panDy = 0, t.fireEvent(new mxEventObject(mxEvent.PAN));else {
      var e = t.panDx,
          i = t.panDy;
      0 == e && 0 == i || (t.panGraph(0, 0), t.view.setTranslate(this.t0x + e / t.view.scale, this.t0y + i / t.view.scale));
    }
  }, this.destroy = function () {
    t.removeMouseListener(this.mouseListener), mxEvent.removeListener(document, "mouseup", this.mouseUpListener);
  };
}

function mxPopupMenu(t) {
  this.factoryMethod = t, null != t && this.init();
}

function mxAutoSaveManager(t) {
  this.changeHandler = mxUtils.bind(this, function (t, e) {
    this.isEnabled() && this.graphModelChanged(e.getProperty("edit").changes);
  }), this.setGraph(t);
}

function mxAnimation(t) {
  this.delay = null != t ? t : 20;
}

function mxMorphing(t, e, i, n) {
  mxAnimation.call(this, n), this.graph = t, this.steps = null != e ? e : 6, this.ease = null != i ? i : 1.5;
}

function mxImageBundle(t) {
  this.images = [], this.alt = null != t && t;
}

function mxImageExport() {}

function mxAbstractCanvas2D() {
  this.converter = this.createUrlConverter(), this.reset();
}

function mxXmlCanvas2D(t) {
  mxAbstractCanvas2D.call(this), this.root = t, this.writeDefaults();
}

function mxSvgCanvas2D(t, e) {
  mxAbstractCanvas2D.call(this), this.root = t, this.gradients = [], this.defs = null, this.styleEnabled = null != e && e;
  var i = null;
  if (t.ownerDocument != document) for (i = t; null != i && "svg" != i.nodeName;) {
    i = i.parentNode;
  }
  null != i && (0 < i.getElementsByTagName("defs").length && (this.defs = i.getElementsByTagName("defs")[0]), null == this.defs && (this.defs = this.createElement("defs"), null != i.firstChild ? i.insertBefore(this.defs, i.firstChild) : i.appendChild(this.defs)), this.styleEnabled && this.defs.appendChild(this.createStyle()));
}

mxUrlConverter.prototype.enabled = !0, mxUrlConverter.prototype.baseUrl = null, mxUrlConverter.prototype.baseDomain = null, mxUrlConverter.prototype.updateBaseUrl = function () {
  this.baseDomain = location.protocol + "//" + location.host, this.baseUrl = this.baseDomain + location.pathname;
  var t = this.baseUrl.lastIndexOf("/");
  0 < t && (this.baseUrl = this.baseUrl.substring(0, t + 1));
}, mxUrlConverter.prototype.isEnabled = function () {
  return this.enabled;
}, mxUrlConverter.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxUrlConverter.prototype.getBaseUrl = function () {
  return this.baseUrl;
}, mxUrlConverter.prototype.setBaseUrl = function (t) {
  this.baseUrl = t;
}, mxUrlConverter.prototype.getBaseDomain = function () {
  return this.baseDomain;
}, mxUrlConverter.prototype.setBaseDomain = function (t) {
  this.baseDomain = t;
}, mxUrlConverter.prototype.isRelativeUrl = function (t) {
  return "//" != t.substring(0, 2) && "http://" != t.substring(0, 7) && "https://" != t.substring(0, 8) && "data:image" != t.substring(0, 10) && "file://" != t.substring(0, 7);
}, mxUrlConverter.prototype.convert = function (t) {
  return this.isEnabled() && this.isRelativeUrl(t) && (null == this.getBaseUrl() && this.updateBaseUrl(), t = "/" == t.charAt(0) ? this.getBaseDomain() + t : this.getBaseUrl() + t), t;
}, mxPanningManager.prototype.damper = 1 / 6, mxPanningManager.prototype.delay = 10, mxPanningManager.prototype.handleMouseOut = !0, mxPanningManager.prototype.border = 0, mxPopupMenu.prototype = new mxEventSource(), mxPopupMenu.prototype.constructor = mxPopupMenu, mxPopupMenu.prototype.submenuImage = mxClient.imageBasePath + "/submenu.gif", mxPopupMenu.prototype.zIndex = 10006, mxPopupMenu.prototype.factoryMethod = null, mxPopupMenu.prototype.useLeftButtonForPopup = !1, mxPopupMenu.prototype.enabled = !0, mxPopupMenu.prototype.itemCount = 0, mxPopupMenu.prototype.autoExpand = !1, mxPopupMenu.prototype.smartSeparators = !1, mxPopupMenu.prototype.labels = !0, mxPopupMenu.prototype.init = function () {
  this.table = document.createElement("table"), this.table.className = "mxPopupMenu", this.tbody = document.createElement("tbody"), this.table.appendChild(this.tbody), this.div = document.createElement("div"), this.div.className = "mxPopupMenu", this.div.style.display = "inline", this.div.style.zIndex = this.zIndex, this.div.appendChild(this.table), mxEvent.disableContextMenu(this.div);
}, mxPopupMenu.prototype.isEnabled = function () {
  return this.enabled;
}, mxPopupMenu.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxPopupMenu.prototype.isPopupTrigger = function (t) {
  return t.isPopupTrigger() || this.useLeftButtonForPopup && mxEvent.isLeftMouseButton(t.getEvent());
}, mxPopupMenu.prototype.addItem = function (t, e, i, n, s, o, l) {
  n = n || this, this.itemCount++, n.willAddSeparator && (n.containsItems && this.addSeparator(n, !0), n.willAddSeparator = !1), n.containsItems = !0;
  var r = document.createElement("tr");
  r.className = "mxPopupMenuItem";
  var a = document.createElement("td");

  if (a.className = "mxPopupMenuIcon", null != e ? ((s = document.createElement("img")).src = e, a.appendChild(s)) : null != s && ((e = document.createElement("div")).className = s, a.appendChild(e)), r.appendChild(a), this.labels && ((a = document.createElement("td")).className = "mxPopupMenuItem" + (null == o || o ? "" : " mxDisabled"), mxUtils.write(a, t), a.align = "left", r.appendChild(a), (t = document.createElement("td")).className = "mxPopupMenuItem" + (null == o || o ? "" : " mxDisabled"), t.style.paddingRight = "6px", t.style.textAlign = "right", r.appendChild(t), null == n.div && this.createSubmenu(n)), n.tbody.appendChild(r), 0 != l && 0 != o) {
    var h = null;
    mxEvent.addGestureListeners(r, mxUtils.bind(this, function (t) {
      this.eventReceiver = r, n.activeRow != r && n.activeRow != n && (null != n.activeRow && null != n.activeRow.div.parentNode && this.hideSubmenu(n), null != r.div && (this.showSubmenu(n, r), n.activeRow = r)), (mxClient.IS_QUIRKS || 8 == document.documentMode) && (h = document.selection.createRange()), mxEvent.consume(t);
    }), mxUtils.bind(this, function (t) {
      n.activeRow != r && n.activeRow != n && (null != n.activeRow && null != n.activeRow.div.parentNode && this.hideSubmenu(n), this.autoExpand && null != r.div && (this.showSubmenu(n, r), n.activeRow = r)), r.className = "mxPopupMenuItemHover";
    }), mxUtils.bind(this, function (t) {
      if (this.eventReceiver == r) {
        if (n.activeRow != r && this.hideMenu(), null != h) {
          try {
            h.select();
          } catch (t) {}

          h = null;
        }

        null != i && i(t);
      }

      this.eventReceiver = null, mxEvent.consume(t);
    })), mxEvent.addListener(r, "mouseout", mxUtils.bind(this, function (t) {
      r.className = "mxPopupMenuItem";
    }));
  }

  return r;
}, mxPopupMenu.prototype.addCheckmark = function (t, e) {
  var i = t.firstChild.nextSibling;
  i.style.backgroundImage = "url('" + e + "')", i.style.backgroundRepeat = "no-repeat", i.style.backgroundPosition = "2px 50%";
}, mxPopupMenu.prototype.createSubmenu = function (t) {
  t.table = document.createElement("table"), t.table.className = "mxPopupMenu", t.tbody = document.createElement("tbody"), t.table.appendChild(t.tbody), t.div = document.createElement("div"), t.div.className = "mxPopupMenu", t.div.style.position = "absolute", t.div.style.display = "inline", t.div.style.zIndex = this.zIndex, t.div.appendChild(t.table);
  var e = document.createElement("img");
  e.setAttribute("src", this.submenuImage), td = t.firstChild.nextSibling.nextSibling, td.appendChild(e);
}, mxPopupMenu.prototype.showSubmenu = function (t, e) {
  if (null != e.div) {
    e.div.style.left = t.div.offsetLeft + e.offsetLeft + e.offsetWidth - 1 + "px", e.div.style.top = t.div.offsetTop + e.offsetTop + "px", document.body.appendChild(e.div);
    var i = parseInt(e.div.offsetLeft),
        n = parseInt(e.div.offsetWidth),
        s = mxUtils.getDocumentScrollOrigin(document),
        o = document.documentElement;
    i + n > s.x + (document.body.clientWidth || o.clientWidth) && (e.div.style.left = Math.max(0, t.div.offsetLeft - n + (mxClient.IS_IE ? 6 : -6)) + "px"), mxUtils.fit(e.div);
  }
}, mxPopupMenu.prototype.addSeparator = function (t, e) {
  if (t = t || this, this.smartSeparators && !e) t.willAddSeparator = !0;else if (null != t.tbody) {
    t.willAddSeparator = !1;
    var i = document.createElement("tr"),
        n = document.createElement("td");
    n.className = "mxPopupMenuIcon", n.style.padding = "0 0 0 0px", i.appendChild(n), (n = document.createElement("td")).style.padding = "0 0 0 0px", n.setAttribute("colSpan", "2");
    var s = document.createElement("hr");
    s.setAttribute("size", "1"), n.appendChild(s), i.appendChild(n), t.tbody.appendChild(i);
  }
}, mxPopupMenu.prototype.popup = function (t, e, i, n) {
  if (null != this.div && null != this.tbody && null != this.factoryMethod) {
    for (this.div.style.left = t + "px", this.div.style.top = e + "px"; null != this.tbody.firstChild;) {
      mxEvent.release(this.tbody.firstChild), this.tbody.removeChild(this.tbody.firstChild);
    }

    this.itemCount = 0, this.factoryMethod(this, i, n), 0 < this.itemCount && (this.showMenu(), this.fireEvent(new mxEventObject(mxEvent.SHOW)));
  }
}, mxPopupMenu.prototype.isMenuShowing = function () {
  return null != this.div && this.div.parentNode == document.body;
}, mxPopupMenu.prototype.showMenu = function () {
  9 <= document.documentMode && (this.div.style.filter = "none"), document.body.appendChild(this.div), mxUtils.fit(this.div);
}, mxPopupMenu.prototype.hideMenu = function () {
  null != this.div && (null != this.div.parentNode && this.div.parentNode.removeChild(this.div), this.hideSubmenu(this), this.containsItems = !1, this.fireEvent(new mxEventObject(mxEvent.HIDE)));
}, mxPopupMenu.prototype.hideSubmenu = function (t) {
  null != t.activeRow && (this.hideSubmenu(t.activeRow), null != t.activeRow.div.parentNode && t.activeRow.div.parentNode.removeChild(t.activeRow.div), t.activeRow = null);
}, mxPopupMenu.prototype.destroy = function () {
  null != this.div && (mxEvent.release(this.div), null != this.div.parentNode && this.div.parentNode.removeChild(this.div), this.div = null);
}, mxAutoSaveManager.prototype = new mxEventSource(), mxAutoSaveManager.prototype.constructor = mxAutoSaveManager, mxAutoSaveManager.prototype.graph = null, mxAutoSaveManager.prototype.autoSaveDelay = 10, mxAutoSaveManager.prototype.autoSaveThrottle = 2, mxAutoSaveManager.prototype.autoSaveThreshold = 5, mxAutoSaveManager.prototype.ignoredChanges = 0, mxAutoSaveManager.prototype.lastSnapshot = 0, mxAutoSaveManager.prototype.enabled = !0, mxAutoSaveManager.prototype.changeHandler = null, mxAutoSaveManager.prototype.isEnabled = function () {
  return this.enabled;
}, mxAutoSaveManager.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxAutoSaveManager.prototype.setGraph = function (t) {
  null != this.graph && this.graph.getModel().removeListener(this.changeHandler), this.graph = t, null != this.graph && this.graph.getModel().addListener(mxEvent.CHANGE, this.changeHandler);
}, mxAutoSaveManager.prototype.save = function () {}, mxAutoSaveManager.prototype.graphModelChanged = function (t) {
  (t = (new Date().getTime() - this.lastSnapshot) / 1e3) > this.autoSaveDelay || this.ignoredChanges >= this.autoSaveThreshold && t > this.autoSaveThrottle ? (this.save(), this.reset()) : this.ignoredChanges++;
}, mxAutoSaveManager.prototype.reset = function () {
  this.lastSnapshot = new Date().getTime(), this.ignoredChanges = 0;
}, mxAutoSaveManager.prototype.destroy = function () {
  this.setGraph(null);
}, mxAnimation.prototype = new mxEventSource(), mxAnimation.prototype.constructor = mxAnimation, mxAnimation.prototype.delay = null, mxAnimation.prototype.thread = null, mxAnimation.prototype.isRunning = function () {
  return null != this.thread;
}, mxAnimation.prototype.startAnimation = function () {
  null == this.thread && (this.thread = window.setInterval(mxUtils.bind(this, this.updateAnimation), this.delay));
}, mxAnimation.prototype.updateAnimation = function () {
  this.fireEvent(new mxEventObject(mxEvent.EXECUTE));
}, mxAnimation.prototype.stopAnimation = function () {
  null != this.thread && (window.clearInterval(this.thread), this.thread = null, this.fireEvent(new mxEventObject(mxEvent.DONE)));
}, mxMorphing.prototype = new mxAnimation(), mxMorphing.prototype.constructor = mxMorphing, mxMorphing.prototype.graph = null, mxMorphing.prototype.steps = null, mxMorphing.prototype.step = 0, mxMorphing.prototype.ease = null, mxMorphing.prototype.cells = null, mxMorphing.prototype.updateAnimation = function () {
  mxAnimation.prototype.updateAnimation.apply(this, arguments);
  var t = new mxCellStatePreview(this.graph);
  if (null != this.cells) for (var e = 0; e < this.cells.length; e++) {
    this.animateCell(this.cells[e], t, !1);
  } else this.animateCell(this.graph.getModel().getRoot(), t, !0);
  this.show(t), (t.isEmpty() || this.step++ >= this.steps) && this.stopAnimation();
}, mxMorphing.prototype.show = function (t) {
  t.show();
}, mxMorphing.prototype.animateCell = function (t, e, i) {
  var n = this.graph.getView().getState(t),
      s = null;

  if (null != n && (s = this.getDelta(n), this.graph.getModel().isVertex(t) && (0 != s.x || 0 != s.y))) {
    var o = this.graph.view.getTranslate(),
        l = this.graph.view.getScale();
    s.x += o.x * l, s.y += o.y * l, e.moveState(n, -s.x / this.ease, -s.y / this.ease);
  }

  if (i && !this.stopRecursion(n, s)) for (n = this.graph.getModel().getChildCount(t), s = 0; s < n; s++) {
    this.animateCell(this.graph.getModel().getChildAt(t, s), e, i);
  }
}, mxMorphing.prototype.stopRecursion = function (t, e) {
  return null != e && (0 != e.x || 0 != e.y);
}, mxMorphing.prototype.getDelta = function (t) {
  var e = this.getOriginForCell(t.cell),
      i = this.graph.getView().getTranslate(),
      n = this.graph.getView().getScale();
  return new mxPoint((e.x - (t.x / n - i.x)) * n, (e.y - (t.y / n - i.y)) * n);
}, mxMorphing.prototype.getOriginForCell = function (t) {
  var e = null;

  if (null != t) {
    var i = this.graph.getModel().getParent(t);
    t = this.graph.getCellGeometry(t), e = this.getOriginForCell(i), null != t && (t.relative ? null != (i = this.graph.getCellGeometry(i)) && (e.x += t.x * i.width, e.y += t.y * i.height) : (e.x += t.x, e.y += t.y));
  }

  return null == e && (e = new mxPoint(-(e = this.graph.view.getTranslate()).x, -e.y)), e;
}, mxImageBundle.prototype.images = null, mxImageBundle.prototype.images = null, mxImageBundle.prototype.putImage = function (t, e, i) {
  this.images[t] = {
    value: e,
    fallback: i
  };
}, mxImageBundle.prototype.getImage = function (t) {
  var e = null;
  return null != t && null != (t = this.images[t]) && (e = this.alt ? t.fallback : t.value), e;
}, mxImageExport.prototype.includeOverlays = !1, mxImageExport.prototype.drawState = function (t, e) {
  null != t && (this.visitStatesRecursive(t, e, mxUtils.bind(this, function () {
    this.drawCellState.apply(this, arguments);
  })), this.includeOverlays && this.visitStatesRecursive(t, e, mxUtils.bind(this, function () {
    this.drawOverlays.apply(this, arguments);
  })));
}, mxImageExport.prototype.visitStatesRecursive = function (t, e, i) {
  if (null != t) {
    i(t, e);

    for (var n = t.view.graph, s = n.model.getChildCount(t.cell), o = 0; o < s; o++) {
      var l = n.view.getState(n.model.getChildAt(t.cell, o));
      this.visitStatesRecursive(l, e, i);
    }
  }
}, mxImageExport.prototype.getLinkForCellState = function (t, e) {
  return null;
}, mxImageExport.prototype.drawCellState = function (t, e) {
  var i = this.getLinkForCellState(t, e);
  null != i && e.setLink(i), this.drawShape(t, e), this.drawText(t, e), null != i && e.setLink(null);
}, mxImageExport.prototype.drawShape = function (t, e) {
  t.shape instanceof mxShape && t.shape.checkBounds() && (e.save(), t.shape.paint(e), e.restore());
}, mxImageExport.prototype.drawText = function (t, e) {
  null != t.text && t.text.checkBounds() && (e.save(), t.text.paint(e), e.restore());
}, mxImageExport.prototype.drawOverlays = function (t, e) {
  null != t.overlays && t.overlays.visit(function (t, i) {
    i instanceof mxShape && i.paint(e);
  });
}, mxAbstractCanvas2D.prototype.state = null, mxAbstractCanvas2D.prototype.states = null, mxAbstractCanvas2D.prototype.path = null, mxAbstractCanvas2D.prototype.rotateHtml = !0, mxAbstractCanvas2D.prototype.lastX = 0, mxAbstractCanvas2D.prototype.lastY = 0, mxAbstractCanvas2D.prototype.moveOp = "M", mxAbstractCanvas2D.prototype.lineOp = "L", mxAbstractCanvas2D.prototype.quadOp = "Q", mxAbstractCanvas2D.prototype.curveOp = "C", mxAbstractCanvas2D.prototype.closeOp = "Z", mxAbstractCanvas2D.prototype.pointerEvents = !1, mxAbstractCanvas2D.prototype.createUrlConverter = function () {
  return new mxUrlConverter();
}, mxAbstractCanvas2D.prototype.reset = function () {
  this.state = this.createState(), this.states = [];
}, mxAbstractCanvas2D.prototype.createState = function () {
  return {
    dx: 0,
    dy: 0,
    scale: 1,
    alpha: 1,
    fillAlpha: 1,
    strokeAlpha: 1,
    fillColor: null,
    gradientFillAlpha: 1,
    gradientColor: null,
    gradientAlpha: 1,
    gradientDirection: null,
    strokeColor: null,
    strokeWidth: 1,
    dashed: !1,
    dashPattern: "3 3",
    fixDash: !1,
    lineCap: "flat",
    lineJoin: "miter",
    miterLimit: 10,
    fontColor: "#000000",
    fontBackgroundColor: null,
    fontBorderColor: null,
    fontSize: mxConstants.DEFAULT_FONTSIZE,
    fontFamily: mxConstants.DEFAULT_FONTFAMILY,
    fontStyle: 0,
    shadow: !1,
    shadowColor: mxConstants.SHADOWCOLOR,
    shadowAlpha: mxConstants.SHADOW_OPACITY,
    shadowDx: mxConstants.SHADOW_OFFSET_X,
    shadowDy: mxConstants.SHADOW_OFFSET_Y,
    rotation: 0,
    rotationCx: 0,
    rotationCy: 0
  };
}, mxAbstractCanvas2D.prototype.format = function (t) {
  return Math.round(parseFloat(t));
}, mxAbstractCanvas2D.prototype.addOp = function () {
  if (null != this.path && (this.path.push(arguments[0]), 2 < arguments.length)) for (var t = this.state, e = 2; e < arguments.length; e += 2) {
    this.lastX = arguments[e - 1], this.lastY = arguments[e], this.path.push(this.format((this.lastX + t.dx) * t.scale)), this.path.push(this.format((this.lastY + t.dy) * t.scale));
  }
}, mxAbstractCanvas2D.prototype.rotatePoint = function (t, e, i, n, s) {
  return i *= Math.PI / 180, mxUtils.getRotatedPoint(new mxPoint(t, e), Math.cos(i), Math.sin(i), new mxPoint(n, s));
}, mxAbstractCanvas2D.prototype.save = function () {
  this.states.push(this.state), this.state = mxUtils.clone(this.state);
}, mxAbstractCanvas2D.prototype.restore = function () {
  0 < this.states.length && (this.state = this.states.pop());
}, mxAbstractCanvas2D.prototype.setLink = function (t) {}, mxAbstractCanvas2D.prototype.scale = function (t) {
  this.state.scale *= t, this.state.strokeWidth *= t;
}, mxAbstractCanvas2D.prototype.translate = function (t, e) {
  this.state.dx += t, this.state.dy += e;
}, mxAbstractCanvas2D.prototype.rotate = function (t, e, i, n, s) {}, mxAbstractCanvas2D.prototype.setAlpha = function (t) {
  this.state.alpha = t;
}, mxAbstractCanvas2D.prototype.setFillAlpha = function (t) {
  this.state.fillAlpha = t;
}, mxAbstractCanvas2D.prototype.setStrokeAlpha = function (t) {
  this.state.strokeAlpha = t;
}, mxAbstractCanvas2D.prototype.setFillColor = function (t) {
  t == mxConstants.NONE && (t = null), this.state.fillColor = t, this.state.gradientColor = null;
}, mxAbstractCanvas2D.prototype.setGradient = function (t, e, i, n, s, o, l, r, a) {
  (i = this.state).fillColor = t, i.gradientFillAlpha = null != r ? r : 1, i.gradientColor = e, i.gradientAlpha = null != a ? a : 1, i.gradientDirection = l;
}, mxAbstractCanvas2D.prototype.setStrokeColor = function (t) {
  t == mxConstants.NONE && (t = null), this.state.strokeColor = t;
}, mxAbstractCanvas2D.prototype.setStrokeWidth = function (t) {
  this.state.strokeWidth = t;
}, mxAbstractCanvas2D.prototype.setDashed = function (t, e) {
  this.state.dashed = t, this.state.fixDash = e;
}, mxAbstractCanvas2D.prototype.setDashPattern = function (t) {
  this.state.dashPattern = t;
}, mxAbstractCanvas2D.prototype.setLineCap = function (t) {
  this.state.lineCap = t;
}, mxAbstractCanvas2D.prototype.setLineJoin = function (t) {
  this.state.lineJoin = t;
}, mxAbstractCanvas2D.prototype.setMiterLimit = function (t) {
  this.state.miterLimit = t;
}, mxAbstractCanvas2D.prototype.setFontColor = function (t) {
  t == mxConstants.NONE && (t = null), this.state.fontColor = t;
}, mxAbstractCanvas2D.prototype.setFontBackgroundColor = function (t) {
  t == mxConstants.NONE && (t = null), this.state.fontBackgroundColor = t;
}, mxAbstractCanvas2D.prototype.setFontBorderColor = function (t) {
  t == mxConstants.NONE && (t = null), this.state.fontBorderColor = t;
}, mxAbstractCanvas2D.prototype.setFontSize = function (t) {
  this.state.fontSize = parseFloat(t);
}, mxAbstractCanvas2D.prototype.setFontFamily = function (t) {
  this.state.fontFamily = t;
}, mxAbstractCanvas2D.prototype.setFontStyle = function (t) {
  null == t && (t = 0), this.state.fontStyle = t;
}, mxAbstractCanvas2D.prototype.setShadow = function (t) {
  this.state.shadow = t;
}, mxAbstractCanvas2D.prototype.setShadowColor = function (t) {
  t == mxConstants.NONE && (t = null), this.state.shadowColor = t;
}, mxAbstractCanvas2D.prototype.setShadowAlpha = function (t) {
  this.state.shadowAlpha = t;
}, mxAbstractCanvas2D.prototype.setShadowOffset = function (t, e) {
  this.state.shadowDx = t, this.state.shadowDy = e;
}, mxAbstractCanvas2D.prototype.begin = function () {
  this.lastY = this.lastX = 0, this.path = [];
}, mxAbstractCanvas2D.prototype.moveTo = function (t, e) {
  this.addOp(this.moveOp, t, e);
}, mxAbstractCanvas2D.prototype.lineTo = function (t, e) {
  this.addOp(this.lineOp, t, e);
}, mxAbstractCanvas2D.prototype.quadTo = function (t, e, i, n) {
  this.addOp(this.quadOp, t, e, i, n);
}, mxAbstractCanvas2D.prototype.curveTo = function (t, e, i, n, s, o) {
  this.addOp(this.curveOp, t, e, i, n, s, o);
}, mxAbstractCanvas2D.prototype.arcTo = function (t, e, i, n, s, o, l) {
  if (null != (t = mxUtils.arcToCurves(this.lastX, this.lastY, t, e, i, n, s, o, l))) for (e = 0; e < t.length; e += 6) {
    this.curveTo(t[e], t[e + 1], t[e + 2], t[e + 3], t[e + 4], t[e + 5]);
  }
}, mxAbstractCanvas2D.prototype.close = function (t, e, i, n, s, o) {
  this.addOp(this.closeOp);
}, mxAbstractCanvas2D.prototype.end = function () {}, mxUtils.extend(mxXmlCanvas2D, mxAbstractCanvas2D), mxXmlCanvas2D.prototype.textEnabled = !0, mxXmlCanvas2D.prototype.compressed = !0, mxXmlCanvas2D.prototype.writeDefaults = function () {
  var t;
  (t = this.createElement("fontfamily")).setAttribute("family", mxConstants.DEFAULT_FONTFAMILY), this.root.appendChild(t), (t = this.createElement("fontsize")).setAttribute("size", mxConstants.DEFAULT_FONTSIZE), this.root.appendChild(t), (t = this.createElement("shadowcolor")).setAttribute("color", mxConstants.SHADOWCOLOR), this.root.appendChild(t), (t = this.createElement("shadowalpha")).setAttribute("alpha", mxConstants.SHADOW_OPACITY), this.root.appendChild(t), (t = this.createElement("shadowoffset")).setAttribute("dx", mxConstants.SHADOW_OFFSET_X), t.setAttribute("dy", mxConstants.SHADOW_OFFSET_Y), this.root.appendChild(t);
}, mxXmlCanvas2D.prototype.format = function (t) {
  return parseFloat(parseFloat(t).toFixed(2));
}, mxXmlCanvas2D.prototype.createElement = function (t) {
  return this.root.ownerDocument.createElement(t);
}, mxXmlCanvas2D.prototype.save = function () {
  this.compressed && mxAbstractCanvas2D.prototype.save.apply(this, arguments), this.root.appendChild(this.createElement("save"));
}, mxXmlCanvas2D.prototype.restore = function () {
  this.compressed && mxAbstractCanvas2D.prototype.restore.apply(this, arguments), this.root.appendChild(this.createElement("restore"));
}, mxXmlCanvas2D.prototype.scale = function (t) {
  var e = this.createElement("scale");
  e.setAttribute("scale", t), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.translate = function (t, e) {
  var i = this.createElement("translate");
  i.setAttribute("dx", this.format(t)), i.setAttribute("dy", this.format(e)), this.root.appendChild(i);
}, mxXmlCanvas2D.prototype.rotate = function (t, e, i, n, s) {
  var o = this.createElement("rotate");
  (0 != t || e || i) && (o.setAttribute("theta", this.format(t)), o.setAttribute("flipH", e ? "1" : "0"), o.setAttribute("flipV", i ? "1" : "0"), o.setAttribute("cx", this.format(n)), o.setAttribute("cy", this.format(s)), this.root.appendChild(o));
}, mxXmlCanvas2D.prototype.setAlpha = function (t) {
  if (this.compressed) {
    if (this.state.alpha == t) return;
    mxAbstractCanvas2D.prototype.setAlpha.apply(this, arguments);
  }

  var e = this.createElement("alpha");
  e.setAttribute("alpha", this.format(t)), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.setFillAlpha = function (t) {
  if (this.compressed) {
    if (this.state.fillAlpha == t) return;
    mxAbstractCanvas2D.prototype.setFillAlpha.apply(this, arguments);
  }

  var e = this.createElement("fillalpha");
  e.setAttribute("alpha", this.format(t)), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.setStrokeAlpha = function (t) {
  if (this.compressed) {
    if (this.state.strokeAlpha == t) return;
    mxAbstractCanvas2D.prototype.setStrokeAlpha.apply(this, arguments);
  }

  var e = this.createElement("strokealpha");
  e.setAttribute("alpha", this.format(t)), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.setFillColor = function (t) {
  if (t == mxConstants.NONE && (t = null), this.compressed) {
    if (this.state.fillColor == t) return;
    mxAbstractCanvas2D.prototype.setFillColor.apply(this, arguments);
  }

  var e = this.createElement("fillcolor");
  e.setAttribute("color", null != t ? t : mxConstants.NONE), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.setGradient = function (t, e, i, n, s, o, l, r, a) {
  if (null != t && null != e) {
    mxAbstractCanvas2D.prototype.setGradient.apply(this, arguments);
    var h = this.createElement("gradient");
    h.setAttribute("c1", t), h.setAttribute("c2", e), h.setAttribute("x", this.format(i)), h.setAttribute("y", this.format(n)), h.setAttribute("w", this.format(s)), h.setAttribute("h", this.format(o)), null != l && h.setAttribute("direction", l), null != r && h.setAttribute("alpha1", r), null != a && h.setAttribute("alpha2", a), this.root.appendChild(h);
  }
}, mxXmlCanvas2D.prototype.setStrokeColor = function (t) {
  if (t == mxConstants.NONE && (t = null), this.compressed) {
    if (this.state.strokeColor == t) return;
    mxAbstractCanvas2D.prototype.setStrokeColor.apply(this, arguments);
  }

  var e = this.createElement("strokecolor");
  e.setAttribute("color", null != t ? t : mxConstants.NONE), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.setStrokeWidth = function (t) {
  if (this.compressed) {
    if (this.state.strokeWidth == t) return;
    mxAbstractCanvas2D.prototype.setStrokeWidth.apply(this, arguments);
  }

  var e = this.createElement("strokewidth");
  e.setAttribute("width", this.format(t)), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.setDashed = function (t, e) {
  if (this.compressed) {
    if (this.state.dashed == t) return;
    mxAbstractCanvas2D.prototype.setDashed.apply(this, arguments);
  }

  var i = this.createElement("dashed");
  i.setAttribute("dashed", t ? "1" : "0"), null != e && i.setAttribute("fixDash", e ? "1" : "0"), this.root.appendChild(i);
}, mxXmlCanvas2D.prototype.setDashPattern = function (t) {
  if (this.compressed) {
    if (this.state.dashPattern == t) return;
    mxAbstractCanvas2D.prototype.setDashPattern.apply(this, arguments);
  }

  var e = this.createElement("dashpattern");
  e.setAttribute("pattern", t), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.setLineCap = function (t) {
  if (this.compressed) {
    if (this.state.lineCap == t) return;
    mxAbstractCanvas2D.prototype.setLineCap.apply(this, arguments);
  }

  var e = this.createElement("linecap");
  e.setAttribute("cap", t), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.setLineJoin = function (t) {
  if (this.compressed) {
    if (this.state.lineJoin == t) return;
    mxAbstractCanvas2D.prototype.setLineJoin.apply(this, arguments);
  }

  var e = this.createElement("linejoin");
  e.setAttribute("join", t), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.setMiterLimit = function (t) {
  if (this.compressed) {
    if (this.state.miterLimit == t) return;
    mxAbstractCanvas2D.prototype.setMiterLimit.apply(this, arguments);
  }

  var e = this.createElement("miterlimit");
  e.setAttribute("limit", t), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.setFontColor = function (t) {
  if (this.textEnabled) {
    if (t == mxConstants.NONE && (t = null), this.compressed) {
      if (this.state.fontColor == t) return;
      mxAbstractCanvas2D.prototype.setFontColor.apply(this, arguments);
    }

    var e = this.createElement("fontcolor");
    e.setAttribute("color", null != t ? t : mxConstants.NONE), this.root.appendChild(e);
  }
}, mxXmlCanvas2D.prototype.setFontBackgroundColor = function (t) {
  if (this.textEnabled) {
    if (t == mxConstants.NONE && (t = null), this.compressed) {
      if (this.state.fontBackgroundColor == t) return;
      mxAbstractCanvas2D.prototype.setFontBackgroundColor.apply(this, arguments);
    }

    var e = this.createElement("fontbackgroundcolor");
    e.setAttribute("color", null != t ? t : mxConstants.NONE), this.root.appendChild(e);
  }
}, mxXmlCanvas2D.prototype.setFontBorderColor = function (t) {
  if (this.textEnabled) {
    if (t == mxConstants.NONE && (t = null), this.compressed) {
      if (this.state.fontBorderColor == t) return;
      mxAbstractCanvas2D.prototype.setFontBorderColor.apply(this, arguments);
    }

    var e = this.createElement("fontbordercolor");
    e.setAttribute("color", null != t ? t : mxConstants.NONE), this.root.appendChild(e);
  }
}, mxXmlCanvas2D.prototype.setFontSize = function (t) {
  if (this.textEnabled) {
    if (this.compressed) {
      if (this.state.fontSize == t) return;
      mxAbstractCanvas2D.prototype.setFontSize.apply(this, arguments);
    }

    var e = this.createElement("fontsize");
    e.setAttribute("size", t), this.root.appendChild(e);
  }
}, mxXmlCanvas2D.prototype.setFontFamily = function (t) {
  if (this.textEnabled) {
    if (this.compressed) {
      if (this.state.fontFamily == t) return;
      mxAbstractCanvas2D.prototype.setFontFamily.apply(this, arguments);
    }

    var e = this.createElement("fontfamily");
    e.setAttribute("family", t), this.root.appendChild(e);
  }
}, mxXmlCanvas2D.prototype.setFontStyle = function (t) {
  if (this.textEnabled) {
    if (null == t && (t = 0), this.compressed) {
      if (this.state.fontStyle == t) return;
      mxAbstractCanvas2D.prototype.setFontStyle.apply(this, arguments);
    }

    var e = this.createElement("fontstyle");
    e.setAttribute("style", t), this.root.appendChild(e);
  }
}, mxXmlCanvas2D.prototype.setShadow = function (t) {
  if (this.compressed) {
    if (this.state.shadow == t) return;
    mxAbstractCanvas2D.prototype.setShadow.apply(this, arguments);
  }

  var e = this.createElement("shadow");
  e.setAttribute("enabled", t ? "1" : "0"), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.setShadowColor = function (t) {
  if (this.compressed) {
    if (t == mxConstants.NONE && (t = null), this.state.shadowColor == t) return;
    mxAbstractCanvas2D.prototype.setShadowColor.apply(this, arguments);
  }

  var e = this.createElement("shadowcolor");
  e.setAttribute("color", null != t ? t : mxConstants.NONE), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.setShadowAlpha = function (t) {
  if (this.compressed) {
    if (this.state.shadowAlpha == t) return;
    mxAbstractCanvas2D.prototype.setShadowAlpha.apply(this, arguments);
  }

  var e = this.createElement("shadowalpha");
  e.setAttribute("alpha", t), this.root.appendChild(e);
}, mxXmlCanvas2D.prototype.setShadowOffset = function (t, e) {
  if (this.compressed) {
    if (this.state.shadowDx == t && this.state.shadowDy == e) return;
    mxAbstractCanvas2D.prototype.setShadowOffset.apply(this, arguments);
  }

  var i = this.createElement("shadowoffset");
  i.setAttribute("dx", t), i.setAttribute("dy", e), this.root.appendChild(i);
}, mxXmlCanvas2D.prototype.rect = function (t, e, i, n) {
  var s = this.createElement("rect");
  s.setAttribute("x", this.format(t)), s.setAttribute("y", this.format(e)), s.setAttribute("w", this.format(i)), s.setAttribute("h", this.format(n)), this.root.appendChild(s);
}, mxXmlCanvas2D.prototype.roundrect = function (t, e, i, n, s, o) {
  var l = this.createElement("roundrect");
  l.setAttribute("x", this.format(t)), l.setAttribute("y", this.format(e)), l.setAttribute("w", this.format(i)), l.setAttribute("h", this.format(n)), l.setAttribute("dx", this.format(s)), l.setAttribute("dy", this.format(o)), this.root.appendChild(l);
}, mxXmlCanvas2D.prototype.ellipse = function (t, e, i, n) {
  var s = this.createElement("ellipse");
  s.setAttribute("x", this.format(t)), s.setAttribute("y", this.format(e)), s.setAttribute("w", this.format(i)), s.setAttribute("h", this.format(n)), this.root.appendChild(s);
}, mxXmlCanvas2D.prototype.image = function (t, e, i, n, s, o, l, r) {
  s = this.converter.convert(s);
  var a = this.createElement("image");
  a.setAttribute("x", this.format(t)), a.setAttribute("y", this.format(e)), a.setAttribute("w", this.format(i)), a.setAttribute("h", this.format(n)), a.setAttribute("src", s), a.setAttribute("aspect", o ? "1" : "0"), a.setAttribute("flipH", l ? "1" : "0"), a.setAttribute("flipV", r ? "1" : "0"), this.root.appendChild(a);
}, mxXmlCanvas2D.prototype.begin = function () {
  this.root.appendChild(this.createElement("begin")), this.lastY = this.lastX = 0;
}, mxXmlCanvas2D.prototype.moveTo = function (t, e) {
  var i = this.createElement("move");
  i.setAttribute("x", this.format(t)), i.setAttribute("y", this.format(e)), this.root.appendChild(i), this.lastX = t, this.lastY = e;
}, mxXmlCanvas2D.prototype.lineTo = function (t, e) {
  var i = this.createElement("line");
  i.setAttribute("x", this.format(t)), i.setAttribute("y", this.format(e)), this.root.appendChild(i), this.lastX = t, this.lastY = e;
}, mxXmlCanvas2D.prototype.quadTo = function (t, e, i, n) {
  var s = this.createElement("quad");
  s.setAttribute("x1", this.format(t)), s.setAttribute("y1", this.format(e)), s.setAttribute("x2", this.format(i)), s.setAttribute("y2", this.format(n)), this.root.appendChild(s), this.lastX = i, this.lastY = n;
}, mxXmlCanvas2D.prototype.curveTo = function (t, e, i, n, s, o) {
  var l = this.createElement("curve");
  l.setAttribute("x1", this.format(t)), l.setAttribute("y1", this.format(e)), l.setAttribute("x2", this.format(i)), l.setAttribute("y2", this.format(n)), l.setAttribute("x3", this.format(s)), l.setAttribute("y3", this.format(o)), this.root.appendChild(l), this.lastX = s, this.lastY = o;
}, mxXmlCanvas2D.prototype.close = function () {
  this.root.appendChild(this.createElement("close"));
}, mxXmlCanvas2D.prototype.text = function (t, e, i, n, s, o, l, r, a, h, u, d, p) {
  if (this.textEnabled && null != s) {
    mxUtils.isNode(s) && (s = mxUtils.getOuterHtml(s));
    var c = this.createElement("text");
    c.setAttribute("x", this.format(t)), c.setAttribute("y", this.format(e)), c.setAttribute("w", this.format(i)), c.setAttribute("h", this.format(n)), c.setAttribute("str", s), null != o && c.setAttribute("align", o), null != l && c.setAttribute("valign", l), c.setAttribute("wrap", r ? "1" : "0"), null == a && (a = ""), c.setAttribute("format", a), null != h && c.setAttribute("overflow", h), null != u && c.setAttribute("clip", u ? "1" : "0"), null != d && c.setAttribute("rotation", d), null != p && c.setAttribute("dir", p), this.root.appendChild(c);
  }
}, mxXmlCanvas2D.prototype.stroke = function () {
  this.root.appendChild(this.createElement("stroke"));
}, mxXmlCanvas2D.prototype.fill = function () {
  this.root.appendChild(this.createElement("fill"));
}, mxXmlCanvas2D.prototype.fillAndStroke = function () {
  this.root.appendChild(this.createElement("fillstroke"));
}, mxUtils.extend(mxSvgCanvas2D, mxAbstractCanvas2D), function () {
  if (mxSvgCanvas2D.prototype.useDomParser = !mxClient.IS_IE && "function" == typeof DOMParser && "function" == typeof XMLSerializer, mxSvgCanvas2D.prototype.useDomParser) try {
    var t = new DOMParser().parseFromString("test text", "text/html");
    mxSvgCanvas2D.prototype.useDomParser = null != t;
  } catch (t) {
    mxSvgCanvas2D.prototype.useDomParser = !1;
  }
}(), mxSvgCanvas2D.prototype.node = null, mxSvgCanvas2D.prototype.matchHtmlAlignment = !0, mxSvgCanvas2D.prototype.textEnabled = !0, mxSvgCanvas2D.prototype.foEnabled = !0, mxSvgCanvas2D.prototype.foAltText = "[Object]", mxSvgCanvas2D.prototype.foOffset = 0, mxSvgCanvas2D.prototype.textOffset = 0, mxSvgCanvas2D.prototype.imageOffset = 0, mxSvgCanvas2D.prototype.strokeTolerance = 0, mxSvgCanvas2D.prototype.minStrokeWidth = 1, mxSvgCanvas2D.prototype.refCount = 0, mxSvgCanvas2D.prototype.blockImagePointerEvents = !1, mxSvgCanvas2D.prototype.lineHeightCorrection = 1, mxSvgCanvas2D.prototype.pointerEventsValue = "all", mxSvgCanvas2D.prototype.fontMetricsPadding = 10, mxSvgCanvas2D.prototype.cacheOffsetSize = !0, mxSvgCanvas2D.prototype.format = function (t) {
  return parseFloat(parseFloat(t).toFixed(2));
}, mxSvgCanvas2D.prototype.getBaseUrl = function () {
  var t = window.location.href,
      e = t.lastIndexOf("#");
  return 0 < e && (t = t.substring(0, e)), t;
}, mxSvgCanvas2D.prototype.reset = function () {
  mxAbstractCanvas2D.prototype.reset.apply(this, arguments), this.gradients = [];
}, mxSvgCanvas2D.prototype.createStyle = function (t) {
  return (t = this.createElement("style")).setAttribute("type", "text/css"), mxUtils.write(t, "svg{font-family:" + mxConstants.DEFAULT_FONTFAMILY + ";font-size:" + mxConstants.DEFAULT_FONTSIZE + ";fill:none;stroke-miterlimit:10}"), t;
}, mxSvgCanvas2D.prototype.createElement = function (t, e) {
  if (null != this.root.ownerDocument.createElementNS) return this.root.ownerDocument.createElementNS(e || mxConstants.NS_SVG, t);
  var i = this.root.ownerDocument.createElement(t);
  return null != e && i.setAttribute("xmlns", e), i;
}, mxSvgCanvas2D.prototype.createAlternateContent = function (t, e, i, n, s, o, l, r, a, h, u, d, p) {
  return null != this.foAltText ? (t = this.state, (e = this.createElement("text")).setAttribute("x", Math.round(n / 2)), e.setAttribute("y", Math.round((s + t.fontSize) / 2)), e.setAttribute("fill", t.fontColor || "black"), e.setAttribute("text-anchor", "middle"), e.setAttribute("font-size", t.fontSize + "px"), e.setAttribute("font-family", t.fontFamily), (t.fontStyle & mxConstants.FONT_BOLD) == mxConstants.FONT_BOLD && e.setAttribute("font-weight", "bold"), (t.fontStyle & mxConstants.FONT_ITALIC) == mxConstants.FONT_ITALIC && e.setAttribute("font-style", "italic"), (t.fontStyle & mxConstants.FONT_UNDERLINE) == mxConstants.FONT_UNDERLINE && e.setAttribute("text-decoration", "underline"), mxUtils.write(e, this.foAltText), e) : null;
}, mxSvgCanvas2D.prototype.createGradientId = function (t, e, i, n, s) {
  return "#" == t.charAt(0) && (t = t.substring(1)), "#" == e.charAt(0) && (e = e.substring(1)), t = t.toLowerCase() + "-" + i, e = e.toLowerCase() + "-" + n, i = null, null == s || s == mxConstants.DIRECTION_SOUTH ? i = "s" : s == mxConstants.DIRECTION_EAST ? i = "e" : (n = t, t = e, e = n, s == mxConstants.DIRECTION_NORTH ? i = "s" : s == mxConstants.DIRECTION_WEST && (i = "e")), "mx-gradient-" + t + "-" + e + "-" + i;
}, mxSvgCanvas2D.prototype.getSvgGradient = function (t, e, i, n, s) {
  var o = this.createGradientId(t, e, i, n, s),
      l = this.gradients[o];

  if (null == l) {
    var r = this.root.ownerSVGElement,
        a = 0,
        h = o + "-" + a;
    if (null != r) for (l = r.ownerDocument.getElementById(h); null != l && l.ownerSVGElement != r;) {
      h = o + "-" + a++, l = r.ownerDocument.getElementById(h);
    } else h = "id" + ++this.refCount;
    null == l && ((l = this.createSvgGradient(t, e, i, n, s)).setAttribute("id", h), null != this.defs ? this.defs.appendChild(l) : r.appendChild(l)), this.gradients[o] = l;
  }

  return l.getAttribute("id");
}, mxSvgCanvas2D.prototype.createSvgGradient = function (t, e, i, n, s) {
  var o = this.createElement("linearGradient");
  return o.setAttribute("x1", "0%"), o.setAttribute("y1", "0%"), o.setAttribute("x2", "0%"), o.setAttribute("y2", "0%"), null == s || s == mxConstants.DIRECTION_SOUTH ? o.setAttribute("y2", "100%") : s == mxConstants.DIRECTION_EAST ? o.setAttribute("x2", "100%") : s == mxConstants.DIRECTION_NORTH ? o.setAttribute("y1", "100%") : s == mxConstants.DIRECTION_WEST && o.setAttribute("x1", "100%"), i = 1 > i ? ";stop-opacity:" + i : "", (s = this.createElement("stop")).setAttribute("offset", "0%"), s.setAttribute("style", "stop-color:" + t + i), o.appendChild(s), i = 1 > n ? ";stop-opacity:" + n : "", (s = this.createElement("stop")).setAttribute("offset", "100%"), s.setAttribute("style", "stop-color:" + e + i), o.appendChild(s), o;
}, mxSvgCanvas2D.prototype.addNode = function (t, e) {
  var i = this.node,
      n = this.state;

  if (null != i) {
    if ("path" == i.nodeName) {
      if (!(null != this.path && 0 < this.path.length)) return;
      i.setAttribute("d", this.path.join(" "));
    }

    t && null != n.fillColor ? this.updateFill() : this.styleEnabled || ("ellipse" == i.nodeName && mxClient.IS_FF ? i.setAttribute("fill", "transparent") : i.setAttribute("fill", "none"), t = !1), e && null != n.strokeColor ? this.updateStroke() : this.styleEnabled || i.setAttribute("stroke", "none"), null != n.transform && 0 < n.transform.length && i.setAttribute("transform", n.transform), n.shadow && this.root.appendChild(this.createShadow(i)), 0 < this.strokeTolerance && !t && this.root.appendChild(this.createTolerance(i)), !this.pointerEvents || "path" == i.nodeName && this.path[this.path.length - 1] != this.closeOp ? this.pointerEvents || null != this.originalRoot || i.setAttribute("pointer-events", "none") : i.setAttribute("pointer-events", this.pointerEventsValue), ("rect" != i.nodeName && "path" != i.nodeName && "ellipse" != i.nodeName || "none" != i.getAttribute("fill") && "transparent" != i.getAttribute("fill") || "none" != i.getAttribute("stroke") || "none" != i.getAttribute("pointer-events")) && this.root.appendChild(i), this.node = null;
  }
}, mxSvgCanvas2D.prototype.updateFill = function () {
  var t = this.state;
  if ((1 > t.alpha || 1 > t.fillAlpha) && this.node.setAttribute("fill-opacity", t.alpha * t.fillAlpha), null != t.fillColor) if (null != t.gradientColor) {
    if (t = this.getSvgGradient(t.fillColor, t.gradientColor, t.gradientFillAlpha, t.gradientAlpha, t.gradientDirection), mxClient.IS_CHROME_APP || mxClient.IS_IE || mxClient.IS_IE11 || mxClient.IS_EDGE || this.root.ownerDocument != document) this.node.setAttribute("fill", "url(#" + t + ")");else {
      var e = this.getBaseUrl().replace(/([\(\)])/g, "\\$1");
      this.node.setAttribute("fill", "url(" + e + "#" + t + ")");
    }
  } else this.node.setAttribute("fill", t.fillColor.toLowerCase());
}, mxSvgCanvas2D.prototype.getCurrentStrokeWidth = function () {
  return Math.max(this.minStrokeWidth, Math.max(.01, this.format(this.state.strokeWidth * this.state.scale)));
}, mxSvgCanvas2D.prototype.updateStroke = function () {
  var t = this.state;
  this.node.setAttribute("stroke", t.strokeColor.toLowerCase()), (1 > t.alpha || 1 > t.strokeAlpha) && this.node.setAttribute("stroke-opacity", t.alpha * t.strokeAlpha);
  var e = this.getCurrentStrokeWidth();
  1 != e && this.node.setAttribute("stroke-width", e), "path" == this.node.nodeName && this.updateStrokeAttributes(), t.dashed && this.node.setAttribute("stroke-dasharray", this.createDashPattern((t.fixDash ? 1 : t.strokeWidth) * t.scale));
}, mxSvgCanvas2D.prototype.updateStrokeAttributes = function () {
  var t = this.state;

  if (null != t.lineJoin && "miter" != t.lineJoin && this.node.setAttribute("stroke-linejoin", t.lineJoin), null != t.lineCap) {
    var e = t.lineCap;
    "flat" == e && (e = "butt"), "butt" != e && this.node.setAttribute("stroke-linecap", e);
  }

  null == t.miterLimit || this.styleEnabled && 10 == t.miterLimit || this.node.setAttribute("stroke-miterlimit", t.miterLimit);
}, mxSvgCanvas2D.prototype.createDashPattern = function (t) {
  var e = [];

  if ("string" == typeof this.state.dashPattern) {
    var i = this.state.dashPattern.split(" ");
    if (0 < i.length) for (var n = 0; n < i.length; n++) {
      e[n] = Number(i[n]) * t;
    }
  }

  return e.join(" ");
}, mxSvgCanvas2D.prototype.createTolerance = function (t) {
  t = t.cloneNode(!0);
  var e = parseFloat(t.getAttribute("stroke-width") || 1) + this.strokeTolerance;
  return t.setAttribute("pointer-events", "stroke"), t.setAttribute("visibility", "hidden"), t.removeAttribute("stroke-dasharray"), t.setAttribute("stroke-width", e), t.setAttribute("fill", "none"), t.setAttribute("stroke", mxClient.IS_OT ? "none" : "white"), t;
}, mxSvgCanvas2D.prototype.createShadow = function (t) {
  t = t.cloneNode(!0);
  var e = this.state;
  return "none" == t.getAttribute("fill") || mxClient.IS_FF && "transparent" == t.getAttribute("fill") || t.setAttribute("fill", e.shadowColor), "none" != t.getAttribute("stroke") && t.setAttribute("stroke", e.shadowColor), t.setAttribute("transform", "translate(" + this.format(e.shadowDx * e.scale) + "," + this.format(e.shadowDy * e.scale) + ")" + (e.transform || "")), t.setAttribute("opacity", e.shadowAlpha), t;
}, mxSvgCanvas2D.prototype.setLink = function (t) {
  if (null == t) this.root = this.originalRoot;else {
    this.originalRoot = this.root;
    var e = this.createElement("a");
    null == e.setAttributeNS || this.root.ownerDocument != document && null == document.documentMode ? e.setAttribute("xlink:href", t) : e.setAttributeNS(mxConstants.NS_XLINK, "xlink:href", t), this.root.appendChild(e), this.root = e;
  }
}, mxSvgCanvas2D.prototype.rotate = function (t, e, i, n, s) {
  if (0 != t || e || i) {
    var o = this.state;
    if (n += o.dx, s += o.dy, n *= o.scale, s *= o.scale, o.transform = o.transform || "", e && i) t += 180;else if (e != i) {
      var l = e ? n : 0,
          r = e ? -1 : 1,
          a = i ? s : 0,
          h = i ? -1 : 1;
      o.transform += "translate(" + this.format(l) + "," + this.format(a) + ")scale(" + this.format(r) + "," + this.format(h) + ")translate(" + this.format(-l) + "," + this.format(-a) + ")";
    }
    (e ? !i : i) && (t *= -1), 0 != t && (o.transform += "rotate(" + this.format(t) + "," + this.format(n) + "," + this.format(s) + ")"), o.rotation += t, o.rotationCx = n, o.rotationCy = s;
  }
}, mxSvgCanvas2D.prototype.begin = function () {
  mxAbstractCanvas2D.prototype.begin.apply(this, arguments), this.node = this.createElement("path");
}, mxSvgCanvas2D.prototype.rect = function (t, e, i, n) {
  var s = this.state,
      o = this.createElement("rect");
  o.setAttribute("x", this.format((t + s.dx) * s.scale)), o.setAttribute("y", this.format((e + s.dy) * s.scale)), o.setAttribute("width", this.format(i * s.scale)), o.setAttribute("height", this.format(n * s.scale)), this.node = o;
}, mxSvgCanvas2D.prototype.roundrect = function (t, e, i, n, s, o) {
  this.rect(t, e, i, n), 0 < s && this.node.setAttribute("rx", this.format(s * this.state.scale)), 0 < o && this.node.setAttribute("ry", this.format(o * this.state.scale));
}, mxSvgCanvas2D.prototype.ellipse = function (t, e, i, n) {
  var s = this.state,
      o = this.createElement("ellipse");
  o.setAttribute("cx", Math.round((t + i / 2 + s.dx) * s.scale)), o.setAttribute("cy", Math.round((e + n / 2 + s.dy) * s.scale)), o.setAttribute("rx", i / 2 * s.scale), o.setAttribute("ry", n / 2 * s.scale), this.node = o;
}, mxSvgCanvas2D.prototype.image = function (t, e, i, n, s, o, l, r) {
  s = this.converter.convert(s), o = null == o || o, l = null != l && l, r = null != r && r;
  var a = this.state;
  t += a.dx, e += a.dy;
  var h = this.createElement("image");

  if (h.setAttribute("x", this.format(t * a.scale) + this.imageOffset), h.setAttribute("y", this.format(e * a.scale) + this.imageOffset), h.setAttribute("width", this.format(i * a.scale)), h.setAttribute("height", this.format(n * a.scale)), null == h.setAttributeNS ? h.setAttribute("xlink:href", s) : h.setAttributeNS(mxConstants.NS_XLINK, "xlink:href", s), o || h.setAttribute("preserveAspectRatio", "none"), (1 > a.alpha || 1 > a.fillAlpha) && h.setAttribute("opacity", a.alpha * a.fillAlpha), s = this.state.transform || "", l || r) {
    var u = o = 1,
        d = 0,
        p = 0;
    l && (o = -1, d = -i - 2 * t), r && (u = -1, p = -n - 2 * e), s += "scale(" + o + "," + u + ")translate(" + d * a.scale + "," + p * a.scale + ")";
  }

  0 < s.length && h.setAttribute("transform", s), this.pointerEvents || h.setAttribute("pointer-events", "none"), this.root.appendChild(h), this.blockImagePointerEvents && (h.setAttribute("style", "pointer-events:none"), (h = this.createElement("rect")).setAttribute("visibility", "hidden"), h.setAttribute("pointer-events", "fill"), h.setAttribute("x", this.format(t * a.scale)), h.setAttribute("y", this.format(e * a.scale)), h.setAttribute("width", this.format(i * a.scale)), h.setAttribute("height", this.format(n * a.scale)), this.root.appendChild(h));
}, mxSvgCanvas2D.prototype.convertHtml = function (t) {
  if (this.useDomParser) {
    null != (e = new DOMParser().parseFromString(t, "text/html")) && ("<body" == (t = new XMLSerializer().serializeToString(e.body)).substring(0, 5) && (t = t.substring(t.indexOf(">", 5) + 1)), "</body>" == t.substring(t.length - 7, t.length) && (t = t.substring(0, t.length - 7)));
  } else {
    if (null != document.implementation && null != document.implementation.createDocument) {
      var e,
          i = (e = document.implementation.createDocument("http://www.w3.org/1999/xhtml", "html", null)).createElement("body");
      e.documentElement.appendChild(i);
      var n = document.createElement("div");

      for (n.innerHTML = t, t = n.firstChild; null != t;) {
        n = t.nextSibling, i.appendChild(e.adoptNode(t)), t = n;
      }

      return i.innerHTML;
    }

    (e = document.createElement("textarea")).innerHTML = t.replace(/&amp;/g, "&amp;amp;").replace(/&#60;/g, "&amp;lt;").replace(/&#62;/g, "&amp;gt;").replace(/&lt;/g, "&amp;lt;").replace(/&gt;/g, "&amp;gt;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), t = e.value.replace(/&/g, "&amp;").replace(/&amp;lt;/g, "&lt;").replace(/&amp;gt;/g, "&gt;").replace(/&amp;amp;/g, "&amp;").replace(/<br>/g, "<br />").replace(/<hr>/g, "<hr />").replace(/(<img[^>]+)>/gm, "$1 />");
  }

  return t;
}, mxSvgCanvas2D.prototype.createDiv = function (t, e, i, n, s) {
  return n = "display:inline-block;font-size:" + (i = this.state).fontSize + "px;font-family:" + i.fontFamily + ";color:" + i.fontColor + ";line-height:" + (mxConstants.ABSOLUTE_LINE_HEIGHT ? i.fontSize * mxConstants.LINE_HEIGHT + "px" : mxConstants.LINE_HEIGHT * this.lineHeightCorrection) + ";" + n, (i.fontStyle & mxConstants.FONT_BOLD) == mxConstants.FONT_BOLD && (n += "font-weight:bold;"), (i.fontStyle & mxConstants.FONT_ITALIC) == mxConstants.FONT_ITALIC && (n += "font-style:italic;"), (i.fontStyle & mxConstants.FONT_UNDERLINE) == mxConstants.FONT_UNDERLINE && (n += "text-decoration:underline;"), e == mxConstants.ALIGN_CENTER ? n += "text-align:center;" : e == mxConstants.ALIGN_RIGHT && (n += "text-align:right;"), e = "", null != i.fontBackgroundColor && (e += "background-color:" + i.fontBackgroundColor + ";"), null != i.fontBorderColor && (e += "border:1px solid " + i.fontBorderColor + ";"), mxUtils.isNode(t) || (t = this.convertHtml(t), "fill" != s && "width" != s ? t = '<div xmlns="http://www.w3.org/1999/xhtml" style="display:inline-block;text-align:inherit;text-decoration:inherit;' + e + '">' + t + "</div>" : n += e), !mxClient.IS_IE && document.createElementNS ? ((s = document.createElementNS("http://www.w3.org/1999/xhtml", "div")).setAttribute("style", n), mxUtils.isNode(t) ? this.root.ownerDocument != document ? s.appendChild(t.cloneNode(!0)) : s.appendChild(t) : s.innerHTML = t, s) : (mxUtils.isNode(t) && this.root.ownerDocument != document && (t = t.outerHTML), mxUtils.parseXml('<div xmlns="http://www.w3.org/1999/xhtml" style="' + n + '">' + t + "</div>").documentElement);
}, mxSvgCanvas2D.prototype.invalidateCachedOffsetSize = function (t) {
  delete t.firstChild.mxCachedOffsetWidth, delete t.firstChild.mxCachedFinalOffsetWidth, delete t.firstChild.mxCachedFinalOffsetHeight;
}, mxSvgCanvas2D.prototype.updateText = function (t, e, i, n, s, o, l, r, a, h, u) {
  if (null != u && null != u.firstChild && null != u.firstChild.firstChild && null != u.firstChild.firstChild.firstChild) {
    var d = (u = u.firstChild).firstChild,
        p = d.firstChild;
    h = null != h ? h : 0;
    var c = this.state;
    t += c.dx, e += c.dy, a ? (p.style.maxHeight = Math.round(n) + "px", p.style.maxWidth = Math.round(i) + "px") : "fill" == r ? (p.style.width = Math.round(i + 1) + "px", p.style.height = Math.round(n + 1) + "px") : "width" == r && (p.style.width = Math.round(i + 1) + "px", 0 < n && (p.style.maxHeight = Math.round(n) + "px")), l && 0 < i && (p.style.width = Math.round(i + 1) + "px");
    var m,
        g = p;
    null != g.firstChild && "DIV" == g.firstChild.nodeName && (g = g.firstChild);
    var x = null != u.mxCachedOffsetWidth ? u.mxCachedOffsetWidth : g.offsetWidth;
    m = x + 0, l && "fill" != r && (a && (m = Math.min(m, i)), p.style.width = Math.round(m + 1) + "px"), m = null != u.mxCachedFinalOffsetWidth ? u.mxCachedFinalOffsetWidth : g.offsetWidth, l = null != u.mxCachedFinalOffsetHeight ? u.mxCachedFinalOffsetHeight : g.offsetHeight, this.cacheOffsetSize && (u.mxCachedOffsetWidth = x, u.mxCachedFinalOffsetWidth = m, u.mxCachedFinalOffsetHeight = l), m += 0, l -= 2, a && (l = Math.min(l, n), m = Math.min(m, i)), "width" == r ? n = l : "fill" != r && (i = m, n = l), l = a = 0, s == mxConstants.ALIGN_CENTER ? a -= i / 2 : s == mxConstants.ALIGN_RIGHT && (a -= i), t += a, o == mxConstants.ALIGN_MIDDLE ? l -= n / 2 : o == mxConstants.ALIGN_BOTTOM && (l -= n), "fill" != r && mxClient.IS_FF && mxClient.IS_WIN && (l -= 2), e += l, s = 1 != c.scale ? "scale(" + c.scale + ")" : "", 0 != c.rotation && this.rotateHtml ? (s += "rotate(" + c.rotation + "," + i / 2 + "," + n / 2 + ")", t = (e = this.rotatePoint((t + i / 2) * c.scale, (e + n / 2) * c.scale, c.rotation, c.rotationCx, c.rotationCy)).x - i * c.scale / 2, e = e.y - n * c.scale / 2) : (t *= c.scale, e *= c.scale), 0 != h && (s += "rotate(" + h + "," + -a + "," + -l + ")"), u.setAttribute("transform", "translate(" + Math.round(t) + "," + Math.round(e) + ")" + s), d.setAttribute("width", Math.round(Math.max(1, i))), d.setAttribute("height", Math.round(Math.max(1, n)));
  }
}, mxSvgCanvas2D.prototype.text = function (t, e, i, n, s, o, l, r, a, h, u, d, p) {
  if (this.textEnabled && null != s) {
    d = null != d ? d : 0;
    var c = this.state;

    if (t += c.dx, e += c.dy, this.foEnabled && "html" == a) {
      var m = "vertical-align:top;";
      u ? m += "overflow:hidden;max-height:" + Math.round(n) + "px;max-width:" + Math.round(i) + "px;" : "fill" == h ? m += "width:" + Math.round(i + 1) + "px;height:" + Math.round(n + 1) + "px;overflow:hidden;" : "width" == h && (m += "width:" + Math.round(i + 1) + "px;", 0 < n && (m += "max-height:" + Math.round(n) + "px;overflow:hidden;"));
      m = r && 0 < i ? m + "width:" + Math.round(i + 1) + "px;white-space:normal;word-wrap:" + mxConstants.WORD_WRAP + ";" : m + "white-space:nowrap;";
      var g = this.createElement("g");
      1 > c.alpha && g.setAttribute("opacity", c.alpha);
      var x = this.createElement("foreignObject");

      if (x.setAttribute("style", "overflow:visible;"), x.setAttribute("pointer-events", "all"), null != (m = this.createDiv(s, o, l, m, h))) {
        var y, f;

        if (null != p && m.setAttribute("dir", p), g.appendChild(x), this.root.appendChild(g), p = y = 2, !mxClient.IS_IE || 9 != document.documentMode && mxClient.IS_SVG) {
          this.root.ownerDocument != document ? (m.style.visibility = "hidden", document.body.appendChild(m)) : x.appendChild(m);
          var v = m;
          null != v.firstChild && "DIV" == v.firstChild.nodeName && (v = v.firstChild, r && "break-word" == m.style.wordWrap && (v.style.width = "100%")), 0 == (C = v.offsetWidth) && m.parentNode == x && (m.style.visibility = "hidden", document.body.appendChild(m), C = v.offsetWidth), this.cacheOffsetSize && (g.mxCachedOffsetWidth = C), !u && r && 0 < i && this.root.ownerDocument != document && "fill" != h && "width" != h && (E = m.style.whiteSpace, m.style.whiteSpace = "nowrap", C < v.offsetWidth && (m.style.whiteSpace = E)), y = C + y - 1, r && "fill" != h && "width" != h && (u && (y = Math.min(y, i)), m.style.width = y + "px"), y = v.offsetWidth, f = v.offsetHeight, this.cacheOffsetSize && (g.mxCachedFinalOffsetWidth = y, g.mxCachedFinalOffsetHeight = f), f -= p, m.parentNode != x && (x.appendChild(m), m.style.visibility = "");
        } else {
          if ((v = document.createElement("div")).style.cssText = m.getAttribute("style"), v.style.display = mxClient.IS_QUIRKS ? "inline" : "inline-block", v.style.position = "absolute", v.style.visibility = "hidden", (f = document.createElement("div")).style.display = mxClient.IS_QUIRKS ? "inline" : "inline-block", f.style.wordWrap = mxConstants.WORD_WRAP, f.innerHTML = mxUtils.isNode(s) ? s.outerHTML : s, v.appendChild(f), document.body.appendChild(v), 8 != document.documentMode && 9 != document.documentMode && null != c.fontBorderColor && (y += 2, p += 2), r && 0 < i) {
            var C = f.offsetWidth;

            if (padDx = 0, !u && r && 0 < i && this.root.ownerDocument != document && "fill" != h) {
              var E = v.style.whiteSpace;
              f.style.whiteSpace = "nowrap", C < f.offsetWidth && (v.style.whiteSpace = E);
            }

            u && (C = Math.min(C, i)), v.style.width = C + "px", y = f.offsetWidth + y + padDx, f = f.offsetHeight + p, v.style.display = "inline-block", v.style.position = "", v.style.visibility = "", v.style.width = y + "px", m.setAttribute("style", v.style.cssText);
          } else y = f.offsetWidth + y, f = f.offsetHeight + p;

          v.parentNode.removeChild(v), x.appendChild(m);
        }

        u && (f = Math.min(f, n), y = Math.min(y, i)), "width" == h ? n = f : "fill" != h && (i = y, n = f), 1 > c.alpha && g.setAttribute("opacity", c.alpha), p = m = 0, o == mxConstants.ALIGN_CENTER ? m -= i / 2 : o == mxConstants.ALIGN_RIGHT && (m -= i), t += m, l == mxConstants.ALIGN_MIDDLE ? p -= n / 2 : l == mxConstants.ALIGN_BOTTOM && (p -= n), "fill" != h && mxClient.IS_FF && mxClient.IS_WIN && (p -= 2), e += p, v = 1 != c.scale ? "scale(" + c.scale + ")" : "", 0 != c.rotation && this.rotateHtml ? (v += "rotate(" + c.rotation + "," + i / 2 + "," + n / 2 + ")", t = (e = this.rotatePoint((t + i / 2) * c.scale, (e + n / 2) * c.scale, c.rotation, c.rotationCx, c.rotationCy)).x - i * c.scale / 2, e = e.y - n * c.scale / 2) : (t *= c.scale, e *= c.scale), 0 != d && (v += "rotate(" + d + "," + -m + "," + -p + ")"), g.setAttribute("transform", "translate(" + (Math.round(t) + this.foOffset) + "," + (Math.round(e) + this.foOffset) + ")" + v), x.setAttribute("width", Math.round(Math.max(1, i))), x.setAttribute("height", Math.round(Math.max(1, n))), this.root.ownerDocument != document && null != (t = this.createAlternateContent(x, t, e, i, n, s, o, l, r, a, h, u, d)) && (x.setAttribute("requiredFeatures", "http://www.w3.org/TR/SVG11/feature#Extensibility"), (i = this.createElement("switch")).appendChild(x), i.appendChild(t), g.appendChild(i));
      }
    } else this.plainText(t, e, i, n, s, o, l, r, h, u, d, p);
  }
}, mxSvgCanvas2D.prototype.createClip = function (t, e, i, n) {
  for (var s = "mx-clip-" + (t = Math.round(t)) + "-" + (e = Math.round(e)) + "-" + (i = Math.round(i)) + "-" + (n = Math.round(n)), o = 0, l = s + "-" + o; null != document.getElementById(l);) {
    l = s + "-" + ++o;
  }

  return clip = this.createElement("clipPath"), clip.setAttribute("id", l), (s = this.createElement("rect")).setAttribute("x", t), s.setAttribute("y", e), s.setAttribute("width", i), s.setAttribute("height", n), clip.appendChild(s), clip;
}, mxSvgCanvas2D.prototype.plainText = function (t, e, i, n, s, o, l, r, a, h, u, d) {
  u = null != u ? u : 0;
  var p = (r = this.state).fontSize,
      c = this.createElement("g"),
      m = r.transform || "";
  this.updateFont(c), 0 != u && (m += "rotate(" + u + "," + this.format(t * r.scale) + "," + this.format(e * r.scale) + ")"), null != d && c.setAttribute("direction", d), h && 0 < i && 0 < n && (d = t, u = e, o == mxConstants.ALIGN_CENTER ? d -= i / 2 : o == mxConstants.ALIGN_RIGHT && (d -= i), "fill" != a && (l == mxConstants.ALIGN_MIDDLE ? u -= n / 2 : l == mxConstants.ALIGN_BOTTOM && (u -= n)), u = this.createClip(d * r.scale - 2, u * r.scale - 2, i * r.scale + 4, n * r.scale + 4), null != this.defs ? this.defs.appendChild(u) : this.root.appendChild(u), mxClient.IS_CHROME_APP || mxClient.IS_IE || mxClient.IS_IE11 || mxClient.IS_EDGE || this.root.ownerDocument != document ? c.setAttribute("clip-path", "url(#" + u.getAttribute("id") + ")") : (d = this.getBaseUrl().replace(/([\(\)])/g, "\\$1"), c.setAttribute("clip-path", "url(" + d + "#" + u.getAttribute("id") + ")"))), "start" != (u = o == mxConstants.ALIGN_RIGHT ? "end" : o == mxConstants.ALIGN_CENTER ? "middle" : "start") && c.setAttribute("text-anchor", u), this.styleEnabled && p == mxConstants.DEFAULT_FONTSIZE || c.setAttribute("font-size", p * r.scale + "px"), 0 < m.length && c.setAttribute("transform", m), 1 > r.alpha && c.setAttribute("opacity", r.alpha), m = s.split("\n"), d = Math.round(p * mxConstants.LINE_HEIGHT);
  var g = p + (m.length - 1) * d;

  for (u = e + p - 1, l == mxConstants.ALIGN_MIDDLE ? "fill" == a ? u -= n / 2 : u -= (h = (this.matchHtmlAlignment && h && 0 < n ? Math.min(g, n) : g) / 2) + 1 : l == mxConstants.ALIGN_BOTTOM && ("fill" == a ? u -= n : u -= (h = this.matchHtmlAlignment && h && 0 < n ? Math.min(g, n) : g) + 2), h = 0; h < m.length; h++) {
    0 < m[h].length && 0 < mxUtils.trim(m[h]).length && ((p = this.createElement("text")).setAttribute("x", this.format(t * r.scale) + this.textOffset), p.setAttribute("y", this.format(u * r.scale) + this.textOffset), mxUtils.write(p, m[h]), c.appendChild(p)), u += d;
  }

  this.root.appendChild(c), this.addTextBackground(c, s, t, e, i, "fill" == a ? n : g, o, l, a);
}, mxSvgCanvas2D.prototype.updateFont = function (t) {
  var e = this.state;
  t.setAttribute("fill", e.fontColor), this.styleEnabled && e.fontFamily == mxConstants.DEFAULT_FONTFAMILY || t.setAttribute("font-family", e.fontFamily), (e.fontStyle & mxConstants.FONT_BOLD) == mxConstants.FONT_BOLD && t.setAttribute("font-weight", "bold"), (e.fontStyle & mxConstants.FONT_ITALIC) == mxConstants.FONT_ITALIC && t.setAttribute("font-style", "italic"), (e.fontStyle & mxConstants.FONT_UNDERLINE) == mxConstants.FONT_UNDERLINE && t.setAttribute("text-decoration", "underline");
}, mxSvgCanvas2D.prototype.addTextBackground = function (t, e, i, n, s, o, l, r, a) {
  var h = this.state;

  if (null != h.fontBackgroundColor || null != h.fontBorderColor) {
    var u = null;
    if ("fill" == a || "width" == a) l == mxConstants.ALIGN_CENTER ? i -= s / 2 : l == mxConstants.ALIGN_RIGHT && (i -= s), r == mxConstants.ALIGN_MIDDLE ? n -= o / 2 : r == mxConstants.ALIGN_BOTTOM && (n -= o), u = new mxRectangle((i + 1) * h.scale, n * h.scale, (s - 2) * h.scale, (o + 2) * h.scale);else if (null != t.getBBox && this.root.ownerDocument == document) try {
      u = t.getBBox();
      var d = mxClient.IS_IE && mxClient.IS_SVG;
      u = new mxRectangle(u.x, u.y + (d ? 0 : 1), u.width, u.height + (d ? 1 : 0));
    } catch (t) {} else (u = document.createElement("div")).style.lineHeight = mxConstants.ABSOLUTE_LINE_HEIGHT ? h.fontSize * mxConstants.LINE_HEIGHT + "px" : mxConstants.LINE_HEIGHT, u.style.fontSize = h.fontSize + "px", u.style.fontFamily = h.fontFamily, u.style.whiteSpace = "nowrap", u.style.position = "absolute", u.style.visibility = "hidden", u.style.display = mxClient.IS_QUIRKS ? "inline" : "inline-block", u.style.zoom = "1", (h.fontStyle & mxConstants.FONT_BOLD) == mxConstants.FONT_BOLD && (u.style.fontWeight = "bold"), (h.fontStyle & mxConstants.FONT_ITALIC) == mxConstants.FONT_ITALIC && (u.style.fontStyle = "italic"), e = mxUtils.htmlEntities(e, !1), u.innerHTML = e.replace(/\n/g, "<br/>"), document.body.appendChild(u), s = u.offsetWidth, o = u.offsetHeight, u.parentNode.removeChild(u), l == mxConstants.ALIGN_CENTER ? i -= s / 2 : l == mxConstants.ALIGN_RIGHT && (i -= s), r == mxConstants.ALIGN_MIDDLE ? n -= o / 2 : r == mxConstants.ALIGN_BOTTOM && (n -= o), u = new mxRectangle((i + 1) * h.scale, (n + 2) * h.scale, s * h.scale, (o + 1) * h.scale);
    null != u && ((e = this.createElement("rect")).setAttribute("fill", h.fontBackgroundColor || "none"), e.setAttribute("stroke", h.fontBorderColor || "none"), e.setAttribute("x", Math.floor(u.x - 1)), e.setAttribute("y", Math.floor(u.y - 1)), e.setAttribute("width", Math.ceil(u.width + 2)), e.setAttribute("height", Math.ceil(u.height)), h = null != h.fontBorderColor ? Math.max(1, this.format(h.scale)) : 0, e.setAttribute("stroke-width", h), this.root.ownerDocument == document && 1 == mxUtils.mod(h, 2) && e.setAttribute("transform", "translate(0.5, 0.5)"), t.insertBefore(e, t.firstChild));
  }
}, mxSvgCanvas2D.prototype.stroke = function () {
  this.addNode(!1, !0);
}, mxSvgCanvas2D.prototype.fill = function () {
  this.addNode(!0, !1);
}, mxSvgCanvas2D.prototype.fillAndStroke = function () {
  this.addNode(!0, !0);
};

var mxVmlCanvas2D = function mxVmlCanvas2D(t) {
  mxAbstractCanvas2D.call(this), this.root = t;
};

function mxGuide(t, e) {
  this.graph = t, this.setStates(e);
}

function mxStencil(t) {
  this.desc = t, this.parseDescription(), this.parseConstraints();
}

function mxShape(t) {
  this.stencil = t, this.initStyles();
}

mxUtils.extend(mxVmlCanvas2D, mxAbstractCanvas2D), mxVmlCanvas2D.prototype.node = null, mxVmlCanvas2D.prototype.textEnabled = !0, mxVmlCanvas2D.prototype.moveOp = "m", mxVmlCanvas2D.prototype.lineOp = "l", mxVmlCanvas2D.prototype.curveOp = "c", mxVmlCanvas2D.prototype.closeOp = "x", mxVmlCanvas2D.prototype.rotatedHtmlBackground = "", mxVmlCanvas2D.prototype.vmlScale = 1, mxVmlCanvas2D.prototype.createElement = function (t) {
  return document.createElement(t);
}, mxVmlCanvas2D.prototype.createVmlElement = function (t) {
  return this.createElement(mxClient.VML_PREFIX + ":" + t);
}, mxVmlCanvas2D.prototype.addNode = function (t, e) {
  var i = this.node,
      n = this.state;

  if (null != i) {
    if ("shape" == i.nodeName) {
      if (!(null != this.path && 0 < this.path.length)) return;
      i.path = this.path.join(" ") + " e", i.style.width = this.root.style.width, i.style.height = this.root.style.height, i.coordsize = parseInt(i.style.width) + " " + parseInt(i.style.height);
    }

    i.strokeweight = this.format(Math.max(1, n.strokeWidth * n.scale / this.vmlScale)) + "px", n.shadow && this.root.appendChild(this.createShadow(i, t && null != n.fillColor, e && null != n.strokeColor)), e && null != n.strokeColor ? (i.stroked = "true", i.strokecolor = n.strokeColor) : i.stroked = "false", i.appendChild(this.createStroke()), t && null != n.fillColor ? i.appendChild(this.createFill()) : !this.pointerEvents || "shape" == i.nodeName && this.path[this.path.length - 1] != this.closeOp ? i.filled = "false" : i.appendChild(this.createTransparentFill()), this.root.appendChild(i);
  }
}, mxVmlCanvas2D.prototype.createTransparentFill = function () {
  var t = this.createVmlElement("fill");
  return t.src = mxClient.imageBasePath + "/transparent.gif", t.type = "tile", t;
}, mxVmlCanvas2D.prototype.createFill = function () {
  var t = this.state,
      e = this.createVmlElement("fill");

  if (e.color = t.fillColor, null != t.gradientColor) {
    e.type = "gradient", e.method = "none", e.color2 = t.gradientColor;
    var i = 180 - t.rotation;
    i = t.gradientDirection == mxConstants.DIRECTION_WEST ? i - (90 + ("x" == this.root.style.flip ? 180 : 0)) : t.gradientDirection == mxConstants.DIRECTION_EAST ? i + (90 + ("x" == this.root.style.flip ? 180 : 0)) : t.gradientDirection == mxConstants.DIRECTION_NORTH ? i - (180 + ("y" == this.root.style.flip ? -180 : 0)) : i + ("y" == this.root.style.flip ? -180 : 0);
    "x" != this.root.style.flip && "y" != this.root.style.flip || (i *= -1), e.angle = mxUtils.mod(i, 360), e.opacity = t.alpha * t.gradientFillAlpha * 100 + "%", e.setAttribute(mxClient.OFFICE_PREFIX + ":opacity2", t.alpha * t.gradientAlpha * 100 + "%");
  } else (1 > t.alpha || 1 > t.fillAlpha) && (e.opacity = t.alpha * t.fillAlpha * 100 + "%");

  return e;
}, mxVmlCanvas2D.prototype.createStroke = function () {
  var t = this.state,
      e = this.createVmlElement("stroke");
  return e.endcap = t.lineCap || "flat", e.joinstyle = t.lineJoin || "miter", e.miterlimit = t.miterLimit || "10", (1 > t.alpha || 1 > t.strokeAlpha) && (e.opacity = t.alpha * t.strokeAlpha * 100 + "%"), t.dashed && (e.dashstyle = this.getVmlDashStyle()), e;
}, mxVmlCanvas2D.prototype.getVmlDashStyle = function () {
  var t = "dash";

  if ("string" == typeof this.state.dashPattern) {
    var e = this.state.dashPattern.split(" ");
    0 < e.length && 1 == e[0] && (t = "0 2");
  }

  return t;
}, mxVmlCanvas2D.prototype.createShadow = function (t, e, i) {
  var n = this.state,
      s = Math.PI / 180 * -n.rotation,
      o = Math.cos(s),
      l = (s = Math.sin(s), n.shadowDx * n.scale),
      r = n.shadowDy * n.scale;
  "x" == this.root.style.flip ? l *= -1 : "y" == this.root.style.flip && (r *= -1);
  var a = t.cloneNode(!0);
  return a.style.marginLeft = Math.round(l * o - r * s) + "px", a.style.marginTop = Math.round(l * s + r * o) + "px", 8 == document.documentMode && (a.strokeweight = t.strokeweight, "shape" == t.nodeName && (a.path = this.path.join(" ") + " e", a.style.width = this.root.style.width, a.style.height = this.root.style.height, a.coordsize = parseInt(t.style.width) + " " + parseInt(t.style.height))), i ? (a.strokecolor = n.shadowColor, a.appendChild(this.createShadowStroke())) : a.stroked = "false", e ? a.appendChild(this.createShadowFill()) : a.filled = "false", a;
}, mxVmlCanvas2D.prototype.createShadowFill = function () {
  var t = this.createVmlElement("fill");
  return t.color = this.state.shadowColor, t.opacity = this.state.alpha * this.state.shadowAlpha * 100 + "%", t;
}, mxVmlCanvas2D.prototype.createShadowStroke = function () {
  var t = this.createStroke();
  return t.opacity = this.state.alpha * this.state.shadowAlpha * 100 + "%", t;
}, mxVmlCanvas2D.prototype.rotate = function (t, e, i, n, s) {
  e && i ? t += 180 : e ? this.root.style.flip = "x" : i && (this.root.style.flip = "y"), (e ? !i : i) && (t *= -1), this.root.style.rotation = t, this.state.rotation += t, this.state.rotationCx = n, this.state.rotationCy = s;
}, mxVmlCanvas2D.prototype.begin = function () {
  mxAbstractCanvas2D.prototype.begin.apply(this, arguments), this.node = this.createVmlElement("shape"), this.node.style.position = "absolute";
}, mxVmlCanvas2D.prototype.quadTo = function (t, e, i, n) {
  var s = this.state,
      o = (this.lastX + s.dx) * s.scale,
      l = (this.lastY + s.dy) * s.scale;
  t = (t + s.dx) * s.scale;
  l += 2 / 3 * ((e = (e + s.dy) * s.scale) - l);
  var r = (i = (i + s.dx) * s.scale) + 2 / 3 * (t - i);
  e = (n = (n + s.dy) * s.scale) + 2 / 3 * (e - n), this.path.push("c " + this.format(o + 2 / 3 * (t - o)) + " " + this.format(l) + " " + this.format(r) + " " + this.format(e) + " " + this.format(i) + " " + this.format(n)), this.lastX = i / s.scale - s.dx, this.lastY = n / s.scale - s.dy;
}, mxVmlCanvas2D.prototype.createRect = function (t, e, i, n, s) {
  var o = this.state;
  return (t = this.createVmlElement(t)).style.position = "absolute", t.style.left = this.format((e + o.dx) * o.scale) + "px", t.style.top = this.format((i + o.dy) * o.scale) + "px", t.style.width = this.format(n * o.scale) + "px", t.style.height = this.format(s * o.scale) + "px", t;
}, mxVmlCanvas2D.prototype.rect = function (t, e, i, n) {
  this.node = this.createRect("rect", t, e, i, n);
}, mxVmlCanvas2D.prototype.roundrect = function (t, e, i, n, s, o) {
  this.node = this.createRect("roundrect", t, e, i, n), this.node.setAttribute("arcsize", Math.max(100 * s / i, 100 * o / n) + "%");
}, mxVmlCanvas2D.prototype.ellipse = function (t, e, i, n) {
  this.node = this.createRect("oval", t, e, i, n);
}, mxVmlCanvas2D.prototype.image = function (t, e, i, n, s, o, l, r) {
  o ? ((t = this.createRect("rect", t, e, i, n)).stroked = "false", (e = this.createVmlElement("fill")).aspect = o ? "atmost" : "ignore", e.rotate = "true", e.type = "frame", e.src = s, t.appendChild(e)) : (t = this.createRect("image", t, e, i, n)).src = s, l && r ? t.style.rotation = "180" : l ? t.style.flip = "x" : r && (t.style.flip = "y"), (1 > this.state.alpha || 1 > this.state.fillAlpha) && (t.style.filter += "alpha(opacity=" + this.state.alpha * this.state.fillAlpha * 100 + ")"), this.root.appendChild(t);
}, mxVmlCanvas2D.prototype.createDiv = function (t, e, i, n) {
  i = this.createElement("div");
  var s = this.state,
      o = "";
  return null != s.fontBackgroundColor && (o += "background-color:" + s.fontBackgroundColor + ";"), null != s.fontBorderColor && (o += "border:1px solid " + s.fontBorderColor + ";"), mxUtils.isNode(t) ? i.appendChild(t) : "fill" != n && "width" != n ? ((n = this.createElement("div")).style.cssText = o, n.style.display = mxClient.IS_QUIRKS ? "inline" : "inline-block", n.style.zoom = "1", n.style.textDecoration = "inherit", n.innerHTML = t, i.appendChild(n)) : (i.style.cssText = o, i.innerHTML = t), (t = i.style).fontSize = s.fontSize / this.vmlScale + "px", t.fontFamily = s.fontFamily, t.color = s.fontColor, t.verticalAlign = "top", t.textAlign = e || "left", t.lineHeight = mxConstants.ABSOLUTE_LINE_HEIGHT ? s.fontSize * mxConstants.LINE_HEIGHT / this.vmlScale + "px" : mxConstants.LINE_HEIGHT, (s.fontStyle & mxConstants.FONT_BOLD) == mxConstants.FONT_BOLD && (t.fontWeight = "bold"), (s.fontStyle & mxConstants.FONT_ITALIC) == mxConstants.FONT_ITALIC && (t.fontStyle = "italic"), (s.fontStyle & mxConstants.FONT_UNDERLINE) == mxConstants.FONT_UNDERLINE && (t.textDecoration = "underline"), i;
}, mxVmlCanvas2D.prototype.text = function (t, e, i, n, s, o, l, r, a, h, u, d, p) {
  if (this.textEnabled && null != s) {
    var c = this.state;

    if ("html" == a) {
      null != c.rotation && (t = (e = this.rotatePoint(t, e, c.rotation, c.rotationCx, c.rotationCy)).x, e = e.y), 8 != document.documentMode || mxClient.IS_EM ? (t *= c.scale, e *= c.scale) : (t += c.dx, e += c.dy, "fill" != h && l == mxConstants.ALIGN_TOP && --e), (a = 8 != document.documentMode || mxClient.IS_EM ? this.createElement("div") : this.createVmlElement("group")).style.position = "absolute", a.style.display = "inline", a.style.left = this.format(t) + "px", a.style.top = this.format(e) + "px", a.style.zoom = c.scale;
      var m = this.createElement("div");
      m.style.position = "relative", m.style.display = "inline";
      var g = (x = mxUtils.getAlignmentAsPoint(o, l)).x,
          x = x.y;

      if (s = this.createDiv(s, o, l, h), o = this.createElement("div"), null != p && s.setAttribute("dir", p), r && 0 < i) {
        if (u || (s.style.width = Math.round(i) + "px"), s.style.wordWrap = mxConstants.WORD_WRAP, s.style.whiteSpace = "normal", "break-word" == s.style.wordWrap) {
          var y = s;
          null != y.firstChild && "DIV" == y.firstChild.nodeName && (y.firstChild.style.width = "100%");
        }
      } else s.style.whiteSpace = "nowrap";

      if (d = c.rotation + (d || 0), this.rotateHtml && 0 != d ? (o.style.display = "inline", o.style.zoom = "1", o.appendChild(s), 8 != document.documentMode || mxClient.IS_EM || "DIV" == this.root.nodeName ? a.appendChild(o) : (m.appendChild(o), a.appendChild(m))) : 8 != document.documentMode || mxClient.IS_EM ? (s.style.display = "inline", a.appendChild(s)) : (m.appendChild(s), a.appendChild(m)), "DIV" != this.root.nodeName ? ((p = this.createVmlElement("rect")).stroked = "false", p.filled = "false", p.appendChild(a), this.root.appendChild(p)) : this.root.appendChild(a), u ? (s.style.overflow = "hidden", s.style.width = Math.round(i) + "px", mxClient.IS_QUIRKS || (s.style.maxHeight = Math.round(n) + "px")) : "fill" == h ? (s.style.overflow = "hidden", s.style.width = Math.max(0, i) + 1 + "px", s.style.height = Math.max(0, n) + 1 + "px") : "width" == h && (s.style.overflow = "hidden", s.style.width = Math.max(0, i) + 1 + "px", s.style.maxHeight = Math.max(0, n) + 1 + "px"), this.rotateHtml && 0 != d) {
        y = Math.PI / 180 * d, d = parseFloat(parseFloat(Math.cos(y)).toFixed(8)), p = parseFloat(parseFloat(Math.sin(-y)).toFixed(8)), 0 > (y %= 2 * Math.PI) && (y += 2 * Math.PI), (y %= Math.PI) > Math.PI / 2 && (y = Math.PI - y), l = Math.cos(y);
        var f = Math.sin(y);
        8 != document.documentMode || mxClient.IS_EM || (s.style.display = "inline-block", o.style.display = "inline-block", m.style.display = "inline-block"), s.style.visibility = "hidden", s.style.position = "absolute", document.body.appendChild(s), null != (m = s).firstChild && "DIV" == m.firstChild.nodeName && (m = m.firstChild), y = m.offsetWidth + 3, m = m.offsetHeight, u ? (i = Math.min(i, y), m = Math.min(m, n)) : i = y, r && (s.style.width = i + "px"), mxClient.IS_QUIRKS && (u || "width" == h) && m > n && (m = n, s.style.height = m + "px"), u = ((n = m) - n * l + i * -f) / 2 - p * i * (g + .5) + d * n * (x + .5), r = (i - i * l + n * -f) / 2 + d * i * (g + .5) + p * n * (x + .5), "group" == a.nodeName && "DIV" == this.root.nodeName ? ((h = this.createElement("div")).style.display = "inline-block", h.style.position = "absolute", h.style.left = this.format(t + (r - i / 2) * c.scale) + "px", h.style.top = this.format(e + (u - n / 2) * c.scale) + "px", a.parentNode.appendChild(h), h.appendChild(a)) : (c = 8 != document.documentMode || mxClient.IS_EM ? c.scale : 1, a.style.left = this.format(t + (r - i / 2) * c) + "px", a.style.top = this.format(e + (u - n / 2) * c) + "px"), o.style.filter = "progid:DXImageTransform.Microsoft.Matrix(M11=" + d + ", M12=" + p + ", M21=" + -p + ", M22=" + d + ", sizingMethod='auto expand')", o.style.backgroundColor = this.rotatedHtmlBackground, 1 > this.state.alpha && (o.style.filter += "alpha(opacity=" + 100 * this.state.alpha + ")"), o.appendChild(s), s.style.position = "", s.style.visibility = "";
      } else 8 != document.documentMode || mxClient.IS_EM ? (s.style.verticalAlign = "top", 1 > this.state.alpha && (a.style.filter = "alpha(opacity=" + 100 * this.state.alpha + ")"), c = s.parentNode, s.style.visibility = "hidden", document.body.appendChild(s), i = s.offsetWidth, m = s.offsetHeight, mxClient.IS_QUIRKS && u && m > n && (m = n, s.style.height = m + "px"), n = m, s.style.visibility = "", c.appendChild(s), a.style.left = this.format(t + i * g * this.state.scale) + "px", a.style.top = this.format(e + n * x * this.state.scale) + "px") : (1 > this.state.alpha && (s.style.filter = "alpha(opacity=" + 100 * this.state.alpha + ")"), m.style.left = 100 * g + "%", m.style.top = 100 * x + "%");
    } else this.plainText(t, e, i, n, mxUtils.htmlEntities(s, !1), o, l, r, a, h, u, d, p);
  }
}, mxVmlCanvas2D.prototype.plainText = function (t, e, i, n, s, o, l, r, a, h, u, d, p) {
  t = (t + (r = this.state).dx) * r.scale, e = (e + r.dy) * r.scale, (i = this.createVmlElement("shape")).style.width = "1px", i.style.height = "1px", i.stroked = "false", (n = this.createVmlElement("fill")).color = r.fontColor, n.opacity = 100 * r.alpha + "%", i.appendChild(n), (n = this.createVmlElement("path")).textpathok = "true", n.v = "m " + this.format(0) + " " + this.format(0) + " l " + this.format(1) + " " + this.format(0), i.appendChild(n), (n = this.createVmlElement("textpath")).style.cssText = "v-text-align:" + o, n.style.align = o, n.style.fontFamily = r.fontFamily, n.string = s, n.on = "true", o = r.fontSize * r.scale / this.vmlScale, n.style.fontSize = o + "px", (r.fontStyle & mxConstants.FONT_BOLD) == mxConstants.FONT_BOLD && (n.style.fontWeight = "bold"), (r.fontStyle & mxConstants.FONT_ITALIC) == mxConstants.FONT_ITALIC && (n.style.fontStyle = "italic"), (r.fontStyle & mxConstants.FONT_UNDERLINE) == mxConstants.FONT_UNDERLINE && (n.style.textDecoration = "underline"), r = o + ((s = s.split("\n")).length - 1) * o * mxConstants.LINE_HEIGHT, o = s = 0, l == mxConstants.ALIGN_BOTTOM ? o = -r / 2 : l != mxConstants.ALIGN_MIDDLE && (o = r / 2), null != d && (i.style.rotation = d, l = Math.PI / 180 * d, s = Math.sin(l) * o, o *= Math.cos(l)), i.appendChild(n), i.style.left = this.format(t - s) + "px", i.style.top = this.format(e + o) + "px", this.root.appendChild(i);
}, mxVmlCanvas2D.prototype.stroke = function () {
  this.addNode(!1, !0);
}, mxVmlCanvas2D.prototype.fill = function () {
  this.addNode(!0, !1);
}, mxVmlCanvas2D.prototype.fillAndStroke = function () {
  this.addNode(!0, !0);
}, mxGuide.prototype.graph = null, mxGuide.prototype.states = null, mxGuide.prototype.horizontal = !0, mxGuide.prototype.vertical = !0, mxGuide.prototype.guideX = null, mxGuide.prototype.guideY = null, mxGuide.prototype.setStates = function (t) {
  this.states = t;
}, mxGuide.prototype.isEnabledForEvent = function (t) {
  return !0;
}, mxGuide.prototype.getGuideTolerance = function () {
  return this.graph.gridSize / 2;
}, mxGuide.prototype.createGuideShape = function (t) {
  return (t = new mxPolyline([], mxConstants.GUIDE_COLOR, mxConstants.GUIDE_STROKEWIDTH)).isDashed = !0, t;
}, mxGuide.prototype.move = function (t, e, i, n) {
  if (null != this.states && (this.horizontal || this.vertical) && null != t && null != e) {
    var s = function s(e) {
      e += this.graph.panDy;
      var i = !1;
      Math.abs(e - L) < y ? (h = e - t.getCenterY(), y = Math.abs(e - L), i = !0) : Math.abs(e - T) < y ? (h = e - t.y, y = Math.abs(e - T), i = !0) : Math.abs(e - A) < y && (h = e - t.y - t.height, y = Math.abs(e - A), i = !0), i && (m = M, g = Math.round(e - this.graph.panDy), null == this.guideY && (this.guideY = this.createGuideShape(!1), this.guideY.dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_VML : mxConstants.DIALECT_SVG, this.guideY.pointerEvents = !1, this.guideY.init(this.graph.getView().getOverlayPane()))), c = c || i;
    },
        o = function o(e, i) {
      e += this.graph.panDx;
      var n = !1;
      Math.abs(e - w) < x ? (a = e - t.getCenterX(), x = Math.abs(e - w), n = !0) : Math.abs(e - S) < x ? (a = e - t.x, x = Math.abs(e - S), n = !0) : Math.abs(e - b) < x && (a = e - t.x - t.width, x = Math.abs(e - b), n = !0), n && (d = i, p = Math.round(e - this.graph.panDx), null == this.guideX && (this.guideX = this.createGuideShape(!0), this.guideX.dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_VML : mxConstants.DIALECT_SVG, this.guideX.pointerEvents = !1, this.guideX.init(this.graph.getView().getOverlayPane()))), u = u || n;
    },
        l = this.graph.getView().translate;

    n = this.graph.getView().scale;
    var r,
        a = e.x,
        h = e.y,
        u = !1,
        d = null,
        p = null,
        c = !1,
        m = null,
        g = null,
        x = r = this.getGuideTolerance(),
        y = r;
    (r = t.clone()).x += e.x, r.y += e.y;
    var f,
        v,
        C,
        E,
        S = r.x,
        b = r.x + r.width,
        w = r.getCenterX(),
        T = r.y,
        A = r.y + r.height,
        L = r.getCenterY();

    for (e = 0; e < this.states.length; e++) {
      var M = this.states[e];
      null != M && (this.horizontal && (o.call(this, M.getCenterX(), M), o.call(this, M.x, M), o.call(this, M.x + M.width, M)), this.vertical && (s.call(this, M.getCenterY(), M), s.call(this, M.y, M), s.call(this, M.y + M.height, M)));
    }

    i && (u || (i = t.x - (this.graph.snap(t.x / n - l.x) + l.x) * n, a = this.graph.snap(a / n) * n - i), c || (i = t.y - (this.graph.snap(t.y / n - l.y) + l.y) * n, h = this.graph.snap(h / n) * n - i)), n = this.graph.container, u || null == this.guideX ? null != this.guideX && (null != d && null != t && (v = Math.min(t.y + h - this.graph.panDy, d.y), E = Math.max(t.y + t.height + h - this.graph.panDy, d.y + d.height)), this.guideX.points = null != v && null != E ? [new mxPoint(p, v), new mxPoint(p, E)] : [new mxPoint(p, -this.graph.panDy), new mxPoint(p, n.scrollHeight - 3 - this.graph.panDy)], this.guideX.stroke = this.getGuideColor(d, !0), this.guideX.node.style.visibility = "visible", this.guideX.redraw()) : this.guideX.node.style.visibility = "hidden", c || null == this.guideY ? null != this.guideY && (null != m && null != t && (f = Math.min(t.x + a - this.graph.panDx, m.x), C = Math.max(t.x + t.width + a - this.graph.panDx, m.x + m.width)), this.guideY.points = null != f && null != C ? [new mxPoint(f, g), new mxPoint(C, g)] : [new mxPoint(-this.graph.panDx, g), new mxPoint(n.scrollWidth - 3 - this.graph.panDx, g)], this.guideY.stroke = this.getGuideColor(m, !1), this.guideY.node.style.visibility = "visible", this.guideY.redraw()) : this.guideY.node.style.visibility = "hidden", e = new mxPoint(a, h);
  }

  return e;
}, mxGuide.prototype.getGuideColor = function (t, e) {
  return mxConstants.GUIDE_COLOR;
}, mxGuide.prototype.hide = function () {
  this.setVisible(!1);
}, mxGuide.prototype.setVisible = function (t) {
  null != this.guideX && (this.guideX.node.style.visibility = t ? "visible" : "hidden"), null != this.guideY && (this.guideY.node.style.visibility = t ? "visible" : "hidden");
}, mxGuide.prototype.destroy = function () {
  null != this.guideX && (this.guideX.destroy(), this.guideX = null), null != this.guideY && (this.guideY.destroy(), this.guideY = null);
}, mxStencil.defaultLocalized = !1, mxStencil.allowEval = !1, mxStencil.prototype.desc = null, mxStencil.prototype.constraints = null, mxStencil.prototype.aspect = null, mxStencil.prototype.w0 = null, mxStencil.prototype.h0 = null, mxStencil.prototype.bgNode = null, mxStencil.prototype.fgNode = null, mxStencil.prototype.strokewidth = null, mxStencil.prototype.parseDescription = function () {
  this.fgNode = this.desc.getElementsByTagName("foreground")[0], this.bgNode = this.desc.getElementsByTagName("background")[0], this.w0 = Number(this.desc.getAttribute("w") || 100), this.h0 = Number(this.desc.getAttribute("h") || 100);
  var t = this.desc.getAttribute("aspect");
  this.aspect = null != t ? t : "variable", t = this.desc.getAttribute("strokewidth"), this.strokewidth = null != t ? t : "1";
}, mxStencil.prototype.parseConstraints = function () {
  var t = this.desc.getElementsByTagName("connections")[0];

  if (null != t && null != (t = mxUtils.getChildNodes(t)) && 0 < t.length) {
    this.constraints = [];

    for (var e = 0; e < t.length; e++) {
      this.constraints.push(this.parseConstraint(t[e]));
    }
  }
}, mxStencil.prototype.parseConstraint = function (t) {
  var e = Number(t.getAttribute("x")),
      i = Number(t.getAttribute("y")),
      n = "1" == t.getAttribute("perimeter");
  return t = t.getAttribute("name"), new mxConnectionConstraint(new mxPoint(e, i), n, t);
}, mxStencil.prototype.evaluateTextAttribute = function (t, e, i) {
  return e = this.evaluateAttribute(t, e, i), t = t.getAttribute("localized"), (mxStencil.defaultLocalized && null == t || "1" == t) && (e = mxResources.get(e)), e;
}, mxStencil.prototype.evaluateAttribute = function (t, e, i) {
  return null == (e = t.getAttribute(e)) && null != (t = mxUtils.getTextContent(t)) && mxStencil.allowEval && "function" == typeof (t = mxUtils.eval(t)) && (e = t(i)), e;
}, mxStencil.prototype.drawShape = function (t, e, i, n, s, o) {
  var l = mxUtils.getValue(e.style, mxConstants.STYLE_DIRECTION, null),
      r = (l = this.computeAspect(e.style, i, n, s, o, l), Math.min(l.width, l.height));
  r = "inherit" == this.strokewidth ? Number(mxUtils.getNumber(e.style, mxConstants.STYLE_STROKEWIDTH, 1)) : Number(this.strokewidth) * r;
  t.setStrokeWidth(r), this.drawChildren(t, e, i, n, s, o, this.bgNode, l, !1, !0), this.drawChildren(t, e, i, n, s, o, this.fgNode, l, !0, !e.outline || null == e.style || 0 == mxUtils.getValue(e.style, mxConstants.STYLE_BACKGROUND_OUTLINE, 0));
}, mxStencil.prototype.drawChildren = function (t, e, i, n, s, o, l, r, a, h) {
  if (null != l && 0 < s && 0 < o) for (i = l.firstChild; null != i;) {
    i.nodeType == mxConstants.NODETYPE_ELEMENT && this.drawNode(t, e, i, r, a, h), i = i.nextSibling;
  }
}, mxStencil.prototype.computeAspect = function (t, e, i, n, s, o) {
  t = e, e = n / this.w0;
  var l = s / this.h0;

  if (o = o == mxConstants.DIRECTION_NORTH || o == mxConstants.DIRECTION_SOUTH) {
    l = n / this.h0, e = s / this.w0;
    var r = (n - s) / 2;
    t += r, i -= r;
  }

  return "fixed" == this.aspect && (e = l = Math.min(e, l), o ? (t += (s - this.w0 * e) / 2, i += (n - this.h0 * l) / 2) : (t += (n - this.w0 * e) / 2, i += (s - this.h0 * l) / 2)), new mxRectangle(t, i, e, l);
}, mxStencil.prototype.drawNode = function (t, e, i, n, s, o) {
  var l = i.nodeName,
      r = n.x,
      a = n.y,
      h = n.width,
      u = n.height,
      d = Math.min(h, u);
  if ("save" == l) t.save();else if ("restore" == l) t.restore();else if (o) {
    if ("path" == l) for (t.begin(), i = i.firstChild; null != i;) {
      i.nodeType == mxConstants.NODETYPE_ELEMENT && this.drawNode(t, e, i, n, s, o), i = i.nextSibling;
    } else if ("close" == l) t.close();else if ("move" == l) t.moveTo(r + Number(i.getAttribute("x")) * h, a + Number(i.getAttribute("y")) * u);else if ("line" == l) t.lineTo(r + Number(i.getAttribute("x")) * h, a + Number(i.getAttribute("y")) * u);else if ("quad" == l) t.quadTo(r + Number(i.getAttribute("x1")) * h, a + Number(i.getAttribute("y1")) * u, r + Number(i.getAttribute("x2")) * h, a + Number(i.getAttribute("y2")) * u);else if ("curve" == l) t.curveTo(r + Number(i.getAttribute("x1")) * h, a + Number(i.getAttribute("y1")) * u, r + Number(i.getAttribute("x2")) * h, a + Number(i.getAttribute("y2")) * u, r + Number(i.getAttribute("x3")) * h, a + Number(i.getAttribute("y3")) * u);else if ("arc" == l) t.arcTo(Number(i.getAttribute("rx")) * h, Number(i.getAttribute("ry")) * u, Number(i.getAttribute("x-axis-rotation")), Number(i.getAttribute("large-arc-flag")), Number(i.getAttribute("sweep-flag")), r + Number(i.getAttribute("x")) * h, a + Number(i.getAttribute("y")) * u);else if ("rect" == l) t.rect(r + Number(i.getAttribute("x")) * h, a + Number(i.getAttribute("y")) * u, Number(i.getAttribute("w")) * h, Number(i.getAttribute("h")) * u);else if ("roundrect" == l) 0 == (e = Number(i.getAttribute("arcsize"))) && (e = 100 * mxConstants.RECTANGLE_ROUNDING_FACTOR), d = Number(i.getAttribute("w")) * h, n = Number(i.getAttribute("h")) * u, e = Number(e) / 100, e = Math.min(d * e, n * e), t.roundrect(r + Number(i.getAttribute("x")) * h, a + Number(i.getAttribute("y")) * u, d, n, e, e);else if ("ellipse" == l) t.ellipse(r + Number(i.getAttribute("x")) * h, a + Number(i.getAttribute("y")) * u, Number(i.getAttribute("w")) * h, Number(i.getAttribute("h")) * u);else if ("image" == l) e.outline || (e = this.evaluateAttribute(i, "src", e), t.image(r + Number(i.getAttribute("x")) * h, a + Number(i.getAttribute("y")) * u, Number(i.getAttribute("w")) * h, Number(i.getAttribute("h")) * u, e, !1, "1" == i.getAttribute("flipH"), "1" == i.getAttribute("flipV")));else if ("text" == l) {
      if (!e.outline) {
        if (d = this.evaluateTextAttribute(i, "str", e), n = "1" == i.getAttribute("vertical") ? -90 : 0, "0" == i.getAttribute("align-shape")) {
          o = e.rotation;
          var p = 1 == mxUtils.getValue(e.style, mxConstants.STYLE_FLIPH, 0);
          e = 1 == mxUtils.getValue(e.style, mxConstants.STYLE_FLIPV, 0), n = p && e ? n - o : p || e ? n + o : n - o;
        }

        n -= i.getAttribute("rotation"), t.text(r + Number(i.getAttribute("x")) * h, a + Number(i.getAttribute("y")) * u, 0, 0, d, i.getAttribute("align") || "left", i.getAttribute("valign") || "top", !1, "", null, !1, n);
      }
    } else if ("include-shape" == l) null != (o = mxStencilRegistry.getStencil(i.getAttribute("name"))) && (r += Number(i.getAttribute("x")) * h, a += Number(i.getAttribute("y")) * u, d = Number(i.getAttribute("w")) * h, n = Number(i.getAttribute("h")) * u, o.drawShape(t, e, r, a, d, n));else if ("fillstroke" == l) t.fillAndStroke();else if ("fill" == l) t.fill();else if ("stroke" == l) t.stroke();else if ("strokewidth" == l) h = "1" == i.getAttribute("fixed") ? 1 : d, t.setStrokeWidth(Number(i.getAttribute("width")) * h);else if ("dashed" == l) t.setDashed("1" == i.getAttribute("dashed"));else if ("dashpattern" == l) {
      if (null != (i = i.getAttribute("pattern"))) {
        for (i = i.split(" "), h = [], u = 0; u < i.length; u++) {
          0 < i[u].length && h.push(Number(i[u]) * d);
        }

        i = h.join(" "), t.setDashPattern(i);
      }
    } else "strokecolor" == l ? t.setStrokeColor(i.getAttribute("color")) : "linecap" == l ? t.setLineCap(i.getAttribute("cap")) : "linejoin" == l ? t.setLineJoin(i.getAttribute("join")) : "miterlimit" == l ? t.setMiterLimit(Number(i.getAttribute("limit"))) : "fillcolor" == l ? t.setFillColor(i.getAttribute("color")) : "alpha" == l ? t.setAlpha(i.getAttribute("alpha")) : "fontcolor" == l ? t.setFontColor(i.getAttribute("color")) : "fontstyle" == l ? t.setFontStyle(i.getAttribute("style")) : "fontfamily" == l ? t.setFontFamily(i.getAttribute("family")) : "fontsize" == l && t.setFontSize(Number(i.getAttribute("size")) * d);
    !s || "fillstroke" != l && "fill" != l && "stroke" != l || t.setShadow(!1);
  }
}, mxShape.prototype.dialect = null, mxShape.prototype.scale = 1, mxShape.prototype.antiAlias = !0, mxShape.prototype.minSvgStrokeWidth = 1, mxShape.prototype.bounds = null, mxShape.prototype.points = null, mxShape.prototype.node = null, mxShape.prototype.state = null, mxShape.prototype.style = null, mxShape.prototype.boundingBox = null, mxShape.prototype.stencil = null, mxShape.prototype.svgStrokeTolerance = 8, mxShape.prototype.pointerEvents = !0, mxShape.prototype.svgPointerEvents = "all", mxShape.prototype.shapePointerEvents = !1, mxShape.prototype.stencilPointerEvents = !1, mxShape.prototype.vmlScale = 1, mxShape.prototype.outline = !1, mxShape.prototype.visible = !0, mxShape.prototype.useSvgBoundingBox = !1, mxShape.prototype.init = function (t) {
  null == this.node && (this.node = this.create(t), null != t && t.appendChild(this.node));
}, mxShape.prototype.initStyles = function (t) {
  this.strokewidth = 1, this.rotation = 0, this.strokeOpacity = this.fillOpacity = this.opacity = 100, this.flipV = this.flipH = !1;
}, mxShape.prototype.isParseVml = function () {
  return !0;
}, mxShape.prototype.isHtmlAllowed = function () {
  return !1;
}, mxShape.prototype.getSvgScreenOffset = function () {
  return 1 == mxUtils.mod(Math.max(1, Math.round((this.stencil && "inherit" != this.stencil.strokewidth ? Number(this.stencil.strokewidth) : this.strokewidth) * this.scale)), 2) ? .5 : 0;
}, mxShape.prototype.create = function (t) {
  return null != t && null != t.ownerSVGElement ? this.createSvg(t) : 8 == document.documentMode || !mxClient.IS_VML || this.dialect != mxConstants.DIALECT_VML && this.isHtmlAllowed() ? this.createHtml(t) : this.createVml(t);
}, mxShape.prototype.createSvg = function () {
  return document.createElementNS(mxConstants.NS_SVG, "g");
}, mxShape.prototype.createVml = function () {
  var t = document.createElement(mxClient.VML_PREFIX + ":group");
  return t.style.position = "absolute", t;
}, mxShape.prototype.createHtml = function () {
  var t = document.createElement("div");
  return t.style.position = "absolute", t;
}, mxShape.prototype.reconfigure = function () {
  this.redraw();
}, mxShape.prototype.redraw = function () {
  this.updateBoundsFromPoints(), this.visible && this.checkBounds() ? (this.node.style.visibility = "visible", this.clear(), "DIV" != this.node.nodeName || !this.isHtmlAllowed() && mxClient.IS_VML ? this.redrawShape() : this.redrawHtmlShape(), this.updateBoundingBox()) : (this.node.style.visibility = "hidden", this.boundingBox = null);
}, mxShape.prototype.clear = function () {
  if (null != this.node.ownerSVGElement) for (; null != this.node.lastChild;) {
    this.node.removeChild(this.node.lastChild);
  } else this.node.style.cssText = "position:absolute;" + (null != this.cursor ? "cursor:" + this.cursor + ";" : ""), this.node.innerHTML = "";
}, mxShape.prototype.updateBoundsFromPoints = function () {
  var t = this.points;

  if (null != t && 0 < t.length && null != t[0]) {
    this.bounds = new mxRectangle(Number(t[0].x), Number(t[0].y), 1, 1);

    for (var e = 1; e < this.points.length; e++) {
      null != t[e] && this.bounds.add(new mxRectangle(Number(t[e].x), Number(t[e].y), 1, 1));
    }
  }
}, mxShape.prototype.getLabelBounds = function (t) {
  var e = mxUtils.getValue(this.style, mxConstants.STYLE_DIRECTION, mxConstants.DIRECTION_EAST),
      i = t;

  if (e != mxConstants.DIRECTION_SOUTH && e != mxConstants.DIRECTION_NORTH && null != this.state && null != this.state.text && this.state.text.isPaintBoundsInverted() && (e = (i = i.clone()).width, i.width = i.height, i.height = e), null != (i = this.getLabelMargins(i))) {
    var n = "1" == mxUtils.getValue(this.style, mxConstants.STYLE_FLIPH, !1),
        s = "1" == mxUtils.getValue(this.style, mxConstants.STYLE_FLIPV, !1);
    return null != this.state && null != this.state.text && this.state.text.isPaintBoundsInverted() && (e = i.x, i.x = i.height, i.height = i.width, i.width = i.y, i.y = e, e = n, n = s, s = e), mxUtils.getDirectedBounds(t, i, this.style, n, s);
  }

  return t;
}, mxShape.prototype.getLabelMargins = function (t) {
  return null;
}, mxShape.prototype.checkBounds = function () {
  return !isNaN(this.scale) && isFinite(this.scale) && 0 < this.scale && null != this.bounds && !isNaN(this.bounds.x) && !isNaN(this.bounds.y) && !isNaN(this.bounds.width) && !isNaN(this.bounds.height) && 0 < this.bounds.width && 0 < this.bounds.height;
}, mxShape.prototype.createVmlGroup = function () {
  var t = document.createElement(mxClient.VML_PREFIX + ":group");
  return t.style.position = "absolute", t.style.width = this.node.style.width, t.style.height = this.node.style.height, t;
}, mxShape.prototype.redrawShape = function () {
  var t = this.createCanvas();
  null != t && (t.pointerEvents = this.pointerEvents, this.paint(t), this.node != t.root && this.node.insertAdjacentHTML("beforeend", t.root.outerHTML), "DIV" == this.node.nodeName && 8 == document.documentMode && (this.node.style.filter = "", mxUtils.addTransparentBackgroundFilter(this.node)), this.destroyCanvas(t));
}, mxShape.prototype.createCanvas = function () {
  var t = null;
  return null != this.node.ownerSVGElement ? t = this.createSvgCanvas() : mxClient.IS_VML && (this.updateVmlContainer(), t = this.createVmlCanvas()), null != t && this.outline && (t.setStrokeWidth(this.strokewidth), t.setStrokeColor(this.stroke), null != this.isDashed && t.setDashed(this.isDashed), t.setStrokeWidth = function () {}, t.setStrokeColor = function () {}, t.setFillColor = function () {}, t.setGradient = function () {}, t.setDashed = function () {}, t.text = function () {}), t;
}, mxShape.prototype.createSvgCanvas = function () {
  var t = new mxSvgCanvas2D(this.node, !1);
  t.strokeTolerance = this.pointerEvents ? this.svgStrokeTolerance : 0, t.pointerEventsValue = this.svgPointerEvents, t.blockImagePointerEvents = mxClient.IS_FF;
  var e = this.getSvgScreenOffset();
  return 0 != e ? this.node.setAttribute("transform", "translate(" + e + "," + e + ")") : this.node.removeAttribute("transform"), t.minStrokeWidth = this.minSvgStrokeWidth, this.antiAlias || (t.format = function (t) {
    return Math.round(parseFloat(t));
  }), t;
}, mxShape.prototype.createVmlCanvas = function () {
  var t = 8 == document.documentMode && this.isParseVml() ? this.createVmlGroup() : this.node,
      e = new mxVmlCanvas2D(t, !1);
  return "" != t.tagUrn && (t.coordsize = Math.max(1, Math.round(this.bounds.width)) * this.vmlScale + "," + Math.max(1, Math.round(this.bounds.height)) * this.vmlScale, e.scale(this.vmlScale), e.vmlScale = this.vmlScale), t = this.scale, e.translate(-Math.round(this.bounds.x / t), -Math.round(this.bounds.y / t)), e;
}, mxShape.prototype.updateVmlContainer = function () {
  this.node.style.left = Math.round(this.bounds.x) + "px", this.node.style.top = Math.round(this.bounds.y) + "px";
  var t = Math.max(1, Math.round(this.bounds.height));
  this.node.style.width = Math.max(1, Math.round(this.bounds.width)) + "px", this.node.style.height = t + "px", this.node.style.overflow = "visible";
}, mxShape.prototype.redrawHtmlShape = function () {
  this.updateHtmlBounds(this.node), this.updateHtmlFilters(this.node), this.updateHtmlColors(this.node);
}, mxShape.prototype.updateHtmlFilters = function (t) {
  var e = "";

  if (100 > this.opacity && (e += "alpha(opacity=" + this.opacity + ")"), this.isShadow && (e += "progid:DXImageTransform.Microsoft.dropShadow (OffX='" + Math.round(mxConstants.SHADOW_OFFSET_X * this.scale) + "', OffY='" + Math.round(mxConstants.SHADOW_OFFSET_Y * this.scale) + "', Color='" + mxConstants.VML_SHADOWCOLOR + "')"), null != this.fill && this.fill != mxConstants.NONE && this.gradient && this.gradient != mxConstants.NONE) {
    var i = this.fill,
        n = this.gradient,
        s = "0",
        o = {
      east: 0,
      south: 1,
      west: 2,
      north: 3
    },
        l = null != this.direction ? o[this.direction] : 0;
    null != this.gradientDirection && (l = mxUtils.mod(l + o[this.gradientDirection] - 1, 4)), 1 == l ? (s = "1", o = i, i = n, n = o) : 2 == l ? (o = i, i = n, n = o) : 3 == l && (s = "1"), e += "progid:DXImageTransform.Microsoft.gradient(startColorStr='" + i + "', endColorStr='" + n + "', gradientType='" + s + "')";
  }

  t.style.filter = e;
}, mxShape.prototype.updateHtmlColors = function (t) {
  var e = this.stroke;
  null != e && e != mxConstants.NONE ? (t.style.borderColor = e, this.isDashed ? t.style.borderStyle = "dashed" : 0 < this.strokewidth && (t.style.borderStyle = "solid"), t.style.borderWidth = Math.max(1, Math.ceil(this.strokewidth * this.scale)) + "px") : t.style.borderWidth = "0px", null != (e = this.outline ? null : this.fill) && e != mxConstants.NONE ? (t.style.backgroundColor = e, t.style.backgroundImage = "none") : this.pointerEvents ? t.style.backgroundColor = "transparent" : 8 == document.documentMode ? mxUtils.addTransparentBackgroundFilter(t) : this.setTransparentBackgroundImage(t);
}, mxShape.prototype.updateHtmlBounds = function (t) {
  var e = 9 <= document.documentMode ? 0 : Math.ceil(this.strokewidth * this.scale);
  t.style.borderWidth = Math.max(1, e) + "px", t.style.overflow = "hidden", t.style.left = Math.round(this.bounds.x - e / 2) + "px", t.style.top = Math.round(this.bounds.y - e / 2) + "px", "CSS1Compat" == document.compatMode && (e = -e), t.style.width = Math.round(Math.max(0, this.bounds.width + e)) + "px", t.style.height = Math.round(Math.max(0, this.bounds.height + e)) + "px";
}, mxShape.prototype.destroyCanvas = function (t) {
  if (t instanceof mxSvgCanvas2D) {
    for (var e in t.gradients) {
      var i = t.gradients[e];
      null != i && (i.mxRefCount = (i.mxRefCount || 0) + 1);
    }

    this.releaseSvgGradients(this.oldGradients), this.oldGradients = t.gradients;
  }
}, mxShape.prototype.paint = function (t) {
  var e = !1;

  if (null != t && this.outline) {
    var i = t.stroke;

    t.stroke = function () {
      e = !0, i.apply(this, arguments);
    };

    var n = t.fillAndStroke;

    t.fillAndStroke = function () {
      e = !0, n.apply(this, arguments);
    };
  }

  var s = this.scale,
      o = this.bounds.x / s,
      l = this.bounds.y / s,
      r = this.bounds.width / s,
      a = this.bounds.height / s;

  if (this.isPaintBoundsInverted()) {
    o = o + (h = (r - a) / 2), l = l - h;
    var h = r;
    r = a, a = h;
  }

  if (this.updateTransform(t, o, l, r, a), this.configureCanvas(t, o, l, r, a), h = null, null == this.stencil && null == this.points && this.shapePointerEvents || null != this.stencil && this.stencilPointerEvents) {
    var u = this.createBoundingBox();
    this.dialect == mxConstants.DIALECT_SVG ? (h = this.createTransparentSvgRectangle(u.x, u.y, u.width, u.height), this.node.appendChild(h)) : ((u = t.createRect("rect", u.x / s, u.y / s, u.width / s, u.height / s)).appendChild(t.createTransparentFill()), u.stroked = "false", t.root.appendChild(u));
  }

  if (null != this.stencil) this.stencil.drawShape(t, this, o, l, r, a);else if (t.setStrokeWidth(this.strokewidth), null != this.points) {
    u = [];

    for (var d = 0; d < this.points.length; d++) {
      null != this.points[d] && u.push(new mxPoint(this.points[d].x / s, this.points[d].y / s));
    }

    this.paintEdgeShape(t, u);
  } else this.paintVertexShape(t, o, l, r, a);
  null != h && null != t.state && null != t.state.transform && h.setAttribute("transform", t.state.transform), null != t && this.outline && !e && (t.rect(o, l, r, a), t.stroke());
}, mxShape.prototype.configureCanvas = function (t, e, i, n, s) {
  var o = null;
  null != this.style && (o = this.style.dashPattern), t.setAlpha(this.opacity / 100), t.setFillAlpha(this.fillOpacity / 100), t.setStrokeAlpha(this.strokeOpacity / 100), null != this.isShadow && t.setShadow(this.isShadow), null != this.isDashed && t.setDashed(this.isDashed, null != this.style && 1 == mxUtils.getValue(this.style, mxConstants.STYLE_FIX_DASH, !1)), null != o && t.setDashPattern(o), null != this.fill && this.fill != mxConstants.NONE && this.gradient && this.gradient != mxConstants.NONE ? (e = this.getGradientBounds(t, e, i, n, s), t.setGradient(this.fill, this.gradient, e.x, e.y, e.width, e.height, this.gradientDirection)) : t.setFillColor(this.fill), t.setStrokeColor(this.stroke);
}, mxShape.prototype.getGradientBounds = function (t, e, i, n, s) {
  return new mxRectangle(e, i, n, s);
}, mxShape.prototype.updateTransform = function (t, e, i, n, s) {
  t.scale(this.scale), t.rotate(this.getShapeRotation(), this.flipH, this.flipV, e + n / 2, i + s / 2);
}, mxShape.prototype.paintVertexShape = function (t, e, i, n, s) {
  this.paintBackground(t, e, i, n, s), this.outline && null != this.style && 0 != mxUtils.getValue(this.style, mxConstants.STYLE_BACKGROUND_OUTLINE, 0) || (t.setShadow(!1), this.paintForeground(t, e, i, n, s));
}, mxShape.prototype.paintBackground = function (t, e, i, n, s) {}, mxShape.prototype.paintForeground = function (t, e, i, n, s) {}, mxShape.prototype.paintEdgeShape = function (t, e) {}, mxShape.prototype.getArcSize = function (t, e) {
  var i;
  return "1" == mxUtils.getValue(this.style, mxConstants.STYLE_ABSOLUTE_ARCSIZE, 0) ? i = Math.min(t / 2, Math.min(e / 2, mxUtils.getValue(this.style, mxConstants.STYLE_ARCSIZE, mxConstants.LINE_ARCSIZE) / 2)) : (i = mxUtils.getValue(this.style, mxConstants.STYLE_ARCSIZE, 100 * mxConstants.RECTANGLE_ROUNDING_FACTOR) / 100, i = Math.min(t * i, e * i)), i;
}, mxShape.prototype.paintGlassEffect = function (t, e, i, n, s, o) {
  var l = Math.ceil(this.strokewidth / 2);
  t.setGradient("#ffffff", "#ffffff", e, i, n, .6 * s, "south", .9, .1), t.begin(), o += 2 * l, this.isRounded ? (t.moveTo(e - l + o, i - l), t.quadTo(e - l, i - l, e - l, i - l + o), t.lineTo(e - l, i + .4 * s), t.quadTo(e + .5 * n, i + .7 * s, e + n + l, i + .4 * s), t.lineTo(e + n + l, i - l + o), t.quadTo(e + n + l, i - l, e + n + l - o, i - l)) : (t.moveTo(e - l, i - l), t.lineTo(e - l, i + .4 * s), t.quadTo(e + .5 * n, i + .7 * s, e + n + l, i + .4 * s), t.lineTo(e + n + l, i - l)), t.close(), t.fill();
}, mxShape.prototype.addPoints = function (t, e, i, n, s, o, l) {
  if (null != e && 0 < e.length) {
    l = null == l || l;
    var r = e[e.length - 1];

    if (s && i) {
      var a = (e = e.slice())[0];
      a = new mxPoint(r.x + (a.x - r.x) / 2, r.y + (a.y - r.y) / 2);
      e.splice(0, 0, a);
    }

    var h = e[0];
    a = 1;

    for (l ? t.moveTo(h.x, h.y) : t.lineTo(h.x, h.y); a < (s ? e.length : e.length - 1);) {
      l = e[mxUtils.mod(a, e.length)];
      var u = h.x - l.x;
      h = h.y - l.y;

      if (i && (0 != u || 0 != h) && (null == o || 0 > mxUtils.indexOf(o, a - 1))) {
        var d = Math.sqrt(u * u + h * h);

        for (t.lineTo(l.x + u * Math.min(n, d / 2) / d, l.y + h * Math.min(n, d / 2) / d), h = e[mxUtils.mod(a + 1, e.length)]; a < e.length - 2 && 0 == Math.round(h.x - l.x) && 0 == Math.round(h.y - l.y);) {
          h = e[mxUtils.mod(a + 2, e.length)], a++;
        }

        u = h.x - l.x, h = h.y - l.y, d = Math.max(1, Math.sqrt(u * u + h * h)), u = l.x + u * Math.min(n, d / 2) / d, h = l.y + h * Math.min(n, d / 2) / d, t.quadTo(l.x, l.y, u, h), l = new mxPoint(u, h);
      } else t.lineTo(l.x, l.y);

      h = l, a++;
    }

    s ? t.close() : t.lineTo(r.x, r.y);
  }
}, mxShape.prototype.resetStyles = function () {
  this.initStyles(), this.spacing = 0, delete this.fill, delete this.gradient, delete this.gradientDirection, delete this.stroke, delete this.startSize, delete this.endSize, delete this.startArrow, delete this.endArrow, delete this.direction, delete this.isShadow, delete this.isDashed, delete this.isRounded, delete this.glass;
}, mxShape.prototype.apply = function (t) {
  this.state = t, this.style = t.style, null != this.style && (this.fill = mxUtils.getValue(this.style, mxConstants.STYLE_FILLCOLOR, this.fill), this.gradient = mxUtils.getValue(this.style, mxConstants.STYLE_GRADIENTCOLOR, this.gradient), this.gradientDirection = mxUtils.getValue(this.style, mxConstants.STYLE_GRADIENT_DIRECTION, this.gradientDirection), this.opacity = mxUtils.getValue(this.style, mxConstants.STYLE_OPACITY, this.opacity), this.fillOpacity = mxUtils.getValue(this.style, mxConstants.STYLE_FILL_OPACITY, this.fillOpacity), this.strokeOpacity = mxUtils.getValue(this.style, mxConstants.STYLE_STROKE_OPACITY, this.strokeOpacity), this.stroke = mxUtils.getValue(this.style, mxConstants.STYLE_STROKECOLOR, this.stroke), this.strokewidth = mxUtils.getNumber(this.style, mxConstants.STYLE_STROKEWIDTH, this.strokewidth), this.spacing = mxUtils.getValue(this.style, mxConstants.STYLE_SPACING, this.spacing), this.startSize = mxUtils.getNumber(this.style, mxConstants.STYLE_STARTSIZE, this.startSize), this.endSize = mxUtils.getNumber(this.style, mxConstants.STYLE_ENDSIZE, this.endSize), this.startArrow = mxUtils.getValue(this.style, mxConstants.STYLE_STARTARROW, this.startArrow), this.endArrow = mxUtils.getValue(this.style, mxConstants.STYLE_ENDARROW, this.endArrow), this.rotation = mxUtils.getValue(this.style, mxConstants.STYLE_ROTATION, this.rotation), this.direction = mxUtils.getValue(this.style, mxConstants.STYLE_DIRECTION, this.direction), this.flipH = 1 == mxUtils.getValue(this.style, mxConstants.STYLE_FLIPH, 0), this.flipV = 1 == mxUtils.getValue(this.style, mxConstants.STYLE_FLIPV, 0), null != this.stencil && (this.flipH = 1 == mxUtils.getValue(this.style, "stencilFlipH", 0) || this.flipH, this.flipV = 1 == mxUtils.getValue(this.style, "stencilFlipV", 0) || this.flipV), this.direction != mxConstants.DIRECTION_NORTH && this.direction != mxConstants.DIRECTION_SOUTH || (t = this.flipH, this.flipH = this.flipV, this.flipV = t), this.isShadow = 1 == mxUtils.getValue(this.style, mxConstants.STYLE_SHADOW, this.isShadow), this.isDashed = 1 == mxUtils.getValue(this.style, mxConstants.STYLE_DASHED, this.isDashed), this.isRounded = 1 == mxUtils.getValue(this.style, mxConstants.STYLE_ROUNDED, this.isRounded), this.glass = 1 == mxUtils.getValue(this.style, mxConstants.STYLE_GLASS, this.glass), this.fill == mxConstants.NONE && (this.fill = null), this.gradient == mxConstants.NONE && (this.gradient = null), this.stroke == mxConstants.NONE && (this.stroke = null));
}, mxShape.prototype.setCursor = function (t) {
  null == t && (t = ""), this.cursor = t, null != this.node && (this.node.style.cursor = t);
}, mxShape.prototype.getCursor = function () {
  return this.cursor;
}, mxShape.prototype.isRoundable = function () {
  return !1;
}, mxShape.prototype.updateBoundingBox = function () {
  if (this.useSvgBoundingBox && null != this.node && null != this.node.ownerSVGElement) try {
    var t = this.node.getBBox();
    if (0 < t.width && 0 < t.height) return this.boundingBox = new mxRectangle(t.x, t.y, t.width, t.height), void this.boundingBox.grow(this.strokewidth * this.scale / 2);
  } catch (t) {}

  if (null != this.bounds) {
    if (null != (t = this.createBoundingBox())) {
      this.augmentBoundingBox(t);
      var e = this.getShapeRotation();
      0 != e && (t = mxUtils.getBoundingBox(t, e));
    }

    this.boundingBox = t;
  }
}, mxShape.prototype.createBoundingBox = function () {
  var t = this.bounds.clone();
  return (null != this.stencil && (this.direction == mxConstants.DIRECTION_NORTH || this.direction == mxConstants.DIRECTION_SOUTH) || this.isPaintBoundsInverted()) && t.rotate90(), t;
}, mxShape.prototype.augmentBoundingBox = function (t) {
  this.isShadow && (t.width += Math.ceil(mxConstants.SHADOW_OFFSET_X * this.scale), t.height += Math.ceil(mxConstants.SHADOW_OFFSET_Y * this.scale)), t.grow(this.strokewidth * this.scale / 2);
}, mxShape.prototype.isPaintBoundsInverted = function () {
  return null == this.stencil && (this.direction == mxConstants.DIRECTION_NORTH || this.direction == mxConstants.DIRECTION_SOUTH);
}, mxShape.prototype.getRotation = function () {
  return null != this.rotation ? this.rotation : 0;
}, mxShape.prototype.getTextRotation = function () {
  var t = this.getRotation();
  return 1 != mxUtils.getValue(this.style, mxConstants.STYLE_HORIZONTAL, 1) && (t += mxText.prototype.verticalTextRotation), t;
}, mxShape.prototype.getShapeRotation = function () {
  var t = this.getRotation();
  return null != this.direction && (this.direction == mxConstants.DIRECTION_NORTH ? t += 270 : this.direction == mxConstants.DIRECTION_WEST ? t += 180 : this.direction == mxConstants.DIRECTION_SOUTH && (t += 90)), t;
}, mxShape.prototype.createTransparentSvgRectangle = function (t, e, i, n) {
  var s = document.createElementNS(mxConstants.NS_SVG, "rect");
  return s.setAttribute("x", t), s.setAttribute("y", e), s.setAttribute("width", i), s.setAttribute("height", n), s.setAttribute("fill", "none"), s.setAttribute("stroke", "none"), s.setAttribute("pointer-events", "all"), s;
}, mxShape.prototype.setTransparentBackgroundImage = function (t) {
  t.style.backgroundImage = "url('" + mxClient.imageBasePath + "/transparent.gif')";
}, mxShape.prototype.releaseSvgGradients = function (t) {
  if (null != t) for (var e in t) {
    var i = t[e];
    null != i && (i.mxRefCount = (i.mxRefCount || 0) - 1, 0 == i.mxRefCount && null != i.parentNode && i.parentNode.removeChild(i));
  }
}, mxShape.prototype.destroy = function () {
  null != this.node && (mxEvent.release(this.node), null != this.node.parentNode && this.node.parentNode.removeChild(this.node), this.node = null), this.releaseSvgGradients(this.oldGradients), this.oldGradients = null;
};
var mxStencilRegistry = {
  stencils: {},
  addStencil: function addStencil(t, e) {
    mxStencilRegistry.stencils[t] = e;
  },
  getStencil: function getStencil(t) {
    return mxStencilRegistry.stencils[t];
  }
},
    mxMarker = {
  markers: [],
  addMarker: function addMarker(t, e) {
    mxMarker.markers[t] = e;
  },
  createMarker: function createMarker(t, e, i, n, s, o, l, r, a, h) {
    var u = mxMarker.markers[i];
    return null != u ? u(t, e, i, n, s, o, l, r, a, h) : null;
  }
};

function mxActor(t, e, i, n) {
  mxShape.call(this), this.bounds = t, this.fill = e, this.stroke = i, this.strokewidth = null != n ? n : 1;
}

function mxCloud(t, e, i, n) {
  mxActor.call(this), this.bounds = t, this.fill = e, this.stroke = i, this.strokewidth = null != n ? n : 1;
}

function mxRectangleShape(t, e, i, n) {
  mxShape.call(this), this.bounds = t, this.fill = e, this.stroke = i, this.strokewidth = null != n ? n : 1;
}

function mxEllipse(t, e, i, n) {
  mxShape.call(this), this.bounds = t, this.fill = e, this.stroke = i, this.strokewidth = null != n ? n : 1;
}

function mxDoubleEllipse(t, e, i, n) {
  mxShape.call(this), this.bounds = t, this.fill = e, this.stroke = i, this.strokewidth = null != n ? n : 1;
}

function mxRhombus(t, e, i, n) {
  mxShape.call(this), this.bounds = t, this.fill = e, this.stroke = i, this.strokewidth = null != n ? n : 1;
}

function mxPolyline(t, e, i) {
  mxShape.call(this), this.points = t, this.stroke = e, this.strokewidth = null != i ? i : 1;
}

function mxArrow(t, e, i, n, s, o, l) {
  mxShape.call(this), this.points = t, this.fill = e, this.stroke = i, this.strokewidth = null != n ? n : 1, this.arrowWidth = null != s ? s : mxConstants.ARROW_WIDTH, this.spacing = null != o ? o : mxConstants.ARROW_SPACING, this.endSize = null != l ? l : mxConstants.ARROW_SIZE;
}

function mxArrowConnector(t, e, i, n, s, o, l) {
  mxShape.call(this), this.points = t, this.fill = e, this.stroke = i, this.strokewidth = null != n ? n : 1, this.arrowWidth = null != s ? s : mxConstants.ARROW_WIDTH, this.arrowSpacing = null != o ? o : mxConstants.ARROW_SPACING, this.startSize = mxConstants.ARROW_SIZE / 5, this.endSize = mxConstants.ARROW_SIZE / 5;
}

function mxText(t, e, i, n, s, o, l, r, a, h, u, d, p, c, m, g, x, y, f, v, C) {
  mxShape.call(this), this.value = t, this.bounds = e, this.color = null != s ? s : "black", this.align = null != i ? i : mxConstants.ALIGN_CENTER, this.valign = null != n ? n : mxConstants.ALIGN_MIDDLE, this.family = null != o ? o : mxConstants.DEFAULT_FONTFAMILY, this.size = null != l ? l : mxConstants.DEFAULT_FONTSIZE, this.fontStyle = null != r ? r : mxConstants.DEFAULT_FONTSTYLE, this.spacing = parseInt(a || 2), this.spacingTop = this.spacing + parseInt(h || 0), this.spacingRight = this.spacing + parseInt(u || 0), this.spacingBottom = this.spacing + parseInt(d || 0), this.spacingLeft = this.spacing + parseInt(p || 0), this.horizontal = null == c || c, this.background = m, this.border = g, this.wrap = null != x && x, this.clipped = null != y && y, this.overflow = null != f ? f : "visible", this.labelPadding = null != v ? v : 0, this.textDirection = C, this.rotation = 0, this.updateMargin();
}

function mxTriangle() {
  mxActor.call(this);
}

function mxHexagon() {
  mxActor.call(this);
}

function mxLine(t, e, i) {
  mxShape.call(this), this.bounds = t, this.stroke = e, this.strokewidth = null != i ? i : 1;
}

function mxImageShape(t, e, i, n, s) {
  mxShape.call(this), this.bounds = t, this.image = e, this.fill = i, this.stroke = n, this.strokewidth = null != s ? s : 1, this.shadow = !1;
}

function mxLabel(t, e, i, n) {
  mxRectangleShape.call(this, t, e, i, n);
}

function mxCylinder(t, e, i, n) {
  mxShape.call(this), this.bounds = t, this.fill = e, this.stroke = i, this.strokewidth = null != n ? n : 1;
}

function mxConnector(t, e, i) {
  mxPolyline.call(this, t, e, i);
}

function mxSwimlane(t, e, i, n) {
  mxShape.call(this), this.bounds = t, this.fill = e, this.stroke = i, this.strokewidth = null != n ? n : 1;
}

function mxGraphLayout(t) {
  this.graph = t;
}

function WeightedCellSorter(t, e) {
  this.cell = t, this.weightedValue = e;
}

function mxStackLayout(t, e, i, n, s, o) {
  mxGraphLayout.call(this, t), this.horizontal = null == e || e, this.spacing = null != i ? i : 0, this.x0 = null != n ? n : 0, this.y0 = null != s ? s : 0, this.border = null != o ? o : 0;
}

function mxPartitionLayout(t, e, i, n) {
  mxGraphLayout.call(this, t), this.horizontal = null == e || e, this.spacing = i || 0, this.border = n || 0;
}

function mxCompactTreeLayout(t, e, i) {
  mxGraphLayout.call(this, t), this.horizontal = null == e || e, this.invert = null != i && i;
}

function mxRadialTreeLayout(t) {
  mxCompactTreeLayout.call(this, t, !1);
}

function mxFastOrganicLayout(t) {
  mxGraphLayout.call(this, t);
}

function mxCircleLayout(t, e) {
  mxGraphLayout.call(this, t), this.radius = null != e ? e : 100;
}

function mxParallelEdgeLayout(t) {
  mxGraphLayout.call(this, t);
}

function mxCompositeLayout(t, e, i) {
  mxGraphLayout.call(this, t), this.layouts = e, this.master = i;
}

function mxEdgeLabelLayout(t, e) {
  mxGraphLayout.call(this, t);
}

function mxGraphAbstractHierarchyCell() {
  this.x = [], this.y = [], this.temp = [];
}

function mxGraphHierarchyNode(t) {
  mxGraphAbstractHierarchyCell.apply(this, arguments), this.cell = t, this.id = mxObjectIdentity.get(t), this.connectsAsTarget = [], this.connectsAsSource = [];
}

function mxGraphHierarchyEdge(t) {
  mxGraphAbstractHierarchyCell.apply(this, arguments), this.edges = t, this.ids = [];

  for (var e = 0; e < t.length; e++) {
    this.ids.push(mxObjectIdentity.get(t[e]));
  }
}

function mxGraphHierarchyModel(t, e, i, n, s) {
  for (t.getGraph(), this.tightenToSource = s, this.roots = i, this.parent = n, this.vertexMapper = new mxDictionary(), this.edgeMapper = new mxDictionary(), this.maxRank = 0, i = [], null == e && (e = this.graph.getChildVertices(n)), this.maxRank = this.SOURCESCANSTARTRANK, this.createInternalCells(t, e, i), n = 0; n < e.length; n++) {
    s = i[n].connectsAsSource;

    for (var o = 0; o < s.length; o++) {
      var l = s[o];

      if (null != (r = l.edges) && 0 < r.length) {
        var r = r[0],
            a = t.getVisibleTerminal(r, !1);
        a = this.vertexMapper.get(a);
        i[n] == a && (a = t.getVisibleTerminal(r, !0), a = this.vertexMapper.get(a)), null != a && i[n] != a && (l.target = a, 0 == a.connectsAsTarget.length && (a.connectsAsTarget = []), 0 > mxUtils.indexOf(a.connectsAsTarget, l) && a.connectsAsTarget.push(l));
      }
    }

    i[n].temp[0] = 1;
  }
}

function mxSwimlaneModel(t, e, i, n, s) {
  for (t.getGraph(), this.tightenToSource = s, this.roots = i, this.parent = n, this.vertexMapper = new mxDictionary(), this.edgeMapper = new mxDictionary(), this.maxRank = 0, i = [], null == e && (e = this.graph.getChildVertices(n)), this.maxRank = this.SOURCESCANSTARTRANK, this.createInternalCells(t, e, i), n = 0; n < e.length; n++) {
    s = i[n].connectsAsSource;

    for (var o = 0; o < s.length; o++) {
      var l = s[o];

      if (null != (r = l.edges) && 0 < r.length) {
        var r = r[0],
            a = t.getVisibleTerminal(r, !1);
        a = this.vertexMapper.get(a);
        i[n] == a && (a = t.getVisibleTerminal(r, !0), a = this.vertexMapper.get(a)), null != a && i[n] != a && (l.target = a, 0 == a.connectsAsTarget.length && (a.connectsAsTarget = []), 0 > mxUtils.indexOf(a.connectsAsTarget, l) && a.connectsAsTarget.push(l));
      }
    }

    i[n].temp[0] = 1;
  }
}

function mxHierarchicalLayoutStage() {}

function mxMedianHybridCrossingReduction(t) {
  this.layout = t;
}

function MedianCellSorter() {}

function mxMinimumCycleRemover(t) {
  this.layout = t;
}

function mxCoordinateAssignment(t, e, i, n, s, o) {
  this.layout = t, this.intraCellSpacing = e, this.interRankCellSpacing = i, this.orientation = n, this.initialX = s, this.parallelEdgeSpacing = o;
}

function mxSwimlaneOrdering(t) {
  this.layout = t;
}

function mxHierarchicalLayout(t, e, i) {
  mxGraphLayout.call(this, t), this.orientation = null != e ? e : mxConstants.DIRECTION_NORTH, this.deterministic = null == i || i;
}

!function () {
  function t(t) {
    return t = null != t ? t : 2, function (e, i, n, s, o, l, r, a, h, u) {
      i = o * h * 1.118, a = l * h * 1.118, o *= r + h, l *= r + h;
      var d = s.clone();
      return d.x -= i, d.y -= a, r = n != mxConstants.ARROW_CLASSIC && n != mxConstants.ARROW_CLASSIC_THIN ? 1 : .75, s.x += -o * r - i, s.y += -l * r - a, function () {
        e.begin(), e.moveTo(d.x, d.y), e.lineTo(d.x - o - l / t, d.y - l + o / t), n != mxConstants.ARROW_CLASSIC && n != mxConstants.ARROW_CLASSIC_THIN || e.lineTo(d.x - 3 * o / 4, d.y - 3 * l / 4), e.lineTo(d.x + l / t - o, d.y - l - o / t), e.close(), u ? e.fillAndStroke() : e.stroke();
      };
    };
  }

  function e(t) {
    return t = null != t ? t : 2, function (e, i, n, s, o, l, r, a, h, u) {
      i = o * h * 1.118, n = l * h * 1.118, o *= r + h, l *= r + h;
      var d = s.clone();
      return d.x -= i, d.y -= n, s.x += 2 * -i, s.y += 2 * -n, function () {
        e.begin(), e.moveTo(d.x - o - l / t, d.y - l + o / t), e.lineTo(d.x, d.y), e.lineTo(d.x + l / t - o, d.y - l - o / t), e.stroke();
      };
    };
  }

  function i(t, e, i, n, s, o, l, r, a, h) {
    r = i == mxConstants.ARROW_DIAMOND ? .7071 : .9862, e = s * a * r, r *= o * a, s *= l + a, o *= l + a;
    var u = n.clone();
    u.x -= e, u.y -= r, n.x += -s - e, n.y += -o - r;
    var d = i == mxConstants.ARROW_DIAMOND ? 2 : 3.4;
    return function () {
      t.begin(), t.moveTo(u.x, u.y), t.lineTo(u.x - s / 2 - o / d, u.y + s / d - o / 2), t.lineTo(u.x - s, u.y - o), t.lineTo(u.x - s / 2 + o / d, u.y - o / 2 - s / d), t.close(), h ? t.fillAndStroke() : t.stroke();
    };
  }

  mxMarker.addMarker("classic", t(2)), mxMarker.addMarker("classicThin", t(3)), mxMarker.addMarker("block", t(2)), mxMarker.addMarker("blockThin", t(3)), mxMarker.addMarker("open", e(2)), mxMarker.addMarker("openThin", e(3)), mxMarker.addMarker("oval", function (t, e, i, n, s, o, l, r, a, h) {
    var u = l / 2,
        d = n.clone();
    return n.x -= s * u, n.y -= o * u, function () {
      t.ellipse(d.x - u, d.y - u, l, l), h ? t.fillAndStroke() : t.stroke();
    };
  }), mxMarker.addMarker("diamond", i), mxMarker.addMarker("diamondThin", i);
}(), mxUtils.extend(mxActor, mxShape), mxActor.prototype.paintVertexShape = function (t, e, i, n, s) {
  t.translate(e, i), t.begin(), this.redrawPath(t, e, i, n, s), t.fillAndStroke();
}, mxActor.prototype.redrawPath = function (t, e, i, n, s) {
  e = n / 3, t.moveTo(0, s), t.curveTo(0, 3 * s / 5, 0, 2 * s / 5, n / 2, 2 * s / 5), t.curveTo(n / 2 - e, 2 * s / 5, n / 2 - e, 0, n / 2, 0), t.curveTo(n / 2 + e, 0, n / 2 + e, 2 * s / 5, n / 2, 2 * s / 5), t.curveTo(n, 2 * s / 5, n, 3 * s / 5, n, s), t.close();
}, mxUtils.extend(mxCloud, mxActor), mxCloud.prototype.redrawPath = function (t, e, i, n, s) {
  t.moveTo(.25 * n, .25 * s), t.curveTo(.05 * n, .25 * s, 0, .5 * s, .16 * n, .55 * s), t.curveTo(0, .66 * s, .18 * n, .9 * s, .31 * n, .8 * s), t.curveTo(.4 * n, s, .7 * n, s, .8 * n, .8 * s), t.curveTo(n, .8 * s, n, .6 * s, .875 * n, .5 * s), t.curveTo(n, .3 * s, .8 * n, .1 * s, .625 * n, .2 * s), t.curveTo(.5 * n, .05 * s, .3 * n, .05 * s, .25 * n, .25 * s), t.close();
}, mxUtils.extend(mxRectangleShape, mxShape), mxRectangleShape.prototype.isHtmlAllowed = function () {
  var t = !0;
  return null != this.style && (t = "1" == mxUtils.getValue(this.style, mxConstants.STYLE_POINTER_EVENTS, "1")), !this.isRounded && !this.glass && 0 == this.rotation && (t || null != this.fill && this.fill != mxConstants.NONE);
}, mxRectangleShape.prototype.paintBackground = function (t, e, i, n, s) {
  var o = !0;
  null != this.style && (o = "1" == mxUtils.getValue(this.style, mxConstants.STYLE_POINTER_EVENTS, "1")), (o || null != this.fill && this.fill != mxConstants.NONE || null != this.stroke && this.stroke != mxConstants.NONE) && (o || null != this.fill && this.fill != mxConstants.NONE || (t.pointerEvents = !1), this.isRounded ? ("1" == mxUtils.getValue(this.style, mxConstants.STYLE_ABSOLUTE_ARCSIZE, 0) ? o = Math.min(n / 2, Math.min(s / 2, mxUtils.getValue(this.style, mxConstants.STYLE_ARCSIZE, mxConstants.LINE_ARCSIZE) / 2)) : (o = mxUtils.getValue(this.style, mxConstants.STYLE_ARCSIZE, 100 * mxConstants.RECTANGLE_ROUNDING_FACTOR) / 100, o = Math.min(n * o, s * o)), t.roundrect(e, i, n, s, o, o)) : t.rect(e, i, n, s), t.fillAndStroke());
}, mxRectangleShape.prototype.isRoundable = function (t, e, i, n, s) {
  return !0;
}, mxRectangleShape.prototype.paintForeground = function (t, e, i, n, s) {
  this.glass && !this.outline && null != this.fill && this.fill != mxConstants.NONE && this.paintGlassEffect(t, e, i, n, s, this.getArcSize(n + this.strokewidth, s + this.strokewidth));
}, mxUtils.extend(mxEllipse, mxShape), mxEllipse.prototype.paintVertexShape = function (t, e, i, n, s) {
  t.ellipse(e, i, n, s), t.fillAndStroke();
}, mxUtils.extend(mxDoubleEllipse, mxShape), mxDoubleEllipse.prototype.vmlScale = 10, mxDoubleEllipse.prototype.paintBackground = function (t, e, i, n, s) {
  t.ellipse(e, i, n, s), t.fillAndStroke();
}, mxDoubleEllipse.prototype.paintForeground = function (t, e, i, n, s) {
  if (!this.outline) {
    var o = mxUtils.getValue(this.style, mxConstants.STYLE_MARGIN, Math.min(3 + this.strokewidth, Math.min(n / 5, s / 5)));
    s -= 2 * o, 0 < (n -= 2 * o) && 0 < s && t.ellipse(e + o, i + o, n, s), t.stroke();
  }
}, mxDoubleEllipse.prototype.getLabelBounds = function (t) {
  var e = mxUtils.getValue(this.style, mxConstants.STYLE_MARGIN, Math.min(3 + this.strokewidth, Math.min(t.width / 5 / this.scale, t.height / 5 / this.scale))) * this.scale;
  return new mxRectangle(t.x + e, t.y + e, t.width - 2 * e, t.height - 2 * e);
}, mxUtils.extend(mxRhombus, mxShape), mxRhombus.prototype.isRoundable = function () {
  return !0;
}, mxRhombus.prototype.paintVertexShape = function (t, e, i, n, s) {
  var o = n / 2,
      l = s / 2,
      r = mxUtils.getValue(this.style, mxConstants.STYLE_ARCSIZE, mxConstants.LINE_ARCSIZE) / 2;
  t.begin(), this.addPoints(t, [new mxPoint(e + o, i), new mxPoint(e + n, i + l), new mxPoint(e + o, i + s), new mxPoint(e, i + l)], this.isRounded, r, !0), t.fillAndStroke();
}, mxUtils.extend(mxPolyline, mxShape), mxPolyline.prototype.getRotation = function () {
  return 0;
}, mxPolyline.prototype.getShapeRotation = function () {
  return 0;
}, mxPolyline.prototype.isPaintBoundsInverted = function () {
  return !1;
}, mxPolyline.prototype.paintEdgeShape = function (t, e) {
  null == this.style || 1 != this.style[mxConstants.STYLE_CURVED] ? this.paintLine(t, e, this.isRounded) : this.paintCurvedLine(t, e);
}, mxPolyline.prototype.paintLine = function (t, e, i) {
  var n = mxUtils.getValue(this.style, mxConstants.STYLE_ARCSIZE, mxConstants.LINE_ARCSIZE) / 2;
  t.begin(), this.addPoints(t, e, i, n, !1), t.stroke();
}, mxPolyline.prototype.paintCurvedLine = function (t, e) {
  t.begin();
  var i = e[0],
      n = e.length;

  for (t.moveTo(i.x, i.y), i = 1; i < n - 2; i++) {
    var s = e[i],
        o = e[i + 1];
    t.quadTo(s.x, s.y, (s.x + o.x) / 2, (s.y + o.y) / 2);
  }

  s = e[n - 2], o = e[n - 1], t.quadTo(s.x, s.y, o.x, o.y), t.stroke();
}, mxUtils.extend(mxArrow, mxShape), mxArrow.prototype.augmentBoundingBox = function (t) {
  mxShape.prototype.augmentBoundingBox.apply(this, arguments), t.grow((Math.max(this.arrowWidth, this.endSize) / 2 + this.strokewidth) * this.scale);
}, mxArrow.prototype.paintEdgeShape = function (t, e) {
  var i = mxConstants.ARROW_SPACING,
      n = mxConstants.ARROW_WIDTH,
      s = e[0],
      o = e[e.length - 1],
      l = o.x - s.x,
      r = o.y - s.y,
      a = (h = Math.sqrt(l * l + r * r)) - 2 * i - mxConstants.ARROW_SIZE,
      h = (l = l / h, n * (r = r / h) / 3),
      u = (n = -n * l / 3, s.x - h / 2 + i * l),
      d = u + h,
      p = (s = s.y - n / 2 + i * r) + n,
      c = d + a * l,
      m = c + h,
      g = (a = p + a * r) + n,
      x = m - 3 * h,
      y = g - 3 * n;
  t.begin(), t.moveTo(u, s), t.lineTo(d, p), t.lineTo(c, a), t.lineTo(m, g), t.lineTo(o.x - i * l, o.y - i * r), t.lineTo(x, y), t.lineTo(x + h, y + n), t.close(), t.fillAndStroke();
}, mxUtils.extend(mxArrowConnector, mxShape), mxArrowConnector.prototype.useSvgBoundingBox = !0, mxArrowConnector.prototype.resetStyles = function () {
  mxShape.prototype.resetStyles.apply(this, arguments), this.arrowSpacing = mxConstants.ARROW_SPACING;
}, mxArrowConnector.prototype.apply = function (t) {
  mxShape.prototype.apply.apply(this, arguments), null != this.style && (this.startSize = 3 * mxUtils.getNumber(this.style, mxConstants.STYLE_STARTSIZE, mxConstants.ARROW_SIZE / 5), this.endSize = 3 * mxUtils.getNumber(this.style, mxConstants.STYLE_ENDSIZE, mxConstants.ARROW_SIZE / 5));
}, mxArrowConnector.prototype.augmentBoundingBox = function (t) {
  mxShape.prototype.augmentBoundingBox.apply(this, arguments);
  var e = this.getEdgeWidth();
  this.isMarkerStart() && (e = Math.max(e, this.getStartArrowWidth())), this.isMarkerEnd() && (e = Math.max(e, this.getEndArrowWidth())), t.grow((e / 2 + this.strokewidth) * this.scale);
}, mxArrowConnector.prototype.paintEdgeShape = function (t, e) {
  var i = this.strokewidth;
  this.outline && (i = Math.max(1, mxUtils.getNumber(this.style, mxConstants.STYLE_STROKEWIDTH, this.strokewidth)));

  for (var n = this.getStartArrowWidth() + i, s = this.getEndArrowWidth() + i, o = this.outline ? this.getEdgeWidth() + i : this.getEdgeWidth(), l = this.isOpenEnded(), r = this.isMarkerStart(), a = this.isMarkerEnd(), h = l ? 0 : this.arrowSpacing + i / 2, u = this.startSize + i, d = (i = this.endSize + i, this.isArrowRounded()), p = e[e.length - 1], c = 1; c < e.length - 1 && e[c].x == e[0].x && e[c].y == e[0].y;) {
    c++;
  }

  var m = e[c].x - e[0].x;
  c = e[c].y - e[0].y;

  if (0 != (E = Math.sqrt(m * m + c * c))) {
    var g,
        x,
        y = m / E,
        f = y,
        v = c / E,
        C = v,
        E = o * v,
        S = -o * y,
        b = [];
    if (d ? t.setLineJoin("round") : 2 < e.length && t.setMiterLimit(1.42), t.begin(), m = y, c = v, r && !l) this.paintMarker(t, e[0].x, e[0].y, y, v, u, n, o, h, !0);else {
      g = e[0].x + E / 2 + h * y, x = e[0].y + S / 2 + h * v;
      var w = e[0].x - E / 2 + h * y,
          T = e[0].y - S / 2 + h * v;
      l ? (t.moveTo(g, x), b.push(function () {
        t.lineTo(w, T);
      })) : (t.moveTo(w, T), t.lineTo(g, x));
    }
    var A = x = g = 0;

    for (E = 0; E < e.length - 2; E++) {
      if (S = mxUtils.relativeCcw(e[E].x, e[E].y, e[E + 1].x, e[E + 1].y, e[E + 2].x, e[E + 2].y), g = e[E + 2].x - e[E + 1].x, x = e[E + 2].y - e[E + 1].y, 0 != (A = Math.sqrt(g * g + x * x)) && (f = g / A, C = x / A, tmp = Math.max(Math.sqrt((y * f + v * C + 1) / 2), .04), g = y + f, x = v + C, 0 != (A = Math.sqrt(g * g + x * x)))) {
        g /= A, x /= A;
        A = Math.max(tmp, Math.min(this.strokewidth / 200 + .04, .35)), A = 0 != S && d ? Math.max(.1, A) : Math.max(tmp, .06);
        var L = e[E + 1].x + x * o / 2 / A,
            M = e[E + 1].y - g * o / 2 / A;
        x = e[E + 1].x - x * o / 2 / A, g = e[E + 1].y + g * o / 2 / A, 0 != S && d ? -1 == S ? (S = x + C * o, A = g - f * o, t.lineTo(x + v * o, g - y * o), t.quadTo(L, M, S, A), function (e, i) {
          b.push(function () {
            t.lineTo(e, i);
          });
        }(x, g)) : (t.lineTo(L, M), function (e, i) {
          var n = L - v * o,
              s = M + y * o,
              l = L - C * o,
              r = M + f * o;
          b.push(function () {
            t.quadTo(e, i, n, s);
          }), b.push(function () {
            t.lineTo(l, r);
          });
        }(x, g)) : (t.lineTo(L, M), function (e, i) {
          b.push(function () {
            t.lineTo(e, i);
          });
        }(x, g)), y = f, v = C;
      }
    }

    if (E = o * C, S = -o * f, a && !l) this.paintMarker(t, p.x, p.y, -y, -v, i, s, o, h, !1);else {
      t.lineTo(p.x - h * f + E / 2, p.y - h * C + S / 2);
      var I = p.x - h * f - E / 2,
          R = p.y - h * C - S / 2;
      l ? (t.moveTo(I, R), b.splice(0, 0, function () {
        t.moveTo(I, R);
      })) : t.lineTo(I, R);
    }

    for (E = b.length - 1; 0 <= E; E--) {
      b[E]();
    }

    l ? (t.end(), t.stroke()) : (t.close(), t.fillAndStroke()), t.setShadow(!1), t.setMiterLimit(4), d && t.setLineJoin("flat"), 2 < e.length && (t.setMiterLimit(4), r && !l && (t.begin(), this.paintMarker(t, e[0].x, e[0].y, m, c, u, n, o, h, !0), t.stroke(), t.end()), a && !l && (t.begin(), this.paintMarker(t, p.x, p.y, -y, -v, i, s, o, h, !0), t.stroke(), t.end()));
  }
}, mxArrowConnector.prototype.paintMarker = function (t, e, i, n, s, o, l, r, a, h) {
  l = r / l;
  var u = r * s / 2;
  r = -r * n / 2;
  var d = (a + o) * n;
  o = (a + o) * s, h ? t.moveTo(e - u + d, i - r + o) : t.lineTo(e - u + d, i - r + o), t.lineTo(e - u / l + d, i - r / l + o), t.lineTo(e + a * n, i + a * s), t.lineTo(e + u / l + d, i + r / l + o), t.lineTo(e + u + d, i + r + o);
}, mxArrowConnector.prototype.isArrowRounded = function () {
  return this.isRounded;
}, mxArrowConnector.prototype.getStartArrowWidth = function () {
  return mxConstants.ARROW_WIDTH;
}, mxArrowConnector.prototype.getEndArrowWidth = function () {
  return mxConstants.ARROW_WIDTH;
}, mxArrowConnector.prototype.getEdgeWidth = function () {
  return mxConstants.ARROW_WIDTH / 3;
}, mxArrowConnector.prototype.isOpenEnded = function () {
  return !1;
}, mxArrowConnector.prototype.isMarkerStart = function () {
  return mxUtils.getValue(this.style, mxConstants.STYLE_STARTARROW, mxConstants.NONE) != mxConstants.NONE;
}, mxArrowConnector.prototype.isMarkerEnd = function () {
  return mxUtils.getValue(this.style, mxConstants.STYLE_ENDARROW, mxConstants.NONE) != mxConstants.NONE;
}, mxUtils.extend(mxText, mxShape), mxText.prototype.baseSpacingTop = 0, mxText.prototype.baseSpacingBottom = 0, mxText.prototype.baseSpacingLeft = 0, mxText.prototype.baseSpacingRight = 0, mxText.prototype.replaceLinefeeds = !0, mxText.prototype.verticalTextRotation = -90, mxText.prototype.ignoreClippedStringSize = !0, mxText.prototype.ignoreStringSize = !1, mxText.prototype.textWidthPadding = 8 != document.documentMode || mxClient.IS_EM ? 3 : 4, mxText.prototype.lastValue = null, mxText.prototype.cacheEnabled = !0, mxText.prototype.isParseVml = function () {
  return !1;
}, mxText.prototype.isHtmlAllowed = function () {
  return 8 != document.documentMode || mxClient.IS_EM;
}, mxText.prototype.getSvgScreenOffset = function () {
  return 0;
}, mxText.prototype.checkBounds = function () {
  return !isNaN(this.scale) && isFinite(this.scale) && 0 < this.scale && null != this.bounds && !isNaN(this.bounds.x) && !isNaN(this.bounds.y) && !isNaN(this.bounds.width) && !isNaN(this.bounds.height);
}, mxText.prototype.paint = function (t, e) {
  var i = this.scale,
      n = this.bounds.x / i,
      s = this.bounds.y / i,
      o = this.bounds.width / i;
  i = this.bounds.height / i;
  this.updateTransform(t, n, s, o, i), this.configureCanvas(t, n, s, o, i);
  var l = null != this.state ? this.state.unscaledWidth : null;
  if (e) null == this.node.firstChild || null != l && this.lastUnscaledWidth == l || t.invalidateCachedOffsetSize(this.node), t.updateText(n, s, o, i, this.align, this.valign, this.wrap, this.overflow, this.clipped, this.getTextRotation(), this.node);else {
    var r = mxUtils.isNode(this.value) || this.dialect == mxConstants.DIALECT_STRICTHTML,
        a = r || t instanceof mxVmlCanvas2D ? "html" : "",
        h = this.value;
    r || "html" != a || (h = mxUtils.htmlEntities(h, !1)), "html" != a || mxUtils.isNode(this.value) || (h = mxUtils.replaceTrailingNewlines(h, "<div><br></div>"));
    h = !mxUtils.isNode(this.value) && this.replaceLinefeeds && "html" == a ? h.replace(/\n/g, "<br/>") : h;
    var u = this.textDirection;
    u != mxConstants.TEXT_DIRECTION_AUTO || r || (u = this.getAutoDirection()), u != mxConstants.TEXT_DIRECTION_LTR && u != mxConstants.TEXT_DIRECTION_RTL && (u = null), t.text(n, s, o, i, h, this.align, this.valign, this.wrap, a, this.overflow, this.clipped, this.getTextRotation(), u);
  }
  this.lastUnscaledWidth = l;
}, mxText.prototype.redraw = function () {
  if (this.visible && this.checkBounds() && this.cacheEnabled && this.lastValue == this.value && (mxUtils.isNode(this.value) || this.dialect == mxConstants.DIALECT_STRICTHTML)) {
    if ("DIV" != this.node.nodeName || !this.isHtmlAllowed() && mxClient.IS_VML) {
      var t = this.createCanvas();
      null != t && null != t.updateText && null != t.invalidateCachedOffsetSize ? (this.paint(t, !0), this.destroyCanvas(t), this.updateBoundingBox()) : mxShape.prototype.redraw.apply(this, arguments);
    } else this.updateSize(this.node, null == this.state || null == this.state.view.textDiv), mxClient.IS_IE && (null == document.documentMode || 8 >= document.documentMode) ? this.updateHtmlFilter() : this.updateHtmlTransform(), this.updateBoundingBox();
  } else mxShape.prototype.redraw.apply(this, arguments), mxUtils.isNode(this.value) || this.dialect == mxConstants.DIALECT_STRICTHTML ? this.lastValue = this.value : this.lastValue = null;
}, mxText.prototype.resetStyles = function () {
  mxShape.prototype.resetStyles.apply(this, arguments), this.color = "black", this.align = mxConstants.ALIGN_CENTER, this.valign = mxConstants.ALIGN_MIDDLE, this.family = mxConstants.DEFAULT_FONTFAMILY, this.size = mxConstants.DEFAULT_FONTSIZE, this.fontStyle = mxConstants.DEFAULT_FONTSTYLE, this.spacingLeft = this.spacingBottom = this.spacingRight = this.spacingTop = this.spacing = 2, this.horizontal = !0, delete this.background, delete this.border, this.textDirection = mxConstants.DEFAULT_TEXT_DIRECTION, delete this.margin;
}, mxText.prototype.apply = function (t) {
  var e = this.spacing;
  mxShape.prototype.apply.apply(this, arguments), null != this.style && (this.fontStyle = mxUtils.getValue(this.style, mxConstants.STYLE_FONTSTYLE, this.fontStyle), this.family = mxUtils.getValue(this.style, mxConstants.STYLE_FONTFAMILY, this.family), this.size = mxUtils.getValue(this.style, mxConstants.STYLE_FONTSIZE, this.size), this.color = mxUtils.getValue(this.style, mxConstants.STYLE_FONTCOLOR, this.color), this.align = mxUtils.getValue(this.style, mxConstants.STYLE_ALIGN, this.align), this.valign = mxUtils.getValue(this.style, mxConstants.STYLE_VERTICAL_ALIGN, this.valign), this.spacing = parseInt(mxUtils.getValue(this.style, mxConstants.STYLE_SPACING, this.spacing)), this.spacingTop = parseInt(mxUtils.getValue(this.style, mxConstants.STYLE_SPACING_TOP, this.spacingTop - e)) + this.spacing, this.spacingRight = parseInt(mxUtils.getValue(this.style, mxConstants.STYLE_SPACING_RIGHT, this.spacingRight - e)) + this.spacing, this.spacingBottom = parseInt(mxUtils.getValue(this.style, mxConstants.STYLE_SPACING_BOTTOM, this.spacingBottom - e)) + this.spacing, this.spacingLeft = parseInt(mxUtils.getValue(this.style, mxConstants.STYLE_SPACING_LEFT, this.spacingLeft - e)) + this.spacing, this.horizontal = mxUtils.getValue(this.style, mxConstants.STYLE_HORIZONTAL, this.horizontal), this.background = mxUtils.getValue(this.style, mxConstants.STYLE_LABEL_BACKGROUNDCOLOR, this.background), this.border = mxUtils.getValue(this.style, mxConstants.STYLE_LABEL_BORDERCOLOR, this.border), this.textDirection = mxUtils.getValue(this.style, mxConstants.STYLE_TEXT_DIRECTION, mxConstants.DEFAULT_TEXT_DIRECTION), this.opacity = mxUtils.getValue(this.style, mxConstants.STYLE_TEXT_OPACITY, 100), this.updateMargin()), this.flipH = this.flipV = null;
}, mxText.prototype.getAutoDirection = function () {
  var t = /[A-Za-z\u05d0-\u065f\u066a-\u06ef\u06fa-\u07ff\ufb1d-\ufdff\ufe70-\ufefc]/.exec(this.value);
  return null != t && 0 < t.length && "z" < t[0] ? mxConstants.TEXT_DIRECTION_RTL : mxConstants.TEXT_DIRECTION_LTR;
}, mxText.prototype.updateBoundingBox = function () {
  var t = this.node;
  this.boundingBox = this.bounds.clone();
  var e = this.getTextRotation(),
      i = null != this.style ? mxUtils.getValue(this.style, mxConstants.STYLE_LABEL_POSITION, mxConstants.ALIGN_CENTER) : null,
      n = null != this.style ? mxUtils.getValue(this.style, mxConstants.STYLE_VERTICAL_LABEL_POSITION, mxConstants.ALIGN_MIDDLE) : null;

  if (!(this.ignoreStringSize || null == t || "fill" == this.overflow || this.clipped && this.ignoreClippedStringSize && i == mxConstants.ALIGN_CENTER && n == mxConstants.ALIGN_MIDDLE)) {
    if (n = i = null, null != t.ownerSVGElement) {
      if (null != t.firstChild && null != t.firstChild.firstChild && "foreignObject" == t.firstChild.firstChild.nodeName) t = t.firstChild.firstChild, i = parseInt(t.getAttribute("width")) * this.scale, n = parseInt(t.getAttribute("height")) * this.scale;else try {
        var s = t.getBBox();
        return void ("string" == typeof this.value && 0 == mxUtils.trim(this.value) ? this.boundingBox = null : this.boundingBox = 0 == s.width && 0 == s.height ? null : new mxRectangle(s.x, s.y, s.width, s.height));
      } catch (t) {}
    } else i = null != this.state ? this.state.view.textDiv : null, null != this.offsetWidth && null != this.offsetHeight || (null != i && (this.updateFont(i), this.updateSize(i, !1), this.updateInnerHtml(i), t = i), s = t, 8 != document.documentMode || mxClient.IS_EM ? null != s.firstChild && "DIV" == s.firstChild.nodeName && (s = s.firstChild) : (n = Math.round(this.bounds.width / this.scale), this.wrap && 0 < n ? (t.style.wordWrap = mxConstants.WORD_WRAP, t.style.whiteSpace = "normal", "break-word" != t.style.wordWrap && (0 < (t = s.getElementsByTagName("div")).length && (s = t[t.length - 1]), i = s.offsetWidth + 2, t = this.node.getElementsByTagName("div"), this.clipped && (i = Math.min(n, i)), 1 < t.length && (t[t.length - 2].style.width = i + "px"))) : t.style.whiteSpace = "nowrap"), this.offsetWidth = s.offsetWidth + this.textWidthPadding, this.offsetHeight = s.offsetHeight), i = this.offsetWidth * this.scale, n = this.offsetHeight * this.scale;
    null != i && null != n && (this.boundingBox = new mxRectangle(this.bounds.x, this.bounds.y, i, n));
  }

  null != this.boundingBox && (0 != e ? (e = mxUtils.getBoundingBox(new mxRectangle(this.margin.x * this.boundingBox.width, this.margin.y * this.boundingBox.height, this.boundingBox.width, this.boundingBox.height), e, new mxPoint(0, 0)), this.unrotatedBoundingBox = mxRectangle.fromRectangle(this.boundingBox), this.unrotatedBoundingBox.x += this.margin.x * this.unrotatedBoundingBox.width, this.unrotatedBoundingBox.y += this.margin.y * this.unrotatedBoundingBox.height, this.boundingBox.x += e.x, this.boundingBox.y += e.y, this.boundingBox.width = e.width, this.boundingBox.height = e.height) : (this.boundingBox.x += this.margin.x * this.boundingBox.width, this.boundingBox.y += this.margin.y * this.boundingBox.height, this.unrotatedBoundingBox = null));
}, mxText.prototype.getShapeRotation = function () {
  return 0;
}, mxText.prototype.getTextRotation = function () {
  return null != this.state && null != this.state.shape ? this.state.shape.getTextRotation() : 0;
}, mxText.prototype.isPaintBoundsInverted = function () {
  return !this.horizontal && null != this.state && this.state.view.graph.model.isVertex(this.state.cell);
}, mxText.prototype.configureCanvas = function (t, e, i, n, s) {
  mxShape.prototype.configureCanvas.apply(this, arguments), t.setFontColor(this.color), t.setFontBackgroundColor(this.background), t.setFontBorderColor(this.border), t.setFontFamily(this.family), t.setFontSize(this.size), t.setFontStyle(this.fontStyle);
}, mxText.prototype.updateVmlContainer = function () {
  this.node.style.left = Math.round(this.bounds.x) + "px", this.node.style.top = Math.round(this.bounds.y) + "px", this.node.style.width = "1px", this.node.style.height = "1px", this.node.style.overflow = "visible";
}, mxText.prototype.redrawHtmlShape = function () {
  var t = this.node.style;
  t.whiteSpace = "normal", t.overflow = "", t.width = "", t.height = "", this.updateValue(), this.updateFont(this.node), this.updateSize(this.node, null == this.state || null == this.state.view.textDiv), this.offsetHeight = this.offsetWidth = null, mxClient.IS_IE && (null == document.documentMode || 8 >= document.documentMode) ? this.updateHtmlFilter() : this.updateHtmlTransform();
}, mxText.prototype.updateHtmlTransform = function () {
  var t = this.getTextRotation(),
      e = this.node.style,
      i = this.margin.x,
      n = this.margin.y;
  0 != t ? (mxUtils.setPrefixedStyle(e, "transformOrigin", 100 * -i + "% " + 100 * -n + "%"), mxUtils.setPrefixedStyle(e, "transform", "translate(" + 100 * i + "%," + 100 * n + "%)scale(" + this.scale + ") rotate(" + t + "deg)")) : (mxUtils.setPrefixedStyle(e, "transformOrigin", "0% 0%"), mxUtils.setPrefixedStyle(e, "transform", "scale(" + this.scale + ")translate(" + 100 * i + "%," + 100 * n + "%)")), e.left = Math.round(this.bounds.x - Math.ceil(i * ("fill" != this.overflow && "width" != this.overflow ? 3 : 1))) + "px", e.top = Math.round(this.bounds.y - n * ("fill" != this.overflow ? 3 : 1)) + "px", e.opacity = 100 > this.opacity ? this.opacity / 100 : "";
}, mxText.prototype.updateInnerHtml = function (t) {
  if (mxUtils.isNode(this.value)) t.innerHTML = this.value.outerHTML;else {
    var e = this.value;
    this.dialect != mxConstants.DIALECT_STRICTHTML && (e = mxUtils.htmlEntities(e, !1)), e = mxUtils.replaceTrailingNewlines(e, "<div>&nbsp;</div>"), e = this.replaceLinefeeds ? e.replace(/\n/g, "<br/>") : e, t.innerHTML = '<div style="display:inline-block;_display:inline;">' + e + "</div>";
  }
}, mxText.prototype.updateHtmlFilter = function () {
  var t = this.node.style,
      e = this.margin.x,
      i = this.margin.y,
      n = this.scale;
  mxUtils.setOpacity(this.node, this.opacity);
  var s,
      o = 0,
      l = null != this.state ? this.state.view.textDiv : null,
      r = this.node;

  if (null != l) {
    l.style.overflow = "", l.style.height = "", l.style.width = "", this.updateFont(l), this.updateSize(l, !1), this.updateInnerHtml(l);
    var a = Math.round(this.bounds.width / this.scale);
    this.wrap && 0 < a ? (l.style.whiteSpace = "normal", l.style.wordWrap = mxConstants.WORD_WRAP, s = a, this.clipped && (s = Math.min(s, this.bounds.width)), l.style.width = s + "px") : l.style.whiteSpace = "nowrap", null != (r = l).firstChild && "DIV" == r.firstChild.nodeName && (r = r.firstChild, this.wrap && "break-word" == l.style.wordWrap && (r.style.width = "100%")), !this.clipped && this.wrap && 0 < a && (s = r.offsetWidth + this.textWidthPadding, l.style.width = s + "px"), o = r.offsetHeight + 2, mxClient.IS_QUIRKS && null != this.border && this.border != mxConstants.NONE && (o += 3);
  } else null != r.firstChild && "DIV" == r.firstChild.nodeName && (o = (r = r.firstChild).offsetHeight);

  s = r.offsetWidth + this.textWidthPadding, this.clipped && (o = Math.min(o, this.bounds.height)), a = this.bounds.width / n, l = this.bounds.height / n, "fill" == this.overflow ? (o = l, s = a) : "width" == this.overflow && (o = r.scrollHeight, s = a), this.offsetWidth = s, this.offsetHeight = o, mxClient.IS_QUIRKS && (this.clipped || "width" == this.overflow && 0 < l) ? (l = Math.min(l, o), t.height = Math.round(l) + "px") : l = o, "fill" != this.overflow && "width" != this.overflow && (this.clipped && (s = Math.min(a, s)), a = s, mxClient.IS_QUIRKS && this.clipped || this.wrap) && (t.width = Math.round(a) + "px");
  l *= n, a *= n;
  var h = this.getTextRotation() * (Math.PI / 180);
  s = parseFloat(parseFloat(Math.cos(h)).toFixed(8)), o = parseFloat(parseFloat(Math.sin(-h)).toFixed(8)), 0 > (h %= 2 * Math.PI) && (h += 2 * Math.PI), (h %= Math.PI) > Math.PI / 2 && (h = Math.PI - h);
  r = Math.cos(h);
  var u = Math.sin(-h),
      d = (e = a * -(e + .5), l * -(i + .5));
  0 != h && (i = "progid:DXImageTransform.Microsoft.Matrix(M11=" + s + ", M12=" + o + ", M21=" + -o + ", M22=" + s + ", sizingMethod='auto expand')", t.filter = null != t.filter && 0 < t.filter.length ? t.filter + " " + i : i), i = 0, "fill" != this.overflow && mxClient.IS_QUIRKS && (i = this.valign == mxConstants.ALIGN_TOP ? i - 1 : this.valign == mxConstants.ALIGN_BOTTOM ? i + 2 : i + 1), t.zoom = n, t.left = Math.round(this.bounds.x + ((a - a * r + l * u) / 2 - s * e - o * d) - a / 2) + "px", t.top = Math.round(this.bounds.y + ((l - l * r + a * u) / 2 + o * e - s * d) - l / 2 + i) + "px";
}, mxText.prototype.updateValue = function () {
  if (mxUtils.isNode(this.value)) this.node.innerHTML = "", this.node.appendChild(this.value);else {
    var t = this.value;
    this.dialect != mxConstants.DIALECT_STRICTHTML && (t = mxUtils.htmlEntities(t, !1));
    t = mxUtils.replaceTrailingNewlines(t, "<div><br></div>"), t = this.replaceLinefeeds ? t.replace(/\n/g, "<br/>") : t;
    var e = null != this.background && this.background != mxConstants.NONE ? this.background : null,
        i = null != this.border && this.border != mxConstants.NONE ? this.border : null;
    if ("fill" == this.overflow || "width" == this.overflow) null != e && (this.node.style.backgroundColor = e), null != i && (this.node.style.border = "1px solid " + i);else {
      var n = "";
      null != e && (n += "background-color:" + e + ";"), null != i && (n += "border:1px solid " + i + ";"), t = '<div style="zoom:1;' + n + "display:inline-block;_display:inline;text-decoration:inherit;padding-bottom:1px;padding-right:1px;line-height:" + (mxConstants.ABSOLUTE_LINE_HEIGHT ? this.size * mxConstants.LINE_HEIGHT + "px" : mxConstants.LINE_HEIGHT) + '">' + t + "</div>";
    }
    this.node.innerHTML = t, 0 < (t = this.node.getElementsByTagName("div")).length && ((e = this.textDirection) == mxConstants.TEXT_DIRECTION_AUTO && this.dialect != mxConstants.DIALECT_STRICTHTML && (e = this.getAutoDirection()), e == mxConstants.TEXT_DIRECTION_LTR || e == mxConstants.TEXT_DIRECTION_RTL ? t[t.length - 1].setAttribute("dir", e) : t[t.length - 1].removeAttribute("dir"));
  }
}, mxText.prototype.updateFont = function (t) {
  (t = t.style).lineHeight = mxConstants.ABSOLUTE_LINE_HEIGHT ? this.size * mxConstants.LINE_HEIGHT + "px" : mxConstants.LINE_HEIGHT, t.fontSize = this.size + "px", t.fontFamily = this.family, t.verticalAlign = "top", t.color = this.color, t.fontWeight = (this.fontStyle & mxConstants.FONT_BOLD) == mxConstants.FONT_BOLD ? "bold" : "", t.fontStyle = (this.fontStyle & mxConstants.FONT_ITALIC) == mxConstants.FONT_ITALIC ? "italic" : "", t.textDecoration = (this.fontStyle & mxConstants.FONT_UNDERLINE) == mxConstants.FONT_UNDERLINE ? "underline" : "", t.textAlign = this.align == mxConstants.ALIGN_CENTER ? "center" : this.align == mxConstants.ALIGN_RIGHT ? "right" : "left";
}, mxText.prototype.updateSize = function (t, e) {
  var i = Math.max(0, Math.round(this.bounds.width / this.scale)),
      n = Math.max(0, Math.round(this.bounds.height / this.scale)),
      s = t.style;

  if (this.clipped ? (s.overflow = "hidden", mxClient.IS_QUIRKS ? s.width = i + "px" : (s.maxHeight = n + "px", s.maxWidth = i + "px")) : "fill" == this.overflow ? (s.width = i + 1 + "px", s.height = n + 1 + "px", s.overflow = "hidden") : "width" == this.overflow && (s.width = i + 1 + "px", s.maxHeight = n + 1 + "px", s.overflow = "hidden"), this.wrap && 0 < i) {
    if (s.wordWrap = mxConstants.WORD_WRAP, s.whiteSpace = "normal", s.width = i + "px", e && "fill" != this.overflow && "width" != this.overflow) {
      null != (n = t).firstChild && "DIV" == n.firstChild.nodeName && (n = n.firstChild, "break-word" == t.style.wordWrap && (n.style.width = "100%"));
      var o = n.offsetWidth;

      if (0 == o) {
        var l = t.parentNode;
        t.style.visibility = "hidden", document.body.appendChild(t), o = n.offsetWidth, t.style.visibility = "", l.appendChild(t);
      }

      o += 3, this.clipped && (o = Math.min(o, i)), s.width = o + "px";
    }
  } else s.whiteSpace = "nowrap";
}, mxText.prototype.updateMargin = function () {
  this.margin = mxUtils.getAlignmentAsPoint(this.align, this.valign);
}, mxText.prototype.getSpacing = function () {
  return new mxPoint(this.align == mxConstants.ALIGN_CENTER ? (this.spacingLeft - this.spacingRight) / 2 : this.align == mxConstants.ALIGN_RIGHT ? -this.spacingRight - this.baseSpacingRight : this.spacingLeft + this.baseSpacingLeft, this.valign == mxConstants.ALIGN_MIDDLE ? (this.spacingTop - this.spacingBottom) / 2 : this.valign == mxConstants.ALIGN_BOTTOM ? -this.spacingBottom - this.baseSpacingBottom : this.spacingTop + this.baseSpacingTop);
}, mxUtils.extend(mxTriangle, mxActor), mxTriangle.prototype.isRoundable = function () {
  return !0;
}, mxTriangle.prototype.redrawPath = function (t, e, i, n, s) {
  e = mxUtils.getValue(this.style, mxConstants.STYLE_ARCSIZE, mxConstants.LINE_ARCSIZE) / 2, this.addPoints(t, [new mxPoint(0, 0), new mxPoint(n, .5 * s), new mxPoint(0, s)], this.isRounded, e, !0);
}, mxUtils.extend(mxHexagon, mxActor), mxHexagon.prototype.redrawPath = function (t, e, i, n, s) {
  e = mxUtils.getValue(this.style, mxConstants.STYLE_ARCSIZE, mxConstants.LINE_ARCSIZE) / 2, this.addPoints(t, [new mxPoint(.25 * n, 0), new mxPoint(.75 * n, 0), new mxPoint(n, .5 * s), new mxPoint(.75 * n, s), new mxPoint(.25 * n, s), new mxPoint(0, .5 * s)], this.isRounded, e, !0);
}, mxUtils.extend(mxLine, mxShape), mxLine.prototype.paintVertexShape = function (t, e, i, n, s) {
  i += s / 2, t.begin(), t.moveTo(e, i), t.lineTo(e + n, i), t.stroke();
}, mxUtils.extend(mxImageShape, mxRectangleShape), mxImageShape.prototype.preserveImageAspect = !0, mxImageShape.prototype.getSvgScreenOffset = function () {
  return 0;
}, mxImageShape.prototype.apply = function (t) {
  mxShape.prototype.apply.apply(this, arguments), this.gradient = this.stroke = this.fill = null, null != this.style && (this.preserveImageAspect = 1 == mxUtils.getNumber(this.style, mxConstants.STYLE_IMAGE_ASPECT, 1), this.flipH = this.flipH || 1 == mxUtils.getValue(this.style, "imageFlipH", 0), this.flipV = this.flipV || 1 == mxUtils.getValue(this.style, "imageFlipV", 0));
}, mxImageShape.prototype.isHtmlAllowed = function () {
  return !this.preserveImageAspect;
}, mxImageShape.prototype.createHtml = function () {
  var t = document.createElement("div");
  return t.style.position = "absolute", t;
}, mxImageShape.prototype.isRoundable = function (t, e, i, n, s) {
  return !1;
}, mxImageShape.prototype.paintVertexShape = function (t, e, i, n, s) {
  if (null != this.image) {
    var o = mxUtils.getValue(this.style, mxConstants.STYLE_IMAGE_BACKGROUND, null),
        l = mxUtils.getValue(this.style, mxConstants.STYLE_IMAGE_BORDER, null);
    null != o && (t.setFillColor(o), t.setStrokeColor(l), t.rect(e, i, n, s), t.fillAndStroke()), t.image(e, i, n, s, this.image, this.preserveImageAspect, !1, !1), null != (l = mxUtils.getValue(this.style, mxConstants.STYLE_IMAGE_BORDER, null)) && (t.setShadow(!1), t.setStrokeColor(l), t.rect(e, i, n, s), t.stroke());
  } else mxRectangleShape.prototype.paintBackground.apply(this, arguments);
}, mxImageShape.prototype.redrawHtmlShape = function () {
  if (this.node.style.left = Math.round(this.bounds.x) + "px", this.node.style.top = Math.round(this.bounds.y) + "px", this.node.style.width = Math.max(0, Math.round(this.bounds.width)) + "px", this.node.style.height = Math.max(0, Math.round(this.bounds.height)) + "px", this.node.innerHTML = "", null != this.image) {
    var t = mxUtils.getValue(this.style, mxConstants.STYLE_IMAGE_BACKGROUND, ""),
        e = mxUtils.getValue(this.style, mxConstants.STYLE_IMAGE_BORDER, "");
    this.node.style.backgroundColor = t, this.node.style.borderColor = e, (t = document.createElement(mxClient.IS_IE6 || (null == document.documentMode || 8 >= document.documentMode) && 0 != this.rotation ? mxClient.VML_PREFIX + ":image" : "img")).setAttribute("border", "0"), t.style.position = "absolute", t.src = this.image, e = 100 > this.opacity ? "alpha(opacity=" + this.opacity + ")" : "", this.node.style.filter = e, this.flipH && this.flipV ? e += "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)" : this.flipH ? e += "progid:DXImageTransform.Microsoft.BasicImage(mirror=1)" : this.flipV && (e += "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)"), t.style.filter != e && (t.style.filter = e), "image" == t.nodeName ? t.style.rotation = this.rotation : 0 != this.rotation ? mxUtils.setPrefixedStyle(t.style, "transform", "rotate(" + this.rotation + "deg)") : mxUtils.setPrefixedStyle(t.style, "transform", ""), t.style.width = this.node.style.width, t.style.height = this.node.style.height, this.node.style.backgroundImage = "", this.node.appendChild(t);
  } else this.setTransparentBackgroundImage(this.node);
}, mxUtils.extend(mxLabel, mxRectangleShape), mxLabel.prototype.imageSize = mxConstants.DEFAULT_IMAGESIZE, mxLabel.prototype.spacing = 2, mxLabel.prototype.indicatorSize = 10, mxLabel.prototype.indicatorSpacing = 2, mxLabel.prototype.init = function (t) {
  mxShape.prototype.init.apply(this, arguments), null != this.indicatorShape && (this.indicator = new this.indicatorShape(), this.indicator.dialect = this.dialect, this.indicator.init(this.node));
}, mxLabel.prototype.redraw = function () {
  null != this.indicator && (this.indicator.fill = this.indicatorColor, this.indicator.stroke = this.indicatorStrokeColor, this.indicator.gradient = this.indicatorGradientColor, this.indicator.direction = this.indicatorDirection), mxShape.prototype.redraw.apply(this, arguments);
}, mxLabel.prototype.isHtmlAllowed = function () {
  return mxRectangleShape.prototype.isHtmlAllowed.apply(this, arguments) && null == this.indicatorColor && null == this.indicatorShape;
}, mxLabel.prototype.paintForeground = function (t, e, i, n, s) {
  this.paintImage(t, e, i, n, s), this.paintIndicator(t, e, i, n, s), mxRectangleShape.prototype.paintForeground.apply(this, arguments);
}, mxLabel.prototype.paintImage = function (t, e, i, n, s) {
  null != this.image && (e = this.getImageBounds(e, i, n, s), t.image(e.x, e.y, e.width, e.height, this.image, !1, !1, !1));
}, mxLabel.prototype.getImageBounds = function (t, e, i, n) {
  var s = mxUtils.getValue(this.style, mxConstants.STYLE_IMAGE_ALIGN, mxConstants.ALIGN_LEFT),
      o = mxUtils.getValue(this.style, mxConstants.STYLE_IMAGE_VERTICAL_ALIGN, mxConstants.ALIGN_MIDDLE),
      l = mxUtils.getNumber(this.style, mxConstants.STYLE_IMAGE_WIDTH, mxConstants.DEFAULT_IMAGESIZE),
      r = mxUtils.getNumber(this.style, mxConstants.STYLE_IMAGE_HEIGHT, mxConstants.DEFAULT_IMAGESIZE),
      a = mxUtils.getNumber(this.style, mxConstants.STYLE_SPACING, this.spacing) + 5;
  return new mxRectangle(t = s == mxConstants.ALIGN_CENTER ? t + (i - l) / 2 : s == mxConstants.ALIGN_RIGHT ? t + (i - l - a) : t + a, e = o == mxConstants.ALIGN_TOP ? e + a : o == mxConstants.ALIGN_BOTTOM ? e + (n - r - a) : e + (n - r) / 2, l, r);
}, mxLabel.prototype.paintIndicator = function (t, e, i, n, s) {
  null != this.indicator ? (this.indicator.bounds = this.getIndicatorBounds(e, i, n, s), this.indicator.paint(t)) : null != this.indicatorImage && (e = this.getIndicatorBounds(e, i, n, s), t.image(e.x, e.y, e.width, e.height, this.indicatorImage, !1, !1, !1));
}, mxLabel.prototype.getIndicatorBounds = function (t, e, i, n) {
  var s = mxUtils.getValue(this.style, mxConstants.STYLE_IMAGE_ALIGN, mxConstants.ALIGN_LEFT),
      o = mxUtils.getValue(this.style, mxConstants.STYLE_IMAGE_VERTICAL_ALIGN, mxConstants.ALIGN_MIDDLE),
      l = mxUtils.getNumber(this.style, mxConstants.STYLE_INDICATOR_WIDTH, this.indicatorSize),
      r = mxUtils.getNumber(this.style, mxConstants.STYLE_INDICATOR_HEIGHT, this.indicatorSize),
      a = this.spacing + 5;
  return new mxRectangle(t = s == mxConstants.ALIGN_RIGHT ? t + (i - l - a) : s == mxConstants.ALIGN_CENTER ? t + (i - l) / 2 : t + a, e = o == mxConstants.ALIGN_BOTTOM ? e + (n - r - a) : o == mxConstants.ALIGN_TOP ? e + a : e + (n - r) / 2, l, r);
}, mxLabel.prototype.redrawHtmlShape = function () {
  for (mxRectangleShape.prototype.redrawHtmlShape.apply(this, arguments); this.node.hasChildNodes();) {
    this.node.removeChild(this.node.lastChild);
  }

  if (null != this.image) {
    var t = document.createElement("img");
    t.style.position = "relative", t.setAttribute("border", "0");
    var e = this.getImageBounds(this.bounds.x, this.bounds.y, this.bounds.width, this.bounds.height);
    e.x -= this.bounds.x, e.y -= this.bounds.y, t.style.left = Math.round(e.x) + "px", t.style.top = Math.round(e.y) + "px", t.style.width = Math.round(e.width) + "px", t.style.height = Math.round(e.height) + "px", t.src = this.image, this.node.appendChild(t);
  }
}, mxUtils.extend(mxCylinder, mxShape), mxCylinder.prototype.maxHeight = 40, mxCylinder.prototype.svgStrokeTolerance = 0, mxCylinder.prototype.paintVertexShape = function (t, e, i, n, s) {
  t.translate(e, i), t.begin(), this.redrawPath(t, e, i, n, s, !1), t.fillAndStroke(), this.outline && null != this.style && 0 != mxUtils.getValue(this.style, mxConstants.STYLE_BACKGROUND_OUTLINE, 0) || (t.setShadow(!1), t.begin(), this.redrawPath(t, e, i, n, s, !0), t.stroke());
}, mxCylinder.prototype.getCylinderSize = function (t, e, i, n) {
  return Math.min(this.maxHeight, Math.round(n / 5));
}, mxCylinder.prototype.redrawPath = function (t, e, i, n, s, o) {
  e = this.getCylinderSize(e, i, n, s), (o && null != this.fill || !o && null == this.fill) && (t.moveTo(0, e), t.curveTo(0, 2 * e, n, 2 * e, n, e), o || (t.stroke(), t.begin())), o || (t.moveTo(0, e), t.curveTo(0, -e / 3, n, -e / 3, n, e), t.lineTo(n, s - e), t.curveTo(n, s + e / 3, 0, s + e / 3, 0, s - e), t.close());
}, mxUtils.extend(mxConnector, mxPolyline), mxConnector.prototype.updateBoundingBox = function () {
  this.useSvgBoundingBox = null != this.style && 1 == this.style[mxConstants.STYLE_CURVED], mxShape.prototype.updateBoundingBox.apply(this, arguments);
}, mxConnector.prototype.paintEdgeShape = function (t, e) {
  var i = this.createMarker(t, e, !0),
      n = this.createMarker(t, e, !1);
  mxPolyline.prototype.paintEdgeShape.apply(this, arguments), t.setFillColor(this.stroke), t.setShadow(!1), t.setDashed(!1), null != i && i(), null != n && n();
}, mxConnector.prototype.createMarker = function (t, e, i) {
  var n = null,
      s = e.length,
      o = mxUtils.getValue(this.style, i ? mxConstants.STYLE_STARTARROW : mxConstants.STYLE_ENDARROW),
      l = i ? e[1] : e[s - 2],
      r = i ? e[0] : e[s - 1];

  if (null != o && null != l && null != r) {
    for (n = 1; n < s - 1 && 0 == Math.round(l.x - r.x) && 0 == Math.round(l.y - r.y);) {
      l = i ? e[1 + n] : e[s - 2 - n], n++;
    }

    e = r.x - l.x, s = r.y - l.y, l = e / (n = Math.max(1, Math.sqrt(e * e + s * s))), e = s / n, s = mxUtils.getNumber(this.style, i ? mxConstants.STYLE_STARTSIZE : mxConstants.STYLE_ENDSIZE, mxConstants.DEFAULT_MARKERSIZE), n = mxMarker.createMarker(t, this, o, r, l, e, s, i, this.strokewidth, 0 != this.style[i ? mxConstants.STYLE_STARTFILL : mxConstants.STYLE_ENDFILL]);
  }

  return n;
}, mxConnector.prototype.augmentBoundingBox = function (t) {
  mxShape.prototype.augmentBoundingBox.apply(this, arguments);
  var e = 0;
  mxUtils.getValue(this.style, mxConstants.STYLE_STARTARROW, mxConstants.NONE) != mxConstants.NONE && (e = mxUtils.getNumber(this.style, mxConstants.STYLE_STARTSIZE, mxConstants.DEFAULT_MARKERSIZE) + 1), mxUtils.getValue(this.style, mxConstants.STYLE_ENDARROW, mxConstants.NONE) != mxConstants.NONE && (e = Math.max(e, mxUtils.getNumber(this.style, mxConstants.STYLE_ENDSIZE, mxConstants.DEFAULT_MARKERSIZE)) + 1), t.grow(e * this.scale);
}, mxUtils.extend(mxSwimlane, mxShape), mxSwimlane.prototype.imageSize = 16, mxSwimlane.prototype.isRoundable = function (t, e, i, n, s) {
  return !0;
}, mxSwimlane.prototype.getTitleSize = function () {
  return Math.max(0, mxUtils.getValue(this.style, mxConstants.STYLE_STARTSIZE, mxConstants.DEFAULT_STARTSIZE));
}, mxSwimlane.prototype.getLabelBounds = function (t) {
  var e = this.getTitleSize();
  t = new mxRectangle(t.x, t.y, t.width, t.height);
  var i = this.isHorizontal(),
      n = 1 == mxUtils.getValue(this.style, mxConstants.STYLE_FLIPH, 0),
      s = 1 == mxUtils.getValue(this.style, mxConstants.STYLE_FLIPV, 0),
      o = this.direction == mxConstants.DIRECTION_NORTH || this.direction == mxConstants.DIRECTION_SOUTH;
  n = !(i = i == !o) && n != (this.direction == mxConstants.DIRECTION_SOUTH || this.direction == mxConstants.DIRECTION_WEST), s = i && s != (this.direction == mxConstants.DIRECTION_SOUTH || this.direction == mxConstants.DIRECTION_WEST);
  return o ? (e = Math.min(t.width, e * this.scale), (n || s) && (t.x += t.width - e), t.width = e) : (e = Math.min(t.height, e * this.scale), (n || s) && (t.y += t.height - e), t.height = e), t;
}, mxSwimlane.prototype.getGradientBounds = function (t, e, i, n, s) {
  return t = this.getTitleSize(), this.isHorizontal() ? new mxRectangle(e, i, n, t = Math.min(t, s)) : new mxRectangle(e, i, t = Math.min(t, n), s);
}, mxSwimlane.prototype.getArcSize = function (t, e, i) {
  return i * (mxUtils.getValue(this.style, mxConstants.STYLE_ARCSIZE, 100 * mxConstants.RECTANGLE_ROUNDING_FACTOR) / 100) * 3;
}, mxSwimlane.prototype.isHorizontal = function () {
  return 1 == mxUtils.getValue(this.style, mxConstants.STYLE_HORIZONTAL, 1);
}, mxSwimlane.prototype.paintVertexShape = function (t, e, i, n, s) {
  var o = this.getTitleSize(),
      l = mxUtils.getValue(this.style, mxConstants.STYLE_SWIMLANE_FILLCOLOR, mxConstants.NONE),
      r = 1 == mxUtils.getValue(this.style, mxConstants.STYLE_SWIMLANE_LINE, 1),
      a = 0;
  o = this.isHorizontal() ? Math.min(o, s) : Math.min(o, n);
  t.translate(e, i), this.isRounded ? (a = this.getArcSize(n, s, o), a = Math.min((this.isHorizontal() ? s : n) - o, Math.min(o, a)), this.paintRoundedSwimlane(t, e, i, n, s, o, a, l, r)) : this.paintSwimlane(t, e, i, n, s, o, l, r), l = mxUtils.getValue(this.style, mxConstants.STYLE_SEPARATORCOLOR, mxConstants.NONE), this.paintSeparator(t, e, i, n, s, o, l), null != this.image && (s = this.getImageBounds(e, i, n, s), t.image(s.x - e, s.y - i, s.width, s.height, this.image, !1, !1, !1)), this.glass && (t.setShadow(!1), this.paintGlassEffect(t, 0, 0, n, o, a));
}, mxSwimlane.prototype.paintSwimlane = function (t, e, i, n, s, o, l, r) {
  t.begin(), this.isHorizontal() ? (t.moveTo(0, o), t.lineTo(0, 0), t.lineTo(n, 0), t.lineTo(n, o), t.fillAndStroke(), o < s && (l == mxConstants.NONE ? t.pointerEvents = !1 : t.setFillColor(l), t.begin(), t.moveTo(0, o), t.lineTo(0, s), t.lineTo(n, s), t.lineTo(n, o), l == mxConstants.NONE ? t.stroke() : t.fillAndStroke())) : (t.moveTo(o, 0), t.lineTo(0, 0), t.lineTo(0, s), t.lineTo(o, s), t.fillAndStroke(), o < n && (l == mxConstants.NONE ? t.pointerEvents = !1 : t.setFillColor(l), t.begin(), t.moveTo(o, 0), t.lineTo(n, 0), t.lineTo(n, s), t.lineTo(o, s), l == mxConstants.NONE ? t.stroke() : t.fillAndStroke())), r && this.paintDivider(t, e, i, n, s, o, l == mxConstants.NONE);
}, mxSwimlane.prototype.paintRoundedSwimlane = function (t, e, i, n, s, o, l, r, a) {
  t.begin(), this.isHorizontal() ? (t.moveTo(n, o), t.lineTo(n, l), t.quadTo(n, 0, n - Math.min(n / 2, l), 0), t.lineTo(Math.min(n / 2, l), 0), t.quadTo(0, 0, 0, l), t.lineTo(0, o), t.fillAndStroke(), o < s && (r == mxConstants.NONE ? t.pointerEvents = !1 : t.setFillColor(r), t.begin(), t.moveTo(0, o), t.lineTo(0, s - l), t.quadTo(0, s, Math.min(n / 2, l), s), t.lineTo(n - Math.min(n / 2, l), s), t.quadTo(n, s, n, s - l), t.lineTo(n, o), r == mxConstants.NONE ? t.stroke() : t.fillAndStroke())) : (t.moveTo(o, 0), t.lineTo(l, 0), t.quadTo(0, 0, 0, Math.min(s / 2, l)), t.lineTo(0, s - Math.min(s / 2, l)), t.quadTo(0, s, l, s), t.lineTo(o, s), t.fillAndStroke(), o < n && (r == mxConstants.NONE ? t.pointerEvents = !1 : t.setFillColor(r), t.begin(), t.moveTo(o, s), t.lineTo(n - l, s), t.quadTo(n, s, n, s - Math.min(s / 2, l)), t.lineTo(n, Math.min(s / 2, l)), t.quadTo(n, 0, n - l, 0), t.lineTo(o, 0), r == mxConstants.NONE ? t.stroke() : t.fillAndStroke())), a && this.paintDivider(t, e, i, n, s, o, r == mxConstants.NONE);
}, mxSwimlane.prototype.paintDivider = function (t, e, i, n, s, o, l) {
  l || t.setShadow(!1), t.begin(), this.isHorizontal() ? (t.moveTo(0, o), t.lineTo(n, o)) : (t.moveTo(o, 0), t.lineTo(o, s)), t.stroke();
}, mxSwimlane.prototype.paintSeparator = function (t, e, i, n, s, o, l) {
  l != mxConstants.NONE && (t.setStrokeColor(l), t.setDashed(!0), t.begin(), this.isHorizontal() ? (t.moveTo(n, o), t.lineTo(n, s)) : (t.moveTo(o, 0), t.lineTo(n, 0)), t.stroke(), t.setDashed(!1));
}, mxSwimlane.prototype.getImageBounds = function (t, e, i, n) {
  return this.isHorizontal() ? new mxRectangle(t + i - this.imageSize, e, this.imageSize, this.imageSize) : new mxRectangle(t, e, this.imageSize, this.imageSize);
}, mxGraphLayout.prototype.graph = null, mxGraphLayout.prototype.useBoundingBox = !0, mxGraphLayout.prototype.parent = null, mxGraphLayout.prototype.moveCell = function (t, e, i) {}, mxGraphLayout.prototype.execute = function (t) {}, mxGraphLayout.prototype.getGraph = function () {
  return this.graph;
}, mxGraphLayout.prototype.getConstraint = function (t, e, i, n) {
  return null != (e = null != (i = this.graph.view.getState(e)) ? i.style : this.graph.getCellStyle(e)) ? e[t] : null;
}, mxGraphLayout.traverse = function (t, e, i, n, s) {
  if (null != i && null != t && (e = null == e || e, !(s = s || new mxDictionary()).get(t) && (s.put(t, !0), null == (n = i(t, n)) || n)) && 0 < (n = this.graph.model.getEdgeCount(t))) for (var o = 0; o < n; o++) {
    var l = this.graph.model.getEdgeAt(t, o),
        r = this.graph.model.getTerminal(l, !0) == t;
    e && !r || (r = this.graph.view.getVisibleTerminal(l, !r), this.traverse(r, e, i, l, s));
  }
}, mxGraphLayout.prototype.isAncestor = function (t, e, i) {
  if (!i) return this.graph.model.getParent(e) == t;
  if (e == t) return !1;

  for (; null != e && e != t;) {
    e = this.graph.model.getParent(e);
  }

  return e == t;
}, mxGraphLayout.prototype.isVertexMovable = function (t) {
  return this.graph.isCellMovable(t);
}, mxGraphLayout.prototype.isVertexIgnored = function (t) {
  return !this.graph.getModel().isVertex(t) || !this.graph.isCellVisible(t);
}, mxGraphLayout.prototype.isEdgeIgnored = function (t) {
  var e = this.graph.getModel();
  return !e.isEdge(t) || !this.graph.isCellVisible(t) || null == e.getTerminal(t, !0) || null == e.getTerminal(t, !1);
}, mxGraphLayout.prototype.setEdgeStyleEnabled = function (t, e) {
  this.graph.setCellStyles(mxConstants.STYLE_NOEDGESTYLE, e ? "0" : "1", [t]);
}, mxGraphLayout.prototype.setOrthogonalEdge = function (t, e) {
  this.graph.setCellStyles(mxConstants.STYLE_ORTHOGONAL, e ? "1" : "0", [t]);
}, mxGraphLayout.prototype.getParentOffset = function (t) {
  var e = new mxPoint();

  if (null != t && t != this.parent) {
    var i = this.graph.getModel();
    if (i.isAncestor(this.parent, t)) for (var n = i.getGeometry(t); t != this.parent;) {
      e.x += n.x, e.y += n.y, t = i.getParent(t), n = i.getGeometry(t);
    }
  }

  return e;
}, mxGraphLayout.prototype.setEdgePoints = function (t, e) {
  if (null != t) {
    var i = this.graph.model,
        n = i.getGeometry(t);
    if (null == n ? (n = new mxGeometry()).setRelative(!0) : n = n.clone(), null != this.parent && null != e) for (var s = i.getParent(t), o = (s = this.getParentOffset(s), 0); o < e.length; o++) {
      e[o].x -= s.x, e[o].y -= s.y;
    }
    n.points = e, i.setGeometry(t, n);
  }
}, mxGraphLayout.prototype.setVertexLocation = function (t, e, i) {
  var n = this.graph.getModel(),
      s = n.getGeometry(t),
      o = null;

  if (null != s) {
    if (o = new mxRectangle(e, i, s.width, s.height), this.useBoundingBox) {
      var l = this.graph.getView().getState(t);

      if (null != l && null != l.text && null != l.text.boundingBox) {
        var r = this.graph.getView().scale,
            a = l.text.boundingBox;
        l.text.boundingBox.x < l.x && (e += (l.x - a.x) / r, o.width = a.width), l.text.boundingBox.y < l.y && (i += (l.y - a.y) / r, o.height = a.height);
      }
    }

    null != this.parent && null != (l = n.getParent(t)) && l != this.parent && (e -= (l = this.getParentOffset(l)).x, i -= l.y), s.x == e && s.y == i || ((s = s.clone()).x = e, s.y = i, n.setGeometry(t, s));
  }

  return o;
}, mxGraphLayout.prototype.getVertexBounds = function (t) {
  var e = this.graph.getModel().getGeometry(t);

  if (this.useBoundingBox) {
    var i = this.graph.getView().getState(t);

    if (null != i && null != i.text && null != i.text.boundingBox) {
      var n = this.graph.getView().scale,
          s = i.text.boundingBox,
          o = Math.max(i.x - s.x, 0) / n,
          l = Math.max(i.y - s.y, 0) / n;
      e = new mxRectangle(e.x - o, e.y - l, e.width + o + Math.max(s.x + s.width - (i.x + i.width), 0) / n, e.height + l + Math.max(s.y + s.height - (i.y + i.height), 0) / n);
    }
  }

  return null != this.parent && (t = this.graph.getModel().getParent(t), e = e.clone(), null != t && t != this.parent && (t = this.getParentOffset(t), e.x += t.x, e.y += t.y)), new mxRectangle(e.x, e.y, e.width, e.height);
}, mxGraphLayout.prototype.arrangeGroups = function (t, e, i, n, s, o) {
  return this.graph.updateGroupBounds(t, e, !0, i, n, s, o);
}, WeightedCellSorter.prototype.weightedValue = 0, WeightedCellSorter.prototype.nudge = !1, WeightedCellSorter.prototype.visited = !1, WeightedCellSorter.prototype.rankIndex = null, WeightedCellSorter.prototype.cell = null, WeightedCellSorter.prototype.compare = function (t, e) {
  return null != t && null != e ? e.weightedValue > t.weightedValue ? -1 : e.weightedValue < t.weightedValue ? 1 : e.nudge ? -1 : 1 : 0;
}, mxStackLayout.prototype = new mxGraphLayout(), mxStackLayout.prototype.constructor = mxStackLayout, mxStackLayout.prototype.horizontal = null, mxStackLayout.prototype.spacing = null, mxStackLayout.prototype.x0 = null, mxStackLayout.prototype.y0 = null, mxStackLayout.prototype.border = 0, mxStackLayout.prototype.marginTop = 0, mxStackLayout.prototype.marginLeft = 0, mxStackLayout.prototype.marginRight = 0, mxStackLayout.prototype.marginBottom = 0, mxStackLayout.prototype.keepFirstLocation = !1, mxStackLayout.prototype.fill = !1, mxStackLayout.prototype.resizeParent = !1, mxStackLayout.prototype.resizeParentMax = !1, mxStackLayout.prototype.resizeLast = !1, mxStackLayout.prototype.wrap = null, mxStackLayout.prototype.borderCollapse = !0, mxStackLayout.prototype.isHorizontal = function () {
  return this.horizontal;
}, mxStackLayout.prototype.moveCell = function (t, e, i) {
  var n = this.graph.getModel(),
      s = n.getParent(t),
      o = this.isHorizontal();

  if (null != t && null != s) {
    var l = 0,
        r = n.getChildCount(s);

    for (i = o ? e : i, null != (e = this.graph.getView().getState(s)) && (i -= o ? e.x : e.y), i /= this.graph.view.scale, e = 0; e < r; e++) {
      var a = n.getChildAt(s, e);

      if (a != t && null != (a = n.getGeometry(a))) {
        if (a = o ? a.x + a.width / 2 : a.y + a.height / 2, l <= i && a > i) break;
        l = a;
      }
    }

    o = s.getIndex(t), o = Math.max(0, e - (e > o ? 1 : 0)), n.add(s, t, o);
  }
}, mxStackLayout.prototype.getParentSize = function (t) {
  var e = this.graph.getModel(),
      i = e.getGeometry(t);
  return null != this.graph.container && (null == i && e.isLayer(t) || t == this.graph.getView().currentRoot) && (i = new mxRectangle(0, 0, this.graph.container.offsetWidth - 1, this.graph.container.offsetHeight - 1)), i;
}, mxStackLayout.prototype.execute = function (t) {
  if (null != t) {
    var e = this.getParentSize(t),
        i = this.isHorizontal(),
        n = this.graph.getModel(),
        s = null;
    null != e && (s = i ? e.height - this.marginTop - this.marginBottom : e.width - this.marginLeft - this.marginRight);
    s = s - 2 * this.border;
    var o = this.x0 + this.border + this.marginLeft,
        l = this.y0 + this.border + this.marginTop;

    if (this.graph.isSwimlane(t)) {
      var r = this.graph.getCellStyle(t),
          a = mxUtils.getNumber(r, mxConstants.STYLE_STARTSIZE, mxConstants.DEFAULT_STARTSIZE);
      r = 1 == mxUtils.getValue(r, mxConstants.STYLE_HORIZONTAL, !0);
      null != e && (a = r ? Math.min(a, e.height) : Math.min(a, e.width)), i == r && (s -= a), r ? l += a : o += a;
    }

    n.beginUpdate();

    try {
      a = 0, r = null;

      for (var h = 0, u = null, d = n.getChildCount(t), p = 0; p < d; p++) {
        var c = n.getChildAt(t, p);

        if (!this.isVertexIgnored(c) && this.isVertexMovable(c)) {
          var m = n.getGeometry(c);

          if (null != m) {
            m = m.clone(), null != this.wrap && null != r && (i && r.x + r.width + m.width + 2 * this.spacing > this.wrap || !i && r.y + r.height + m.height + 2 * this.spacing > this.wrap) && (r = null, i ? l += a + this.spacing : o += a + this.spacing, a = 0);
            a = Math.max(a, i ? m.height : m.width);
            var g = 0;

            if (!this.borderCollapse) {
              var x = this.graph.getCellStyle(c);
              g = mxUtils.getNumber(x, mxConstants.STYLE_STROKEWIDTH, 1);
            }

            null != r ? i ? m.x = h + this.spacing + Math.floor(g / 2) : m.y = h + this.spacing + Math.floor(g / 2) : this.keepFirstLocation || (i ? m.x = o : m.y = l), i ? m.y = l : m.x = o, this.fill && null != s && (i ? m.height = s : m.width = s), this.setChildGeometry(c, m), u = c, r = m, h = i ? r.x + r.width + Math.floor(g / 2) : r.y + r.height + Math.floor(g / 2);
          }
        }
      }

      this.resizeParent && null != e && null != r && !this.graph.isCellCollapsed(t) ? this.updateParentGeometry(t, e, r) : this.resizeLast && null != e && null != r && null != u && (i ? r.width = e.width - r.x - this.spacing - this.marginRight - this.marginLeft : r.height = e.height - r.y - this.spacing - this.marginBottom, this.setChildGeometry(u, r));
    } finally {
      n.endUpdate();
    }
  }
}, mxStackLayout.prototype.setChildGeometry = function (t, e) {
  var i = this.graph.getCellGeometry(t);
  null != i && e.x == i.x && e.y == i.y && e.width == i.width && e.height == i.height || this.graph.getModel().setGeometry(t, e);
}, mxStackLayout.prototype.updateParentGeometry = function (t, e, i) {
  var n = this.isHorizontal(),
      s = this.graph.getModel(),
      o = e.clone();
  n ? (i = i.x + i.width + this.marginRight + this.border, o.width = this.resizeParentMax ? Math.max(o.width, i) : i) : (i = i.y + i.height + this.marginBottom + this.border, o.height = this.resizeParentMax ? Math.max(o.height, i) : i), e.x == o.x && e.y == o.y && e.width == o.width && e.height == o.height || s.setGeometry(t, o);
}, mxPartitionLayout.prototype = new mxGraphLayout(), mxPartitionLayout.prototype.constructor = mxPartitionLayout, mxPartitionLayout.prototype.horizontal = null, mxPartitionLayout.prototype.spacing = null, mxPartitionLayout.prototype.border = null, mxPartitionLayout.prototype.resizeVertices = !0, mxPartitionLayout.prototype.isHorizontal = function () {
  return this.horizontal;
}, mxPartitionLayout.prototype.moveCell = function (t, e, i) {
  var n = (i = this.graph.getModel()).getParent(t);

  if (null != t && null != n) {
    var s,
        o = 0,
        l = i.getChildCount(n);

    for (s = 0; s < l; s++) {
      var r = i.getChildAt(n, s);

      if (null != (r = this.getVertexBounds(r))) {
        if (r = r.x + r.width / 2, o < e && r > e) break;
        o = r;
      }
    }

    e = n.getIndex(t), e = Math.max(0, s - (s > e ? 1 : 0)), i.add(n, t, e);
  }
}, mxPartitionLayout.prototype.execute = function (t) {
  var e = this.isHorizontal(),
      i = this.graph.getModel(),
      n = i.getGeometry(t);

  if (null != this.graph.container && (null == n && i.isLayer(t) || t == this.graph.getView().currentRoot) && (n = new mxRectangle(0, 0, this.graph.container.offsetWidth - 1, this.graph.container.offsetHeight - 1)), null != n) {
    for (var s = [], o = i.getChildCount(t), l = 0; l < o; l++) {
      var r = i.getChildAt(t, l);
      !this.isVertexIgnored(r) && this.isVertexMovable(r) && s.push(r);
    }

    if (0 < (o = s.length)) {
      var a = this.border,
          h = this.border,
          u = (u = e ? n.height : n.width) - 2 * this.border;

      if (t = this.graph.isSwimlane(t) ? this.graph.getStartSize(t) : new mxRectangle(), u -= e ? t.height : t.width, a += t.width, h += t.height, t = this.border + (o - 1) * this.spacing, 0 < (n = e ? (n.width - a - t) / o : (n.height - h - t) / o)) {
        i.beginUpdate();

        try {
          for (l = 0; l < o; l++) {
            r = s[l];
            var d = i.getGeometry(r);
            null != d && ((d = d.clone()).x = a, d.y = h, e ? (this.resizeVertices && (d.width = n, d.height = u), a += n + this.spacing) : (this.resizeVertices && (d.height = n, d.width = u), h += n + this.spacing), i.setGeometry(r, d));
          }
        } finally {
          i.endUpdate();
        }
      }
    }
  }
}, mxCompactTreeLayout.prototype = new mxGraphLayout(), mxCompactTreeLayout.prototype.constructor = mxCompactTreeLayout, mxCompactTreeLayout.prototype.horizontal = null, mxCompactTreeLayout.prototype.invert = null, mxCompactTreeLayout.prototype.resizeParent = !0, mxCompactTreeLayout.prototype.maintainParentLocation = !1, mxCompactTreeLayout.prototype.groupPadding = 10, mxCompactTreeLayout.prototype.groupPaddingTop = 0, mxCompactTreeLayout.prototype.groupPaddingRight = 0, mxCompactTreeLayout.prototype.groupPaddingBottom = 0, mxCompactTreeLayout.prototype.groupPaddingLeft = 0, mxCompactTreeLayout.prototype.parentsChanged = null, mxCompactTreeLayout.prototype.moveTree = !1, mxCompactTreeLayout.prototype.visited = null, mxCompactTreeLayout.prototype.levelDistance = 10, mxCompactTreeLayout.prototype.nodeDistance = 20, mxCompactTreeLayout.prototype.resetEdges = !0, mxCompactTreeLayout.prototype.prefHozEdgeSep = 5, mxCompactTreeLayout.prototype.prefVertEdgeOff = 4, mxCompactTreeLayout.prototype.minEdgeJetty = 8, mxCompactTreeLayout.prototype.channelBuffer = 4, mxCompactTreeLayout.prototype.edgeRouting = !0, mxCompactTreeLayout.prototype.sortEdges = !1, mxCompactTreeLayout.prototype.alignRanks = !1, mxCompactTreeLayout.prototype.maxRankHeight = null, mxCompactTreeLayout.prototype.root = null, mxCompactTreeLayout.prototype.node = null, mxCompactTreeLayout.prototype.isVertexIgnored = function (t) {
  return mxGraphLayout.prototype.isVertexIgnored.apply(this, arguments) || 0 == this.graph.getConnections(t).length;
}, mxCompactTreeLayout.prototype.isHorizontal = function () {
  return this.horizontal;
}, mxCompactTreeLayout.prototype.execute = function (t, e) {
  this.parent = t;
  var i = this.graph.getModel();
  if (null == e) {
    if (0 < this.graph.getEdges(t, i.getParent(t), this.invert, !this.invert, !1).length) this.root = t;else {
      if (0 < (l = this.graph.findTreeRoots(t, !0, this.invert)).length) for (var n = 0; n < l.length; n++) {
        if (!this.isVertexIgnored(l[n]) && 0 < this.graph.getEdges(l[n], null, this.invert, !this.invert, !1).length) {
          this.root = l[n];
          break;
        }
      }
    }
  } else this.root = e;

  if (null != this.root) {
    if (this.parentsChanged = this.resizeParent ? {} : null, this.parentY = this.parentX = null, t != this.root && null != i.isVertex(t) && this.maintainParentLocation) {
      var s = this.graph.getCellGeometry(t);
      null != s && (this.parentX = s.x, this.parentY = s.y);
    }

    i.beginUpdate();

    try {
      if (this.visited = {}, this.node = this.dfs(this.root, t), this.alignRanks && (this.maxRankHeight = [], this.findRankHeights(this.node, 0), this.setCellHeights(this.node, 0)), null != this.node) {
        this.layout(this.node);
        var o = this.graph.gridSize,
            l = o;

        if (!this.moveTree) {
          var r = this.getVertexBounds(this.root);
          null != r && (o = r.x, l = r.y);
        }

        if (r = null, null != (r = this.isHorizontal() ? this.horizontalLayout(this.node, o, l) : this.verticalLayout(this.node, null, o, l))) {
          var a = n = 0;
          0 > r.x && (n = Math.abs(o - r.x)), 0 > r.y && (a = Math.abs(l - r.y)), 0 == n && 0 == a || this.moveNode(this.node, n, a), this.resizeParent && this.adjustParents(), this.edgeRouting && this.localEdgeProcessing(this.node);
        }

        null != this.parentX && null != this.parentY && null != (s = this.graph.getCellGeometry(t)) && ((s = s.clone()).x = this.parentX, s.y = this.parentY, i.setGeometry(t, s));
      }
    } finally {
      i.endUpdate();
    }
  }
}, mxCompactTreeLayout.prototype.moveNode = function (t, e, i) {
  for (t.x += e, t.y += i, this.apply(t), t = t.child; null != t;) {
    this.moveNode(t, e, i), t = t.next;
  }
}, mxCompactTreeLayout.prototype.sortOutgoingEdges = function (t, e) {
  var i = new mxDictionary();
  e.sort(function (e, n) {
    var s = e.getTerminal(e.getTerminal(!1) == t),
        o = i.get(s);
    null == o && (o = mxCellPath.create(s).split(mxCellPath.PATH_SEPARATOR), i.put(s, o));
    s = n.getTerminal(n.getTerminal(!1) == t);
    var l = i.get(s);
    return null == l && (l = mxCellPath.create(s).split(mxCellPath.PATH_SEPARATOR), i.put(s, l)), mxCellPath.compare(o, l);
  });
}, mxCompactTreeLayout.prototype.findRankHeights = function (t, e) {
  (null == this.maxRankHeight[e] || this.maxRankHeight[e] < t.height) && (this.maxRankHeight[e] = t.height);

  for (var i = t.child; null != i;) {
    this.findRankHeights(i, e + 1), i = i.next;
  }
}, mxCompactTreeLayout.prototype.setCellHeights = function (t, e) {
  null != this.maxRankHeight[e] && this.maxRankHeight[e] > t.height && (t.height = this.maxRankHeight[e]);

  for (var i = t.child; null != i;) {
    this.setCellHeights(i, e + 1), i = i.next;
  }
}, mxCompactTreeLayout.prototype.dfs = function (t, e) {
  var i = mxCellPath.create(t),
      n = null;

  if (null != t && null == this.visited[i] && !this.isVertexIgnored(t)) {
    this.visited[i] = t;
    n = this.createNode(t), i = this.graph.getModel();
    var s = null,
        o = this.graph.getEdges(t, e, this.invert, !this.invert, !1, !0),
        l = this.graph.getView();
    this.sortEdges && this.sortOutgoingEdges(t, o);

    for (var r = 0; r < o.length; r++) {
      var a = o[r];

      if (!this.isEdgeIgnored(a)) {
        this.resetEdges && this.setEdgePoints(a, null), this.edgeRouting && (this.setEdgeStyleEnabled(a, !1), this.setEdgePoints(a, null));
        var h;
        a = null != (h = l.getState(a)) ? h.getVisibleTerminal(this.invert) : l.getVisibleTerminal(a, this.invert);
        null != (h = this.dfs(a, e)) && null != i.getGeometry(a) && (null == s ? n.child = h : s.next = h, s = h);
      }
    }
  }

  return n;
}, mxCompactTreeLayout.prototype.layout = function (t) {
  if (null != t) {
    for (var e = t.child; null != e;) {
      this.layout(e), e = e.next;
    }

    null != t.child ? this.attachParent(t, this.join(t)) : this.layoutLeaf(t);
  }
}, mxCompactTreeLayout.prototype.horizontalLayout = function (t, e, i, n) {
  if (t.x += e + t.offsetX, t.y += i + t.offsetY, n = this.apply(t, n), null != (e = t.child)) {
    n = this.horizontalLayout(e, t.x, t.y, n), i = t.y + e.offsetY;

    for (var s = e.next; null != s;) {
      n = this.horizontalLayout(s, t.x + e.offsetX, i, n), i += s.offsetY, s = s.next;
    }
  }

  return n;
}, mxCompactTreeLayout.prototype.verticalLayout = function (t, e, i, n, s) {
  if (t.x += i + t.offsetY, t.y += n + t.offsetX, s = this.apply(t, s), null != (e = t.child)) for (s = this.verticalLayout(e, t, t.x, t.y, s), i = t.x + e.offsetY, n = e.next; null != n;) {
    s = this.verticalLayout(n, t, i, t.y + e.offsetX, s), i += n.offsetY, n = n.next;
  }
  return s;
}, mxCompactTreeLayout.prototype.attachParent = function (t, e) {
  var i = this.nodeDistance + this.levelDistance,
      n = (e - t.width) / 2 - this.nodeDistance,
      s = n + t.width + 2 * this.nodeDistance - e;
  t.child.offsetX = i + t.height, t.child.offsetY = s, t.contour.upperHead = this.createLine(t.height, 0, this.createLine(i, s, t.contour.upperHead)), t.contour.lowerHead = this.createLine(t.height, 0, this.createLine(i, n, t.contour.lowerHead));
}, mxCompactTreeLayout.prototype.layoutLeaf = function (t) {
  var e = 2 * this.nodeDistance;
  t.contour.upperTail = this.createLine(t.height + e, 0), t.contour.upperHead = t.contour.upperTail, t.contour.lowerTail = this.createLine(0, -t.width - e), t.contour.lowerHead = this.createLine(t.height + e, 0, t.contour.lowerTail);
}, mxCompactTreeLayout.prototype.join = function (t) {
  var e = 2 * this.nodeDistance,
      i = t.child;
  t.contour = i.contour;
  var n = i.width + e,
      s = n;

  for (i = i.next; null != i;) {
    var o = this.merge(t.contour, i.contour);
    i.offsetY = o + n, i.offsetX = 0, s += o + (n = i.width + e), i = i.next;
  }

  return s;
}, mxCompactTreeLayout.prototype.merge = function (t, e) {
  for (var i = 0, n = 0, s = 0, o = t.lowerHead, l = e.upperHead; null != l && null != o;) {
    var r = this.offset(i, n, l.dx, l.dy, o.dx, o.dy);
    n = n + r, s = s + r;
    i + l.dx <= o.dx ? (i += l.dx, n += l.dy, l = l.next) : (i -= o.dx, n -= o.dy, o = o.next);
  }

  return null != l ? (i = this.bridge(t.upperTail, 0, 0, l, i, n), t.upperTail = null != i.next ? e.upperTail : i, t.lowerTail = e.lowerTail) : null == (i = this.bridge(e.lowerTail, i, n, o, 0, 0)).next && (t.lowerTail = i), t.lowerHead = e.lowerHead, s;
}, mxCompactTreeLayout.prototype.offset = function (t, e, i, n, s, o) {
  return s <= t || 0 >= t + i ? 0 : 0 < (t = 0 < s * n - i * o ? 0 > t ? t * n / i - e : 0 < t ? t * o / s - e : -e : s < t + i ? o - (e + (s - t) * n / i) : s > t + i ? (i + t) * o / s - (e + n) : o - (e + n)) ? t : 0;
}, mxCompactTreeLayout.prototype.bridge = function (t, e, i, n, s, o) {
  return e = s + n.dx - e, 0 == n.dx ? s = n.dy : (s = e * n.dy, s /= n.dx), e = this.createLine(e, s, n.next), t.next = this.createLine(0, o + n.dy - s - i, e), e;
}, mxCompactTreeLayout.prototype.createNode = function (t) {
  var e = {};
  return e.cell = t, e.x = 0, e.y = 0, e.width = 0, e.height = 0, null != (t = this.getVertexBounds(t)) && (this.isHorizontal() ? (e.width = t.height, e.height = t.width) : (e.width = t.width, e.height = t.height)), e.offsetX = 0, e.offsetY = 0, e.contour = {}, e;
}, mxCompactTreeLayout.prototype.apply = function (t, e) {
  var i = this.graph.getModel(),
      n = t.cell,
      s = i.getGeometry(n);
  return null != n && null != s && (this.isVertexMovable(n) && (s = this.setVertexLocation(n, t.x, t.y), this.resizeParent && (i = i.getParent(n), n = mxCellPath.create(i), null == this.parentsChanged[n] && (this.parentsChanged[n] = i))), e = null == e ? new mxRectangle(s.x, s.y, s.width, s.height) : new mxRectangle(Math.min(e.x, s.x), Math.min(e.y, s.y), Math.max(e.x + e.width, s.x + s.width), Math.max(e.y + e.height, s.y + s.height))), e;
}, mxCompactTreeLayout.prototype.createLine = function (t, e, i) {
  var n = {};
  return n.dx = t, n.dy = e, n.next = i, n;
}, mxCompactTreeLayout.prototype.adjustParents = function () {
  var t,
      e = [];

  for (t in this.parentsChanged) {
    e.push(this.parentsChanged[t]);
  }

  this.arrangeGroups(mxUtils.sortCells(e, !0), this.groupPadding, this.groupPaddingTop, this.groupPaddingRight, this.groupPaddingBottom, this.groupPaddingLeft);
}, mxCompactTreeLayout.prototype.localEdgeProcessing = function (t) {
  for (this.processNodeOutgoing(t), t = t.child; null != t;) {
    this.localEdgeProcessing(t), t = t.next;
  }
}, mxCompactTreeLayout.prototype.processNodeOutgoing = function (t) {
  for (var e = t.child, i = t.cell, n = 0, s = []; null != e;) {
    n++;
    var o = e.x;
    this.horizontal && (o = e.y), s.push(new WeightedCellSorter(e, o)), e = e.next;
  }

  s.sort(WeightedCellSorter.prototype.compare), (o = t.width) > (l = (n + 1) * this.prefHozEdgeSep) + 2 * this.prefHozEdgeSep && (o -= 2 * this.prefHozEdgeSep), e = (t = o / n) / 2, o > l + 2 * this.prefHozEdgeSep && (e += this.prefHozEdgeSep);
  o = this.minEdgeJetty - this.prefVertEdgeOff;

  for (var l = this.getVertexBounds(i), r = 0; r < s.length; r++) {
    for (var a, h, u = s[r].cell.cell, d = this.getVertexBounds(u), p = (u = this.graph.getEdgesBetween(i, u, !1), []), c = 0; c < u.length; c++) {
      this.horizontal ? (a = l.x + l.width, h = l.y + e, p.push(new mxPoint(a, h)), a = l.x + l.width + o, p.push(new mxPoint(a, h)), h = d.y + d.height / 2) : (a = l.x + e, h = l.y + l.height, p.push(new mxPoint(a, h)), h = l.y + l.height + o, p.push(new mxPoint(a, h)), a = d.x + d.width / 2), p.push(new mxPoint(a, h)), this.setEdgePoints(u[c], p);
    }

    r < n / 2 ? o += this.prefVertEdgeOff : r > n / 2 && (o -= this.prefVertEdgeOff), e += t;
  }
}, mxUtils.extend(mxRadialTreeLayout, mxCompactTreeLayout), mxRadialTreeLayout.prototype.angleOffset = .5, mxRadialTreeLayout.prototype.rootx = 0, mxRadialTreeLayout.prototype.rooty = 0, mxRadialTreeLayout.prototype.levelDistance = 120, mxRadialTreeLayout.prototype.nodeDistance = 10, mxRadialTreeLayout.prototype.autoRadius = !1, mxRadialTreeLayout.prototype.sortEdges = !1, mxRadialTreeLayout.prototype.rowMinX = [], mxRadialTreeLayout.prototype.rowMaxX = [], mxRadialTreeLayout.prototype.rowMinCenX = [], mxRadialTreeLayout.prototype.rowMaxCenX = [], mxRadialTreeLayout.prototype.rowRadi = [], mxRadialTreeLayout.prototype.row = [], mxRadialTreeLayout.prototype.isVertexIgnored = function (t) {
  return mxGraphLayout.prototype.isVertexIgnored.apply(this, arguments) || 0 == this.graph.getConnections(t).length;
}, mxRadialTreeLayout.prototype.execute = function (t, e) {
  this.parent = t, this.edgeRouting = this.useBoundingBox = !1, mxCompactTreeLayout.prototype.execute.apply(this, arguments);
  var i = null,
      n = this.getVertexBounds(this.root);

  for (var s in this.centerX = n.x + n.width / 2, this.centerY = n.y + n.height / 2, this.visited) {
    var o = this.getVertexBounds(this.visited[s]);
    (i = null != i ? i : o.clone()).add(o);
  }

  this.calcRowDims([this.node], 0);
  var l = 0,
      r = 0;

  for (i = 0; i < this.row.length; i++) {
    s = (this.rowMaxX[i] - this.centerX - this.nodeDistance) / this.rowRadi[i], l = Math.max(l, (this.centerX - this.rowMinX[i] - this.nodeDistance) / this.rowRadi[i]), r = Math.max(r, s);
  }

  for (i = 0; i < this.row.length; i++) {
    var a = this.centerX - this.nodeDistance - l * this.rowRadi[i],
        h = this.centerX + this.nodeDistance + r * this.rowRadi[i] - a;

    for (s = 0; s < this.row[i].length; s++) {
      n = (o = this.row[i])[s], o = this.getVertexBounds(n.cell), n.theta = (o.x + o.width / 2 - a) / h * Math.PI * 2;
    }
  }

  for (i = this.row.length - 2; 0 <= i; i--) {
    for (o = this.row[i], s = 0; s < o.length; s++) {
      for (l = (n = o[s]).child, a = r = 0; null != l;) {
        a += l.theta, r++, l = l.next;
      }

      0 < r && ((l = a / r) > n.theta && s < o.length - 1 ? n.theta = Math.min(l, o[s + 1].theta - Math.PI / 10) : l < n.theta && 0 < s && (n.theta = Math.max(l, o[s - 1].theta + Math.PI / 10)));
    }
  }

  for (i = 0; i < this.row.length; i++) {
    for (s = 0; s < this.row[i].length; s++) {
      n = (o = this.row[i])[s], o = this.getVertexBounds(n.cell), this.setVertexLocation(n.cell, this.centerX - o.width / 2 + this.rowRadi[i] * Math.cos(n.theta), this.centerY - o.height / 2 + this.rowRadi[i] * Math.sin(n.theta));
    }
  }
}, mxRadialTreeLayout.prototype.calcRowDims = function (t, e) {
  if (null != t && 0 != t.length) {
    this.rowMinX[e] = this.centerX, this.rowMaxX[e] = this.centerX, this.rowMinCenX[e] = this.centerX, this.rowMaxCenX[e] = this.centerX, this.row[e] = [];

    for (var i = !1, n = 0; n < t.length; n++) {
      for (var s = null != t[n] ? t[n].child : null; null != s;) {
        var o = this.getVertexBounds(s.cell);
        this.rowMinX[e] = Math.min(o.x, this.rowMinX[e]), this.rowMaxX[e] = Math.max(o.x + o.width, this.rowMaxX[e]), this.rowMinCenX[e] = Math.min(o.x + o.width / 2, this.rowMinCenX[e]), this.rowMaxCenX[e] = Math.max(o.x + o.width / 2, this.rowMaxCenX[e]), this.rowRadi[e] = o.y - this.getVertexBounds(this.root).y, null != s.child && (i = !0), this.row[e].push(s), s = s.next;
      }
    }

    i && this.calcRowDims(this.row[e], e + 1);
  }
}, mxFastOrganicLayout.prototype = new mxGraphLayout(), mxFastOrganicLayout.prototype.constructor = mxFastOrganicLayout, mxFastOrganicLayout.prototype.useInputOrigin = !0, mxFastOrganicLayout.prototype.resetEdges = !0, mxFastOrganicLayout.prototype.disableEdgeStyle = !0, mxFastOrganicLayout.prototype.forceConstant = 50, mxFastOrganicLayout.prototype.forceConstantSquared = 0, mxFastOrganicLayout.prototype.minDistanceLimit = 2, mxFastOrganicLayout.prototype.maxDistanceLimit = 500, mxFastOrganicLayout.prototype.minDistanceLimitSquared = 4, mxFastOrganicLayout.prototype.initialTemp = 200, mxFastOrganicLayout.prototype.temperature = 0, mxFastOrganicLayout.prototype.maxIterations = 0, mxFastOrganicLayout.prototype.iteration = 0, mxFastOrganicLayout.prototype.allowedToRun = !0, mxFastOrganicLayout.prototype.isVertexIgnored = function (t) {
  return mxGraphLayout.prototype.isVertexIgnored.apply(this, arguments) || 0 == this.graph.getConnections(t).length;
}, mxFastOrganicLayout.prototype.execute = function (t) {
  var e = this.graph.getModel();
  this.vertexArray = [];

  for (var i = this.graph.getChildVertices(t), n = 0; n < i.length; n++) {
    this.isVertexIgnored(i[n]) || this.vertexArray.push(i[n]);
  }

  var s = this.useInputOrigin ? this.graph.getBoundingBoxFromGeometry(this.vertexArray) : null,
      o = this.vertexArray.length;

  for (this.indices = [], this.dispX = [], this.dispY = [], this.cellLocation = [], this.isMoveable = [], this.neighbours = [], this.radius = [], this.radiusSquared = [], .001 > this.forceConstant && (this.forceConstant = .001), this.forceConstantSquared = this.forceConstant * this.forceConstant, n = 0; n < this.vertexArray.length; n++) {
    var l = this.vertexArray[n];
    this.cellLocation[n] = [];
    var r = mxObjectIdentity.get(l);
    this.indices[r] = n;
    var a = this.getVertexBounds(l),
        h = a.width,
        u = a.height,
        d = a.x,
        p = a.y;
    this.cellLocation[n][0] = d + h / 2, this.cellLocation[n][1] = p + u / 2, this.radius[n] = Math.min(h, u), this.radiusSquared[n] = this.radius[n] * this.radius[n];
  }

  e.beginUpdate();

  try {
    for (n = 0; n < o; n++) {
      this.dispX[n] = 0, this.dispY[n] = 0, this.isMoveable[n] = this.isVertexMovable(this.vertexArray[n]);
      var c = this.graph.getConnections(this.vertexArray[n], t);
      i = this.graph.getOpposites(c, this.vertexArray[n]);

      for (this.neighbours[n] = [], h = 0; h < i.length; h++) {
        this.resetEdges && this.graph.resetEdge(c[h]), this.disableEdgeStyle && this.setEdgeStyleEnabled(c[h], !1);
        r = mxObjectIdentity.get(i[h]);
        var m = this.indices[r];
        this.neighbours[n][h] = null != m ? m : n;
      }
    }

    for (this.temperature = this.initialTemp, 0 == this.maxIterations && (this.maxIterations = 20 * Math.sqrt(o)), this.iteration = 0; this.iteration < this.maxIterations; this.iteration++) {
      if (!this.allowedToRun) return;
      this.calcRepulsion(), this.calcAttraction(), this.calcPositions(), this.reduceTemperature();
    }

    for (t = i = null, n = 0; n < this.vertexArray.length; n++) {
      l = this.vertexArray[n], this.isVertexMovable(l) && null != (a = this.getVertexBounds(l)) && (this.cellLocation[n][0] -= a.width / 2, this.cellLocation[n][1] -= a.height / 2, d = this.graph.snap(Math.round(this.cellLocation[n][0])), p = this.graph.snap(Math.round(this.cellLocation[n][1])), this.setVertexLocation(l, d, p), i = null == i ? d : Math.min(i, d), t = null == t ? p : Math.min(t, p));
    }

    n = 1 - (i || 0), l = 1 - (t || 0), null != s && (n += s.x, l += s.y), this.graph.moveCells(this.vertexArray, n, l);
  } finally {
    e.endUpdate();
  }
}, mxFastOrganicLayout.prototype.calcPositions = function () {
  for (var t = 0; t < this.vertexArray.length; t++) {
    if (this.isMoveable[t]) {
      .001 > (i = Math.sqrt(this.dispX[t] * this.dispX[t] + this.dispY[t] * this.dispY[t])) && (i = .001);
      var e = this.dispX[t] / i * Math.min(i, this.temperature),
          i = this.dispY[t] / i * Math.min(i, this.temperature);
      this.dispX[t] = 0, this.dispY[t] = 0, this.cellLocation[t][0] += e, this.cellLocation[t][1] += i;
    }
  }
}, mxFastOrganicLayout.prototype.calcAttraction = function () {
  for (var t = 0; t < this.vertexArray.length; t++) {
    for (var e = 0; e < this.neighbours[t].length; e++) {
      var i = this.neighbours[t][e];

      if (t != i && this.isMoveable[t] && this.isMoveable[i]) {
        (n = (o = this.cellLocation[t][0] - this.cellLocation[i][0]) * o + (l = this.cellLocation[t][1] - this.cellLocation[i][1]) * l - this.radiusSquared[t] - this.radiusSquared[i]) < this.minDistanceLimitSquared && (n = this.minDistanceLimitSquared);
        var n,
            s = Math.sqrt(n),
            o = o / s * (n = n / this.forceConstant),
            l = l / s * n;
        this.dispX[t] -= o, this.dispY[t] -= l, this.dispX[i] += o, this.dispY[i] += l;
      }
    }
  }
}, mxFastOrganicLayout.prototype.calcRepulsion = function () {
  for (var t = this.vertexArray.length, e = 0; e < t; e++) {
    for (var i = e; i < t; i++) {
      if (!this.allowedToRun) return;

      if (i != e && this.isMoveable[e] && this.isMoveable[i]) {
        var n = this.cellLocation[e][0] - this.cellLocation[i][0],
            s = this.cellLocation[e][1] - this.cellLocation[i][1];
        0 == n && (n = .01 + Math.random()), 0 == s && (s = .01 + Math.random());
        var o = Math.sqrt(n * n + s * s),
            l = o - this.radius[e] - this.radius[i];
        l > this.maxDistanceLimit || (l < this.minDistanceLimit && (l = this.minDistanceLimit), n = n / o * (l = this.forceConstantSquared / l), s = s / o * l, this.dispX[e] += n, this.dispY[e] += s, this.dispX[i] -= n, this.dispY[i] -= s);
      }
    }
  }
}, mxFastOrganicLayout.prototype.reduceTemperature = function () {
  this.temperature = this.initialTemp * (1 - this.iteration / this.maxIterations);
}, mxCircleLayout.prototype = new mxGraphLayout(), mxCircleLayout.prototype.constructor = mxCircleLayout, mxCircleLayout.prototype.radius = null, mxCircleLayout.prototype.moveCircle = !1, mxCircleLayout.prototype.x0 = 0, mxCircleLayout.prototype.y0 = 0, mxCircleLayout.prototype.resetEdges = !0, mxCircleLayout.prototype.disableEdgeStyle = !0, mxCircleLayout.prototype.execute = function (t) {
  var e = this.graph.getModel();
  e.beginUpdate();

  try {
    for (var i = 0, n = null, s = null, o = [], l = e.getChildCount(t), r = 0; r < l; r++) {
      var a = e.getChildAt(t, r);
      if (this.isVertexIgnored(a)) this.isEdgeIgnored(a) || (this.resetEdges && this.graph.resetEdge(a), this.disableEdgeStyle && this.setEdgeStyleEnabled(a, !1));else {
        o.push(a);
        var h = this.getVertexBounds(a);
        n = null == n ? h.y : Math.min(n, h.y), s = null == s ? h.x : Math.min(s, h.x), i = Math.max(i, Math.max(h.width, h.height));
      }
    }

    var u = this.getRadius(o.length, i);
    this.moveCircle && (s = this.x0, n = this.y0), this.circle(o, u, s, n);
  } finally {
    e.endUpdate();
  }
}, mxCircleLayout.prototype.getRadius = function (t, e) {
  return Math.max(t * e / Math.PI, this.radius);
}, mxCircleLayout.prototype.circle = function (t, e, i, n) {
  for (var s = t.length, o = 2 * Math.PI / s, l = 0; l < s; l++) {
    this.isVertexMovable(t[l]) && this.setVertexLocation(t[l], Math.round(i + e + e * Math.sin(l * o)), Math.round(n + e + e * Math.cos(l * o)));
  }
}, mxParallelEdgeLayout.prototype = new mxGraphLayout(), mxParallelEdgeLayout.prototype.constructor = mxParallelEdgeLayout, mxParallelEdgeLayout.prototype.spacing = 20, mxParallelEdgeLayout.prototype.execute = function (t) {
  t = this.findParallels(t), this.graph.model.beginUpdate();

  try {
    for (var e in t) {
      var i = t[e];
      1 < i.length && this.layout(i);
    }
  } finally {
    this.graph.model.endUpdate();
  }
}, mxParallelEdgeLayout.prototype.findParallels = function (t) {
  for (var e = this.graph.getModel(), i = [], n = e.getChildCount(t), s = 0; s < n; s++) {
    var o = e.getChildAt(t, s);

    if (!this.isEdgeIgnored(o)) {
      var l = this.getEdgeId(o);
      null != l && (null == i[l] && (i[l] = []), i[l].push(o));
    }
  }

  return i;
}, mxParallelEdgeLayout.prototype.getEdgeId = function (t) {
  var e = this.graph.getView(),
      i = e.getVisibleTerminal(t, !0);
  return t = e.getVisibleTerminal(t, !1), null != i && null != t ? (i = mxObjectIdentity.get(i)) > (t = mxObjectIdentity.get(t)) ? t + "-" + i : i + "-" + t : null;
}, mxParallelEdgeLayout.prototype.layout = function (t) {
  var e = t[0],
      i = this.graph.getView(),
      n = (o = this.graph.getModel()).getGeometry(i.getVisibleTerminal(e, !0));

  if (n == (o = o.getGeometry(i.getVisibleTerminal(e, !1)))) {
    e = n.x + n.width + this.spacing, i = n.y + n.height / 2;

    for (var s = 0; s < t.length; s++) {
      this.route(t[s], e, i), e += this.spacing;
    }
  } else if (null != n && null != o) {
    e = n.x + n.width / 2, i = n.y + n.height / 2, s = o.x + o.width / 2 - e;
    var o,
        l = o.y + o.height / 2 - i;
    if (0 < (o = Math.sqrt(s * s + l * l))) for (n = l * this.spacing / o, o = s * this.spacing / o, e = e + s / 2 + n * (t.length - 1) / 2, i = i + l / 2 - o * (t.length - 1) / 2, s = 0; s < t.length; s++) {
      this.route(t[s], e, i), e -= n, i += o;
    }
  }
}, mxParallelEdgeLayout.prototype.route = function (t, e, i) {
  this.graph.isCellMovable(t) && this.setEdgePoints(t, [new mxPoint(e, i)]);
}, mxCompositeLayout.prototype = new mxGraphLayout(), mxCompositeLayout.prototype.constructor = mxCompositeLayout, mxCompositeLayout.prototype.layouts = null, mxCompositeLayout.prototype.master = null, mxCompositeLayout.prototype.moveCell = function (t, e, i) {
  null != this.master ? this.master.move.apply(this.master, arguments) : this.layouts[0].move.apply(this.layouts[0], arguments);
}, mxCompositeLayout.prototype.execute = function (t) {
  var e = this.graph.getModel();
  e.beginUpdate();

  try {
    for (var i = 0; i < this.layouts.length; i++) {
      this.layouts[i].execute.apply(this.layouts[i], arguments);
    }
  } finally {
    e.endUpdate();
  }
}, mxEdgeLabelLayout.prototype = new mxGraphLayout(), mxEdgeLabelLayout.prototype.constructor = mxEdgeLabelLayout, mxEdgeLabelLayout.prototype.execute = function (t) {
  for (var e = this.graph.view, i = this.graph.getModel(), n = [], s = [], o = i.getChildCount(t), l = 0; l < o; l++) {
    var r = i.getChildAt(t, l),
        a = e.getState(r);
    null != a && (this.isVertexIgnored(r) ? this.isEdgeIgnored(r) || n.push(a) : s.push(a));
  }

  this.placeLabels(s, n);
}, mxEdgeLabelLayout.prototype.placeLabels = function (t, e) {
  var i = this.graph.getModel();
  i.beginUpdate();

  try {
    for (var n = 0; n < e.length; n++) {
      var s = e[n];
      if (null != s && null != s.text && null != s.text.boundingBox) for (var o = 0; o < t.length; o++) {
        var l = t[o];
        null != l && this.avoid(s, l);
      }
    }
  } finally {
    i.endUpdate();
  }
}, mxEdgeLabelLayout.prototype.avoid = function (t, e) {
  var i = this.graph.getModel(),
      n = t.text.boundingBox;

  if (mxUtils.intersects(n, e)) {
    var s = -n.y - n.height + e.y,
        o = -n.y + e.y + e.height;
    s = Math.abs(s) < Math.abs(o) ? s : o, o = -n.x - n.width + e.x, n = -n.x + e.x + e.width, n = Math.abs(o) < Math.abs(n) ? o : n;
    Math.abs(n) < Math.abs(s) ? s = 0 : n = 0, null != (o = i.getGeometry(t.cell)) && (null != (o = o.clone()).offset ? (o.offset.x += n, o.offset.y += s) : o.offset = new mxPoint(n, s), i.setGeometry(t.cell, o));
  }
}, mxGraphAbstractHierarchyCell.prototype.maxRank = -1, mxGraphAbstractHierarchyCell.prototype.minRank = -1, mxGraphAbstractHierarchyCell.prototype.x = null, mxGraphAbstractHierarchyCell.prototype.y = null, mxGraphAbstractHierarchyCell.prototype.width = 0, mxGraphAbstractHierarchyCell.prototype.height = 0, mxGraphAbstractHierarchyCell.prototype.nextLayerConnectedCells = null, mxGraphAbstractHierarchyCell.prototype.previousLayerConnectedCells = null, mxGraphAbstractHierarchyCell.prototype.temp = null, mxGraphAbstractHierarchyCell.prototype.getNextLayerConnectedCells = function (t) {
  return null;
}, mxGraphAbstractHierarchyCell.prototype.getPreviousLayerConnectedCells = function (t) {
  return null;
}, mxGraphAbstractHierarchyCell.prototype.isEdge = function () {
  return !1;
}, mxGraphAbstractHierarchyCell.prototype.isVertex = function () {
  return !1;
}, mxGraphAbstractHierarchyCell.prototype.getGeneralPurposeVariable = function (t) {
  return null;
}, mxGraphAbstractHierarchyCell.prototype.setGeneralPurposeVariable = function (t, e) {
  return null;
}, mxGraphAbstractHierarchyCell.prototype.setX = function (t, e) {
  this.isVertex() ? this.x[0] = e : this.isEdge() && (this.x[t - this.minRank - 1] = e);
}, mxGraphAbstractHierarchyCell.prototype.getX = function (t) {
  return this.isVertex() ? this.x[0] : this.isEdge() ? this.x[t - this.minRank - 1] : 0;
}, mxGraphAbstractHierarchyCell.prototype.setY = function (t, e) {
  this.isVertex() ? this.y[0] = e : this.isEdge() && (this.y[t - this.minRank - 1] = e);
}, mxGraphHierarchyNode.prototype = new mxGraphAbstractHierarchyCell(), mxGraphHierarchyNode.prototype.constructor = mxGraphHierarchyNode, mxGraphHierarchyNode.prototype.cell = null, mxGraphHierarchyNode.prototype.id = null, mxGraphHierarchyNode.prototype.connectsAsTarget = null, mxGraphHierarchyNode.prototype.connectsAsSource = null, mxGraphHierarchyNode.prototype.hashCode = !1, mxGraphHierarchyNode.prototype.getRankValue = function (t) {
  return this.maxRank;
}, mxGraphHierarchyNode.prototype.getNextLayerConnectedCells = function (t) {
  if (null == this.nextLayerConnectedCells) {
    this.nextLayerConnectedCells = [], this.nextLayerConnectedCells[0] = [];

    for (var e = 0; e < this.connectsAsTarget.length; e++) {
      var i = this.connectsAsTarget[e];
      -1 == i.maxRank || i.maxRank == t + 1 ? this.nextLayerConnectedCells[0].push(i.source) : this.nextLayerConnectedCells[0].push(i);
    }
  }

  return this.nextLayerConnectedCells[0];
}, mxGraphHierarchyNode.prototype.getPreviousLayerConnectedCells = function (t) {
  if (null == this.previousLayerConnectedCells) {
    this.previousLayerConnectedCells = [], this.previousLayerConnectedCells[0] = [];

    for (var e = 0; e < this.connectsAsSource.length; e++) {
      var i = this.connectsAsSource[e];
      -1 == i.minRank || i.minRank == t - 1 ? this.previousLayerConnectedCells[0].push(i.target) : this.previousLayerConnectedCells[0].push(i);
    }
  }

  return this.previousLayerConnectedCells[0];
}, mxGraphHierarchyNode.prototype.isVertex = function () {
  return !0;
}, mxGraphHierarchyNode.prototype.getGeneralPurposeVariable = function (t) {
  return this.temp[0];
}, mxGraphHierarchyNode.prototype.setGeneralPurposeVariable = function (t, e) {
  this.temp[0] = e;
}, mxGraphHierarchyNode.prototype.isAncestor = function (t) {
  if (null != t && null != this.hashCode && null != t.hashCode && this.hashCode.length < t.hashCode.length) {
    if (this.hashCode == t.hashCode) return !0;
    if (null == this.hashCode || null == this.hashCode) return !1;

    for (var e = 0; e < this.hashCode.length; e++) {
      if (this.hashCode[e] != t.hashCode[e]) return !1;
    }

    return !0;
  }

  return !1;
}, mxGraphHierarchyNode.prototype.getCoreCell = function () {
  return this.cell;
}, mxGraphHierarchyEdge.prototype = new mxGraphAbstractHierarchyCell(), mxGraphHierarchyEdge.prototype.constructor = mxGraphHierarchyEdge, mxGraphHierarchyEdge.prototype.edges = null, mxGraphHierarchyEdge.prototype.ids = null, mxGraphHierarchyEdge.prototype.source = null, mxGraphHierarchyEdge.prototype.target = null, mxGraphHierarchyEdge.prototype.isReversed = !1, mxGraphHierarchyEdge.prototype.invert = function (t) {
  t = this.source, this.source = this.target, this.target = t, this.isReversed = !this.isReversed;
}, mxGraphHierarchyEdge.prototype.getNextLayerConnectedCells = function (t) {
  if (null == this.nextLayerConnectedCells) {
    this.nextLayerConnectedCells = [];

    for (var e = 0; e < this.temp.length; e++) {
      this.nextLayerConnectedCells[e] = [], e == this.temp.length - 1 ? this.nextLayerConnectedCells[e].push(this.source) : this.nextLayerConnectedCells[e].push(this);
    }
  }

  return this.nextLayerConnectedCells[t - this.minRank - 1];
}, mxGraphHierarchyEdge.prototype.getPreviousLayerConnectedCells = function (t) {
  if (null == this.previousLayerConnectedCells) {
    this.previousLayerConnectedCells = [];

    for (var e = 0; e < this.temp.length; e++) {
      this.previousLayerConnectedCells[e] = [], 0 == e ? this.previousLayerConnectedCells[e].push(this.target) : this.previousLayerConnectedCells[e].push(this);
    }
  }

  return this.previousLayerConnectedCells[t - this.minRank - 1];
}, mxGraphHierarchyEdge.prototype.isEdge = function () {
  return !0;
}, mxGraphHierarchyEdge.prototype.getGeneralPurposeVariable = function (t) {
  return this.temp[t - this.minRank - 1];
}, mxGraphHierarchyEdge.prototype.setGeneralPurposeVariable = function (t, e) {
  this.temp[t - this.minRank - 1] = e;
}, mxGraphHierarchyEdge.prototype.getCoreCell = function () {
  return null != this.edges && 0 < this.edges.length ? this.edges[0] : null;
}, mxGraphHierarchyModel.prototype.maxRank = null, mxGraphHierarchyModel.prototype.vertexMapper = null, mxGraphHierarchyModel.prototype.edgeMapper = null, mxGraphHierarchyModel.prototype.ranks = null, mxGraphHierarchyModel.prototype.roots = null, mxGraphHierarchyModel.prototype.parent = null, mxGraphHierarchyModel.prototype.dfsCount = 0, mxGraphHierarchyModel.prototype.SOURCESCANSTARTRANK = 1e8, mxGraphHierarchyModel.prototype.tightenToSource = !1, mxGraphHierarchyModel.prototype.createInternalCells = function (t, e, i) {
  for (var n = t.getGraph(), s = 0; s < e.length; s++) {
    i[s] = new mxGraphHierarchyNode(e[s]), this.vertexMapper.put(e[s], i[s]);
    var o = t.getEdges(e[s]);
    i[s].connectsAsSource = [];

    for (var l = 0; l < o.length; l++) {
      if ((a = t.getVisibleTerminal(o[l], !1)) != e[s] && t.graph.model.isVertex(a) && !t.isVertexIgnored(a)) {
        var r = t.getEdgesBetween(e[s], a, !1),
            a = t.getEdgesBetween(e[s], a, !0);

        if (null != r && 0 < r.length && null == this.edgeMapper.get(r[0]) && 2 * a.length >= r.length) {
          a = new mxGraphHierarchyEdge(r);

          for (var h = 0; h < r.length; h++) {
            var u = r[h];
            this.edgeMapper.put(u, a), n.resetEdge(u), t.disableEdgeStyle && (t.setEdgeStyleEnabled(u, !1), t.setOrthogonalEdge(u, !0));
          }

          a.source = i[s], 0 > mxUtils.indexOf(i[s].connectsAsSource, a) && i[s].connectsAsSource.push(a);
        }
      }
    }

    i[s].temp[0] = 0;
  }
}, mxGraphHierarchyModel.prototype.initialRank = function () {
  var t = [];
  if (null != this.roots) for (var e = 0; e < this.roots.length; e++) {
    null != (s = this.vertexMapper.get(this.roots[e])) && t.push(s);
  }
  var i = this.vertexMapper.getValues();

  for (e = 0; e < i.length; e++) {
    i[e].temp[0] = -1;
  }

  for (var n = t.slice(); 0 < t.length;) {
    var s, o, l;
    o = (s = t[0]).connectsAsTarget, l = s.connectsAsSource;
    var r = !0,
        a = this.SOURCESCANSTARTRANK;

    for (e = 0; e < o.length; e++) {
      var h = o[e];

      if (5270620 != h.temp[0]) {
        r = !1;
        break;
      }

      h = h.source, a = Math.min(a, h.temp[0] - 1);
    }

    if (r) {
      if (s.temp[0] = a, this.maxRank = Math.min(this.maxRank, a), null != l) for (e = 0; e < l.length; e++) {
        (h = l[e]).temp[0] = 5270620, -1 == (h = h.target).temp[0] && (t.push(h), h.temp[0] = -2);
      }
      t.shift();
    } else if (e = t.shift(), t.push(s), e == s && 1 == t.length) break;
  }

  for (e = 0; e < i.length; e++) {
    i[e].temp[0] -= this.maxRank;
  }

  for (e = 0; e < n.length; e++) {
    for (t = 0, o = (s = n[e]).connectsAsSource, i = 0; i < o.length; i++) {
      h = (h = o[i]).target, s.temp[0] = Math.max(t, h.temp[0] + 1), t = s.temp[0];
    }
  }

  this.maxRank = this.SOURCESCANSTARTRANK - this.maxRank;
}, mxGraphHierarchyModel.prototype.fixRanks = function () {
  var t = [];
  this.ranks = [];

  for (var e = 0; e < this.maxRank + 1; e++) {
    t[e] = [], this.ranks[e] = t[e];
  }

  var i = null;

  if (null != this.roots) {
    var n = this.roots;

    for (i = [], e = 0; e < n.length; e++) {
      var s = this.vertexMapper.get(n[e]);
      i[e] = s;
    }
  }

  this.visit(function (e, i, n, s, o) {
    if (0 == o && 0 > i.maxRank && 0 > i.minRank && (t[i.temp[0]].push(i), i.maxRank = i.temp[0], i.minRank = i.temp[0], i.temp[0] = t[i.maxRank].length - 1), null != e && null != n && 1 < e.maxRank - i.maxRank) for (n.maxRank = e.maxRank, n.minRank = i.maxRank, n.temp = [], n.x = [], n.y = [], e = n.minRank + 1; e < n.maxRank; e++) {
      t[e].push(n), n.setGeneralPurposeVariable(e, t[e].length - 1);
    }
  }, i, !1, null);
}, mxGraphHierarchyModel.prototype.visit = function (t, e, i, n) {
  if (null != e) {
    for (var s = 0; s < e.length; s++) {
      var o = e[s];
      null != o && (null == n && (n = {}), i ? (o.hashCode = [], o.hashCode[0] = this.dfsCount, o.hashCode[1] = s, this.extendedDfs(null, o, null, t, n, o.hashCode, s, 0)) : this.dfs(null, o, null, t, n, 0));
    }

    this.dfsCount++;
  }
}, mxGraphHierarchyModel.prototype.dfs = function (t, e, i, n, s, o) {
  if (null != e) {
    var l = e.id;
    if (null == s[l]) for (s[l] = e, n(t, e, i, o, 0), t = e.connectsAsSource.slice(), i = 0; i < t.length; i++) {
      l = t[i], this.dfs(e, l.target, l, n, s, o + 1);
    } else n(t, e, i, o, 1);
  }
}, mxGraphHierarchyModel.prototype.extendedDfs = function (t, e, i, n, s, o, l, r) {
  if (null != e) if (null == t || null != e.hashCode && e.hashCode[0] == t.hashCode[0] || (o = t.hashCode.length + 1, e.hashCode = t.hashCode.slice(), e.hashCode[o - 1] = l), null == s[l = e.id]) for (s[l] = e, n(t, e, i, r, 0), t = e.connectsAsSource.slice(), i = 0; i < t.length; i++) {
    l = t[i], this.extendedDfs(e, l.target, l, n, s, e.hashCode, i, r + 1);
  } else n(t, e, i, r, 1);
}, mxSwimlaneModel.prototype.maxRank = null, mxSwimlaneModel.prototype.vertexMapper = null, mxSwimlaneModel.prototype.edgeMapper = null, mxSwimlaneModel.prototype.ranks = null, mxSwimlaneModel.prototype.roots = null, mxSwimlaneModel.prototype.parent = null, mxSwimlaneModel.prototype.dfsCount = 0, mxSwimlaneModel.prototype.SOURCESCANSTARTRANK = 1e8, mxSwimlaneModel.prototype.tightenToSource = !1, mxSwimlaneModel.prototype.ranksPerGroup = null, mxSwimlaneModel.prototype.createInternalCells = function (t, e, i) {
  for (var n = t.getGraph(), s = t.swimlanes, o = 0; o < e.length; o++) {
    i[o] = new mxGraphHierarchyNode(e[o]), this.vertexMapper.put(e[o], i[o]), i[o].swimlaneIndex = -1;

    for (var l = 0; l < s.length; l++) {
      if (n.model.getParent(e[o]) == s[l]) {
        i[o].swimlaneIndex = l;
        break;
      }
    }

    l = t.getEdges(e[o]), i[o].connectsAsSource = [];

    for (var r = 0; r < l.length; r++) {
      if ((h = t.getVisibleTerminal(l[r], !1)) != e[o] && t.graph.model.isVertex(h) && !t.isVertexIgnored(h)) {
        var a = t.getEdgesBetween(e[o], h, !1),
            h = t.getEdgesBetween(e[o], h, !0);

        if (null != a && 0 < a.length && null == this.edgeMapper.get(a[0]) && 2 * h.length >= a.length) {
          h = new mxGraphHierarchyEdge(a);

          for (var u = 0; u < a.length; u++) {
            var d = a[u];
            this.edgeMapper.put(d, h), n.resetEdge(d), t.disableEdgeStyle && (t.setEdgeStyleEnabled(d, !1), t.setOrthogonalEdge(d, !0));
          }

          h.source = i[o], 0 > mxUtils.indexOf(i[o].connectsAsSource, h) && i[o].connectsAsSource.push(h);
        }
      }
    }

    i[o].temp[0] = 0;
  }
}, mxSwimlaneModel.prototype.initialRank = function () {
  this.ranksPerGroup = [];
  var t = [],
      e = {};
  if (null != this.roots) for (var i = 0; i < this.roots.length; i++) {
    var n = this.vertexMapper.get(this.roots[i]);
    this.maxChainDfs(null, n, null, e, 0), null != n && t.push(n);
  }

  for (n = [], e = [], i = this.ranksPerGroup.length - 1; 0 <= i; i--) {
    n[i] = i == this.ranksPerGroup.length - 1 ? 0 : e[i + 1] + 1, e[i] = n[i] + this.ranksPerGroup[i];
  }

  for (this.maxRank = e[0], n = this.vertexMapper.getValues(), i = 0; i < n.length; i++) {
    n[i].temp[0] = -1;
  }

  for (t.slice(); 0 < t.length;) {
    var s, o;
    s = (n = t[0]).connectsAsTarget, o = n.connectsAsSource;
    var l = !0,
        r = e[0];

    for (i = 0; i < s.length; i++) {
      var a = s[i];

      if (5270620 != a.temp[0]) {
        l = !1;
        break;
      }

      a = a.source, r = Math.min(r, a.temp[0] - 1);
    }

    if (l) {
      if (r > e[n.swimlaneIndex] && (r = e[n.swimlaneIndex]), n.temp[0] = r, null != o) for (i = 0; i < o.length; i++) {
        (a = o[i]).temp[0] = 5270620, -1 == (a = a.target).temp[0] && (t.push(a), a.temp[0] = -2);
      }
      t.shift();
    } else if (i = t.shift(), t.push(n), i == n && 1 == t.length) break;
  }
}, mxSwimlaneModel.prototype.maxChainDfs = function (t, e, i, n, s) {
  if (null != e && null == n[t = mxCellPath.create(e.cell)]) for (n[t] = e, t = e.swimlaneIndex, (null == this.ranksPerGroup[t] || this.ranksPerGroup[t] < s) && (this.ranksPerGroup[t] = s), t = e.connectsAsSource.slice(), i = 0; i < t.length; i++) {
    var o = t[i],
        l = o.target;
    e.swimlaneIndex < l.swimlaneIndex ? this.maxChainDfs(e, l, o, mxUtils.clone(n, null, !0), 0) : e.swimlaneIndex == l.swimlaneIndex && this.maxChainDfs(e, l, o, mxUtils.clone(n, null, !0), s + 1);
  }
}, mxSwimlaneModel.prototype.fixRanks = function () {
  var t = [];
  this.ranks = [];

  for (var e = 0; e < this.maxRank + 1; e++) {
    t[e] = [], this.ranks[e] = t[e];
  }

  var i = null;

  if (null != this.roots) {
    var n = this.roots;

    for (i = [], e = 0; e < n.length; e++) {
      var s = this.vertexMapper.get(n[e]);
      i[e] = s;
    }
  }

  this.visit(function (e, i, n, s, o) {
    if (0 == o && 0 > i.maxRank && 0 > i.minRank && (t[i.temp[0]].push(i), i.maxRank = i.temp[0], i.minRank = i.temp[0], i.temp[0] = t[i.maxRank].length - 1), null != e && null != n && 1 < e.maxRank - i.maxRank) for (n.maxRank = e.maxRank, n.minRank = i.maxRank, n.temp = [], n.x = [], n.y = [], e = n.minRank + 1; e < n.maxRank; e++) {
      t[e].push(n), n.setGeneralPurposeVariable(e, t[e].length - 1);
    }
  }, i, !1, null);
}, mxSwimlaneModel.prototype.visit = function (t, e, i, n) {
  if (null != e) {
    for (var s = 0; s < e.length; s++) {
      var o = e[s];
      null != o && (null == n && (n = {}), i ? (o.hashCode = [], o.hashCode[0] = this.dfsCount, o.hashCode[1] = s, this.extendedDfs(null, o, null, t, n, o.hashCode, s, 0)) : this.dfs(null, o, null, t, n, 0));
    }

    this.dfsCount++;
  }
}, mxSwimlaneModel.prototype.dfs = function (t, e, i, n, s, o) {
  if (null != e) {
    var l = e.id;
    if (null == s[l]) for (s[l] = e, n(t, e, i, o, 0), t = e.connectsAsSource.slice(), i = 0; i < t.length; i++) {
      l = t[i], this.dfs(e, l.target, l, n, s, o + 1);
    } else n(t, e, i, o, 1);
  }
}, mxSwimlaneModel.prototype.extendedDfs = function (t, e, i, n, s, o, l, r) {
  if (null != e) if (null == t || null != e.hashCode && e.hashCode[0] == t.hashCode[0] || (o = t.hashCode.length + 1, e.hashCode = t.hashCode.slice(), e.hashCode[o - 1] = l), null == s[l = e.id]) {
    for (s[l] = e, n(t, e, i, r, 0), t = e.connectsAsSource.slice(), i = e.connectsAsTarget.slice(), l = 0; l < t.length; l++) {
      var a = (o = t[l]).target;
      e.swimlaneIndex <= a.swimlaneIndex && this.extendedDfs(e, a, o, n, s, e.hashCode, l, r + 1);
    }

    for (l = 0; l < i.length; l++) {
      a = (o = i[l]).source, e.swimlaneIndex < a.swimlaneIndex && this.extendedDfs(e, a, o, n, s, e.hashCode, l, r + 1);
    }
  } else n(t, e, i, r, 1);
}, mxHierarchicalLayoutStage.prototype.execute = function (t) {}, mxMedianHybridCrossingReduction.prototype = new mxHierarchicalLayoutStage(), mxMedianHybridCrossingReduction.prototype.constructor = mxMedianHybridCrossingReduction, mxMedianHybridCrossingReduction.prototype.layout = null, mxMedianHybridCrossingReduction.prototype.maxIterations = 24, mxMedianHybridCrossingReduction.prototype.nestedBestRanks = null, mxMedianHybridCrossingReduction.prototype.currentBestCrossings = 0, mxMedianHybridCrossingReduction.prototype.iterationsWithoutImprovement = 0, mxMedianHybridCrossingReduction.prototype.maxNoImprovementIterations = 2, mxMedianHybridCrossingReduction.prototype.execute = function (t) {
  t = this.layout.getModel(), this.nestedBestRanks = [];

  for (var e = 0; e < t.ranks.length; e++) {
    this.nestedBestRanks[e] = t.ranks[e].slice();
  }

  var i = 0,
      n = this.calculateCrossings(t);

  for (e = 0; e < this.maxIterations && i < this.maxNoImprovementIterations; e++) {
    this.weightedMedian(e, t), this.transpose(e, t);
    var s = this.calculateCrossings(t);
    if (s < n) for (n = s, s = i = 0; s < this.nestedBestRanks.length; s++) {
      for (var o = t.ranks[s], l = 0; l < o.length; l++) {
        var r = o[l];
        this.nestedBestRanks[s][r.getGeneralPurposeVariable(s)] = r;
      }
    } else for (i++, s = 0; s < this.nestedBestRanks.length; s++) {
      for (o = t.ranks[s], l = 0; l < o.length; l++) {
        (r = o[l]).setGeneralPurposeVariable(s, l);
      }
    }
    if (0 == n) break;
  }

  for (i = [], n = [], e = 0; e < t.maxRank + 1; e++) {
    n[e] = [], i[e] = n[e];
  }

  for (e = 0; e < this.nestedBestRanks.length; e++) {
    for (s = 0; s < this.nestedBestRanks[e].length; s++) {
      n[e].push(this.nestedBestRanks[e][s]);
    }
  }

  t.ranks = i;
}, mxMedianHybridCrossingReduction.prototype.calculateCrossings = function (t) {
  for (var e = t.ranks.length, i = 0, n = 1; n < e; n++) {
    i += this.calculateRankCrossing(n, t);
  }

  return i;
}, mxMedianHybridCrossingReduction.prototype.calculateRankCrossing = function (t, e) {
  for (var i = 0, n = e.ranks[t], s = e.ranks[t - 1], o = [], l = 0; l < n.length; l++) {
    for (var r = (a = n[l]).getGeneralPurposeVariable(t), a = a.getPreviousLayerConnectedCells(t), h = [], u = 0; u < a.length; u++) {
      var d = a[u].getGeneralPurposeVariable(t - 1);
      h.push(d);
    }

    h.sort(function (t, e) {
      return t - e;
    }), o[r] = h;
  }

  for (n = [], l = 0; l < o.length; l++) {
    n = n.concat(o[l]);
  }

  for (o = 1; o < s.length;) {
    o <<= 1;
  }

  for (r = 2 * o - 1, --o, s = [], l = 0; l < r; ++l) {
    s[l] = 0;
  }

  for (l = 0; l < n.length; l++) {
    for (++s[r = n[l] + o]; 0 < r;) {
      r % 2 && (i += s[r + 1]), ++s[r = r - 1 >> 1];
    }
  }

  return i;
}, mxMedianHybridCrossingReduction.prototype.transpose = function (t, e) {
  for (var i = !0, n = 0; i && 10 > n++;) {
    for (var s = 1 == t % 2 && 1 == n % 2, o = (i = !1, 0); o < e.ranks.length; o++) {
      for (var l = e.ranks[o], r = [], a = 0; a < l.length; a++) {
        var h = l[a],
            u = h.getGeneralPurposeVariable(o);
        0 > u && (u = a), r[u] = h;
      }

      var d,
          p,
          c,
          m = null,
          g = null,
          x = null,
          y = null,
          f = null;

      for (a = 0; a < l.length - 1; a++) {
        if (0 == a) {
          h = (c = r[a]).getNextLayerConnectedCells(o), u = c.getPreviousLayerConnectedCells(o), d = [], p = [];

          for (var v = 0; v < h.length; v++) {
            d[v] = h[v].getGeneralPurposeVariable(o + 1);
          }

          for (v = 0; v < u.length; v++) {
            p[v] = u[v].getGeneralPurposeVariable(o - 1);
          }
        } else h = m, u = g, d = x, p = y, c = f;

        for (m = (f = r[a + 1]).getNextLayerConnectedCells(o), g = f.getPreviousLayerConnectedCells(o), x = [], y = [], v = 0; v < m.length; v++) {
          x[v] = m[v].getGeneralPurposeVariable(o + 1);
        }

        for (v = 0; v < g.length; v++) {
          y[v] = g[v].getGeneralPurposeVariable(o - 1);
        }

        var C = 0,
            E = 0;

        for (v = 0; v < d.length; v++) {
          for (var S = 0; S < x.length; S++) {
            d[v] > x[S] && C++, d[v] < x[S] && E++;
          }
        }

        for (v = 0; v < p.length; v++) {
          for (S = 0; S < y.length; S++) {
            p[v] > y[S] && C++, p[v] < y[S] && E++;
          }
        }

        (E < C || E == C && s) && (m = c.getGeneralPurposeVariable(o), c.setGeneralPurposeVariable(o, f.getGeneralPurposeVariable(o)), f.setGeneralPurposeVariable(o, m), m = h, g = u, x = d, y = p, f = c, s || (i = !0));
      }
    }
  }
}, mxMedianHybridCrossingReduction.prototype.weightedMedian = function (t, e) {
  var i = 0 == t % 2;
  if (i) for (var n = e.maxRank - 1; 0 <= n; n--) {
    this.medianRank(n, i);
  } else for (n = 1; n < e.maxRank; n++) {
    this.medianRank(n, i);
  }
}, mxMedianHybridCrossingReduction.prototype.medianRank = function (t, e) {
  for (var i = this.nestedBestRanks[t].length, n = [], s = [], o = 0; o < i; o++) {
    var l,
        r,
        a = this.nestedBestRanks[t][o],
        h = new MedianCellSorter();
    h.cell = a, r = e ? t + 1 : t - 1, null != (l = e ? a.getNextLayerConnectedCells(t) : a.getPreviousLayerConnectedCells(t)) && 0 != l.length ? (h.medianValue = this.medianValue(l, r), n.push(h)) : s[a.getGeneralPurposeVariable(t)] = !0;
  }

  for (n.sort(MedianCellSorter.prototype.compare), o = 0; o < i; o++) {
    null == s[o] && (a = n.shift().cell).setGeneralPurposeVariable(t, o);
  }
}, mxMedianHybridCrossingReduction.prototype.medianValue = function (t, e) {
  for (var i = [], n = 0, s = 0; s < t.length; s++) {
    var o = t[s];
    i[n++] = o.getGeneralPurposeVariable(e);
  }

  return i.sort(function (t, e) {
    return t - e;
  }), 1 == n % 2 ? i[Math.floor(n / 2)] : 2 == n ? (i[0] + i[1]) / 2 : (o = i[(s = n / 2) - 1] - i[0], n = i[n - 1] - i[s], (i[s - 1] * n + i[s] * o) / (o + n));
}, MedianCellSorter.prototype.medianValue = 0, MedianCellSorter.prototype.cell = !1, MedianCellSorter.prototype.compare = function (t, e) {
  return null != t && null != e ? e.medianValue > t.medianValue ? -1 : e.medianValue < t.medianValue ? 1 : 0 : 0;
}, mxMinimumCycleRemover.prototype = new mxHierarchicalLayoutStage(), mxMinimumCycleRemover.prototype.constructor = mxMinimumCycleRemover, mxMinimumCycleRemover.prototype.layout = null, mxMinimumCycleRemover.prototype.execute = function (t) {
  t = this.layout.getModel();

  for (var e = {}, i = t.vertexMapper.getValues(), n = {}, s = 0; s < i.length; s++) {
    n[i[s].id] = i[s];
  }

  if (i = null, null != t.roots) {
    var o = t.roots;

    for (i = [], s = 0; s < o.length; s++) {
      i[s] = t.vertexMapper.get(o[s]);
    }
  }

  t.visit(function (t, i, s, o, l) {
    i.isAncestor(t) && (s.invert(), mxUtils.remove(s, t.connectsAsSource), t.connectsAsTarget.push(s), mxUtils.remove(s, i.connectsAsTarget), i.connectsAsSource.push(s)), e[i.id] = i, delete n[i.id];
  }, i, !0, null), s = mxUtils.clone(e, null, !0), t.visit(function (t, i, s, o, l) {
    i.isAncestor(t) && (s.invert(), mxUtils.remove(s, t.connectsAsSource), i.connectsAsSource.push(s), t.connectsAsTarget.push(s), mxUtils.remove(s, i.connectsAsTarget)), e[i.id] = i, delete n[i.id];
  }, n, !0, s);
}, mxCoordinateAssignment.prototype = new mxHierarchicalLayoutStage(), mxCoordinateAssignment.prototype.constructor = mxCoordinateAssignment, mxCoordinateAssignment.prototype.layout = null, mxCoordinateAssignment.prototype.intraCellSpacing = 30, mxCoordinateAssignment.prototype.interRankCellSpacing = 100, mxCoordinateAssignment.prototype.parallelEdgeSpacing = 10, mxCoordinateAssignment.prototype.maxIterations = 8, mxCoordinateAssignment.prototype.prefHozEdgeSep = 5, mxCoordinateAssignment.prototype.prefVertEdgeOff = 2, mxCoordinateAssignment.prototype.minEdgeJetty = 12, mxCoordinateAssignment.prototype.channelBuffer = 4, mxCoordinateAssignment.prototype.jettyPositions = null, mxCoordinateAssignment.prototype.orientation = mxConstants.DIRECTION_NORTH, mxCoordinateAssignment.prototype.initialX = null, mxCoordinateAssignment.prototype.limitX = null, mxCoordinateAssignment.prototype.currentXDelta = null, mxCoordinateAssignment.prototype.widestRank = null, mxCoordinateAssignment.prototype.rankTopY = null, mxCoordinateAssignment.prototype.rankBottomY = null, mxCoordinateAssignment.prototype.widestRankValue = null, mxCoordinateAssignment.prototype.rankWidths = null, mxCoordinateAssignment.prototype.rankY = null, mxCoordinateAssignment.prototype.fineTuning = !0, mxCoordinateAssignment.prototype.nextLayerConnectedCache = null, mxCoordinateAssignment.prototype.previousLayerConnectedCache = null, mxCoordinateAssignment.prototype.groupPadding = 10, mxCoordinateAssignment.prototype.printStatus = function () {
  var t = this.layout.getModel();
  mxLog.show(), mxLog.writeln("======Coord assignment debug=======");

  for (var e = 0; e < t.ranks.length; e++) {
    mxLog.write("Rank ", e, " : ");

    for (var i = t.ranks[e], n = 0; n < i.length; n++) {
      mxLog.write(i[n].getGeneralPurposeVariable(e), "  ");
    }

    mxLog.writeln();
  }

  mxLog.writeln("====================================");
}, mxCoordinateAssignment.prototype.execute = function (t) {
  this.jettyPositions = {}, t = this.layout.getModel(), this.currentXDelta = 0, this.initialCoords(this.layout.getGraph(), t), this.fineTuning && this.minNode(t);
  var e = 1e8;
  if (this.fineTuning) for (var i = 0; i < this.maxIterations; i++) {
    if (0 != i && (this.medianPos(i, t), this.minNode(t)), this.currentXDelta < e) {
      for (var n = 0; n < t.ranks.length; n++) {
        for (var s = t.ranks[n], o = 0; o < s.length; o++) {
          var l = s[o];
          l.setX(n, l.getGeneralPurposeVariable(n));
        }
      }

      e = this.currentXDelta;
    } else for (n = 0; n < t.ranks.length; n++) {
      for (s = t.ranks[n], o = 0; o < s.length; o++) {
        (l = s[o]).setGeneralPurposeVariable(n, l.getX(n));
      }
    }

    this.minPath(this.layout.getGraph(), t), this.currentXDelta = 0;
  }
  this.setCellLocations(this.layout.getGraph(), t);
}, mxCoordinateAssignment.prototype.minNode = function (t) {
  for (var e = [], i = new mxDictionary(), n = [], s = 0; s <= t.maxRank; s++) {
    n[s] = t.ranks[s];

    for (var o = 0; o < n[s].length; o++) {
      (h = new WeightedCellSorter(l = n[s][o], s)).rankIndex = o, h.visited = !0, e.push(h), i.put(l, h);
    }
  }

  for (t = 10 * e.length, o = 0; 0 < e.length && o <= t;) {
    s = (l = e.shift()).cell;
    var l,
        r = l.weightedValue,
        a = parseInt(l.rankIndex),
        h = s.getNextLayerConnectedCells(r),
        u = s.getPreviousLayerConnectedCells(r),
        d = h.length,
        p = u.length,
        c = this.medianXValue(h, r + 1),
        m = this.medianXValue(u, r - 1),
        g = d + p,
        x = s.getGeneralPurposeVariable(r),
        y = x;

    if (0 < g && (y = (c * d + m * p) / g), d = !1, y < x - 1 ? 0 == a ? (s.setGeneralPurposeVariable(r, y), d = !0) : (x = (x = (a = n[r][a - 1]).getGeneralPurposeVariable(r)) + a.width / 2 + this.intraCellSpacing + s.width / 2) < y ? (s.setGeneralPurposeVariable(r, y), d = !0) : x < s.getGeneralPurposeVariable(r) - 1 && (s.setGeneralPurposeVariable(r, x), d = !0) : y > x + 1 && (a == n[r].length - 1 ? (s.setGeneralPurposeVariable(r, y), d = !0) : (x = (x = (a = n[r][a + 1]).getGeneralPurposeVariable(r)) - a.width / 2 - this.intraCellSpacing - s.width / 2) > y ? (s.setGeneralPurposeVariable(r, y), d = !0) : x > s.getGeneralPurposeVariable(r) + 1 && (s.setGeneralPurposeVariable(r, x), d = !0)), d) {
      for (s = 0; s < h.length; s++) {
        r = h[s], null != (r = i.get(r)) && 0 == r.visited && (r.visited = !0, e.push(r));
      }

      for (s = 0; s < u.length; s++) {
        r = u[s], null != (r = i.get(r)) && 0 == r.visited && (r.visited = !0, e.push(r));
      }
    }

    l.visited = !1, o++;
  }
}, mxCoordinateAssignment.prototype.medianPos = function (t, e) {
  if (0 == t % 2) for (var i = e.maxRank; 0 < i; i--) {
    this.rankMedianPosition(i - 1, e, i);
  } else for (i = 0; i < e.maxRank - 1; i++) {
    this.rankMedianPosition(i + 1, e, i);
  }
}, mxCoordinateAssignment.prototype.rankMedianPosition = function (t, e, i) {
  e = e.ranks[t];

  for (var n = [], s = {}, o = 0; o < e.length; o++) {
    var l,
        r = e[o];
    n[o] = new WeightedCellSorter(), n[o].cell = r, n[o].rankIndex = o, s[r.id] = n[o], l = i < t ? r.getPreviousLayerConnectedCells(t) : r.getNextLayerConnectedCells(t), n[o].weightedValue = this.calculatedWeightedValue(r, l);
  }

  for (n.sort(WeightedCellSorter.prototype.compare), o = 0; o < n.length; o++) {
    var a;
    r = n[o].cell;
    a = 0, null != (l = i < t ? r.getPreviousLayerConnectedCells(t).slice() : r.getNextLayerConnectedCells(t).slice()) && (a = 0 < (a = l.length) ? this.medianXValue(l, i) : r.getGeneralPurposeVariable(t));
    var h = 0;
    l = -1e8;

    for (var u = n[o].rankIndex - 1; 0 <= u;) {
      var d = s[e[u].id];

      if (null != d) {
        var p = d.cell;
        d.visited ? (l = p.getGeneralPurposeVariable(t) + p.width / 2 + this.intraCellSpacing + h + r.width / 2, u = -1) : (h += p.width + this.intraCellSpacing, u--);
      }
    }

    for (h = 0, p = 1e8, u = n[o].rankIndex + 1; u < n.length;) {
      if (null != (d = s[e[u].id])) {
        var c = d.cell;
        d.visited ? (p = c.getGeneralPurposeVariable(t) - c.width / 2 - this.intraCellSpacing - h - r.width / 2, u = n.length) : (h += c.width + this.intraCellSpacing, u++);
      }
    }

    a >= l && a <= p ? r.setGeneralPurposeVariable(t, a) : a < l ? (r.setGeneralPurposeVariable(t, l), this.currentXDelta += l - a) : a > p && (r.setGeneralPurposeVariable(t, p), this.currentXDelta += a - p), n[o].visited = !0;
  }
}, mxCoordinateAssignment.prototype.calculatedWeightedValue = function (t, e) {
  for (var i = 0, n = 0; n < e.length; n++) {
    var s = e[n];
    t.isVertex() && s.isVertex() ? i++ : i = t.isEdge() && s.isEdge() ? i + 8 : i + 2;
  }

  return i;
}, mxCoordinateAssignment.prototype.medianXValue = function (t, e) {
  if (0 == t.length) return 0;

  for (var i = [], n = 0; n < t.length; n++) {
    i[n] = t[n].getGeneralPurposeVariable(e);
  }

  return i.sort(function (t, e) {
    return t - e;
  }), 1 == t.length % 2 ? i[Math.floor(t.length / 2)] : (i[(n = t.length / 2) - 1] + i[n]) / 2;
}, mxCoordinateAssignment.prototype.initialCoords = function (t, e) {
  this.calculateWidestRank(t, e);

  for (var i = this.widestRank; 0 <= i; i--) {
    i < e.maxRank && this.rankCoordinates(i, t, e);
  }

  for (i = this.widestRank + 1; i <= e.maxRank; i++) {
    0 < i && this.rankCoordinates(i, t, e);
  }
}, mxCoordinateAssignment.prototype.rankCoordinates = function (t, e, i) {
  e = i.ranks[t], i = this.initialX + (this.widestRankValue - this.rankWidths[t]) / 2;

  for (var n = !1, s = 0; s < e.length; s++) {
    var o = e[s];

    if (o.isVertex()) {
      var l = this.layout.getVertexBounds(o.cell);
      null != l ? this.orientation == mxConstants.DIRECTION_NORTH || this.orientation == mxConstants.DIRECTION_SOUTH ? (o.width = l.width, o.height = l.height) : (o.width = l.height, o.height = l.width) : n = !0;
    } else o.isEdge() && (l = 1, null != o.edges ? l = o.edges.length : mxLog.warn("edge.edges is null"), o.width = (l - 1) * this.parallelEdgeSpacing);

    i += o.width / 2, o.setX(t, i), o.setGeneralPurposeVariable(t, i), i += o.width / 2, i += this.intraCellSpacing;
  }

  1 == n && mxLog.warn("At least one cell has no bounds");
}, mxCoordinateAssignment.prototype.calculateWidestRank = function (t, e) {
  var i = -this.interRankCellSpacing,
      n = 0;
  this.rankWidths = [], this.rankY = [];

  for (var s = e.maxRank; 0 <= s; s--) {
    for (var o = 0, l = e.ranks[s], r = this.initialX, a = !1, h = 0; h < l.length; h++) {
      var u = l[h];

      if (u.isVertex()) {
        var d = this.layout.getVertexBounds(u.cell);
        null != d ? this.orientation == mxConstants.DIRECTION_NORTH || this.orientation == mxConstants.DIRECTION_SOUTH ? (u.width = d.width, u.height = d.height) : (u.width = d.height, u.height = d.width) : a = !0, o = Math.max(o, u.height);
      } else u.isEdge() && (d = 1, null != u.edges ? d = u.edges.length : mxLog.warn("edge.edges is null"), u.width = (d - 1) * this.parallelEdgeSpacing);

      r += u.width / 2, u.setX(s, r), u.setGeneralPurposeVariable(s, r), r += u.width / 2, (r += this.intraCellSpacing) > this.widestRankValue && (this.widestRankValue = r, this.widestRank = s), this.rankWidths[s] = r;
    }

    for (1 == a && mxLog.warn("At least one cell has no bounds"), this.rankY[s] = i, r = o / 2 + n / 2 + this.interRankCellSpacing, n = o, i = this.orientation == mxConstants.DIRECTION_NORTH || this.orientation == mxConstants.DIRECTION_WEST ? i + r : i - r, h = 0; h < l.length; h++) {
      l[h].setY(s, i);
    }
  }
}, mxCoordinateAssignment.prototype.minPath = function (t, e) {
  for (var i = e.edgeMapper.getValues(), n = 0; n < i.length; n++) {
    var s = i[n];

    if (!(1 > s.maxRank - s.minRank - 1)) {
      for (var o = s.getGeneralPurposeVariable(s.minRank + 1), l = !0, r = 0, a = s.minRank + 2; a < s.maxRank; a++) {
        o != (h = s.getGeneralPurposeVariable(a)) ? (l = !1, o = h) : r++;
      }

      if (!l) {
        l = o = 0;
        var h = [],
            u = [],
            d = s.getGeneralPurposeVariable(s.minRank + 1);

        for (a = s.minRank + 1; a < s.maxRank - 1; a++) {
          var p = s.getX(a + 1);
          d == p ? (h[a - s.minRank - 1] = d, o++) : this.repositionValid(e, s, a + 1, d) ? (h[a - s.minRank - 1] = d, o++) : d = h[a - s.minRank - 1] = p;
        }

        for (d = s.getX(a), a = s.maxRank - 1; a > s.minRank + 1; a--) {
          d == (p = s.getX(a - 1)) ? (u[a - s.minRank - 2] = d, l++) : this.repositionValid(e, s, a - 1, d) ? (u[a - s.minRank - 2] = d, l++) : (u[a - s.minRank - 2] = s.getX(a - 1), d = p);
        }

        if (l > r || o > r) if (l >= o) for (a = s.maxRank - 2; a > s.minRank; a--) {
          s.setX(a, u[a - s.minRank - 1]);
        } else if (o > l) for (a = s.minRank + 2; a < s.maxRank; a++) {
          s.setX(a, h[a - s.minRank - 2]);
        }
      }
    }
  }
}, mxCoordinateAssignment.prototype.repositionValid = function (t, e, i, n) {
  t = t.ranks[i];

  for (var s = -1, o = 0; o < t.length; o++) {
    if (e == t[o]) {
      s = o;
      break;
    }
  }

  if (0 > s) return !1;

  if (n < (o = e.getGeneralPurposeVariable(i))) {
    if (0 == s) return !0;
    if (!((i = (i = (t = t[s - 1]).getGeneralPurposeVariable(i)) + t.width / 2 + this.intraCellSpacing + e.width / 2) <= n)) return !1;
  } else if (n > o) {
    if (s == t.length - 1) return !0;
    if (!((i = (i = (t = t[s + 1]).getGeneralPurposeVariable(i)) - t.width / 2 - this.intraCellSpacing - e.width / 2) >= n)) return !1;
  }

  return !0;
}, mxCoordinateAssignment.prototype.setCellLocations = function (t, e) {
  this.rankTopY = [], this.rankBottomY = [];

  for (var i = 0; i < e.ranks.length; i++) {
    this.rankTopY[i] = Number.MAX_VALUE, this.rankBottomY[i] = -Number.MAX_VALUE;
  }

  var n = e.vertexMapper.getValues();

  for (i = 0; i < n.length; i++) {
    this.setVertexLocation(n[i]);
  }

  for (this.layout.edgeStyle != mxHierarchicalEdgeStyle.ORTHOGONAL && this.layout.edgeStyle != mxHierarchicalEdgeStyle.POLYLINE && this.layout.edgeStyle != mxHierarchicalEdgeStyle.CURVE || this.localEdgeProcessing(e), n = e.edgeMapper.getValues(), i = 0; i < n.length; i++) {
    this.setEdgePosition(n[i]);
  }
}, mxCoordinateAssignment.prototype.localEdgeProcessing = function (t) {
  for (var e = 0; e < t.ranks.length; e++) {
    for (var i = t.ranks[e], n = 0; n < i.length; n++) {
      var s = i[n];
      if (s.isVertex()) for (var o = s.getPreviousLayerConnectedCells(e), l = e - 1, r = 0; 2 > r; r++) {
        if (-1 < l && l < t.ranks.length && null != o && 0 < o.length) {
          for (var a = [], h = 0; h < o.length; h++) {
            var u = new WeightedCellSorter(o[h], o[h].getX(l));
            a.push(u);
          }

          a.sort(WeightedCellSorter.prototype.compare);
          var d = (u = s.x[0] - s.width / 2) + s.width,
              p = o = 0;

          for (l = [], h = 0; h < a.length; h++) {
            var c,
                m = a[h].cell;

            if (m.isVertex()) {
              c = 0 == r ? s.connectsAsSource : s.connectsAsTarget;

              for (var g = 0; g < c.length; g++) {
                c[g].source != m && c[g].target != m || (o += c[g].edges.length, p++, l.push(c[g]));
              }
            } else o += m.edges.length, p++, l.push(m);
          }

          for (s.width > (o + 1) * this.prefHozEdgeSep + 2 * this.prefHozEdgeSep && (u += this.prefHozEdgeSep, d -= this.prefHozEdgeSep), u += (a = (d - u) / o) / 2, d = this.minEdgeJetty - this.prefVertEdgeOff, h = 0; h < l.length; h++) {
            for (p = l[h].edges.length, null == (m = this.jettyPositions[l[h].ids[0]]) && (m = [], this.jettyPositions[l[h].ids[0]] = m), h < o / 2 ? d += this.prefVertEdgeOff : h > o / 2 && (d -= this.prefVertEdgeOff), c = 0; c < p; c++) {
              m[4 * c + 2 * r] = u, u += a, m[4 * c + 2 * r + 1] = d;
            }
          }
        }

        o = s.getNextLayerConnectedCells(e), l = e + 1;
      }
    }
  }
}, mxCoordinateAssignment.prototype.setEdgePosition = function (t) {
  var e = 0;

  if (101207 != t.temp[0]) {
    var i = t.maxRank,
        n = t.minRank;
    i == n && (i = t.source.maxRank, n = t.target.minRank);

    for (var s = 0, o = this.jettyPositions[t.ids[0]], l = t.isReversed ? t.target.cell : t.source.cell, r = this.layout.graph, a = this.orientation == mxConstants.DIRECTION_EAST || this.orientation == mxConstants.DIRECTION_SOUTH, h = 0; h < t.edges.length; h++) {
      var u = t.edges[h],
          d = this.layout.getVisibleTerminal(u, !0),
          p = [],
          c = t.isReversed;

      if (d != l && (c = !c), null != o) {
        var m = c ? 2 : 0,
            g = c ? a ? this.rankBottomY[n] : this.rankTopY[n] : a ? this.rankTopY[i] : this.rankBottomY[i],
            x = o[4 * s + 1 + m];
        c != a && (x = -x);
        g = g + x, m = o[4 * s + m];
        var y = r.model.getTerminal(u, !0);
        this.layout.isPort(y) && r.model.getParent(y) == d && (m = null != (m = r.view.getState(y)) ? m.x : d.geometry.x + t.source.width * y.geometry.x), this.orientation == mxConstants.DIRECTION_NORTH || this.orientation == mxConstants.DIRECTION_SOUTH ? (p.push(new mxPoint(m, g)), this.layout.edgeStyle == mxHierarchicalEdgeStyle.CURVE && p.push(new mxPoint(m, g + x))) : (p.push(new mxPoint(g, m)), this.layout.edgeStyle == mxHierarchicalEdgeStyle.CURVE && p.push(new mxPoint(g + x, m)));
      }

      for (m = t.x.length - 1, g = x = -1, d = t.maxRank - 1, c && (m = 0, x = t.x.length, g = 1, d = t.minRank + 1); t.maxRank != t.minRank && m != x; m += g) {
        y = t.x[m] + e;
        var f = (this.rankTopY[d] + this.rankBottomY[d + 1]) / 2,
            v = (this.rankTopY[d - 1] + this.rankBottomY[d]) / 2;

        if (c) {
          var C = f;
          f = v, v = C;
        }

        this.orientation == mxConstants.DIRECTION_NORTH || this.orientation == mxConstants.DIRECTION_SOUTH ? (p.push(new mxPoint(y, f)), p.push(new mxPoint(y, v))) : (p.push(new mxPoint(f, y)), p.push(new mxPoint(v, y))), this.limitX = Math.max(this.limitX, y), d += g;
      }

      null != o && (m = c ? 2 : 0, g = c ? a ? this.rankTopY[i] : this.rankBottomY[i] : a ? this.rankBottomY[n] : this.rankTopY[n], x = o[4 * s + 3 - m], c != a && (x = -x), g -= x, m = o[4 * s + 2 - m], c = r.model.getTerminal(u, !1), d = this.layout.getVisibleTerminal(u, !1), this.layout.isPort(c) && r.model.getParent(c) == d && (m = null != (m = r.view.getState(c)) ? m.x : d.geometry.x + t.target.width * c.geometry.x), this.orientation == mxConstants.DIRECTION_NORTH || this.orientation == mxConstants.DIRECTION_SOUTH ? (this.layout.edgeStyle == mxHierarchicalEdgeStyle.CURVE && p.push(new mxPoint(m, g - x)), p.push(new mxPoint(m, g))) : (this.layout.edgeStyle == mxHierarchicalEdgeStyle.CURVE && p.push(new mxPoint(g - x, m)), p.push(new mxPoint(g, m)))), t.isReversed && this.processReversedEdge(t, u), this.layout.setEdgePoints(u, p), e = 0 == e ? this.parallelEdgeSpacing : 0 < e ? -e : -e + this.parallelEdgeSpacing, s++;
    }

    t.temp[0] = 101207;
  }
}, mxCoordinateAssignment.prototype.setVertexLocation = function (t) {
  var e = t.cell,
      i = t.x[0] - t.width / 2,
      n = t.y[0] - t.height / 2;
  this.rankTopY[t.minRank] = Math.min(this.rankTopY[t.minRank], n), this.rankBottomY[t.minRank] = Math.max(this.rankBottomY[t.minRank], n + t.height), this.orientation == mxConstants.DIRECTION_NORTH || this.orientation == mxConstants.DIRECTION_SOUTH ? this.layout.setVertexLocation(e, i, n) : this.layout.setVertexLocation(e, n, i), this.limitX = Math.max(this.limitX, i + t.width);
}, mxCoordinateAssignment.prototype.processReversedEdge = function (t, e) {}, mxSwimlaneOrdering.prototype = new mxHierarchicalLayoutStage(), mxSwimlaneOrdering.prototype.constructor = mxSwimlaneOrdering, mxSwimlaneOrdering.prototype.layout = null, mxSwimlaneOrdering.prototype.execute = function (t) {
  t = this.layout.getModel();
  var e = mxUtils.clone(t.vertexMapper, null, !0),
      i = null;
  if (null != t.roots) for (var n = t.roots, s = (i = [], 0); s < n.length; s++) {
    mxCellPath.create(n[s]), i[s] = t.vertexMapper.get(n[s]);
  }
  t.visit(function (t, i, n, s, o) {
    s = null != t && t.swimlaneIndex == i.swimlaneIndex && i.isAncestor(t), o = null != t && null != n && t.swimlaneIndex < i.swimlaneIndex && n.source == i, s ? (n.invert(), mxUtils.remove(n, t.connectsAsSource), i.connectsAsSource.push(n), t.connectsAsTarget.push(n), mxUtils.remove(n, i.connectsAsTarget)) : o && (n.invert(), mxUtils.remove(n, t.connectsAsTarget), i.connectsAsTarget.push(n), t.connectsAsSource.push(n), mxUtils.remove(n, i.connectsAsSource)), t = mxCellPath.create(i.cell), delete e[t];
  }, i, !0, null);
};
var mxHierarchicalEdgeStyle = {
  ORTHOGONAL: 1,
  POLYLINE: 2,
  STRAIGHT: 3,
  CURVE: 4
};

function mxSwimlaneLayout(t, e, i) {
  mxGraphLayout.call(this, t), this.orientation = null != e ? e : mxConstants.DIRECTION_NORTH, this.deterministic = null == i || i;
}

function mxGraphModel(t) {
  this.currentEdit = this.createUndoableEdit(), null != t ? this.setRoot(t) : this.clear();
}

function mxRootChange(t, e) {
  this.model = t, this.previous = this.root = e;
}

function mxChildChange(t, e, i, n) {
  this.model = t, this.previous = this.parent = e, this.child = i, this.previousIndex = this.index = n;
}

function mxTerminalChange(t, e, i, n) {
  this.model = t, this.cell = e, this.previous = this.terminal = i, this.source = n;
}

function mxValueChange(t, e, i) {
  this.model = t, this.cell = e, this.previous = this.value = i;
}

function mxStyleChange(t, e, i) {
  this.model = t, this.cell = e, this.previous = this.style = i;
}

function mxGeometryChange(t, e, i) {
  this.model = t, this.cell = e, this.previous = this.geometry = i;
}

function mxCollapseChange(t, e, i) {
  this.model = t, this.cell = e, this.previous = this.collapsed = i;
}

function mxVisibleChange(t, e, i) {
  this.model = t, this.cell = e, this.previous = this.visible = i;
}

function mxCellAttributeChange(t, e, i) {
  this.cell = t, this.attribute = e, this.previous = this.value = i;
}

function mxCell(t, e, i) {
  this.value = t, this.setGeometry(e), this.setStyle(i), null != this.onInit && this.onInit();
}

function mxGeometry(t, e, i, n) {
  mxRectangle.call(this, t, e, i, n);
}

mxHierarchicalLayout.prototype = new mxGraphLayout(), mxHierarchicalLayout.prototype.constructor = mxHierarchicalLayout, mxHierarchicalLayout.prototype.roots = null, mxHierarchicalLayout.prototype.resizeParent = !1, mxHierarchicalLayout.prototype.maintainParentLocation = !1, mxHierarchicalLayout.prototype.moveParent = !1, mxHierarchicalLayout.prototype.parentBorder = 0, mxHierarchicalLayout.prototype.intraCellSpacing = 30, mxHierarchicalLayout.prototype.interRankCellSpacing = 100, mxHierarchicalLayout.prototype.interHierarchySpacing = 60, mxHierarchicalLayout.prototype.parallelEdgeSpacing = 10, mxHierarchicalLayout.prototype.orientation = mxConstants.DIRECTION_NORTH, mxHierarchicalLayout.prototype.fineTuning = !0, mxHierarchicalLayout.prototype.tightenToSource = !0, mxHierarchicalLayout.prototype.disableEdgeStyle = !0, mxHierarchicalLayout.prototype.traverseAncestors = !0, mxHierarchicalLayout.prototype.model = null, mxHierarchicalLayout.prototype.edgesCache = null, mxHierarchicalLayout.prototype.edgeSourceTermCache = null, mxHierarchicalLayout.prototype.edgesTargetTermCache = null, mxHierarchicalLayout.prototype.edgeStyle = mxHierarchicalEdgeStyle.POLYLINE, mxHierarchicalLayout.prototype.getModel = function () {
  return this.model;
}, mxHierarchicalLayout.prototype.execute = function (t, e) {
  this.parent = t;
  var i = this.graph.model;

  if (this.edgesCache = new mxDictionary(), this.edgeSourceTermCache = new mxDictionary(), this.edgesTargetTermCache = new mxDictionary(), null == e || e instanceof Array || (e = [e]), null != e || null != t) {
    if (this.parentY = this.parentX = null, t != this.root && null != i.isVertex(t) && this.maintainParentLocation) {
      var n = this.graph.getCellGeometry(t);
      null != n && (this.parentX = n.x, this.parentY = n.y);
    }

    if (null != e) {
      for (var s = [], o = 0; o < e.length; o++) {
        (null == t || i.isAncestor(t, e[o])) && i.isVertex(e[o]) && s.push(e[o]);
      }

      this.roots = s;
    }

    i.beginUpdate();

    try {
      this.run(t), this.resizeParent && !this.graph.isCellCollapsed(t) && this.graph.updateGroupBounds([t], this.parentBorder, this.moveParent), null != this.parentX && null != this.parentY && null != (n = this.graph.getCellGeometry(t)) && ((n = n.clone()).x = this.parentX, n.y = this.parentY, i.setGeometry(t, n));
    } finally {
      i.endUpdate();
    }
  }
}, mxHierarchicalLayout.prototype.findRoots = function (t, e) {
  var i = [];

  if (null != t && null != e) {
    var n,
        s = this.graph.model,
        o = null,
        l = -1e5;

    for (n in e) {
      var r = e[n];

      if (s.isVertex(r) && this.graph.isCellVisible(r)) {
        for (var a = this.getEdges(r), h = 0, u = 0, d = 0; d < a.length; d++) {
          this.getVisibleTerminal(a[d], !0) == r ? h++ : u++;
        }

        0 == u && 0 < h && i.push(r), (a = h - u) > l && (l = a, o = r);
      }
    }

    0 == i.length && null != o && i.push(o);
  }

  return i;
}, mxHierarchicalLayout.prototype.getEdges = function (t) {
  if (null != (i = this.edgesCache.get(t))) return i;

  for (var e = this.graph.model, i = [], n = this.graph.isCellCollapsed(t), s = e.getChildCount(t), o = 0; o < s; o++) {
    var l = e.getChildAt(t, o);
    this.isPort(l) ? i = i.concat(e.getEdges(l, !0, !0)) : !n && this.graph.isCellVisible(l) || (i = i.concat(e.getEdges(l, !0, !0)));
  }

  for (i = i.concat(e.getEdges(t, !0, !0)), e = [], o = 0; o < i.length; o++) {
    ((n = this.getVisibleTerminal(i[o], !0)) == (s = this.getVisibleTerminal(i[o], !1)) || n != s && (s == t && (null == this.parent || this.isAncestor(this.parent, n, this.traverseAncestors)) || n == t && (null == this.parent || this.isAncestor(this.parent, s, this.traverseAncestors)))) && e.push(i[o]);
  }

  return this.edgesCache.put(t, e), e;
}, mxHierarchicalLayout.prototype.getVisibleTerminal = function (t, e) {
  var i = this.edgesTargetTermCache;
  if (e && (i = this.edgeSourceTermCache), null != (n = i.get(t))) return n;
  var n,
      s = null != (n = this.graph.view.getState(t)) ? n.getVisibleTerminal(e) : this.graph.view.getVisibleTerminal(t, e);
  return null == s && (s = null != n ? n.getVisibleTerminal(e) : this.graph.view.getVisibleTerminal(t, e)), null != s && (this.isPort(s) && (s = this.graph.model.getParent(s)), i.put(t, s)), s;
}, mxHierarchicalLayout.prototype.run = function (t) {
  var e = [],
      i = [];

  if (null == this.roots && null != t) {
    var n = {};
    this.filterDescendants(t, n), this.roots = [];
    var s,
        o = !0;

    for (s in n) {
      if (null != n[s]) {
        o = !1;
        break;
      }
    }

    for (; !o;) {
      var l = this.findRoots(t, n);

      for (o = 0; o < l.length; o++) {
        var r = {};
        e.push(r), this.traverse(l[o], !0, null, i, r, e, n);
      }

      for (o = 0; o < l.length; o++) {
        this.roots.push(l[o]);
      }

      for (s in o = !0, n) {
        if (null != n[s]) {
          o = !1;
          break;
        }
      }
    }
  } else for (o = 0; o < this.roots.length; o++) {
    r = {}, e.push(r), this.traverse(this.roots[o], !0, null, i, r, e, null);
  }

  for (o = i = 0; o < e.length; o++) {
    for (s in n = [], r = e[o]) {
      n.push(r[s]);
    }

    this.model = new mxGraphHierarchyModel(this, n, this.roots, t, this.tightenToSource), this.cycleStage(t), this.layeringStage(), this.crossingStage(t), i = this.placementStage(i, t);
  }
}, mxHierarchicalLayout.prototype.filterDescendants = function (t, e) {
  var i = this.graph.model;
  if (i.isVertex(t) && t != this.parent && this.graph.isCellVisible(t) && (e[mxObjectIdentity.get(t)] = t), this.traverseAncestors || t == this.parent && this.graph.isCellVisible(t)) for (var n = i.getChildCount(t), s = 0; s < n; s++) {
    var o = i.getChildAt(t, s);
    this.isPort(o) || this.filterDescendants(o, e);
  }
}, mxHierarchicalLayout.prototype.isPort = function (t) {
  return null != t && null != t.geometry && t.geometry.relative;
}, mxHierarchicalLayout.prototype.getEdgesBetween = function (t, e, i) {
  i = null != i && i;

  for (var n = this.getEdges(t), s = [], o = 0; o < n.length; o++) {
    var l = this.getVisibleTerminal(n[o], !0),
        r = this.getVisibleTerminal(n[o], !1);
    (l == t && r == e || !i && l == e && r == t) && s.push(n[o]);
  }

  return s;
}, mxHierarchicalLayout.prototype.traverse = function (t, e, i, n, s, o, l) {
  if (null != t && null != n) if (null != n[a = mxObjectIdentity.get(t)] || null != l && null == l[a]) {
    if (null == s[a]) for (i = 0; i < o.length; i++) {
      if (null != (e = o[i])[a]) {
        for (r in e) {
          s[r] = e[r];
        }

        o.splice(i, 1);
        break;
      }
    }
  } else {
    null == s[a] && (s[a] = t), null == n[a] && (n[a] = t), null !== l && delete l[a];
    var r = this.getEdges(t),
        a = [];

    for (i = 0; i < r.length; i++) {
      a[i] = this.getVisibleTerminal(r[i], !0) == t;
    }

    for (i = 0; i < r.length; i++) {
      if (!e || a[i]) {
        t = this.getVisibleTerminal(r[i], !a[i]);

        for (var h = 1, u = 0; u < r.length; u++) {
          if (u != i) {
            var d = a[u];
            this.getVisibleTerminal(r[u], !d) == t && (d ? h++ : h--);
          }
        }

        0 <= h && (s = this.traverse(t, e, r[i], n, s, o, l));
      }
    }
  }
  return s;
}, mxHierarchicalLayout.prototype.cycleStage = function (t) {
  new mxMinimumCycleRemover(this).execute(t);
}, mxHierarchicalLayout.prototype.layeringStage = function () {
  this.model.initialRank(), this.model.fixRanks();
}, mxHierarchicalLayout.prototype.crossingStage = function (t) {
  new mxMedianHybridCrossingReduction(this).execute(t);
}, mxHierarchicalLayout.prototype.placementStage = function (t, e) {
  var i = new mxCoordinateAssignment(this, this.intraCellSpacing, this.interRankCellSpacing, this.orientation, t, this.parallelEdgeSpacing);
  return i.fineTuning = this.fineTuning, i.execute(e), i.limitX + this.interHierarchySpacing;
}, mxSwimlaneLayout.prototype = new mxGraphLayout(), mxSwimlaneLayout.prototype.constructor = mxSwimlaneLayout, mxSwimlaneLayout.prototype.roots = null, mxSwimlaneLayout.prototype.swimlanes = null, mxSwimlaneLayout.prototype.dummyVertices = null, mxSwimlaneLayout.prototype.dummyVertexWidth = 50, mxSwimlaneLayout.prototype.resizeParent = !1, mxSwimlaneLayout.prototype.maintainParentLocation = !1, mxSwimlaneLayout.prototype.moveParent = !1, mxSwimlaneLayout.prototype.parentBorder = 30, mxSwimlaneLayout.prototype.intraCellSpacing = 30, mxSwimlaneLayout.prototype.interRankCellSpacing = 100, mxSwimlaneLayout.prototype.interHierarchySpacing = 60, mxSwimlaneLayout.prototype.parallelEdgeSpacing = 10, mxSwimlaneLayout.prototype.orientation = mxConstants.DIRECTION_NORTH, mxSwimlaneLayout.prototype.fineTuning = !0, mxSwimlaneLayout.prototype.tightenToSource = !0, mxSwimlaneLayout.prototype.disableEdgeStyle = !0, mxSwimlaneLayout.prototype.traverseAncestors = !0, mxSwimlaneLayout.prototype.model = null, mxSwimlaneLayout.prototype.edgesCache = null, mxHierarchicalLayout.prototype.edgeSourceTermCache = null, mxHierarchicalLayout.prototype.edgesTargetTermCache = null, mxHierarchicalLayout.prototype.edgeStyle = mxHierarchicalEdgeStyle.POLYLINE, mxSwimlaneLayout.prototype.getModel = function () {
  return this.model;
}, mxSwimlaneLayout.prototype.execute = function (t, e) {
  this.parent = t;
  var i = this.graph.model;

  if (this.edgesCache = new mxDictionary(), this.edgeSourceTermCache = new mxDictionary(), this.edgesTargetTermCache = new mxDictionary(), !(null == e || 1 > e.length)) {
    if (null == t && (t = i.getParent(e[0])), this.parentY = this.parentX = null, t != this.root && null != i.isVertex(t) && this.maintainParentLocation) {
      var n = this.graph.getCellGeometry(t);
      null != n && (this.parentX = n.x, this.parentY = n.y);
    }

    this.swimlanes = e, this.dummyVertices = [];

    for (var s = 0; s < e.length; s++) {
      var o = this.graph.getChildCells(e[s]);
      null != o && 0 != o.length || (o = this.graph.insertVertex(e[s], null, null, 0, 0, this.dummyVertexWidth, 0), this.dummyVertices.push(o));
    }

    i.beginUpdate();

    try {
      this.run(t), this.resizeParent && !this.graph.isCellCollapsed(t) && this.graph.updateGroupBounds([t], this.parentBorder, this.moveParent), null != this.parentX && null != this.parentY && null != (n = this.graph.getCellGeometry(t)) && ((n = n.clone()).x = this.parentX, n.y = this.parentY, i.setGeometry(t, n)), this.graph.removeCells(this.dummyVertices);
    } finally {
      i.endUpdate();
    }
  }
}, mxSwimlaneLayout.prototype.updateGroupBounds = function () {
  var t,
      e = [],
      i = this.model;

  for (t in i.edgeMapper) {
    for (var n = i.edgeMapper[t], s = 0; s < n.edges.length; s++) {
      e.push(n.edges[s]);
    }
  }

  for (e = this.graph.getBoundingBoxFromGeometry(e, !0), i = [], s = 0; s < this.swimlanes.length; s++) {
    var o = this.swimlanes[s];

    if (null != (t = this.graph.getCellGeometry(o))) {
      var l = this.graph.getChildCells(o);
      n = this.graph.isSwimlane(o) ? this.graph.getStartSize(o) : new mxRectangle(), o = this.graph.getBoundingBoxFromGeometry(l);
      i[s] = o, n = o.y + t.y - n.height - this.parentBorder, t = o.y + t.y + o.height, null == e ? e = new mxRectangle(0, n, 0, t - n) : (e.y = Math.min(e.y, n), e.height = Math.max(e.y + e.height, t) - e.y);
    }
  }

  for (s = 0; s < this.swimlanes.length; s++) {
    if (o = this.swimlanes[s], null != (t = this.graph.getCellGeometry(o))) {
      l = this.graph.getChildCells(o), n = this.graph.isSwimlane(o) ? this.graph.getStartSize(o) : new mxRectangle();
      var r = t.clone(),
          a = 0 == s ? this.parentBorder : this.interRankCellSpacing / 2;
      r.x += i[s].x - n.width - a, r.y = r.y + e.y - t.y - this.parentBorder, r.width = i[s].width + n.width + this.interRankCellSpacing / 2 + a, r.height = e.height + n.height + 2 * this.parentBorder, this.graph.model.setGeometry(o, r), this.graph.moveCells(l, -i[s].x + n.width + a, t.y - e.y + this.parentBorder);
    }
  }
}, mxSwimlaneLayout.prototype.findRoots = function (t, e) {
  var i = [];

  if (null != t && null != e) {
    var n,
        s = this.graph.model,
        o = null,
        l = -1e5;

    for (n in e) {
      var r = e[n];

      if (null != r && s.isVertex(r) && this.graph.isCellVisible(r) && s.isAncestor(t, r)) {
        for (var a = this.getEdges(r), h = 0, u = 0, d = 0; d < a.length; d++) {
          var p = this.getVisibleTerminal(a[d], !0);
          p == r ? (p = this.getVisibleTerminal(a[d], !1), s.isAncestor(t, p) && h++) : s.isAncestor(t, p) && u++;
        }

        0 == u && 0 < h && i.push(r), (a = h - u) > l && (l = a, o = r);
      }
    }

    0 == i.length && null != o && i.push(o);
  }

  return i;
}, mxSwimlaneLayout.prototype.getEdges = function (t) {
  if (null != (i = this.edgesCache.get(t))) return i;

  for (var e = this.graph.model, i = [], n = this.graph.isCellCollapsed(t), s = e.getChildCount(t), o = 0; o < s; o++) {
    var l = e.getChildAt(t, o);
    this.isPort(l) ? i = i.concat(e.getEdges(l, !0, !0)) : !n && this.graph.isCellVisible(l) || (i = i.concat(e.getEdges(l, !0, !0)));
  }

  for (i = i.concat(e.getEdges(t, !0, !0)), e = [], o = 0; o < i.length; o++) {
    ((n = this.getVisibleTerminal(i[o], !0)) == (s = this.getVisibleTerminal(i[o], !1)) || n != s && (s == t && (null == this.parent || this.graph.isValidAncestor(n, this.parent, this.traverseAncestors)) || n == t && (null == this.parent || this.graph.isValidAncestor(s, this.parent, this.traverseAncestors)))) && e.push(i[o]);
  }

  return this.edgesCache.put(t, e), e;
}, mxSwimlaneLayout.prototype.getVisibleTerminal = function (t, e) {
  var i = this.edgesTargetTermCache;
  if (e && (i = this.edgeSourceTermCache), null != (n = i.get(t))) return n;
  var n,
      s = null != (n = this.graph.view.getState(t)) ? n.getVisibleTerminal(e) : this.graph.view.getVisibleTerminal(t, e);
  return null == s && (s = null != n ? n.getVisibleTerminal(e) : this.graph.view.getVisibleTerminal(t, e)), null != s && (this.isPort(s) && (s = this.graph.model.getParent(s)), i.put(t, s)), s;
}, mxSwimlaneLayout.prototype.run = function (t) {
  var e = [],
      i = [];

  if (null != this.swimlanes && 0 < this.swimlanes.length && null != t) {
    for (var n = {}, s = 0; s < this.swimlanes.length; s++) {
      this.filterDescendants(this.swimlanes[s], n);
    }

    this.roots = [];
    var o;
    s = !0;

    for (o in n) {
      if (null != n[o]) {
        s = !1;
        break;
      }
    }

    for (var l = 0; !s && l < this.swimlanes.length;) {
      var r = this.findRoots(this.swimlanes[l], n);
      if (0 == r.length) l++;else {
        for (s = 0; s < r.length; s++) {
          var a = {};
          e.push(a), this.traverse(r[s], !0, null, i, a, e, n, l);
        }

        for (s = 0; s < r.length; s++) {
          this.roots.push(r[s]);
        }

        for (o in s = !0, n) {
          if (null != n[o]) {
            s = !1;
            break;
          }
        }
      }
    }
  } else for (s = 0; s < this.roots.length; s++) {
    a = {}, e.push(a), this.traverse(this.roots[s], !0, null, i, a, e, null);
  }

  for (o in e = [], i) {
    e.push(i[o]);
  }

  this.model = new mxSwimlaneModel(this, e, this.roots, t, this.tightenToSource), this.cycleStage(t), this.layeringStage(), this.crossingStage(t), initialX = this.placementStage(0, t);
}, mxSwimlaneLayout.prototype.filterDescendants = function (t, e) {
  var i = this.graph.model;
  if (i.isVertex(t) && t != this.parent && i.getParent(t) != this.parent && this.graph.isCellVisible(t) && (e[mxObjectIdentity.get(t)] = t), this.traverseAncestors || t == this.parent && this.graph.isCellVisible(t)) for (var n = i.getChildCount(t), s = 0; s < n; s++) {
    var o = i.getChildAt(t, s);
    this.isPort(o) || this.filterDescendants(o, e);
  }
}, mxSwimlaneLayout.prototype.isPort = function (t) {
  return !!t.geometry.relative;
}, mxSwimlaneLayout.prototype.getEdgesBetween = function (t, e, i) {
  i = null != i && i;

  for (var n = this.getEdges(t), s = [], o = 0; o < n.length; o++) {
    var l = this.getVisibleTerminal(n[o], !0),
        r = this.getVisibleTerminal(n[o], !1);
    (l == t && r == e || !i && l == e && r == t) && s.push(n[o]);
  }

  return s;
}, mxSwimlaneLayout.prototype.traverse = function (t, e, i, n, s, o, l, r) {
  if (null != t && null != n) if (null != n[h = mxObjectIdentity.get(t)] || null != l && null == l[h]) {
    if (null == s[h]) for (i = 0; i < o.length; i++) {
      if (null != (t = o[i])[h]) {
        for (a in t) {
          s[a] = t[a];
        }

        o.splice(i, 1);
        break;
      }
    }
  } else {
    null == s[h] && (s[h] = t), null == n[h] && (n[h] = t), null !== l && delete l[h];
    var a = this.getEdges(t),
        h = this.graph.model;

    for (i = 0; i < a.length; i++) {
      var u,
          d = this.getVisibleTerminal(a[i], !0),
          p = d == t;

      for (p && (d = this.getVisibleTerminal(a[i], !1)), u = 0; u < this.swimlanes.length && !h.isAncestor(this.swimlanes[u], d); u++) {
        ;
      }

      u >= this.swimlanes.length || !(u > r || (!e || p) && u == r) || (s = this.traverse(d, e, a[i], n, s, o, l, u));
    }
  }
  return s;
}, mxSwimlaneLayout.prototype.cycleStage = function (t) {
  new mxSwimlaneOrdering(this).execute(t);
}, mxSwimlaneLayout.prototype.layeringStage = function () {
  this.model.initialRank(), this.model.fixRanks();
}, mxSwimlaneLayout.prototype.crossingStage = function (t) {
  new mxMedianHybridCrossingReduction(this).execute(t);
}, mxSwimlaneLayout.prototype.placementStage = function (t, e) {
  var i = new mxCoordinateAssignment(this, this.intraCellSpacing, this.interRankCellSpacing, this.orientation, t, this.parallelEdgeSpacing);
  return i.fineTuning = this.fineTuning, i.execute(e), i.limitX + this.interHierarchySpacing;
}, mxGraphModel.prototype = new mxEventSource(), mxGraphModel.prototype.constructor = mxGraphModel, mxGraphModel.prototype.root = null, mxGraphModel.prototype.cells = null, mxGraphModel.prototype.maintainEdgeParent = !0, mxGraphModel.prototype.ignoreRelativeEdgeParent = !0, mxGraphModel.prototype.createIds = !0, mxGraphModel.prototype.prefix = "", mxGraphModel.prototype.postfix = "", mxGraphModel.prototype.nextId = 0, mxGraphModel.prototype.currentEdit = null, mxGraphModel.prototype.updateLevel = 0, mxGraphModel.prototype.endingUpdate = !1, mxGraphModel.prototype.clear = function () {
  this.setRoot(this.createRoot());
}, mxGraphModel.prototype.isCreateIds = function () {
  return this.createIds;
}, mxGraphModel.prototype.setCreateIds = function (t) {
  this.createIds = t;
}, mxGraphModel.prototype.createRoot = function () {
  var t = new mxCell();
  return t.insert(new mxCell()), t;
}, mxGraphModel.prototype.getCell = function (t) {
  return null != this.cells ? this.cells[t] : null;
}, mxGraphModel.prototype.filterCells = function (t, e) {
  var i = null;

  if (null != t) {
    i = [];

    for (var n = 0; n < t.length; n++) {
      e(t[n]) && i.push(t[n]);
    }
  }

  return i;
}, mxGraphModel.prototype.getDescendants = function (t) {
  return this.filterDescendants(null, t);
}, mxGraphModel.prototype.filterDescendants = function (t, e) {
  var i = [];
  e = e || this.getRoot(), (null == t || t(e)) && i.push(e);

  for (var n = this.getChildCount(e), s = 0; s < n; s++) {
    var o = this.getChildAt(e, s);
    i = i.concat(this.filterDescendants(t, o));
  }

  return i;
}, mxGraphModel.prototype.getRoot = function (t) {
  var e = t || this.root;
  if (null != t) for (; null != t;) {
    e = t, t = this.getParent(t);
  }
  return e;
}, mxGraphModel.prototype.setRoot = function (t) {
  return this.execute(new mxRootChange(this, t)), t;
}, mxGraphModel.prototype.rootChanged = function (t) {
  var e = this.root;
  return this.root = t, this.nextId = 0, this.cells = null, this.cellAdded(t), e;
}, mxGraphModel.prototype.isRoot = function (t) {
  return null != t && this.root == t;
}, mxGraphModel.prototype.isLayer = function (t) {
  return this.isRoot(this.getParent(t));
}, mxGraphModel.prototype.isAncestor = function (t, e) {
  for (; null != e && e != t;) {
    e = this.getParent(e);
  }

  return e == t;
}, mxGraphModel.prototype.contains = function (t) {
  return this.isAncestor(this.root, t);
}, mxGraphModel.prototype.getParent = function (t) {
  return null != t ? t.getParent() : null;
}, mxGraphModel.prototype.add = function (t, e, i) {
  if (e != t && null != t && null != e) {
    null == i && (i = this.getChildCount(t));
    var n = t != this.getParent(e);
    this.execute(new mxChildChange(this, t, e, i)), this.maintainEdgeParent && n && this.updateEdgeParents(e);
  }

  return e;
}, mxGraphModel.prototype.cellAdded = function (t) {
  if (null != t) {
    if (null == t.getId() && this.createIds && t.setId(this.createId(t)), null != t.getId()) if ((e = this.getCell(t.getId())) != t) {
      for (; null != e;) {
        t.setId(this.createId(t)), e = this.getCell(t.getId());
      }

      null == this.cells && (this.cells = {}), this.cells[t.getId()] = t;
    }
    mxUtils.isNumeric(t.getId()) && (this.nextId = Math.max(this.nextId, t.getId()));

    for (var e = this.getChildCount(t), i = 0; i < e; i++) {
      this.cellAdded(this.getChildAt(t, i));
    }
  }
}, mxGraphModel.prototype.createId = function (t) {
  return t = this.nextId, this.nextId++, this.prefix + t + this.postfix;
}, mxGraphModel.prototype.updateEdgeParents = function (t, e) {
  e = e || this.getRoot(t);

  for (var i = this.getChildCount(t), n = 0; n < i; n++) {
    var s = this.getChildAt(t, n);
    this.updateEdgeParents(s, e);
  }

  for (s = this.getEdgeCount(t), i = [], n = 0; n < s; n++) {
    i.push(this.getEdgeAt(t, n));
  }

  for (n = 0; n < i.length; n++) {
    s = i[n], this.isAncestor(e, s) && this.updateEdgeParent(s, e);
  }
}, mxGraphModel.prototype.updateEdgeParent = function (t, e) {
  for (var i = this.getTerminal(t, !0), n = this.getTerminal(t, !1); null != i && !this.isEdge(i) && null != i.geometry && i.geometry.relative;) {
    i = this.getParent(i);
  }

  for (; null != n && this.ignoreRelativeEdgeParent && !this.isEdge(n) && null != n.geometry && n.geometry.relative;) {
    n = this.getParent(n);
  }

  if (this.isAncestor(e, i) && this.isAncestor(e, n) && null != (i = i == n ? this.getParent(i) : this.getNearestCommonAncestor(i, n)) && (this.getParent(i) != this.root || this.isAncestor(i, t)) && this.getParent(t) != i) {
    if (null != (n = this.getGeometry(t))) {
      var s = this.getOrigin(this.getParent(t)),
          o = this.getOrigin(i),
          l = o.x - s.x;
      s = o.y - s.y;
      (n = n.clone()).translate(-l, -s), this.setGeometry(t, n);
    }

    this.add(i, t, this.getChildCount(i));
  }
}, mxGraphModel.prototype.getOrigin = function (t) {
  var e;
  return null != t ? (e = this.getOrigin(this.getParent(t)), this.isEdge(t) || null != (t = this.getGeometry(t)) && (e.x += t.x, e.y += t.y)) : e = new mxPoint(), e;
}, mxGraphModel.prototype.getNearestCommonAncestor = function (t, e) {
  if (null != t && null != e && null != (o = mxCellPath.create(e)) && 0 < o.length) {
    var i = t,
        n = mxCellPath.create(i);

    if (o.length < n.length) {
      i = e;
      var s = n,
          o = (n = o, s);
    }

    for (; null != i;) {
      if (s = this.getParent(i), 0 == o.indexOf(n + mxCellPath.PATH_SEPARATOR) && null != s) return i;
      n = mxCellPath.getParentPath(n), i = s;
    }
  }

  return null;
}, mxGraphModel.prototype.remove = function (t) {
  return t == this.root ? this.setRoot(null) : null != this.getParent(t) && this.execute(new mxChildChange(this, null, t)), t;
}, mxGraphModel.prototype.cellRemoved = function (t) {
  if (null != t && null != this.cells) {
    for (var e = this.getChildCount(t) - 1; 0 <= e; e--) {
      this.cellRemoved(this.getChildAt(t, e));
    }

    null != this.cells && null != t.getId() && delete this.cells[t.getId()];
  }
}, mxGraphModel.prototype.parentForCellChanged = function (t, e, i) {
  var n = this.getParent(t);
  return null != e ? e == n && n.getIndex(t) == i || e.insert(t, i) : null != n && (i = n.getIndex(t), n.remove(i)), this.contains(n) || null == e ? null == e && this.cellRemoved(t) : this.cellAdded(t), n;
}, mxGraphModel.prototype.getChildCount = function (t) {
  return null != t ? t.getChildCount() : 0;
}, mxGraphModel.prototype.getChildAt = function (t, e) {
  return null != t ? t.getChildAt(e) : null;
}, mxGraphModel.prototype.getChildren = function (t) {
  return null != t ? t.children : null;
}, mxGraphModel.prototype.getChildVertices = function (t) {
  return this.getChildCells(t, !0, !1);
}, mxGraphModel.prototype.getChildEdges = function (t) {
  return this.getChildCells(t, !1, !0);
}, mxGraphModel.prototype.getChildCells = function (t, e, i) {
  e = null != e && e, i = null != i && i;

  for (var n = this.getChildCount(t), s = [], o = 0; o < n; o++) {
    var l = this.getChildAt(t, o);
    (!i && !e || i && this.isEdge(l) || e && this.isVertex(l)) && s.push(l);
  }

  return s;
}, mxGraphModel.prototype.getTerminal = function (t, e) {
  return null != t ? t.getTerminal(e) : null;
}, mxGraphModel.prototype.setTerminal = function (t, e, i) {
  var n = e != this.getTerminal(t, i);
  return this.execute(new mxTerminalChange(this, t, e, i)), this.maintainEdgeParent && n && this.updateEdgeParent(t, this.getRoot()), e;
}, mxGraphModel.prototype.setTerminals = function (t, e, i) {
  this.beginUpdate();

  try {
    this.setTerminal(t, e, !0), this.setTerminal(t, i, !1);
  } finally {
    this.endUpdate();
  }
}, mxGraphModel.prototype.terminalForCellChanged = function (t, e, i) {
  var n = this.getTerminal(t, i);
  return null != e ? e.insertEdge(t, i) : null != n && n.removeEdge(t, i), n;
}, mxGraphModel.prototype.getEdgeCount = function (t) {
  return null != t ? t.getEdgeCount() : 0;
}, mxGraphModel.prototype.getEdgeAt = function (t, e) {
  return null != t ? t.getEdgeAt(e) : null;
}, mxGraphModel.prototype.getDirectedEdgeCount = function (t, e, i) {
  for (var n = 0, s = this.getEdgeCount(t), o = 0; o < s; o++) {
    var l = this.getEdgeAt(t, o);
    l != i && this.getTerminal(l, e) == t && n++;
  }

  return n;
}, mxGraphModel.prototype.getConnections = function (t) {
  return this.getEdges(t, !0, !0, !1);
}, mxGraphModel.prototype.getIncomingEdges = function (t) {
  return this.getEdges(t, !0, !1, !1);
}, mxGraphModel.prototype.getOutgoingEdges = function (t) {
  return this.getEdges(t, !1, !0, !1);
}, mxGraphModel.prototype.getEdges = function (t, e, i, n) {
  e = null == e || e, i = null == i || i, n = null == n || n;

  for (var s = this.getEdgeCount(t), o = [], l = 0; l < s; l++) {
    var r = this.getEdgeAt(t, l),
        a = this.getTerminal(r, !0),
        h = this.getTerminal(r, !1);
    (n && a == h || a != h && (e && h == t || i && a == t)) && o.push(r);
  }

  return o;
}, mxGraphModel.prototype.getEdgesBetween = function (t, e, i) {
  i = null != i && i;
  var n = this.getEdgeCount(t),
      s = this.getEdgeCount(e),
      o = t,
      l = n;

  for (s < n && (l = s, o = e), n = [], s = 0; s < l; s++) {
    var r = this.getEdgeAt(o, s),
        a = this.getTerminal(r, !0),
        h = this.getTerminal(r, !1);
    (a == t && h == e || !i && h == t && a == e) && n.push(r);
  }

  return n;
}, mxGraphModel.prototype.getOpposites = function (t, e, i, n) {
  i = null == i || i, n = null == n || n;
  var s = [];
  if (null != t) for (var o = 0; o < t.length; o++) {
    var l = this.getTerminal(t[o], !0),
        r = this.getTerminal(t[o], !1);
    l == e && null != r && r != e && n ? s.push(r) : r == e && null != l && l != e && i && s.push(l);
  }
  return s;
}, mxGraphModel.prototype.getTopmostCells = function (t) {
  for (var e = new mxDictionary(), i = [], n = 0; n < t.length; n++) {
    e.put(t[n], !0);
  }

  for (n = 0; n < t.length; n++) {
    for (var s = t[n], o = !0, l = this.getParent(s); null != l;) {
      if (e.get(l)) {
        o = !1;
        break;
      }

      l = this.getParent(l);
    }

    o && i.push(s);
  }

  return i;
}, mxGraphModel.prototype.isVertex = function (t) {
  return null != t && t.isVertex();
}, mxGraphModel.prototype.isEdge = function (t) {
  return null != t && t.isEdge();
}, mxGraphModel.prototype.isConnectable = function (t) {
  return null != t && t.isConnectable();
}, mxGraphModel.prototype.getValue = function (t) {
  return null != t ? t.getValue() : null;
}, mxGraphModel.prototype.setValue = function (t, e) {
  return this.execute(new mxValueChange(this, t, e)), e;
}, mxGraphModel.prototype.valueForCellChanged = function (t, e) {
  return t.valueChanged(e);
}, mxGraphModel.prototype.getGeometry = function (t) {
  return null != t ? t.getGeometry() : null;
}, mxGraphModel.prototype.setGeometry = function (t, e) {
  return e != this.getGeometry(t) && this.execute(new mxGeometryChange(this, t, e)), e;
}, mxGraphModel.prototype.geometryForCellChanged = function (t, e) {
  var i = this.getGeometry(t);
  return t.setGeometry(e), i;
}, mxGraphModel.prototype.getStyle = function (t) {
  return null != t ? t.getStyle() : null;
}, mxGraphModel.prototype.setStyle = function (t, e) {
  return e != this.getStyle(t) && this.execute(new mxStyleChange(this, t, e)), e;
}, mxGraphModel.prototype.styleForCellChanged = function (t, e) {
  var i = this.getStyle(t);
  return t.setStyle(e), i;
}, mxGraphModel.prototype.isCollapsed = function (t) {
  return null != t && t.isCollapsed();
}, mxGraphModel.prototype.setCollapsed = function (t, e) {
  return e != this.isCollapsed(t) && this.execute(new mxCollapseChange(this, t, e)), e;
}, mxGraphModel.prototype.collapsedStateForCellChanged = function (t, e) {
  var i = this.isCollapsed(t);
  return t.setCollapsed(e), i;
}, mxGraphModel.prototype.isVisible = function (t) {
  return null != t && t.isVisible();
}, mxGraphModel.prototype.setVisible = function (t, e) {
  return e != this.isVisible(t) && this.execute(new mxVisibleChange(this, t, e)), e;
}, mxGraphModel.prototype.visibleStateForCellChanged = function (t, e) {
  var i = this.isVisible(t);
  return t.setVisible(e), i;
}, mxGraphModel.prototype.execute = function (t) {
  t.execute(), this.beginUpdate(), this.currentEdit.add(t), this.fireEvent(new mxEventObject(mxEvent.EXECUTE, "change", t)), this.fireEvent(new mxEventObject(mxEvent.EXECUTED, "change", t)), this.endUpdate();
}, mxGraphModel.prototype.beginUpdate = function () {
  this.updateLevel++, this.fireEvent(new mxEventObject(mxEvent.BEGIN_UPDATE)), 1 == this.updateLevel && this.fireEvent(new mxEventObject(mxEvent.START_EDIT));
}, mxGraphModel.prototype.endUpdate = function () {
  if (this.updateLevel--, 0 == this.updateLevel && this.fireEvent(new mxEventObject(mxEvent.END_EDIT)), !this.endingUpdate) {
    this.endingUpdate = 0 == this.updateLevel, this.fireEvent(new mxEventObject(mxEvent.END_UPDATE, "edit", this.currentEdit));

    try {
      if (this.endingUpdate && !this.currentEdit.isEmpty()) {
        this.fireEvent(new mxEventObject(mxEvent.BEFORE_UNDO, "edit", this.currentEdit));
        var t = this.currentEdit;
        this.currentEdit = this.createUndoableEdit(), t.notify(), this.fireEvent(new mxEventObject(mxEvent.UNDO, "edit", t));
      }
    } finally {
      this.endingUpdate = !1;
    }
  }
}, mxGraphModel.prototype.createUndoableEdit = function (t) {
  var e = new mxUndoableEdit(this, null == t || t);
  return e.notify = function () {
    e.source.fireEvent(new mxEventObject(mxEvent.CHANGE, "edit", e, "changes", e.changes)), e.source.fireEvent(new mxEventObject(mxEvent.NOTIFY, "edit", e, "changes", e.changes));
  }, e;
}, mxGraphModel.prototype.mergeChildren = function (t, e, i) {
  i = null == i || i, this.beginUpdate();

  try {
    var n = {};

    for (var s in this.mergeChildrenImpl(t, e, i, n), n) {
      var o = n[s],
          l = this.getTerminal(o, !0);
      null != l && (l = n[mxCellPath.create(l)], this.setTerminal(o, l, !0)), null != (l = this.getTerminal(o, !1)) && (l = n[mxCellPath.create(l)], this.setTerminal(o, l, !1));
    }
  } finally {
    this.endUpdate();
  }
}, mxGraphModel.prototype.mergeChildrenImpl = function (t, e, i, n) {
  this.beginUpdate();

  try {
    for (var s = t.getChildCount(), o = 0; o < s; o++) {
      var l = t.getChildAt(o);

      if ("function" == typeof l.getId) {
        var r = l.getId(),
            a = null == r || this.isEdge(l) && i ? null : this.getCell(r);

        if (null == a) {
          var h = l.clone();
          h.setId(r), h.setTerminal(l.getTerminal(!0), !0), h.setTerminal(l.getTerminal(!1), !1), a = e.insert(h), this.cellAdded(a);
        }

        n[mxCellPath.create(l)] = a, this.mergeChildrenImpl(l, a, i, n);
      }
    }
  } finally {
    this.endUpdate();
  }
}, mxGraphModel.prototype.getParents = function (t) {
  var e = [];
  if (null != t) for (var i = new mxDictionary(), n = 0; n < t.length; n++) {
    var s = this.getParent(t[n]);
    null == s || i.get(s) || (i.put(s, !0), e.push(s));
  }
  return e;
}, mxGraphModel.prototype.cloneCell = function (t) {
  return null != t ? this.cloneCells([t], !0)[0] : null;
}, mxGraphModel.prototype.cloneCells = function (t, e, i) {
  i = null != i ? i : {};

  for (var n = [], s = 0; s < t.length; s++) {
    null != t[s] ? n.push(this.cloneCellImpl(t[s], i, e)) : n.push(null);
  }

  for (s = 0; s < n.length; s++) {
    null != n[s] && this.restoreClone(n[s], t[s], i);
  }

  return n;
}, mxGraphModel.prototype.cloneCellImpl = function (t, e, i) {
  var n = mxObjectIdentity.get(t),
      s = e[n];
  if (null == s && (s = this.cellCloned(t), e[n] = s, i)) for (i = this.getChildCount(t), n = 0; n < i; n++) {
    var o = this.cloneCellImpl(this.getChildAt(t, n), e, !0);
    s.insert(o);
  }
  return s;
}, mxGraphModel.prototype.cellCloned = function (t) {
  return t.clone();
}, mxGraphModel.prototype.restoreClone = function (t, e, i) {
  null != (n = this.getTerminal(e, !0)) && null != (n = i[mxObjectIdentity.get(n)]) && n.insertEdge(t, !0), null != (n = this.getTerminal(e, !1)) && null != (n = i[mxObjectIdentity.get(n)]) && n.insertEdge(t, !1);

  for (var n = this.getChildCount(t), s = 0; s < n; s++) {
    this.restoreClone(this.getChildAt(t, s), this.getChildAt(e, s), i);
  }
}, mxRootChange.prototype.execute = function () {
  this.root = this.previous, this.previous = this.model.rootChanged(this.previous);
}, mxChildChange.prototype.execute = function () {
  if (null != this.child) {
    var t = this.model.getParent(this.child),
        e = null != t ? t.getIndex(this.child) : 0;
    null == this.previous && this.connect(this.child, !1), t = this.model.parentForCellChanged(this.child, this.previous, this.previousIndex), null != this.previous && this.connect(this.child, !0), this.parent = this.previous, this.previous = t, this.index = this.previousIndex, this.previousIndex = e;
  }
}, mxChildChange.prototype.connect = function (t, e) {
  e = null == e || e;
  var i = t.getTerminal(!0),
      n = t.getTerminal(!1);

  for (null != i && (e ? this.model.terminalForCellChanged(t, i, !0) : this.model.terminalForCellChanged(t, null, !0)), null != n && (e ? this.model.terminalForCellChanged(t, n, !1) : this.model.terminalForCellChanged(t, null, !1)), t.setTerminal(i, !0), t.setTerminal(n, !1), i = this.model.getChildCount(t), n = 0; n < i; n++) {
    this.connect(this.model.getChildAt(t, n), e);
  }
}, mxTerminalChange.prototype.execute = function () {
  null != this.cell && (this.terminal = this.previous, this.previous = this.model.terminalForCellChanged(this.cell, this.previous, this.source));
}, mxValueChange.prototype.execute = function () {
  null != this.cell && (this.value = this.previous, this.previous = this.model.valueForCellChanged(this.cell, this.previous));
}, mxStyleChange.prototype.execute = function () {
  null != this.cell && (this.style = this.previous, this.previous = this.model.styleForCellChanged(this.cell, this.previous));
}, mxGeometryChange.prototype.execute = function () {
  null != this.cell && (this.geometry = this.previous, this.previous = this.model.geometryForCellChanged(this.cell, this.previous));
}, mxCollapseChange.prototype.execute = function () {
  null != this.cell && (this.collapsed = this.previous, this.previous = this.model.collapsedStateForCellChanged(this.cell, this.previous));
}, mxVisibleChange.prototype.execute = function () {
  null != this.cell && (this.visible = this.previous, this.previous = this.model.visibleStateForCellChanged(this.cell, this.previous));
}, mxCellAttributeChange.prototype.execute = function () {
  if (null != this.cell) {
    var t = this.cell.getAttribute(this.attribute);
    null == this.previous ? this.cell.value.removeAttribute(this.attribute) : this.cell.setAttribute(this.attribute, this.previous), this.previous = t;
  }
}, mxCell.prototype.id = null, mxCell.prototype.value = null, mxCell.prototype.geometry = null, mxCell.prototype.style = null, mxCell.prototype.vertex = !1, mxCell.prototype.edge = !1, mxCell.prototype.connectable = !0, mxCell.prototype.visible = !0, mxCell.prototype.collapsed = !1, mxCell.prototype.parent = null, mxCell.prototype.source = null, mxCell.prototype.target = null, mxCell.prototype.children = null, mxCell.prototype.edges = null, mxCell.prototype.mxTransient = "id value parent source target children edges".split(" "), mxCell.prototype.getId = function () {
  return this.id;
}, mxCell.prototype.setId = function (t) {
  this.id = t;
}, mxCell.prototype.getValue = function () {
  return this.value;
}, mxCell.prototype.setValue = function (t) {
  this.value = t;
}, mxCell.prototype.valueChanged = function (t) {
  var e = this.getValue();
  return this.setValue(t), e;
}, mxCell.prototype.getGeometry = function () {
  return this.geometry;
}, mxCell.prototype.setGeometry = function (t) {
  this.geometry = t;
}, mxCell.prototype.getStyle = function () {
  return this.style;
}, mxCell.prototype.setStyle = function (t) {
  this.style = t;
}, mxCell.prototype.isVertex = function () {
  return 0 != this.vertex;
}, mxCell.prototype.setVertex = function (t) {
  this.vertex = t;
}, mxCell.prototype.isEdge = function () {
  return 0 != this.edge;
}, mxCell.prototype.setEdge = function (t) {
  this.edge = t;
}, mxCell.prototype.isConnectable = function () {
  return 0 != this.connectable;
}, mxCell.prototype.setConnectable = function (t) {
  this.connectable = t;
}, mxCell.prototype.isVisible = function () {
  return 0 != this.visible;
}, mxCell.prototype.setVisible = function (t) {
  this.visible = t;
}, mxCell.prototype.isCollapsed = function () {
  return 0 != this.collapsed;
}, mxCell.prototype.setCollapsed = function (t) {
  this.collapsed = t;
}, mxCell.prototype.getParent = function () {
  return this.parent;
}, mxCell.prototype.setParent = function (t) {
  this.parent = t;
}, mxCell.prototype.getTerminal = function (t) {
  return t ? this.source : this.target;
}, mxCell.prototype.setTerminal = function (t, e) {
  return e ? this.source = t : this.target = t, t;
}, mxCell.prototype.getChildCount = function () {
  return null == this.children ? 0 : this.children.length;
}, mxCell.prototype.getIndex = function (t) {
  return mxUtils.indexOf(this.children, t);
}, mxCell.prototype.getChildAt = function (t) {
  return null == this.children ? null : this.children[t];
}, mxCell.prototype.insert = function (t, e) {
  return null != t && (null == e && (e = this.getChildCount(), t.getParent() == this && e--), t.removeFromParent(), t.setParent(this), null == this.children ? (this.children = [], this.children.push(t)) : this.children.splice(e, 0, t)), t;
}, mxCell.prototype.remove = function (t) {
  var e = null;
  return null != this.children && 0 <= t && null != (e = this.getChildAt(t)) && (this.children.splice(t, 1), e.setParent(null)), e;
}, mxCell.prototype.removeFromParent = function () {
  if (null != this.parent) {
    var t = this.parent.getIndex(this);
    this.parent.remove(t);
  }
}, mxCell.prototype.getEdgeCount = function () {
  return null == this.edges ? 0 : this.edges.length;
}, mxCell.prototype.getEdgeIndex = function (t) {
  return mxUtils.indexOf(this.edges, t);
}, mxCell.prototype.getEdgeAt = function (t) {
  return null == this.edges ? null : this.edges[t];
}, mxCell.prototype.insertEdge = function (t, e) {
  return null != t && (t.removeFromTerminal(e), t.setTerminal(this, e), null == this.edges || t.getTerminal(!e) != this || 0 > mxUtils.indexOf(this.edges, t)) && (null == this.edges && (this.edges = []), this.edges.push(t)), t;
}, mxCell.prototype.removeEdge = function (t, e) {
  if (null != t) {
    if (t.getTerminal(!e) != this && null != this.edges) {
      var i = this.getEdgeIndex(t);
      0 <= i && this.edges.splice(i, 1);
    }

    t.setTerminal(null, e);
  }

  return t;
}, mxCell.prototype.removeFromTerminal = function (t) {
  var e = this.getTerminal(t);
  null != e && e.removeEdge(this, t);
}, mxCell.prototype.hasAttribute = function (t) {
  var e = this.getValue();
  return null != e && e.nodeType == mxConstants.NODETYPE_ELEMENT && e.hasAttribute ? e.hasAttribute(t) : null != e.getAttribute(t);
}, mxCell.prototype.getAttribute = function (t, e) {
  var i = this.getValue();
  return (null != i && i.nodeType == mxConstants.NODETYPE_ELEMENT ? i.getAttribute(t) : null) || e;
}, mxCell.prototype.setAttribute = function (t, e) {
  var i = this.getValue();
  null != i && i.nodeType == mxConstants.NODETYPE_ELEMENT && i.setAttribute(t, e);
}, mxCell.prototype.clone = function () {
  var t = mxUtils.clone(this, this.mxTransient);
  return t.setValue(this.cloneValue()), t;
}, mxCell.prototype.cloneValue = function () {
  var t = this.getValue();
  return null != t && ("function" == typeof t.clone ? t = t.clone() : isNaN(t.nodeType) || (t = t.cloneNode(!0))), t;
}, mxGeometry.prototype = new mxRectangle(), mxGeometry.prototype.constructor = mxGeometry, mxGeometry.prototype.TRANSLATE_CONTROL_POINTS = !0, mxGeometry.prototype.alternateBounds = null, mxGeometry.prototype.sourcePoint = null, mxGeometry.prototype.targetPoint = null, mxGeometry.prototype.points = null, mxGeometry.prototype.offset = null, mxGeometry.prototype.relative = !1, mxGeometry.prototype.swap = function () {
  if (null != this.alternateBounds) {
    var t = new mxRectangle(this.x, this.y, this.width, this.height);
    this.x = this.alternateBounds.x, this.y = this.alternateBounds.y, this.width = this.alternateBounds.width, this.height = this.alternateBounds.height, this.alternateBounds = t;
  }
}, mxGeometry.prototype.getTerminalPoint = function (t) {
  return t ? this.sourcePoint : this.targetPoint;
}, mxGeometry.prototype.setTerminalPoint = function (t, e) {
  return e ? this.sourcePoint = t : this.targetPoint = t, t;
}, mxGeometry.prototype.rotate = function (t, e) {
  var i = mxUtils.toRadians(t),
      n = Math.cos(i);
  i = Math.sin(i);

  if (!this.relative) {
    var s = new mxPoint(this.getCenterX(), this.getCenterY());
    s = mxUtils.getRotatedPoint(s, n, i, e);
    this.x = Math.round(s.x - this.width / 2), this.y = Math.round(s.y - this.height / 2);
  }

  if (null != this.sourcePoint && (s = mxUtils.getRotatedPoint(this.sourcePoint, n, i, e), this.sourcePoint.x = Math.round(s.x), this.sourcePoint.y = Math.round(s.y)), null != this.targetPoint && (s = mxUtils.getRotatedPoint(this.targetPoint, n, i, e), this.targetPoint.x = Math.round(s.x), this.targetPoint.y = Math.round(s.y)), null != this.points) for (var o = 0; o < this.points.length; o++) {
    null != this.points[o] && (s = mxUtils.getRotatedPoint(this.points[o], n, i, e), this.points[o].x = Math.round(s.x), this.points[o].y = Math.round(s.y));
  }
}, mxGeometry.prototype.translate = function (t, e) {
  if (t = parseFloat(t), e = parseFloat(e), this.relative || (this.x = parseFloat(this.x) + t, this.y = parseFloat(this.y) + e), null != this.sourcePoint && (this.sourcePoint.x = parseFloat(this.sourcePoint.x) + t, this.sourcePoint.y = parseFloat(this.sourcePoint.y) + e), null != this.targetPoint && (this.targetPoint.x = parseFloat(this.targetPoint.x) + t, this.targetPoint.y = parseFloat(this.targetPoint.y) + e), this.TRANSLATE_CONTROL_POINTS && null != this.points) for (var i = 0; i < this.points.length; i++) {
    null != this.points[i] && (this.points[i].x = parseFloat(this.points[i].x) + t, this.points[i].y = parseFloat(this.points[i].y) + e);
  }
}, mxGeometry.prototype.scale = function (t, e, i) {
  if (t = parseFloat(t), e = parseFloat(e), null != this.sourcePoint && (this.sourcePoint.x = parseFloat(this.sourcePoint.x) * t, this.sourcePoint.y = parseFloat(this.sourcePoint.y) * e), null != this.targetPoint && (this.targetPoint.x = parseFloat(this.targetPoint.x) * t, this.targetPoint.y = parseFloat(this.targetPoint.y) * e), null != this.points) for (var n = 0; n < this.points.length; n++) {
    null != this.points[n] && (this.points[n].x = parseFloat(this.points[n].x) * t, this.points[n].y = parseFloat(this.points[n].y) * e);
  }
  this.relative || (this.x = parseFloat(this.x) * t, this.y = parseFloat(this.y) * e, i && (e = t = Math.min(t, e)), this.width = parseFloat(this.width) * t, this.height = parseFloat(this.height) * e);
}, mxGeometry.prototype.equals = function (t) {
  return mxRectangle.prototype.equals.apply(this, arguments) && this.relative == t.relative && (null == this.sourcePoint && null == t.sourcePoint || null != this.sourcePoint && this.sourcePoint.equals(t.sourcePoint)) && (null == this.targetPoint && null == t.targetPoint || null != this.targetPoint && this.targetPoint.equals(t.targetPoint)) && (null == this.points && null == t.points || null != this.points && mxUtils.equalPoints(this.points, t.points)) && (null == this.alternateBounds && null == t.alternateBounds || null != this.alternateBounds && this.alternateBounds.equals(t.alternateBounds)) && (null == this.offset && null == t.offset || null != this.offset && this.offset.equals(t.offset));
};
var mxCellPath = {
  PATH_SEPARATOR: ".",
  create: function create(t) {
    var e = "";
    if (null != t) for (var i = t.getParent(); null != i;) {
      e = i.getIndex(t) + mxCellPath.PATH_SEPARATOR + e, i = (t = i).getParent();
    }
    return 1 < (t = e.length) && (e = e.substring(0, t - 1)), e;
  },
  getParentPath: function getParentPath(t) {
    if (null != t) {
      var e = t.lastIndexOf(mxCellPath.PATH_SEPARATOR);
      if (0 <= e) return t.substring(0, e);
      if (0 < t.length) return "";
    }

    return null;
  },
  resolve: function resolve(t, e) {
    var i = t;
    if (null != e) for (var n = e.split(mxCellPath.PATH_SEPARATOR), s = 0; s < n.length; s++) {
      i = i.getChildAt(parseInt(n[s]));
    }
    return i;
  },
  compare: function compare(t, e) {
    for (var i = Math.min(t.length, e.length), n = 0, s = 0; s < i; s++) {
      if (t[s] != e[s]) {
        0 == t[s].length || 0 == e[s].length ? n = t[s] == e[s] ? 0 : t[s] > e[s] ? 1 : -1 : n = (i = parseInt(t[s])) == (s = parseInt(e[s])) ? 0 : i > s ? 1 : -1;
        break;
      }
    }

    return 0 == n && (i = t.length) != (s = e.length) && (n = i > s ? 1 : -1), n;
  }
},
    mxPerimeter = {
  RectanglePerimeter: function RectanglePerimeter(t, e, i, n) {
    e = t.getCenterX();
    var s = t.getCenterY(),
        o = Math.atan2(i.y - s, i.x - e),
        l = new mxPoint(0, 0),
        r = Math.PI,
        a = Math.PI / 2 - o,
        h = Math.atan2(t.height, t.width);
    return o < -r + h || o > r - h ? (l.x = t.x, l.y = s - t.width * Math.tan(o) / 2) : o < -h ? (l.y = t.y, l.x = e - t.height * Math.tan(a) / 2) : o < h ? (l.x = t.x + t.width, l.y = s + t.width * Math.tan(o) / 2) : (l.y = t.y + t.height, l.x = e + t.height * Math.tan(a) / 2), n && (i.x >= t.x && i.x <= t.x + t.width ? l.x = i.x : i.y >= t.y && i.y <= t.y + t.height && (l.y = i.y), i.x < t.x ? l.x = t.x : i.x > t.x + t.width && (l.x = t.x + t.width), i.y < t.y ? l.y = t.y : i.y > t.y + t.height && (l.y = t.y + t.height)), l;
  },
  EllipsePerimeter: function EllipsePerimeter(t, e, i, n) {
    var s = t.x,
        o = t.y,
        l = t.width / 2,
        r = t.height / 2,
        a = s + l,
        h = o + r;
    e = i.x, i = i.y;
    var u = parseInt(e - a),
        d = parseInt(i - h);
    if (0 == u && 0 != d) return new mxPoint(a, h + r * d / Math.abs(d));
    if (0 == u && 0 == d) return new mxPoint(e, i);

    if (n) {
      if (i >= o && i <= o + t.height) return t = i - h, t = Math.sqrt(l * l * (1 - t * t / (r * r))) || 0, e <= s && (t = -t), new mxPoint(a + t, i);
      if (e >= s && e <= s + t.width) return t = e - a, t = Math.sqrt(r * r * (1 - t * t / (l * l))) || 0, i <= o && (t = -t), new mxPoint(e, h + t);
    }

    return h -= (s = d / u) * a, a = (-(t = -2 * a * (o = l * l * s * s + r * r)) - (r = Math.sqrt(t * t - 4 * o * (l * l * s * s * a * a + r * r * a * a - l * l * r * r)))) / (2 * o), r = s * (l = (-t + r) / (2 * o)) + h, h = s * a + h, Math.sqrt(Math.pow(l - e, 2) + Math.pow(r - i, 2)) < Math.sqrt(Math.pow(a - e, 2) + Math.pow(h - i, 2)) ? (e = l, i = r) : (e = a, i = h), new mxPoint(e, i);
  },
  RhombusPerimeter: function RhombusPerimeter(t, e, i, n) {
    e = t.x;
    var s = t.y,
        o = t.width,
        l = e + o / 2,
        r = s + (t = t.height) / 2,
        a = i.x;
    if (i = i.y, l == a) return new mxPoint(l, r > i ? s : s + t);
    if (r == i) return new mxPoint(l > a ? e : e + o, r);
    var h = l,
        u = r;
    return n && (a >= e && a <= e + o ? h = a : i >= s && i <= s + t && (u = i)), a < l ? i < r ? mxUtils.intersection(a, i, h, u, l, s, e, r) : mxUtils.intersection(a, i, h, u, l, s + t, e, r) : i < r ? mxUtils.intersection(a, i, h, u, l, s, e + o, r) : mxUtils.intersection(a, i, h, u, l, s + t, e + o, r);
  },
  TrianglePerimeter: function TrianglePerimeter(t, e, i, n) {
    var s = (e = null != e ? e.style[mxConstants.STYLE_DIRECTION] : null) == mxConstants.DIRECTION_NORTH || e == mxConstants.DIRECTION_SOUTH,
        o = t.x,
        l = t.y,
        r = t.width,
        a = t.height;
    t = o + r / 2;
    var h = l + a / 2,
        u = new mxPoint(o, l),
        d = new mxPoint(o + r, h),
        p = new mxPoint(o, l + a);
    e == mxConstants.DIRECTION_NORTH ? (u = p, d = new mxPoint(t, l), p = new mxPoint(o + r, l + a)) : e == mxConstants.DIRECTION_SOUTH ? (d = new mxPoint(t, l + a), p = new mxPoint(o + r, l)) : e == mxConstants.DIRECTION_WEST && (u = new mxPoint(o + r, l), d = new mxPoint(o, h), p = new mxPoint(o + r, l + a));
    var c = i.x - t,
        m = i.y - h;
    c = s ? Math.atan2(c, m) : Math.atan2(m, c), m = s ? Math.atan2(r, a) : Math.atan2(a, r);
    return (e == mxConstants.DIRECTION_NORTH || e == mxConstants.DIRECTION_WEST ? c > -m && c < m : c < -Math.PI + m || c > Math.PI - m) ? i = n && (s && i.x >= u.x && i.x <= p.x || !s && i.y >= u.y && i.y <= p.y) ? s ? new mxPoint(i.x, u.y) : new mxPoint(u.x, i.y) : e == mxConstants.DIRECTION_NORTH ? new mxPoint(o + r / 2 + a * Math.tan(c) / 2, l + a) : e == mxConstants.DIRECTION_SOUTH ? new mxPoint(o + r / 2 - a * Math.tan(c) / 2, l) : e == mxConstants.DIRECTION_WEST ? new mxPoint(o + r, l + a / 2 + r * Math.tan(c) / 2) : new mxPoint(o, l + a / 2 - r * Math.tan(c) / 2) : (n && (n = new mxPoint(t, h), i.y >= l && i.y <= l + a ? (n.x = s ? t : e == mxConstants.DIRECTION_WEST ? o + r : o, n.y = i.y) : i.x >= o && i.x <= o + r && (n.x = i.x, n.y = s ? e == mxConstants.DIRECTION_NORTH ? l + a : l : h), t = n.x, h = n.y), i = s && i.x <= o + r / 2 || !s && i.y <= l + a / 2 ? mxUtils.intersection(i.x, i.y, t, h, u.x, u.y, d.x, d.y) : mxUtils.intersection(i.x, i.y, t, h, d.x, d.y, p.x, p.y)), null == i && (i = new mxPoint(t, h)), i;
  },
  HexagonPerimeter: function HexagonPerimeter(t, e, i, n) {
    var s = t.x,
        o = t.y,
        l = t.width,
        r = t.height,
        a = t.getCenterX();
    t = t.getCenterY();
    var h = i.x,
        u = i.y,
        d = -Math.atan2(u - t, h - a),
        p = Math.PI,
        c = Math.PI / 2,
        m = (e = null != e ? mxUtils.getValue(e.style, mxConstants.STYLE_DIRECTION, mxConstants.DIRECTION_EAST) : mxConstants.DIRECTION_EAST) == mxConstants.DIRECTION_NORTH || e == mxConstants.DIRECTION_SOUTH;
    e = new mxPoint();
    var g = new mxPoint();

    if ((h < s && u < o || h < s && u > o + r || h > s + l && u < o || h > s + l && u > o + r) && (n = !1), n) {
      if (m) {
        if (h == a) {
          if (u <= o) return new mxPoint(a, o);
          if (u >= o + r) return new mxPoint(a, o + r);
        } else if (h < s) {
          if (u == o + r / 4) return new mxPoint(s, o + r / 4);
          if (u == o + 3 * r / 4) return new mxPoint(s, o + 3 * r / 4);
        } else if (h > s + l) {
          if (u == o + r / 4) return new mxPoint(s + l, o + r / 4);
          if (u == o + 3 * r / 4) return new mxPoint(s + l, o + 3 * r / 4);
        } else if (h == s) {
          if (u < t) return new mxPoint(s, o + r / 4);
          if (u > t) return new mxPoint(s, o + 3 * r / 4);
        } else if (h == s + l) {
          if (u < t) return new mxPoint(s + l, o + r / 4);
          if (u > t) return new mxPoint(s + l, o + 3 * r / 4);
        }

        if (u == o) return new mxPoint(a, o);
        if (u == o + r) return new mxPoint(a, o + r);
        h < a ? u > o + r / 4 && u < o + 3 * r / 4 ? (e = new mxPoint(s, o), g = new mxPoint(s, o + r)) : u < o + r / 4 ? (e = new mxPoint(s - Math.floor(.5 * l), o + Math.floor(.5 * r)), g = new mxPoint(s + l, o - Math.floor(.25 * r))) : u > o + 3 * r / 4 && (e = new mxPoint(s - Math.floor(.5 * l), o + Math.floor(.5 * r)), g = new mxPoint(s + l, o + Math.floor(1.25 * r))) : h > a && (u > o + r / 4 && u < o + 3 * r / 4 ? (e = new mxPoint(s + l, o), g = new mxPoint(s + l, o + r)) : u < o + r / 4 ? (e = new mxPoint(s, o - Math.floor(.25 * r)), g = new mxPoint(s + Math.floor(1.5 * l), o + Math.floor(.5 * r))) : u > o + 3 * r / 4 && (e = new mxPoint(s + Math.floor(1.5 * l), o + Math.floor(.5 * r)), g = new mxPoint(s, o + Math.floor(1.25 * r))));
      } else {
        if (u == t) {
          if (h <= s) return new mxPoint(s, o + r / 2);
          if (h >= s + l) return new mxPoint(s + l, o + r / 2);
        } else if (u < o) {
          if (h == s + l / 4) return new mxPoint(s + l / 4, o);
          if (h == s + 3 * l / 4) return new mxPoint(s + 3 * l / 4, o);
        } else if (u > o + r) {
          if (h == s + l / 4) return new mxPoint(s + l / 4, o + r);
          if (h == s + 3 * l / 4) return new mxPoint(s + 3 * l / 4, o + r);
        } else if (u == o) {
          if (h < a) return new mxPoint(s + l / 4, o);
          if (h > a) return new mxPoint(s + 3 * l / 4, o);
        } else if (u == o + r) {
          if (h < a) return new mxPoint(s + l / 4, o + r);
          if (u > t) return new mxPoint(s + 3 * l / 4, o + r);
        }

        if (h == s) return new mxPoint(s, t);
        if (h == s + l) return new mxPoint(s + l, t);
        u < t ? h > s + l / 4 && h < s + 3 * l / 4 ? (e = new mxPoint(s, o), g = new mxPoint(s + l, o)) : h < s + l / 4 ? (e = new mxPoint(s - Math.floor(.25 * l), o + r), g = new mxPoint(s + Math.floor(.5 * l), o - Math.floor(.5 * r))) : h > s + 3 * l / 4 && (e = new mxPoint(s + Math.floor(.5 * l), o - Math.floor(.5 * r)), g = new mxPoint(s + Math.floor(1.25 * l), o + r)) : u > t && (h > s + l / 4 && h < s + 3 * l / 4 ? (e = new mxPoint(s, o + r), g = new mxPoint(s + l, o + r)) : h < s + l / 4 ? (e = new mxPoint(s - Math.floor(.25 * l), o), g = new mxPoint(s + Math.floor(.5 * l), o + Math.floor(1.5 * r))) : h > s + 3 * l / 4 && (e = new mxPoint(s + Math.floor(.5 * l), o + Math.floor(1.5 * r)), g = new mxPoint(s + Math.floor(1.25 * l), o)));
      }

      n = a, d = t, h >= s && h <= s + l ? (n = h, d = u < t ? o + r : o) : u >= o && u <= o + r && (d = u, n = h < a ? s + l : s), i = mxUtils.intersection(n, d, i.x, i.y, e.x, e.y, g.x, g.y);
    } else {
      if (m) {
        if (d == (h = Math.atan2(r / 4, l / 2))) return new mxPoint(s + l, o + Math.floor(.25 * r));
        if (d == c) return new mxPoint(s + Math.floor(.5 * l), o);
        if (d == p - h) return new mxPoint(s, o + Math.floor(.25 * r));
        if (d == -h) return new mxPoint(s + l, o + Math.floor(.75 * r));
        if (d == -c) return new mxPoint(s + Math.floor(.5 * l), o + r);
        if (d == -p + h) return new mxPoint(s, o + Math.floor(.75 * r));
        d < h && d > -h ? (e = new mxPoint(s + l, o), g = new mxPoint(s + l, o + r)) : d > h && d < c ? (e = new mxPoint(s, o - Math.floor(.25 * r)), g = new mxPoint(s + Math.floor(1.5 * l), o + Math.floor(.5 * r))) : d > c && d < p - h ? (e = new mxPoint(s - Math.floor(.5 * l), o + Math.floor(.5 * r)), g = new mxPoint(s + l, o - Math.floor(.25 * r))) : d > p - h && d <= p || d < -p + h && d >= -p ? (e = new mxPoint(s, o), g = new mxPoint(s, o + r)) : d < -h && d > -c ? (e = new mxPoint(s + Math.floor(1.5 * l), o + Math.floor(.5 * r)), g = new mxPoint(s, o + Math.floor(1.25 * r))) : d < -c && d > -p + h && (e = new mxPoint(s - Math.floor(.5 * l), o + Math.floor(.5 * r)), g = new mxPoint(s + l, o + Math.floor(1.25 * r)));
      } else {
        if (d == (h = Math.atan2(r / 2, l / 4))) return new mxPoint(s + Math.floor(.75 * l), o);
        if (d == p - h) return new mxPoint(s + Math.floor(.25 * l), o);
        if (d == p || d == -p) return new mxPoint(s, o + Math.floor(.5 * r));
        if (0 == d) return new mxPoint(s + l, o + Math.floor(.5 * r));
        if (d == -h) return new mxPoint(s + Math.floor(.75 * l), o + r);
        if (d == -p + h) return new mxPoint(s + Math.floor(.25 * l), o + r);
        0 < d && d < h ? (e = new mxPoint(s + Math.floor(.5 * l), o - Math.floor(.5 * r)), g = new mxPoint(s + Math.floor(1.25 * l), o + r)) : d > h && d < p - h ? (e = new mxPoint(s, o), g = new mxPoint(s + l, o)) : d > p - h && d < p ? (e = new mxPoint(s - Math.floor(.25 * l), o + r), g = new mxPoint(s + Math.floor(.5 * l), o - Math.floor(.5 * r))) : 0 > d && d > -h ? (e = new mxPoint(s + Math.floor(.5 * l), o + Math.floor(1.5 * r)), g = new mxPoint(s + Math.floor(1.25 * l), o)) : d < -h && d > -p + h ? (e = new mxPoint(s, o + r), g = new mxPoint(s + l, o + r)) : d < -p + h && d > -p && (e = new mxPoint(s - Math.floor(.25 * l), o), g = new mxPoint(s + Math.floor(.5 * l), o + Math.floor(1.5 * r)));
      }

      i = mxUtils.intersection(a, t, i.x, i.y, e.x, e.y, g.x, g.y);
    }

    return null == i ? new mxPoint(a, t) : i;
  }
};

function mxPrintPreview(t, e, i, n, s, o, l, r, a) {
  this.graph = t, this.scale = null != e ? e : 1 / t.pageScale, this.border = null != n ? n : 0, this.pageFormat = mxRectangle.fromRectangle(null != i ? i : t.pageFormat), this.title = null != r ? r : "Printer-friendly version", this.x0 = null != s ? s : 0, this.y0 = null != o ? o : 0, this.borderColor = l, this.pageSelector = null == a || a;
}

function mxStylesheet() {
  this.styles = {}, this.putDefaultVertexStyle(this.createDefaultVertexStyle()), this.putDefaultEdgeStyle(this.createDefaultEdgeStyle());
}

function mxCellState(t, e, i) {
  this.view = t, this.cell = e, this.style = i, this.origin = new mxPoint(), this.absoluteOffset = new mxPoint();
}

function mxGraphSelectionModel(t) {
  this.graph = t, this.cells = [];
}

function mxSelectionChange(t, e, i) {
  this.selectionModel = t, this.added = null != e ? e.slice() : null, this.removed = null != i ? i.slice() : null;
}

function mxCellEditor(t) {
  this.graph = t, this.zoomHandler = mxUtils.bind(this, function () {
    this.graph.isEditing() && this.resize();
  }), this.graph.view.addListener(mxEvent.SCALE, this.zoomHandler), this.graph.view.addListener(mxEvent.SCALE_AND_TRANSLATE, this.zoomHandler), this.changeHandler = mxUtils.bind(this, function (t) {
    null != this.editingCell && null == this.graph.getView().getState(this.editingCell) && this.stopEditing(!0);
  }), this.graph.getModel().addListener(mxEvent.CHANGE, this.changeHandler);
}

function mxCellRenderer() {}

mxPrintPreview.prototype.graph = null, mxPrintPreview.prototype.pageFormat = null, mxPrintPreview.prototype.scale = null, mxPrintPreview.prototype.border = 0, mxPrintPreview.prototype.marginTop = 0, mxPrintPreview.prototype.marginBottom = 0, mxPrintPreview.prototype.x0 = 0, mxPrintPreview.prototype.y0 = 0, mxPrintPreview.prototype.autoOrigin = !0, mxPrintPreview.prototype.printOverlays = !1, mxPrintPreview.prototype.printControls = !1, mxPrintPreview.prototype.printBackgroundImage = !1, mxPrintPreview.prototype.backgroundColor = "#ffffff", mxPrintPreview.prototype.borderColor = null, mxPrintPreview.prototype.title = null, mxPrintPreview.prototype.pageSelector = null, mxPrintPreview.prototype.wnd = null, mxPrintPreview.prototype.targetWindow = null, mxPrintPreview.prototype.pageCount = 0, mxPrintPreview.prototype.clipping = !0, mxPrintPreview.prototype.getWindow = function () {
  return this.wnd;
}, mxPrintPreview.prototype.getDoctype = function () {
  var t = "";
  return 5 == document.documentMode ? t = '<meta http-equiv="X-UA-Compatible" content="IE=5">' : 8 == document.documentMode ? t = '<meta http-equiv="X-UA-Compatible" content="IE=8">' : 8 < document.documentMode && (t = '\x3c!--[if IE]><meta http-equiv="X-UA-Compatible" content="IE=edge"><![endif]--\x3e'), t;
}, mxPrintPreview.prototype.appendGraph = function (t, e, i, n, s, o) {
  this.graph = t, this.scale = null != e ? e : 1 / t.pageScale, this.x0 = i, this.y0 = n, this.open(null, null, s, o);
}, mxPrintPreview.prototype.open = function (t, e, i, n) {
  var s = this.graph.cellRenderer.initializeOverlay,
      o = null;

  try {
    this.printOverlays && (this.graph.cellRenderer.initializeOverlay = function (t, e) {
      e.init(t.view.getDrawPane());
    }), this.printControls && (this.graph.cellRenderer.initControl = function (t, e, i, n) {
      e.dialect = t.view.graph.dialect, e.init(t.view.getDrawPane());
    }), this.wnd = null != e ? e : this.wnd;
    var l = !1;
    null == this.wnd && (l = !0, this.wnd = window.open());
    var r = this.wnd.document;

    if (l) {
      var a = this.getDoctype();
      null != a && 0 < a.length && r.writeln(a), mxClient.IS_VML ? r.writeln('<html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">') : ("CSS1Compat" === document.compatMode && r.writeln("<!DOCTYPE html>"), r.writeln("<html>")), r.writeln("<head>"), this.writeHead(r, t), r.writeln("</head>"), r.writeln('<body class="mxPage">');
    }

    var h = this.graph.getGraphBounds().clone(),
        u = this.graph.getView().getScale(),
        d = u / this.scale,
        p = this.graph.getView().getTranslate();
    this.autoOrigin || (this.x0 -= p.x * this.scale, this.y0 -= p.y * this.scale, h.width += h.x, h.height += h.y, h.x = 0, this.border = h.y = 0);
    var c = this.pageFormat.width - 2 * this.border,
        m = this.pageFormat.height - 2 * this.border;
    this.pageFormat.height += this.marginTop + this.marginBottom, h.width /= d, h.height /= d;
    var g = Math.max(1, Math.ceil((h.width + this.x0) / c)),
        x = Math.max(1, Math.ceil((h.height + this.y0) / m));
    this.pageCount = g * x;
    var y = mxUtils.bind(this, function () {
      if (this.pageSelector && (1 < x || 1 < g)) {
        var t = this.createPageSelector(x, g);

        if (r.body.appendChild(t), mxClient.IS_IE && null == r.documentMode || 5 == r.documentMode || 8 == r.documentMode || 7 == r.documentMode) {
          t.style.position = "absolute";

          var e = function e() {
            t.style.top = (r.body.scrollTop || r.documentElement.scrollTop) + 10 + "px";
          };

          mxEvent.addListener(this.wnd, "scroll", function (t) {
            e();
          }), mxEvent.addListener(this.wnd, "resize", function (t) {
            e();
          });
        }
      }
    }),
        f = mxUtils.bind(this, function (t, e) {
      if (null != this.borderColor && (t.style.borderColor = this.borderColor, t.style.borderStyle = "solid", t.style.borderWidth = "1px"), t.style.background = this.backgroundColor, (i || e) && (t.style.pageBreakAfter = "always"), l && (mxClient.IS_IE || 11 <= document.documentMode || mxClient.IS_EDGE)) r.writeln(t.outerHTML), t.parentNode.removeChild(t);else if (mxClient.IS_IE || 11 <= document.documentMode || mxClient.IS_EDGE) {
        var n = r.createElement("div");
        n.innerHTML = t.outerHTML, n = n.getElementsByTagName("div")[0], r.body.appendChild(n), t.parentNode.removeChild(t);
      } else t.parentNode.removeChild(t), r.body.appendChild(t);
      (i || e) && this.addPageBreak(r);
    }),
        v = this.getCoverPages(this.pageFormat.width, this.pageFormat.height);
    if (null != v) for (var C = 0; C < v.length; C++) {
      f(v[C], !0);
    }
    var E = this.getAppendices(this.pageFormat.width, this.pageFormat.height);

    for (C = 0; C < x; C++) {
      var S = C * m / this.scale - this.y0 / this.scale + (h.y - p.y * u) / u;

      for (t = 0; t < g; t++) {
        if (null == this.wnd) return null;
        var b = t * c / this.scale - this.x0 / this.scale + (h.x - p.x * u) / u,
            w = C * g + t + 1,
            T = new mxRectangle(b, S, c, m);
        (o = this.renderPage(this.pageFormat.width, this.pageFormat.height, 0, 0, mxUtils.bind(this, function (t) {
          this.addGraphFragment(-b, -S, this.scale, w, t, T), this.printBackgroundImage && this.insertBackgroundImage(t, -b, -S);
        }), w)).setAttribute("id", "mxPage-" + w), f(o, null != E || C < x - 1 || t < g - 1);
      }
    }

    if (null != E) for (C = 0; C < E.length; C++) {
      f(E[C], C < E.length - 1);
    }
    l && !n && (this.closeDocument(), y()), this.wnd.focus();
  } catch (t) {
    null != o && null != o.parentNode && o.parentNode.removeChild(o);
  } finally {
    this.graph.cellRenderer.initializeOverlay = s;
  }

  return this.wnd;
}, mxPrintPreview.prototype.addPageBreak = function (t) {
  var e = t.createElement("hr");
  e.className = "mxPageBreak", t.body.appendChild(e);
}, mxPrintPreview.prototype.closeDocument = function () {
  try {
    if (null != this.wnd && null != this.wnd.document) {
      var t = this.wnd.document;
      this.writePostfix(t), t.writeln("</body>"), t.writeln("</html>"), t.close(), mxEvent.release(t.body);
    }
  } catch (t) {}
}, mxPrintPreview.prototype.writeHead = function (t, e) {
  null != this.title && t.writeln("<title>" + this.title + "</title>"), mxClient.IS_VML && t.writeln('<style type="text/css">v\\:*{behavior:url(#default#VML)}o\\:*{behavior:url(#default#VML)}</style>'), mxClient.link("stylesheet", mxClient.basePath + "/css/common.css", t), t.writeln('<style type="text/css">'), t.writeln("@media print {"), t.writeln("  * { -webkit-print-color-adjust: exact; }"), t.writeln("  table.mxPageSelector { display: none; }"), t.writeln("  hr.mxPageBreak { display: none; }"), t.writeln("}"), t.writeln("@media screen {"), t.writeln("  table.mxPageSelector { position: fixed; right: 10px; top: 10px;font-family: Arial; font-size:10pt; border: solid 1px darkgray;background: white; border-collapse:collapse; }"), t.writeln("  table.mxPageSelector td { border: solid 1px gray; padding:4px; }"), t.writeln("  body.mxPage { background: gray; }"), t.writeln("}"), null != e && t.writeln(e), t.writeln("</style>");
}, mxPrintPreview.prototype.writePostfix = function (t) {}, mxPrintPreview.prototype.createPageSelector = function (t, e) {
  var i = this.wnd.document,
      n = i.createElement("table");
  n.className = "mxPageSelector", n.setAttribute("border", "0");

  for (var s = i.createElement("tbody"), o = 0; o < t; o++) {
    for (var l = i.createElement("tr"), r = 0; r < e; r++) {
      var a = o * e + r + 1,
          h = i.createElement("td"),
          u = i.createElement("a");
      u.setAttribute("href", "#mxPage-" + a), !mxClient.IS_NS || mxClient.IS_SF || mxClient.IS_GC || u.setAttribute("onclick", "var page = document.getElementById('mxPage-" + a + "');page.scrollIntoView(true);event.preventDefault();"), mxUtils.write(u, a, i), h.appendChild(u), l.appendChild(h);
    }

    s.appendChild(l);
  }

  return n.appendChild(s), n;
}, mxPrintPreview.prototype.renderPage = function (t, e, i, n, s, o) {
  o = this.wnd.document;
  var l = document.createElement("div"),
      r = null;

  try {
    if (0 != i || 0 != n) {
      l.style.position = "relative", l.style.width = t + "px", l.style.height = e + "px", l.style.pageBreakInside = "avoid";
      var a = document.createElement("div");
      a.style.position = "relative", a.style.top = this.border + "px", a.style.left = this.border + "px", a.style.width = t - 2 * this.border + "px", a.style.height = e - 2 * this.border + "px", a.style.overflow = "hidden";
      var h = document.createElement("div");
      h.style.position = "relative", h.style.marginLeft = i + "px", h.style.marginTop = n + "px", 8 == o.documentMode && (a.style.position = "absolute", h.style.position = "absolute"), 10 == o.documentMode && (h.style.width = "100%", h.style.height = "100%"), a.appendChild(h), l.appendChild(a), document.body.appendChild(l), r = h;
    } else l.style.width = t + "px", l.style.height = e + "px", l.style.overflow = "hidden", l.style.pageBreakInside = "avoid", 8 == o.documentMode && (l.style.position = "relative"), (a = document.createElement("div")).style.width = t - 2 * this.border + "px", a.style.height = e - 2 * this.border + "px", a.style.overflow = "hidden", !mxClient.IS_IE || null != o.documentMode && 5 != o.documentMode && 8 != o.documentMode && 7 != o.documentMode ? (a.style.top = this.border + "px", a.style.left = this.border + "px") : (a.style.marginTop = this.border + "px", a.style.marginLeft = this.border + "px"), this.graph.dialect == mxConstants.DIALECT_VML && (a.style.position = "absolute"), l.appendChild(a), document.body.appendChild(l), r = a;
  } catch (t) {
    throw l.parentNode.removeChild(l), t;
  }

  return s(r), l;
}, mxPrintPreview.prototype.getRoot = function () {
  var t = this.graph.view.currentRoot;
  return null == t && (t = this.graph.getModel().getRoot()), t;
}, mxPrintPreview.prototype.addGraphFragment = function (t, e, i, n, s, o) {
  var l = this.graph.getView();
  n = this.graph.container, this.graph.container = s;
  var r = l.getCanvas(),
      a = l.getBackgroundPane(),
      h = l.getDrawPane(),
      u = l.getOverlayPane();

  if (this.graph.dialect == mxConstants.DIALECT_SVG) {
    if (l.createSvg(), !mxClient.NO_FO) {
      var d = l.getDrawPane().parentNode;
      d.getAttribute("transform"), d.setAttribute("transformOrigin", "0 0"), d.setAttribute("transform", "scale(" + i + "," + i + ")translate(" + t + "," + e + ")"), i = 1, e = t = 0;
    }
  } else this.graph.dialect == mxConstants.DIALECT_VML ? l.createVml() : l.createHtml();

  d = l.isEventsEnabled(), l.setEventsEnabled(!1);
  var p = this.graph.isEnabled();
  this.graph.setEnabled(!1);
  var c = l.getTranslate();
  l.translate = new mxPoint(t, e);
  var m = this.graph.cellRenderer.redraw,
      g = l.states;

  if (t = l.scale, this.clipping) {
    var x = new mxRectangle((o.x + c.x) * t, (o.y + c.y) * t, o.width * t / i, o.height * t / i);

    this.graph.cellRenderer.redraw = function (t, e, i) {
      if (null != t) {
        var n = g.get(t.cell);
        null != n && (null == (n = l.getBoundingBox(n, !1)) || mxUtils.intersects(x, n));
      }

      m.apply(this, arguments);
    };
  }

  t = null;

  try {
    var y = [this.getRoot()];
    t = new mxTemporaryCellStates(l, i, y, null, mxUtils.bind(this, function (t) {
      return this.getLinkForCellState(t);
    }));
  } finally {
    if (mxClient.IS_IE) l.overlayPane.innerHTML = "", l.canvas.style.overflow = "hidden", l.canvas.style.position = "relative", l.canvas.style.top = this.marginTop + "px", l.canvas.style.width = o.width + "px", l.canvas.style.height = o.height + "px";else for (i = s.firstChild; null != i;) {
      y = i.nextSibling, "svg" == (e = i.nodeName.toLowerCase()) ? (i.style.overflow = "hidden", i.style.position = "relative", i.style.top = this.marginTop + "px", i.setAttribute("width", o.width), i.setAttribute("height", o.height), i.style.width = "", i.style.height = "") : "default" != i.style.cursor && "div" != e && i.parentNode.removeChild(i), i = y;
    }
    this.printBackgroundImage && 0 < (s = s.getElementsByTagName("svg")).length && (s[0].style.position = "absolute"), l.overlayPane.parentNode.removeChild(l.overlayPane), this.graph.setEnabled(p), this.graph.container = n, this.graph.cellRenderer.redraw = m, l.canvas = r, l.backgroundPane = a, l.drawPane = h, l.overlayPane = u, l.translate = c, t.destroy(), l.setEventsEnabled(d);
  }
}, mxPrintPreview.prototype.getLinkForCellState = function (t) {
  return this.graph.getLinkForCell(t.cell);
}, mxPrintPreview.prototype.insertBackgroundImage = function (t, e, i) {
  var n = this.graph.backgroundImage;

  if (null != n) {
    var s = document.createElement("img");
    s.style.position = "absolute", s.style.marginLeft = Math.round(e * this.scale) + "px", s.style.marginTop = Math.round(i * this.scale) + "px", s.setAttribute("width", Math.round(this.scale * n.width)), s.setAttribute("height", Math.round(this.scale * n.height)), s.src = n.src, t.insertBefore(s, t.firstChild);
  }
}, mxPrintPreview.prototype.getCoverPages = function () {
  return null;
}, mxPrintPreview.prototype.getAppendices = function () {
  return null;
}, mxPrintPreview.prototype.print = function (t) {
  null != (t = this.open(t)) && t.print();
}, mxPrintPreview.prototype.close = function () {
  null != this.wnd && (this.wnd.close(), this.wnd = null);
}, mxStylesheet.prototype.createDefaultVertexStyle = function () {
  var t = {};
  return t[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_RECTANGLE, t[mxConstants.STYLE_PERIMETER] = mxPerimeter.RectanglePerimeter, t[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.ALIGN_MIDDLE, t[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_CENTER, t[mxConstants.STYLE_FILLCOLOR] = "#C3D9FF", t[mxConstants.STYLE_STROKECOLOR] = "#6482B9", t[mxConstants.STYLE_FONTCOLOR] = "#774400", t;
}, mxStylesheet.prototype.createDefaultEdgeStyle = function () {
  var t = {};
  return t[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_CONNECTOR, t[mxConstants.STYLE_ENDARROW] = mxConstants.ARROW_CLASSIC, t[mxConstants.STYLE_VERTICAL_ALIGN] = mxConstants.ALIGN_MIDDLE, t[mxConstants.STYLE_ALIGN] = mxConstants.ALIGN_CENTER, t[mxConstants.STYLE_STROKECOLOR] = "#6482B9", t[mxConstants.STYLE_FONTCOLOR] = "#446299", t;
}, mxStylesheet.prototype.putDefaultVertexStyle = function (t) {
  this.putCellStyle("defaultVertex", t);
}, mxStylesheet.prototype.putDefaultEdgeStyle = function (t) {
  this.putCellStyle("defaultEdge", t);
}, mxStylesheet.prototype.getDefaultVertexStyle = function () {
  return this.styles.defaultVertex;
}, mxStylesheet.prototype.getDefaultEdgeStyle = function () {
  return this.styles.defaultEdge;
}, mxStylesheet.prototype.putCellStyle = function (t, e) {
  this.styles[t] = e;
}, mxStylesheet.prototype.getCellStyle = function (t, e) {
  var i = e;
  if (null != t && 0 < t.length) for (var n = t.split(";"), s = (i = null != i && ";" != t.charAt(0) ? mxUtils.clone(i) : {}, 0); s < n.length; s++) {
    var o = (l = n[s]).indexOf("=");

    if (0 <= o) {
      var l,
          r = l.substring(0, o);
      (l = l.substring(o + 1)) == mxConstants.NONE ? delete i[r] : mxUtils.isNumeric(l) ? i[r] = parseFloat(l) : i[r] = l;
    } else if (null != (l = this.styles[l])) for (r in l) {
      i[r] = l[r];
    }
  }
  return i;
}, mxCellState.prototype = new mxRectangle(), mxCellState.prototype.constructor = mxCellState, mxCellState.prototype.view = null, mxCellState.prototype.cell = null, mxCellState.prototype.style = null, mxCellState.prototype.invalid = !0, mxCellState.prototype.origin = null, mxCellState.prototype.absolutePoints = null, mxCellState.prototype.absoluteOffset = null, mxCellState.prototype.visibleSourceState = null, mxCellState.prototype.visibleTargetState = null, mxCellState.prototype.terminalDistance = 0, mxCellState.prototype.length = 0, mxCellState.prototype.segments = null, mxCellState.prototype.shape = null, mxCellState.prototype.text = null, mxCellState.prototype.unscaledWidth = null, mxCellState.prototype.getPerimeterBounds = function (t, e) {
  if (t = t || 0, e = null != e ? e : new mxRectangle(this.x, this.y, this.width, this.height), null != this.shape && null != this.shape.stencil && "fixed" == this.shape.stencil.aspect) {
    var i = this.shape.stencil.computeAspect(this.style, e.x, e.y, e.width, e.height);
    e.x = i.x, e.y = i.y, e.width = this.shape.stencil.w0 * i.width, e.height = this.shape.stencil.h0 * i.height;
  }

  return 0 != t && e.grow(t), e;
}, mxCellState.prototype.setAbsoluteTerminalPoint = function (t, e) {
  e ? (null == this.absolutePoints && (this.absolutePoints = []), 0 == this.absolutePoints.length ? this.absolutePoints.push(t) : this.absolutePoints[0] = t) : null == this.absolutePoints ? (this.absolutePoints = [], this.absolutePoints.push(null), this.absolutePoints.push(t)) : 1 == this.absolutePoints.length ? this.absolutePoints.push(t) : this.absolutePoints[this.absolutePoints.length - 1] = t;
}, mxCellState.prototype.setCursor = function (t) {
  null != this.shape && this.shape.setCursor(t), null != this.text && this.text.setCursor(t);
}, mxCellState.prototype.getVisibleTerminal = function (t) {
  return null != (t = this.getVisibleTerminalState(t)) ? t.cell : null;
}, mxCellState.prototype.getVisibleTerminalState = function (t) {
  return t ? this.visibleSourceState : this.visibleTargetState;
}, mxCellState.prototype.setVisibleTerminalState = function (t, e) {
  e ? this.visibleSourceState = t : this.visibleTargetState = t;
}, mxCellState.prototype.getCellBounds = function () {
  return this.cellBounds;
}, mxCellState.prototype.getPaintBounds = function () {
  return this.paintBounds;
}, mxCellState.prototype.updateCachedBounds = function () {
  var t = this.view.translate,
      e = this.view.scale;
  this.cellBounds = new mxRectangle(this.x / e - t.x, this.y / e - t.y, this.width / e, this.height / e), this.paintBounds = mxRectangle.fromRectangle(this.cellBounds), null != this.shape && this.shape.isPaintBoundsInverted() && this.paintBounds.rotate90();
}, mxCellState.prototype.setState = function (t) {
  this.view = t.view, this.cell = t.cell, this.style = t.style, this.absolutePoints = t.absolutePoints, this.origin = t.origin, this.absoluteOffset = t.absoluteOffset, this.boundingBox = t.boundingBox, this.terminalDistance = t.terminalDistance, this.segments = t.segments, this.length = t.length, this.x = t.x, this.y = t.y, this.width = t.width, this.height = t.height, this.unscaledWidth = t.unscaledWidth;
}, mxCellState.prototype.clone = function () {
  var t = new mxCellState(this.view, this.cell, this.style);

  if (null != this.absolutePoints) {
    t.absolutePoints = [];

    for (var e = 0; e < this.absolutePoints.length; e++) {
      t.absolutePoints[e] = this.absolutePoints[e].clone();
    }
  }

  return null != this.origin && (t.origin = this.origin.clone()), null != this.absoluteOffset && (t.absoluteOffset = this.absoluteOffset.clone()), null != this.boundingBox && (t.boundingBox = this.boundingBox.clone()), t.terminalDistance = this.terminalDistance, t.segments = this.segments, t.length = this.length, t.x = this.x, t.y = this.y, t.width = this.width, t.height = this.height, t.unscaledWidth = this.unscaledWidth, t;
}, mxCellState.prototype.destroy = function () {
  this.view.graph.cellRenderer.destroy(this);
}, mxGraphSelectionModel.prototype = new mxEventSource(), mxGraphSelectionModel.prototype.constructor = mxGraphSelectionModel, mxGraphSelectionModel.prototype.doneResource = "none" != mxClient.language ? "done" : "", mxGraphSelectionModel.prototype.updatingSelectionResource = "none" != mxClient.language ? "updatingSelection" : "", mxGraphSelectionModel.prototype.graph = null, mxGraphSelectionModel.prototype.singleSelection = !1, mxGraphSelectionModel.prototype.isSingleSelection = function () {
  return this.singleSelection;
}, mxGraphSelectionModel.prototype.setSingleSelection = function (t) {
  this.singleSelection = t;
}, mxGraphSelectionModel.prototype.isSelected = function (t) {
  return null != t && 0 <= mxUtils.indexOf(this.cells, t);
}, mxGraphSelectionModel.prototype.isEmpty = function () {
  return 0 == this.cells.length;
}, mxGraphSelectionModel.prototype.clear = function () {
  this.changeSelection(null, this.cells);
}, mxGraphSelectionModel.prototype.setCell = function (t) {
  null != t && this.setCells([t]);
}, mxGraphSelectionModel.prototype.setCells = function (t) {
  if (null != t) {
    this.singleSelection && (t = [this.getFirstSelectableCell(t)]);

    for (var e = [], i = 0; i < t.length; i++) {
      this.graph.isCellSelectable(t[i]) && e.push(t[i]);
    }

    this.changeSelection(e, this.cells);
  }
}, mxGraphSelectionModel.prototype.getFirstSelectableCell = function (t) {
  if (null != t) for (var e = 0; e < t.length; e++) {
    if (this.graph.isCellSelectable(t[e])) return t[e];
  }
  return null;
}, mxGraphSelectionModel.prototype.addCell = function (t) {
  null != t && this.addCells([t]);
}, mxGraphSelectionModel.prototype.addCells = function (t) {
  if (null != t) {
    var e = null;
    this.singleSelection && (e = this.cells, t = [this.getFirstSelectableCell(t)]);

    for (var i = [], n = 0; n < t.length; n++) {
      !this.isSelected(t[n]) && this.graph.isCellSelectable(t[n]) && i.push(t[n]);
    }

    this.changeSelection(i, e);
  }
}, mxGraphSelectionModel.prototype.removeCell = function (t) {
  null != t && this.removeCells([t]);
}, mxGraphSelectionModel.prototype.removeCells = function (t) {
  if (null != t) {
    for (var e = [], i = 0; i < t.length; i++) {
      this.isSelected(t[i]) && e.push(t[i]);
    }

    this.changeSelection(null, e);
  }
}, mxGraphSelectionModel.prototype.changeSelection = function (t, e) {
  if (null != t && 0 < t.length && null != t[0] || null != e && 0 < e.length && null != e[0]) {
    var i = new mxSelectionChange(this, t, e);
    i.execute();
    var n = new mxUndoableEdit(this, !1);
    n.add(i), this.fireEvent(new mxEventObject(mxEvent.UNDO, "edit", n));
  }
}, mxGraphSelectionModel.prototype.cellAdded = function (t) {
  null == t || this.isSelected(t) || this.cells.push(t);
}, mxGraphSelectionModel.prototype.cellRemoved = function (t) {
  null != t && 0 <= (t = mxUtils.indexOf(this.cells, t)) && this.cells.splice(t, 1);
}, mxSelectionChange.prototype.execute = function () {
  var t = mxLog.enter("mxSelectionChange.execute");
  if (window.status = mxResources.get(this.selectionModel.updatingSelectionResource) || this.selectionModel.updatingSelectionResource, null != this.removed) for (var e = 0; e < this.removed.length; e++) {
    this.selectionModel.cellRemoved(this.removed[e]);
  }
  if (null != this.added) for (e = 0; e < this.added.length; e++) {
    this.selectionModel.cellAdded(this.added[e]);
  }
  e = this.added, this.added = this.removed, this.removed = e, window.status = mxResources.get(this.selectionModel.doneResource) || this.selectionModel.doneResource, mxLog.leave("mxSelectionChange.execute", t), this.selectionModel.fireEvent(new mxEventObject(mxEvent.CHANGE, "added", this.added, "removed", this.removed));
}, mxCellEditor.prototype.graph = null, mxCellEditor.prototype.textarea = null, mxCellEditor.prototype.editingCell = null, mxCellEditor.prototype.trigger = null, mxCellEditor.prototype.modified = !1, mxCellEditor.prototype.autoSize = !0, mxCellEditor.prototype.selectText = !0, mxCellEditor.prototype.emptyLabelText = mxClient.IS_FF ? "<br>" : "", mxCellEditor.prototype.escapeCancelsEditing = !0, mxCellEditor.prototype.textNode = "", mxCellEditor.prototype.zIndex = 5, mxCellEditor.prototype.minResize = new mxRectangle(0, 20), mxCellEditor.prototype.wordWrapPadding = mxClient.IS_QUIRKS ? 2 : mxClient.IS_IE11 ? 0 : 1, mxCellEditor.prototype.blurEnabled = !1, mxCellEditor.prototype.initialValue = null, mxCellEditor.prototype.init = function () {
  this.textarea = document.createElement("div"), this.textarea.className = "mxCellEditor mxPlainTextEditor", this.textarea.contentEditable = !0, mxClient.IS_GC && (this.textarea.style.minHeight = "1em"), this.textarea.style.position = this.isLegacyEditor() ? "absolute" : "relative", this.installListeners(this.textarea);
}, mxCellEditor.prototype.applyValue = function (t, e) {
  this.graph.labelChanged(t.cell, e, this.trigger);
}, mxCellEditor.prototype.getInitialValue = function (t, e) {
  var i = mxUtils.htmlEntities(this.graph.getEditingValue(t.cell, e), !1);
  return mxClient.IS_QUIRKS || 8 == document.documentMode || 9 == document.documentMode || 10 == document.documentMode || (i = mxUtils.replaceTrailingNewlines(i, "<div><br></div>")), i.replace(/\n/g, "<br>");
}, mxCellEditor.prototype.getCurrentValue = function (t) {
  return mxUtils.extractTextWithWhitespace(this.textarea.childNodes);
}, mxCellEditor.prototype.isCancelEditingKeyEvent = function (t) {
  return this.escapeCancelsEditing || mxEvent.isShiftDown(t) || mxEvent.isControlDown(t) || mxEvent.isMetaDown(t);
}, mxCellEditor.prototype.installListeners = function (t) {
  mxEvent.addListener(t, "blur", mxUtils.bind(this, function (t) {
    this.blurEnabled && this.focusLost(t);
  })), mxEvent.addListener(t, "keydown", mxUtils.bind(this, function (t) {
    mxEvent.isConsumed(t) || (this.isStopEditingEvent(t) ? (this.graph.stopEditing(!1), mxEvent.consume(t)) : 27 == t.keyCode && (this.graph.stopEditing(this.isCancelEditingKeyEvent(t)), mxEvent.consume(t)));
  }));
  var e = mxUtils.bind(this, function (e) {
    null != this.editingCell && this.clearOnChange && t.innerHTML == this.getEmptyLabelText() && (!mxClient.IS_FF || 8 != e.keyCode && 46 != e.keyCode) && (this.clearOnChange = !1, t.innerHTML = "");
  });
  mxEvent.addListener(t, "keypress", e), mxEvent.addListener(t, "paste", e), e = mxUtils.bind(this, function (t) {
    null != this.editingCell && (0 == this.textarea.innerHTML.length || "<br>" == this.textarea.innerHTML ? (this.textarea.innerHTML = this.getEmptyLabelText(), this.clearOnChange = 0 < this.textarea.innerHTML.length) : this.clearOnChange = !1);
  }), mxEvent.addListener(t, mxClient.IS_IE11 || mxClient.IS_IE ? "keyup" : "input", e), mxEvent.addListener(t, "cut", e), mxEvent.addListener(t, "paste", e);
  e = mxClient.IS_IE11 || mxClient.IS_IE ? "keydown" : "input";
  var i = mxUtils.bind(this, function (t) {
    null != this.editingCell && this.autoSize && !mxEvent.isConsumed(t) && (null != this.resizeThread && window.clearTimeout(this.resizeThread), this.resizeThread = window.setTimeout(mxUtils.bind(this, function () {
      this.resizeThread = null, this.resize();
    }), 0));
  });
  mxEvent.addListener(t, e, i), 9 <= document.documentMode ? (mxEvent.addListener(t, "DOMNodeRemoved", i), mxEvent.addListener(t, "DOMNodeInserted", i)) : (mxEvent.addListener(t, "cut", i), mxEvent.addListener(t, "paste", i));
}, mxCellEditor.prototype.isStopEditingEvent = function (t) {
  return 113 == t.keyCode || this.graph.isEnterStopsCellEditing() && 13 == t.keyCode && !mxEvent.isControlDown(t) && !mxEvent.isShiftDown(t);
}, mxCellEditor.prototype.isEventSource = function (t) {
  return mxEvent.getSource(t) == this.textarea;
}, mxCellEditor.prototype.resize = function () {
  var t = this.graph.getView().getState(this.editingCell);
  if (null == t) this.stopEditing(!0);else if (null != this.textarea) {
    var e = this.graph.getModel().isEdge(t.cell),
        i = this.graph.getView().scale,
        n = null;

    if (this.autoSize && "fill" != t.style[mxConstants.STYLE_OVERFLOW]) {
      var s = mxUtils.getValue(t.style, mxConstants.STYLE_LABEL_WIDTH, null);
      if (null == (n = null != t.text ? t.text.margin : null) && (n = mxUtils.getAlignmentAsPoint(mxUtils.getValue(t.style, mxConstants.STYLE_ALIGN, mxConstants.ALIGN_CENTER), mxUtils.getValue(t.style, mxConstants.STYLE_VERTICAL_ALIGN, mxConstants.ALIGN_MIDDLE))), e) this.bounds = new mxRectangle(t.absoluteOffset.x, t.absoluteOffset.y, 0, 0), null != s && (s = (parseFloat(s) + 2) * i, this.bounds.width = s, this.bounds.x += n.x * s);else {
        e = mxRectangle.fromRectangle(t);
        var o = mxUtils.getValue(t.style, mxConstants.STYLE_LABEL_POSITION, mxConstants.ALIGN_CENTER),
            l = mxUtils.getValue(t.style, mxConstants.STYLE_VERTICAL_LABEL_POSITION, mxConstants.ALIGN_MIDDLE);
        e = null != t.shape && o == mxConstants.ALIGN_CENTER && l == mxConstants.ALIGN_MIDDLE ? t.shape.getLabelBounds(e) : e;

        if (null != s && (e.width = parseFloat(s) * i), !t.view.graph.cellRenderer.legacySpacing || "width" != t.style[mxConstants.STYLE_OVERFLOW]) {
          o = parseInt(t.style[mxConstants.STYLE_SPACING] || 2) * i;
          var r = (parseInt(t.style[mxConstants.STYLE_SPACING_TOP] || 0) + mxText.prototype.baseSpacingTop) * i + o,
              a = (parseInt(t.style[mxConstants.STYLE_SPACING_RIGHT] || 0) + mxText.prototype.baseSpacingRight) * i + o,
              h = (parseInt(t.style[mxConstants.STYLE_SPACING_BOTTOM] || 0) + mxText.prototype.baseSpacingBottom) * i + o,
              u = (parseInt(t.style[mxConstants.STYLE_SPACING_LEFT] || 0) + mxText.prototype.baseSpacingLeft) * i + o;
          o = mxUtils.getValue(t.style, mxConstants.STYLE_LABEL_POSITION, mxConstants.ALIGN_CENTER), l = mxUtils.getValue(t.style, mxConstants.STYLE_VERTICAL_LABEL_POSITION, mxConstants.ALIGN_MIDDLE), e = new mxRectangle(e.x + u, e.y + r, e.width - (o == mxConstants.ALIGN_CENTER && null == s ? u + a : 0), e.height - (l == mxConstants.ALIGN_MIDDLE ? r + h : 0));
        }

        this.bounds = new mxRectangle(e.x + t.absoluteOffset.x, e.y + t.absoluteOffset.y, e.width, e.height);
      }
      this.graph.isWrapping(t.cell) && (2 <= this.bounds.width || 2 <= this.bounds.height) && this.textarea.innerHTML != this.getEmptyLabelText() ? (this.textarea.style.wordWrap = mxConstants.WORD_WRAP, this.textarea.style.whiteSpace = "normal", s = Math.round(this.bounds.width / i) + this.wordWrapPadding, "relative" != this.textarea.style.position ? (this.textarea.style.width = s + "px", this.textarea.scrollWidth > s && (this.textarea.style.width = this.textarea.scrollWidth + "px")) : this.textarea.style.maxWidth = s + "px") : (this.textarea.style.whiteSpace = "nowrap", this.textarea.style.width = ""), 8 == document.documentMode && (this.textarea.style.zoom = "1", this.textarea.style.height = "auto"), t = this.textarea.scrollWidth, s = this.textarea.scrollHeight, 8 == document.documentMode ? (this.textarea.style.left = Math.max(0, Math.ceil((this.bounds.x - n.x * (this.bounds.width - (t + 1) * i) + t * (i - 1) * 0 + 2 * (n.x + .5)) / i)) + "px", this.textarea.style.top = Math.max(0, Math.ceil((this.bounds.y - n.y * (this.bounds.height - (s + .5) * i) + s * (i - 1) * 0 + 1 * Math.abs(n.y + .5)) / i)) + "px", this.textarea.style.width = Math.round(t * i) + "px", this.textarea.style.height = Math.round(s * i) + "px") : mxClient.IS_QUIRKS ? (this.textarea.style.left = Math.max(0, Math.ceil(this.bounds.x - n.x * (this.bounds.width - (t + 1) * i) + t * (i - 1) * 0 + 2 * (n.x + .5))) + "px", this.textarea.style.top = Math.max(0, Math.ceil(this.bounds.y - n.y * (this.bounds.height - (s + .5) * i) + s * (i - 1) * 0 + 1 * Math.abs(n.y + .5))) + "px") : (this.textarea.style.left = Math.max(0, Math.round(this.bounds.x - n.x * (this.bounds.width - 2)) + 1) + "px", this.textarea.style.top = Math.max(0, Math.round(this.bounds.y - n.y * (this.bounds.height - 4) + (-1 == n.y ? 3 : 0)) + 1) + "px");
    } else this.bounds = this.getEditorBounds(t), this.textarea.style.width = Math.round(this.bounds.width / i) + "px", this.textarea.style.height = Math.round(this.bounds.height / i) + "px", 8 == document.documentMode || mxClient.IS_QUIRKS ? (this.textarea.style.left = Math.round(this.bounds.x) + "px", this.textarea.style.top = Math.round(this.bounds.y) + "px") : (this.textarea.style.left = Math.max(0, Math.round(this.bounds.x + 1)) + "px", this.textarea.style.top = Math.max(0, Math.round(this.bounds.y + 1)) + "px"), this.graph.isWrapping(t.cell) && (2 <= this.bounds.width || 2 <= this.bounds.height) && this.textarea.innerHTML != this.getEmptyLabelText() ? (this.textarea.style.wordWrap = mxConstants.WORD_WRAP, this.textarea.style.whiteSpace = "normal", "fill" != t.style[mxConstants.STYLE_OVERFLOW] && (this.textarea.style.width = Math.round(this.bounds.width / i) + this.wordWrapPadding + "px")) : (this.textarea.style.whiteSpace = "nowrap", "fill" != t.style[mxConstants.STYLE_OVERFLOW] && (this.textarea.style.width = ""));

    mxClient.IS_VML ? this.textarea.style.zoom = i : (mxUtils.setPrefixedStyle(this.textarea.style, "transformOrigin", "0px 0px"), mxUtils.setPrefixedStyle(this.textarea.style, "transform", "scale(" + i + "," + i + ")" + (null == n ? "" : " translate(" + 100 * n.x + "%," + 100 * n.y + "%)")));
  }
}, mxCellEditor.prototype.focusLost = function () {
  this.stopEditing(!this.graph.isInvokesStopCellEditing());
}, mxCellEditor.prototype.getBackgroundColor = function (t) {
  return null;
}, mxCellEditor.prototype.isLegacyEditor = function () {
  if (mxClient.IS_VML) return !0;
  var t = !1;

  if (mxClient.IS_SVG) {
    var e = this.graph.view.getDrawPane().ownerSVGElement;
    null != e && (t = "absolute" == mxUtils.getCurrentStyle(e).position);
  }

  return !t;
}, mxCellEditor.prototype.startEditing = function (t, e) {
  this.stopEditing(!0), null == this.textarea && this.init(), null != this.graph.tooltipHandler && this.graph.tooltipHandler.hideTooltip();
  var i = this.graph.getView().getState(t);

  if (null != i) {
    this.graph.getView();
    var n = mxUtils.getValue(i.style, mxConstants.STYLE_FONTSIZE, mxConstants.DEFAULT_FONTSIZE),
        s = mxUtils.getValue(i.style, mxConstants.STYLE_FONTFAMILY, mxConstants.DEFAULT_FONTFAMILY),
        o = mxUtils.getValue(i.style, mxConstants.STYLE_FONTCOLOR, "black"),
        l = mxUtils.getValue(i.style, mxConstants.STYLE_ALIGN, mxConstants.ALIGN_LEFT),
        r = (mxUtils.getValue(i.style, mxConstants.STYLE_FONTSTYLE, 0) & mxConstants.FONT_BOLD) == mxConstants.FONT_BOLD,
        a = (mxUtils.getValue(i.style, mxConstants.STYLE_FONTSTYLE, 0) & mxConstants.FONT_ITALIC) == mxConstants.FONT_ITALIC,
        h = (mxUtils.getValue(i.style, mxConstants.STYLE_FONTSTYLE, 0) & mxConstants.FONT_UNDERLINE) == mxConstants.FONT_UNDERLINE;
    this.textarea.style.lineHeight = mxConstants.ABSOLUTE_LINE_HEIGHT ? Math.round(n * mxConstants.LINE_HEIGHT) + "px" : mxConstants.LINE_HEIGHT, this.textarea.style.backgroundColor = this.getBackgroundColor(i), this.textarea.style.textDecoration = h ? "underline" : "", this.textarea.style.fontWeight = r ? "bold" : "normal", this.textarea.style.fontStyle = a ? "italic" : "", this.textarea.style.fontSize = Math.round(n) + "px", this.textarea.style.zIndex = this.zIndex, this.textarea.style.fontFamily = s, this.textarea.style.textAlign = l, this.textarea.style.outline = "none", this.textarea.style.color = o, (n = this.textDirection = mxUtils.getValue(i.style, mxConstants.STYLE_TEXT_DIRECTION, mxConstants.DEFAULT_TEXT_DIRECTION)) == mxConstants.TEXT_DIRECTION_AUTO && (null == i || null == i.text || i.text.dialect == mxConstants.DIALECT_STRICTHTML || mxUtils.isNode(i.text.value) || (n = i.text.getAutoDirection())), n == mxConstants.TEXT_DIRECTION_LTR || n == mxConstants.TEXT_DIRECTION_RTL ? this.textarea.setAttribute("dir", n) : this.textarea.removeAttribute("dir"), this.textarea.innerHTML = this.getInitialValue(i, e) || "", this.initialValue = this.textarea.innerHTML, 0 == this.textarea.innerHTML.length || "<br>" == this.textarea.innerHTML ? (this.textarea.innerHTML = this.getEmptyLabelText(), this.clearOnChange = !0) : this.clearOnChange = this.textarea.innerHTML == this.getEmptyLabelText(), this.graph.container.appendChild(this.textarea), this.editingCell = t, this.trigger = e, this.textNode = null, null != i.text && this.isHideLabel(i) && (this.textNode = i.text.node, this.textNode.style.visibility = "hidden"), this.autoSize && (this.graph.model.isEdge(i.cell) || "fill" != i.style[mxConstants.STYLE_OVERFLOW]) && window.setTimeout(mxUtils.bind(this, function () {
      this.resize();
    }), 0), this.resize();

    try {
      this.textarea.focus(), this.isSelectText() && 0 < this.textarea.innerHTML.length && (this.textarea.innerHTML != this.getEmptyLabelText() || !this.clearOnChange) && document.execCommand("selectAll", !1, null);
    } catch (t) {}
  }
}, mxCellEditor.prototype.isSelectText = function () {
  return this.selectText;
}, mxCellEditor.prototype.clearSelection = function () {
  var t = null;
  window.getSelection ? t = window.getSelection() : document.selection && (t = document.selection), null != t && (t.empty ? t.empty() : t.removeAllRanges && t.removeAllRanges());
}, mxCellEditor.prototype.stopEditing = function (t) {
  if (null != this.editingCell) {
    null != this.textNode && (this.textNode.style.visibility = "visible", this.textNode = null), t = t ? null : this.graph.view.getState(this.editingCell);
    var e = this.initialValue;
    this.bounds = this.trigger = this.editingCell = this.initialValue = null, this.textarea.blur(), this.clearSelection(), null != this.textarea.parentNode && this.textarea.parentNode.removeChild(this.textarea), this.clearOnChange && this.textarea.innerHTML == this.getEmptyLabelText() && (this.textarea.innerHTML = "", this.clearOnChange = !1), null != t && this.textarea.innerHTML != e && (this.prepareTextarea(), null != (e = this.getCurrentValue(t)) && this.applyValue(t, e)), mxEvent.release(this.textarea), this.textarea = null;
  }
}, mxCellEditor.prototype.prepareTextarea = function () {
  mxClient.IS_FF && null != this.textarea.lastChild && "BR" == this.textarea.lastChild.nodeName && this.textarea.removeChild(this.textarea.lastChild);
}, mxCellEditor.prototype.isHideLabel = function (t) {
  return !0;
}, mxCellEditor.prototype.getMinimumSize = function (t) {
  var e = this.graph.getView().scale;
  return new mxRectangle(0, 0, null == t.text ? 30 : t.text.size * e + 20, "left" == this.textarea.style.textAlign ? 120 : 40);
}, mxCellEditor.prototype.getEditorBounds = function (t) {
  var e = this.graph.getModel().isEdge(t.cell),
      i = this.graph.getView().scale,
      n = (s = this.getMinimumSize(t)).width,
      s = s.height;
  if (!e && t.view.graph.cellRenderer.legacySpacing && "fill" == t.style[mxConstants.STYLE_OVERFLOW]) i = t.shape.getLabelBounds(mxRectangle.fromRectangle(t));else {
    var o = parseInt(t.style[mxConstants.STYLE_SPACING] || 0) * i,
        l = (parseInt(t.style[mxConstants.STYLE_SPACING_TOP] || 0) + mxText.prototype.baseSpacingTop) * i + o,
        r = (parseInt(t.style[mxConstants.STYLE_SPACING_RIGHT] || 0) + mxText.prototype.baseSpacingRight) * i + o,
        a = (parseInt(t.style[mxConstants.STYLE_SPACING_BOTTOM] || 0) + mxText.prototype.baseSpacingBottom) * i + o;
    o = (parseInt(t.style[mxConstants.STYLE_SPACING_LEFT] || 0) + mxText.prototype.baseSpacingLeft) * i + o, i = new mxRectangle(t.x, t.y, Math.max(n, t.width - o - r), Math.max(s, t.height - l - a)), r = mxUtils.getValue(t.style, mxConstants.STYLE_LABEL_POSITION, mxConstants.ALIGN_CENTER), a = mxUtils.getValue(t.style, mxConstants.STYLE_VERTICAL_LABEL_POSITION, mxConstants.ALIGN_MIDDLE), i = null != t.shape && r == mxConstants.ALIGN_CENTER && a == mxConstants.ALIGN_MIDDLE ? t.shape.getLabelBounds(i) : i;
    e ? (i.x = t.absoluteOffset.x, i.y = t.absoluteOffset.y, null != t.text && null != t.text.boundingBox && (0 < t.text.boundingBox.x && (i.x = t.text.boundingBox.x), 0 < t.text.boundingBox.y && (i.y = t.text.boundingBox.y))) : null != t.text && null != t.text.boundingBox && (i.x = Math.min(i.x, t.text.boundingBox.x), i.y = Math.min(i.y, t.text.boundingBox.y)), i.x += o, i.y += l, null != t.text && null != t.text.boundingBox && (e ? (i.width = Math.max(n, t.text.boundingBox.width), i.height = Math.max(s, t.text.boundingBox.height)) : (i.width = Math.max(i.width, t.text.boundingBox.width), i.height = Math.max(i.height, t.text.boundingBox.height))), this.graph.getModel().isVertex(t.cell) && ((e = mxUtils.getValue(t.style, mxConstants.STYLE_LABEL_POSITION, mxConstants.ALIGN_CENTER)) == mxConstants.ALIGN_LEFT ? i.x -= t.width : e == mxConstants.ALIGN_RIGHT && (i.x += t.width), (e = mxUtils.getValue(t.style, mxConstants.STYLE_VERTICAL_LABEL_POSITION, mxConstants.ALIGN_MIDDLE)) == mxConstants.ALIGN_TOP ? i.y -= t.height : e == mxConstants.ALIGN_BOTTOM && (i.y += t.height));
  }
  return new mxRectangle(Math.round(i.x), Math.round(i.y), Math.round(i.width), Math.round(i.height));
}, mxCellEditor.prototype.getEmptyLabelText = function (t) {
  return this.emptyLabelText;
}, mxCellEditor.prototype.getEditingCell = function () {
  return this.editingCell;
}, mxCellEditor.prototype.destroy = function () {
  null != this.textarea && (mxEvent.release(this.textarea), null != this.textarea.parentNode && this.textarea.parentNode.removeChild(this.textarea), this.textarea = null), null != this.changeHandler && (this.graph.getModel().removeListener(this.changeHandler), this.changeHandler = null), this.zoomHandler && (this.graph.view.removeListener(this.zoomHandler), this.zoomHandler = null);
}, mxCellRenderer.defaultShapes = {}, mxCellRenderer.prototype.defaultEdgeShape = mxConnector, mxCellRenderer.prototype.defaultVertexShape = mxRectangleShape, mxCellRenderer.prototype.defaultTextShape = mxText, mxCellRenderer.prototype.legacyControlPosition = !0, mxCellRenderer.prototype.legacySpacing = !0, mxCellRenderer.prototype.antiAlias = !0, mxCellRenderer.prototype.minSvgStrokeWidth = 1, mxCellRenderer.prototype.forceControlClickHandler = !1, mxCellRenderer.registerShape = function (t, e) {
  mxCellRenderer.defaultShapes[t] = e;
}, mxCellRenderer.registerShape(mxConstants.SHAPE_RECTANGLE, mxRectangleShape), mxCellRenderer.registerShape(mxConstants.SHAPE_ELLIPSE, mxEllipse), mxCellRenderer.registerShape(mxConstants.SHAPE_RHOMBUS, mxRhombus), mxCellRenderer.registerShape(mxConstants.SHAPE_CYLINDER, mxCylinder), mxCellRenderer.registerShape(mxConstants.SHAPE_CONNECTOR, mxConnector), mxCellRenderer.registerShape(mxConstants.SHAPE_ACTOR, mxActor), mxCellRenderer.registerShape(mxConstants.SHAPE_TRIANGLE, mxTriangle), mxCellRenderer.registerShape(mxConstants.SHAPE_HEXAGON, mxHexagon), mxCellRenderer.registerShape(mxConstants.SHAPE_CLOUD, mxCloud), mxCellRenderer.registerShape(mxConstants.SHAPE_LINE, mxLine), mxCellRenderer.registerShape(mxConstants.SHAPE_ARROW, mxArrow), mxCellRenderer.registerShape(mxConstants.SHAPE_ARROW_CONNECTOR, mxArrowConnector), mxCellRenderer.registerShape(mxConstants.SHAPE_DOUBLE_ELLIPSE, mxDoubleEllipse), mxCellRenderer.registerShape(mxConstants.SHAPE_SWIMLANE, mxSwimlane), mxCellRenderer.registerShape(mxConstants.SHAPE_IMAGE, mxImageShape), mxCellRenderer.registerShape(mxConstants.SHAPE_LABEL, mxLabel), mxCellRenderer.prototype.initializeShape = function (t) {
  t.shape.dialect = t.view.graph.dialect, this.configureShape(t), t.shape.init(t.view.getDrawPane());
}, mxCellRenderer.prototype.createShape = function (t) {
  var e = null;
  return null != t.style && (e = null != (e = mxStencilRegistry.getStencil(t.style[mxConstants.STYLE_SHAPE])) ? new mxShape(e) : new (this.getShapeConstructor(t))()), e;
}, mxCellRenderer.prototype.createIndicatorShape = function (t) {
  t.shape.indicatorShape = this.getShape(t.view.graph.getIndicatorShape(t));
}, mxCellRenderer.prototype.getShape = function (t) {
  return null != t ? mxCellRenderer.defaultShapes[t] : null;
}, mxCellRenderer.prototype.getShapeConstructor = function (t) {
  var e = this.getShape(t.style[mxConstants.STYLE_SHAPE]);
  return null == e && (e = t.view.graph.getModel().isEdge(t.cell) ? this.defaultEdgeShape : this.defaultVertexShape), e;
}, mxCellRenderer.prototype.configureShape = function (t) {
  t.shape.apply(t), t.shape.image = t.view.graph.getImage(t), t.shape.indicatorColor = t.view.graph.getIndicatorColor(t), t.shape.indicatorStrokeColor = t.style[mxConstants.STYLE_INDICATOR_STROKECOLOR], t.shape.indicatorGradientColor = t.view.graph.getIndicatorGradientColor(t), t.shape.indicatorDirection = t.style[mxConstants.STYLE_INDICATOR_DIRECTION], t.shape.indicatorImage = t.view.graph.getIndicatorImage(t), this.postConfigureShape(t);
}, mxCellRenderer.prototype.postConfigureShape = function (t) {
  null != t.shape && (this.resolveColor(t, "indicatorColor", mxConstants.STYLE_FILLCOLOR), this.resolveColor(t, "indicatorGradientColor", mxConstants.STYLE_GRADIENTCOLOR), this.resolveColor(t, "fill", mxConstants.STYLE_FILLCOLOR), this.resolveColor(t, "stroke", mxConstants.STYLE_STROKECOLOR), this.resolveColor(t, "gradient", mxConstants.STYLE_GRADIENTCOLOR));
}, mxCellRenderer.prototype.checkPlaceholderStyles = function (t) {
  if (null != t.style) for (var e = ["inherit", "swimlane", "indicated"], i = [mxConstants.STYLE_FILLCOLOR, mxConstants.STYLE_STROKECOLOR, mxConstants.STYLE_GRADIENTCOLOR], n = 0; n < i.length; n++) {
    if (0 <= mxUtils.indexOf(e, t.style[i[n]])) return !0;
  }
  return !1;
}, mxCellRenderer.prototype.resolveColor = function (t, e, i) {
  var n = t.shape[e],
      s = t.view.graph,
      o = null;
  "inherit" == n ? o = s.model.getParent(t.cell) : "swimlane" == n ? (t.shape[e] = i == mxConstants.STYLE_STROKECOLOR ? "#000000" : "#ffffff", o = null != s.model.getTerminal(t.cell, !1) ? s.model.getTerminal(t.cell, !1) : t.cell, o = s.getSwimlane(o), i = s.swimlaneIndicatorColorAttribute) : "indicated" == n && (t.shape[e] = t.shape.indicatorColor), null != o && (n = s.getView().getState(o), t.shape[e] = null, null != n && (t.shape[e] = null != n.shape && "indicatorColor" != e ? n.shape[e] : n.style[i]));
}, mxCellRenderer.prototype.getLabelValue = function (t) {
  return t.view.graph.getLabel(t.cell);
}, mxCellRenderer.prototype.createLabel = function (t, e) {
  var i = t.view.graph;

  if (i.getModel().isEdge(t.cell), 0 < t.style[mxConstants.STYLE_FONTSIZE] || null == t.style[mxConstants.STYLE_FONTSIZE]) {
    var n = i.isHtmlLabel(t.cell) || null != e && mxUtils.isNode(e);
    t.text = new this.defaultTextShape(e, new mxRectangle(), t.style[mxConstants.STYLE_ALIGN] || mxConstants.ALIGN_CENTER, i.getVerticalAlign(t), t.style[mxConstants.STYLE_FONTCOLOR], t.style[mxConstants.STYLE_FONTFAMILY], t.style[mxConstants.STYLE_FONTSIZE], t.style[mxConstants.STYLE_FONTSTYLE], t.style[mxConstants.STYLE_SPACING], t.style[mxConstants.STYLE_SPACING_TOP], t.style[mxConstants.STYLE_SPACING_RIGHT], t.style[mxConstants.STYLE_SPACING_BOTTOM], t.style[mxConstants.STYLE_SPACING_LEFT], t.style[mxConstants.STYLE_HORIZONTAL], t.style[mxConstants.STYLE_LABEL_BACKGROUNDCOLOR], t.style[mxConstants.STYLE_LABEL_BORDERCOLOR], i.isWrapping(t.cell) && i.isHtmlLabel(t.cell), i.isLabelClipped(t.cell), t.style[mxConstants.STYLE_OVERFLOW], t.style[mxConstants.STYLE_LABEL_PADDING], mxUtils.getValue(t.style, mxConstants.STYLE_TEXT_DIRECTION, mxConstants.DEFAULT_TEXT_DIRECTION)), t.text.opacity = mxUtils.getValue(t.style, mxConstants.STYLE_TEXT_OPACITY, 100), t.text.dialect = n ? mxConstants.DIALECT_STRICTHTML : t.view.graph.dialect, t.text.style = t.style, t.text.state = t, this.initializeLabel(t, t.text);

    var s = !1,
        o = function o(e) {
      var n = t;
      return (mxClient.IS_TOUCH || s) && (n = mxEvent.getClientX(e), e = mxEvent.getClientY(e), e = mxUtils.convertPoint(i.container, n, e), n = i.view.getState(i.getCellAt(e.x, e.y))), n;
    };

    mxEvent.addGestureListeners(t.text.node, mxUtils.bind(this, function (e) {
      this.isLabelEvent(t, e) && (i.fireMouseEvent(mxEvent.MOUSE_DOWN, new mxMouseEvent(e, t)), s = i.dialect != mxConstants.DIALECT_SVG && "IMG" == mxEvent.getSource(e).nodeName);
    }), mxUtils.bind(this, function (e) {
      this.isLabelEvent(t, e) && i.fireMouseEvent(mxEvent.MOUSE_MOVE, new mxMouseEvent(e, o(e)));
    }), mxUtils.bind(this, function (e) {
      this.isLabelEvent(t, e) && (i.fireMouseEvent(mxEvent.MOUSE_UP, new mxMouseEvent(e, o(e))), s = !1);
    })), i.nativeDblClickEnabled && mxEvent.addListener(t.text.node, "dblclick", mxUtils.bind(this, function (e) {
      this.isLabelEvent(t, e) && (i.dblClick(e, t.cell), mxEvent.consume(e));
    }));
  }
}, mxCellRenderer.prototype.initializeLabel = function (t, e) {
  mxClient.IS_SVG && mxClient.NO_FO && e.dialect != mxConstants.DIALECT_SVG ? e.init(t.view.graph.container) : e.init(t.view.getDrawPane());
}, mxCellRenderer.prototype.createCellOverlays = function (t) {
  var e = t.view.graph.getCellOverlays(t.cell),
      i = null;

  if (null != e) {
    i = new mxDictionary();

    for (var n = 0; n < e.length; n++) {
      var s = null != t.overlays ? t.overlays.remove(e[n]) : null;
      null == s && ((s = new mxImageShape(new mxRectangle(), e[n].image.src)).dialect = t.view.graph.dialect, s.preserveImageAspect = !1, s.overlay = e[n], this.initializeOverlay(t, s), this.installCellOverlayListeners(t, e[n], s), null != e[n].cursor && (s.node.style.cursor = e[n].cursor)), i.put(e[n], s);
    }
  }

  null != t.overlays && t.overlays.visit(function (t, e) {
    e.destroy();
  }), t.overlays = i;
}, mxCellRenderer.prototype.initializeOverlay = function (t, e) {
  e.init(t.view.getOverlayPane());
}, mxCellRenderer.prototype.installCellOverlayListeners = function (t, e, i) {
  var n = t.view.graph;
  mxEvent.addListener(i.node, "click", function (i) {
    n.isEditing() && n.stopEditing(!n.isInvokesStopCellEditing()), e.fireEvent(new mxEventObject(mxEvent.CLICK, "event", i, "cell", t.cell));
  }), mxEvent.addGestureListeners(i.node, function (t) {
    mxEvent.consume(t);
  }, function (e) {
    n.fireMouseEvent(mxEvent.MOUSE_MOVE, new mxMouseEvent(e, t));
  }), mxClient.IS_TOUCH && mxEvent.addListener(i.node, "touchend", function (i) {
    e.fireEvent(new mxEventObject(mxEvent.CLICK, "event", i, "cell", t.cell));
  });
}, mxCellRenderer.prototype.createControl = function (t) {
  var e = t.view.graph,
      i = e.getFoldingImage(t);

  if (e.foldingEnabled && null != i) {
    if (null == t.control) {
      var n = new mxRectangle(0, 0, i.width, i.height);
      t.control = new mxImageShape(n, i.src), t.control.preserveImageAspect = !1, t.control.dialect = e.dialect, this.initControl(t, t.control, !0, this.createControlClickHandler(t));
    }
  } else null != t.control && (t.control.destroy(), t.control = null);
}, mxCellRenderer.prototype.createControlClickHandler = function (t) {
  var e = t.view.graph;
  return mxUtils.bind(this, function (i) {
    if (this.forceControlClickHandler || e.isEnabled()) {
      var n = !e.isCellCollapsed(t.cell);
      e.foldCells(n, !1, [t.cell], null, i), mxEvent.consume(i);
    }
  });
}, mxCellRenderer.prototype.initControl = function (t, e, i, n) {
  var s = t.view.graph;

  if (s.isHtmlLabel(t.cell) && mxClient.NO_FO && s.dialect == mxConstants.DIALECT_SVG ? (e.dialect = mxConstants.DIALECT_PREFERHTML, e.init(s.container), e.node.style.zIndex = 1) : e.init(t.view.getOverlayPane()), e = e.innerNode || e.node, null == n || mxClient.IS_IOS || (s.isEnabled() && (e.style.cursor = "pointer"), mxEvent.addListener(e, "click", n)), i) {
    var o = null;
    mxEvent.addGestureListeners(e, function (e) {
      o = new mxPoint(mxEvent.getClientX(e), mxEvent.getClientY(e)), s.fireMouseEvent(mxEvent.MOUSE_DOWN, new mxMouseEvent(e, t)), mxEvent.consume(e);
    }, function (e) {
      s.fireMouseEvent(mxEvent.MOUSE_MOVE, new mxMouseEvent(e, t));
    }, function (e) {
      s.fireMouseEvent(mxEvent.MOUSE_UP, new mxMouseEvent(e, t)), mxEvent.consume(e);
    }), null != n && mxClient.IS_IOS && e.addEventListener("touchend", function (t) {
      if (null != o) {
        var e = s.tolerance;
        Math.abs(o.x - mxEvent.getClientX(t)) < e && Math.abs(o.y - mxEvent.getClientY(t)) < e && (n.call(n, t), mxEvent.consume(t));
      }
    }, !0);
  }

  return e;
}, mxCellRenderer.prototype.isShapeEvent = function (t, e) {
  return !0;
}, mxCellRenderer.prototype.isLabelEvent = function (t, e) {
  return !0;
}, mxCellRenderer.prototype.installListeners = function (t) {
  var e = t.view.graph,
      i = function i(_i) {
    var n = t;
    return (e.dialect != mxConstants.DIALECT_SVG && "IMG" == mxEvent.getSource(_i).nodeName || mxClient.IS_TOUCH) && (n = mxEvent.getClientX(_i), _i = mxEvent.getClientY(_i), _i = mxUtils.convertPoint(e.container, n, _i), n = e.view.getState(e.getCellAt(_i.x, _i.y))), n;
  };

  mxEvent.addGestureListeners(t.shape.node, mxUtils.bind(this, function (i) {
    this.isShapeEvent(t, i) && e.fireMouseEvent(mxEvent.MOUSE_DOWN, new mxMouseEvent(i, t));
  }), mxUtils.bind(this, function (n) {
    this.isShapeEvent(t, n) && e.fireMouseEvent(mxEvent.MOUSE_MOVE, new mxMouseEvent(n, i(n)));
  }), mxUtils.bind(this, function (n) {
    this.isShapeEvent(t, n) && e.fireMouseEvent(mxEvent.MOUSE_UP, new mxMouseEvent(n, i(n)));
  })), e.nativeDblClickEnabled && mxEvent.addListener(t.shape.node, "dblclick", mxUtils.bind(this, function (i) {
    this.isShapeEvent(t, i) && (e.dblClick(i, t.cell), mxEvent.consume(i));
  }));
}, mxCellRenderer.prototype.redrawLabel = function (t, e) {
  var i = t.view.graph,
      n = this.getLabelValue(t),
      s = i.isWrapping(t.cell),
      o = i.isLabelClipped(t.cell),
      l = t.view.graph.isHtmlLabel(t.cell) || null != n && mxUtils.isNode(n) ? mxConstants.DIALECT_STRICTHTML : t.view.graph.dialect,
      r = t.style[mxConstants.STYLE_OVERFLOW] || "visible";

  if (null == t.text || t.text.wrap == s && t.text.clipped == o && t.text.overflow == r && t.text.dialect == l || (t.text.destroy(), t.text = null), null == t.text && null != n && (mxUtils.isNode(n) || 0 < n.length) ? this.createLabel(t, n) : null == t.text || null != n && 0 != n.length || (t.text.destroy(), t.text = null), null != t.text) {
    e && (null != t.text.lastValue && this.isTextShapeInvalid(t, t.text) && (t.text.lastValue = null), t.text.resetStyles(), t.text.apply(t), t.text.valign = i.getVerticalAlign(t));
    i = this.getLabelBounds(t);
    var a = this.getTextScale(t);
    !e && t.text.value == n && t.text.isWrapping == s && t.text.overflow == r && t.text.isClipping == o && t.text.scale == a && t.text.dialect == l && t.text.bounds.equals(i) || (0 != t.text.bounds.width && null != t.unscaledWidth && 0 != Math.round(t.text.bounds.width / t.text.scale * a - i.width) && (t.unscaledWidth = null), t.text.dialect = l, t.text.value = n, t.text.bounds = i, t.text.scale = a, t.text.wrap = s, t.text.clipped = o, t.text.overflow = r, n = t.text.node.style.visibility, this.redrawLabelShape(t.text), t.text.node.style.visibility = n);
  }
}, mxCellRenderer.prototype.isTextShapeInvalid = function (t, e) {
  function i(i, n, s) {
    return "spacingTop" == n || "spacingRight" == n || "spacingBottom" == n || "spacingLeft" == n ? parseFloat(e[i]) - parseFloat(e.spacing) != (t.style[n] || s) : e[i] != (t.style[n] || s);
  }

  return i("fontStyle", mxConstants.STYLE_FONTSTYLE, mxConstants.DEFAULT_FONTSTYLE) || i("family", mxConstants.STYLE_FONTFAMILY, mxConstants.DEFAULT_FONTFAMILY) || i("size", mxConstants.STYLE_FONTSIZE, mxConstants.DEFAULT_FONTSIZE) || i("color", mxConstants.STYLE_FONTCOLOR, "black") || i("align", mxConstants.STYLE_ALIGN, "") || i("valign", mxConstants.STYLE_VERTICAL_ALIGN, "") || i("spacing", mxConstants.STYLE_SPACING, 2) || i("spacingTop", mxConstants.STYLE_SPACING_TOP, 0) || i("spacingRight", mxConstants.STYLE_SPACING_RIGHT, 0) || i("spacingBottom", mxConstants.STYLE_SPACING_BOTTOM, 0) || i("spacingLeft", mxConstants.STYLE_SPACING_LEFT, 0) || i("horizontal", mxConstants.STYLE_HORIZONTAL, !0) || i("background", mxConstants.STYLE_LABEL_BACKGROUNDCOLOR) || i("border", mxConstants.STYLE_LABEL_BORDERCOLOR) || i("opacity", mxConstants.STYLE_TEXT_OPACITY, 100) || i("textDirection", mxConstants.STYLE_TEXT_DIRECTION, mxConstants.DEFAULT_TEXT_DIRECTION);
}, mxCellRenderer.prototype.redrawLabelShape = function (t) {
  t.redraw();
}, mxCellRenderer.prototype.getTextScale = function (t) {
  return t.view.scale;
}, mxCellRenderer.prototype.getLabelBounds = function (t) {
  var e = t.view.graph,
      i = t.view.scale,
      n = e.getModel().isEdge(t.cell),
      s = new mxRectangle(t.absoluteOffset.x, t.absoluteOffset.y);

  if (n) {
    var o = t.text.getSpacing();
    s.x += o.x * i, s.y += o.y * i, null != (e = e.getCellGeometry(t.cell)) && (s.width = Math.max(0, e.width * i), s.height = Math.max(0, e.height * i));
  } else t.text.isPaintBoundsInverted() && (e = s.x, s.x = s.y, s.y = e), s.x += t.x, s.y += t.y, s.width = Math.max(1, t.width), s.height = Math.max(1, t.height), (e = mxUtils.getValue(t.style, mxConstants.STYLE_STROKECOLOR, mxConstants.NONE)) != mxConstants.NONE && "" != e && (o = parseFloat(mxUtils.getValue(t.style, mxConstants.STYLE_STROKEWIDTH, 1)) * i, e = 1 + Math.floor((o - 1) / 2), o = Math.floor(o + 1), s.x += e, s.y += e, s.width -= o, s.height -= o);

  return t.text.isPaintBoundsInverted() && (e = (t.width - t.height) / 2, s.x += e, s.y -= e, e = s.width, s.width = s.height, s.height = e), null != t.shape && (e = mxUtils.getValue(t.style, mxConstants.STYLE_LABEL_POSITION, mxConstants.ALIGN_CENTER), o = mxUtils.getValue(t.style, mxConstants.STYLE_VERTICAL_LABEL_POSITION, mxConstants.ALIGN_MIDDLE), e == mxConstants.ALIGN_CENTER && o == mxConstants.ALIGN_MIDDLE && (s = t.shape.getLabelBounds(s))), null != (e = mxUtils.getValue(t.style, mxConstants.STYLE_LABEL_WIDTH, null)) && (s.width = parseFloat(e) * i), n || this.rotateLabelBounds(t, s), s;
}, mxCellRenderer.prototype.rotateLabelBounds = function (t, e) {
  if (e.y -= t.text.margin.y * e.height, e.x -= t.text.margin.x * e.width, !this.legacySpacing || "fill" != t.style[mxConstants.STYLE_OVERFLOW] && "width" != t.style[mxConstants.STYLE_OVERFLOW]) {
    var i = t.view.scale,
        n = t.text.getSpacing();
    e.x += n.x * i, e.y += n.y * i;
    n = mxUtils.getValue(t.style, mxConstants.STYLE_LABEL_POSITION, mxConstants.ALIGN_CENTER);
    var s = mxUtils.getValue(t.style, mxConstants.STYLE_VERTICAL_LABEL_POSITION, mxConstants.ALIGN_MIDDLE),
        o = mxUtils.getValue(t.style, mxConstants.STYLE_LABEL_WIDTH, null);
    e.width = Math.max(0, e.width - (n == mxConstants.ALIGN_CENTER && null == o ? t.text.spacingLeft * i + t.text.spacingRight * i : 0)), e.height = Math.max(0, e.height - (s == mxConstants.ALIGN_MIDDLE ? t.text.spacingTop * i + t.text.spacingBottom * i : 0));
  }

  0 != (s = t.text.getTextRotation()) && null != t && t.view.graph.model.isVertex(t.cell) && (i = t.getCenterX(), n = t.getCenterY(), e.x != i || e.y != n) && (s *= Math.PI / 180, pt = mxUtils.getRotatedPoint(new mxPoint(e.x, e.y), Math.cos(s), Math.sin(s), new mxPoint(i, n)), e.x = pt.x, e.y = pt.y);
}, mxCellRenderer.prototype.redrawCellOverlays = function (t, e) {
  if (this.createCellOverlays(t), null != t.overlays) {
    var i = mxUtils.mod(mxUtils.getValue(t.style, mxConstants.STYLE_ROTATION, 0), 90),
        n = mxUtils.toRadians(i),
        s = Math.cos(n),
        o = Math.sin(n);
    t.overlays.visit(function (n, l) {
      var r = l.overlay.getBounds(t);

      if (!t.view.graph.getModel().isEdge(t.cell) && null != t.shape && 0 != i) {
        var a = r.getCenterX(),
            h = r.getCenterY();
        a = (h = mxUtils.getRotatedPoint(new mxPoint(a, h), s, o, new mxPoint(t.getCenterX(), t.getCenterY()))).x, h = h.y;
        r.x = Math.round(a - r.width / 2), r.y = Math.round(h - r.height / 2);
      }

      !e && null != l.bounds && l.scale == t.view.scale && l.bounds.equals(r) || (l.bounds = r, l.scale = t.view.scale, l.redraw());
    });
  }
}, mxCellRenderer.prototype.redrawControl = function (t, e) {
  var i = t.view.graph.getFoldingImage(t);

  if (null != t.control && null != i) {
    i = this.getControlBounds(t, i.width, i.height);
    var n = this.legacyControlPosition ? mxUtils.getValue(t.style, mxConstants.STYLE_ROTATION, 0) : t.shape.getTextRotation(),
        s = t.view.scale;
    !e && t.control.scale == s && t.control.bounds.equals(i) && t.control.rotation == n || (t.control.rotation = n, t.control.bounds = i, t.control.scale = s, t.control.redraw());
  }
}, mxCellRenderer.prototype.getControlBounds = function (t, e, i) {
  if (null != t.control) {
    var n = t.view.scale,
        s = t.getCenterX(),
        o = t.getCenterY();

    if (!t.view.graph.getModel().isEdge(t.cell) && (s = t.x + e * n, o = t.y + i * n, null != t.shape)) {
      var l = t.shape.getShapeRotation();
      if (this.legacyControlPosition) l = mxUtils.getValue(t.style, mxConstants.STYLE_ROTATION, 0);else if (t.shape.isPaintBoundsInverted()) {
        var r = (t.width - t.height) / 2;
        s = s + r, o = o - r;
      }
      0 != l && (r = mxUtils.toRadians(l), l = Math.cos(r), r = Math.sin(r), s = (o = mxUtils.getRotatedPoint(new mxPoint(s, o), l, r, new mxPoint(t.getCenterX(), t.getCenterY()))).x, o = o.y);
    }

    return t.view.graph.getModel().isEdge(t.cell), new mxRectangle(Math.round(s - e / 2 * n), Math.round(o - i / 2 * n), Math.round(e * n), Math.round(i * n));
  }

  return null;
}, mxCellRenderer.prototype.insertStateAfter = function (t, e, i) {
  for (var n = this.getShapesForState(t), s = 0; s < n.length; s++) {
    if (null != n[s] && null != n[s].node) {
      var o = n[s].node.parentNode != t.view.getDrawPane() && n[s].node.parentNode != t.view.getOverlayPane(),
          l = o ? i : e;
      if (null != l && l.nextSibling != n[s].node) null == l.nextSibling ? l.parentNode.appendChild(n[s].node) : l.parentNode.insertBefore(n[s].node, l.nextSibling);else if (null == l) if (n[s].node.parentNode == t.view.graph.container) {
        for (l = t.view.canvas; null != l && l.parentNode != t.view.graph.container;) {
          l = l.parentNode;
        }

        null != l && null != l.nextSibling ? l.nextSibling != n[s].node && n[s].node.parentNode.insertBefore(n[s].node, l.nextSibling) : n[s].node.parentNode.appendChild(n[s].node);
      } else null != n[s].node.parentNode.firstChild && n[s].node.parentNode.firstChild != n[s].node && n[s].node.parentNode.insertBefore(n[s].node, n[s].node.parentNode.firstChild);
      o ? i = n[s].node : e = n[s].node;
    }
  }

  return [e, i];
}, mxCellRenderer.prototype.getShapesForState = function (t) {
  return [t.shape, t.text, t.control];
}, mxCellRenderer.prototype.redraw = function (t, e, i) {
  e = this.redrawShape(t, e, i), null == t.shape || null != i && !i || (this.redrawLabel(t, e), this.redrawCellOverlays(t, e), this.redrawControl(t, e));
}, mxCellRenderer.prototype.redrawShape = function (t, e, i) {
  var n = t.view.graph.model,
      s = !1;
  return null != t.shape && null != t.shape.style && null != t.style && t.shape.style[mxConstants.STYLE_SHAPE] != t.style[mxConstants.STYLE_SHAPE] && (t.shape.destroy(), t.shape = null), null == t.shape && null != t.view.graph.container && t.cell != t.view.currentRoot && (n.isVertex(t.cell) || n.isEdge(t.cell)) ? (t.shape = this.createShape(t), null != t.shape && (t.shape.minSvgStrokeWidth = this.minSvgStrokeWidth, t.shape.antiAlias = this.antiAlias, this.createIndicatorShape(t), this.initializeShape(t), this.createCellOverlays(t), this.installListeners(t), t.view.graph.selectionCellsHandler.updateHandler(t))) : e || null == t.shape || mxUtils.equalEntries(t.shape.style, t.style) && !this.checkPlaceholderStyles(t) || (t.shape.resetStyles(), this.configureShape(t), t.view.graph.selectionCellsHandler.updateHandler(t), e = !0), null != t.shape && (this.createControl(t), e || this.isShapeInvalid(t, t.shape)) && (null != t.absolutePoints ? (t.shape.points = t.absolutePoints.slice(), t.shape.bounds = null) : (t.shape.points = null, t.shape.bounds = new mxRectangle(t.x, t.y, t.width, t.height)), t.shape.scale = t.view.scale, null == i || i ? this.doRedrawShape(t) : t.shape.updateBoundingBox(), s = !0), s;
}, mxCellRenderer.prototype.doRedrawShape = function (t) {
  t.shape.redraw();
}, mxCellRenderer.prototype.isShapeInvalid = function (t, e) {
  return null == e.bounds || e.scale != t.view.scale || null == t.absolutePoints && !e.bounds.equals(t) || null != t.absolutePoints && !mxUtils.equalPoints(e.points, t.absolutePoints);
}, mxCellRenderer.prototype.destroy = function (t) {
  null != t.shape && (null != t.text && (t.text.destroy(), t.text = null), null != t.overlays && (t.overlays.visit(function (t, e) {
    e.destroy();
  }), t.overlays = null), null != t.control && (t.control.destroy(), t.control = null), t.shape.destroy(), t.shape = null);
};
var mxEdgeStyle = {
  EntityRelation: function EntityRelation(t, e, i, n, s) {
    var o = t.view,
        l = o.graph,
        r = mxUtils.getValue(t.style, mxConstants.STYLE_SEGMENT, mxConstants.ENTITY_SEGMENT) * o.scale,
        a = t.absolutePoints,
        h = a[0],
        u = a[a.length - 1],
        d = !1;
    if (null != h) (e = new mxCellState()).x = h.x, e.y = h.y;else {
      if (null == e) return;
      if ((m = mxUtils.getPortConstraints(e, t, !0, mxConstants.DIRECTION_MASK_NONE)) != mxConstants.DIRECTION_MASK_NONE && m != mxConstants.DIRECTION_MASK_WEST + mxConstants.DIRECTION_MASK_EAST) d = m == mxConstants.DIRECTION_MASK_WEST;else {
        var p = l.getCellGeometry(e.cell);
        p.relative ? d = p.x <= .5 : null != i && (d = i.x + i.width < e.x);
      }
    }
    var c = !0;
    if (null != u) (i = new mxCellState()).x = u.x, i.y = u.y;else if (null != i) {
      var m;
      if ((m = mxUtils.getPortConstraints(i, t, !1, mxConstants.DIRECTION_MASK_NONE)) != mxConstants.DIRECTION_MASK_NONE && m != mxConstants.DIRECTION_MASK_WEST + mxConstants.DIRECTION_MASK_EAST) c = m == mxConstants.DIRECTION_MASK_WEST;else {
        var g = l.getCellGeometry(i.cell);
        g.relative ? c = g.x <= .5 : null != e && (c = e.x + e.width < i.x);
      }
    }

    if (null != e && null != i) {
      var x = d ? e.x : e.x + e.width,
          y = o.getRoutingCenterY(e),
          f = c ? i.x : i.x + i.width,
          v = o.getRoutingCenterY(i),
          C = r,
          E = d ? -C : C,
          S = new mxPoint(x + E, y),
          b = new mxPoint(f + (E = c ? -C : C), v);

      if (d == c) {
        var w = d ? Math.min(x, f) - r : Math.max(x, f) + r;
        s.push(new mxPoint(w, y)), s.push(new mxPoint(w, v));
      } else if (S.x < b.x == d) {
        var T = y + (v - y) / 2;
        s.push(S), s.push(new mxPoint(S.x, T)), s.push(new mxPoint(b.x, T)), s.push(b);
      } else s.push(S), s.push(b);
    }
  },
  Loop: function Loop(t, e, i, n, s) {
    var o = (i = t.absolutePoints)[i.length - 1];

    if (null != i[0] && null != o) {
      if (null != n && 0 < n.length) for (e = 0; e < n.length; e++) {
        i = n[e], i = t.view.transformControlPoint(t, i), s.push(new mxPoint(i.x, i.y));
      }
    } else if (null != e) {
      var l = (o = t.view).graph;
      null != (i = null != n && 0 < n.length ? n[0] : null) && (i = o.transformControlPoint(t, i), mxUtils.contains(e, i.x, i.y) && (i = null));
      var r = n = 0,
          a = 0,
          h = 0;
      l = mxUtils.getValue(t.style, mxConstants.STYLE_SEGMENT, l.gridSize) * o.scale;
      (t = mxUtils.getValue(t.style, mxConstants.STYLE_DIRECTION, mxConstants.DIRECTION_WEST)) == mxConstants.DIRECTION_NORTH || t == mxConstants.DIRECTION_SOUTH ? (n = o.getRoutingCenterX(e), r = l) : (a = o.getRoutingCenterY(e), h = l), null == i || i.x < e.x || i.x > e.x + e.width ? null != i ? (n = i.x, h = Math.max(Math.abs(a - i.y), h)) : t == mxConstants.DIRECTION_NORTH ? a = e.y - 2 * r : t == mxConstants.DIRECTION_SOUTH ? a = e.y + e.height + 2 * r : n = t == mxConstants.DIRECTION_EAST ? e.x - 2 * h : e.x + e.width + 2 * h : null != i && (n = o.getRoutingCenterX(e), r = Math.max(Math.abs(n - i.x), h), a = i.y, h = 0), s.push(new mxPoint(n - r, a - h)), s.push(new mxPoint(n + r, a + h));
    }
  },
  ElbowConnector: function ElbowConnector(t, e, i, n, s) {
    var o = null != n && 0 < n.length ? n[0] : null,
        l = !1,
        r = !1;
    if (null != e && null != i) if (null != o) {
      var a = Math.min(e.x, i.x),
          h = Math.max(e.x + e.width, i.x + i.width),
          u = (r = Math.min(e.y, i.y), Math.max(e.y + e.height, i.y + i.height));
      l = (o = t.view.transformControlPoint(t, o)).y < r || o.y > u, r = o.x < a || o.x > h;
    } else (l = (a = Math.max(e.x, i.x)) == (h = Math.min(e.x + e.width, i.x + i.width))) || (r = (r = Math.max(e.y, i.y)) == (u = Math.min(e.y + e.height, i.y + i.height)));
    r || !l && t.style[mxConstants.STYLE_ELBOW] != mxConstants.ELBOW_VERTICAL ? mxEdgeStyle.SideToSide(t, e, i, n, s) : mxEdgeStyle.TopToBottom(t, e, i, n, s);
  },
  SideToSide: function SideToSide(t, e, i, n, s) {
    var o = t.view;
    n = null != n && 0 < n.length ? n[0] : null;
    var l = (r = t.absolutePoints)[0],
        r = r[r.length - 1];
    null != n && (n = o.transformControlPoint(t, n)), null != l && ((e = new mxCellState()).x = l.x, e.y = l.y), null != r && ((i = new mxCellState()).x = r.x, i.y = r.y), null != e && null != i && (t = Math.max(e.x, i.x), l = Math.min(e.x + e.width, i.x + i.width), t = null != n ? n.x : Math.round(l + (t - l) / 2), l = o.getRoutingCenterY(e), o = o.getRoutingCenterY(i), null != n && (n.y >= e.y && n.y <= e.y + e.height && (l = n.y), n.y >= i.y && n.y <= i.y + i.height && (o = n.y)), mxUtils.contains(i, t, l) || mxUtils.contains(e, t, l) || s.push(new mxPoint(t, l)), mxUtils.contains(i, t, o) || mxUtils.contains(e, t, o) || s.push(new mxPoint(t, o)), 1 == s.length && (null != n ? mxUtils.contains(i, t, n.y) || mxUtils.contains(e, t, n.y) || s.push(new mxPoint(t, n.y)) : (o = Math.max(e.y, i.y), s.push(new mxPoint(t, o + (Math.min(e.y + e.height, i.y + i.height) - o) / 2)))));
  },
  TopToBottom: function TopToBottom(t, e, i, n, s) {
    var o = t.view;
    n = null != n && 0 < n.length ? n[0] : null;
    var l = (r = t.absolutePoints)[0],
        r = r[r.length - 1];
    null != n && (n = o.transformControlPoint(t, n)), null != l && ((e = new mxCellState()).x = l.x, e.y = l.y), null != r && ((i = new mxCellState()).x = r.x, i.y = r.y), null != e && null != i && (l = Math.max(e.y, i.y), r = Math.min(e.y + e.height, i.y + i.height), t = o.getRoutingCenterX(e), null != n && n.x >= e.x && n.x <= e.x + e.width && (t = n.x), l = null != n ? n.y : Math.round(r + (l - r) / 2), mxUtils.contains(i, t, l) || mxUtils.contains(e, t, l) || s.push(new mxPoint(t, l)), t = null != n && n.x >= i.x && n.x <= i.x + i.width ? n.x : o.getRoutingCenterX(i), mxUtils.contains(i, t, l) || mxUtils.contains(e, t, l) || s.push(new mxPoint(t, l)), 1 == s.length && (null != n && 1 == s.length ? mxUtils.contains(i, n.x, l) || mxUtils.contains(e, n.x, l) || s.push(new mxPoint(n.x, l)) : (o = Math.max(e.x, i.x), s.push(new mxPoint(o + (Math.min(e.x + e.width, i.x + i.width) - o) / 2, l)))));
  },
  SegmentConnector: function SegmentConnector(t, e, i, n, s) {
    function o(t) {
      return (null == a || Math.abs(a.x - t.x) >= r || Math.abs(a.y - t.y) >= r) && (s.push(t), a = t), a;
    }

    var l = t.absolutePoints,
        r = Math.max(1, t.view.scale),
        a = 0 < s.length ? s[0] : null,
        h = !0,
        u = null,
        d = l[0];
    null == d && null != e ? d = new mxPoint(t.view.getRoutingCenterX(e), t.view.getRoutingCenterY(e)) : null != d && (d = d.clone()), d.x = Math.round(d.x), d.y = Math.round(d.y);
    var p = l.length - 1;

    if (null != n && 0 < n.length) {
      u = [];

      for (var c = 0; c < n.length; c++) {
        var m = t.view.transformControlPoint(t, n[c]);
        null != m && (m.x = Math.round(m.x), m.y = Math.round(m.y), u.push(m));
      }

      if (0 == u.length) return;
      n = u, null != d && null != n[0] && (Math.abs(n[0].x - d.x) < r && (n[0].x = d.x), Math.abs(n[0].y - d.y) < r && (n[0].y = d.y)), null != (m = l[p]) && null != n[n.length - 1] && (Math.abs(n[n.length - 1].x - m.x) < r && (n[n.length - 1].x = m.x), Math.abs(n[n.length - 1].y - m.y) < r && (n[n.length - 1].y = m.y));
      u = n[0];
      var g = e,
          x = l[0],
          y = !1,
          f = !1;
      y = u;

      for (null != x && (x.x = Math.round(x.x), x.y = Math.round(x.y), g = null), c = 0; 2 > c; c++) {
        var v = null != x && x.x == y.x,
            C = null != x && x.y == y.y,
            E = null != g && y.y >= g.y && y.y <= g.y + g.height;
        g = null != g && y.x >= g.x && y.x <= g.x + g.width, y = C || null == x && E, f = v || null == x && g;

        if (0 != c || !(y && f || v && C)) {
          if (null != x && !C && !v && (E || g)) {
            h = !E;
            break;
          }

          if (f || y) {
            h = y, 1 == c && (h = 0 == n.length % 2 ? y : f);
            break;
          }
        }

        g = i, null != (x = l[p]) && (x.x = Math.round(x.x), x.y = Math.round(x.y), g = null), y = n[n.length - 1], v && C && (n = n.slice(1));
      }

      for (h && (null != l[0] && l[0].y != u.y || null == l[0] && null != e && (u.y < e.y || u.y > e.y + e.height)) ? o(new mxPoint(d.x, u.y)) : !h && (null != l[0] && l[0].x != u.x || null == l[0] && null != e && (u.x < e.x || u.x > e.x + e.width)) && o(new mxPoint(u.x, d.y)), h ? d.y = u.y : d.x = u.x, c = 0; c < n.length; c++) {
        h = !h, u = n[c], h ? d.y = u.y : d.x = u.x, o(d.clone());
      }
    } else u = d, h = !0;

    if (null == (d = l[p]) && null != i && (d = new mxPoint(t.view.getRoutingCenterX(i), t.view.getRoutingCenterY(i))), null != d && (d.x = Math.round(d.x), d.y = Math.round(d.y), null != u && (h && (null != l[p] && l[p].y != u.y || null == l[p] && null != i && (u.y < i.y || u.y > i.y + i.height)) ? o(new mxPoint(d.x, u.y)) : !h && (null != l[p] && l[p].x != u.x || null == l[p] && null != i && (u.x < i.x || u.x > i.x + i.width)) && o(new mxPoint(u.x, d.y)))), null == l[0] && null != e) for (; 1 < s.length && null != s[1] && mxUtils.contains(e, s[1].x, s[1].y);) {
      s.splice(1, 1);
    }
    if (null == l[p] && null != i) for (; 1 < s.length && null != s[s.length - 1] && mxUtils.contains(i, s[s.length - 1].x, s[s.length - 1].y);) {
      s.splice(s.length - 1, 1);
    }
    null != m && null != s[s.length - 1] && Math.abs(m.x - s[s.length - 1].x) < r && Math.abs(m.y - s[s.length - 1].y) < r && (s.splice(s.length - 1, 1), null != s[s.length - 1] && (Math.abs(s[s.length - 1].x - m.x) < r && (s[s.length - 1].x = m.x), Math.abs(s[s.length - 1].y - m.y) < r && (s[s.length - 1].y = m.y)));
  },
  orthBuffer: 10,
  orthPointsFallback: !0,
  dirVectors: [[-1, 0], [0, -1], [1, 0], [0, 1], [-1, 0], [0, -1], [1, 0]],
  wayPoints1: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
  routePatterns: [[[513, 2308, 2081, 2562], [513, 1090, 514, 2184, 2114, 2561], [513, 1090, 514, 2564, 2184, 2562], [513, 2308, 2561, 1090, 514, 2568, 2308]], [[514, 1057, 513, 2308, 2081, 2562], [514, 2184, 2114, 2561], [514, 2184, 2562, 1057, 513, 2564, 2184], [514, 1057, 513, 2568, 2308, 2561]], [[1090, 514, 1057, 513, 2308, 2081, 2562], [2114, 2561], [1090, 2562, 1057, 513, 2564, 2184], [1090, 514, 1057, 513, 2308, 2561, 2568]], [[2081, 2562], [1057, 513, 1090, 514, 2184, 2114, 2561], [1057, 513, 1090, 514, 2184, 2562, 2564], [1057, 2561, 1090, 514, 2568, 2308]]],
  inlineRoutePatterns: [[null, [2114, 2568], null, null], [null, [514, 2081, 2114, 2568], null, null], [null, [2114, 2561], null, null], [[2081, 2562], [1057, 2114, 2568], [2184, 2562], null]],
  vertexSeperations: [],
  limits: [[0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0]],
  LEFT_MASK: 32,
  TOP_MASK: 64,
  RIGHT_MASK: 128,
  BOTTOM_MASK: 256,
  LEFT: 1,
  TOP: 2,
  RIGHT: 4,
  BOTTOM: 8,
  SIDE_MASK: 480,
  CENTER_MASK: 512,
  SOURCE_MASK: 1024,
  TARGET_MASK: 2048,
  VERTEX_MASK: 3072,
  getJettySize: function getJettySize(t, e, i, n, s) {
    return "auto" == (e = mxUtils.getValue(t.style, s ? mxConstants.STYLE_SOURCE_JETTY_SIZE : mxConstants.STYLE_TARGET_JETTY_SIZE, mxUtils.getValue(t.style, mxConstants.STYLE_JETTY_SIZE, mxEdgeStyle.orthBuffer))) && (mxUtils.getValue(t.style, s ? mxConstants.STYLE_STARTARROW : mxConstants.STYLE_ENDARROW, mxConstants.NONE) != mxConstants.NONE ? (t = mxUtils.getNumber(t.style, s ? mxConstants.STYLE_STARTSIZE : mxConstants.STYLE_ENDSIZE, mxConstants.DEFAULT_MARKERSIZE), e = Math.max(2, Math.ceil((t + mxEdgeStyle.orthBuffer) / mxEdgeStyle.orthBuffer)) * mxEdgeStyle.orthBuffer) : e = 2 * mxEdgeStyle.orthBuffer), e;
  },
  OrthConnector: function OrthConnector(t, e, i, n, s) {
    var o = t.view.graph,
        l = null != e && o.getModel().isEdge(e.cell),
        r = null != i && o.getModel().isEdge(i.cell),
        a = (o = t.absolutePoints)[0],
        h = o[o.length - 1],
        u = null != e ? e.x : a.x,
        d = null != e ? e.y : a.y,
        p = null != e ? e.width : 0,
        c = null != e ? e.height : 0,
        m = null != i ? i.x : h.x,
        g = null != i ? i.y : h.y,
        x = null != i ? i.width : 0,
        y = null != i ? i.height : 0,
        f = (o = t.view.scale * mxEdgeStyle.getJettySize(t, e, i, n, !0), t.view.scale * mxEdgeStyle.getJettySize(t, e, i, n, !1));
    null != e && i == e && (o = f = Math.max(o, f));
    var v = f + o,
        C = !1;

    if (null != a && null != h) {
      C = h.x - a.x;
      var E = h.y - a.y;
      C = C * C + E * E < v * v;
    }

    if (C || mxEdgeStyle.orthPointsFallback && null != n && 0 < n.length || l || r) mxEdgeStyle.SegmentConnector(t, e, i, n, s);else {
      for (n = [mxConstants.DIRECTION_MASK_ALL, mxConstants.DIRECTION_MASK_ALL], null != e && (n[0] = mxUtils.getPortConstraints(e, t, !0, mxConstants.DIRECTION_MASK_ALL), 0 != (C = mxUtils.getValue(e.style, mxConstants.STYLE_ROTATION, 0)) && (u = (C = mxUtils.getBoundingBox(new mxRectangle(u, d, p, c), C)).x, d = C.y, p = C.width, c = C.height)), null != i && (n[1] = mxUtils.getPortConstraints(i, t, !1, mxConstants.DIRECTION_MASK_ALL), 0 != (C = mxUtils.getValue(i.style, mxConstants.STYLE_ROTATION, 0)) && (m = (C = mxUtils.getBoundingBox(new mxRectangle(m, g, x, y), C)).x, g = C.y, x = C.width, y = C.height)), t = [0, 0], u = [[u = Math.round(10 * u) / 10, d = Math.round(10 * d) / 10, p = Math.round(10 * p) / 10, c = Math.round(10 * c) / 10], [m = Math.round(10 * m) / 10, g = Math.round(10 * g) / 10, x = Math.round(10 * x) / 10, y = Math.round(10 * y) / 10]], f = [o, f], C = 0; 2 > C; C++) {
        mxEdgeStyle.limits[C][1] = u[C][0] - f[C], mxEdgeStyle.limits[C][2] = u[C][1] - f[C], mxEdgeStyle.limits[C][4] = u[C][0] + u[C][2] + f[C], mxEdgeStyle.limits[C][8] = u[C][1] + u[C][3] + f[C];
      }

      for (E = (f = u[0][1] + u[0][3] / 2) - (d = u[1][1] + u[1][3] / 2), f = 0, 0 > (C = u[0][0] + u[0][2] / 2 - (u[1][0] + u[1][2] / 2)) ? f = 0 > E ? 2 : 1 : 0 >= E && (f = 3, 0 == C && (f = 2)), d = null, null != e && (d = a), e = [[.5, .5], [.5, .5]], C = 0; 2 > C; C++) {
        null != d && (e[C][0] = (d.x - u[C][0]) / u[C][2], 1 >= Math.abs(d.x - u[C][0]) ? t[C] = mxConstants.DIRECTION_MASK_WEST : 1 >= Math.abs(d.x - u[C][0] - u[C][2]) && (t[C] = mxConstants.DIRECTION_MASK_EAST), e[C][1] = (d.y - u[C][1]) / u[C][3], 1 >= Math.abs(d.y - u[C][1]) ? t[C] = mxConstants.DIRECTION_MASK_NORTH : 1 >= Math.abs(d.y - u[C][1] - u[C][3]) && (t[C] = mxConstants.DIRECTION_MASK_SOUTH)), d = null, null != i && (d = h);
      }

      for (C = u[0][1] - (u[1][1] + u[1][3]), h = u[0][0] - (u[1][0] + u[1][2]), d = u[1][1] - (u[0][1] + u[0][3]), p = u[1][0] - (u[0][0] + u[0][2]), mxEdgeStyle.vertexSeperations[1] = Math.max(h - v, 0), mxEdgeStyle.vertexSeperations[2] = Math.max(C - v, 0), mxEdgeStyle.vertexSeperations[4] = Math.max(d - v, 0), mxEdgeStyle.vertexSeperations[3] = Math.max(p - v, 0), v = [], a = [], (i = [])[0] = h >= p ? mxConstants.DIRECTION_MASK_WEST : mxConstants.DIRECTION_MASK_EAST, a[0] = C >= d ? mxConstants.DIRECTION_MASK_NORTH : mxConstants.DIRECTION_MASK_SOUTH, i[1] = mxUtils.reversePortConstraints(i[0]), a[1] = mxUtils.reversePortConstraints(a[0]), h = h >= p ? h : p, d = C >= d ? C : d, p = [[0, 0], [0, 0]], c = !1, C = 0; 2 > C; C++) {
        0 == t[C] && (0 == (i[C] & n[C]) && (i[C] = mxUtils.reversePortConstraints(i[C])), 0 == (a[C] & n[C]) && (a[C] = mxUtils.reversePortConstraints(a[C])), p[C][0] = a[C], p[C][1] = i[C]);
      }

      for (0 < d && 0 < h && (0 < (i[0] & n[0]) && 0 < (a[1] & n[1]) ? (p[0][0] = i[0], p[0][1] = a[0], p[1][0] = a[1], p[1][1] = i[1], c = !0) : 0 < (a[0] & n[0]) && 0 < (i[1] & n[1]) && (p[0][0] = a[0], p[0][1] = i[0], p[1][0] = i[1], p[1][1] = a[1], c = !0)), 0 < d && !c && (p[0][0] = a[0], p[0][1] = i[0], p[1][0] = a[1], p[1][1] = i[1], c = !0), 0 < h && !c && (p[0][0] = i[0], p[0][1] = a[0], p[1][0] = i[1], p[1][1] = a[1]), C = 0; 2 > C; C++) {
        0 == t[C] && (0 == (p[C][0] & n[C]) && (p[C][0] = p[C][1]), v[C] = p[C][0] & n[C], v[C] |= (p[C][1] & n[C]) << 8, v[C] |= (p[1 - C][C] & n[C]) << 16, v[C] |= (p[1 - C][1 - C] & n[C]) << 24, 0 == (15 & v[C]) && (v[C] <<= 8), 0 == (3840 & v[C]) && (v[C] = 15 & v[C] | v[C] >> 8), 0 == (983040 & v[C]) && (v[C] = 65535 & v[C] | (251658240 & v[C]) >> 8), t[C] = 15 & v[C], n[C] == mxConstants.DIRECTION_MASK_WEST || n[C] == mxConstants.DIRECTION_MASK_NORTH || n[C] == mxConstants.DIRECTION_MASK_EAST || n[C] == mxConstants.DIRECTION_MASK_SOUTH) && (t[C] = n[C]);
      }

      switch (n = t[0] == mxConstants.DIRECTION_MASK_EAST ? 3 : t[0], v = t[1] == mxConstants.DIRECTION_MASK_EAST ? 3 : t[1], 1 > (n -= f) && (n += 4), 1 > (v -= f) && (v += 4), n = mxEdgeStyle.routePatterns[n - 1][v - 1], mxEdgeStyle.wayPoints1[0][0] = u[0][0], mxEdgeStyle.wayPoints1[0][1] = u[0][1], t[0]) {
        case mxConstants.DIRECTION_MASK_WEST:
          mxEdgeStyle.wayPoints1[0][0] -= o, mxEdgeStyle.wayPoints1[0][1] += e[0][1] * u[0][3];
          break;

        case mxConstants.DIRECTION_MASK_SOUTH:
          mxEdgeStyle.wayPoints1[0][0] += e[0][0] * u[0][2], mxEdgeStyle.wayPoints1[0][1] += u[0][3] + o;
          break;

        case mxConstants.DIRECTION_MASK_EAST:
          mxEdgeStyle.wayPoints1[0][0] += u[0][2] + o, mxEdgeStyle.wayPoints1[0][1] += e[0][1] * u[0][3];
          break;

        case mxConstants.DIRECTION_MASK_NORTH:
          mxEdgeStyle.wayPoints1[0][0] += e[0][0] * u[0][2], mxEdgeStyle.wayPoints1[0][1] -= o;
      }

      for (o = 0, i = v = 0 < (t[0] & (mxConstants.DIRECTION_MASK_EAST | mxConstants.DIRECTION_MASK_WEST)) ? 0 : 1, C = 0; C < n.length; C++) {
        c = (a = 15 & n[C]) == mxConstants.DIRECTION_MASK_EAST ? 3 : a, 4 < (c += f) && (c -= 4), h = mxEdgeStyle.dirVectors[c - 1], (a = 0 < c % 2 ? 0 : 1) != v && (o++, mxEdgeStyle.wayPoints1[o][0] = mxEdgeStyle.wayPoints1[o - 1][0], mxEdgeStyle.wayPoints1[o][1] = mxEdgeStyle.wayPoints1[o - 1][1]), m = 0 < (n[C] & mxEdgeStyle.TARGET_MASK), g = 0 < (n[C] & mxEdgeStyle.SOURCE_MASK), d = (n[C] & mxEdgeStyle.SIDE_MASK) >> 5, 15 < (d <<= f) && (d >>= 4), p = 0 < (n[C] & mxEdgeStyle.CENTER_MASK), (g || m) && 9 > d ? (c = g ? 0 : 1, d = p && 0 == a ? u[c][0] + e[c][0] * u[c][2] : p ? u[c][1] + e[c][1] * u[c][3] : mxEdgeStyle.limits[c][d], 0 == a ? 0 < (d = (d - mxEdgeStyle.wayPoints1[o][0]) * h[0]) && (mxEdgeStyle.wayPoints1[o][0] += h[0] * d) : 0 < (d = (d - mxEdgeStyle.wayPoints1[o][1]) * h[1]) && (mxEdgeStyle.wayPoints1[o][1] += h[1] * d)) : p && (mxEdgeStyle.wayPoints1[o][0] += h[0] * Math.abs(mxEdgeStyle.vertexSeperations[c] / 2), mxEdgeStyle.wayPoints1[o][1] += h[1] * Math.abs(mxEdgeStyle.vertexSeperations[c] / 2)), 0 < o && mxEdgeStyle.wayPoints1[o][a] == mxEdgeStyle.wayPoints1[o - 1][a] ? o-- : v = a;
      }

      for (C = 0; C <= o && (C != o || ((0 < (t[1] & (mxConstants.DIRECTION_MASK_EAST | mxConstants.DIRECTION_MASK_WEST)) ? 0 : 1) == i ? 0 : 1) == (o + 1) % 2); C++) {
        s.push(new mxPoint(Math.round(mxEdgeStyle.wayPoints1[C][0]), Math.round(mxEdgeStyle.wayPoints1[C][1])));
      }

      for (t = 1; t < s.length;) {
        null == s[t - 1] || null == s[t] || s[t - 1].x != s[t].x || s[t - 1].y != s[t].y ? t++ : s.splice(t, 1);
      }
    }
  },
  getRoutePattern: function getRoutePattern(t, e, i, n) {
    var s = t[0] == mxConstants.DIRECTION_MASK_EAST ? 3 : t[0];
    return t = t[1] == mxConstants.DIRECTION_MASK_EAST ? 3 : t[1], 1 > (s -= e) && (s += 4), 1 > (t -= e) && (t += 4), e = routePatterns[s - 1][t - 1], 0 != i && 0 != n || null == inlineRoutePatterns[s - 1][t - 1] || (e = inlineRoutePatterns[s - 1][t - 1]), e;
  }
},
    mxStyleRegistry = {
  values: [],
  putValue: function putValue(t, e) {
    mxStyleRegistry.values[t] = e;
  },
  getValue: function getValue(t) {
    return mxStyleRegistry.values[t];
  },
  getName: function getName(t) {
    for (var e in mxStyleRegistry.values) {
      if (mxStyleRegistry.values[e] == t) return e;
    }

    return null;
  }
};

function mxGraphView(t) {
  this.graph = t, this.translate = new mxPoint(), this.graphBounds = new mxRectangle(), this.states = new mxDictionary();
}

function mxCurrentRootChange(t, e) {
  if (this.view = t, this.previous = this.root = e, this.isUp = null == e, !this.isUp) for (var i = this.view.currentRoot, n = this.view.graph.getModel(); null != i;) {
    if (i == e) {
      this.isUp = !0;
      break;
    }

    i = n.getParent(i);
  }
}

function mxGraph(t, e, i, n) {
  this.mouseListeners = null, this.renderHint = i, this.dialect = mxClient.IS_SVG ? mxConstants.DIALECT_SVG : i == mxConstants.RENDERING_HINT_EXACT && mxClient.IS_VML ? mxConstants.DIALECT_VML : i == mxConstants.RENDERING_HINT_FASTEST ? mxConstants.DIALECT_STRICTHTML : i == mxConstants.RENDERING_HINT_FASTER ? mxConstants.DIALECT_PREFERHTML : mxConstants.DIALECT_MIXEDHTML, this.model = null != e ? e : new mxGraphModel(), this.multiplicities = [], this.imageBundles = [], this.cellRenderer = this.createCellRenderer(), this.setSelectionModel(this.createSelectionModel()), this.setStylesheet(null != n ? n : this.createStylesheet()), this.view = this.createGraphView(), this.graphModelChangeListener = mxUtils.bind(this, function (t, e) {
    this.graphModelChanged(e.getProperty("edit").changes);
  }), this.model.addListener(mxEvent.CHANGE, this.graphModelChangeListener), this.createHandlers(), null != t && this.init(t), this.view.revalidate();
}

function mxCellOverlay(t, e, i, n, s, o) {
  this.image = t, this.tooltip = e, this.align = null != i ? i : this.align, this.verticalAlign = null != n ? n : this.verticalAlign, this.offset = null != s ? s : new mxPoint(), this.cursor = null != o ? o : "help";
}

function mxOutline(t, e) {
  this.source = t, null != e && this.init(e);
}

function mxMultiplicity(t, e, i, n, s, o, l, r, a, h) {
  this.source = t, this.type = e, this.attr = i, this.value = n, this.min = null != s ? s : 0, this.max = null != o ? o : "n", this.validNeighbors = l, this.countError = mxResources.get(r) || r, this.typeError = mxResources.get(a) || a, this.validNeighborsAllowed = null == h || h;
}

function mxLayoutManager(t) {
  this.undoHandler = mxUtils.bind(this, function (t, e) {
    this.isEnabled() && this.beforeUndo(e.getProperty("edit"));
  }), this.moveHandler = mxUtils.bind(this, function (t, e) {
    this.isEnabled() && this.cellsMoved(e.getProperty("cells"), e.getProperty("event"));
  }), this.setGraph(t);
}

function mxSwimlaneManager(t, e, i, n) {
  this.horizontal = null == e || e, this.addEnabled = null == i || i, this.resizeEnabled = null == n || n, this.addHandler = mxUtils.bind(this, function (t, e) {
    this.isEnabled() && this.isAddEnabled() && this.cellsAdded(e.getProperty("cells"));
  }), this.resizeHandler = mxUtils.bind(this, function (t, e) {
    this.isEnabled() && this.isResizeEnabled() && this.cellsResized(e.getProperty("cells"));
  }), this.setGraph(t);
}

function mxTemporaryCellStates(t, e, i, n, s) {
  e = null != e ? e : 1, this.view = t, this.oldValidateCellState = t.validateCellState, this.oldBounds = t.getGraphBounds(), this.oldStates = t.getStates(), this.oldScale = t.getScale(), this.oldDoRedrawShape = t.graph.cellRenderer.doRedrawShape;
  var o = this;

  if (null != s && (t.graph.cellRenderer.doRedrawShape = function (e) {
    var i = e.shape.paint;
    e.shape.paint = function (t) {
      var n = s(e);
      null != n && t.setLink(n), i.apply(this, arguments), null != n && t.setLink(null);
    }, o.oldDoRedrawShape.apply(t.graph.cellRenderer, arguments), e.shape.paint = i;
  }), t.validateCellState = function (e, i) {
    return null == e || null == n || n(e) ? o.oldValidateCellState.apply(t, arguments) : null;
  }, t.setStates(new mxDictionary()), t.setScale(e), null != i) {
    t.resetValidationState(), e = null;

    for (var l = 0; l < i.length; l++) {
      var r = t.getBoundingBox(t.validateCellState(t.validateCell(i[l])));
      null == e ? e = r : e.add(r);
    }

    t.setGraphBounds(e || new mxRectangle());
  }
}

function mxCellStatePreview(t) {
  this.deltas = new mxDictionary(), this.graph = t;
}

function mxConnectionConstraint(t, e, i) {
  this.point = t, this.perimeter = null == e || e, this.name = i;
}

function mxGraphHandler(t) {
  this.graph = t, this.graph.addMouseListener(this), this.panHandler = mxUtils.bind(this, function () {
    this.updatePreviewShape(), this.updateHint();
  }), this.graph.addListener(mxEvent.PAN, this.panHandler), this.escapeHandler = mxUtils.bind(this, function (t, e) {
    this.reset();
  }), this.graph.addListener(mxEvent.ESCAPE, this.escapeHandler), this.refreshHandler = mxUtils.bind(this, function (t, e) {
    if (null != this.first) try {
      this.bounds = this.graph.getView().getBounds(this.cells), this.pBounds = this.getPreviewBounds(this.cells), this.updatePreviewShape();
    } catch (t) {
      this.reset();
    }
  }), this.graph.getModel().addListener(mxEvent.CHANGE, this.refreshHandler);
}

function mxPanningHandler(t) {
  null != t && (this.graph = t, this.graph.addMouseListener(this), this.forcePanningHandler = mxUtils.bind(this, function (t, e) {
    var i = e.getProperty("eventName"),
        n = e.getProperty("event");
    i == mxEvent.MOUSE_DOWN && this.isForcePanningEvent(n) && (this.start(n), this.active = !0, this.fireEvent(new mxEventObject(mxEvent.PAN_START, "event", n)), n.consume());
  }), this.graph.addListener(mxEvent.FIRE_MOUSE_EVENT, this.forcePanningHandler), this.gestureHandler = mxUtils.bind(this, function (t, e) {
    if (this.isPinchEnabled()) {
      var i = e.getProperty("event");

      if (mxEvent.isConsumed(i) || "gesturestart" != i.type ? "gestureend" == i.type && null != this.initialScale && (this.initialScale = null) : (this.initialScale = this.graph.view.scale, this.active || null == this.mouseDownEvent || (this.start(this.mouseDownEvent), this.mouseDownEvent = null)), null != this.initialScale) {
        var n = Math.round(this.initialScale * i.scale * 100) / 100;
        null != this.minScale && (n = Math.max(this.minScale, n)), null != this.maxScale && (n = Math.min(this.maxScale, n)), this.graph.view.scale != n && (this.graph.zoomTo(n), mxEvent.consume(i));
      }
    }
  }), this.graph.addListener(mxEvent.GESTURE, this.gestureHandler), this.mouseUpListener = mxUtils.bind(this, function () {
    this.active && this.reset();
  }), mxEvent.addListener(document, "mouseup", this.mouseUpListener));
}

function mxPopupMenuHandler(t, e) {
  null != t && (this.graph = t, this.factoryMethod = e, this.graph.addMouseListener(this), this.gestureHandler = mxUtils.bind(this, function (t, e) {
    this.inTolerance = !1;
  }), this.graph.addListener(mxEvent.GESTURE, this.gestureHandler), this.init());
}

function mxCellMarker(t, e, i, n) {
  mxEventSource.call(this), null != t && (this.graph = t, this.validColor = null != e ? e : mxConstants.DEFAULT_VALID_COLOR, this.invalidColor = null != i ? i : mxConstants.DEFAULT_INVALID_COLOR, this.hotspot = null != n ? n : mxConstants.DEFAULT_HOTSPOT, this.highlight = new mxCellHighlight(t));
}

function mxSelectionCellsHandler(t) {
  mxEventSource.call(this), this.graph = t, this.handlers = new mxDictionary(), this.graph.addMouseListener(this), this.refreshHandler = mxUtils.bind(this, function (t, e) {
    this.isEnabled() && this.refresh();
  }), this.graph.getSelectionModel().addListener(mxEvent.CHANGE, this.refreshHandler), this.graph.getModel().addListener(mxEvent.CHANGE, this.refreshHandler), this.graph.getView().addListener(mxEvent.SCALE, this.refreshHandler), this.graph.getView().addListener(mxEvent.TRANSLATE, this.refreshHandler), this.graph.getView().addListener(mxEvent.SCALE_AND_TRANSLATE, this.refreshHandler), this.graph.getView().addListener(mxEvent.DOWN, this.refreshHandler), this.graph.getView().addListener(mxEvent.UP, this.refreshHandler);
}

function mxConnectionHandler(t, e) {
  mxEventSource.call(this), null != t && (this.graph = t, this.factoryMethod = e, this.init(), this.escapeHandler = mxUtils.bind(this, function (t, e) {
    this.reset();
  }), this.graph.addListener(mxEvent.ESCAPE, this.escapeHandler));
}

function mxConstraintHandler(t) {
  this.graph = t, this.resetHandler = mxUtils.bind(this, function (t, e) {
    null != this.currentFocus && null == this.graph.view.getState(this.currentFocus.cell) ? this.reset() : this.redraw();
  }), this.graph.model.addListener(mxEvent.CHANGE, this.resetHandler), this.graph.view.addListener(mxEvent.SCALE_AND_TRANSLATE, this.resetHandler), this.graph.view.addListener(mxEvent.TRANSLATE, this.resetHandler), this.graph.view.addListener(mxEvent.SCALE, this.resetHandler), this.graph.addListener(mxEvent.ROOT, this.resetHandler);
}

function mxRubberband(t) {
  null != t && (this.graph = t, this.graph.addMouseListener(this), this.forceRubberbandHandler = mxUtils.bind(this, function (t, e) {
    var i = e.getProperty("eventName"),
        n = e.getProperty("event");

    if (i == mxEvent.MOUSE_DOWN && this.isForceRubberbandEvent(n)) {
      i = mxUtils.getOffset(this.graph.container);
      var s = mxUtils.getScrollOrigin(this.graph.container);
      s.x -= i.x, s.y -= i.y, this.start(n.getX() + s.x, n.getY() + s.y), n.consume(!1);
    }
  }), this.graph.addListener(mxEvent.FIRE_MOUSE_EVENT, this.forceRubberbandHandler), this.panHandler = mxUtils.bind(this, function () {
    this.repaint();
  }), this.graph.addListener(mxEvent.PAN, this.panHandler), this.gestureHandler = mxUtils.bind(this, function (t, e) {
    null != this.first && this.reset();
  }), this.graph.addListener(mxEvent.GESTURE, this.gestureHandler), mxClient.IS_IE && mxEvent.addListener(window, "unload", mxUtils.bind(this, function () {
    this.destroy();
  })));
}

function mxHandle(t, e, i) {
  this.graph = t.view.graph, this.state = t, this.cursor = null != e ? e : this.cursor, this.image = null != i ? i : this.image, this.init();
}

function mxVertexHandler(t) {
  null != t && (this.state = t, this.init(), this.escapeHandler = mxUtils.bind(this, function (t, e) {
    this.livePreview && null != this.index && (this.state.view.graph.cellRenderer.redraw(this.state, !0), this.state.view.invalidate(this.state.cell), this.state.invalid = !1, this.state.view.validate()), this.reset();
  }), this.state.view.graph.addListener(mxEvent.ESCAPE, this.escapeHandler));
}

function mxEdgeHandler(t) {
  null != t && (this.state = t, this.init(), this.escapeHandler = mxUtils.bind(this, function (e, i) {
    var n = null != this.index;
    this.reset(), n && this.graph.cellRenderer.redraw(this.state, !1, t.view.isRendering());
  }), this.state.view.graph.addListener(mxEvent.ESCAPE, this.escapeHandler));
}

function mxElbowEdgeHandler(t) {
  mxEdgeHandler.call(this, t);
}

function mxEdgeSegmentHandler(t) {
  mxEdgeHandler.call(this, t);
}

function mxKeyHandler(t, e) {
  null != t && (this.graph = t, this.target = e || document.documentElement, this.normalKeys = [], this.shiftKeys = [], this.controlKeys = [], this.controlShiftKeys = [], this.keydownHandler = mxUtils.bind(this, function (t) {
    this.keyDown(t);
  }), mxEvent.addListener(this.target, "keydown", this.keydownHandler), mxClient.IS_IE && mxEvent.addListener(window, "unload", mxUtils.bind(this, function () {
    this.destroy();
  })));
}

function mxTooltipHandler(t, e) {
  null != t && (this.graph = t, this.delay = e || 500, this.graph.addMouseListener(this));
}

function mxCellTracker(t, e, i) {
  mxCellMarker.call(this, t, e), this.graph.addMouseListener(this), null != i && (this.getCell = i), mxClient.IS_IE && mxEvent.addListener(window, "unload", mxUtils.bind(this, function () {
    this.destroy();
  }));
}

function mxCellHighlight(t, e, i, n) {
  null != t && (this.graph = t, this.highlightColor = null != e ? e : mxConstants.DEFAULT_VALID_COLOR, this.strokeWidth = null != i ? i : mxConstants.HIGHLIGHT_STROKEWIDTH, this.dashed = null != n && n, this.opacity = mxConstants.HIGHLIGHT_OPACITY, this.repaintHandler = mxUtils.bind(this, function () {
    if (null != this.state) {
      var t = this.graph.view.getState(this.state.cell);
      null == t ? this.hide() : (this.state = t, this.repaint());
    }
  }), this.graph.getView().addListener(mxEvent.SCALE, this.repaintHandler), this.graph.getView().addListener(mxEvent.TRANSLATE, this.repaintHandler), this.graph.getView().addListener(mxEvent.SCALE_AND_TRANSLATE, this.repaintHandler), this.graph.getModel().addListener(mxEvent.CHANGE, this.repaintHandler), this.resetHandler = mxUtils.bind(this, function () {
    this.hide();
  }), this.graph.getView().addListener(mxEvent.DOWN, this.resetHandler), this.graph.getView().addListener(mxEvent.UP, this.resetHandler));
}

function mxDefaultKeyHandler(t) {
  if (null != t) {
    this.editor = t, this.handler = new mxKeyHandler(t.graph);
    var e = this.handler.escape;

    this.handler.escape = function (i) {
      e.apply(this, arguments), t.hideProperties(), t.fireEvent(new mxEventObject(mxEvent.ESCAPE, "event", i));
    };
  }
}

function mxDefaultPopupMenu(t) {
  this.config = t;
}

function mxDefaultToolbar(t, e) {
  this.editor = e, null != t && null != e && this.init(t);
}

function mxEditor(t) {
  this.actions = [], this.addActions(), null != document.body && (this.cycleAttributeValues = [], this.popupHandler = new mxDefaultPopupMenu(), this.undoManager = new mxUndoManager(), this.graph = this.createGraph(), this.toolbar = this.createToolbar(), this.keyHandler = new mxDefaultKeyHandler(this), this.configure(t), this.graph.swimlaneIndicatorColorAttribute = this.cycleAttributeName, null != this.onInit && this.onInit(), mxClient.IS_IE && mxEvent.addListener(window, "unload", mxUtils.bind(this, function () {
    this.destroy();
  })));
}

mxStyleRegistry.putValue(mxConstants.EDGESTYLE_ELBOW, mxEdgeStyle.ElbowConnector), mxStyleRegistry.putValue(mxConstants.EDGESTYLE_ENTITY_RELATION, mxEdgeStyle.EntityRelation), mxStyleRegistry.putValue(mxConstants.EDGESTYLE_LOOP, mxEdgeStyle.Loop), mxStyleRegistry.putValue(mxConstants.EDGESTYLE_SIDETOSIDE, mxEdgeStyle.SideToSide), mxStyleRegistry.putValue(mxConstants.EDGESTYLE_TOPTOBOTTOM, mxEdgeStyle.TopToBottom), mxStyleRegistry.putValue(mxConstants.EDGESTYLE_ORTHOGONAL, mxEdgeStyle.OrthConnector), mxStyleRegistry.putValue(mxConstants.EDGESTYLE_SEGMENT, mxEdgeStyle.SegmentConnector), mxStyleRegistry.putValue(mxConstants.PERIMETER_ELLIPSE, mxPerimeter.EllipsePerimeter), mxStyleRegistry.putValue(mxConstants.PERIMETER_RECTANGLE, mxPerimeter.RectanglePerimeter), mxStyleRegistry.putValue(mxConstants.PERIMETER_RHOMBUS, mxPerimeter.RhombusPerimeter), mxStyleRegistry.putValue(mxConstants.PERIMETER_TRIANGLE, mxPerimeter.TrianglePerimeter), mxStyleRegistry.putValue(mxConstants.PERIMETER_HEXAGON, mxPerimeter.HexagonPerimeter), mxGraphView.prototype = new mxEventSource(), mxGraphView.prototype.constructor = mxGraphView, mxGraphView.prototype.EMPTY_POINT = new mxPoint(), mxGraphView.prototype.doneResource = "none" != mxClient.language ? "done" : "", mxGraphView.prototype.updatingDocumentResource = "none" != mxClient.language ? "updatingDocument" : "", mxGraphView.prototype.allowEval = !1, mxGraphView.prototype.captureDocumentGesture = !0, mxGraphView.prototype.optimizeVmlReflows = !0, mxGraphView.prototype.rendering = !0, mxGraphView.prototype.graph = null, mxGraphView.prototype.currentRoot = null, mxGraphView.prototype.graphBounds = null, mxGraphView.prototype.scale = 1, mxGraphView.prototype.translate = null, mxGraphView.prototype.states = null, mxGraphView.prototype.updateStyle = !1, mxGraphView.prototype.lastNode = null, mxGraphView.prototype.lastHtmlNode = null, mxGraphView.prototype.lastForegroundNode = null, mxGraphView.prototype.lastForegroundHtmlNode = null, mxGraphView.prototype.getGraphBounds = function () {
  return this.graphBounds;
}, mxGraphView.prototype.setGraphBounds = function (t) {
  this.graphBounds = t;
}, mxGraphView.prototype.getBounds = function (t) {
  var e = null;
  if (null != t && 0 < t.length) for (var i = this.graph.getModel(), n = 0; n < t.length; n++) {
    if (i.isVertex(t[n]) || i.isEdge(t[n])) {
      var s = this.getState(t[n]);
      null != s && (null == e ? e = mxRectangle.fromRectangle(s) : e.add(s));
    }
  }
  return e;
}, mxGraphView.prototype.setCurrentRoot = function (t) {
  if (this.currentRoot != t) {
    var e = new mxCurrentRootChange(this, t);
    e.execute();
    var i = new mxUndoableEdit(this, !1);
    i.add(e), this.fireEvent(new mxEventObject(mxEvent.UNDO, "edit", i)), this.graph.sizeDidChange();
  }

  return t;
}, mxGraphView.prototype.scaleAndTranslate = function (t, e, i) {
  var n = this.scale,
      s = new mxPoint(this.translate.x, this.translate.y);
  this.scale == t && this.translate.x == e && this.translate.y == i || (this.scale = t, this.translate.x = e, this.translate.y = i, this.isEventsEnabled() && this.viewStateChanged()), this.fireEvent(new mxEventObject(mxEvent.SCALE_AND_TRANSLATE, "scale", t, "previousScale", n, "translate", this.translate, "previousTranslate", s));
}, mxGraphView.prototype.getScale = function () {
  return this.scale;
}, mxGraphView.prototype.setScale = function (t) {
  var e = this.scale;
  this.scale != t && (this.scale = t, this.isEventsEnabled() && this.viewStateChanged()), this.fireEvent(new mxEventObject(mxEvent.SCALE, "scale", t, "previousScale", e));
}, mxGraphView.prototype.getTranslate = function () {
  return this.translate;
}, mxGraphView.prototype.setTranslate = function (t, e) {
  var i = new mxPoint(this.translate.x, this.translate.y);
  this.translate.x == t && this.translate.y == e || (this.translate.x = t, this.translate.y = e, this.isEventsEnabled() && this.viewStateChanged()), this.fireEvent(new mxEventObject(mxEvent.TRANSLATE, "translate", this.translate, "previousTranslate", i));
}, mxGraphView.prototype.viewStateChanged = function () {
  this.revalidate(), this.graph.sizeDidChange();
}, mxGraphView.prototype.refresh = function () {
  null != this.currentRoot && this.clear(), this.revalidate();
}, mxGraphView.prototype.revalidate = function () {
  this.invalidate(), this.validate();
}, mxGraphView.prototype.clear = function (t, e, i) {
  var n = this.graph.getModel();

  if (t = t || n.getRoot(), e = null != e && e, i = null == i || i, this.removeState(t), i && (e || t != this.currentRoot)) {
    i = n.getChildCount(t);

    for (var s = 0; s < i; s++) {
      this.clear(n.getChildAt(t, s), e);
    }
  } else this.invalidate(t);
}, mxGraphView.prototype.invalidate = function (t, e, i) {
  var n = this.graph.getModel();

  if (t = t || n.getRoot(), e = null == e || e, i = null == i || i, null != (o = this.getState(t)) && (o.invalid = !0), !t.invalidating) {
    if (t.invalidating = !0, e) for (var s = n.getChildCount(t), o = 0; o < s; o++) {
      var l = n.getChildAt(t, o);
      this.invalidate(l, e, i);
    }
    if (i) for (s = n.getEdgeCount(t), o = 0; o < s; o++) {
      this.invalidate(n.getEdgeAt(t, o), e, i);
    }
    delete t.invalidating;
  }
}, mxGraphView.prototype.validate = function (t) {
  var e = mxLog.enter("mxGraphView.validate");
  window.status = mxResources.get(this.updatingDocumentResource) || this.updatingDocumentResource, this.resetValidationState();
  var i = null;
  this.optimizeVmlReflows && null != this.canvas && null == this.textDiv && (8 == document.documentMode && !mxClient.IS_EM || mxClient.IS_QUIRKS) && (this.placeholder = document.createElement("div"), this.placeholder.style.position = "absolute", this.placeholder.style.width = this.canvas.clientWidth + "px", this.placeholder.style.height = this.canvas.clientHeight + "px", this.canvas.parentNode.appendChild(this.placeholder), i = this.drawPane.style.display, this.canvas.style.display = "none", this.textDiv = document.createElement("div"), this.textDiv.style.position = "absolute", this.textDiv.style.whiteSpace = "nowrap", this.textDiv.style.visibility = "hidden", this.textDiv.style.display = mxClient.IS_QUIRKS ? "inline" : "inline-block", this.textDiv.style.zoom = "1", document.body.appendChild(this.textDiv)), t = this.getBoundingBox(this.validateCellState(this.validateCell(t || (null != this.currentRoot ? this.currentRoot : this.graph.getModel().getRoot())))), this.setGraphBounds(null != t ? t : this.getEmptyBounds()), this.validateBackground(), null != i && (this.canvas.style.display = i, this.textDiv.parentNode.removeChild(this.textDiv), null != this.placeholder && this.placeholder.parentNode.removeChild(this.placeholder), this.textDiv = null), this.resetValidationState(), window.status = mxResources.get(this.doneResource) || this.doneResource, mxLog.leave("mxGraphView.validate", e);
}, mxGraphView.prototype.getEmptyBounds = function () {
  return new mxRectangle(this.translate.x * this.scale, this.translate.y * this.scale);
}, mxGraphView.prototype.getBoundingBox = function (t, e) {
  e = null == e || e;
  var i = null;
  if (null != t && (null != t.shape && null != t.shape.boundingBox && (i = t.shape.boundingBox.clone()), null != t.text && null != t.text.boundingBox && (null != i ? i.add(t.text.boundingBox) : i = t.text.boundingBox.clone()), e)) for (var n = this.graph.getModel(), s = n.getChildCount(t.cell), o = 0; o < s; o++) {
    var l = this.getBoundingBox(this.getState(n.getChildAt(t.cell, o)));
    null != l && (null == i ? i = l : i.add(l));
  }
  return i;
}, mxGraphView.prototype.createBackgroundPageShape = function (t) {
  return new mxRectangleShape(t, "white", "black");
}, mxGraphView.prototype.validateBackground = function () {
  this.validateBackgroundImage(), this.validateBackgroundPage();
}, mxGraphView.prototype.validateBackgroundImage = function () {
  var t = this.graph.getBackgroundImage();

  if (null != t) {
    if (null == this.backgroundImage || this.backgroundImage.image != t.src) {
      null != this.backgroundImage && this.backgroundImage.destroy();
      var e = new mxRectangle(0, 0, 1, 1);
      this.backgroundImage = new mxImageShape(e, t.src), this.backgroundImage.dialect = this.graph.dialect, this.backgroundImage.init(this.backgroundPane), this.backgroundImage.redraw(), 8 != document.documentMode || mxClient.IS_EM || mxEvent.addGestureListeners(this.backgroundImage.node, mxUtils.bind(this, function (t) {
        this.graph.fireMouseEvent(mxEvent.MOUSE_DOWN, new mxMouseEvent(t));
      }), mxUtils.bind(this, function (t) {
        this.graph.fireMouseEvent(mxEvent.MOUSE_MOVE, new mxMouseEvent(t));
      }), mxUtils.bind(this, function (t) {
        this.graph.fireMouseEvent(mxEvent.MOUSE_UP, new mxMouseEvent(t));
      }));
    }

    this.redrawBackgroundImage(this.backgroundImage, t);
  } else null != this.backgroundImage && (this.backgroundImage.destroy(), this.backgroundImage = null);
}, mxGraphView.prototype.validateBackgroundPage = function () {
  if (this.graph.pageVisible) {
    var t = this.getBackgroundPageBounds();
    null == this.backgroundPageShape ? (this.backgroundPageShape = this.createBackgroundPageShape(t), this.backgroundPageShape.scale = this.scale, this.backgroundPageShape.isShadow = !0, this.backgroundPageShape.dialect = this.graph.dialect, this.backgroundPageShape.init(this.backgroundPane), this.backgroundPageShape.redraw(), this.graph.nativeDblClickEnabled && mxEvent.addListener(this.backgroundPageShape.node, "dblclick", mxUtils.bind(this, function (t) {
      this.graph.dblClick(t);
    })), mxEvent.addGestureListeners(this.backgroundPageShape.node, mxUtils.bind(this, function (t) {
      this.graph.fireMouseEvent(mxEvent.MOUSE_DOWN, new mxMouseEvent(t));
    }), mxUtils.bind(this, function (t) {
      null != this.graph.tooltipHandler && this.graph.tooltipHandler.isHideOnHover() && this.graph.tooltipHandler.hide(), this.graph.isMouseDown && !mxEvent.isConsumed(t) && this.graph.fireMouseEvent(mxEvent.MOUSE_MOVE, new mxMouseEvent(t));
    }), mxUtils.bind(this, function (t) {
      this.graph.fireMouseEvent(mxEvent.MOUSE_UP, new mxMouseEvent(t));
    }))) : (this.backgroundPageShape.scale = this.scale, this.backgroundPageShape.bounds = t, this.backgroundPageShape.redraw());
  } else null != this.backgroundPageShape && (this.backgroundPageShape.destroy(), this.backgroundPageShape = null);
}, mxGraphView.prototype.getBackgroundPageBounds = function () {
  var t = this.graph.pageFormat,
      e = this.scale * this.graph.pageScale;
  return new mxRectangle(this.scale * this.translate.x, this.scale * this.translate.y, t.width * e, t.height * e);
}, mxGraphView.prototype.redrawBackgroundImage = function (t, e) {
  t.scale = this.scale, t.bounds.x = this.scale * this.translate.x, t.bounds.y = this.scale * this.translate.y, t.bounds.width = this.scale * e.width, t.bounds.height = this.scale * e.height, t.redraw();
}, mxGraphView.prototype.validateCell = function (t, e) {
  if (null != t) if (e = (null == e || e) && this.graph.isCellVisible(t), null == this.getState(t, e) || e) for (var i = this.graph.getModel(), n = i.getChildCount(t), s = 0; s < n; s++) {
    this.validateCell(i.getChildAt(t, s), e && (!this.isCellCollapsed(t) || t == this.currentRoot));
  } else this.removeState(t);
  return t;
}, mxGraphView.prototype.validateCellState = function (t, e) {
  e = null == e || e;
  var i = null;

  if (null != t && null != (i = this.getState(t))) {
    var n = this.graph.getModel();

    if (i.invalid && (i.invalid = !1, null == i.style && (i.style = this.graph.getCellStyle(i.cell)), t != this.currentRoot && this.validateCellState(n.getParent(t), !1), i.setVisibleTerminalState(this.validateCellState(this.getVisibleTerminal(t, !0), !1), !0), i.setVisibleTerminalState(this.validateCellState(this.getVisibleTerminal(t, !1), !1), !1), this.updateCellState(i), t == this.currentRoot || i.invalid || (this.graph.cellRenderer.redraw(i, !1, this.isRendering()), i.updateCachedBounds())), e && !i.invalid) {
      null != i.shape && this.stateValidated(i);

      for (var s = n.getChildCount(t), o = 0; o < s; o++) {
        this.validateCellState(n.getChildAt(t, o));
      }
    }
  }

  return i;
}, mxGraphView.prototype.updateCellState = function (t) {
  if (t.absoluteOffset.x = 0, t.absoluteOffset.y = 0, t.origin.x = 0, t.origin.y = 0, t.length = 0, t.cell != this.currentRoot) {
    var e = this.graph.getModel(),
        i = this.getState(e.getParent(t.cell));
    null != i && i.cell != this.currentRoot && (t.origin.x += i.origin.x, t.origin.y += i.origin.y);
    var n = this.graph.getChildOffsetForCell(t.cell);
    null != n && (t.origin.x += n.x, t.origin.y += n.y);
    var s = this.graph.getCellGeometry(t.cell);
    null != s && (e.isEdge(t.cell) || (n = s.offset || this.EMPTY_POINT, s.relative && null != i ? e.isEdge(i.cell) ? null != (n = this.getPoint(i, s)) && (t.origin.x += n.x / this.scale - i.origin.x - this.translate.x, t.origin.y += n.y / this.scale - i.origin.y - this.translate.y) : (t.origin.x += s.x * i.width / this.scale + n.x, t.origin.y += s.y * i.height / this.scale + n.y) : (t.absoluteOffset.x = this.scale * n.x, t.absoluteOffset.y = this.scale * n.y, t.origin.x += s.x, t.origin.y += s.y)), t.x = this.scale * (this.translate.x + t.origin.x), t.y = this.scale * (this.translate.y + t.origin.y), t.width = this.scale * s.width, t.unscaledWidth = s.width, t.height = this.scale * s.height, e.isVertex(t.cell) && this.updateVertexState(t, s), e.isEdge(t.cell) && this.updateEdgeState(t, s));
  }

  t.updateCachedBounds();
}, mxGraphView.prototype.isCellCollapsed = function (t) {
  return this.graph.isCellCollapsed(t);
}, mxGraphView.prototype.updateVertexState = function (t, e) {
  var i = this.graph.getModel(),
      n = this.getState(i.getParent(t.cell));

  if (e.relative && null != n && !i.isEdge(n.cell) && 0 != (s = mxUtils.toRadians(n.style[mxConstants.STYLE_ROTATION] || "0"))) {
    i = Math.cos(s);
    var s = Math.sin(s),
        o = new mxPoint(t.getCenterX(), t.getCenterY());
    n = new mxPoint(n.getCenterX(), n.getCenterY()), n = mxUtils.getRotatedPoint(o, i, s, n);
    t.x = n.x - t.width / 2, t.y = n.y - t.height / 2;
  }

  this.updateVertexLabelOffset(t);
}, mxGraphView.prototype.updateEdgeState = function (t, e) {
  var i = t.getVisibleTerminalState(!0),
      n = t.getVisibleTerminalState(!1);
  null != this.graph.model.getTerminal(t.cell, !0) && null == i || null == i && null == e.getTerminalPoint(!0) || null != this.graph.model.getTerminal(t.cell, !1) && null == n || null == n && null == e.getTerminalPoint(!1) ? this.clear(t.cell, !0) : (this.updateFixedTerminalPoints(t, i, n), this.updatePoints(t, e.points, i, n), this.updateFloatingTerminalPoints(t, i, n), i = t.absolutePoints, t.cell != this.currentRoot && (null == i || 2 > i.length || null == i[0] || null == i[i.length - 1]) ? this.clear(t.cell, !0) : (this.updateEdgeBounds(t), this.updateEdgeLabelOffset(t)));
}, mxGraphView.prototype.updateVertexLabelOffset = function (t) {
  var e = mxUtils.getValue(t.style, mxConstants.STYLE_LABEL_POSITION, mxConstants.ALIGN_CENTER);
  if (e == mxConstants.ALIGN_LEFT) e = null != (e = mxUtils.getValue(t.style, mxConstants.STYLE_LABEL_WIDTH, null)) ? e * this.scale : t.width, t.absoluteOffset.x -= e;else if (e == mxConstants.ALIGN_RIGHT) t.absoluteOffset.x += t.width;else if (e == mxConstants.ALIGN_CENTER && null != (e = mxUtils.getValue(t.style, mxConstants.STYLE_LABEL_WIDTH, null))) {
    var i = mxUtils.getValue(t.style, mxConstants.STYLE_ALIGN, mxConstants.ALIGN_CENTER),
        n = 0;
    i == mxConstants.ALIGN_CENTER ? n = .5 : i == mxConstants.ALIGN_RIGHT && (n = 1), 0 != n && (t.absoluteOffset.x -= (e * this.scale - t.width) * n);
  }
  (e = mxUtils.getValue(t.style, mxConstants.STYLE_VERTICAL_LABEL_POSITION, mxConstants.ALIGN_MIDDLE)) == mxConstants.ALIGN_TOP ? t.absoluteOffset.y -= t.height : e == mxConstants.ALIGN_BOTTOM && (t.absoluteOffset.y += t.height);
}, mxGraphView.prototype.resetValidationState = function () {
  this.lastForegroundHtmlNode = this.lastForegroundNode = this.lastHtmlNode = this.lastNode = null;
}, mxGraphView.prototype.stateValidated = function (t) {
  var e = this.graph.getModel().isEdge(t.cell) && this.graph.keepEdgesInForeground || this.graph.getModel().isVertex(t.cell) && this.graph.keepEdgesInBackground;
  t = this.graph.cellRenderer.insertStateAfter(t, e && this.lastForegroundNode || this.lastNode, e && this.lastForegroundHtmlNode || this.lastHtmlNode), e ? (this.lastForegroundHtmlNode = t[1], this.lastForegroundNode = t[0]) : (this.lastHtmlNode = t[1], this.lastNode = t[0]);
}, mxGraphView.prototype.updateFixedTerminalPoints = function (t, e, i) {
  this.updateFixedTerminalPoint(t, e, !0, this.graph.getConnectionConstraint(t, e, !0)), this.updateFixedTerminalPoint(t, i, !1, this.graph.getConnectionConstraint(t, i, !1));
}, mxGraphView.prototype.updateFixedTerminalPoint = function (t, e, i, n) {
  t.setAbsoluteTerminalPoint(this.getFixedTerminalPoint(t, e, i, n), i);
}, mxGraphView.prototype.getFixedTerminalPoint = function (t, e, i, n) {
  var s = null;

  if (null != n && (s = this.graph.getConnectionPoint(e, n)), null == s && null == e) {
    e = this.scale, n = this.translate;
    var o = t.origin;
    null != (s = this.graph.getCellGeometry(t.cell).getTerminalPoint(i)) && (s = new mxPoint(e * (n.x + s.x + o.x), e * (n.y + s.y + o.y)));
  }

  return s;
}, mxGraphView.prototype.updateBoundsFromStencil = function (t) {
  var e = null;

  if (null != t && null != t.shape && null != t.shape.stencil && "fixed" == t.shape.stencil.aspect) {
    e = mxRectangle.fromRectangle(t);
    var i = t.shape.stencil.computeAspect(t.style, t.x, t.y, t.width, t.height);
    t.setRect(i.x, i.y, t.shape.stencil.w0 * i.width, t.shape.stencil.h0 * i.height);
  }

  return e;
}, mxGraphView.prototype.updatePoints = function (t, e, i, n) {
  if (null != t) {
    var s = [];
    s.push(t.absolutePoints[0]);
    var o = this.getEdgeStyle(t, e, i, n);

    if (null != o) {
      i = this.getTerminalPort(t, i, !0), n = this.getTerminalPort(t, n, !1);
      var l = this.updateBoundsFromStencil(i),
          r = this.updateBoundsFromStencil(n);
      o(t, i, n, e, s), null != l && i.setRect(l.x, l.y, l.width, l.height), null != r && n.setRect(r.x, r.y, r.width, r.height);
    } else if (null != e) for (o = 0; o < e.length; o++) {
      null != e[o] && (i = mxUtils.clone(e[o]), s.push(this.transformControlPoint(t, i)));
    }

    e = t.absolutePoints, s.push(e[e.length - 1]), t.absolutePoints = s;
  }
}, mxGraphView.prototype.transformControlPoint = function (t, e) {
  if (null != t && null != e) {
    var i = t.origin;
    return new mxPoint(this.scale * (e.x + this.translate.x + i.x), this.scale * (e.y + this.translate.y + i.y));
  }

  return null;
}, mxGraphView.prototype.isLoopStyleEnabled = function (t, e, i, n) {
  var s = this.graph.getConnectionConstraint(t, i, !0),
      o = this.graph.getConnectionConstraint(t, n, !1);
  return !(!(null == e || 2 > e.length) || mxUtils.getValue(t.style, mxConstants.STYLE_ORTHOGONAL_LOOP, !1) && (null != s && null != s.point || null != o && null != o.point)) && null != i && i == n;
}, mxGraphView.prototype.getEdgeStyle = function (t, e, i, n) {
  return "string" == typeof (t = this.isLoopStyleEnabled(t, e, i, n) ? mxUtils.getValue(t.style, mxConstants.STYLE_LOOP, this.graph.defaultLoopStyle) : mxUtils.getValue(t.style, mxConstants.STYLE_NOEDGESTYLE, !1) ? null : t.style[mxConstants.STYLE_EDGE]) && (null == (e = mxStyleRegistry.getValue(t)) && this.isAllowEval() && (e = mxUtils.eval(t)), t = e), "function" == typeof t ? t : null;
}, mxGraphView.prototype.updateFloatingTerminalPoints = function (t, e, i) {
  var n = t.absolutePoints,
      s = n[0];
  null == n[n.length - 1] && null != i && this.updateFloatingTerminalPoint(t, i, e, !1), null == s && null != e && this.updateFloatingTerminalPoint(t, e, i, !0);
}, mxGraphView.prototype.updateFloatingTerminalPoint = function (t, e, i, n) {
  t.setAbsoluteTerminalPoint(this.getFloatingTerminalPoint(t, e, i, n), n);
}, mxGraphView.prototype.getFloatingTerminalPoint = function (t, e, i, n) {
  e = this.getTerminalPort(t, e, n);
  var s = this.getNextPoint(t, i, n),
      o = this.graph.isOrthogonal(t);
  i = mxUtils.toRadians(Number(e.style[mxConstants.STYLE_ROTATION] || "0"));
  var l = new mxPoint(e.getCenterX(), e.getCenterY());

  if (0 != i) {
    var r = Math.cos(-i),
        a = Math.sin(-i);
    s = mxUtils.getRotatedPoint(s, r, a, l);
  }

  return r = parseFloat(t.style[mxConstants.STYLE_PERIMETER_SPACING] || 0), r += parseFloat(t.style[n ? mxConstants.STYLE_SOURCE_PERIMETER_SPACING : mxConstants.STYLE_TARGET_PERIMETER_SPACING] || 0), t = this.getPerimeterPoint(e, s, 0 == i && o, r), 0 != i && (r = Math.cos(i), a = Math.sin(i), t = mxUtils.getRotatedPoint(t, r, a, l)), t;
}, mxGraphView.prototype.getTerminalPort = function (t, e, i) {
  return null != (t = mxUtils.getValue(t.style, i ? mxConstants.STYLE_SOURCE_PORT : mxConstants.STYLE_TARGET_PORT)) && null != (t = this.getState(this.graph.getModel().getCell(t))) && (e = t), e;
}, mxGraphView.prototype.getPerimeterPoint = function (t, e, i, n) {
  var s = null;

  if (null != t) {
    var o = this.getPerimeterFunction(t);

    if (null != o && null != e && (0 < (n = this.getPerimeterBounds(t, n)).width || 0 < n.height)) {
      s = new mxPoint(e.x, e.y);
      var l = e = !1;
      this.graph.model.isVertex(t.cell) && (e = 1 == mxUtils.getValue(t.style, mxConstants.STYLE_FLIPH, 0), l = 1 == mxUtils.getValue(t.style, mxConstants.STYLE_FLIPV, 0), null != t.shape && null != t.shape.stencil && (e = 1 == mxUtils.getValue(t.style, "stencilFlipH", 0) || e, l = 1 == mxUtils.getValue(t.style, "stencilFlipV", 0) || l), e && (s.x = 2 * n.getCenterX() - s.x), l && (s.y = 2 * n.getCenterY() - s.y)), null != (s = o(n, t, s, i)) && (e && (s.x = 2 * n.getCenterX() - s.x), l && (s.y = 2 * n.getCenterY() - s.y));
    }

    null == s && (s = this.getPoint(t));
  }

  return s;
}, mxGraphView.prototype.getRoutingCenterX = function (t) {
  var e = null != t.style && parseFloat(t.style[mxConstants.STYLE_ROUTING_CENTER_X]) || 0;
  return t.getCenterX() + e * t.width;
}, mxGraphView.prototype.getRoutingCenterY = function (t) {
  var e = null != t.style && parseFloat(t.style[mxConstants.STYLE_ROUTING_CENTER_Y]) || 0;
  return t.getCenterY() + e * t.height;
}, mxGraphView.prototype.getPerimeterBounds = function (t, e) {
  return e = null != e ? e : 0, null != t && (e += parseFloat(t.style[mxConstants.STYLE_PERIMETER_SPACING] || 0)), t.getPerimeterBounds(e * this.scale);
}, mxGraphView.prototype.getPerimeterFunction = function (t) {
  if ("string" == typeof (t = t.style[mxConstants.STYLE_PERIMETER])) {
    var e = mxStyleRegistry.getValue(t);
    null == e && this.isAllowEval() && (e = mxUtils.eval(t)), t = e;
  }

  return "function" == typeof t ? t : null;
}, mxGraphView.prototype.getNextPoint = function (t, e, i) {
  var n = null;
  return null != (t = t.absolutePoints) && 2 <= t.length && (n = t.length, n = t[i ? Math.min(1, n - 1) : Math.max(0, n - 2)]), null == n && null != e && (n = new mxPoint(e.getCenterX(), e.getCenterY())), n;
}, mxGraphView.prototype.getVisibleTerminal = function (t, e) {
  for (var i = this.graph.getModel(), n = i.getTerminal(t, e), s = n; null != n && n != this.currentRoot;) {
    this.graph.isCellVisible(s) && !this.isCellCollapsed(n) || (s = n), n = i.getParent(n);
  }

  return i.getParent(s) == i.getRoot() && (s = null), s;
}, mxGraphView.prototype.updateEdgeBounds = function (t) {
  var e = t.absolutePoints,
      i = e[0],
      n = e[e.length - 1];

  if (i.x != n.x || i.y != n.y) {
    var s = n.x - i.x,
        o = n.y - i.y;
    t.terminalDistance = Math.sqrt(s * s + o * o);
  } else t.terminalDistance = 0;

  n = 0;
  var l = [];

  if (null != (o = i)) {
    i = o.x;

    for (var r = o.y, a = i, h = r, u = 1; u < e.length; u++) {
      var d = e[u];
      null != d && (s = o.x - d.x, o = o.y - d.y, s = Math.sqrt(s * s + o * o), l.push(s), n += s, o = d, i = Math.min(o.x, i), r = Math.min(o.y, r), a = Math.max(o.x, a), h = Math.max(o.y, h));
    }

    t.length = n, t.segments = l, t.x = i, t.y = r, t.width = Math.max(1, a - i), t.height = Math.max(1, h - r);
  }
}, mxGraphView.prototype.getPoint = function (t, e) {
  var i = t.getCenterX(),
      n = t.getCenterY();
  if (null == t.segments || null != e && !e.relative) null != e && null != (h = e.offset) && (i += h.x, n += h.y);else {
    for (var s = t.absolutePoints.length, o = Math.round((.5 + (null != e ? e.x / 2 : 0)) * t.length), l = t.segments[0], r = 0, a = 1; o >= Math.round(r + l) && a < s - 1;) {
      r += l, l = t.segments[a++];
    }

    if (s = 0 == l ? 0 : (o - r) / l, o = t.absolutePoints[a - 1], a = t.absolutePoints[a], null != o && null != a) {
      if (r = i = n = 0, null != e) {
        n = e.y;
        var h = e.offset;
        null != h && (i = h.x, r = h.y);
      }

      h = a.x - o.x, a = a.y - o.y, i = o.x + h * s + ((0 == l ? 0 : a / l) * n + i) * this.scale, n = o.y + a * s - ((0 == l ? 0 : h / l) * n - r) * this.scale;
    }
  }
  return new mxPoint(i, n);
}, mxGraphView.prototype.getRelativePoint = function (t, e, i) {
  if (null != (s = this.graph.getModel().getGeometry(t.cell))) {
    var n = t.absolutePoints.length;

    if (s.relative && 1 < n) {
      for (var s = t.length, o = t.segments, l = t.absolutePoints[0], r = t.absolutePoints[1], a = mxUtils.ptSegDistSq(l.x, l.y, r.x, r.y, e, i), h = 0, u = 0, d = 0, p = 2; p < n; p++) {
        u += o[p - 2], r = t.absolutePoints[p], (l = mxUtils.ptSegDistSq(l.x, l.y, r.x, r.y, e, i)) <= a && (a = l, h = p - 1, d = u), l = r;
      }

      return n = o[h], l = t.absolutePoints[h], a = (r = t.absolutePoints[h + 1]).x, o = r.y, o = (a = (t = l.x - a) - (e - a)) * t + (o = (h = l.y - o) - (i - o)) * h, (t = Math.sqrt(0 >= o ? 0 : o * o / (t * t + h * h))) > n && (t = n), n = Math.sqrt(mxUtils.ptSegDistSq(l.x, l.y, r.x, r.y, e, i)), -1 == mxUtils.relativeCcw(l.x, l.y, r.x, r.y, e, i) && (n = -n), new mxPoint((s / 2 - d - t) / s * -2, n / this.scale);
    }
  }

  return new mxPoint();
}, mxGraphView.prototype.updateEdgeLabelOffset = function (t) {
  var e = t.absolutePoints;
  if (t.absoluteOffset.x = t.getCenterX(), t.absoluteOffset.y = t.getCenterY(), null != e && 0 < e.length && null != t.segments) if ((s = this.graph.getCellGeometry(t.cell)).relative) {
    null != (i = this.getPoint(t, s)) && (t.absoluteOffset = i);
  } else {
    var i = e[0],
        n = e[e.length - 1];

    if (null != i && null != n) {
      e = n.x - i.x;
      var s,
          o = n.y - i.y,
          l = n = 0;
      null != (s = s.offset) && (n = s.x, l = s.y), s = i.y + o / 2 + l * this.scale, t.absoluteOffset.x = i.x + e / 2 + n * this.scale, t.absoluteOffset.y = s;
    }
  }
}, mxGraphView.prototype.getState = function (t, e) {
  e = e || !1;
  var i = null;
  return null != t && (i = this.states.get(t), e && (null == i || this.updateStyle) && this.graph.isCellVisible(t) && (null == i ? (i = this.createState(t), this.states.put(t, i)) : i.style = this.graph.getCellStyle(t))), i;
}, mxGraphView.prototype.isRendering = function () {
  return this.rendering;
}, mxGraphView.prototype.setRendering = function (t) {
  this.rendering = t;
}, mxGraphView.prototype.isAllowEval = function () {
  return this.allowEval;
}, mxGraphView.prototype.setAllowEval = function (t) {
  this.allowEval = t;
}, mxGraphView.prototype.getStates = function () {
  return this.states;
}, mxGraphView.prototype.setStates = function (t) {
  this.states = t;
}, mxGraphView.prototype.getCellStates = function (t) {
  if (null == t) return this.states;

  for (var e = [], i = 0; i < t.length; i++) {
    var n = this.getState(t[i]);
    null != n && e.push(n);
  }

  return e;
}, mxGraphView.prototype.removeState = function (t) {
  var e = null;
  return null != t && null != (e = this.states.remove(t)) && (this.graph.cellRenderer.destroy(e), e.invalid = !0, e.destroy()), e;
}, mxGraphView.prototype.createState = function (t) {
  return new mxCellState(this, t, this.graph.getCellStyle(t));
}, mxGraphView.prototype.getCanvas = function () {
  return this.canvas;
}, mxGraphView.prototype.getBackgroundPane = function () {
  return this.backgroundPane;
}, mxGraphView.prototype.getDrawPane = function () {
  return this.drawPane;
}, mxGraphView.prototype.getOverlayPane = function () {
  return this.overlayPane;
}, mxGraphView.prototype.getDecoratorPane = function () {
  return this.decoratorPane;
}, mxGraphView.prototype.isContainerEvent = function (t) {
  return (t = mxEvent.getSource(t)) == this.graph.container || t.parentNode == this.backgroundPane || null != t.parentNode && t.parentNode.parentNode == this.backgroundPane || t == this.canvas.parentNode || t == this.canvas || t == this.backgroundPane || t == this.drawPane || t == this.overlayPane || t == this.decoratorPane;
}, mxGraphView.prototype.isScrollEvent = function (t) {
  var e = mxUtils.getOffset(this.graph.container);
  t = new mxPoint(t.clientX - e.x, t.clientY - e.y);
  e = this.graph.container.offsetWidth;
  var i = this.graph.container.clientWidth;
  return e > i && t.x > i + 2 && t.x <= e || (e = this.graph.container.offsetHeight) > (i = this.graph.container.clientHeight) && t.y > i + 2 && t.y <= e;
}, mxGraphView.prototype.init = function () {
  this.installListeners();
  var t = this.graph;
  t.dialect == mxConstants.DIALECT_SVG ? this.createSvg() : t.dialect == mxConstants.DIALECT_VML ? this.createVml() : this.createHtml();
}, mxGraphView.prototype.installListeners = function () {
  var t = this.graph,
      e = t.container;

  if (null != e) {
    mxClient.IS_TOUCH && (mxEvent.addListener(e, "gesturestart", mxUtils.bind(this, function (e) {
      t.fireGestureEvent(e), mxEvent.consume(e);
    })), mxEvent.addListener(e, "gesturechange", mxUtils.bind(this, function (e) {
      t.fireGestureEvent(e), mxEvent.consume(e);
    })), mxEvent.addListener(e, "gestureend", mxUtils.bind(this, function (e) {
      t.fireGestureEvent(e), mxEvent.consume(e);
    }))), mxEvent.addGestureListeners(e, mxUtils.bind(this, function (e) {
      !this.isContainerEvent(e) || (mxClient.IS_IE || mxClient.IS_IE11 || mxClient.IS_GC || mxClient.IS_OP || mxClient.IS_SF) && this.isScrollEvent(e) || t.fireMouseEvent(mxEvent.MOUSE_DOWN, new mxMouseEvent(e));
    }), mxUtils.bind(this, function (e) {
      this.isContainerEvent(e) && t.fireMouseEvent(mxEvent.MOUSE_MOVE, new mxMouseEvent(e));
    }), mxUtils.bind(this, function (e) {
      this.isContainerEvent(e) && t.fireMouseEvent(mxEvent.MOUSE_UP, new mxMouseEvent(e));
    })), mxEvent.addListener(e, "dblclick", mxUtils.bind(this, function (e) {
      this.isContainerEvent(e) && t.dblClick(e);
    }));

    var i = function i(_i2) {
      var n = null;
      return mxClient.IS_TOUCH && (n = mxEvent.getClientX(_i2), _i2 = mxEvent.getClientY(_i2), _i2 = mxUtils.convertPoint(e, n, _i2), n = t.view.getState(t.getCellAt(_i2.x, _i2.y))), n;
    };

    t.addMouseListener({
      mouseDown: function mouseDown(e, i) {
        t.popupMenuHandler.hideMenu();
      },
      mouseMove: function mouseMove() {},
      mouseUp: function mouseUp() {}
    }), this.moveHandler = mxUtils.bind(this, function (e) {
      null != t.tooltipHandler && t.tooltipHandler.isHideOnHover() && t.tooltipHandler.hide(), this.captureDocumentGesture && t.isMouseDown && null != t.container && !this.isContainerEvent(e) && "none" != t.container.style.display && "hidden" != t.container.style.visibility && !mxEvent.isConsumed(e) && t.fireMouseEvent(mxEvent.MOUSE_MOVE, new mxMouseEvent(e, i(e)));
    }), this.endHandler = mxUtils.bind(this, function (e) {
      this.captureDocumentGesture && t.isMouseDown && null != t.container && !this.isContainerEvent(e) && "none" != t.container.style.display && "hidden" != t.container.style.visibility && t.fireMouseEvent(mxEvent.MOUSE_UP, new mxMouseEvent(e));
    }), mxEvent.addGestureListeners(document, null, this.moveHandler, this.endHandler);
  }
}, mxGraphView.prototype.createHtml = function () {
  var t = this.graph.container;
  null != t && (this.canvas = this.createHtmlPane("100%", "100%"), this.canvas.style.overflow = "hidden", this.backgroundPane = this.createHtmlPane("1px", "1px"), this.drawPane = this.createHtmlPane("1px", "1px"), this.overlayPane = this.createHtmlPane("1px", "1px"), this.decoratorPane = this.createHtmlPane("1px", "1px"), this.canvas.appendChild(this.backgroundPane), this.canvas.appendChild(this.drawPane), this.canvas.appendChild(this.overlayPane), this.canvas.appendChild(this.decoratorPane), t.appendChild(this.canvas), this.updateContainerStyle(t), mxClient.IS_QUIRKS && (t = mxUtils.bind(this, function (t) {
    t = this.getGraphBounds(), this.updateHtmlCanvasSize(t.x + t.width + this.graph.border, t.y + t.height + this.graph.border);
  }), mxEvent.addListener(window, "resize", t)));
}, mxGraphView.prototype.updateHtmlCanvasSize = function (t, e) {
  if (null != this.graph.container) {
    var i = this.graph.container.offsetHeight;
    this.canvas.style.width = this.graph.container.offsetWidth < t ? t + "px" : "100%", this.canvas.style.height = i < e ? e + "px" : "100%";
  }
}, mxGraphView.prototype.createHtmlPane = function (t, e) {
  var i = document.createElement("DIV");
  return null != t && null != e ? (i.style.position = "absolute", i.style.left = "0px", i.style.top = "0px", i.style.width = t, i.style.height = e) : i.style.position = "relative", i;
}, mxGraphView.prototype.createVml = function () {
  var t = this.graph.container;

  if (null != t) {
    var e = t.offsetWidth,
        i = t.offsetHeight;
    this.canvas = this.createVmlPane(e, i), this.canvas.style.overflow = "hidden", this.backgroundPane = this.createVmlPane(e, i), this.drawPane = this.createVmlPane(e, i), this.overlayPane = this.createVmlPane(e, i), this.decoratorPane = this.createVmlPane(e, i), this.canvas.appendChild(this.backgroundPane), this.canvas.appendChild(this.drawPane), this.canvas.appendChild(this.overlayPane), this.canvas.appendChild(this.decoratorPane), t.appendChild(this.canvas);
  }
}, mxGraphView.prototype.createVmlPane = function (t, e) {
  var i = document.createElement(mxClient.VML_PREFIX + ":group");
  return i.style.position = "absolute", i.style.left = "0px", i.style.top = "0px", i.style.width = t + "px", i.style.height = e + "px", i.setAttribute("coordsize", t + "," + e), i.setAttribute("coordorigin", "0,0"), i;
}, mxGraphView.prototype.createSvg = function () {
  var t = this.graph.container;
  this.canvas = document.createElementNS(mxConstants.NS_SVG, "g"), this.backgroundPane = document.createElementNS(mxConstants.NS_SVG, "g"), this.canvas.appendChild(this.backgroundPane), this.drawPane = document.createElementNS(mxConstants.NS_SVG, "g"), this.canvas.appendChild(this.drawPane), this.overlayPane = document.createElementNS(mxConstants.NS_SVG, "g"), this.canvas.appendChild(this.overlayPane), this.decoratorPane = document.createElementNS(mxConstants.NS_SVG, "g"), this.canvas.appendChild(this.decoratorPane);
  var e = document.createElementNS(mxConstants.NS_SVG, "svg");
  e.style.left = "0px", e.style.top = "0px", e.style.width = "100%", e.style.height = "100%", e.style.display = "block", e.appendChild(this.canvas), (mxClient.IS_IE || mxClient.IS_IE11) && (e.style.overflow = "hidden"), null != t && (t.appendChild(e), this.updateContainerStyle(t));
}, mxGraphView.prototype.updateContainerStyle = function (t) {
  var e = mxUtils.getCurrentStyle(t);
  null != e && "static" == e.position && (t.style.position = "relative"), mxClient.IS_POINTER && (t.style.touchAction = "none");
}, mxGraphView.prototype.destroy = function () {
  var t = null != this.canvas ? this.canvas.ownerSVGElement : null;
  null == t && (t = this.canvas), null != t && null != t.parentNode && (this.clear(this.currentRoot, !0), mxEvent.removeGestureListeners(document, null, this.moveHandler, this.endHandler), mxEvent.release(this.graph.container), t.parentNode.removeChild(t), this.decoratorPane = this.overlayPane = this.drawPane = this.backgroundPane = this.canvas = this.endHandler = this.moveHandler = null);
}, mxCurrentRootChange.prototype.execute = function () {
  var t = this.view.currentRoot;
  this.view.currentRoot = this.previous, this.previous = t, null != (t = this.view.graph.getTranslateForRoot(this.view.currentRoot)) && (this.view.translate = new mxPoint(-t.x, -t.y)), this.isUp ? (this.view.clear(this.view.currentRoot, !0), this.view.validate()) : this.view.refresh(), this.view.fireEvent(new mxEventObject(this.isUp ? mxEvent.UP : mxEvent.DOWN, "root", this.view.currentRoot, "previous", this.previous)), this.isUp = !this.isUp;
}, mxLoadResources ? mxResources.add(mxClient.basePath + "/resources/graph") : mxClient.defaultBundles.push(mxClient.basePath + "/resources/graph"), mxGraph.prototype = new mxEventSource(), mxGraph.prototype.constructor = mxGraph, mxGraph.prototype.EMPTY_ARRAY = [], mxGraph.prototype.mouseListeners = null, mxGraph.prototype.isMouseDown = !1, mxGraph.prototype.model = null, mxGraph.prototype.view = null, mxGraph.prototype.stylesheet = null, mxGraph.prototype.selectionModel = null, mxGraph.prototype.cellEditor = null, mxGraph.prototype.cellRenderer = null, mxGraph.prototype.multiplicities = null, mxGraph.prototype.renderHint = null, mxGraph.prototype.dialect = null, mxGraph.prototype.gridSize = 10, mxGraph.prototype.gridEnabled = !0, mxGraph.prototype.portsEnabled = !0, mxGraph.prototype.nativeDblClickEnabled = !0, mxGraph.prototype.doubleTapEnabled = !0, mxGraph.prototype.doubleTapTimeout = 500, mxGraph.prototype.doubleTapTolerance = 25, mxGraph.prototype.lastTouchY = 0, mxGraph.prototype.lastTouchY = 0, mxGraph.prototype.lastTouchTime = 0, mxGraph.prototype.tapAndHoldEnabled = !0, mxGraph.prototype.tapAndHoldDelay = 500, mxGraph.prototype.tapAndHoldInProgress = !1, mxGraph.prototype.tapAndHoldValid = !1, mxGraph.prototype.initialTouchX = 0, mxGraph.prototype.initialTouchY = 0, mxGraph.prototype.tolerance = 4, mxGraph.prototype.defaultOverlap = .5, mxGraph.prototype.defaultParent = null, mxGraph.prototype.alternateEdgeStyle = null, mxGraph.prototype.backgroundImage = null, mxGraph.prototype.pageVisible = !1, mxGraph.prototype.pageBreaksVisible = !1, mxGraph.prototype.pageBreakColor = "gray", mxGraph.prototype.pageBreakDashed = !0, mxGraph.prototype.minPageBreakDist = 20, mxGraph.prototype.preferPageSize = !1, mxGraph.prototype.pageFormat = mxConstants.PAGE_FORMAT_A4_PORTRAIT, mxGraph.prototype.pageScale = 1.5, mxGraph.prototype.enabled = !0, mxGraph.prototype.escapeEnabled = !0, mxGraph.prototype.invokesStopCellEditing = !0, mxGraph.prototype.enterStopsCellEditing = !1, mxGraph.prototype.useScrollbarsForPanning = !0, mxGraph.prototype.exportEnabled = !0, mxGraph.prototype.importEnabled = !0, mxGraph.prototype.cellsLocked = !1, mxGraph.prototype.cellsCloneable = !0, mxGraph.prototype.foldingEnabled = !0, mxGraph.prototype.cellsEditable = !0, mxGraph.prototype.cellsDeletable = !0, mxGraph.prototype.cellsMovable = !0, mxGraph.prototype.edgeLabelsMovable = !0, mxGraph.prototype.vertexLabelsMovable = !1, mxGraph.prototype.dropEnabled = !1, mxGraph.prototype.splitEnabled = !0, mxGraph.prototype.cellsResizable = !0, mxGraph.prototype.cellsBendable = !0, mxGraph.prototype.cellsSelectable = !0, mxGraph.prototype.cellsDisconnectable = !0, mxGraph.prototype.autoSizeCells = !1, mxGraph.prototype.autoSizeCellsOnAdd = !1, mxGraph.prototype.autoScroll = !0, mxGraph.prototype.ignoreScrollbars = !1, mxGraph.prototype.translateToScrollPosition = !1, mxGraph.prototype.timerAutoScroll = !1, mxGraph.prototype.allowAutoPanning = !1, mxGraph.prototype.autoExtend = !0, mxGraph.prototype.maximumGraphBounds = null, mxGraph.prototype.minimumGraphSize = null, mxGraph.prototype.minimumContainerSize = null, mxGraph.prototype.maximumContainerSize = null, mxGraph.prototype.resizeContainer = !1, mxGraph.prototype.border = 0, mxGraph.prototype.keepEdgesInForeground = !1, mxGraph.prototype.keepEdgesInBackground = !1, mxGraph.prototype.allowNegativeCoordinates = !0, mxGraph.prototype.constrainChildren = !0, mxGraph.prototype.constrainRelativeChildren = !1, mxGraph.prototype.extendParents = !0, mxGraph.prototype.extendParentsOnAdd = !0, mxGraph.prototype.extendParentsOnMove = !1, mxGraph.prototype.recursiveResize = !1, mxGraph.prototype.collapseToPreferredSize = !0, mxGraph.prototype.zoomFactor = 1.2, mxGraph.prototype.keepSelectionVisibleOnZoom = !1, mxGraph.prototype.centerZoom = !0, mxGraph.prototype.resetViewOnRootChange = !0, mxGraph.prototype.resetEdgesOnResize = !1, mxGraph.prototype.resetEdgesOnMove = !1, mxGraph.prototype.resetEdgesOnConnect = !0, mxGraph.prototype.allowLoops = !1, mxGraph.prototype.defaultLoopStyle = mxEdgeStyle.Loop, mxGraph.prototype.multigraph = !0, mxGraph.prototype.connectableEdges = !1, mxGraph.prototype.allowDanglingEdges = !0, mxGraph.prototype.cloneInvalidEdges = !1, mxGraph.prototype.disconnectOnMove = !0, mxGraph.prototype.labelsVisible = !0, mxGraph.prototype.htmlLabels = !1, mxGraph.prototype.swimlaneSelectionEnabled = !0, mxGraph.prototype.swimlaneNesting = !0, mxGraph.prototype.swimlaneIndicatorColorAttribute = mxConstants.STYLE_FILLCOLOR, mxGraph.prototype.imageBundles = null, mxGraph.prototype.minFitScale = .1, mxGraph.prototype.maxFitScale = 8, mxGraph.prototype.panDx = 0, mxGraph.prototype.panDy = 0, mxGraph.prototype.collapsedImage = new mxImage(mxClient.imageBasePath + "/collapsed.gif", 9, 9), mxGraph.prototype.expandedImage = new mxImage(mxClient.imageBasePath + "/expanded.gif", 9, 9), mxGraph.prototype.warningImage = new mxImage(mxClient.imageBasePath + "/warning" + (mxClient.IS_MAC ? ".png" : ".gif"), 16, 16), mxGraph.prototype.alreadyConnectedResource = "none" != mxClient.language ? "alreadyConnected" : "", mxGraph.prototype.containsValidationErrorsResource = "none" != mxClient.language ? "containsValidationErrors" : "", mxGraph.prototype.collapseExpandResource = "none" != mxClient.language ? "collapse-expand" : "", mxGraph.prototype.init = function (t) {
  this.container = t, this.cellEditor = this.createCellEditor(), this.view.init(), this.sizeDidChange(), mxEvent.addListener(t, "mouseleave", mxUtils.bind(this, function () {
    null != this.tooltipHandler && this.tooltipHandler.hide();
  })), mxClient.IS_IE && (mxEvent.addListener(window, "unload", mxUtils.bind(this, function () {
    this.destroy();
  })), mxEvent.addListener(t, "selectstart", mxUtils.bind(this, function (t) {
    return this.isEditing() || !this.isMouseDown && !mxEvent.isShiftDown(t);
  }))), 8 == document.documentMode && t.insertAdjacentHTML("beforeend", "<" + mxClient.VML_PREFIX + ':group style="DISPLAY: none;"></' + mxClient.VML_PREFIX + ":group>");
}, mxGraph.prototype.createHandlers = function () {
  this.tooltipHandler = this.createTooltipHandler(), this.tooltipHandler.setEnabled(!1), this.selectionCellsHandler = this.createSelectionCellsHandler(), this.connectionHandler = this.createConnectionHandler(), this.connectionHandler.setEnabled(!1), this.graphHandler = this.createGraphHandler(), this.panningHandler = this.createPanningHandler(), this.panningHandler.panningEnabled = !1, this.popupMenuHandler = this.createPopupMenuHandler();
}, mxGraph.prototype.createTooltipHandler = function () {
  return new mxTooltipHandler(this);
}, mxGraph.prototype.createSelectionCellsHandler = function () {
  return new mxSelectionCellsHandler(this);
}, mxGraph.prototype.createConnectionHandler = function () {
  return new mxConnectionHandler(this);
}, mxGraph.prototype.createGraphHandler = function () {
  return new mxGraphHandler(this);
}, mxGraph.prototype.createPanningHandler = function () {
  return new mxPanningHandler(this);
}, mxGraph.prototype.createPopupMenuHandler = function () {
  return new mxPopupMenuHandler(this);
}, mxGraph.prototype.createSelectionModel = function () {
  return new mxGraphSelectionModel(this);
}, mxGraph.prototype.createStylesheet = function () {
  return new mxStylesheet();
}, mxGraph.prototype.createGraphView = function () {
  return new mxGraphView(this);
}, mxGraph.prototype.createCellRenderer = function () {
  return new mxCellRenderer();
}, mxGraph.prototype.createCellEditor = function () {
  return new mxCellEditor(this);
}, mxGraph.prototype.getModel = function () {
  return this.model;
}, mxGraph.prototype.getView = function () {
  return this.view;
}, mxGraph.prototype.getStylesheet = function () {
  return this.stylesheet;
}, mxGraph.prototype.setStylesheet = function (t) {
  this.stylesheet = t;
}, mxGraph.prototype.getSelectionModel = function () {
  return this.selectionModel;
}, mxGraph.prototype.setSelectionModel = function (t) {
  this.selectionModel = t;
}, mxGraph.prototype.getSelectionCellsForChanges = function (t) {
  for (var e = new mxDictionary(), i = [], n = mxUtils.bind(this, function (t) {
    if (!e.get(t) && this.model.contains(t)) if (this.model.isEdge(t) || this.model.isVertex(t)) e.put(t, !0), i.push(t);else for (var s = this.model.getChildCount(t), o = 0; o < s; o++) {
      n(this.model.getChildAt(t, o));
    }
  }), s = 0; s < t.length; s++) {
    var o = t[s];

    if (o.constructor != mxRootChange) {
      var l = null;
      o instanceof mxChildChange ? l = o.child : null != o.cell && o.cell instanceof mxCell && (l = o.cell), null != l && n(l);
    }
  }

  return i;
}, mxGraph.prototype.graphModelChanged = function (t) {
  for (var e = 0; e < t.length; e++) {
    this.processChange(t[e]);
  }

  this.removeSelectionCells(this.getRemovedCellsForChanges(t)), this.view.validate(), this.sizeDidChange();
}, mxGraph.prototype.getRemovedCellsForChanges = function (t) {
  for (var e = [], i = 0; i < t.length; i++) {
    var n = t[i];
    if (n instanceof mxRootChange) break;
    n instanceof mxChildChange ? this.model.contains(n.previous) && !this.model.contains(n.parent) && (e = e.concat(this.model.getDescendants(n.child))) : n instanceof mxVisibleChange && (e = e.concat(this.model.getDescendants(n.cell)));
  }

  return e;
}, mxGraph.prototype.processChange = function (t) {
  if (t instanceof mxRootChange) this.clearSelection(), this.setDefaultParent(null), this.removeStateForCell(t.previous), this.resetViewOnRootChange && (this.view.scale = 1, this.view.translate.x = 0, this.view.translate.y = 0), this.fireEvent(new mxEventObject(mxEvent.ROOT));else if (t instanceof mxChildChange) {
    var e = this.model.getParent(t.child);
    this.view.invalidate(t.child, !0, !0), this.model.contains(e) && !this.isCellCollapsed(e) || (this.view.invalidate(t.child, !0, !0), this.removeStateForCell(t.child), this.view.currentRoot == t.child && this.home()), e != t.previous && (null != e && this.view.invalidate(e, !1, !1), null != t.previous && this.view.invalidate(t.previous, !1, !1));
  } else t instanceof mxTerminalChange || t instanceof mxGeometryChange ? (t instanceof mxTerminalChange || null == t.previous && null != t.geometry || null != t.previous && !t.previous.equals(t.geometry)) && this.view.invalidate(t.cell) : t instanceof mxValueChange ? this.view.invalidate(t.cell, !1, !1) : t instanceof mxStyleChange ? (this.view.invalidate(t.cell, !0, !0), null != (t = this.view.getState(t.cell)) && (t.style = null)) : null != t.cell && t.cell instanceof mxCell && this.removeStateForCell(t.cell);
}, mxGraph.prototype.removeStateForCell = function (t) {
  for (var e = this.model.getChildCount(t), i = 0; i < e; i++) {
    this.removeStateForCell(this.model.getChildAt(t, i));
  }

  this.view.invalidate(t, !1, !0), this.view.removeState(t);
}, mxGraph.prototype.addCellOverlay = function (t, e) {
  null == t.overlays && (t.overlays = []), t.overlays.push(e);
  var i = this.view.getState(t);
  return null != i && this.cellRenderer.redraw(i), this.fireEvent(new mxEventObject(mxEvent.ADD_OVERLAY, "cell", t, "overlay", e)), e;
}, mxGraph.prototype.getCellOverlays = function (t) {
  return t.overlays;
}, mxGraph.prototype.removeCellOverlay = function (t, e) {
  if (null == e) this.removeCellOverlays(t);else {
    var i = mxUtils.indexOf(t.overlays, e);
    0 <= i ? (t.overlays.splice(i, 1), 0 == t.overlays.length && (t.overlays = null), null != (i = this.view.getState(t)) && this.cellRenderer.redraw(i), this.fireEvent(new mxEventObject(mxEvent.REMOVE_OVERLAY, "cell", t, "overlay", e))) : e = null;
  }
  return e;
}, mxGraph.prototype.removeCellOverlays = function (t) {
  var e = t.overlays;

  if (null != e) {
    t.overlays = null;
    var i = this.view.getState(t);

    for (null != i && this.cellRenderer.redraw(i), i = 0; i < e.length; i++) {
      this.fireEvent(new mxEventObject(mxEvent.REMOVE_OVERLAY, "cell", t, "overlay", e[i]));
    }
  }

  return e;
}, mxGraph.prototype.clearCellOverlays = function (t) {
  t = null != t ? t : this.model.getRoot(), this.removeCellOverlays(t);

  for (var e = this.model.getChildCount(t), i = 0; i < e; i++) {
    var n = this.model.getChildAt(t, i);
    this.clearCellOverlays(n);
  }
}, mxGraph.prototype.setCellWarning = function (t, e, i, n) {
  return null != e && 0 < e.length ? (e = new mxCellOverlay(i = null != i ? i : this.warningImage, "<font color=red>" + e + "</font>"), n && e.addListener(mxEvent.CLICK, mxUtils.bind(this, function (e, i) {
    this.isEnabled() && this.setSelectionCell(t);
  })), this.addCellOverlay(t, e)) : (this.removeCellOverlays(t), null);
}, mxGraph.prototype.startEditing = function (t) {
  this.startEditingAtCell(null, t);
}, mxGraph.prototype.startEditingAtCell = function (t, e) {
  null != e && mxEvent.isMultiTouchEvent(e) || (null == t && (null == (t = this.getSelectionCell()) || this.isCellEditable(t) || (t = null)), null != t && (this.fireEvent(new mxEventObject(mxEvent.START_EDITING, "cell", t, "event", e)), this.cellEditor.startEditing(t, e), this.fireEvent(new mxEventObject(mxEvent.EDITING_STARTED, "cell", t, "event", e))));
}, mxGraph.prototype.getEditingValue = function (t, e) {
  return this.convertValueToString(t);
}, mxGraph.prototype.stopEditing = function (t) {
  this.cellEditor.stopEditing(t), this.fireEvent(new mxEventObject(mxEvent.EDITING_STOPPED, "cancel", t));
}, mxGraph.prototype.labelChanged = function (t, e, i) {
  this.model.beginUpdate();

  try {
    var n = t.value;
    this.cellLabelChanged(t, e, this.isAutoSizeCell(t)), this.fireEvent(new mxEventObject(mxEvent.LABEL_CHANGED, "cell", t, "value", e, "old", n, "event", i));
  } finally {
    this.model.endUpdate();
  }

  return t;
}, mxGraph.prototype.cellLabelChanged = function (t, e, i) {
  this.model.beginUpdate();

  try {
    this.model.setValue(t, e), i && this.cellSizeUpdated(t, !1);
  } finally {
    this.model.endUpdate();
  }
}, mxGraph.prototype.escape = function (t) {
  this.fireEvent(new mxEventObject(mxEvent.ESCAPE, "event", t));
}, mxGraph.prototype.click = function (t) {
  var e = t.getEvent(),
      i = t.getCell(),
      n = new mxEventObject(mxEvent.CLICK, "event", e, "cell", i);
  if (t.isConsumed() && n.consume(), this.fireEvent(n), this.isEnabled() && !mxEvent.isConsumed(e) && !n.isConsumed()) if (null != i) {
    if (this.isTransparentClickEvent(e)) {
      var s = !1;
      null != (t = this.getCellAt(t.graphX, t.graphY, null, null, null, mxUtils.bind(this, function (t) {
        return t = this.isCellSelected(t.cell), !(s = s || t) || t;
      }))) && (i = t);
    }

    this.selectCellForEvent(i, e);
  } else i = null, this.isSwimlaneSelectionEnabled() && (i = this.getSwimlaneAt(t.getGraphX(), t.getGraphY())), null != i ? this.selectCellForEvent(i, e) : this.isToggleEvent(e) || this.clearSelection();
}, mxGraph.prototype.dblClick = function (t, e) {
  var i = new mxEventObject(mxEvent.DOUBLE_CLICK, "event", t, "cell", e);
  this.fireEvent(i), !this.isEnabled() || mxEvent.isConsumed(t) || i.isConsumed() || null == e || !this.isCellEditable(e) || this.isEditing(e) || (this.startEditingAtCell(e, t), mxEvent.consume(t));
}, mxGraph.prototype.tapAndHold = function (t) {
  var e = t.getEvent(),
      i = new mxEventObject(mxEvent.TAP_AND_HOLD, "event", e, "cell", t.getCell());
  this.fireEvent(i), i.isConsumed() && (this.panningHandler.panningTrigger = !1), this.isEnabled() && !mxEvent.isConsumed(e) && !i.isConsumed() && this.connectionHandler.isEnabled() && null != (e = this.view.getState(this.connectionHandler.marker.getCell(t))) && (this.connectionHandler.marker.currentColor = this.connectionHandler.marker.validColor, this.connectionHandler.marker.markedState = e, this.connectionHandler.marker.mark(), this.connectionHandler.first = new mxPoint(t.getGraphX(), t.getGraphY()), this.connectionHandler.edgeState = this.connectionHandler.createEdgeState(t), this.connectionHandler.previous = e, this.connectionHandler.fireEvent(new mxEventObject(mxEvent.START, "state", this.connectionHandler.previous)));
}, mxGraph.prototype.scrollPointToVisible = function (t, e, i, n) {
  if (this.timerAutoScroll || !this.ignoreScrollbars && !mxUtils.hasScrollbars(this.container)) this.allowAutoPanning && !this.panningHandler.isActive() && (null == this.panningManager && (this.panningManager = this.createPanningManager()), this.panningManager.panTo(t + this.panDx, e + this.panDy));else {
    var s = this.container;

    if (n = null != n ? n : 20, t >= s.scrollLeft && e >= s.scrollTop && t <= s.scrollLeft + s.clientWidth && e <= s.scrollTop + s.clientHeight) {
      var o = s.scrollLeft + s.clientWidth - t;

      if (o < n) {
        if (t = s.scrollLeft, s.scrollLeft += n - o, i && t == s.scrollLeft) {
          if (this.dialect == mxConstants.DIALECT_SVG) {
            t = this.view.getDrawPane().ownerSVGElement;
            var l = this.container.scrollWidth + n - o;
          } else l = Math.max(s.clientWidth, s.scrollWidth) + n - o, t = this.view.getCanvas();

          t.style.width = l + "px", s.scrollLeft += n - o;
        }
      } else (o = t - s.scrollLeft) < n && (s.scrollLeft -= n - o);

      (o = s.scrollTop + s.clientHeight - e) < n ? (t = s.scrollTop, s.scrollTop += n - o, t == s.scrollTop && i && (this.dialect == mxConstants.DIALECT_SVG ? (t = this.view.getDrawPane().ownerSVGElement, e = this.container.scrollHeight + n - o) : (e = Math.max(s.clientHeight, s.scrollHeight) + n - o, t = this.view.getCanvas()), t.style.height = e + "px", s.scrollTop += n - o)) : (o = e - s.scrollTop) < n && (s.scrollTop -= n - o);
    }
  }
}, mxGraph.prototype.createPanningManager = function () {
  return new mxPanningManager(this);
}, mxGraph.prototype.getBorderSizes = function () {
  var t = mxUtils.getCurrentStyle(this.container);
  return new mxRectangle(mxUtils.parseCssNumber(t.paddingLeft) + ("none" != t.borderLeftStyle ? mxUtils.parseCssNumber(t.borderLeftWidth) : 0), mxUtils.parseCssNumber(t.paddingTop) + ("none" != t.borderTopStyle ? mxUtils.parseCssNumber(t.borderTopWidth) : 0), mxUtils.parseCssNumber(t.paddingRight) + ("none" != t.borderRightStyle ? mxUtils.parseCssNumber(t.borderRightWidth) : 0), mxUtils.parseCssNumber(t.paddingBottom) + ("none" != t.borderBottomStyle ? mxUtils.parseCssNumber(t.borderBottomWidth) : 0));
}, mxGraph.prototype.getPreferredPageSize = function (t, e, i) {
  t = this.view.translate;
  var n = this.pageFormat,
      s = this.pageScale;
  n = new mxRectangle(0, 0, Math.ceil(n.width * s), Math.ceil(n.height * s));
  return new mxRectangle(0, 0, (this.pageBreaksVisible ? Math.ceil(e / n.width) : 1) * n.width + 2 + t.x, (this.pageBreaksVisible ? Math.ceil(i / n.height) : 1) * n.height + 2 + t.y);
}, mxGraph.prototype.fit = function (t, e, i, n, s, o, l) {
  if (null != this.container) {
    t = null != t ? t : this.getBorder(), e = null != e && e, i = null != i ? i : 0, n = null == n || n, s = null != s && s, o = null != o && o;
    var r = this.getBorderSizes(),
        a = this.container.offsetWidth - r.x - r.width - 1,
        h = null != l ? l : this.container.offsetHeight - r.y - r.height - 1;

    if (0 < (l = this.view.getGraphBounds()).width && 0 < l.height) {
      e && null != l.x && null != l.y && ((l = l.clone()).width += l.x, l.height += l.y, l.x = 0, l.y = 0);
      r = this.view.scale;
      var u = l.width / r,
          d = l.height / r;
      null != this.backgroundImage && (u = Math.max(u, this.backgroundImage.width - l.x / r), d = Math.max(d, this.backgroundImage.height - l.y / r));
      var p = (e ? t : 2 * t) + i + 1;
      a = a - p, h = h - p;
      if (s = s ? h / d : o ? a / u : Math.min(a / u, h / d), null != this.minFitScale && (s = Math.max(s, this.minFitScale)), null != this.maxFitScale && (s = Math.min(s, this.maxFitScale)), !n) return s;
      e ? this.view.scale != s && this.view.setScale(s) : mxUtils.hasScrollbars(this.container) ? (this.view.setScale(s), null != (t = this.getGraphBounds()).x && (this.container.scrollLeft = t.x), null != t.y && (this.container.scrollTop = t.y)) : this.view.scaleAndTranslate(s, null != l.x ? Math.floor(this.view.translate.x - l.x / r + t / s + i / 2) : t, null != l.y ? Math.floor(this.view.translate.y - l.y / r + t / s + i / 2) : t);
    }
  }

  return this.view.scale;
}, mxGraph.prototype.sizeDidChange = function () {
  var t = this.getGraphBounds();

  if (null != this.container) {
    var e = this.getBorder(),
        i = Math.max(0, t.x + t.width + 2 * e * this.view.scale);
    e = Math.max(0, t.y + t.height + 2 * e * this.view.scale);

    if (null != this.minimumContainerSize && (i = Math.max(i, this.minimumContainerSize.width), e = Math.max(e, this.minimumContainerSize.height)), this.resizeContainer && this.doResizeContainer(i, e), this.preferPageSize || !mxClient.IS_IE && this.pageVisible) {
      var n = this.getPreferredPageSize(t, Math.max(1, i), Math.max(1, e));
      null != n && (i = n.width * this.view.scale, e = n.height * this.view.scale);
    }

    null != this.minimumGraphSize && (i = Math.max(i, this.minimumGraphSize.width * this.view.scale), e = Math.max(e, this.minimumGraphSize.height * this.view.scale)), i = Math.ceil(i), e = Math.ceil(e), this.dialect == mxConstants.DIALECT_SVG ? ((n = this.view.getDrawPane().ownerSVGElement).style.minWidth = Math.max(1, i) + "px", n.style.minHeight = Math.max(1, e) + "px", n.style.width = "100%", n.style.height = "100%") : mxClient.IS_QUIRKS ? this.view.updateHtmlCanvasSize(Math.max(1, i), Math.max(1, e)) : (this.view.canvas.style.minWidth = Math.max(1, i) + "px", this.view.canvas.style.minHeight = Math.max(1, e) + "px"), this.updatePageBreaks(this.pageBreaksVisible, i, e);
  }

  this.fireEvent(new mxEventObject(mxEvent.SIZE, "bounds", t));
}, mxGraph.prototype.doResizeContainer = function (t, e) {
  null != this.maximumContainerSize && (t = Math.min(this.maximumContainerSize.width, t), e = Math.min(this.maximumContainerSize.height, e)), this.container.style.width = Math.ceil(t) + "px", this.container.style.height = Math.ceil(e) + "px";
}, mxGraph.prototype.updatePageBreaks = function (t, e, i) {
  e = this.view.scale, i = this.view.translate;
  var n = this.pageFormat,
      s = e * this.pageScale,
      o = new mxRectangle(0, 0, n.width * s, n.height * s);
  (n = mxRectangle.fromRectangle(this.getGraphBounds())).width = Math.max(1, n.width), n.height = Math.max(1, n.height), o.x = Math.floor((n.x - i.x * e) / o.width) * o.width + i.x * e, o.y = Math.floor((n.y - i.y * e) / o.height) * o.height + i.y * e, n.width = Math.ceil((n.width + (n.x - o.x)) / o.width) * o.width, n.height = Math.ceil((n.height + (n.y - o.y)) / o.height) * o.height;
  var l = (t = t && Math.min(o.width, o.height) > this.minPageBreakDist) ? Math.ceil(n.height / o.height) + 1 : 0,
      r = t ? Math.ceil(n.width / o.width) + 1 : 0,
      a = (r - 1) * o.width,
      h = (l - 1) * o.height;
  null == this.horizontalPageBreaks && 0 < l && (this.horizontalPageBreaks = []), null == this.verticalPageBreaks && 0 < r && (this.verticalPageBreaks = []), (t = mxUtils.bind(this, function (t) {
    if (null != t) {
      for (var e = t == this.horizontalPageBreaks ? l : r, i = 0; i <= e; i++) {
        var n = t == this.horizontalPageBreaks ? [new mxPoint(Math.round(o.x), Math.round(o.y + i * o.height)), new mxPoint(Math.round(o.x + a), Math.round(o.y + i * o.height))] : [new mxPoint(Math.round(o.x + i * o.width), Math.round(o.y)), new mxPoint(Math.round(o.x + i * o.width), Math.round(o.y + h))];
        null != t[i] ? (t[i].points = n, t[i].redraw()) : ((n = new mxPolyline(n, this.pageBreakColor)).dialect = this.dialect, n.pointerEvents = !1, n.isDashed = this.pageBreakDashed, n.init(this.view.backgroundPane), n.redraw(), t[i] = n);
      }

      for (i = e; i < t.length; i++) {
        t[i].destroy();
      }

      t.splice(e, t.length - e);
    }
  }))(this.horizontalPageBreaks), t(this.verticalPageBreaks);
}, mxGraph.prototype.getCellStyle = function (t) {
  var e = this.model.getStyle(t);
  return t = this.model.isEdge(t) ? this.stylesheet.getDefaultEdgeStyle() : this.stylesheet.getDefaultVertexStyle(), null != e && (t = this.postProcessCellStyle(this.stylesheet.getCellStyle(e, t))), null == t && (t = mxGraph.prototype.EMPTY_ARRAY), t;
}, mxGraph.prototype.postProcessCellStyle = function (t) {
  if (null != t) {
    var e = t[mxConstants.STYLE_IMAGE],
        i = this.getImageFromBundles(e);
    null != i ? t[mxConstants.STYLE_IMAGE] = i : i = e, null != i && "data:image/" == i.substring(0, 11) && ("data:image/svg+xml,<" == i.substring(0, 20) ? i = i.substring(0, 19) + encodeURIComponent(i.substring(19)) : "data:image/svg+xml,%3C" != i.substring(0, 22) && 0 < (e = i.indexOf(",")) && ";base64," != i.substring(e - 7, e + 1) && (i = i.substring(0, e) + ";base64," + i.substring(e + 1)), t[mxConstants.STYLE_IMAGE] = i);
  }

  return t;
}, mxGraph.prototype.setCellStyle = function (t, e) {
  if (null != (e = e || this.getSelectionCells())) {
    this.model.beginUpdate();

    try {
      for (var i = 0; i < e.length; i++) {
        this.model.setStyle(e[i], t);
      }
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.toggleCellStyle = function (t, e, i) {
  return i = i || this.getSelectionCell(), this.toggleCellStyles(t, e, [i]);
}, mxGraph.prototype.toggleCellStyles = function (t, e, i) {
  e = null != e && e;
  var n,
      s = null;
  null != (i = i || this.getSelectionCells()) && 0 < i.length && null != (n = null != (n = this.view.getState(i[0])) ? n.style : this.getCellStyle(i[0])) && (s = mxUtils.getValue(n, t, e) ? 0 : 1, this.setCellStyles(t, s, i));
  return s;
}, mxGraph.prototype.setCellStyles = function (t, e, i) {
  i = i || this.getSelectionCells(), mxUtils.setCellStyles(this.model, i, t, e);
}, mxGraph.prototype.toggleCellStyleFlags = function (t, e, i) {
  this.setCellStyleFlags(t, e, null, i);
}, mxGraph.prototype.setCellStyleFlags = function (t, e, i, n) {
  if (null != (n = n || this.getSelectionCells()) && 0 < n.length) {
    var s;
    if (null == i) null != (s = null != (s = this.view.getState(n[0])) ? s.style : this.getCellStyle(n[0])) && (i = (parseInt(s[t] || 0) & e) != e);
    mxUtils.setCellStyleFlags(this.model, n, t, e, i);
  }
}, mxGraph.prototype.alignCells = function (t, e, i) {
  if (null == e && (e = this.getSelectionCells()), null != e && 1 < e.length) {
    if (null == i) for (var n = 0; n < e.length; n++) {
      var s = this.view.getState(e[n]);
      if (null != s && !this.model.isEdge(e[n])) if (null == i) {
        if (t == mxConstants.ALIGN_CENTER) {
          i = s.x + s.width / 2;
          break;
        }

        if (t == mxConstants.ALIGN_RIGHT) i = s.x + s.width;else if (t == mxConstants.ALIGN_TOP) i = s.y;else {
          if (t == mxConstants.ALIGN_MIDDLE) {
            i = s.y + s.height / 2;
            break;
          }

          i = t == mxConstants.ALIGN_BOTTOM ? s.y + s.height : s.x;
        }
      } else i = t == mxConstants.ALIGN_RIGHT ? Math.max(i, s.x + s.width) : t == mxConstants.ALIGN_TOP ? Math.min(i, s.y) : t == mxConstants.ALIGN_BOTTOM ? Math.max(i, s.y + s.height) : Math.min(i, s.x);
    }

    if (null != i) {
      var o = this.view.scale;
      this.model.beginUpdate();

      try {
        for (n = 0; n < e.length; n++) {
          if (null != (s = this.view.getState(e[n]))) {
            var l = this.getCellGeometry(e[n]);
            null == l || this.model.isEdge(e[n]) || (l = l.clone(), t == mxConstants.ALIGN_CENTER ? l.x += (i - s.x - s.width / 2) / o : t == mxConstants.ALIGN_RIGHT ? l.x += (i - s.x - s.width) / o : t == mxConstants.ALIGN_TOP ? l.y += (i - s.y) / o : t == mxConstants.ALIGN_MIDDLE ? l.y += (i - s.y - s.height / 2) / o : t == mxConstants.ALIGN_BOTTOM ? l.y += (i - s.y - s.height) / o : l.x += (i - s.x) / o, this.resizeCell(e[n], l));
          }
        }

        this.fireEvent(new mxEventObject(mxEvent.ALIGN_CELLS, "align", t, "cells", e));
      } finally {
        this.model.endUpdate();
      }
    }
  }

  return e;
}, mxGraph.prototype.flipEdge = function (t) {
  if (null != t && null != this.alternateEdgeStyle) {
    this.model.beginUpdate();

    try {
      var e = this.model.getStyle(t);
      null == e || 0 == e.length ? this.model.setStyle(t, this.alternateEdgeStyle) : this.model.setStyle(t, null), this.resetEdge(t), this.fireEvent(new mxEventObject(mxEvent.FLIP_EDGE, "edge", t));
    } finally {
      this.model.endUpdate();
    }
  }

  return t;
}, mxGraph.prototype.addImageBundle = function (t) {
  this.imageBundles.push(t);
}, mxGraph.prototype.removeImageBundle = function (t) {
  for (var e = [], i = 0; i < this.imageBundles.length; i++) {
    this.imageBundles[i] != t && e.push(this.imageBundles[i]);
  }

  this.imageBundles = e;
}, mxGraph.prototype.getImageFromBundles = function (t) {
  if (null != t) for (var e = 0; e < this.imageBundles.length; e++) {
    var i = this.imageBundles[e].getImage(t);
    if (null != i) return i;
  }
  return null;
}, mxGraph.prototype.orderCells = function (t, e) {
  null == e && (e = mxUtils.sortCells(this.getSelectionCells(), !0)), this.model.beginUpdate();

  try {
    this.cellsOrdered(e, t), this.fireEvent(new mxEventObject(mxEvent.ORDER_CELLS, "back", t, "cells", e));
  } finally {
    this.model.endUpdate();
  }

  return e;
}, mxGraph.prototype.cellsOrdered = function (t, e) {
  if (null != t) {
    this.model.beginUpdate();

    try {
      for (var i = 0; i < t.length; i++) {
        var n = this.model.getParent(t[i]);
        e ? this.model.add(n, t[i], i) : this.model.add(n, t[i], this.model.getChildCount(n) - 1);
      }

      this.fireEvent(new mxEventObject(mxEvent.CELLS_ORDERED, "back", e, "cells", t));
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.groupCells = function (t, e, i) {
  null == i && (i = mxUtils.sortCells(this.getSelectionCells(), !0)), i = this.getCellsForGroup(i), null == t && (t = this.createGroupCell(i));
  var n = this.getBoundsForGroup(t, i, e);

  if (0 < i.length && null != n) {
    var s = this.model.getParent(t);
    null == s && (s = this.model.getParent(i[0])), this.model.beginUpdate();

    try {
      null == this.getCellGeometry(t) && this.model.setGeometry(t, new mxGeometry());
      var o = this.model.getChildCount(s);
      this.cellsAdded([t], s, o, null, null, !1, !1, !1), o = this.model.getChildCount(t), this.cellsAdded(i, t, o, null, null, !1, !1, !1), this.cellsMoved(i, -n.x, -n.y, !1, !1, !1), this.cellsResized([t], [n], !1), this.fireEvent(new mxEventObject(mxEvent.GROUP_CELLS, "group", t, "border", e, "cells", i));
    } finally {
      this.model.endUpdate();
    }
  }

  return t;
}, mxGraph.prototype.getCellsForGroup = function (t) {
  var e = [];

  if (null != t && 0 < t.length) {
    var i = this.model.getParent(t[0]);
    e.push(t[0]);

    for (var n = 1; n < t.length; n++) {
      this.model.getParent(t[n]) == i && e.push(t[n]);
    }
  }

  return e;
}, mxGraph.prototype.getBoundsForGroup = function (t, e, i) {
  return null != (e = this.getBoundingBoxFromGeometry(e, !0)) && (this.isSwimlane(t) && (t = this.getStartSize(t), e.x -= t.width, e.y -= t.height, e.width += t.width, e.height += t.height), null != i && (e.x -= i, e.y -= i, e.width += 2 * i, e.height += 2 * i)), e;
}, mxGraph.prototype.createGroupCell = function (t) {
  return (t = new mxCell("")).setVertex(!0), t.setConnectable(!1), t;
}, mxGraph.prototype.ungroupCells = function (t) {
  var e = [];

  if (null == t) {
    t = this.getSelectionCells();

    for (var i = [], n = 0; n < t.length; n++) {
      0 < this.model.getChildCount(t[n]) && i.push(t[n]);
    }

    t = i;
  }

  if (null != t && 0 < t.length) {
    this.model.beginUpdate();

    try {
      for (n = 0; n < t.length; n++) {
        if (null != (s = this.model.getChildren(t[n])) && 0 < s.length) {
          var s = s.slice(),
              o = this.model.getParent(t[n]),
              l = this.model.getChildCount(o);
          this.cellsAdded(s, o, l, null, null, !0), e = e.concat(s);
        }
      }

      this.removeCellsAfterUngroup(t), this.fireEvent(new mxEventObject(mxEvent.UNGROUP_CELLS, "cells", t));
    } finally {
      this.model.endUpdate();
    }
  }

  return e;
}, mxGraph.prototype.removeCellsAfterUngroup = function (t) {
  this.cellsRemoved(this.addAllEdges(t));
}, mxGraph.prototype.removeCellsFromParent = function (t) {
  null == t && (t = this.getSelectionCells()), this.model.beginUpdate();

  try {
    var e = this.getDefaultParent(),
        i = this.model.getChildCount(e);
    this.cellsAdded(t, e, i, null, null, !0), this.fireEvent(new mxEventObject(mxEvent.REMOVE_CELLS_FROM_PARENT, "cells", t));
  } finally {
    this.model.endUpdate();
  }

  return t;
}, mxGraph.prototype.updateGroupBounds = function (t, e, i, n, s, o, l) {
  null == t && (t = this.getSelectionCells()), e = null != e ? e : 0, i = null != i && i, n = null != n ? n : 0, s = null != s ? s : 0, o = null != o ? o : 0, l = null != l ? l : 0, this.model.beginUpdate();

  try {
    for (var r = t.length - 1; 0 <= r; r--) {
      var a = this.getCellGeometry(t[r]);

      if (null != a) {
        var h = this.getChildCells(t[r]);

        if (null != h && 0 < h.length) {
          var u = this.getBoundingBoxFromGeometry(h, !0);

          if (null != u && 0 < u.width && 0 < u.height) {
            var d = 0,
                p = 0;

            if (this.isSwimlane(t[r])) {
              var c = this.getStartSize(t[r]);
              d = c.width, p = c.height;
            }

            a = a.clone(), i && (a.x = Math.round(a.x + u.x - e - d - l), a.y = Math.round(a.y + u.y - e - p - n)), a.width = Math.round(u.width + 2 * e + d + l + s), a.height = Math.round(u.height + 2 * e + p + n + o), this.model.setGeometry(t[r], a), this.moveCells(h, e + d - u.x + l, e + p - u.y + n);
          }
        }
      }
    }
  } finally {
    this.model.endUpdate();
  }

  return t;
}, mxGraph.prototype.getBoundingBox = function (t) {
  var e = null;
  if (null != t && 0 < t.length) for (var i = 0; i < t.length; i++) {
    if (this.model.isVertex(t[i]) || this.model.isEdge(t[i])) {
      var n = this.view.getBoundingBox(this.view.getState(t[i]), !0);
      null != n && (null == e ? e = mxRectangle.fromRectangle(n) : e.add(n));
    }
  }
  return e;
}, mxGraph.prototype.cloneCell = function (t, e, i, n) {
  return this.cloneCells([t], e, i, n)[0];
}, mxGraph.prototype.cloneCells = function (t, e, i, n) {
  e = null == e || e;
  var s = null;

  if (null != t) {
    for (var o = new mxDictionary(), l = (s = [], 0); l < t.length; l++) {
      o.put(t[l], !0), s.push(t[l]);
    }

    if (0 < s.length) {
      var r = this.view.scale,
          a = this.view.translate;

      for (s = this.model.cloneCells(t, !0, i), l = 0; l < t.length; l++) {
        if (!e && this.model.isEdge(s[l]) && null != this.getEdgeValidationError(s[l], this.model.getTerminal(s[l], !0), this.model.getTerminal(s[l], !1))) s[l] = null;else {
          var h = this.model.getGeometry(s[l]);

          if (null != h) {
            var u = this.view.getState(t[l]),
                d = this.view.getState(this.model.getParent(t[l]));
            if (null != u && null != d) if (i = n ? 0 : d.origin.x, d = n ? 0 : d.origin.y, this.model.isEdge(s[l])) {
              u = u.absolutePoints;

              for (var p = this.model.getTerminal(t[l], !0); null != p && !o.get(p);) {
                p = this.model.getParent(p);
              }

              for (null == p && h.setTerminalPoint(new mxPoint(u[0].x / r - a.x, u[0].y / r - a.y), !0), p = this.model.getTerminal(t[l], !1); null != p && !o.get(p);) {
                p = this.model.getParent(p);
              }

              if (null == p && (p = u.length - 1, h.setTerminalPoint(new mxPoint(u[p].x / r - a.x, u[p].y / r - a.y), !1)), null != (h = h.points)) for (u = 0; u < h.length; u++) {
                h[u].x += i, h[u].y += d;
              }
            } else h.translate(i, d);
          }
        }
      }
    } else s = [];
  }

  return s;
}, mxGraph.prototype.insertVertex = function (t, e, i, n, s, o, l, r, a) {
  return e = this.createVertex(t, e, i, n, s, o, l, r, a), this.addCell(e, t);
}, mxGraph.prototype.createVertex = function (t, e, i, n, s, o, l, r, a) {
  return (t = new mxGeometry(n, s, o, l)).relative = null != a && a, (i = new mxCell(i, t, r)).setId(e), i.setVertex(!0), i.setConnectable(!0), i;
}, mxGraph.prototype.insertEdge = function (t, e, i, n, s, o) {
  return e = this.createEdge(t, e, i, n, s, o), this.addEdge(e, t, n, s);
}, mxGraph.prototype.createEdge = function (t, e, i, n, s, o) {
  return (t = new mxCell(i, new mxGeometry(), o)).setId(e), t.setEdge(!0), t.geometry.relative = !0, t;
}, mxGraph.prototype.addEdge = function (t, e, i, n, s) {
  return this.addCell(t, e, s, i, n);
}, mxGraph.prototype.addCell = function (t, e, i, n, s) {
  return this.addCells([t], e, i, n, s)[0];
}, mxGraph.prototype.addCells = function (t, e, i, n, s) {
  null == e && (e = this.getDefaultParent()), null == i && (i = this.model.getChildCount(e)), this.model.beginUpdate();

  try {
    this.cellsAdded(t, e, i, n, s, !1, !0), this.fireEvent(new mxEventObject(mxEvent.ADD_CELLS, "cells", t, "parent", e, "index", i, "source", n, "target", s));
  } finally {
    this.model.endUpdate();
  }

  return t;
}, mxGraph.prototype.cellsAdded = function (t, e, i, n, s, o, l, r) {
  if (null != t && null != e && null != i) {
    this.model.beginUpdate();

    try {
      for (var a = null != (u = o ? this.view.getState(e) : null) ? u.origin : null, h = new mxPoint(0, 0), u = 0; u < t.length; u++) {
        if (null == t[u]) i--;else {
          var d = this.model.getParent(t[u]);

          if (null != a && t[u] != e && e != d) {
            var p = this.view.getState(d),
                c = null != p ? p.origin : h;

            if (null != (m = this.model.getGeometry(t[u]))) {
              var m,
                  g = c.x - a.x,
                  x = c.y - a.y;
              (m = m.clone()).translate(g, x), m.relative || !this.model.isVertex(t[u]) || this.isAllowNegativeCoordinates() || (m.x = Math.max(0, m.x), m.y = Math.max(0, m.y)), this.model.setGeometry(t[u], m);
            }
          }

          e == d && i + u > this.model.getChildCount(e) && i--, this.model.add(e, t[u], i + u), this.autoSizeCellsOnAdd && this.autoSizeCell(t[u], !0), (null == r || r) && this.isExtendParentsOnAdd(t[u]) && this.isExtendParent(t[u]) && this.extendParent(t[u]), (null == l || l) && this.constrainChild(t[u]), null != n && this.cellConnected(t[u], n, !0), null != s && this.cellConnected(t[u], s, !1);
        }
      }

      this.fireEvent(new mxEventObject(mxEvent.CELLS_ADDED, "cells", t, "parent", e, "index", i, "source", n, "target", s, "absolute", o));
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.autoSizeCell = function (t, e) {
  if (null == e || e) for (var i = this.model.getChildCount(t), n = 0; n < i; n++) {
    this.autoSizeCell(this.model.getChildAt(t, n));
  }
  this.getModel().isVertex(t) && this.isAutoSizeCell(t) && this.updateCellSize(t);
}, mxGraph.prototype.removeCells = function (t, e) {
  e = null == e || e, null == t && (t = this.getDeletableCells(this.getSelectionCells())), e && (t = this.getDeletableCells(this.addAllEdges(t))), this.model.beginUpdate();

  try {
    this.cellsRemoved(t), this.fireEvent(new mxEventObject(mxEvent.REMOVE_CELLS, "cells", t, "includeEdges", e));
  } finally {
    this.model.endUpdate();
  }

  return t;
}, mxGraph.prototype.cellsRemoved = function (t) {
  if (null != t && 0 < t.length) {
    var e = this.view.scale,
        i = this.view.translate;
    this.model.beginUpdate();

    try {
      for (var n = new mxDictionary(), s = 0; s < t.length; s++) {
        n.put(t[s], !0);
      }

      for (s = 0; s < t.length; s++) {
        for (var o = this.getAllEdges([t[s]]), l = mxUtils.bind(this, function (n, l) {
          var a = this.model.getGeometry(n);

          if (null != a) {
            var h = this.view.getState(n);

            if (null != h) {
              for (var u = h.getVisibleTerminal(l), d = !1; null != u;) {
                if (t[s] == u) {
                  d = !0;
                  break;
                }

                u = this.model.getParent(u);
              }

              if (d) {
                u = i.x, d = i.y;
                var p = this.view.getState(this.model.getParent(n));
                null != p && this.model.isVertex(p.cell) && (u = p.x / e, d = p.y / e), a = a.clone(), h = h.absolutePoints, p = l ? 0 : h.length - 1, a.setTerminalPoint(new mxPoint(h[p].x / e - u, h[p].y / e - d), l), this.model.setTerminal(o[r], null, l), this.model.setGeometry(o[r], a);
              }
            }
          }
        }), r = 0; r < o.length; r++) {
          n.get(o[r]) || (l(o[r], !0), l(o[r], !1));
        }

        this.model.remove(t[s]);
      }

      this.fireEvent(new mxEventObject(mxEvent.CELLS_REMOVED, "cells", t));
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.splitEdge = function (t, e, i, n, s) {
  n = n || 0, s = s || 0;
  var o = this.model.getParent(t),
      l = this.model.getTerminal(t, !0);
  this.model.beginUpdate();

  try {
    if (null == i) {
      i = this.cloneCell(t);
      var r = this.view.getState(t),
          a = this.getCellGeometry(i);

      if (null != a && null != a.points && null != r) {
        var h = this.view.translate,
            u = this.view.scale,
            d = mxUtils.findNearestSegment(r, (n + h.x) * u, (s + h.y) * u);
        a.points = a.points.slice(0, d), null != (a = this.getCellGeometry(t)) && null != a.points && ((a = a.clone()).points = a.points.slice(d), this.model.setGeometry(t, a));
      }
    }

    this.cellsMoved(e, n, s, !1, !1), this.cellsAdded(e, o, this.model.getChildCount(o), null, null, !0), this.cellsAdded([i], o, this.model.getChildCount(o), l, e[0], !1), this.cellConnected(t, e[0], !0), this.fireEvent(new mxEventObject(mxEvent.SPLIT_EDGE, "edge", t, "cells", e, "newEdge", i, "dx", n, "dy", s));
  } finally {
    this.model.endUpdate();
  }

  return i;
}, mxGraph.prototype.toggleCells = function (t, e, i) {
  null == e && (e = this.getSelectionCells()), i && (e = this.addAllEdges(e)), this.model.beginUpdate();

  try {
    this.cellsToggled(e, t), this.fireEvent(new mxEventObject(mxEvent.TOGGLE_CELLS, "show", t, "cells", e, "includeEdges", i));
  } finally {
    this.model.endUpdate();
  }

  return e;
}, mxGraph.prototype.cellsToggled = function (t, e) {
  if (null != t && 0 < t.length) {
    this.model.beginUpdate();

    try {
      for (var i = 0; i < t.length; i++) {
        this.model.setVisible(t[i], e);
      }
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.foldCells = function (t, e, i, n, s) {
  e = null != e && e, null == i && (i = this.getFoldableCells(this.getSelectionCells(), t)), this.stopEditing(!1), this.model.beginUpdate();

  try {
    this.cellsFolded(i, t, e, n), this.fireEvent(new mxEventObject(mxEvent.FOLD_CELLS, "collapse", t, "recurse", e, "cells", i));
  } finally {
    this.model.endUpdate();
  }

  return i;
}, mxGraph.prototype.cellsFolded = function (t, e, i, n) {
  if (null != t && 0 < t.length) {
    this.model.beginUpdate();

    try {
      for (var s = 0; s < t.length; s++) {
        if ((!n || this.isCellFoldable(t[s], e)) && e != this.isCellCollapsed(t[s])) {
          if (this.model.setCollapsed(t[s], e), this.swapBounds(t[s], e), this.isExtendParent(t[s]) && this.extendParent(t[s]), i) {
            var o = this.model.getChildren(t[s]);
            this.cellsFolded(o, e, i);
          }

          this.constrainChild(t[s]);
        }
      }

      this.fireEvent(new mxEventObject(mxEvent.CELLS_FOLDED, "cells", t, "collapse", e, "recurse", i));
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.swapBounds = function (t, e) {
  if (null != t) {
    var i = this.model.getGeometry(t);
    null != i && (i = i.clone(), this.updateAlternateBounds(t, i, e), i.swap(), this.model.setGeometry(t, i));
  }
}, mxGraph.prototype.updateAlternateBounds = function (t, e, i) {
  if (null != t && null != e) {
    if (i = null != (i = this.view.getState(t)) ? i.style : this.getCellStyle(t), null == e.alternateBounds) {
      var n = e;
      this.collapseToPreferredSize && null != (t = this.getPreferredSizeForCell(t)) && (n = t, 0 < (t = mxUtils.getValue(i, mxConstants.STYLE_STARTSIZE)) && (n.height = Math.max(n.height, t))), e.alternateBounds = new mxRectangle(0, 0, n.width, n.height);
    }

    if (null != e.alternateBounds) {
      e.alternateBounds.x = e.x, e.alternateBounds.y = e.y;
      var s = mxUtils.toRadians(i[mxConstants.STYLE_ROTATION] || 0);
      0 != s && (t = e.alternateBounds.getCenterX() - e.getCenterX(), i = e.alternateBounds.getCenterY() - e.getCenterY(), n = Math.cos(s), s = Math.sin(s), e.alternateBounds.x += n * t - s * i - t, e.alternateBounds.y += s * t + n * i - i);
    }
  }
}, mxGraph.prototype.addAllEdges = function (t) {
  var e = t.slice();
  return mxUtils.removeDuplicates(e.concat(this.getAllEdges(t)));
}, mxGraph.prototype.getAllEdges = function (t) {
  var e = [];
  if (null != t) for (var i = 0; i < t.length; i++) {
    for (var n = this.model.getEdgeCount(t[i]), s = 0; s < n; s++) {
      e.push(this.model.getEdgeAt(t[i], s));
    }

    n = this.model.getChildren(t[i]), e = e.concat(this.getAllEdges(n));
  }
  return e;
}, mxGraph.prototype.updateCellSize = function (t, e) {
  e = null != e && e, this.model.beginUpdate();

  try {
    this.cellSizeUpdated(t, e), this.fireEvent(new mxEventObject(mxEvent.UPDATE_CELL_SIZE, "cell", t, "ignoreChildren", e));
  } finally {
    this.model.endUpdate();
  }

  return t;
}, mxGraph.prototype.cellSizeUpdated = function (t, e) {
  if (null != t) {
    this.model.beginUpdate();

    try {
      var i = this.getPreferredSizeForCell(t),
          n = this.model.getGeometry(t);

      if (null != i && null != n) {
        var s = this.isCellCollapsed(t);
        n = n.clone();

        if (this.isSwimlane(t)) {
          var o = this.view.getState(t),
              l = null != o ? o.style : this.getCellStyle(t),
              r = this.model.getStyle(t);
          null == r && (r = ""), mxUtils.getValue(l, mxConstants.STYLE_HORIZONTAL, !0) ? (r = mxUtils.setStyle(r, mxConstants.STYLE_STARTSIZE, i.height + 8), s && (n.height = i.height + 8), n.width = i.width) : (r = mxUtils.setStyle(r, mxConstants.STYLE_STARTSIZE, i.width + 8), s && (n.width = i.width + 8), n.height = i.height), this.model.setStyle(t, r);
        } else n.width = i.width, n.height = i.height;

        if (!e && !s) {
          var a = this.view.getBounds(this.model.getChildren(t));

          if (null != a) {
            var h = this.view.translate,
                u = this.view.scale,
                d = (a.y + a.height) / u - n.y - h.y;
            n.width = Math.max(n.width, (a.x + a.width) / u - n.x - h.x), n.height = Math.max(n.height, d);
          }
        }

        this.cellsResized([t], [n], !1);
      }
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.getPreferredSizeForCell = function (t) {
  var e = null;

  if (null != t) {
    var i = this.view.getState(t) || this.view.createState(t),
        n = i.style;

    if (!this.model.isEdge(t)) {
      var s = n[mxConstants.STYLE_FONTSIZE] || mxConstants.DEFAULT_FONTSIZE;
      t = e = 0, null == this.getImage(i) && null == n[mxConstants.STYLE_IMAGE] || n[mxConstants.STYLE_SHAPE] != mxConstants.SHAPE_LABEL || (n[mxConstants.STYLE_VERTICAL_ALIGN] == mxConstants.ALIGN_MIDDLE && (e += parseFloat(n[mxConstants.STYLE_IMAGE_WIDTH]) || mxLabel.prototype.imageSize), n[mxConstants.STYLE_ALIGN] != mxConstants.ALIGN_CENTER && (t += parseFloat(n[mxConstants.STYLE_IMAGE_HEIGHT]) || mxLabel.prototype.imageSize)), e += 2 * (n[mxConstants.STYLE_SPACING] || 0), e += n[mxConstants.STYLE_SPACING_LEFT] || 0, e += n[mxConstants.STYLE_SPACING_RIGHT] || 0, t += 2 * (n[mxConstants.STYLE_SPACING] || 0), t += n[mxConstants.STYLE_SPACING_TOP] || 0, t += n[mxConstants.STYLE_SPACING_BOTTOM] || 0;
      var o = this.getFoldingImage(i);
      null != o && (e += o.width + 8), null != (o = this.cellRenderer.getLabelValue(i)) && 0 < o.length ? (this.isHtmlLabel(i.cell) || (o = mxUtils.htmlEntities(o)), o = o.replace(/\n/g, "<br>"), i = (s = mxUtils.getSizeForString(o, s, n[mxConstants.STYLE_FONTFAMILY])).width + e, t = s.height + t, mxUtils.getValue(n, mxConstants.STYLE_HORIZONTAL, !0) || (n = t, t = i, i = n), this.gridEnabled && (i = this.snap(i + this.gridSize / 2), t = this.snap(t + this.gridSize / 2)), e = new mxRectangle(0, 0, i, t)) : e = new mxRectangle(0, 0, n = 4 * this.gridSize, n);
    }
  }

  return e;
}, mxGraph.prototype.resizeCell = function (t, e, i) {
  return this.resizeCells([t], [e], i)[0];
}, mxGraph.prototype.resizeCells = function (t, e, i) {
  i = null != i ? i : this.isRecursiveResize(), this.model.beginUpdate();

  try {
    this.cellsResized(t, e, i), this.fireEvent(new mxEventObject(mxEvent.RESIZE_CELLS, "cells", t, "bounds", e));
  } finally {
    this.model.endUpdate();
  }

  return t;
}, mxGraph.prototype.cellsResized = function (t, e, i) {
  if (i = null != i && i, null != t && null != e && t.length == e.length) {
    this.model.beginUpdate();

    try {
      for (var n = 0; n < t.length; n++) {
        this.cellResized(t[n], e[n], !1, i), this.isExtendParent(t[n]) && this.extendParent(t[n]), this.constrainChild(t[n]);
      }

      this.resetEdgesOnResize && this.resetEdges(t), this.fireEvent(new mxEventObject(mxEvent.CELLS_RESIZED, "cells", t, "bounds", e));
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.cellResized = function (t, e, i, n) {
  var s = this.model.getGeometry(t);

  if (null != s && (s.x != e.x || s.y != e.y || s.width != e.width || s.height != e.height)) {
    s = s.clone(), !i && s.relative ? null != (i = s.offset) && (i.x += e.x - s.x, i.y += e.y - s.y) : (s.x = e.x, s.y = e.y), s.width = e.width, s.height = e.height, s.relative || !this.model.isVertex(t) || this.isAllowNegativeCoordinates() || (s.x = Math.max(0, s.x), s.y = Math.max(0, s.y)), this.model.beginUpdate();

    try {
      n && this.resizeChildCells(t, s), this.model.setGeometry(t, s), this.constrainChildCells(t);
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.resizeChildCells = function (t, e) {
  for (var i = this.model.getGeometry(t), n = e.width / i.width, s = (i = e.height / i.height, this.model.getChildCount(t)), o = 0; o < s; o++) {
    this.scaleCell(this.model.getChildAt(t, o), n, i, !0);
  }
}, mxGraph.prototype.constrainChildCells = function (t) {
  for (var e = this.model.getChildCount(t), i = 0; i < e; i++) {
    this.constrainChild(this.model.getChildAt(t, i));
  }
}, mxGraph.prototype.scaleCell = function (t, e, i, n) {
  if (null != (s = this.model.getGeometry(t))) {
    var s,
        o = null != (o = this.view.getState(t)) ? o.style : this.getCellStyle(t),
        l = (s = s.clone()).x,
        r = s.y,
        a = s.width,
        h = s.height;
    s.scale(e, i, "fixed" == o[mxConstants.STYLE_ASPECT]), "1" == o[mxConstants.STYLE_RESIZE_WIDTH] ? s.width = a * e : "0" == o[mxConstants.STYLE_RESIZE_WIDTH] && (s.width = a), "1" == o[mxConstants.STYLE_RESIZE_HEIGHT] ? s.height = h * i : "0" == o[mxConstants.STYLE_RESIZE_HEIGHT] && (s.height = h), this.isCellMovable(t) || (s.x = l, s.y = r), this.isCellResizable(t) || (s.width = a, s.height = h), this.model.isVertex(t) ? this.cellResized(t, s, !0, n) : this.model.setGeometry(t, s);
  }
}, mxGraph.prototype.extendParent = function (t) {
  if (null != t) {
    var e = this.model.getParent(t),
        i = this.getCellGeometry(e);
    null == e || null == i || this.isCellCollapsed(e) || null != (t = this.getCellGeometry(t)) && !t.relative && (i.width < t.x + t.width || i.height < t.y + t.height) && ((i = i.clone()).width = Math.max(i.width, t.x + t.width), i.height = Math.max(i.height, t.y + t.height), this.cellsResized([e], [i], !1));
  }
}, mxGraph.prototype.importCells = function (t, e, i, n, s, o) {
  return this.moveCells(t, e, i, !0, n, s, o);
}, mxGraph.prototype.moveCells = function (t, e, i, n, s, o, l) {
  if (e = null != e ? e : 0, i = null != i ? i : 0, n = null != n && n, null != t && (0 != e || 0 != i || n || null != s)) {
    t = this.model.getTopmostCells(t), this.model.beginUpdate();

    try {
      for (var r = new mxDictionary(), a = 0; a < t.length; a++) {
        r.put(t[a], !0);
      }

      var h = mxUtils.bind(this, function (t) {
        for (; null != t;) {
          if (r.get(t)) return !0;
          t = this.model.getParent(t);
        }

        return !1;
      }),
          u = [];

      for (a = 0; a < t.length; a++) {
        var d = this.getCellGeometry(t[a]),
            p = this.model.getParent(t[a]);
        null != d && d.relative && this.model.isEdge(p) && (h(this.model.getTerminal(p, !0)) || h(this.model.getTerminal(p, !1))) || u.push(t[a]);
      }

      t = u, n && (t = this.cloneCells(t, this.isCloneInvalidEdges(), l), null == s && (s = this.getDefaultParent()));
      var c = this.isAllowNegativeCoordinates();

      if (null != s && this.setAllowNegativeCoordinates(!0), this.cellsMoved(t, e, i, !n && this.isDisconnectOnMove() && this.isAllowDanglingEdges(), null == s, this.isExtendParentsOnMove() && null == s), this.setAllowNegativeCoordinates(c), null != s) {
        var m = this.model.getChildCount(s);
        this.cellsAdded(t, s, m, null, null, !0);
      }

      this.fireEvent(new mxEventObject(mxEvent.MOVE_CELLS, "cells", t, "dx", e, "dy", i, "clone", n, "target", s, "event", o));
    } finally {
      this.model.endUpdate();
    }
  }

  return t;
}, mxGraph.prototype.cellsMoved = function (t, e, i, n, s, o) {
  if (null != t && (0 != e || 0 != i)) {
    o = null != o && o, this.model.beginUpdate();

    try {
      n && this.disconnectGraph(t);

      for (var l = 0; l < t.length; l++) {
        this.translateCell(t[l], e, i), o && this.isExtendParent(t[l]) ? this.extendParent(t[l]) : s && this.constrainChild(t[l]);
      }

      this.resetEdgesOnMove && this.resetEdges(t), this.fireEvent(new mxEventObject(mxEvent.CELLS_MOVED, "cells", t, "dx", e, "dy", i, "disconnect", n));
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.translateCell = function (t, e, i) {
  var n = this.model.getGeometry(t);

  if (null != n) {
    if (e = parseFloat(e), i = parseFloat(i), (n = n.clone()).translate(e, i), n.relative || !this.model.isVertex(t) || this.isAllowNegativeCoordinates() || (n.x = Math.max(0, parseFloat(n.x)), n.y = Math.max(0, parseFloat(n.y))), n.relative && !this.model.isEdge(t)) {
      var s = this.model.getParent(t),
          o = 0;
      this.model.isVertex(s) && (s = null != (o = this.view.getState(s)) ? o.style : this.getCellStyle(s), o = mxUtils.getValue(s, mxConstants.STYLE_ROTATION, 0)), 0 != o && (o = mxUtils.toRadians(-o), s = Math.cos(o), o = Math.sin(o), e = (i = mxUtils.getRotatedPoint(new mxPoint(e, i), s, o, new mxPoint(0, 0))).x, i = i.y), null == n.offset ? n.offset = new mxPoint(e, i) : (n.offset.x = parseFloat(n.offset.x) + e, n.offset.y = parseFloat(n.offset.y) + i);
    }

    this.model.setGeometry(t, n);
  }
}, mxGraph.prototype.getCellContainmentArea = function (t) {
  if (null != t && !this.model.isEdge(t) && null != (l = this.model.getParent(t)) && l != this.getDefaultParent() && null != (n = this.model.getGeometry(l))) {
    var e = t = 0,
        i = n.width,
        n = n.height;

    if (this.isSwimlane(l)) {
      var s = this.getStartSize(l),
          o = null != (r = this.view.getState(l)) ? r.style : this.getCellStyle(l),
          l = mxUtils.getValue(o, mxConstants.STYLE_DIRECTION, mxConstants.DIRECTION_EAST),
          r = 1 == mxUtils.getValue(o, mxConstants.STYLE_FLIPH, 0);
      o = 1 == mxUtils.getValue(o, mxConstants.STYLE_FLIPV, 0);

      if (l == mxConstants.DIRECTION_SOUTH || l == mxConstants.DIRECTION_NORTH) {
        var a = s.width;
        s.width = s.height, s.height = a;
      }

      (l == mxConstants.DIRECTION_EAST && !o || l == mxConstants.DIRECTION_NORTH && !r || l == mxConstants.DIRECTION_WEST && o || l == mxConstants.DIRECTION_SOUTH && r) && (t = s.width, e = s.height), i -= s.width, n -= s.height;
    }

    return new mxRectangle(t, e, i, n);
  }

  return null;
}, mxGraph.prototype.getMaximumGraphBounds = function () {
  return this.maximumGraphBounds;
}, mxGraph.prototype.constrainChild = function (t, e) {
  if (null != t) {
    var i = this.getCellGeometry(t);

    if (null != i && (this.isConstrainRelativeChildren() || !i.relative)) {
      var n = this.model.getParent(t);
      this.getCellGeometry(n);
      var s = this.getMaximumGraphBounds();
      if (null != s && null != (n = this.getBoundingBoxFromGeometry([n], !1)) && ((s = mxRectangle.fromRectangle(s)).x -= n.x, s.y -= n.y), this.isConstrainChild(t) && null != (n = this.getCellContainmentArea(t))) 0 < (o = this.getOverlap(t)) && ((n = mxRectangle.fromRectangle(n)).x -= n.width * o, n.y -= n.height * o, n.width += 2 * n.width * o, n.height += 2 * n.height * o), null == s ? s = n : (s = mxRectangle.fromRectangle(s)).intersect(n);

      if (null != s) {
        if (n = [t], !this.isCellCollapsed(t)) for (var o = this.model.getDescendants(t), l = 0; l < o.length; l++) {
          this.isCellVisible(o[l]) && n.push(o[l]);
        }
        null != (n = this.getBoundingBoxFromGeometry(n, !1)) && (o = 0, (i = i.clone()).width > s.width && (o = i.width - s.width, i.width -= o), n.x + n.width > s.x + s.width && (o -= n.x + n.width - s.x - s.width - o), l = 0, i.height > s.height && (l = i.height - s.height, i.height -= l), n.y + n.height > s.y + s.height && (l -= n.y + n.height - s.y - s.height - l), n.x < s.x && (o -= n.x - s.x), n.y < s.y && (l -= n.y - s.y), 0 == o && 0 == l || (i.relative ? (null == i.offset && (i.offset = new mxPoint()), i.offset.x += o, i.offset.y += l) : (i.x += o, i.y += l)), this.model.setGeometry(t, i));
      }
    }
  }
}, mxGraph.prototype.resetEdges = function (t) {
  if (null != t) {
    for (var e = new mxDictionary(), i = 0; i < t.length; i++) {
      e.put(t[i], !0);
    }

    this.model.beginUpdate();

    try {
      for (i = 0; i < t.length; i++) {
        var n = this.model.getEdges(t[i]);
        if (null != n) for (var s = 0; s < n.length; s++) {
          var o = this.view.getState(n[s]),
              l = null != o ? o.getVisibleTerminal(!0) : this.view.getVisibleTerminal(n[s], !0),
              r = null != o ? o.getVisibleTerminal(!1) : this.view.getVisibleTerminal(n[s], !1);
          e.get(l) && e.get(r) || this.resetEdge(n[s]);
        }
        this.resetEdges(this.model.getChildren(t[i]));
      }
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.resetEdge = function (t) {
  var e = this.model.getGeometry(t);
  return null != e && null != e.points && 0 < e.points.length && ((e = e.clone()).points = [], this.model.setGeometry(t, e)), t;
}, mxGraph.prototype.getOutlineConstraint = function (t, e, i) {
  if (null != e.shape) {
    i = this.view.getPerimeterBounds(e);
    var n = e.style[mxConstants.STYLE_DIRECTION];

    if (n == mxConstants.DIRECTION_NORTH || n == mxConstants.DIRECTION_SOUTH) {
      i.x += i.width / 2 - i.height / 2, i.y += i.height / 2 - i.width / 2;
      var s = i.width;
      i.width = i.height, i.height = s;
    }

    if (0 != (o = mxUtils.toRadians(e.shape.getShapeRotation()))) {
      s = Math.cos(-o);
      var o = Math.sin(-o),
          l = new mxPoint(i.getCenterX(), i.getCenterY());
      t = mxUtils.getRotatedPoint(t, s, o, l);
    }

    l = o = 1;
    var r = 0,
        a = 0;

    if (this.getModel().isVertex(e.cell)) {
      var h = e.style[mxConstants.STYLE_FLIPH],
          u = e.style[mxConstants.STYLE_FLIPV];
      null != e.shape && null != e.shape.stencil && (h = 1 == mxUtils.getValue(e.style, "stencilFlipH", 0) || h, u = 1 == mxUtils.getValue(e.style, "stencilFlipV", 0) || u), n != mxConstants.DIRECTION_NORTH && n != mxConstants.DIRECTION_SOUTH || (s = h, h = u, u = s), h && (o = -1, r = -i.width), u && (l = -1, a = -i.height);
    }

    return t = new mxPoint((t.x - i.x) * o - r + i.x, (t.y - i.y) * l - a + i.y), new mxConnectionConstraint(new mxPoint(0 == i.width ? 0 : Math.round(1e3 * (t.x - i.x) / i.width) / 1e3, 0 == i.height ? 0 : Math.round(1e3 * (t.y - i.y) / i.height) / 1e3), !1);
  }

  return null;
}, mxGraph.prototype.getAllConnectionConstraints = function (t, e) {
  return null != t && null != t.shape && null != t.shape.stencil ? t.shape.stencil.constraints : null;
}, mxGraph.prototype.getConnectionConstraint = function (t, e, i) {
  e = null;
  var n = t.style[i ? mxConstants.STYLE_EXIT_X : mxConstants.STYLE_ENTRY_X];

  if (null != n) {
    var s = t.style[i ? mxConstants.STYLE_EXIT_Y : mxConstants.STYLE_ENTRY_Y];
    null != s && (e = new mxPoint(parseFloat(n), parseFloat(s)));
  }

  return n = !1, null != e && (n = mxUtils.getValue(t.style, i ? mxConstants.STYLE_EXIT_PERIMETER : mxConstants.STYLE_ENTRY_PERIMETER, !0)), new mxConnectionConstraint(e, n);
}, mxGraph.prototype.setConnectionConstraint = function (t, e, i, n) {
  if (null != n) {
    this.model.beginUpdate();

    try {
      null == n || null == n.point ? (this.setCellStyles(i ? mxConstants.STYLE_EXIT_X : mxConstants.STYLE_ENTRY_X, null, [t]), this.setCellStyles(i ? mxConstants.STYLE_EXIT_Y : mxConstants.STYLE_ENTRY_Y, null, [t]), this.setCellStyles(i ? mxConstants.STYLE_EXIT_PERIMETER : mxConstants.STYLE_ENTRY_PERIMETER, null, [t])) : null != n.point && (this.setCellStyles(i ? mxConstants.STYLE_EXIT_X : mxConstants.STYLE_ENTRY_X, n.point.x, [t]), this.setCellStyles(i ? mxConstants.STYLE_EXIT_Y : mxConstants.STYLE_ENTRY_Y, n.point.y, [t]), n.perimeter ? this.setCellStyles(i ? mxConstants.STYLE_EXIT_PERIMETER : mxConstants.STYLE_ENTRY_PERIMETER, null, [t]) : this.setCellStyles(i ? mxConstants.STYLE_EXIT_PERIMETER : mxConstants.STYLE_ENTRY_PERIMETER, "0", [t]));
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.getConnectionPoint = function (t, e) {
  var i = null;

  if (null != t && null != e.point) {
    var n = this.view.getPerimeterBounds(t),
        s = new mxPoint(n.getCenterX(), n.getCenterY()),
        o = 0;
    null != (i = t.style[mxConstants.STYLE_DIRECTION]) && 1 == mxUtils.getValue(t.style, mxConstants.STYLE_ANCHOR_POINT_DIRECTION, 1) && (i == mxConstants.DIRECTION_NORTH ? o += 270 : i == mxConstants.DIRECTION_WEST ? o += 180 : i == mxConstants.DIRECTION_SOUTH && (o += 90), i != mxConstants.DIRECTION_NORTH && i != mxConstants.DIRECTION_SOUTH || n.rotate90());
    i = new mxPoint(n.x + e.point.x * n.width, n.y + e.point.y * n.height);
    var l = t.style[mxConstants.STYLE_ROTATION] || 0;

    if (e.perimeter) {
      if (0 != o) {
        var r = n = 0;
        90 == o ? r = 1 : 180 == o ? n = -1 : 270 == o && (r = -1), i = mxUtils.getRotatedPoint(i, n, r, s);
      }

      i = this.view.getPerimeterPoint(t, i, !1);
    } else l += o, this.getModel().isVertex(t.cell) && (o = 1 == t.style[mxConstants.STYLE_FLIPH], r = 1 == t.style[mxConstants.STYLE_FLIPV], null != t.shape && null != t.shape.stencil && (o = 1 == mxUtils.getValue(t.style, "stencilFlipH", 0) || o, r = 1 == mxUtils.getValue(t.style, "stencilFlipV", 0) || r), o && (i.x = 2 * n.getCenterX() - i.x), r && (i.y = 2 * n.getCenterY() - i.y));

    0 != l && null != i && (l = mxUtils.toRadians(l), n = Math.cos(l), r = Math.sin(l), i = mxUtils.getRotatedPoint(i, n, r, s));
  }

  return null != i && (i.x = Math.round(i.x), i.y = Math.round(i.y)), i;
}, mxGraph.prototype.connectCell = function (t, e, i, n) {
  this.model.beginUpdate();

  try {
    var s = this.model.getTerminal(t, i);
    this.cellConnected(t, e, i, n), this.fireEvent(new mxEventObject(mxEvent.CONNECT_CELL, "edge", t, "terminal", e, "source", i, "previous", s));
  } finally {
    this.model.endUpdate();
  }

  return t;
}, mxGraph.prototype.cellConnected = function (t, e, i, n) {
  if (null != t) {
    this.model.beginUpdate();

    try {
      var s = this.model.getTerminal(t, i);
      this.setConnectionConstraint(t, e, i, n), this.isPortsEnabled() && (n = null, this.isPort(e) && (n = e.getId(), e = this.getTerminalForPort(e, i)), this.setCellStyles(i ? mxConstants.STYLE_SOURCE_PORT : mxConstants.STYLE_TARGET_PORT, n, [t])), this.model.setTerminal(t, e, i), this.resetEdgesOnConnect && this.resetEdge(t), this.fireEvent(new mxEventObject(mxEvent.CELL_CONNECTED, "edge", t, "terminal", e, "source", i, "previous", s));
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.disconnectGraph = function (t) {
  if (null != t) {
    this.model.beginUpdate();

    try {
      for (var e = this.view.scale, i = this.view.translate, n = new mxDictionary(), s = 0; s < t.length; s++) {
        n.put(t[s], !0);
      }

      for (s = 0; s < t.length; s++) {
        if (this.model.isEdge(t[s])) {
          if (null != (r = this.model.getGeometry(t[s]))) {
            var o = this.view.getState(t[s]),
                l = this.view.getState(this.model.getParent(t[s]));

            if (null != o && null != l) {
              var r = r.clone(),
                  a = -l.origin.x,
                  h = -l.origin.y,
                  u = o.absolutePoints,
                  d = this.model.getTerminal(t[s], !0);

              if (null != d && this.isCellDisconnectable(t[s], d, !0)) {
                for (; null != d && !n.get(d);) {
                  d = this.model.getParent(d);
                }

                null == d && (r.setTerminalPoint(new mxPoint(u[0].x / e - i.x + a, u[0].y / e - i.y + h), !0), this.model.setTerminal(t[s], null, !0));
              }

              var p = this.model.getTerminal(t[s], !1);

              if (null != p && this.isCellDisconnectable(t[s], p, !1)) {
                for (; null != p && !n.get(p);) {
                  p = this.model.getParent(p);
                }

                if (null == p) {
                  var c = u.length - 1;
                  r.setTerminalPoint(new mxPoint(u[c].x / e - i.x + a, u[c].y / e - i.y + h), !1), this.model.setTerminal(t[s], null, !1);
                }
              }

              this.model.setGeometry(t[s], r);
            }
          }
        }
      }
    } finally {
      this.model.endUpdate();
    }
  }
}, mxGraph.prototype.getCurrentRoot = function () {
  return this.view.currentRoot;
}, mxGraph.prototype.getTranslateForRoot = function (t) {
  return null;
}, mxGraph.prototype.isPort = function (t) {
  return !1;
}, mxGraph.prototype.getTerminalForPort = function (t, e) {
  return this.model.getParent(t);
}, mxGraph.prototype.getChildOffsetForCell = function (t) {
  return null;
}, mxGraph.prototype.enterGroup = function (t) {
  null != (t = t || this.getSelectionCell()) && this.isValidRoot(t) && (this.view.setCurrentRoot(t), this.clearSelection());
}, mxGraph.prototype.exitGroup = function () {
  var t = this.model.getRoot(),
      e = this.getCurrentRoot();

  if (null != e) {
    for (var i = this.model.getParent(e); i != t && !this.isValidRoot(i) && this.model.getParent(i) != t;) {
      i = this.model.getParent(i);
    }

    i == t || this.model.getParent(i) == t ? this.view.setCurrentRoot(null) : this.view.setCurrentRoot(i), null != this.view.getState(e) && this.setSelectionCell(e);
  }
}, mxGraph.prototype.home = function () {
  var t = this.getCurrentRoot();
  null != t && (this.view.setCurrentRoot(null), null != this.view.getState(t) && this.setSelectionCell(t));
}, mxGraph.prototype.isValidRoot = function (t) {
  return null != t;
}, mxGraph.prototype.getGraphBounds = function () {
  return this.view.getGraphBounds();
}, mxGraph.prototype.getCellBounds = function (t, e, i) {
  var n = [t];

  if (e && (n = n.concat(this.model.getEdges(t))), n = this.view.getBounds(n), i) {
    i = this.model.getChildCount(t);

    for (var s = 0; s < i; s++) {
      var o = this.getCellBounds(this.model.getChildAt(t, s), e, !0);
      null != n ? n.add(o) : n = o;
    }
  }

  return n;
}, mxGraph.prototype.getBoundingBoxFromGeometry = function (t, e) {
  e = null != e && e;
  var i = null;
  if (null != t) for (var n = 0; n < t.length; n++) {
    if (e || this.model.isVertex(t[n])) {
      var s = this.getCellGeometry(t[n]);

      if (null != s) {
        var o = null;

        if (this.model.isEdge(t[n])) {
          if (o = function o(t) {
            null != t && (null == l ? l = new mxRectangle(t.x, t.y, 0, 0) : l.add(new mxRectangle(t.x, t.y, 0, 0)));
          }, null == this.model.getTerminal(t[n], !0) && o(s.getTerminalPoint(!0)), null == this.model.getTerminal(t[n], !1) && o(s.getTerminalPoint(!1)), null != (s = s.points) && 0 < s.length) for (var l = new mxRectangle(s[0].x, s[0].y, 0, 0), r = 1; r < s.length; r++) {
            o(s[r]);
          }
          o = l;
        } else r = this.model.getParent(t[n]), s.relative ? this.model.isVertex(r) && r != this.view.currentRoot && null != (l = this.getBoundingBoxFromGeometry([r], !1)) && (o = new mxRectangle(s.x * l.width, s.y * l.height, s.width, s.height), 0 <= mxUtils.indexOf(t, r) && (o.x += l.x, o.y += l.y)) : (o = mxRectangle.fromRectangle(s), this.model.isVertex(r) && 0 <= mxUtils.indexOf(t, r) && null != (l = this.getBoundingBoxFromGeometry([r], !1)) && (o.x += l.x, o.y += l.y)), null != o && null != s.offset && (o.x += s.offset.x, o.y += s.offset.y);

        null != o && (null == i ? i = mxRectangle.fromRectangle(o) : i.add(o));
      }
    }
  }
  return i;
}, mxGraph.prototype.refresh = function (t) {
  this.view.clear(t, null == t), this.view.validate(), this.sizeDidChange(), this.fireEvent(new mxEventObject(mxEvent.REFRESH));
}, mxGraph.prototype.snap = function (t) {
  return this.gridEnabled && (t = Math.round(t / this.gridSize) * this.gridSize), t;
}, mxGraph.prototype.panGraph = function (t, e) {
  if (this.useScrollbarsForPanning && mxUtils.hasScrollbars(this.container)) this.container.scrollLeft = -t, this.container.scrollTop = -e;else {
    var i = this.view.getCanvas();
    if (this.dialect == mxConstants.DIALECT_SVG) {
      if (0 == t && 0 == e) {
        if (mxClient.IS_IE ? i.setAttribute("transform", "translate(" + t + "," + e + ")") : i.removeAttribute("transform"), null != this.shiftPreview1) {
          for (var n = this.shiftPreview1.firstChild; null != n;) {
            var s = n.nextSibling;
            this.container.appendChild(n), n = s;
          }

          for (null != this.shiftPreview1.parentNode && this.shiftPreview1.parentNode.removeChild(this.shiftPreview1), this.shiftPreview1 = null, this.container.appendChild(i.parentNode), n = this.shiftPreview2.firstChild; null != n;) {
            s = n.nextSibling, this.container.appendChild(n), n = s;
          }

          null != this.shiftPreview2.parentNode && this.shiftPreview2.parentNode.removeChild(this.shiftPreview2), this.shiftPreview2 = null;
        }
      } else {
        if (i.setAttribute("transform", "translate(" + t + "," + e + ")"), null == this.shiftPreview1) {
          this.shiftPreview1 = document.createElement("div"), this.shiftPreview1.style.position = "absolute", this.shiftPreview1.style.overflow = "visible", this.shiftPreview2 = document.createElement("div"), this.shiftPreview2.style.position = "absolute", this.shiftPreview2.style.overflow = "visible";
          var o = this.shiftPreview1;

          for (n = this.container.firstChild; null != n;) {
            s = n.nextSibling, n != i.parentNode ? o.appendChild(n) : o = this.shiftPreview2, n = s;
          }

          null != this.shiftPreview1.firstChild && this.container.insertBefore(this.shiftPreview1, i.parentNode), null != this.shiftPreview2.firstChild && this.container.appendChild(this.shiftPreview2);
        }

        this.shiftPreview1.style.left = t + "px", this.shiftPreview1.style.top = e + "px", this.shiftPreview2.style.left = t + "px", this.shiftPreview2.style.top = e + "px";
      }
    } else i.style.left = t + "px", i.style.top = e + "px";
    this.panDx = t, this.panDy = e, this.fireEvent(new mxEventObject(mxEvent.PAN));
  }
}, mxGraph.prototype.zoomIn = function () {
  this.zoom(this.zoomFactor);
}, mxGraph.prototype.zoomOut = function () {
  this.zoom(1 / this.zoomFactor);
}, mxGraph.prototype.zoomActual = function () {
  1 == this.view.scale ? this.view.setTranslate(0, 0) : (this.view.translate.x = 0, this.view.translate.y = 0, this.view.setScale(1));
}, mxGraph.prototype.zoomTo = function (t, e) {
  this.zoom(t / this.view.scale, e);
}, mxGraph.prototype.center = function (t, e, i, n) {
  t = null == t || t, e = null == e || e, i = null != i ? i : .5, n = null != n ? n : .5;
  var s = mxUtils.hasScrollbars(this.container),
      o = this.container.clientWidth,
      l = this.container.clientHeight,
      r = this.getGraphBounds(),
      a = this.view.translate,
      h = this.view.scale,
      u = t ? o - r.width : 0,
      d = e ? l - r.height : 0;
  s ? (r.x -= a.x, r.y -= a.y, (t = this.container.scrollWidth) > o && (u = 0), (e = this.container.scrollHeight) > l && (d = 0), this.view.setTranslate(Math.floor(u / 2 - r.x), Math.floor(d / 2 - r.y)), this.container.scrollLeft = (t - o) / 2, this.container.scrollTop = (e - l) / 2) : this.view.setTranslate(t ? Math.floor(a.x - r.x * h + u * i / h) : a.x, e ? Math.floor(a.y - r.y * h + d * n / h) : a.y);
}, mxGraph.prototype.zoom = function (t, e) {
  e = null != e ? e : this.centerZoom;
  var i = Math.round(this.view.scale * t * 100) / 100,
      n = this.view.getState(this.getSelectionCell());
  if (t = i / this.view.scale, this.keepSelectionVisibleOnZoom && null != n) n = new mxRectangle(n.x * t, n.y * t, n.width * t, n.height * t), this.view.scale = i, this.scrollRectToVisible(n) || (this.view.revalidate(), this.view.setScale(i));else if (n = mxUtils.hasScrollbars(this.container), e && !n) {
    n = this.container.offsetWidth;
    var s = this.container.offsetHeight;
    if (1 < t) n = n * -(o = (t - 1) / (2 * i)), s = s * -o;else n *= o = (1 / t - 1) / (2 * this.view.scale), s *= o;
    this.view.scaleAndTranslate(i, this.view.translate.x + n, this.view.translate.y + s);
  } else {
    var o = this.view.translate.x,
        l = this.view.translate.y,
        r = this.container.scrollLeft,
        a = this.container.scrollTop;
    this.view.setScale(i), n && (s = n = 0, e && (n = this.container.offsetWidth * (t - 1) / 2, s = this.container.offsetHeight * (t - 1) / 2), this.container.scrollLeft = (this.view.translate.x - o) * this.view.scale + Math.round(r * t + n), this.container.scrollTop = (this.view.translate.y - l) * this.view.scale + Math.round(a * t + s));
  }
}, mxGraph.prototype.zoomToRect = function (t) {
  var e = this.container.clientWidth / t.width / (this.container.clientHeight / t.height);
  t.x = Math.max(0, t.x), t.y = Math.max(0, t.y);
  var i = Math.min(this.container.scrollWidth, t.x + t.width),
      n = Math.min(this.container.scrollHeight, t.y + t.height);
  t.width = i - t.x, t.height = n - t.y, 1 > e ? (i = ((e = t.height / e) - t.height) / 2, t.height = e, t.y -= Math.min(t.y, i), n = Math.min(this.container.scrollHeight, t.y + t.height), t.height = n - t.y) : (i = ((e *= t.width) - t.width) / 2, t.width = e, t.x -= Math.min(t.x, i), i = Math.min(this.container.scrollWidth, t.x + t.width), t.width = i - t.x), e = this.container.clientWidth / t.width, i = this.view.scale * e, mxUtils.hasScrollbars(this.container) ? (this.view.setScale(i), this.container.scrollLeft = Math.round(t.x * e), this.container.scrollTop = Math.round(t.y * e)) : this.view.scaleAndTranslate(i, this.view.translate.x - t.x / this.view.scale, this.view.translate.y - t.y / this.view.scale);
}, mxGraph.prototype.scrollCellToVisible = function (t, e) {
  var i = -this.view.translate.x,
      n = -this.view.translate.y,
      s = this.view.getState(t);
  null != s && (i = new mxRectangle(i + s.x, n + s.y, s.width, s.height), e && null != this.container && (n = this.container.clientWidth, s = this.container.clientHeight, i.x = i.getCenterX() - n / 2, i.width = n, i.y = i.getCenterY() - s / 2, i.height = s), n = new mxPoint(this.view.translate.x, this.view.translate.y), this.scrollRectToVisible(i) && (i = new mxPoint(this.view.translate.x, this.view.translate.y), this.view.translate.x = n.x, this.view.translate.y = n.y, this.view.setTranslate(i.x, i.y)));
}, mxGraph.prototype.scrollRectToVisible = function (t) {
  var e = !1;

  if (null != t) {
    var i = this.container.offsetWidth,
        n = this.container.offsetHeight,
        s = Math.min(i, t.width),
        o = Math.min(n, t.height);

    if (mxUtils.hasScrollbars(this.container)) {
      i = this.container, t.x += this.view.translate.x, t.y += this.view.translate.y;
      var l = i.scrollLeft - t.x;
      n = Math.max(l - i.scrollLeft, 0);
      0 < l ? i.scrollLeft -= l + 2 : 0 < (l = t.x + s - i.scrollLeft - i.clientWidth) && (i.scrollLeft += l + 2), s = i.scrollTop - t.y, l = Math.max(0, s - i.scrollTop), 0 < s ? i.scrollTop -= s + 2 : 0 < (s = t.y + o - i.scrollTop - i.clientHeight) && (i.scrollTop += s + 2), this.useScrollbarsForPanning || 0 == n && 0 == l || this.view.setTranslate(n, l);
    } else {
      l = -this.view.translate.x;
      var r = -this.view.translate.y,
          a = this.view.scale;
      t.x + s > l + i && (this.view.translate.x -= (t.x + s - i - l) / a, e = !0), t.y + o > r + n && (this.view.translate.y -= (t.y + o - n - r) / a, e = !0), t.x < l && (this.view.translate.x += (l - t.x) / a, e = !0), t.y < r && (this.view.translate.y += (r - t.y) / a, e = !0), e && (this.view.refresh(), null != this.selectionCellsHandler && this.selectionCellsHandler.refresh());
    }
  }

  return e;
}, mxGraph.prototype.getCellGeometry = function (t) {
  return this.model.getGeometry(t);
}, mxGraph.prototype.isCellVisible = function (t) {
  return this.model.isVisible(t);
}, mxGraph.prototype.isCellCollapsed = function (t) {
  return this.model.isCollapsed(t);
}, mxGraph.prototype.isCellConnectable = function (t) {
  return this.model.isConnectable(t);
}, mxGraph.prototype.isOrthogonal = function (t) {
  var e = t.style[mxConstants.STYLE_ORTHOGONAL];
  return null != e ? e : (t = this.view.getEdgeStyle(t)) == mxEdgeStyle.SegmentConnector || t == mxEdgeStyle.ElbowConnector || t == mxEdgeStyle.SideToSide || t == mxEdgeStyle.TopToBottom || t == mxEdgeStyle.EntityRelation || t == mxEdgeStyle.OrthConnector;
}, mxGraph.prototype.isLoop = function (t) {
  var e = t.getVisibleTerminalState(!0);
  return t = t.getVisibleTerminalState(!1), null != e && e == t;
}, mxGraph.prototype.isCloneEvent = function (t) {
  return mxEvent.isControlDown(t);
}, mxGraph.prototype.isTransparentClickEvent = function (t) {
  return !1;
}, mxGraph.prototype.isToggleEvent = function (t) {
  return mxClient.IS_MAC ? mxEvent.isMetaDown(t) : mxEvent.isControlDown(t);
}, mxGraph.prototype.isGridEnabledEvent = function (t) {
  return null != t && !mxEvent.isAltDown(t);
}, mxGraph.prototype.isConstrainedEvent = function (t) {
  return mxEvent.isShiftDown(t);
}, mxGraph.prototype.isIgnoreTerminalEvent = function (t) {
  return !1;
}, mxGraph.prototype.validationAlert = function (t) {
  mxUtils.alert(t);
}, mxGraph.prototype.isEdgeValid = function (t, e, i) {
  return null == this.getEdgeValidationError(t, e, i);
}, mxGraph.prototype.getEdgeValidationError = function (t, e, i) {
  if (null != t && !this.isAllowDanglingEdges() && (null == e || null == i)) return "";
  if (null != t && null == this.model.getTerminal(t, !0) && null == this.model.getTerminal(t, !1)) return null;
  if (!this.allowLoops && e == i && null != e || !this.isValidConnection(e, i)) return "";

  if (null != e && null != i) {
    var n = "";
    if (!this.multigraph) (1 < (s = this.model.getEdgesBetween(e, i, !0)).length || 1 == s.length && s[0] != t) && (n += (mxResources.get(this.alreadyConnectedResource) || this.alreadyConnectedResource) + "\n");
    var s = this.model.getDirectedEdgeCount(e, !0, t),
        o = this.model.getDirectedEdgeCount(i, !1, t);
    if (null != this.multiplicities) for (var l = 0; l < this.multiplicities.length; l++) {
      var r = this.multiplicities[l].check(this, t, e, i, s, o);
      null != r && (n += r);
    }
    return null != (r = this.validateEdge(t, e, i)) && (n += r), 0 < n.length ? n : null;
  }

  return this.allowDanglingEdges ? null : "";
}, mxGraph.prototype.validateEdge = function (t, e, i) {
  return null;
}, mxGraph.prototype.validateGraph = function (t, e) {
  t = null != t ? t : this.model.getRoot(), e = null != e ? e : {};

  for (var i = !0, n = this.model.getChildCount(t), s = 0; s < n; s++) {
    var o = this.model.getChildAt(t, s),
        l = e;
    this.isValidRoot(o) && (l = {}), null != (l = this.validateGraph(o, l)) ? this.setCellWarning(o, l.replace(/\n/g, "<br>")) : this.setCellWarning(o, null), i = i && null == l;
  }

  return n = "", this.isCellCollapsed(t) && !i && (n += (mxResources.get(this.containsValidationErrorsResource) || this.containsValidationErrorsResource) + "\n"), n = this.model.isEdge(t) ? n + (this.getEdgeValidationError(t, this.model.getTerminal(t, !0), this.model.getTerminal(t, !1)) || "") : n + (this.getCellValidationError(t) || ""), null != (s = this.validateCell(t, e)) && (n += s), null == this.model.getParent(t) && this.view.validate(), 0 < n.length || !i ? n : null;
}, mxGraph.prototype.getCellValidationError = function (t) {
  var e = this.model.getDirectedEdgeCount(t, !0),
      i = this.model.getDirectedEdgeCount(t, !1);
  t = this.model.getValue(t);
  var n = "";
  if (null != this.multiplicities) for (var s = 0; s < this.multiplicities.length; s++) {
    var o = this.multiplicities[s];
    o.source && mxUtils.isNode(t, o.type, o.attr, o.value) && (e > o.max || e < o.min) ? n += o.countError + "\n" : !o.source && mxUtils.isNode(t, o.type, o.attr, o.value) && (i > o.max || i < o.min) && (n += o.countError + "\n");
  }
  return 0 < n.length ? n : null;
}, mxGraph.prototype.validateCell = function (t, e) {
  return null;
}, mxGraph.prototype.getBackgroundImage = function () {
  return this.backgroundImage;
}, mxGraph.prototype.setBackgroundImage = function (t) {
  this.backgroundImage = t;
}, mxGraph.prototype.getFoldingImage = function (t) {
  if (null != t && this.foldingEnabled && !this.getModel().isEdge(t.cell)) {
    var e = this.isCellCollapsed(t.cell);
    if (this.isCellFoldable(t.cell, !e)) return e ? this.collapsedImage : this.expandedImage;
  }

  return null;
}, mxGraph.prototype.convertValueToString = function (t) {
  if (null != (t = this.model.getValue(t))) {
    if (mxUtils.isNode(t)) return t.nodeName;
    if ("function" == typeof t.toString) return t.toString();
  }

  return "";
}, mxGraph.prototype.getLabel = function (t) {
  var e = "";

  if (this.labelsVisible && null != t) {
    var i = null != (i = this.view.getState(t)) ? i.style : this.getCellStyle(t);
    mxUtils.getValue(i, mxConstants.STYLE_NOLABEL, !1) || (e = this.convertValueToString(t));
  }

  return e;
}, mxGraph.prototype.isHtmlLabel = function (t) {
  return this.isHtmlLabels();
}, mxGraph.prototype.isHtmlLabels = function () {
  return this.htmlLabels;
}, mxGraph.prototype.setHtmlLabels = function (t) {
  this.htmlLabels = t;
}, mxGraph.prototype.isWrapping = function (t) {
  var e = this.view.getState(t);
  return null != (t = null != e ? e.style : this.getCellStyle(t)) && "wrap" == t[mxConstants.STYLE_WHITE_SPACE];
}, mxGraph.prototype.isLabelClipped = function (t) {
  var e = this.view.getState(t);
  return null != (t = null != e ? e.style : this.getCellStyle(t)) && "hidden" == t[mxConstants.STYLE_OVERFLOW];
}, mxGraph.prototype.getTooltip = function (t, e, i, n) {
  var s = null;
  return null != t && (null == t.control || e != t.control.node && e.parentNode != t.control.node || (s = this.collapseExpandResource, s = mxUtils.htmlEntities(mxResources.get(s) || s).replace(/\\n/g, "<br>")), null == s && null != t.overlays && t.overlays.visit(function (t, i) {
    null != s || e != i.node && e.parentNode != i.node || (s = i.overlay.toString());
  }), null == s && null != (i = this.selectionCellsHandler.getHandler(t.cell)) && "function" == typeof i.getTooltipForNode && (s = i.getTooltipForNode(e)), null == s && (s = this.getTooltipForCell(t.cell))), s;
}, mxGraph.prototype.getTooltipForCell = function (t) {
  return null != t && null != t.getTooltip ? t.getTooltip() : this.convertValueToString(t);
}, mxGraph.prototype.getLinkForCell = function (t) {
  return null;
}, mxGraph.prototype.getCursorForMouseEvent = function (t) {
  return this.getCursorForCell(t.getCell());
}, mxGraph.prototype.getCursorForCell = function (t) {
  return null;
}, mxGraph.prototype.getStartSize = function (t) {
  var e = new mxRectangle(),
      i = this.view.getState(t);
  return null != (t = null != i ? i.style : this.getCellStyle(t)) && (i = parseInt(mxUtils.getValue(t, mxConstants.STYLE_STARTSIZE, mxConstants.DEFAULT_STARTSIZE)), mxUtils.getValue(t, mxConstants.STYLE_HORIZONTAL, !0) ? e.height = i : e.width = i), e;
}, mxGraph.prototype.getImage = function (t) {
  return null != t && null != t.style ? t.style[mxConstants.STYLE_IMAGE] : null;
}, mxGraph.prototype.getVerticalAlign = function (t) {
  return null != t && null != t.style ? t.style[mxConstants.STYLE_VERTICAL_ALIGN] || mxConstants.ALIGN_MIDDLE : null;
}, mxGraph.prototype.getIndicatorColor = function (t) {
  return null != t && null != t.style ? t.style[mxConstants.STYLE_INDICATOR_COLOR] : null;
}, mxGraph.prototype.getIndicatorGradientColor = function (t) {
  return null != t && null != t.style ? t.style[mxConstants.STYLE_INDICATOR_GRADIENTCOLOR] : null;
}, mxGraph.prototype.getIndicatorShape = function (t) {
  return null != t && null != t.style ? t.style[mxConstants.STYLE_INDICATOR_SHAPE] : null;
}, mxGraph.prototype.getIndicatorImage = function (t) {
  return null != t && null != t.style ? t.style[mxConstants.STYLE_INDICATOR_IMAGE] : null;
}, mxGraph.prototype.getBorder = function () {
  return this.border;
}, mxGraph.prototype.setBorder = function (t) {
  this.border = t;
}, mxGraph.prototype.isSwimlane = function (t) {
  var e;
  if (null != t && this.model.getParent(t) != this.model.getRoot() && null != (e = null != (e = this.view.getState(t)) ? e.style : this.getCellStyle(t)) && !this.model.isEdge(t)) return e[mxConstants.STYLE_SHAPE] == mxConstants.SHAPE_SWIMLANE;
  return !1;
}, mxGraph.prototype.isResizeContainer = function () {
  return this.resizeContainer;
}, mxGraph.prototype.setResizeContainer = function (t) {
  this.resizeContainer = t;
}, mxGraph.prototype.isEnabled = function () {
  return this.enabled;
}, mxGraph.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxGraph.prototype.isEscapeEnabled = function () {
  return this.escapeEnabled;
}, mxGraph.prototype.setEscapeEnabled = function (t) {
  this.escapeEnabled = t;
}, mxGraph.prototype.isInvokesStopCellEditing = function () {
  return this.invokesStopCellEditing;
}, mxGraph.prototype.setInvokesStopCellEditing = function (t) {
  this.invokesStopCellEditing = t;
}, mxGraph.prototype.isEnterStopsCellEditing = function () {
  return this.enterStopsCellEditing;
}, mxGraph.prototype.setEnterStopsCellEditing = function (t) {
  this.enterStopsCellEditing = t;
}, mxGraph.prototype.isCellLocked = function (t) {
  var e = this.model.getGeometry(t);
  return this.isCellsLocked() || null != e && this.model.isVertex(t) && e.relative;
}, mxGraph.prototype.isCellsLocked = function () {
  return this.cellsLocked;
}, mxGraph.prototype.setCellsLocked = function (t) {
  this.cellsLocked = t;
}, mxGraph.prototype.getCloneableCells = function (t) {
  return this.model.filterCells(t, mxUtils.bind(this, function (t) {
    return this.isCellCloneable(t);
  }));
}, mxGraph.prototype.isCellCloneable = function (t) {
  var e = this.view.getState(t);
  return t = null != e ? e.style : this.getCellStyle(t), this.isCellsCloneable() && 0 != t[mxConstants.STYLE_CLONEABLE];
}, mxGraph.prototype.isCellsCloneable = function () {
  return this.cellsCloneable;
}, mxGraph.prototype.setCellsCloneable = function (t) {
  this.cellsCloneable = t;
}, mxGraph.prototype.getExportableCells = function (t) {
  return this.model.filterCells(t, mxUtils.bind(this, function (t) {
    return this.canExportCell(t);
  }));
}, mxGraph.prototype.canExportCell = function (t) {
  return this.exportEnabled;
}, mxGraph.prototype.getImportableCells = function (t) {
  return this.model.filterCells(t, mxUtils.bind(this, function (t) {
    return this.canImportCell(t);
  }));
}, mxGraph.prototype.canImportCell = function (t) {
  return this.importEnabled;
}, mxGraph.prototype.isCellSelectable = function (t) {
  return this.isCellsSelectable();
}, mxGraph.prototype.isCellsSelectable = function () {
  return this.cellsSelectable;
}, mxGraph.prototype.setCellsSelectable = function (t) {
  this.cellsSelectable = t;
}, mxGraph.prototype.getDeletableCells = function (t) {
  return this.model.filterCells(t, mxUtils.bind(this, function (t) {
    return this.isCellDeletable(t);
  }));
}, mxGraph.prototype.isCellDeletable = function (t) {
  var e = this.view.getState(t);
  return t = null != e ? e.style : this.getCellStyle(t), this.isCellsDeletable() && 0 != t[mxConstants.STYLE_DELETABLE];
}, mxGraph.prototype.isCellsDeletable = function () {
  return this.cellsDeletable;
}, mxGraph.prototype.setCellsDeletable = function (t) {
  this.cellsDeletable = t;
}, mxGraph.prototype.isLabelMovable = function (t) {
  return !this.isCellLocked(t) && (this.model.isEdge(t) && this.edgeLabelsMovable || this.model.isVertex(t) && this.vertexLabelsMovable);
}, mxGraph.prototype.isCellRotatable = function (t) {
  var e = this.view.getState(t);
  return 0 != (null != e ? e.style : this.getCellStyle(t))[mxConstants.STYLE_ROTATABLE];
}, mxGraph.prototype.getMovableCells = function (t) {
  return this.model.filterCells(t, mxUtils.bind(this, function (t) {
    return this.isCellMovable(t);
  }));
}, mxGraph.prototype.isCellMovable = function (t) {
  var e = null != (e = this.view.getState(t)) ? e.style : this.getCellStyle(t);
  return this.isCellsMovable() && !this.isCellLocked(t) && 0 != e[mxConstants.STYLE_MOVABLE];
}, mxGraph.prototype.isCellsMovable = function () {
  return this.cellsMovable;
}, mxGraph.prototype.setCellsMovable = function (t) {
  this.cellsMovable = t;
}, mxGraph.prototype.isGridEnabled = function () {
  return this.gridEnabled;
}, mxGraph.prototype.setGridEnabled = function (t) {
  this.gridEnabled = t;
}, mxGraph.prototype.isPortsEnabled = function () {
  return this.portsEnabled;
}, mxGraph.prototype.setPortsEnabled = function (t) {
  this.portsEnabled = t;
}, mxGraph.prototype.getGridSize = function () {
  return this.gridSize;
}, mxGraph.prototype.setGridSize = function (t) {
  this.gridSize = t;
}, mxGraph.prototype.getTolerance = function () {
  return this.tolerance;
}, mxGraph.prototype.setTolerance = function (t) {
  this.tolerance = t;
}, mxGraph.prototype.isVertexLabelsMovable = function () {
  return this.vertexLabelsMovable;
}, mxGraph.prototype.setVertexLabelsMovable = function (t) {
  this.vertexLabelsMovable = t;
}, mxGraph.prototype.isEdgeLabelsMovable = function () {
  return this.edgeLabelsMovable;
}, mxGraph.prototype.setEdgeLabelsMovable = function (t) {
  this.edgeLabelsMovable = t;
}, mxGraph.prototype.isSwimlaneNesting = function () {
  return this.swimlaneNesting;
}, mxGraph.prototype.setSwimlaneNesting = function (t) {
  this.swimlaneNesting = t;
}, mxGraph.prototype.isSwimlaneSelectionEnabled = function () {
  return this.swimlaneSelectionEnabled;
}, mxGraph.prototype.setSwimlaneSelectionEnabled = function (t) {
  this.swimlaneSelectionEnabled = t;
}, mxGraph.prototype.isMultigraph = function () {
  return this.multigraph;
}, mxGraph.prototype.setMultigraph = function (t) {
  this.multigraph = t;
}, mxGraph.prototype.isAllowLoops = function () {
  return this.allowLoops;
}, mxGraph.prototype.setAllowDanglingEdges = function (t) {
  this.allowDanglingEdges = t;
}, mxGraph.prototype.isAllowDanglingEdges = function () {
  return this.allowDanglingEdges;
}, mxGraph.prototype.setConnectableEdges = function (t) {
  this.connectableEdges = t;
}, mxGraph.prototype.isConnectableEdges = function () {
  return this.connectableEdges;
}, mxGraph.prototype.setCloneInvalidEdges = function (t) {
  this.cloneInvalidEdges = t;
}, mxGraph.prototype.isCloneInvalidEdges = function () {
  return this.cloneInvalidEdges;
}, mxGraph.prototype.setAllowLoops = function (t) {
  this.allowLoops = t;
}, mxGraph.prototype.isDisconnectOnMove = function () {
  return this.disconnectOnMove;
}, mxGraph.prototype.setDisconnectOnMove = function (t) {
  this.disconnectOnMove = t;
}, mxGraph.prototype.isDropEnabled = function () {
  return this.dropEnabled;
}, mxGraph.prototype.setDropEnabled = function (t) {
  this.dropEnabled = t;
}, mxGraph.prototype.isSplitEnabled = function () {
  return this.splitEnabled;
}, mxGraph.prototype.setSplitEnabled = function (t) {
  this.splitEnabled = t;
}, mxGraph.prototype.isCellResizable = function (t) {
  var e = null != (e = this.view.getState(t)) ? e.style : this.getCellStyle(t);
  return this.isCellsResizable() && !this.isCellLocked(t) && "0" != mxUtils.getValue(e, mxConstants.STYLE_RESIZABLE, "1");
}, mxGraph.prototype.isCellsResizable = function () {
  return this.cellsResizable;
}, mxGraph.prototype.setCellsResizable = function (t) {
  this.cellsResizable = t;
}, mxGraph.prototype.isTerminalPointMovable = function (t, e) {
  return !0;
}, mxGraph.prototype.isCellBendable = function (t) {
  var e = null != (e = this.view.getState(t)) ? e.style : this.getCellStyle(t);
  return this.isCellsBendable() && !this.isCellLocked(t) && 0 != e[mxConstants.STYLE_BENDABLE];
}, mxGraph.prototype.isCellsBendable = function () {
  return this.cellsBendable;
}, mxGraph.prototype.setCellsBendable = function (t) {
  this.cellsBendable = t;
}, mxGraph.prototype.isCellEditable = function (t) {
  var e = null != (e = this.view.getState(t)) ? e.style : this.getCellStyle(t);
  return this.isCellsEditable() && !this.isCellLocked(t) && 0 != e[mxConstants.STYLE_EDITABLE];
}, mxGraph.prototype.isCellsEditable = function () {
  return this.cellsEditable;
}, mxGraph.prototype.setCellsEditable = function (t) {
  this.cellsEditable = t;
}, mxGraph.prototype.isCellDisconnectable = function (t, e, i) {
  return this.isCellsDisconnectable() && !this.isCellLocked(t);
}, mxGraph.prototype.isCellsDisconnectable = function () {
  return this.cellsDisconnectable;
}, mxGraph.prototype.setCellsDisconnectable = function (t) {
  this.cellsDisconnectable = t;
}, mxGraph.prototype.isValidSource = function (t) {
  return null == t && this.allowDanglingEdges || null != t && (!this.model.isEdge(t) || this.connectableEdges) && this.isCellConnectable(t);
}, mxGraph.prototype.isValidTarget = function (t) {
  return this.isValidSource(t);
}, mxGraph.prototype.isValidConnection = function (t, e) {
  return this.isValidSource(t) && this.isValidTarget(e);
}, mxGraph.prototype.setConnectable = function (t) {
  this.connectionHandler.setEnabled(t);
}, mxGraph.prototype.isConnectable = function (t) {
  return this.connectionHandler.isEnabled();
}, mxGraph.prototype.setTooltips = function (t) {
  this.tooltipHandler.setEnabled(t);
}, mxGraph.prototype.setPanning = function (t) {
  this.panningHandler.panningEnabled = t;
}, mxGraph.prototype.isEditing = function (t) {
  if (null != this.cellEditor) {
    var e = this.cellEditor.getEditingCell();
    return null == t ? null != e : t == e;
  }

  return !1;
}, mxGraph.prototype.isAutoSizeCell = function (t) {
  var e = this.view.getState(t);
  return t = null != e ? e.style : this.getCellStyle(t), this.isAutoSizeCells() || 1 == t[mxConstants.STYLE_AUTOSIZE];
}, mxGraph.prototype.isAutoSizeCells = function () {
  return this.autoSizeCells;
}, mxGraph.prototype.setAutoSizeCells = function (t) {
  this.autoSizeCells = t;
}, mxGraph.prototype.isExtendParent = function (t) {
  return !this.getModel().isEdge(t) && this.isExtendParents();
}, mxGraph.prototype.isExtendParents = function () {
  return this.extendParents;
}, mxGraph.prototype.setExtendParents = function (t) {
  this.extendParents = t;
}, mxGraph.prototype.isExtendParentsOnAdd = function (t) {
  return this.extendParentsOnAdd;
}, mxGraph.prototype.setExtendParentsOnAdd = function (t) {
  this.extendParentsOnAdd = t;
}, mxGraph.prototype.isExtendParentsOnMove = function () {
  return this.extendParentsOnMove;
}, mxGraph.prototype.setExtendParentsOnMove = function (t) {
  this.extendParentsOnMove = t;
}, mxGraph.prototype.isRecursiveResize = function (t) {
  return this.recursiveResize;
}, mxGraph.prototype.setRecursiveResize = function (t) {
  this.recursiveResize = t;
}, mxGraph.prototype.isConstrainChild = function (t) {
  return this.isConstrainChildren() && !this.getModel().isEdge(this.getModel().getParent(t));
}, mxGraph.prototype.isConstrainChildren = function () {
  return this.constrainChildren;
}, mxGraph.prototype.setConstrainChildren = function (t) {
  this.constrainChildren = t;
}, mxGraph.prototype.isConstrainRelativeChildren = function () {
  return this.constrainRelativeChildren;
}, mxGraph.prototype.setConstrainRelativeChildren = function (t) {
  this.constrainRelativeChildren = t;
}, mxGraph.prototype.isAllowNegativeCoordinates = function () {
  return this.allowNegativeCoordinates;
}, mxGraph.prototype.setAllowNegativeCoordinates = function (t) {
  this.allowNegativeCoordinates = t;
}, mxGraph.prototype.getOverlap = function (t) {
  return this.isAllowOverlapParent(t) ? this.defaultOverlap : 0;
}, mxGraph.prototype.isAllowOverlapParent = function (t) {
  return !1;
}, mxGraph.prototype.getFoldableCells = function (t, e) {
  return this.model.filterCells(t, mxUtils.bind(this, function (t) {
    return this.isCellFoldable(t, e);
  }));
}, mxGraph.prototype.isCellFoldable = function (t, e) {
  var i = null != (i = this.view.getState(t)) ? i.style : this.getCellStyle(t);
  return 0 < this.model.getChildCount(t) && 0 != i[mxConstants.STYLE_FOLDABLE];
}, mxGraph.prototype.isValidDropTarget = function (t, e, i) {
  return null != t && (this.isSplitEnabled() && this.isSplitTarget(t, e, i) || !this.model.isEdge(t) && (this.isSwimlane(t) || 0 < this.model.getChildCount(t) && !this.isCellCollapsed(t)));
}, mxGraph.prototype.isSplitTarget = function (t, e, i) {
  return !(!this.model.isEdge(t) || null == e || 1 != e.length || !this.isCellConnectable(e[0]) || null != this.getEdgeValidationError(t, this.model.getTerminal(t, !0), e[0])) && (i = this.model.getTerminal(t, !0), t = this.model.getTerminal(t, !1), !this.model.isAncestor(e[0], i) && !this.model.isAncestor(e[0], t));
}, mxGraph.prototype.getDropTarget = function (t, e, i, n) {
  if (!this.isSwimlaneNesting()) for (var s = 0; s < t.length; s++) {
    if (this.isSwimlane(t[s])) return null;
  }
  if ((s = mxUtils.convertPoint(this.container, mxEvent.getClientX(e), mxEvent.getClientY(e))).x -= this.panDx, s.y -= this.panDy, s = this.getSwimlaneAt(s.x, s.y), null == i) i = s;else if (null != s) {
    for (var o = this.model.getParent(s); null != o && this.isSwimlane(o) && o != i;) {
      o = this.model.getParent(o);
    }

    o == i && (i = s);
  }

  for (; null != i && !this.isValidDropTarget(i, t, e) && !this.model.isLayer(i);) {
    i = this.model.getParent(i);
  }

  if (null == n || !n) for (var l = i; null != l && 0 > mxUtils.indexOf(t, l);) {
    l = this.model.getParent(l);
  }
  return this.model.isLayer(i) || null != l ? null : i;
}, mxGraph.prototype.getDefaultParent = function () {
  var t = this.getCurrentRoot();
  return null == t && null == (t = this.defaultParent) && (t = this.model.getRoot(), t = this.model.getChildAt(t, 0)), t;
}, mxGraph.prototype.setDefaultParent = function (t) {
  this.defaultParent = t;
}, mxGraph.prototype.getSwimlane = function (t) {
  for (; null != t && !this.isSwimlane(t);) {
    t = this.model.getParent(t);
  }

  return t;
}, mxGraph.prototype.getSwimlaneAt = function (t, e, i) {
  if (null != (i = i || this.getDefaultParent())) for (var n = this.model.getChildCount(i), s = 0; s < n; s++) {
    var o = this.model.getChildAt(i, s),
        l = this.getSwimlaneAt(t, e, o);
    if (null != l) return l;
    if (this.isSwimlane(o) && (l = this.view.getState(o), this.intersects(l, t, e))) return o;
  }
  return null;
}, mxGraph.prototype.getCellAt = function (t, e, i, n, s, o) {
  if (n = null == n || n, s = null == s || s, null == i && null == (i = this.getCurrentRoot()) && (i = this.getModel().getRoot()), null != i) for (var l = this.model.getChildCount(i) - 1; 0 <= l; l--) {
    var r = this.model.getChildAt(i, l),
        a = this.getCellAt(t, e, r, n, s, o);
    if (null != a) return a;
    if (this.isCellVisible(r) && (s && this.model.isEdge(r) || n && this.model.isVertex(r)) && null != (a = this.view.getState(r)) && (null == o || !o(a, t, e)) && this.intersects(a, t, e)) return r;
  }
  return null;
}, mxGraph.prototype.intersects = function (t, e, i) {
  if (null != t) {
    var n = t.absolutePoints;

    if (null != n) {
      t = this.tolerance * this.tolerance;

      for (var s = n[0], o = 1; o < n.length; o++) {
        var l = n[o];
        if (mxUtils.ptSegDistSq(s.x, s.y, l.x, l.y, e, i) <= t) return !0;
        s = l;
      }
    } else if (0 != (s = mxUtils.toRadians(mxUtils.getValue(t.style, mxConstants.STYLE_ROTATION) || 0)) && (n = Math.cos(-s), s = Math.sin(-s), o = new mxPoint(t.getCenterX(), t.getCenterY()), e = (s = mxUtils.getRotatedPoint(new mxPoint(e, i), n, s, o)).x, i = s.y), mxUtils.contains(t, e, i)) return !0;
  }

  return !1;
}, mxGraph.prototype.hitsSwimlaneContent = function (t, e, i) {
  var n = this.getView().getState(t);

  if (t = this.getStartSize(t), null != n) {
    var s = this.getView().getScale();
    if (e -= n.x, i -= n.y, 0 < t.width && 0 < e && e > t.width * s || 0 < t.height && 0 < i && i > t.height * s) return !0;
  }

  return !1;
}, mxGraph.prototype.getChildVertices = function (t) {
  return this.getChildCells(t, !0, !1);
}, mxGraph.prototype.getChildEdges = function (t) {
  return this.getChildCells(t, !1, !0);
}, mxGraph.prototype.getChildCells = function (t, e, i) {
  for (t = null != t ? t : this.getDefaultParent(), t = this.model.getChildCells(t, null != e && e, null != i && i), e = [], i = 0; i < t.length; i++) {
    this.isCellVisible(t[i]) && e.push(t[i]);
  }

  return e;
}, mxGraph.prototype.getConnections = function (t, e) {
  return this.getEdges(t, e, !0, !0, !1);
}, mxGraph.prototype.getIncomingEdges = function (t, e) {
  return this.getEdges(t, e, !0, !1, !1);
}, mxGraph.prototype.getOutgoingEdges = function (t, e) {
  return this.getEdges(t, e, !1, !0, !1);
}, mxGraph.prototype.getEdges = function (t, e, i, n, s, o) {
  i = null == i || i, n = null == n || n, s = null == s || s, o = null != o && o;

  for (var l = [], r = this.isCellCollapsed(t), a = this.model.getChildCount(t), h = 0; h < a; h++) {
    var u = this.model.getChildAt(t, h);
    !r && this.isCellVisible(u) || (l = l.concat(this.model.getEdges(u, i, n)));
  }

  for (l = l.concat(this.model.getEdges(t, i, n)), r = [], h = 0; h < l.length; h++) {
    a = null != (u = this.view.getState(l[h])) ? u.getVisibleTerminal(!0) : this.view.getVisibleTerminal(l[h], !0), u = null != u ? u.getVisibleTerminal(!1) : this.view.getVisibleTerminal(l[h], !1), (s && a == u || a != u && (i && u == t && (null == e || this.isValidAncestor(a, e, o)) || n && a == t && (null == e || this.isValidAncestor(u, e, o)))) && r.push(l[h]);
  }

  return r;
}, mxGraph.prototype.isValidAncestor = function (t, e, i) {
  return i ? this.model.isAncestor(e, t) : this.model.getParent(t) == e;
}, mxGraph.prototype.getOpposites = function (t, e, i, n) {
  i = null == i || i, n = null == n || n;
  var s = [],
      o = new mxDictionary();
  if (null != t) for (var l = 0; l < t.length; l++) {
    var r = null != (a = this.view.getState(t[l])) ? a.getVisibleTerminal(!0) : this.view.getVisibleTerminal(t[l], !0),
        a = null != a ? a.getVisibleTerminal(!1) : this.view.getVisibleTerminal(t[l], !1);
    r == e && null != a && a != e && n ? o.get(a) || (o.put(a, !0), s.push(a)) : a == e && null != r && r != e && i && !o.get(r) && (o.put(r, !0), s.push(r));
  }
  return s;
}, mxGraph.prototype.getEdgesBetween = function (t, e, i) {
  i = null != i && i;

  for (var n = this.getEdges(t), s = [], o = 0; o < n.length; o++) {
    var l = null != (r = this.view.getState(n[o])) ? r.getVisibleTerminal(!0) : this.view.getVisibleTerminal(n[o], !0),
        r = null != r ? r.getVisibleTerminal(!1) : this.view.getVisibleTerminal(n[o], !1);
    (l == t && r == e || !i && l == e && r == t) && s.push(n[o]);
  }

  return s;
}, mxGraph.prototype.getPointForEvent = function (t, e) {
  var i = mxUtils.convertPoint(this.container, mxEvent.getClientX(t), mxEvent.getClientY(t)),
      n = this.view.scale,
      s = this.view.translate,
      o = 0 != e ? this.gridSize / 2 : 0;
  return i.x = this.snap(i.x / n - s.x - o), i.y = this.snap(i.y / n - s.y - o), i;
}, mxGraph.prototype.getCells = function (t, e, i, n, s, o) {
  if (o = null != o ? o : [], 0 < i || 0 < n) {
    var l = this.getModel(),
        r = t + i,
        a = e + n;
    if (null == s && null == (s = this.getCurrentRoot()) && (s = l.getRoot()), null != s) for (var h = l.getChildCount(s), u = 0; u < h; u++) {
      var d = l.getChildAt(s, u),
          p = this.view.getState(d);

      if (null != p && this.isCellVisible(d)) {
        var c = mxUtils.getValue(p.style, mxConstants.STYLE_ROTATION) || 0;
        0 != c && (p = mxUtils.getBoundingBox(p, c)), (l.isEdge(d) || l.isVertex(d)) && p.x >= t && p.y + p.height <= a && p.y >= e && p.x + p.width <= r ? o.push(d) : this.getCells(t, e, i, n, d, o);
      }
    }
  }

  return o;
}, mxGraph.prototype.getCellsBeyond = function (t, e, i, n, s) {
  var o = [];
  if ((n || s) && (null == i && (i = this.getDefaultParent()), null != i)) for (var l = this.model.getChildCount(i), r = 0; r < l; r++) {
    var a = this.model.getChildAt(i, r),
        h = this.view.getState(a);
    this.isCellVisible(a) && null != h && (!n || h.x >= t) && (!s || h.y >= e) && o.push(a);
  }
  return o;
}, mxGraph.prototype.findTreeRoots = function (t, e, i) {
  e = null != e && e, i = null != i && i;
  var n = [];

  if (null != t) {
    for (var s = this.getModel(), o = s.getChildCount(t), l = null, r = 0, a = 0; a < o; a++) {
      var h = s.getChildAt(t, a);

      if (this.model.isVertex(h) && this.isCellVisible(h)) {
        for (var u = this.getConnections(h, e ? t : null), d = 0, p = 0, c = 0; c < u.length; c++) {
          this.view.getVisibleTerminal(u[c], !0) == h ? d++ : p++;
        }

        (i && 0 == d && 0 < p || !i && 0 == p && 0 < d) && n.push(h), (u = i ? p - d : d - p) > r && (r = u, l = h);
      }
    }

    0 == n.length && null != l && n.push(l);
  }

  return n;
}, mxGraph.prototype.traverse = function (t, e, i, n, s, o) {
  if (null != i && null != t && (e = null == e || e, o = null != o && o, !(s = s || new mxDictionary()).get(t) && (s.put(t, !0), null == (n = i(t, n)) || n)) && 0 < (n = this.model.getEdgeCount(t))) for (var l = 0; l < n; l++) {
    var r = this.model.getEdgeAt(t, l),
        a = this.model.getTerminal(r, !0) == t;
    e && !o != a || (a = this.model.getTerminal(r, !a), this.traverse(a, e, i, r, s, o));
  }
}, mxGraph.prototype.isCellSelected = function (t) {
  return this.getSelectionModel().isSelected(t);
}, mxGraph.prototype.isSelectionEmpty = function () {
  return this.getSelectionModel().isEmpty();
}, mxGraph.prototype.clearSelection = function () {
  return this.getSelectionModel().clear();
}, mxGraph.prototype.getSelectionCount = function () {
  return this.getSelectionModel().cells.length;
}, mxGraph.prototype.getSelectionCell = function () {
  return this.getSelectionModel().cells[0];
}, mxGraph.prototype.getSelectionCells = function () {
  return this.getSelectionModel().cells.slice();
}, mxGraph.prototype.setSelectionCell = function (t) {
  this.getSelectionModel().setCell(t);
}, mxGraph.prototype.setSelectionCells = function (t) {
  this.getSelectionModel().setCells(t);
}, mxGraph.prototype.addSelectionCell = function (t) {
  this.getSelectionModel().addCell(t);
}, mxGraph.prototype.addSelectionCells = function (t) {
  this.getSelectionModel().addCells(t);
}, mxGraph.prototype.removeSelectionCell = function (t) {
  this.getSelectionModel().removeCell(t);
}, mxGraph.prototype.removeSelectionCells = function (t) {
  this.getSelectionModel().removeCells(t);
}, mxGraph.prototype.selectRegion = function (t, e) {
  var i = this.getCells(t.x, t.y, t.width, t.height);
  return this.selectCellsForEvent(i, e), i;
}, mxGraph.prototype.selectNextCell = function () {
  this.selectCell(!0);
}, mxGraph.prototype.selectPreviousCell = function () {
  this.selectCell();
}, mxGraph.prototype.selectParentCell = function () {
  this.selectCell(!1, !0);
}, mxGraph.prototype.selectChildCell = function () {
  this.selectCell(!1, !1, !0);
}, mxGraph.prototype.selectCell = function (t, e, i) {
  var n = 0 < (s = this.selectionModel).cells.length ? s.cells[0] : null;
  1 < s.cells.length && s.clear();
  var s = null != n ? this.model.getParent(n) : this.getDefaultParent(),
      o = this.model.getChildCount(s);
  null == n && 0 < o ? (t = this.model.getChildAt(s, 0), this.setSelectionCell(t)) : null != n && !e || null == this.view.getState(s) || null == this.model.getGeometry(s) ? null != n && i ? 0 < this.model.getChildCount(n) && (t = this.model.getChildAt(n, 0), this.setSelectionCell(t)) : 0 < o && (e = s.getIndex(n), t ? (e++, t = this.model.getChildAt(s, e % o)) : (e--, t = this.model.getChildAt(s, 0 > e ? o - 1 : e)), this.setSelectionCell(t)) : this.getCurrentRoot() != s && this.setSelectionCell(s);
}, mxGraph.prototype.selectAll = function (t, e) {
  t = t || this.getDefaultParent();
  var i = e ? this.model.filterDescendants(function (e) {
    return e != t;
  }, t) : this.model.getChildren(t);
  null != i && this.setSelectionCells(i);
}, mxGraph.prototype.selectVertices = function (t) {
  this.selectCells(!0, !1, t);
}, mxGraph.prototype.selectEdges = function (t) {
  this.selectCells(!1, !0, t);
}, mxGraph.prototype.selectCells = function (t, e, i) {
  i = i || this.getDefaultParent();
  var n = mxUtils.bind(this, function (i) {
    return null != this.view.getState(i) && (0 == this.model.getChildCount(i) && this.model.isVertex(i) && t && !this.model.isEdge(this.model.getParent(i)) || this.model.isEdge(i) && e);
  });
  i = this.model.filterDescendants(n, i), this.setSelectionCells(i);
}, mxGraph.prototype.selectCellForEvent = function (t, e) {
  var i = this.isCellSelected(t);
  this.isToggleEvent(e) ? i ? this.removeSelectionCell(t) : this.addSelectionCell(t) : i && 1 == this.getSelectionCount() || this.setSelectionCell(t);
}, mxGraph.prototype.selectCellsForEvent = function (t, e) {
  this.isToggleEvent(e) ? this.addSelectionCells(t) : this.setSelectionCells(t);
}, mxGraph.prototype.createHandler = function (t) {
  var e = null;
  if (null != t) if (this.model.isEdge(t.cell)) {
    e = t.getVisibleTerminalState(!0);
    var i = t.getVisibleTerminalState(!1),
        n = this.getCellGeometry(t.cell);
    e = this.view.getEdgeStyle(t, null != n ? n.points : null, e, i), e = this.createEdgeHandler(t, e);
  } else e = this.createVertexHandler(t);
  return e;
}, mxGraph.prototype.createVertexHandler = function (t) {
  return new mxVertexHandler(t);
}, mxGraph.prototype.createEdgeHandler = function (t, e) {
  return e == mxEdgeStyle.Loop || e == mxEdgeStyle.ElbowConnector || e == mxEdgeStyle.SideToSide || e == mxEdgeStyle.TopToBottom ? this.createElbowEdgeHandler(t) : e == mxEdgeStyle.SegmentConnector || e == mxEdgeStyle.OrthConnector ? this.createEdgeSegmentHandler(t) : new mxEdgeHandler(t);
}, mxGraph.prototype.createEdgeSegmentHandler = function (t) {
  return new mxEdgeSegmentHandler(t);
}, mxGraph.prototype.createElbowEdgeHandler = function (t) {
  return new mxElbowEdgeHandler(t);
}, mxGraph.prototype.addMouseListener = function (t) {
  null == this.mouseListeners && (this.mouseListeners = []), this.mouseListeners.push(t);
}, mxGraph.prototype.removeMouseListener = function (t) {
  if (null != this.mouseListeners) for (var e = 0; e < this.mouseListeners.length; e++) {
    if (this.mouseListeners[e] == t) {
      this.mouseListeners.splice(e, 1);
      break;
    }
  }
}, mxGraph.prototype.updateMouseEvent = function (t, e) {
  if (null == t.graphX || null == t.graphY) {
    var i = mxUtils.convertPoint(this.container, t.getX(), t.getY());
    t.graphX = i.x - this.panDx, t.graphY = i.y - this.panDy, null == t.getCell() && this.isMouseDown && e == mxEvent.MOUSE_MOVE && (t.state = this.view.getState(this.getCellAt(i.x, i.y, null, null, null, function (t) {
      return null == t.shape || t.shape.paintBackground != mxRectangleShape.prototype.paintBackground || "1" == mxUtils.getValue(t.style, mxConstants.STYLE_POINTER_EVENTS, "1") || null != t.shape.fill && t.shape.fill != mxConstants.NONE;
    })));
  }

  return t;
}, mxGraph.prototype.getStateForTouchEvent = function (t) {
  var e = mxEvent.getClientX(t);
  return t = mxEvent.getClientY(t), e = mxUtils.convertPoint(this.container, e, t), this.view.getState(this.getCellAt(e.x, e.y));
}, mxGraph.prototype.isEventIgnored = function (t, e, i) {
  var n = mxEvent.isMouseEvent(e.getEvent()),
      s = !1;
  return e.getEvent() == this.lastEvent ? s = !0 : this.lastEvent = e.getEvent(), null != this.eventSource && t != mxEvent.MOUSE_MOVE ? (mxEvent.removeGestureListeners(this.eventSource, null, this.mouseMoveRedirect, this.mouseUpRedirect), this.eventSource = this.mouseUpRedirect = this.mouseMoveRedirect = null) : mxClient.IS_GC || null == this.eventSource || e.getSource() == this.eventSource ? !mxClient.IS_TOUCH || t != mxEvent.MOUSE_DOWN || n || mxEvent.isPenEvent(e.getEvent()) || (this.eventSource = e.getSource(), this.mouseMoveRedirect = mxUtils.bind(this, function (t) {
    this.fireMouseEvent(mxEvent.MOUSE_MOVE, new mxMouseEvent(t, this.getStateForTouchEvent(t)));
  }), this.mouseUpRedirect = mxUtils.bind(this, function (t) {
    this.fireMouseEvent(mxEvent.MOUSE_UP, new mxMouseEvent(t, this.getStateForTouchEvent(t)));
  }), mxEvent.addGestureListeners(this.eventSource, null, this.mouseMoveRedirect, this.mouseUpRedirect)) : s = !0, this.isSyntheticEventIgnored(t, e, i) && (s = !0), !mxEvent.isPopupTrigger(this.lastEvent) && t != mxEvent.MOUSE_MOVE && 2 == this.lastEvent.detail || (t == mxEvent.MOUSE_UP && this.isMouseDown ? this.isMouseDown = !1 : t != mxEvent.MOUSE_DOWN || this.isMouseDown ? !s && ((!mxClient.IS_FF || t != mxEvent.MOUSE_MOVE) && this.isMouseDown && this.isMouseTrigger != n || t == mxEvent.MOUSE_DOWN && this.isMouseDown || t == mxEvent.MOUSE_UP && !this.isMouseDown) && (s = !0) : (this.isMouseDown = !0, this.isMouseTrigger = n), s || t != mxEvent.MOUSE_DOWN || (this.lastMouseX = e.getX(), this.lastMouseY = e.getY()), s);
}, mxGraph.prototype.isSyntheticEventIgnored = function (t, e, i) {
  return i = !1, e = mxEvent.isMouseEvent(e.getEvent()), this.ignoreMouseEvents && e && t != mxEvent.MOUSE_MOVE ? (this.ignoreMouseEvents = t != mxEvent.MOUSE_UP, i = !0) : mxClient.IS_FF && !e && t == mxEvent.MOUSE_UP && (this.ignoreMouseEvents = !0), i;
}, mxGraph.prototype.isEventSourceIgnored = function (t, e) {
  var i = e.getSource(),
      n = null != i.nodeName ? i.nodeName.toLowerCase() : "",
      s = !mxEvent.isMouseEvent(e.getEvent()) || mxEvent.isLeftMouseButton(e.getEvent());
  return t == mxEvent.MOUSE_DOWN && s && ("select" == n || "option" == n || "input" == n && "checkbox" != i.type && "radio" != i.type && "button" != i.type && "submit" != i.type && "file" != i.type);
}, mxGraph.prototype.getEventState = function (t) {
  return t;
}, mxGraph.prototype.fireMouseEvent = function (t, e, i) {
  if (this.isEventSourceIgnored(t, e)) null != this.tooltipHandler && this.tooltipHandler.hide();else {
    if (null == i && (i = this), e = this.updateMouseEvent(e, t), !this.nativeDblClickEnabled && !mxEvent.isPopupTrigger(e.getEvent()) || this.doubleTapEnabled && mxClient.IS_TOUCH && (mxEvent.isTouchEvent(e.getEvent()) || mxEvent.isPenEvent(e.getEvent()))) {
      var n = new Date().getTime();
      if (!mxClient.IS_QUIRKS && t == mxEvent.MOUSE_DOWN || mxClient.IS_QUIRKS && t == mxEvent.MOUSE_UP && !this.fireDoubleClick) {
        if (null != this.lastTouchEvent && this.lastTouchEvent != e.getEvent() && n - this.lastTouchTime < this.doubleTapTimeout && Math.abs(this.lastTouchX - e.getX()) < this.doubleTapTolerance && Math.abs(this.lastTouchY - e.getY()) < this.doubleTapTolerance && 2 > this.doubleClickCounter) {
          if (this.doubleClickCounter++, n = !1, t == mxEvent.MOUSE_UP ? e.getCell() == this.lastTouchCell && null != this.lastTouchCell && (this.lastTouchTime = 0, n = this.lastTouchCell, this.lastTouchCell = null, mxClient.IS_QUIRKS && e.getSource().fireEvent("ondblclick"), this.dblClick(e.getEvent(), n), n = !0) : (this.fireDoubleClick = !0, this.lastTouchTime = 0), !mxClient.IS_QUIRKS || n) return void mxEvent.consume(e.getEvent());
        } else null != this.lastTouchEvent && this.lastTouchEvent == e.getEvent() || (this.lastTouchCell = e.getCell(), this.lastTouchX = e.getX(), this.lastTouchY = e.getY(), this.lastTouchTime = n, this.lastTouchEvent = e.getEvent(), this.doubleClickCounter = 0);
      } else if ((this.isMouseDown || t == mxEvent.MOUSE_UP) && this.fireDoubleClick) return this.fireDoubleClick = !1, n = this.lastTouchCell, this.lastTouchCell = null, this.isMouseDown = !1, void ((null != n || (mxEvent.isTouchEvent(e.getEvent()) || mxEvent.isPenEvent(e.getEvent())) && (mxClient.IS_GC || mxClient.IS_SF)) && Math.abs(this.lastTouchX - e.getX()) < this.doubleTapTolerance && Math.abs(this.lastTouchY - e.getY()) < this.doubleTapTolerance ? this.dblClick(e.getEvent(), n) : mxEvent.consume(e.getEvent()));
    }

    if (!this.isEventIgnored(t, e, i)) {
      if (e.state = this.getEventState(e.getState()), this.fireEvent(new mxEventObject(mxEvent.FIRE_MOUSE_EVENT, "eventName", t, "event", e)), mxClient.IS_OP || mxClient.IS_SF || mxClient.IS_GC || mxClient.IS_IE11 || mxClient.IS_IE && mxClient.IS_SVG || e.getEvent().target != this.container) {
        if (t == mxEvent.MOUSE_MOVE && this.isMouseDown && this.autoScroll && !mxEvent.isMultiTouchEvent(e.getEvent)) this.scrollPointToVisible(e.getGraphX(), e.getGraphY(), this.autoExtend);else if (t == mxEvent.MOUSE_UP && this.ignoreScrollbars && this.translateToScrollPosition && (0 != this.container.scrollLeft || 0 != this.container.scrollTop)) {
          n = this.view.scale;
          var s = this.view.translate;
          this.view.setTranslate(s.x - this.container.scrollLeft / n, s.y - this.container.scrollTop / n), this.container.scrollLeft = 0, this.container.scrollTop = 0;
        }
        if (null != this.mouseListeners) for (n = [i, e], e.getEvent().preventDefault || (e.getEvent().returnValue = !0), s = 0; s < this.mouseListeners.length; s++) {
          var o = this.mouseListeners[s];
          t == mxEvent.MOUSE_DOWN ? o.mouseDown.apply(o, n) : t == mxEvent.MOUSE_MOVE ? o.mouseMove.apply(o, n) : t == mxEvent.MOUSE_UP && o.mouseUp.apply(o, n);
        }
        t == mxEvent.MOUSE_UP && this.click(e);
      }

      (mxEvent.isTouchEvent(e.getEvent()) || mxEvent.isPenEvent(e.getEvent())) && t == mxEvent.MOUSE_DOWN && this.tapAndHoldEnabled && !this.tapAndHoldInProgress ? (this.tapAndHoldInProgress = !0, this.initialTouchX = e.getGraphX(), this.initialTouchY = e.getGraphY(), this.tapAndHoldThread && window.clearTimeout(this.tapAndHoldThread), this.tapAndHoldThread = window.setTimeout(mxUtils.bind(this, function () {
        this.tapAndHoldValid && this.tapAndHold(e), this.tapAndHoldValid = this.tapAndHoldInProgress = !1;
      }), this.tapAndHoldDelay), this.tapAndHoldValid = !0) : t == mxEvent.MOUSE_UP ? this.tapAndHoldValid = this.tapAndHoldInProgress = !1 : this.tapAndHoldValid && (this.tapAndHoldValid = Math.abs(this.initialTouchX - e.getGraphX()) < this.tolerance && Math.abs(this.initialTouchY - e.getGraphY()) < this.tolerance), t == mxEvent.MOUSE_DOWN && this.isEditing() && !this.cellEditor.isEventSource(e.getEvent()) && this.stopEditing(!this.isInvokesStopCellEditing()), this.consumeMouseEvent(t, e, i);
    }
  }
}, mxGraph.prototype.consumeMouseEvent = function (t, e, i) {
  t == mxEvent.MOUSE_DOWN && mxEvent.isTouchEvent(e.getEvent()) && e.consume(!1);
}, mxGraph.prototype.fireGestureEvent = function (t, e) {
  this.lastTouchTime = 0, this.fireEvent(new mxEventObject(mxEvent.GESTURE, "event", t, "cell", e));
}, mxGraph.prototype.destroy = function () {
  this.destroyed || (this.destroyed = !0, null != this.tooltipHandler && this.tooltipHandler.destroy(), null != this.selectionCellsHandler && this.selectionCellsHandler.destroy(), null != this.panningHandler && this.panningHandler.destroy(), null != this.popupMenuHandler && this.popupMenuHandler.destroy(), null != this.connectionHandler && this.connectionHandler.destroy(), null != this.graphHandler && this.graphHandler.destroy(), null != this.cellEditor && this.cellEditor.destroy(), null != this.view && this.view.destroy(), null != this.model && null != this.graphModelChangeListener && (this.model.removeListener(this.graphModelChangeListener), this.graphModelChangeListener = null), this.container = null);
}, mxCellOverlay.prototype = new mxEventSource(), mxCellOverlay.prototype.constructor = mxCellOverlay, mxCellOverlay.prototype.image = null, mxCellOverlay.prototype.tooltip = null, mxCellOverlay.prototype.align = mxConstants.ALIGN_RIGHT, mxCellOverlay.prototype.verticalAlign = mxConstants.ALIGN_BOTTOM, mxCellOverlay.prototype.offset = null, mxCellOverlay.prototype.cursor = null, mxCellOverlay.prototype.defaultOverlap = .5, mxCellOverlay.prototype.getBounds = function (t) {
  var e = t.view.graph.getModel().isEdge(t.cell),
      i = t.view.scale,
      n = this.image.width,
      s = this.image.height;
  if (e) {
    if (1 == (e = t.absolutePoints).length % 2) e = e[Math.floor(e.length / 2)];else {
      var o = e.length / 2;
      t = e[o - 1], e = e[o], e = new mxPoint(t.x + (e.x - t.x) / 2, t.y + (e.y - t.y) / 2);
    }
  } else (e = new mxPoint()).x = this.align == mxConstants.ALIGN_LEFT ? t.x : this.align == mxConstants.ALIGN_CENTER ? t.x + t.width / 2 : t.x + t.width, e.y = this.verticalAlign == mxConstants.ALIGN_TOP ? t.y : this.verticalAlign == mxConstants.ALIGN_MIDDLE ? t.y + t.height / 2 : t.y + t.height;
  return new mxRectangle(Math.round(e.x - (n * this.defaultOverlap - this.offset.x) * i), Math.round(e.y - (s * this.defaultOverlap - this.offset.y) * i), n * i, s * i);
}, mxCellOverlay.prototype.toString = function () {
  return this.tooltip;
}, mxOutline.prototype.source = null, mxOutline.prototype.outline = null, mxOutline.prototype.graphRenderHint = mxConstants.RENDERING_HINT_FASTER, mxOutline.prototype.enabled = !0, mxOutline.prototype.showViewport = !0, mxOutline.prototype.border = 10, mxOutline.prototype.sizerSize = 8, mxOutline.prototype.labelsVisible = !1, mxOutline.prototype.updateOnPan = !1, mxOutline.prototype.sizerImage = null, mxOutline.prototype.minScale = 1e-4, mxOutline.prototype.suspended = !1, mxOutline.prototype.forceVmlHandles = 8 == document.documentMode, mxOutline.prototype.createGraph = function (t) {
  return (t = new mxGraph(t, this.source.getModel(), this.graphRenderHint, this.source.getStylesheet())).foldingEnabled = !1, t.autoScroll = !1, t;
}, mxOutline.prototype.init = function (t) {
  this.outline = this.createGraph(t);
  var e = this.outline.graphModelChanged;
  this.outline.graphModelChanged = mxUtils.bind(this, function (t) {
    this.suspended || null == this.outline || e.apply(this.outline, arguments);
  }), mxClient.IS_SVG && ((t = this.outline.getView().getCanvas().parentNode).setAttribute("shape-rendering", "optimizeSpeed"), t.setAttribute("image-rendering", "optimizeSpeed")), this.outline.labelsVisible = this.labelsVisible, this.outline.setEnabled(!1), this.updateHandler = mxUtils.bind(this, function (t, e) {
    this.suspended || this.active || this.update();
  }), this.source.getModel().addListener(mxEvent.CHANGE, this.updateHandler), this.outline.addMouseListener(this), (t = this.source.getView()).addListener(mxEvent.SCALE, this.updateHandler), t.addListener(mxEvent.TRANSLATE, this.updateHandler), t.addListener(mxEvent.SCALE_AND_TRANSLATE, this.updateHandler), t.addListener(mxEvent.DOWN, this.updateHandler), t.addListener(mxEvent.UP, this.updateHandler), mxEvent.addListener(this.source.container, "scroll", this.updateHandler), this.panHandler = mxUtils.bind(this, function (t) {
    this.updateOnPan && this.updateHandler.apply(this, arguments);
  }), this.source.addListener(mxEvent.PAN, this.panHandler), this.refreshHandler = mxUtils.bind(this, function (t) {
    this.outline.setStylesheet(this.source.getStylesheet()), this.outline.refresh();
  }), this.source.addListener(mxEvent.REFRESH, this.refreshHandler), this.bounds = new mxRectangle(0, 0, 0, 0), this.selectionBorder = new mxRectangleShape(this.bounds, null, mxConstants.OUTLINE_COLOR, mxConstants.OUTLINE_STROKEWIDTH), this.selectionBorder.dialect = this.outline.dialect, this.forceVmlHandles && (this.selectionBorder.isHtmlAllowed = function () {
    return !1;
  }), this.selectionBorder.init(this.outline.getView().getOverlayPane()), t = mxUtils.bind(this, function (t) {
    var e = mxEvent.getSource(t),
        i = mxUtils.bind(this, function (t) {
      this.outline.fireMouseEvent(mxEvent.MOUSE_MOVE, new mxMouseEvent(t));
    }),
        n = mxUtils.bind(this, function (t) {
      mxEvent.removeGestureListeners(e, null, i, n), this.outline.fireMouseEvent(mxEvent.MOUSE_UP, new mxMouseEvent(t));
    });
    mxEvent.addGestureListeners(e, null, i, n), this.outline.fireMouseEvent(mxEvent.MOUSE_DOWN, new mxMouseEvent(t));
  }), mxEvent.addGestureListeners(this.selectionBorder.node, t), this.sizer = this.createSizer(), this.forceVmlHandles && (this.sizer.isHtmlAllowed = function () {
    return !1;
  }), this.sizer.init(this.outline.getView().getOverlayPane()), this.enabled && (this.sizer.node.style.cursor = "nwse-resize"), mxEvent.addGestureListeners(this.sizer.node, t), this.selectionBorder.node.style.display = this.showViewport ? "" : "none", this.sizer.node.style.display = this.selectionBorder.node.style.display, this.selectionBorder.node.style.cursor = "move", this.update(!1);
}, mxOutline.prototype.isEnabled = function () {
  return this.enabled;
}, mxOutline.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxOutline.prototype.setZoomEnabled = function (t) {
  this.sizer.node.style.visibility = t ? "visible" : "hidden";
}, mxOutline.prototype.refresh = function () {
  this.update(!0);
}, mxOutline.prototype.createSizer = function () {
  var t = null != this.sizerImage ? new mxImageShape(new mxRectangle(0, 0, this.sizerImage.width, this.sizerImage.height), this.sizerImage.src) : new mxRectangleShape(new mxRectangle(0, 0, this.sizerSize, this.sizerSize), mxConstants.OUTLINE_HANDLE_FILLCOLOR, mxConstants.OUTLINE_HANDLE_STROKECOLOR);
  return t.dialect = this.outline.dialect, t;
}, mxOutline.prototype.getSourceContainerSize = function () {
  return new mxRectangle(0, 0, this.source.container.scrollWidth, this.source.container.scrollHeight);
}, mxOutline.prototype.getOutlineOffset = function (t) {
  return null;
}, mxOutline.prototype.getSourceGraphBounds = function () {
  return this.source.getGraphBounds();
}, mxOutline.prototype.update = function (t) {
  if (null != this.source && null != this.source.container && null != this.outline && null != this.outline.container) {
    var e = this.source.view.scale,
        i = new mxRectangle((i = this.getSourceGraphBounds()).x / e + this.source.panDx, i.y / e + this.source.panDy, i.width / e, i.height / e),
        n = new mxRectangle(0, 0, this.source.container.clientWidth / e, this.source.container.clientHeight / e);

    if ((s = i.clone()).add(n), n = this.getSourceContainerSize(), e = Math.min(Math.max(0, this.outline.container.clientWidth - this.border) / Math.max(n.width / e, s.width), Math.max(0, this.outline.container.clientHeight - this.border) / Math.max(n.height / e, s.height)), 0 < (n = isNaN(e) ? this.minScale : Math.max(this.minScale, e))) {
      this.outline.getView().scale != n && (this.outline.getView().scale = n, t = !0), (e = this.outline.getView()).currentRoot != this.source.getView().currentRoot && e.setCurrentRoot(this.source.getView().currentRoot);
      var s,
          o = (s = this.source.view.translate).x + this.source.panDx,
          l = s.y + this.source.panDy;
      null != (n = this.getOutlineOffset(n)) && (o += n.x, l += n.y), 0 > i.x && (o -= i.x), 0 > i.y && (l -= i.y), e.translate.x == o && e.translate.y == l || (e.translate.x = o, e.translate.y = l, t = !0);
      i = e.translate, o = (n = this.source.getView().scale) / e.scale, l = 1 / e.scale;
      var r = this.source.container;
      this.bounds = new mxRectangle((i.x - s.x - this.source.panDx) / l, (i.y - s.y - this.source.panDy) / l, r.clientWidth / o, r.clientHeight / o), this.bounds.x += this.source.container.scrollLeft * e.scale / n, this.bounds.y += this.source.container.scrollTop * e.scale / n, (i = this.selectionBorder.bounds).x == this.bounds.x && i.y == this.bounds.y && i.width == this.bounds.width && i.height == this.bounds.height || (this.selectionBorder.bounds = this.bounds, this.selectionBorder.redraw()), i = this.sizer.bounds, e = new mxRectangle(this.bounds.x + this.bounds.width - i.width / 2, this.bounds.y + this.bounds.height - i.height / 2, i.width, i.height), i.x == e.x && i.y == e.y && i.width == e.width && i.height == e.height || (this.sizer.bounds = e, "hidden" != this.sizer.node.style.visibility && this.sizer.redraw()), t && this.outline.view.revalidate();
    }
  }
}, mxOutline.prototype.mouseDown = function (t, e) {
  if (this.enabled && this.showViewport) {
    var i = mxEvent.isMouseEvent(e.getEvent()) ? 0 : this.source.tolerance;
    i = this.source.allowHandleBoundsCheck && (mxClient.IS_IE || 0 < i) ? new mxRectangle(e.getGraphX() - i, e.getGraphY() - i, 2 * i, 2 * i) : null;
    this.zoom = e.isSource(this.sizer) || null != i && mxUtils.intersects(shape.bounds, i), this.startX = e.getX(), this.startY = e.getY(), this.active = !0, this.source.useScrollbarsForPanning && mxUtils.hasScrollbars(this.source.container) ? (this.dx0 = this.source.container.scrollLeft, this.dy0 = this.source.container.scrollTop) : this.dy0 = this.dx0 = 0;
  }

  e.consume();
}, mxOutline.prototype.mouseMove = function (t, e) {
  if (this.active) {
    this.selectionBorder.node.style.display = this.showViewport ? "" : "none", this.sizer.node.style.display = this.selectionBorder.node.style.display;
    var i = (o = this.getTranslateForEvent(e)).x,
        n = o.y;
    if (this.zoom) n = i / ((o = this.source.container).clientWidth / o.clientHeight), o = new mxRectangle(this.bounds.x, this.bounds.y, Math.max(1, this.bounds.width + i), Math.max(1, this.bounds.height + n)), this.selectionBorder.bounds = o, this.selectionBorder.redraw();else {
      var s = this.outline.getView().scale,
          o = new mxRectangle(this.bounds.x + i, this.bounds.y + n, this.bounds.width, this.bounds.height);
      this.selectionBorder.bounds = o, this.selectionBorder.redraw(), i = i / s * this.source.getView().scale, n = n / s * this.source.getView().scale, this.source.panGraph(-i - this.dx0, -n - this.dy0);
    }
    i = this.sizer.bounds, this.sizer.bounds = new mxRectangle(o.x + o.width - i.width / 2, o.y + o.height - i.height / 2, i.width, i.height), "hidden" != this.sizer.node.style.visibility && this.sizer.redraw(), e.consume();
  }
}, mxOutline.prototype.getTranslateForEvent = function (t) {
  return new mxPoint(t.getX() - this.startX, t.getY() - this.startY);
}, mxOutline.prototype.mouseUp = function (t, e) {
  if (this.active) {
    var i = (n = this.getTranslateForEvent(e)).x,
        n = n.y;

    if (0 < Math.abs(i) || 0 < Math.abs(n)) {
      if (this.zoom) {
        n = this.selectionBorder.bounds.width;
        var s = this.source.getView().scale;
        this.source.zoomTo(Math.max(this.minScale, s - i * s / n), !1);
      } else this.source.useScrollbarsForPanning && mxUtils.hasScrollbars(this.source.container) || (this.source.panGraph(0, 0), i /= this.outline.getView().scale, n /= this.outline.getView().scale, s = this.source.getView().translate, this.source.getView().setTranslate(s.x - i, s.y - n));

      this.update(), e.consume();
    }

    this.index = null, this.active = !1;
  }
}, mxOutline.prototype.destroy = function () {
  null != this.source && (this.source.removeListener(this.panHandler), this.source.removeListener(this.refreshHandler), this.source.getModel().removeListener(this.updateHandler), this.source.getView().removeListener(this.updateHandler), mxEvent.addListener(this.source.container, "scroll", this.updateHandler), this.source = null), null != this.outline && (this.outline.removeMouseListener(this), this.outline.destroy(), this.outline = null), null != this.selectionBorder && (this.selectionBorder.destroy(), this.selectionBorder = null), null != this.sizer && (this.sizer.destroy(), this.sizer = null);
}, mxMultiplicity.prototype.type = null, mxMultiplicity.prototype.attr = null, mxMultiplicity.prototype.value = null, mxMultiplicity.prototype.source = null, mxMultiplicity.prototype.min = null, mxMultiplicity.prototype.max = null, mxMultiplicity.prototype.validNeighbors = null, mxMultiplicity.prototype.validNeighborsAllowed = !0, mxMultiplicity.prototype.countError = null, mxMultiplicity.prototype.typeError = null, mxMultiplicity.prototype.check = function (t, e, i, n, s, o) {
  var l = "";
  return (this.source && this.checkTerminal(t, i, e) || !this.source && this.checkTerminal(t, n, e)) && (null != this.countError && (this.source && (0 == this.max || s >= this.max) || !this.source && (0 == this.max || o >= this.max)) && (l += this.countError + "\n"), null != this.validNeighbors && null != this.typeError && 0 < this.validNeighbors.length && (this.checkNeighbors(t, e, i, n) || (l += this.typeError + "\n"))), 0 < l.length ? l : null;
}, mxMultiplicity.prototype.checkNeighbors = function (t, e, i, n) {
  e = t.model.getValue(i), n = t.model.getValue(n), i = !this.validNeighborsAllowed;

  for (var s = this.validNeighbors, o = 0; o < s.length; o++) {
    if (this.source && this.checkType(t, n, s[o])) {
      i = this.validNeighborsAllowed;
      break;
    }

    if (!this.source && this.checkType(t, e, s[o])) {
      i = this.validNeighborsAllowed;
      break;
    }
  }

  return i;
}, mxMultiplicity.prototype.checkTerminal = function (t, e, i) {
  return e = t.model.getValue(e), this.checkType(t, e, this.type, this.attr, this.value);
}, mxMultiplicity.prototype.checkType = function (t, e, i, n, s) {
  return null != e && (isNaN(e.nodeType) ? e == i : mxUtils.isNode(e, i, n, s));
}, mxLayoutManager.prototype = new mxEventSource(), mxLayoutManager.prototype.constructor = mxLayoutManager, mxLayoutManager.prototype.graph = null, mxLayoutManager.prototype.bubbling = !0, mxLayoutManager.prototype.enabled = !0, mxLayoutManager.prototype.updateHandler = null, mxLayoutManager.prototype.moveHandler = null, mxLayoutManager.prototype.isEnabled = function () {
  return this.enabled;
}, mxLayoutManager.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxLayoutManager.prototype.isBubbling = function () {
  return this.bubbling;
}, mxLayoutManager.prototype.setBubbling = function (t) {
  this.bubbling = t;
}, mxLayoutManager.prototype.getGraph = function () {
  return this.graph;
}, mxLayoutManager.prototype.setGraph = function (t) {
  if (null != this.graph) {
    var e = this.graph.getModel();
    e.removeListener(this.undoHandler), this.graph.removeListener(this.moveHandler);
  }

  this.graph = t, null != this.graph && ((e = this.graph.getModel()).addListener(mxEvent.BEFORE_UNDO, this.undoHandler), this.graph.addListener(mxEvent.MOVE_CELLS, this.moveHandler));
}, mxLayoutManager.prototype.getLayout = function (t) {
  return null;
}, mxLayoutManager.prototype.beforeUndo = function (t) {
  t = this.getCellsForChanges(t.changes);

  for (var e = this.getGraph().getModel(), i = [], n = 0; n < t.length; n++) {
    i = i.concat(e.getDescendants(t[n]));
  }

  if (t = i, this.isBubbling()) for (i = e.getParents(t); 0 < i.length;) {
    t = t.concat(i), i = e.getParents(i);
  }
  this.executeLayoutForCells(t);
}, mxLayoutManager.prototype.executeLayoutForCells = function (t) {
  t = (t = mxUtils.sortCells(t, !0)).concat(t.slice().reverse()), this.layoutCells(t);
}, mxLayoutManager.prototype.cellsMoved = function (t, e) {
  if (null != t && null != e) for (var i = mxUtils.convertPoint(this.getGraph().container, mxEvent.getClientX(e), mxEvent.getClientY(e)), n = this.getGraph().getModel(), s = 0; s < t.length; s++) {
    var o = n.getParent(t[s]);
    0 > mxUtils.indexOf(t, o) && null != (o = this.getLayout(o)) && o.moveCell(t[s], i.x, i.y);
  }
}, mxLayoutManager.prototype.getCellsForChanges = function (t) {
  for (var e = new mxDictionary(), i = [], n = 0; n < t.length; n++) {
    if ((s = t[n]) instanceof mxRootChange) return [];

    for (var s = this.getCellsForChange(s), o = 0; o < s.length; o++) {
      null == s[o] || e.get(s[o]) || (e.put(s[o], !0), i.push(s[o]));
    }
  }

  return i;
}, mxLayoutManager.prototype.getCellsForChange = function (t) {
  var e = this.getGraph().getModel();
  return t instanceof mxChildChange ? [t.child, t.previous, e.getParent(t.child)] : t instanceof mxTerminalChange || t instanceof mxGeometryChange ? [t.cell, e.getParent(t.cell)] : t instanceof mxVisibleChange || t instanceof mxStyleChange ? [t.cell] : [];
}, mxLayoutManager.prototype.layoutCells = function (t) {
  if (0 < t.length) {
    var e = this.getGraph().getModel();
    e.beginUpdate();

    try {
      for (var i = null, n = 0; n < t.length; n++) {
        t[n] != e.getRoot() && t[n] != i && this.executeLayout(this.getLayout(t[n]), t[n]) && (i = t[n]);
      }

      this.fireEvent(new mxEventObject(mxEvent.LAYOUT_CELLS, "cells", t));
    } finally {
      e.endUpdate();
    }
  }
}, mxLayoutManager.prototype.executeLayout = function (t, e) {
  var i = !1;
  return null != t && null != e && (t.execute(e), i = !0), i;
}, mxLayoutManager.prototype.destroy = function () {
  this.setGraph(null);
}, mxSwimlaneManager.prototype = new mxEventSource(), mxSwimlaneManager.prototype.constructor = mxSwimlaneManager, mxSwimlaneManager.prototype.graph = null, mxSwimlaneManager.prototype.enabled = !0, mxSwimlaneManager.prototype.horizontal = !0, mxSwimlaneManager.prototype.addEnabled = !0, mxSwimlaneManager.prototype.resizeEnabled = !0, mxSwimlaneManager.prototype.addHandler = null, mxSwimlaneManager.prototype.resizeHandler = null, mxSwimlaneManager.prototype.isEnabled = function () {
  return this.enabled;
}, mxSwimlaneManager.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxSwimlaneManager.prototype.isHorizontal = function () {
  return this.horizontal;
}, mxSwimlaneManager.prototype.setHorizontal = function (t) {
  this.horizontal = t;
}, mxSwimlaneManager.prototype.isAddEnabled = function () {
  return this.addEnabled;
}, mxSwimlaneManager.prototype.setAddEnabled = function (t) {
  this.addEnabled = t;
}, mxSwimlaneManager.prototype.isResizeEnabled = function () {
  return this.resizeEnabled;
}, mxSwimlaneManager.prototype.setResizeEnabled = function (t) {
  this.resizeEnabled = t;
}, mxSwimlaneManager.prototype.getGraph = function () {
  return this.graph;
}, mxSwimlaneManager.prototype.setGraph = function (t) {
  null != this.graph && (this.graph.removeListener(this.addHandler), this.graph.removeListener(this.resizeHandler)), this.graph = t, null != this.graph && (this.graph.addListener(mxEvent.ADD_CELLS, this.addHandler), this.graph.addListener(mxEvent.CELLS_RESIZED, this.resizeHandler));
}, mxSwimlaneManager.prototype.isSwimlaneIgnored = function (t) {
  return !this.getGraph().isSwimlane(t);
}, mxSwimlaneManager.prototype.isCellHorizontal = function (t) {
  return this.graph.isSwimlane(t) ? (t = this.graph.getCellStyle(t), 1 == mxUtils.getValue(t, mxConstants.STYLE_HORIZONTAL, 1)) : !this.isHorizontal();
}, mxSwimlaneManager.prototype.cellsAdded = function (t) {
  if (null != t) {
    var e = this.getGraph().getModel();
    e.beginUpdate();

    try {
      for (var i = 0; i < t.length; i++) {
        this.isSwimlaneIgnored(t[i]) || this.swimlaneAdded(t[i]);
      }
    } finally {
      e.endUpdate();
    }
  }
}, mxSwimlaneManager.prototype.swimlaneAdded = function (t) {
  for (var e = this.getGraph().getModel(), i = e.getParent(t), n = e.getChildCount(i), s = null, o = 0; o < n; o++) {
    var l = e.getChildAt(i, o);
    if (l != t && !this.isSwimlaneIgnored(l) && null != (s = e.getGeometry(l))) break;
  }

  null != s && (e = null != i ? this.isCellHorizontal(i) : this.horizontal, this.resizeSwimlane(t, s.width, s.height, e));
}, mxSwimlaneManager.prototype.cellsResized = function (t) {
  if (null != t) {
    var e = this.getGraph().getModel();
    e.beginUpdate();

    try {
      for (var i = 0; i < t.length; i++) {
        if (!this.isSwimlaneIgnored(t[i])) {
          var n = e.getGeometry(t[i]);

          if (null != n) {
            for (var s = new mxRectangle(0, 0, n.width, n.height), o = l = t[i]; null != o;) {
              var l = o,
                  r = (o = e.getParent(o), this.graph.isSwimlane(o) ? this.graph.getStartSize(o) : new mxRectangle());
              s.width += r.width, s.height += r.height;
            }

            var a = null != o ? this.isCellHorizontal(o) : this.horizontal;
            this.resizeSwimlane(l, s.width, s.height, a);
          }
        }
      }
    } finally {
      e.endUpdate();
    }
  }
}, mxSwimlaneManager.prototype.resizeSwimlane = function (t, e, i, n) {
  var s = this.getGraph().getModel();
  s.beginUpdate();

  try {
    var o = this.isCellHorizontal(t);

    if (!this.isSwimlaneIgnored(t)) {
      var l = s.getGeometry(t);
      null != l && (n && l.height != i || !n && l.width != e) && (l = l.clone(), n ? l.height = i : l.width = e, s.setGeometry(t, l));
    }

    var r = this.graph.isSwimlane(t) ? this.graph.getStartSize(t) : new mxRectangle();
    e -= r.width, i -= r.height;
    var a = s.getChildCount(t);

    for (n = 0; n < a; n++) {
      var h = s.getChildAt(t, n);
      this.resizeSwimlane(h, e, i, o);
    }
  } finally {
    s.endUpdate();
  }
}, mxSwimlaneManager.prototype.destroy = function () {
  this.setGraph(null);
}, mxTemporaryCellStates.prototype.view = null, mxTemporaryCellStates.prototype.oldStates = null, mxTemporaryCellStates.prototype.oldBounds = null, mxTemporaryCellStates.prototype.oldScale = null, mxTemporaryCellStates.prototype.destroy = function () {
  this.view.setScale(this.oldScale), this.view.setStates(this.oldStates), this.view.setGraphBounds(this.oldBounds), this.view.validateCellState = this.oldValidateCellState, this.view.graph.cellRenderer.doRedrawShape = this.oldDoRedrawShape;
}, mxCellStatePreview.prototype.graph = null, mxCellStatePreview.prototype.deltas = null, mxCellStatePreview.prototype.count = 0, mxCellStatePreview.prototype.isEmpty = function () {
  return 0 == this.count;
}, mxCellStatePreview.prototype.moveState = function (t, e, i, n, s) {
  n = null == n || n, s = null == s || s;
  var o = this.deltas.get(t.cell);
  return null == o ? (o = {
    point: new mxPoint(e, i),
    state: t
  }, this.deltas.put(t.cell, o), this.count++) : n ? (o.point.x += e, o.point.y += i) : (o.point.x = e, o.point.y = i), s && this.addEdges(t), o.point;
}, mxCellStatePreview.prototype.show = function (t) {
  this.deltas.visit(mxUtils.bind(this, function (t, e) {
    this.translateState(e.state, e.point.x, e.point.y);
  })), this.deltas.visit(mxUtils.bind(this, function (e, i) {
    this.revalidateState(i.state, i.point.x, i.point.y, t);
  }));
}, mxCellStatePreview.prototype.translateState = function (t, e, i) {
  if (null != t) {
    var n = this.graph.getModel();

    if (n.isVertex(t.cell)) {
      t.view.updateCellState(t);
      var s = n.getGeometry(t.cell);
      0 == e && 0 == i || null == s || s.relative && null == this.deltas.get(t.cell) || (t.x += e, t.y += i);
    }

    s = n.getChildCount(t.cell);

    for (var o = 0; o < s; o++) {
      this.translateState(t.view.getState(n.getChildAt(t.cell, o)), e, i);
    }
  }
}, mxCellStatePreview.prototype.revalidateState = function (t, e, i, n) {
  if (null != t) {
    var s = this.graph.getModel();
    s.isEdge(t.cell) && t.view.updateCellState(t);
    var o = this.graph.getCellGeometry(t.cell),
        l = t.view.getState(s.getParent(t.cell));

    for (0 == e && 0 == i || null == o || !o.relative || !s.isVertex(t.cell) || null != l && !s.isVertex(l.cell) && null == this.deltas.get(t.cell) || (t.x += e, t.y += i), this.graph.cellRenderer.redraw(t), null != n && n(t), o = s.getChildCount(t.cell), l = 0; l < o; l++) {
      this.revalidateState(this.graph.view.getState(s.getChildAt(t.cell, l)), e, i, n);
    }
  }
}, mxCellStatePreview.prototype.addEdges = function (t) {
  for (var e = this.graph.getModel(), i = e.getEdgeCount(t.cell), n = 0; n < i; n++) {
    var s = t.view.getState(e.getEdgeAt(t.cell, n));
    null != s && this.moveState(s, 0, 0);
  }
}, mxConnectionConstraint.prototype.point = null, mxConnectionConstraint.prototype.perimeter = null, mxConnectionConstraint.prototype.name = null, mxGraphHandler.prototype.graph = null, mxGraphHandler.prototype.maxCells = mxClient.IS_IE ? 20 : 50, mxGraphHandler.prototype.enabled = !0, mxGraphHandler.prototype.highlightEnabled = !0, mxGraphHandler.prototype.cloneEnabled = !0, mxGraphHandler.prototype.moveEnabled = !0, mxGraphHandler.prototype.guidesEnabled = !1, mxGraphHandler.prototype.guide = null, mxGraphHandler.prototype.currentDx = null, mxGraphHandler.prototype.currentDy = null, mxGraphHandler.prototype.updateCursor = !0, mxGraphHandler.prototype.selectEnabled = !0, mxGraphHandler.prototype.removeCellsFromParent = !0, mxGraphHandler.prototype.connectOnDrop = !1, mxGraphHandler.prototype.scrollOnMove = !0, mxGraphHandler.prototype.minimumSize = 6, mxGraphHandler.prototype.previewColor = "black", mxGraphHandler.prototype.htmlPreview = !1, mxGraphHandler.prototype.shape = null, mxGraphHandler.prototype.scaleGrid = !1, mxGraphHandler.prototype.rotationEnabled = !0, mxGraphHandler.prototype.isEnabled = function () {
  return this.enabled;
}, mxGraphHandler.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxGraphHandler.prototype.isCloneEnabled = function () {
  return this.cloneEnabled;
}, mxGraphHandler.prototype.setCloneEnabled = function (t) {
  this.cloneEnabled = t;
}, mxGraphHandler.prototype.isMoveEnabled = function () {
  return this.moveEnabled;
}, mxGraphHandler.prototype.setMoveEnabled = function (t) {
  this.moveEnabled = t;
}, mxGraphHandler.prototype.isSelectEnabled = function () {
  return this.selectEnabled;
}, mxGraphHandler.prototype.setSelectEnabled = function (t) {
  this.selectEnabled = t;
}, mxGraphHandler.prototype.isRemoveCellsFromParent = function () {
  return this.removeCellsFromParent;
}, mxGraphHandler.prototype.setRemoveCellsFromParent = function (t) {
  this.removeCellsFromParent = t;
}, mxGraphHandler.prototype.getInitialCellForEvent = function (t) {
  return t.getCell();
}, mxGraphHandler.prototype.isDelayedSelection = function (t, e) {
  return this.graph.isCellSelected(t);
}, mxGraphHandler.prototype.consumeMouseEvent = function (t, e) {
  e.consume();
}, mxGraphHandler.prototype.mouseDown = function (t, e) {
  if (!e.isConsumed() && this.isEnabled() && this.graph.isEnabled() && null != e.getState() && !mxEvent.isMultiTouchEvent(e.getEvent())) {
    var i = this.getInitialCellForEvent(e);

    if (this.delayedSelection = this.isDelayedSelection(i, e), this.cell = null, this.isSelectEnabled() && !this.delayedSelection && this.graph.selectCellForEvent(i, e.getEvent()), this.isMoveEnabled()) {
      var n = this.graph.model,
          s = n.getGeometry(i);
      this.graph.isCellMovable(i) && (!n.isEdge(i) || 1 < this.graph.getSelectionCount() || null != s.points && 0 < s.points.length || null == n.getTerminal(i, !0) || null == n.getTerminal(i, !1) || this.graph.allowDanglingEdges || this.graph.isCloneEvent(e.getEvent()) && this.graph.isCellsCloneable()) ? this.start(i, e.getX(), e.getY()) : this.delayedSelection && (this.cell = i), this.cellWasClicked = !0, this.consumeMouseEvent(mxEvent.MOUSE_DOWN, e);
    }
  }
}, mxGraphHandler.prototype.getGuideStates = function () {
  var t = this.graph.getDefaultParent(),
      e = this.graph.getModel(),
      i = mxUtils.bind(this, function (t) {
    return null != this.graph.view.getState(t) && e.isVertex(t) && null != e.getGeometry(t) && !e.getGeometry(t).relative;
  });
  return this.graph.view.getCellStates(e.filterDescendants(i, t));
}, mxGraphHandler.prototype.getCells = function (t) {
  return !this.delayedSelection && this.graph.isCellMovable(t) ? [t] : this.graph.getMovableCells(this.graph.getSelectionCells());
}, mxGraphHandler.prototype.getPreviewBounds = function (t) {
  return null != (t = this.getBoundingBox(t)) && (t.width = Math.max(0, t.width - 1), t.height = Math.max(0, t.height - 1), t.width < this.minimumSize ? (t.x -= (this.minimumSize - t.width) / 2, t.width = this.minimumSize) : (t.x = Math.round(t.x), t.width = Math.ceil(t.width)), t.height < this.minimumSize ? (t.y -= (this.minimumSize - t.height) / 2, t.height = this.minimumSize) : (t.y = Math.round(t.y), t.height = Math.ceil(t.height))), t;
}, mxGraphHandler.prototype.getBoundingBox = function (t) {
  var e = null;
  if (null != t && 0 < t.length) for (var i = this.graph.getModel(), n = 0; n < t.length; n++) {
    if (i.isVertex(t[n]) || i.isEdge(t[n])) {
      var s = this.graph.view.getState(t[n]);

      if (null != s) {
        var o = s;
        i.isVertex(t[n]) && null != s.shape && null != s.shape.boundingBox && (o = s.shape.boundingBox), null == e ? e = mxRectangle.fromRectangle(o) : e.add(o);
      }
    }
  }
  return e;
}, mxGraphHandler.prototype.createPreviewShape = function (t) {
  return (t = new mxRectangleShape(t, null, this.previewColor)).isDashed = !0, this.htmlPreview ? (t.dialect = mxConstants.DIALECT_STRICTHTML, t.init(this.graph.container)) : (t.dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_VML : mxConstants.DIALECT_SVG, t.init(this.graph.getView().getOverlayPane()), t.pointerEvents = !1, mxClient.IS_IOS && (t.getSvgScreenOffset = function () {
    return 0;
  })), t;
}, mxGraphHandler.prototype.start = function (t, e, i) {
  this.cell = t, this.first = mxUtils.convertPoint(this.graph.container, e, i), this.cells = this.getCells(this.cell), this.bounds = this.graph.getView().getBounds(this.cells), this.pBounds = this.getPreviewBounds(this.cells), this.guidesEnabled && (this.guide = new mxGuide(this.graph, this.getGuideStates()));
}, mxGraphHandler.prototype.useGuidesForEvent = function (t) {
  return null == this.guide || this.guide.isEnabledForEvent(t.getEvent());
}, mxGraphHandler.prototype.snap = function (t) {
  var e = this.scaleGrid ? this.graph.view.scale : 1;
  return t.x = this.graph.snap(t.x / e) * e, t.y = this.graph.snap(t.y / e) * e, t;
}, mxGraphHandler.prototype.getDelta = function (t) {
  t = mxUtils.convertPoint(this.graph.container, t.getX(), t.getY());
  var e = this.graph.view.scale;
  return new mxPoint(this.roundLength((t.x - this.first.x) / e) * e, this.roundLength((t.y - this.first.y) / e) * e);
}, mxGraphHandler.prototype.updateHint = function (t) {}, mxGraphHandler.prototype.removeHint = function () {}, mxGraphHandler.prototype.roundLength = function (t) {
  return Math.round(2 * t) / 2;
}, mxGraphHandler.prototype.mouseMove = function (t, e) {
  var i = this.graph;
  if (!e.isConsumed() && i.isMouseDown && null != this.cell && null != this.first && null != this.bounds) {
    if (mxEvent.isMultiTouchEvent(e.getEvent())) this.reset();else {
      var n = (s = this.getDelta(e)).x,
          s = s.y,
          o = i.tolerance;

      if (null != this.shape || Math.abs(n) > o || Math.abs(s) > o) {
        null == this.highlight && (this.highlight = new mxCellHighlight(this.graph, mxConstants.DROP_TARGET_COLOR, 3)), null == this.shape && (this.shape = this.createPreviewShape(this.bounds));
        o = i.isCloneEvent(e.getEvent()) && i.isCellsCloneable() && this.isCloneEnabled();
        var l = i.isGridEnabledEvent(e.getEvent()),
            r = !0;
        if (null != this.guide && this.useGuidesForEvent(e)) r = !1, n = (s = this.guide.move(this.bounds, new mxPoint(n, s), l, o)).x, s = s.y;else if (l) {
          var a = i.getView().translate,
              h = i.getView().scale;
          l = this.bounds.x - (i.snap(this.bounds.x / h - a.x) + a.x) * h, a = this.bounds.y - (i.snap(this.bounds.y / h - a.y) + a.y) * h, n = (s = this.snap(new mxPoint(n, s))).x - l, s = s.y - a;
        }
        null != this.guide && r && this.guide.hide(), i.isConstrainedEvent(e.getEvent()) && (Math.abs(n) > Math.abs(s) ? s = 0 : n = 0), this.currentDx = n, this.currentDy = s, this.updatePreviewShape(), r = null, s = e.getCell(), i.isDropEnabled() && this.highlightEnabled && (r = i.getDropTarget(this.cells, e.getEvent(), s, o)), l = !1, null == (n = i.getView().getState(r)) || i.model.getParent(this.cell) == r && !o ? (this.target = null, this.connectOnDrop && null != s && 1 == this.cells.length && i.getModel().isVertex(s) && i.isCellConnectable(s) && null != (n = i.getView().getState(s)) && (i = null == i.getEdgeValidationError(null, this.cell, s) ? mxConstants.VALID_COLOR : mxConstants.INVALID_CONNECT_TARGET_COLOR, this.setHighlightColor(i), l = !0)) : (this.target != r && (this.target = r, this.setHighlightColor(mxConstants.DROP_TARGET_COLOR)), l = !0), null != n && l ? this.highlight.highlight(n) : this.highlight.hide();
      }

      this.updateHint(e), this.consumeMouseEvent(mxEvent.MOUSE_MOVE, e), mxEvent.consume(e.getEvent());
    }
  } else !this.isMoveEnabled() && !this.isCloneEnabled() || !this.updateCursor || e.isConsumed() || null == e.getState() && null == e.sourceState || i.isMouseDown || (null == (o = i.getCursorForMouseEvent(e)) && i.isEnabled() && i.isCellMovable(e.getCell()) && (o = i.getModel().isEdge(e.getCell()) ? mxConstants.CURSOR_MOVABLE_EDGE : mxConstants.CURSOR_MOVABLE_VERTEX), null != o && null != e.sourceState && e.sourceState.setCursor(o));
}, mxGraphHandler.prototype.updatePreviewShape = function () {
  null != this.shape && (this.shape.bounds = new mxRectangle(Math.round(this.pBounds.x + this.currentDx - this.graph.panDx), Math.round(this.pBounds.y + this.currentDy - this.graph.panDy), this.pBounds.width, this.pBounds.height), this.shape.redraw());
}, mxGraphHandler.prototype.setHighlightColor = function (t) {
  null != this.highlight && this.highlight.setHighlightColor(t);
}, mxGraphHandler.prototype.mouseUp = function (t, e) {
  if (!e.isConsumed()) {
    var i = this.graph;

    if (null != this.cell && null != this.first && null != this.shape && null != this.currentDx && null != this.currentDy) {
      var n = e.getCell();
      if (this.connectOnDrop && null == this.target && null != n && i.getModel().isVertex(n) && i.isCellConnectable(n) && i.isEdgeValid(null, this.cell, n)) i.connectionHandler.connect(this.cell, n, e.getEvent());else {
        n = i.isCloneEvent(e.getEvent()) && i.isCellsCloneable() && this.isCloneEnabled();
        var s = i.getView().scale,
            o = this.roundLength(this.currentDx / s),
            l = (s = this.roundLength(this.currentDy / s), this.target);
        i.isSplitEnabled() && i.isSplitTarget(l, this.cells, e.getEvent()) ? i.splitEdge(l, this.cells, null, o, s) : this.moveCells(this.cells, o, s, n, this.target, e.getEvent());
      }
    } else this.isSelectEnabled() && this.delayedSelection && null != this.cell && this.selectDelayed(e);
  }

  this.cellWasClicked && this.consumeMouseEvent(mxEvent.MOUSE_UP, e), this.reset();
}, mxGraphHandler.prototype.selectDelayed = function (t) {
  this.graph.isCellSelected(this.cell) && this.graph.popupMenuHandler.isPopupTrigger(t) || this.graph.selectCellForEvent(this.cell, t.getEvent());
}, mxGraphHandler.prototype.reset = function () {
  this.destroyShapes(), this.removeHint(), this.delayedSelection = this.cellWasClicked = !1, this.target = this.cell = this.first = this.guides = this.currentDy = this.currentDx = null;
}, mxGraphHandler.prototype.shouldRemoveCellsFromParent = function (t, e, i) {
  if (this.graph.getModel().isVertex(t) && null != (t = this.graph.getView().getState(t))) {
    if (i = mxUtils.convertPoint(this.graph.container, mxEvent.getClientX(i), mxEvent.getClientY(i)), 0 != (n = mxUtils.toRadians(mxUtils.getValue(t.style, mxConstants.STYLE_ROTATION) || 0))) {
      e = Math.cos(-n);
      var n = Math.sin(-n),
          s = new mxPoint(t.getCenterX(), t.getCenterY());
      i = mxUtils.getRotatedPoint(i, e, n, s);
    }

    return !mxUtils.contains(t, i.x, i.y);
  }

  return !1;
}, mxGraphHandler.prototype.moveCells = function (t, e, i, n, s, o) {
  n && (t = this.graph.getCloneableCells(t)), null == s && this.isRemoveCellsFromParent() && this.shouldRemoveCellsFromParent(this.graph.getModel().getParent(this.cell), t, o) && (s = this.graph.getDefaultParent()), n = n && !this.graph.isCellLocked(s || this.graph.getDefaultParent()), t = this.graph.moveCells(t, e - this.graph.panDx / this.graph.view.scale, i - this.graph.panDy / this.graph.view.scale, n, s, o), this.isSelectEnabled() && this.scrollOnMove && this.graph.scrollCellToVisible(t[0]), n && this.graph.setSelectionCells(t);
}, mxGraphHandler.prototype.destroyShapes = function () {
  null != this.shape && (this.shape.destroy(), this.shape = null), null != this.guide && (this.guide.destroy(), this.guide = null), null != this.highlight && (this.highlight.destroy(), this.highlight = null);
}, mxGraphHandler.prototype.destroy = function () {
  this.graph.removeMouseListener(this), this.graph.removeListener(this.panHandler), null != this.escapeHandler && (this.graph.removeListener(this.escapeHandler), this.escapeHandler = null), null != this.refreshHandler && (this.graph.getModel().removeListener(this.refreshHandler), this.refreshHandler = null), this.destroyShapes(), this.removeHint();
}, mxPanningHandler.prototype = new mxEventSource(), mxPanningHandler.prototype.constructor = mxPanningHandler, mxPanningHandler.prototype.graph = null, mxPanningHandler.prototype.useLeftButtonForPanning = !1, mxPanningHandler.prototype.usePopupTrigger = !0, mxPanningHandler.prototype.ignoreCell = !1, mxPanningHandler.prototype.previewEnabled = !0, mxPanningHandler.prototype.useGrid = !1, mxPanningHandler.prototype.panningEnabled = !0, mxPanningHandler.prototype.pinchEnabled = !0, mxPanningHandler.prototype.maxScale = 8, mxPanningHandler.prototype.minScale = .01, mxPanningHandler.prototype.dx = null, mxPanningHandler.prototype.dy = null, mxPanningHandler.prototype.startX = 0, mxPanningHandler.prototype.startY = 0, mxPanningHandler.prototype.isActive = function () {
  return this.active || null != this.initialScale;
}, mxPanningHandler.prototype.isPanningEnabled = function () {
  return this.panningEnabled;
}, mxPanningHandler.prototype.setPanningEnabled = function (t) {
  this.panningEnabled = t;
}, mxPanningHandler.prototype.isPinchEnabled = function () {
  return this.pinchEnabled;
}, mxPanningHandler.prototype.setPinchEnabled = function (t) {
  this.pinchEnabled = t;
}, mxPanningHandler.prototype.isPanningTrigger = function (t) {
  var e = t.getEvent();
  return this.useLeftButtonForPanning && null == t.getState() && mxEvent.isLeftMouseButton(e) || mxEvent.isControlDown(e) && mxEvent.isShiftDown(e) || this.usePopupTrigger && mxEvent.isPopupTrigger(e);
}, mxPanningHandler.prototype.isForcePanningEvent = function (t) {
  return this.ignoreCell || mxEvent.isMultiTouchEvent(t.getEvent());
}, mxPanningHandler.prototype.mouseDown = function (t, e) {
  this.mouseDownEvent = e, !e.isConsumed() && this.isPanningEnabled() && !this.active && this.isPanningTrigger(e) && (this.start(e), this.consumePanningTrigger(e));
};
mxPanningHandler.prototype.start = function (t) {
  this.dx0 = -this.graph.container.scrollLeft, this.dy0 = -this.graph.container.scrollTop, this.startX = t.getX(), this.startY = t.getY(), this.dy = this.dx = null, this.panningTrigger = !0;
}, mxPanningHandler.prototype.consumePanningTrigger = function (t) {
  t.consume();
}, mxPanningHandler.prototype.mouseMove = function (t, e) {
  if (this.dx = e.getX() - this.startX, this.dy = e.getY() - this.startY, this.active) this.previewEnabled && (this.useGrid && (this.dx = this.graph.snap(this.dx), this.dy = this.graph.snap(this.dy)), this.graph.panGraph(this.dx + this.dx0, this.dy + this.dy0)), this.fireEvent(new mxEventObject(mxEvent.PAN, "event", e));else if (this.panningTrigger) {
    var i = this.active;
    this.active = Math.abs(this.dx) > this.graph.tolerance || Math.abs(this.dy) > this.graph.tolerance, !i && this.active && this.fireEvent(new mxEventObject(mxEvent.PAN_START, "event", e));
  }
  (this.active || this.panningTrigger) && e.consume();
}, mxPanningHandler.prototype.mouseUp = function (t, e) {
  if (this.active) {
    if (null != this.dx && null != this.dy) {
      if (!this.graph.useScrollbarsForPanning || !mxUtils.hasScrollbars(this.graph.container)) {
        var i = this.graph.getView().scale,
            n = this.graph.getView().translate;
        this.graph.panGraph(0, 0), this.panGraph(n.x + this.dx / i, n.y + this.dy / i);
      }

      e.consume();
    }

    this.fireEvent(new mxEventObject(mxEvent.PAN_END, "event", e));
  }

  this.reset();
}, mxPanningHandler.prototype.reset = function () {
  this.panningTrigger = !1, this.mouseDownEvent = null, this.active = !1, this.dy = this.dx = null;
}, mxPanningHandler.prototype.panGraph = function (t, e) {
  this.graph.getView().setTranslate(t, e);
}, mxPanningHandler.prototype.destroy = function () {
  this.graph.removeMouseListener(this), this.graph.removeListener(this.forcePanningHandler), this.graph.removeListener(this.gestureHandler), mxEvent.removeListener(document, "mouseup", this.mouseUpListener);
}, mxPopupMenuHandler.prototype = new mxPopupMenu(), mxPopupMenuHandler.prototype.constructor = mxPopupMenuHandler, mxPopupMenuHandler.prototype.graph = null, mxPopupMenuHandler.prototype.selectOnPopup = !0, mxPopupMenuHandler.prototype.clearSelectionOnBackground = !0, mxPopupMenuHandler.prototype.triggerX = null, mxPopupMenuHandler.prototype.triggerY = null, mxPopupMenuHandler.prototype.screenX = null, mxPopupMenuHandler.prototype.screenY = null, mxPopupMenuHandler.prototype.init = function () {
  mxPopupMenu.prototype.init.apply(this), mxEvent.addGestureListeners(this.div, mxUtils.bind(this, function (t) {
    this.graph.tooltipHandler.hide();
  }));
}, mxPopupMenuHandler.prototype.isSelectOnPopup = function (t) {
  return this.selectOnPopup;
}, mxPopupMenuHandler.prototype.mouseDown = function (t, e) {
  this.isEnabled() && !mxEvent.isMultiTouchEvent(e.getEvent()) && (this.hideMenu(), this.triggerX = e.getGraphX(), this.triggerY = e.getGraphY(), this.screenX = mxEvent.getMainEvent(e.getEvent()).screenX, this.screenY = mxEvent.getMainEvent(e.getEvent()).screenY, this.popupTrigger = this.isPopupTrigger(e), this.inTolerance = !0);
}, mxPopupMenuHandler.prototype.mouseMove = function (t, e) {
  this.inTolerance && null != this.screenX && null != this.screenY && (Math.abs(mxEvent.getMainEvent(e.getEvent()).screenX - this.screenX) > this.graph.tolerance || Math.abs(mxEvent.getMainEvent(e.getEvent()).screenY - this.screenY) > this.graph.tolerance) && (this.inTolerance = !1);
}, mxPopupMenuHandler.prototype.mouseUp = function (t, e) {
  if (this.popupTrigger && this.inTolerance && null != this.triggerX && null != this.triggerY) {
    var i = this.getCellForPopupEvent(e);
    this.graph.isEnabled() && this.isSelectOnPopup(e) && null != i && !this.graph.isCellSelected(i) ? this.graph.setSelectionCell(i) : this.clearSelectionOnBackground && null == i && this.graph.clearSelection(), this.graph.tooltipHandler.hide();
    var n = mxUtils.getScrollOrigin();
    this.popup(e.getX() + n.x + 1, e.getY() + n.y + 1, i, e.getEvent()), e.consume();
  }

  this.inTolerance = this.popupTrigger = !1;
}, mxPopupMenuHandler.prototype.getCellForPopupEvent = function (t) {
  return t.getCell();
}, mxPopupMenuHandler.prototype.destroy = function () {
  this.graph.removeMouseListener(this), this.graph.removeListener(this.gestureHandler), mxPopupMenu.prototype.destroy.apply(this);
}, mxUtils.extend(mxCellMarker, mxEventSource), mxCellMarker.prototype.graph = null, mxCellMarker.prototype.enabled = !0, mxCellMarker.prototype.hotspot = mxConstants.DEFAULT_HOTSPOT, mxCellMarker.prototype.hotspotEnabled = !1, mxCellMarker.prototype.validColor = null, mxCellMarker.prototype.invalidColor = null, mxCellMarker.prototype.currentColor = null, mxCellMarker.prototype.validState = null, mxCellMarker.prototype.markedState = null, mxCellMarker.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxCellMarker.prototype.isEnabled = function () {
  return this.enabled;
}, mxCellMarker.prototype.setHotspot = function (t) {
  this.hotspot = t;
}, mxCellMarker.prototype.getHotspot = function () {
  return this.hotspot;
}, mxCellMarker.prototype.setHotspotEnabled = function (t) {
  this.hotspotEnabled = t;
}, mxCellMarker.prototype.isHotspotEnabled = function () {
  return this.hotspotEnabled;
}, mxCellMarker.prototype.hasValidState = function () {
  return null != this.validState;
}, mxCellMarker.prototype.getValidState = function () {
  return this.validState;
}, mxCellMarker.prototype.getMarkedState = function () {
  return this.markedState;
}, mxCellMarker.prototype.reset = function () {
  this.validState = null, null != this.markedState && (this.markedState = null, this.unmark());
}, mxCellMarker.prototype.process = function (t) {
  var e = null;
  return this.isEnabled() && (e = this.getState(t), this.setCurrentState(e, t)), e;
}, mxCellMarker.prototype.setCurrentState = function (t, e, i) {
  var n = null != t && this.isValidState(t);
  i = null != i ? i : this.getMarkerColor(e.getEvent(), t, n), this.validState = n ? t : null, t == this.markedState && i == this.currentColor || (this.currentColor = i, null != t && null != this.currentColor ? (this.markedState = t, this.mark()) : null != this.markedState && (this.markedState = null, this.unmark()));
}, mxCellMarker.prototype.markCell = function (t, e) {
  var i = this.graph.getView().getState(t);
  null != i && (this.currentColor = null != e ? e : this.validColor, this.markedState = i, this.mark());
}, mxCellMarker.prototype.mark = function () {
  this.highlight.setHighlightColor(this.currentColor), this.highlight.highlight(this.markedState), this.fireEvent(new mxEventObject(mxEvent.MARK, "state", this.markedState));
}, mxCellMarker.prototype.unmark = function () {
  this.mark();
}, mxCellMarker.prototype.isValidState = function (t) {
  return !0;
}, mxCellMarker.prototype.getMarkerColor = function (t, e, i) {
  return i ? this.validColor : this.invalidColor;
}, mxCellMarker.prototype.getState = function (t) {
  var e = this.graph.getView(),
      i = this.getCell(t);
  return null != (e = this.getStateToMark(e.getState(i))) && this.intersects(e, t) ? e : null;
}, mxCellMarker.prototype.getCell = function (t) {
  return t.getCell();
}, mxCellMarker.prototype.getStateToMark = function (t) {
  return t;
}, mxCellMarker.prototype.intersects = function (t, e) {
  return !this.hotspotEnabled || mxUtils.intersectsHotspot(t, e.getGraphX(), e.getGraphY(), this.hotspot, mxConstants.MIN_HOTSPOT_SIZE, mxConstants.MAX_HOTSPOT_SIZE);
}, mxCellMarker.prototype.destroy = function () {
  this.graph.getView().removeListener(this.resetHandler), this.graph.getModel().removeListener(this.resetHandler), this.highlight.destroy();
}, mxUtils.extend(mxSelectionCellsHandler, mxEventSource), mxSelectionCellsHandler.prototype.graph = null, mxSelectionCellsHandler.prototype.enabled = !0, mxSelectionCellsHandler.prototype.refreshHandler = null, mxSelectionCellsHandler.prototype.maxHandlers = 100, mxSelectionCellsHandler.prototype.handlers = null, mxSelectionCellsHandler.prototype.isEnabled = function () {
  return this.enabled;
}, mxSelectionCellsHandler.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxSelectionCellsHandler.prototype.getHandler = function (t) {
  return this.handlers.get(t);
}, mxSelectionCellsHandler.prototype.reset = function () {
  this.handlers.visit(function (t, e) {
    e.reset.apply(e);
  });
}, mxSelectionCellsHandler.prototype.refresh = function () {
  var t = this.handlers;
  this.handlers = new mxDictionary();

  for (var e = this.graph.getSelectionCells(), i = 0; i < e.length; i++) {
    var n = this.graph.view.getState(e[i]);

    if (null != n) {
      var s = t.remove(e[i]);
      null != s && (s.state != n ? (s.destroy(), s = null) : this.isHandlerActive(s) || (null != s.refresh && s.refresh(), s.redraw())), null == s && (s = this.graph.createHandler(n), this.fireEvent(new mxEventObject(mxEvent.ADD, "state", n))), null != s && this.handlers.put(e[i], s);
    }
  }

  t.visit(mxUtils.bind(this, function (t, e) {
    this.fireEvent(new mxEventObject(mxEvent.REMOVE, "state", e.state)), e.destroy();
  }));
}, mxSelectionCellsHandler.prototype.isHandlerActive = function (t) {
  return null != t.index;
}, mxSelectionCellsHandler.prototype.updateHandler = function (t) {
  var e = this.handlers.remove(t.cell);
  null != e && (e.destroy(), null != (e = this.graph.createHandler(t)) && this.handlers.put(t.cell, e));
}, mxSelectionCellsHandler.prototype.mouseDown = function (t, e) {
  if (this.graph.isEnabled() && this.isEnabled()) {
    var i = [t, e];
    this.handlers.visit(function (t, e) {
      e.mouseDown.apply(e, i);
    });
  }
}, mxSelectionCellsHandler.prototype.mouseMove = function (t, e) {
  if (this.graph.isEnabled() && this.isEnabled()) {
    var i = [t, e];
    this.handlers.visit(function (t, e) {
      e.mouseMove.apply(e, i);
    });
  }
}, mxSelectionCellsHandler.prototype.mouseUp = function (t, e) {
  if (this.graph.isEnabled() && this.isEnabled()) {
    var i = [t, e];
    this.handlers.visit(function (t, e) {
      e.mouseUp.apply(e, i);
    });
  }
}, mxSelectionCellsHandler.prototype.destroy = function () {
  this.graph.removeMouseListener(this), null != this.refreshHandler && (this.graph.getSelectionModel().removeListener(this.refreshHandler), this.graph.getModel().removeListener(this.refreshHandler), this.graph.getView().removeListener(this.refreshHandler), this.refreshHandler = null);
}, mxUtils.extend(mxConnectionHandler, mxEventSource), mxConnectionHandler.prototype.graph = null, mxConnectionHandler.prototype.factoryMethod = !0, mxConnectionHandler.prototype.moveIconFront = !1, mxConnectionHandler.prototype.moveIconBack = !1, mxConnectionHandler.prototype.connectImage = null, mxConnectionHandler.prototype.targetConnectImage = !1, mxConnectionHandler.prototype.enabled = !0, mxConnectionHandler.prototype.select = !0, mxConnectionHandler.prototype.createTarget = !1, mxConnectionHandler.prototype.marker = null, mxConnectionHandler.prototype.constraintHandler = null, mxConnectionHandler.prototype.error = null, mxConnectionHandler.prototype.waypointsEnabled = !1, mxConnectionHandler.prototype.ignoreMouseDown = !1, mxConnectionHandler.prototype.first = null, mxConnectionHandler.prototype.connectIconOffset = new mxPoint(0, mxConstants.TOOLTIP_VERTICAL_OFFSET), mxConnectionHandler.prototype.edgeState = null, mxConnectionHandler.prototype.changeHandler = null, mxConnectionHandler.prototype.drillHandler = null, mxConnectionHandler.prototype.mouseDownCounter = 0, mxConnectionHandler.prototype.movePreviewAway = mxClient.IS_VML, mxConnectionHandler.prototype.outlineConnect = !1, mxConnectionHandler.prototype.livePreview = !1, mxConnectionHandler.prototype.cursor = null, mxConnectionHandler.prototype.insertBeforeSource = !1, mxConnectionHandler.prototype.isEnabled = function () {
  return this.enabled;
}, mxConnectionHandler.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxConnectionHandler.prototype.isInsertBefore = function (t, e, i, n, s) {
  return this.insertBeforeSource && e != i;
}, mxConnectionHandler.prototype.isCreateTarget = function (t) {
  return this.createTarget;
}, mxConnectionHandler.prototype.setCreateTarget = function (t) {
  this.createTarget = t;
}, mxConnectionHandler.prototype.createShape = function () {
  var t = this.livePreview && null != this.edgeState ? this.graph.cellRenderer.createShape(this.edgeState) : new mxPolyline([], mxConstants.INVALID_COLOR);
  return t.dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_VML : mxConstants.DIALECT_SVG, t.scale = this.graph.view.scale, t.pointerEvents = !1, t.isDashed = !0, t.init(this.graph.getView().getOverlayPane()), mxEvent.redirectMouseEvents(t.node, this.graph, null), t;
}, mxConnectionHandler.prototype.init = function () {
  this.graph.addMouseListener(this), this.marker = this.createMarker(), this.constraintHandler = new mxConstraintHandler(this.graph), this.changeHandler = mxUtils.bind(this, function (t) {
    null != this.iconState && (this.iconState = this.graph.getView().getState(this.iconState.cell)), null != this.iconState ? (this.redrawIcons(this.icons, this.iconState), this.constraintHandler.reset()) : null != this.previous && null == this.graph.view.getState(this.previous.cell) && this.reset();
  }), this.graph.getModel().addListener(mxEvent.CHANGE, this.changeHandler), this.graph.getView().addListener(mxEvent.SCALE, this.changeHandler), this.graph.getView().addListener(mxEvent.TRANSLATE, this.changeHandler), this.graph.getView().addListener(mxEvent.SCALE_AND_TRANSLATE, this.changeHandler), this.drillHandler = mxUtils.bind(this, function (t) {
    this.reset();
  }), this.graph.addListener(mxEvent.START_EDITING, this.drillHandler), this.graph.getView().addListener(mxEvent.DOWN, this.drillHandler), this.graph.getView().addListener(mxEvent.UP, this.drillHandler);
}, mxConnectionHandler.prototype.isConnectableCell = function (t) {
  return !0;
}, mxConnectionHandler.prototype.createMarker = function () {
  var t = new mxCellMarker(this.graph);
  return t.hotspotEnabled = !0, t.getCell = mxUtils.bind(this, function (e) {
    var i = mxCellMarker.prototype.getCell.apply(t, arguments);

    if (this.error = null, null == i && null != this.currentPoint && (i = this.graph.getCellAt(this.currentPoint.x, this.currentPoint.y)), null != i && !this.graph.isCellConnectable(i)) {
      var n = this.graph.getModel().getParent(i);
      this.graph.getModel().isVertex(n) && this.graph.isCellConnectable(n) && (i = n);
    }

    return (this.graph.isSwimlane(i) && null != this.currentPoint && this.graph.hitsSwimlaneContent(i, this.currentPoint.x, this.currentPoint.y) || !this.isConnectableCell(i)) && (i = null), null != i ? this.isConnecting() ? null != this.previous && (this.error = this.validateConnection(this.previous.cell, i), null != this.error && 0 == this.error.length && (i = null, this.isCreateTarget(e.getEvent()) && (this.error = null))) : this.isValidSource(i, e) || (i = null) : !this.isConnecting() || this.isCreateTarget(e.getEvent()) || this.graph.allowDanglingEdges || (this.error = ""), i;
  }), t.isValidState = mxUtils.bind(this, function (e) {
    return this.isConnecting() ? null == this.error : mxCellMarker.prototype.isValidState.apply(t, arguments);
  }), t.getMarkerColor = mxUtils.bind(this, function (e, i, n) {
    return null == this.connectImage || this.isConnecting() ? mxCellMarker.prototype.getMarkerColor.apply(t, arguments) : null;
  }), t.intersects = mxUtils.bind(this, function (e, i) {
    return !(null == this.connectImage && !this.isConnecting()) || mxCellMarker.prototype.intersects.apply(t, arguments);
  }), t;
}, mxConnectionHandler.prototype.start = function (t, e, i, n) {
  this.previous = t, this.first = new mxPoint(e, i), this.edgeState = null != n ? n : this.createEdgeState(null), this.marker.currentColor = this.marker.validColor, this.marker.markedState = t, this.marker.mark(), this.fireEvent(new mxEventObject(mxEvent.START, "state", this.previous));
}, mxConnectionHandler.prototype.isConnecting = function () {
  return null != this.first && null != this.shape;
}, mxConnectionHandler.prototype.isValidSource = function (t, e) {
  return this.graph.isValidSource(t);
}, mxConnectionHandler.prototype.isValidTarget = function (t) {
  return !0;
}, mxConnectionHandler.prototype.validateConnection = function (t, e) {
  return this.isValidTarget(e) ? this.graph.getEdgeValidationError(null, t, e) : "";
}, mxConnectionHandler.prototype.getConnectImage = function (t) {
  return this.connectImage;
}, mxConnectionHandler.prototype.isMoveIconToFrontForState = function (t) {
  return null != t.text && t.text.node.parentNode == this.graph.container || this.moveIconFront;
}, mxConnectionHandler.prototype.createIcons = function (t) {
  if (null != (s = this.getConnectImage(t)) && null != t) {
    this.iconState = t;
    var e = [],
        i = new mxImageShape(new mxRectangle(0, 0, s.width, s.height), s.src, null, null, 0);
    i.preserveImageAspect = !1, this.isMoveIconToFrontForState(t) ? (i.dialect = mxConstants.DIALECT_STRICTHTML, i.init(this.graph.container)) : (i.dialect = this.graph.dialect == mxConstants.DIALECT_SVG ? mxConstants.DIALECT_SVG : mxConstants.DIALECT_VML, i.init(this.graph.getView().getOverlayPane()), this.moveIconBack && null != i.node.previousSibling && i.node.parentNode.insertBefore(i.node, i.node.parentNode.firstChild)), i.node.style.cursor = mxConstants.CURSOR_CONNECT;
    var n = mxUtils.bind(this, function () {
      return null != this.currentState ? this.currentState : t;
    }),
        s = mxUtils.bind(this, function (t) {
      mxEvent.isConsumed(t) || (this.icon = i, this.graph.fireMouseEvent(mxEvent.MOUSE_DOWN, new mxMouseEvent(t, n())));
    });
    return mxEvent.redirectMouseEvents(i.node, this.graph, n, s), e.push(i), this.redrawIcons(e, this.iconState), e;
  }

  return null;
}, mxConnectionHandler.prototype.redrawIcons = function (t, e) {
  if (null != t && null != t[0] && null != e) {
    var i = this.getIconPosition(t[0], e);
    t[0].bounds.x = i.x, t[0].bounds.y = i.y, t[0].redraw();
  }
}, mxConnectionHandler.prototype.getIconPosition = function (t, e) {
  var i = this.graph.getView().scale,
      n = e.getCenterX(),
      s = e.getCenterY();

  if (this.graph.isSwimlane(e.cell)) {
    n = 0 != (o = this.graph.getStartSize(e.cell)).width ? e.x + o.width * i / 2 : n, s = 0 != o.height ? e.y + o.height * i / 2 : s;

    if (0 != (o = mxUtils.toRadians(mxUtils.getValue(e.style, mxConstants.STYLE_ROTATION) || 0))) {
      i = Math.cos(o);
      var o = Math.sin(o),
          l = new mxPoint(e.getCenterX(), e.getCenterY());
      n = (s = mxUtils.getRotatedPoint(new mxPoint(n, s), i, o, l)).x, s = s.y;
    }
  }

  return new mxPoint(n - t.bounds.width / 2, s - t.bounds.height / 2);
}, mxConnectionHandler.prototype.destroyIcons = function () {
  if (null != this.icons) {
    for (var t = 0; t < this.icons.length; t++) {
      this.icons[t].destroy();
    }

    this.iconState = this.selectedIcon = this.icon = this.icons = null;
  }
}, mxConnectionHandler.prototype.isStartEvent = function (t) {
  return null != this.constraintHandler.currentFocus && null != this.constraintHandler.currentConstraint || null != this.previous && null == this.error && (null == this.icons || null != this.icons && null != this.icon);
}, mxConnectionHandler.prototype.mouseDown = function (t, e) {
  if (this.mouseDownCounter++, this.isEnabled() && this.graph.isEnabled() && !e.isConsumed() && !this.isConnecting() && this.isStartEvent(e)) {
    if (null != this.constraintHandler.currentConstraint && null != this.constraintHandler.currentFocus && null != this.constraintHandler.currentPoint ? (this.sourceConstraint = this.constraintHandler.currentConstraint, this.previous = this.constraintHandler.currentFocus, this.first = this.constraintHandler.currentPoint.clone()) : this.first = new mxPoint(e.getGraphX(), e.getGraphY()), this.edgeState = this.createEdgeState(e), this.mouseDownCounter = 1, this.waypointsEnabled && null == this.shape && (this.waypoints = null, this.shape = this.createShape(), null != this.edgeState && this.shape.apply(this.edgeState)), null == this.previous && null != this.edgeState) {
      var i = this.graph.getPointForEvent(e.getEvent());
      this.edgeState.cell.geometry.setTerminalPoint(i, !0);
    }

    this.fireEvent(new mxEventObject(mxEvent.START, "state", this.previous)), e.consume();
  }

  this.selectedIcon = this.icon, this.icon = null;
}, mxConnectionHandler.prototype.isImmediateConnectSource = function (t) {
  return !this.graph.isCellMovable(t.cell);
}, mxConnectionHandler.prototype.createEdgeState = function (t) {
  return null;
}, mxConnectionHandler.prototype.isOutlineConnectEvent = function (t) {
  var e = mxUtils.getOffset(this.graph.container),
      i = t.getEvent(),
      n = mxEvent.getClientX(i),
      s = (i = mxEvent.getClientY(i), document.documentElement),
      o = this.currentPoint.x - this.graph.container.scrollLeft + e.x - ((window.pageXOffset || s.scrollLeft) - (s.clientLeft || 0));
  e = this.currentPoint.y - this.graph.container.scrollTop + e.y - ((window.pageYOffset || s.scrollTop) - (s.clientTop || 0));
  return this.outlineConnect && !mxEvent.isShiftDown(t.getEvent()) && (t.isSource(this.marker.highlight.shape) || mxEvent.isAltDown(t.getEvent()) && null != t.getState() || this.marker.highlight.isHighlightAt(n, i) || (o != n || e != i) && null == t.getState() && this.marker.highlight.isHighlightAt(o, e));
}, mxConnectionHandler.prototype.updateCurrentState = function (t, e) {
  if (this.constraintHandler.update(t, null == this.first, !1, null == this.first || t.isSource(this.marker.highlight.shape) ? null : e), null != this.constraintHandler.currentFocus && null != this.constraintHandler.currentConstraint) null != this.marker.highlight && null != this.marker.highlight.state && this.marker.highlight.state.cell == this.constraintHandler.currentFocus.cell ? "transparent" != this.marker.highlight.shape.stroke && (this.marker.highlight.shape.stroke = "transparent", this.marker.highlight.repaint()) : this.marker.markCell(this.constraintHandler.currentFocus.cell, "transparent"), null != this.previous && (this.error = this.validateConnection(this.previous.cell, this.constraintHandler.currentFocus.cell), null == this.error ? this.currentState = this.constraintHandler.currentFocus : this.constraintHandler.reset());else {
    this.graph.isIgnoreTerminalEvent(t.getEvent()) ? (this.marker.reset(), this.currentState = null) : (this.marker.process(t), this.currentState = this.marker.getValidState(), null == this.currentState || this.isCellEnabled(this.currentState.cell) || (this.currentState = null));
    var i = this.isOutlineConnectEvent(t);
    null != this.currentState && i && (t.isSource(this.marker.highlight.shape) && (e = new mxPoint(t.getGraphX(), t.getGraphY())), i = this.graph.getOutlineConstraint(e, this.currentState, t), this.constraintHandler.setFocus(t, this.currentState, !1), this.constraintHandler.currentConstraint = i, this.constraintHandler.currentPoint = e), this.outlineConnect && null != this.marker.highlight && null != this.marker.highlight.shape && (i = this.graph.view.scale, null != this.constraintHandler.currentConstraint && null != this.constraintHandler.currentFocus ? (this.marker.highlight.shape.stroke = mxConstants.OUTLINE_HIGHLIGHT_COLOR, this.marker.highlight.shape.strokewidth = mxConstants.OUTLINE_HIGHLIGHT_STROKEWIDTH / i / i, this.marker.highlight.repaint()) : this.marker.hasValidState() && (this.marker.getValidState() != t.getState() ? (this.marker.highlight.shape.stroke = "transparent", this.currentState = null) : this.marker.highlight.shape.stroke = mxConstants.DEFAULT_VALID_COLOR, this.marker.highlight.shape.strokewidth = mxConstants.HIGHLIGHT_STROKEWIDTH / i / i, this.marker.highlight.repaint()));
  }
}, mxConnectionHandler.prototype.isCellEnabled = function (t) {
  return !0;
}, mxConnectionHandler.prototype.convertWaypoint = function (t) {
  var e = this.graph.getView().getScale(),
      i = this.graph.getView().getTranslate();
  t.x = t.x / e - i.x, t.y = t.y / e - i.y;
}, mxConnectionHandler.prototype.snapToPreview = function (t, e) {
  if (!mxEvent.isAltDown(t.getEvent()) && null != this.previous) {
    var i = this.graph.gridSize * this.graph.view.scale / 2,
        n = null != this.sourceConstraint ? this.first : new mxPoint(this.previous.getCenterX(), this.previous.getCenterY());
    Math.abs(n.x - t.getGraphX()) < i && (e.x = n.x), Math.abs(n.y - t.getGraphY()) < i && (e.y = n.y);
  }
}, mxConnectionHandler.prototype.mouseMove = function (t, e) {
  if (e.isConsumed() || !this.ignoreMouseDown && null == this.first && this.graph.isMouseDown) this.constraintHandler.reset();else {
    this.isEnabled() || null == this.currentState || (this.destroyIcons(), this.currentState = null);
    var i = (s = this.graph.getView()).scale,
        n = s.translate,
        s = new mxPoint(e.getGraphX(), e.getGraphY());

    if (this.error = null, this.graph.isGridEnabledEvent(e.getEvent()) && (s = new mxPoint((this.graph.snap(s.x / i - n.x) + n.x) * i, (this.graph.snap(s.y / i - n.y) + n.y) * i)), this.snapToPreview(e, s), this.currentPoint = s, (null != this.first || this.isEnabled() && this.graph.isEnabled()) && (null != this.shape || null == this.first || Math.abs(e.getGraphX() - this.first.x) > this.graph.tolerance || Math.abs(e.getGraphY() - this.first.y) > this.graph.tolerance) && this.updateCurrentState(e, s), null != this.first) {
      var o = null;
      i = s;

      if (null != this.constraintHandler.currentConstraint && null != this.constraintHandler.currentFocus && null != this.constraintHandler.currentPoint ? (o = this.constraintHandler.currentConstraint, i = this.constraintHandler.currentPoint.clone()) : null != this.previous && !this.graph.isIgnoreTerminalEvent(e.getEvent()) && mxEvent.isShiftDown(e.getEvent()) && (Math.abs(this.previous.getCenterX() - s.x) < Math.abs(this.previous.getCenterY() - s.y) ? s.x = this.previous.getCenterX() : s.y = this.previous.getCenterY()), n = this.first, null != this.selectedIcon) {
        var l = this.selectedIcon.bounds.width,
            r = this.selectedIcon.bounds.height;
        null != this.currentState && this.targetConnectImage ? (l = this.getIconPosition(this.selectedIcon, this.currentState), this.selectedIcon.bounds.x = l.x, this.selectedIcon.bounds.y = l.y) : (l = new mxRectangle(e.getGraphX() + this.connectIconOffset.x, e.getGraphY() + this.connectIconOffset.y, l, r), this.selectedIcon.bounds = l), this.selectedIcon.redraw();
      }

      if (null != this.edgeState ? (this.updateEdgeState(i, o), i = this.edgeState.absolutePoints[this.edgeState.absolutePoints.length - 1], n = this.edgeState.absolutePoints[0]) : (null != this.currentState && null == this.constraintHandler.currentConstraint && null != (l = this.getTargetPerimeterPoint(this.currentState, e)) && (i = l), null == this.sourceConstraint && null != this.previous && null != (l = this.getSourcePerimeterPoint(this.previous, null != this.waypoints && 0 < this.waypoints.length ? this.waypoints[0] : i, e)) && (n = l)), null == this.currentState && this.movePreviewAway) {
        if (l = n, null != this.edgeState && 2 <= this.edgeState.absolutePoints.length && null != (o = this.edgeState.absolutePoints[this.edgeState.absolutePoints.length - 2]) && (l = o), o = i.x - l.x, l = i.y - l.y, 0 == (r = Math.sqrt(o * o + l * l))) return;
        this.originalPoint = i.clone(), i.x -= 4 * o / r, i.y -= 4 * l / r;
      } else this.originalPoint = null;

      null == this.shape && (o = Math.abs(e.getGraphX() - this.first.x), l = Math.abs(e.getGraphY() - this.first.y), o > this.graph.tolerance || l > this.graph.tolerance) && (this.shape = this.createShape(), null != this.edgeState && this.shape.apply(this.edgeState), this.updateCurrentState(e, s)), null != this.shape && (null != this.edgeState ? this.shape.points = this.edgeState.absolutePoints : (s = [n], null != this.waypoints && (s = s.concat(this.waypoints)), s.push(i), this.shape.points = s), this.drawPreview()), null != this.cursor && (this.graph.container.style.cursor = this.cursor), mxEvent.consume(e.getEvent()), e.consume();
    } else this.isEnabled() && this.graph.isEnabled() ? this.previous != this.currentState && null == this.edgeState ? (this.destroyIcons(), null != this.currentState && null == this.error && null == this.constraintHandler.currentConstraint && (this.icons = this.createIcons(this.currentState), null == this.icons && (this.currentState.setCursor(mxConstants.CURSOR_CONNECT), e.consume())), this.previous = this.currentState) : this.previous != this.currentState || null == this.currentState || null != this.icons || this.graph.isMouseDown || e.consume() : this.constraintHandler.reset();

    if (!this.graph.isMouseDown && null != this.currentState && null != this.icons) {
      for (s = !1, i = e.getSource(), n = 0; n < this.icons.length && !s; n++) {
        s = i == this.icons[n].node || i.parentNode == this.icons[n].node;
      }

      s || this.updateIcons(this.currentState, this.icons, e);
    }
  }
}, mxConnectionHandler.prototype.updateEdgeState = function (t, e) {
  null != this.sourceConstraint && null != this.sourceConstraint.point && (this.edgeState.style[mxConstants.STYLE_EXIT_X] = this.sourceConstraint.point.x, this.edgeState.style[mxConstants.STYLE_EXIT_Y] = this.sourceConstraint.point.y), null != e && null != e.point ? (this.edgeState.style[mxConstants.STYLE_ENTRY_X] = e.point.x, this.edgeState.style[mxConstants.STYLE_ENTRY_Y] = e.point.y) : (delete this.edgeState.style[mxConstants.STYLE_ENTRY_X], delete this.edgeState.style[mxConstants.STYLE_ENTRY_Y]), this.edgeState.absolutePoints = [null, null != this.currentState ? null : t], this.graph.view.updateFixedTerminalPoint(this.edgeState, this.previous, !0, this.sourceConstraint), null != this.currentState && (null == e && (e = this.graph.getConnectionConstraint(this.edgeState, this.previous, !1)), this.edgeState.setAbsoluteTerminalPoint(null, !1), this.graph.view.updateFixedTerminalPoint(this.edgeState, this.currentState, !1, e));
  var i = null;

  if (null != this.waypoints) {
    i = [];

    for (var n = 0; n < this.waypoints.length; n++) {
      var s = this.waypoints[n].clone();
      this.convertWaypoint(s), i[n] = s;
    }
  }

  this.graph.view.updatePoints(this.edgeState, i, this.previous, this.currentState), this.graph.view.updateFloatingTerminalPoints(this.edgeState, this.previous, this.currentState);
}, mxConnectionHandler.prototype.getTargetPerimeterPoint = function (t, e) {
  var i = null,
      n = (s = t.view).getPerimeterFunction(t);

  if (null != n) {
    var s,
        o = null != this.waypoints && 0 < this.waypoints.length ? this.waypoints[this.waypoints.length - 1] : new mxPoint(this.previous.getCenterX(), this.previous.getCenterY());
    null != (s = n(s.getPerimeterBounds(t), this.edgeState, o, !1)) && (i = s);
  } else i = new mxPoint(t.getCenterX(), t.getCenterY());

  return i;
}, mxConnectionHandler.prototype.getSourcePerimeterPoint = function (t, e, i) {
  i = null;
  var n = t.view,
      s = n.getPerimeterFunction(t),
      o = new mxPoint(t.getCenterX(), t.getCenterY());

  if (null != s) {
    var l = mxUtils.getValue(t.style, mxConstants.STYLE_ROTATION, 0),
        r = Math.PI / 180 * -l;
    0 != l && (e = mxUtils.getRotatedPoint(new mxPoint(e.x, e.y), Math.cos(r), Math.sin(r), o)), null != (t = s(n.getPerimeterBounds(t), t, e, !1)) && (0 != l && (t = mxUtils.getRotatedPoint(new mxPoint(t.x, t.y), Math.cos(-r), Math.sin(-r), o)), i = t);
  } else i = o;

  return i;
}, mxConnectionHandler.prototype.updateIcons = function (t, e, i) {}, mxConnectionHandler.prototype.isStopEvent = function (t) {
  return null != t.getState();
}, mxConnectionHandler.prototype.addWaypointForEvent = function (t) {
  var e = mxUtils.convertPoint(this.graph.container, t.getX(), t.getY()),
      i = Math.abs(e.x - this.first.x);
  e = Math.abs(e.y - this.first.y);
  (null != this.waypoints || 1 < this.mouseDownCounter && (i > this.graph.tolerance || e > this.graph.tolerance)) && (null == this.waypoints && (this.waypoints = []), i = this.graph.view.scale, e = new mxPoint(this.graph.snap(t.getGraphX() / i) * i, this.graph.snap(t.getGraphY() / i) * i), this.waypoints.push(e));
}, mxConnectionHandler.prototype.checkConstraints = function (t, e) {
  return null == t || null == e || null == t.point || null == e.point || !t.point.equals(e.point) || t.perimeter != e.perimeter;
}, mxConnectionHandler.prototype.mouseUp = function (t, e) {
  if (!e.isConsumed() && this.isConnecting()) {
    if (this.waypointsEnabled && !this.isStopEvent(e)) return this.addWaypointForEvent(e), void e.consume();
    var i = this.sourceConstraint,
        n = this.constraintHandler.currentConstraint,
        s = null != this.previous ? this.previous.cell : null,
        o = null;
    null != this.constraintHandler.currentConstraint && null != this.constraintHandler.currentFocus && (o = this.constraintHandler.currentFocus.cell), null == o && null != this.currentState && (o = this.currentState.cell), null != this.error || null != s && null != o && s == o && !this.checkConstraints(i, n) ? (null != this.previous && null != this.marker.validState && this.previous.cell == this.marker.validState.cell && this.graph.selectCellForEvent(this.marker.source, e.getEvent()), null != this.error && 0 < this.error.length && this.graph.validationAlert(this.error)) : this.connect(s, o, e.getEvent(), e.getCell()), this.destroyIcons(), e.consume();
  }

  null != this.first && this.reset();
}, mxConnectionHandler.prototype.reset = function () {
  null != this.shape && (this.shape.destroy(), this.shape = null), null != this.cursor && null != this.graph.container && (this.graph.container.style.cursor = ""), this.destroyIcons(), this.marker.reset(), this.constraintHandler.reset(), this.sourceConstraint = this.error = this.previous = this.edgeState = this.currentPoint = this.originalPoint = null, this.mouseDownCounter = 0, this.first = null, this.fireEvent(new mxEventObject(mxEvent.RESET));
}, mxConnectionHandler.prototype.drawPreview = function () {
  this.updatePreview(null == this.error), this.shape.redraw();
}, mxConnectionHandler.prototype.updatePreview = function (t) {
  this.shape.strokewidth = this.getEdgeWidth(t), this.shape.stroke = this.getEdgeColor(t);
}, mxConnectionHandler.prototype.getEdgeColor = function (t) {
  return t ? mxConstants.VALID_COLOR : mxConstants.INVALID_COLOR;
}, mxConnectionHandler.prototype.getEdgeWidth = function (t) {
  return t ? 3 : 1;
}, mxConnectionHandler.prototype.connect = function (t, e, i, n) {
  if (null != e || this.isCreateTarget(i) || this.graph.allowDanglingEdges) {
    var s = this.graph.getModel(),
        o = !1,
        l = null;
    s.beginUpdate();

    try {
      if (null != t && null == e && !this.graph.isIgnoreTerminalEvent(i) && this.isCreateTarget(i) && null != (e = this.createTargetVertex(i, t))) {
        if (n = this.graph.getDropTarget([e], i, n), o = !0, null != n && this.graph.getModel().isEdge(n)) n = this.graph.getDefaultParent();else {
          var r = this.graph.getView().getState(n);

          if (null != r) {
            var a = s.getGeometry(e);
            a.x -= r.origin.x, a.y -= r.origin.y;
          }
        }
        this.graph.addCell(e, n);
      }

      var h = this.graph.getDefaultParent();
      null != t && null != e && s.getParent(t) == s.getParent(e) && s.getParent(s.getParent(t)) != s.getRoot() && (h = s.getParent(t), null != t.geometry && t.geometry.relative && null != e.geometry && e.geometry.relative && (h = s.getParent(h)));
      var u = r = null;

      if (null != this.edgeState && (r = this.edgeState.cell.value, u = this.edgeState.cell.style), null != (l = this.insertEdge(h, null, r, t, e, u))) {
        if (this.graph.setConnectionConstraint(l, t, !0, this.sourceConstraint), this.graph.setConnectionConstraint(l, e, !1, this.constraintHandler.currentConstraint), null != this.edgeState && s.setGeometry(l, this.edgeState.cell.geometry), h = s.getParent(t), this.isInsertBefore(l, t, e, i, n)) {
          for (a = t; null != a.parent && null != a.geometry && a.geometry.relative && a.parent != l.parent;) {
            a = this.graph.model.getParent(a);
          }

          null != a && null != a.parent && a.parent == l.parent && s.add(h, l, a.parent.getIndex(a));
        }

        var d = s.getGeometry(l);

        if (null == d && ((d = new mxGeometry()).relative = !0, s.setGeometry(l, d)), null != this.waypoints && 0 < this.waypoints.length) {
          var p = this.graph.view.scale,
              c = this.graph.view.translate;

          for (d.points = [], t = 0; t < this.waypoints.length; t++) {
            var m = this.waypoints[t];
            d.points.push(new mxPoint(m.x / p - c.x, m.y / p - c.y));
          }
        }

        if (null == e) {
          var g = this.graph.view.translate;
          p = this.graph.view.scale;
          (m = null != this.originalPoint ? new mxPoint(this.originalPoint.x / p - g.x, this.originalPoint.y / p - g.y) : new mxPoint(this.currentPoint.x / p - g.x, this.currentPoint.y / p - g.y)).x -= this.graph.panDx / this.graph.view.scale, m.y -= this.graph.panDy / this.graph.view.scale, d.setTerminalPoint(m, !1);
        }

        this.fireEvent(new mxEventObject(mxEvent.CONNECT, "cell", l, "terminal", e, "event", i, "target", n, "terminalInserted", o));
      }
    } catch (t) {
      mxLog.show(), mxLog.debug(t.message);
    } finally {
      s.endUpdate();
    }

    this.select && this.selectCells(l, o ? e : null);
  }
}, mxConnectionHandler.prototype.selectCells = function (t, e) {
  this.graph.setSelectionCell(t);
}, mxConnectionHandler.prototype.insertEdge = function (t, e, i, n, s, o) {
  return null == this.factoryMethod ? this.graph.insertEdge(t, e, i, n, s, o) : (e = this.createEdge(i, n, s, o), this.graph.addEdge(e, t, n, s));
}, mxConnectionHandler.prototype.createTargetVertex = function (t, e) {
  for (var i = this.graph.getCellGeometry(e); null != i && i.relative;) {
    e = this.graph.getModel().getParent(e), i = this.graph.getCellGeometry(e);
  }

  var n = this.graph.cloneCell(e);

  if (null != (i = this.graph.getModel().getGeometry(n))) {
    var s = this.graph.view.translate,
        o = this.graph.view.scale,
        l = new mxPoint(this.currentPoint.x / o - s.x, this.currentPoint.y / o - s.y);

    if (i.x = Math.round(l.x - i.width / 2 - this.graph.panDx / o), i.y = Math.round(l.y - i.height / 2 - this.graph.panDy / o), 0 < (l = this.getAlignmentTolerance())) {
      var r = this.graph.view.getState(e);

      if (null != r) {
        var a = r.x / o - s.x;
        s = r.y / o - s.y;
        Math.abs(a - i.x) <= l && (i.x = Math.round(a)), Math.abs(s - i.y) <= l && (i.y = Math.round(s));
      }
    }
  }

  return n;
}, mxConnectionHandler.prototype.getAlignmentTolerance = function (t) {
  return this.graph.isGridEnabled() ? this.graph.gridSize / 2 : this.graph.tolerance;
}, mxConnectionHandler.prototype.createEdge = function (t, e, i, n) {
  var s = null;
  return null != this.factoryMethod && (s = this.factoryMethod(e, i, n)), null == s && ((s = new mxCell(t || "")).setEdge(!0), s.setStyle(n), (t = new mxGeometry()).relative = !0, s.setGeometry(t)), s;
}, mxConnectionHandler.prototype.destroy = function () {
  this.graph.removeMouseListener(this), null != this.shape && (this.shape.destroy(), this.shape = null), null != this.marker && (this.marker.destroy(), this.marker = null), null != this.constraintHandler && (this.constraintHandler.destroy(), this.constraintHandler = null), null != this.changeHandler && (this.graph.getModel().removeListener(this.changeHandler), this.graph.getView().removeListener(this.changeHandler), this.changeHandler = null), null != this.drillHandler && (this.graph.removeListener(this.drillHandler), this.graph.getView().removeListener(this.drillHandler), this.drillHandler = null), null != this.escapeHandler && (this.graph.removeListener(this.escapeHandler), this.escapeHandler = null);
}, mxConstraintHandler.prototype.pointImage = new mxImage(mxClient.imageBasePath + "/point.gif", 5, 5), mxConstraintHandler.prototype.graph = null, mxConstraintHandler.prototype.enabled = !0, mxConstraintHandler.prototype.highlightColor = mxConstants.DEFAULT_VALID_COLOR, mxConstraintHandler.prototype.isEnabled = function () {
  return this.enabled;
}, mxConstraintHandler.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxConstraintHandler.prototype.reset = function () {
  if (null != this.focusIcons) {
    for (var t = 0; t < this.focusIcons.length; t++) {
      this.focusIcons[t].destroy();
    }

    this.focusIcons = null;
  }

  null != this.focusHighlight && (this.focusHighlight.destroy(), this.focusHighlight = null), this.focusPoints = this.currentFocus = this.currentPoint = this.currentFocusArea = this.currentConstraint = null;
}, mxConstraintHandler.prototype.getTolerance = function (t) {
  return this.graph.getTolerance();
}, mxConstraintHandler.prototype.getImageForConstraint = function (t, e, i) {
  return this.pointImage;
}, mxConstraintHandler.prototype.isEventIgnored = function (t, e) {
  return !1;
}, mxConstraintHandler.prototype.isStateIgnored = function (t, e) {
  return !1;
}, mxConstraintHandler.prototype.destroyIcons = function () {
  if (null != this.focusIcons) {
    for (var t = 0; t < this.focusIcons.length; t++) {
      this.focusIcons[t].destroy();
    }

    this.focusPoints = this.focusIcons = null;
  }
}, mxConstraintHandler.prototype.destroyFocusHighlight = function () {
  null != this.focusHighlight && (this.focusHighlight.destroy(), this.focusHighlight = null);
}, mxConstraintHandler.prototype.isKeepFocusEvent = function (t) {
  return mxEvent.isShiftDown(t.getEvent());
}, mxConstraintHandler.prototype.getCellForEvent = function (t, e) {
  var i = t.getCell();

  if (null != i || null == e || t.getGraphX() == e.x && t.getGraphY() == e.y || (i = this.graph.getCellAt(e.x, e.y)), null != i && !this.graph.isCellConnectable(i)) {
    var n = this.graph.getModel().getParent(i);
    this.graph.getModel().isVertex(n) && this.graph.isCellConnectable(n) && (i = n);
  }

  return this.graph.isCellLocked(i) ? null : i;
}, mxConstraintHandler.prototype.update = function (t, e, i, n) {
  if (this.isEnabled() && !this.isEventIgnored(t)) {
    null == this.mouseleaveHandler && null != this.graph.container && (this.mouseleaveHandler = mxUtils.bind(this, function () {
      this.reset();
    }), mxEvent.addListener(this.graph.container, "mouseleave", this.resetHandler));
    var s = this.getTolerance(t),
        o = new mxRectangle((o = null != n ? n.x : t.getGraphX()) - s, (r = null != n ? n.y : t.getGraphY()) - s, 2 * s, 2 * s),
        l = (s = new mxRectangle(t.getGraphX() - s, t.getGraphY() - s, 2 * s, 2 * s), this.graph.view.getState(this.getCellForEvent(t, n)));
    if (this.isKeepFocusEvent(t) || null != this.currentFocusArea && null != this.currentFocus && null == l && this.graph.getModel().isVertex(this.currentFocus.cell) && mxUtils.intersects(this.currentFocusArea, s) || l == this.currentFocus || (this.currentFocus = this.currentFocusArea = null, this.setFocus(t, l, e)), t = this.currentPoint = this.currentConstraint = null, null != this.focusIcons && null != this.constraints && (null == l || this.currentFocus == l)) for (var r = s.getCenterX(), a = s.getCenterY(), h = 0; h < this.focusIcons.length; h++) {
      var u = r - this.focusIcons[h].bounds.getCenterX(),
          d = a - this.focusIcons[h].bounds.getCenterY();
      u = u * u + d * d;

      if ((this.intersects(this.focusIcons[h], s, e, i) || null != n && this.intersects(this.focusIcons[h], o, e, i)) && (null == t || u < t)) {
        if (this.currentConstraint = this.constraints[h], this.currentPoint = this.focusPoints[h], t = u, (u = this.focusIcons[h].bounds.clone()).grow(mxConstants.HIGHLIGHT_SIZE + 1), --u.width, --u.height, null == this.focusHighlight) {
          (d = this.createHighlightShape()).dialect = this.graph.dialect == mxConstants.DIALECT_SVG ? mxConstants.DIALECT_SVG : mxConstants.DIALECT_VML, d.pointerEvents = !1, d.init(this.graph.getView().getOverlayPane()), this.focusHighlight = d;
          var p = mxUtils.bind(this, function () {
            return null != this.currentFocus ? this.currentFocus : l;
          });
          mxEvent.redirectMouseEvents(d.node, this.graph, p);
        }

        this.focusHighlight.bounds = u, this.focusHighlight.redraw();
      }
    }
    null == this.currentConstraint && this.destroyFocusHighlight();
  } else this.currentPoint = this.currentFocus = this.currentConstraint = null;
}, mxConstraintHandler.prototype.redraw = function () {
  if (null != this.currentFocus && null != this.constraints && null != this.focusIcons) {
    var t = this.graph.view.getState(this.currentFocus.cell);
    this.currentFocus = t, this.currentFocusArea = new mxRectangle(t.x, t.y, t.width, t.height);

    for (var e = 0; e < this.constraints.length; e++) {
      var i = this.graph.getConnectionPoint(t, this.constraints[e]),
          n = this.getImageForConstraint(t, this.constraints[e], i);
      n = new mxRectangle(Math.round(i.x - n.width / 2), Math.round(i.y - n.height / 2), n.width, n.height);
      this.focusIcons[e].bounds = n, this.focusIcons[e].redraw(), this.currentFocusArea.add(this.focusIcons[e].bounds), this.focusPoints[e] = i;
    }
  }
}, mxConstraintHandler.prototype.setFocus = function (t, e, i) {
  if (this.constraints = null != e && !this.isStateIgnored(e, i) && this.graph.isCellConnectable(e.cell) ? this.isEnabled() && this.graph.getAllConnectionConstraints(e, i) || [] : null, null != this.constraints) {
    if (this.currentFocus = e, this.currentFocusArea = new mxRectangle(e.x, e.y, e.width, e.height), null != this.focusIcons) {
      for (i = 0; i < this.focusIcons.length; i++) {
        this.focusIcons[i].destroy();
      }

      this.focusPoints = this.focusIcons = null;
    }

    for (this.focusPoints = [], this.focusIcons = [], i = 0; i < this.constraints.length; i++) {
      var n,
          s = this.graph.getConnectionPoint(e, this.constraints[i]),
          o = (n = this.getImageForConstraint(e, this.constraints[i], s)).src;
      (o = new mxImageShape(n = new mxRectangle(Math.round(s.x - n.width / 2), Math.round(s.y - n.height / 2), n.width, n.height), o)).dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_MIXEDHTML : mxConstants.DIALECT_SVG, o.preserveImageAspect = !1, o.init(this.graph.getView().getDecoratorPane()), (mxClient.IS_QUIRKS || 8 == document.documentMode) && mxEvent.addListener(o.node, "dragstart", function (t) {
        return mxEvent.consume(t), !1;
      }), null != o.node.previousSibling && o.node.parentNode.insertBefore(o.node, o.node.parentNode.firstChild), n = mxUtils.bind(this, function () {
        return null != this.currentFocus ? this.currentFocus : e;
      }), o.redraw(), mxEvent.redirectMouseEvents(o.node, this.graph, n), this.currentFocusArea.add(o.bounds), this.focusIcons.push(o), this.focusPoints.push(s);
    }

    this.currentFocusArea.grow(this.getTolerance(t));
  } else this.destroyIcons(), this.destroyFocusHighlight();
}, mxConstraintHandler.prototype.createHighlightShape = function () {
  var t = new mxRectangleShape(null, this.highlightColor, this.highlightColor, mxConstants.HIGHLIGHT_STROKEWIDTH);
  return t.opacity = mxConstants.HIGHLIGHT_OPACITY, t;
}, mxConstraintHandler.prototype.intersects = function (t, e, i, n) {
  return mxUtils.intersects(t.bounds, e);
}, mxConstraintHandler.prototype.destroy = function () {
  this.reset(), null != this.resetHandler && (this.graph.model.removeListener(this.resetHandler), this.graph.view.removeListener(this.resetHandler), this.graph.removeListener(this.resetHandler), this.resetHandler = null), null != this.mouseleaveHandler && null != this.graph.container && (mxEvent.removeListener(this.graph.container, "mouseleave", this.mouseleaveHandler), this.mouseleaveHandler = null);
}, mxRubberband.prototype.defaultOpacity = 20, mxRubberband.prototype.enabled = !0, mxRubberband.prototype.div = null, mxRubberband.prototype.sharedDiv = null, mxRubberband.prototype.currentX = 0, mxRubberband.prototype.currentY = 0, mxRubberband.prototype.fadeOut = !1, mxRubberband.prototype.isEnabled = function () {
  return this.enabled;
}, mxRubberband.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxRubberband.prototype.isForceRubberbandEvent = function (t) {
  return mxEvent.isAltDown(t.getEvent());
}, mxRubberband.prototype.mouseDown = function (t, e) {
  if (!e.isConsumed() && this.isEnabled() && this.graph.isEnabled() && null == e.getState() && !mxEvent.isMultiTouchEvent(e.getEvent())) {
    var i = mxUtils.getOffset(this.graph.container),
        n = mxUtils.getScrollOrigin(this.graph.container);
    n.x -= i.x, n.y -= i.y, this.start(e.getX() + n.x, e.getY() + n.y), e.consume(!1);
  }
}, mxRubberband.prototype.start = function (t, e) {
  function i(t) {
    t = new mxMouseEvent(t);
    var e = mxUtils.convertPoint(n, t.getX(), t.getY());
    return t.graphX = e.x, t.graphY = e.y, t;
  }

  this.first = new mxPoint(t, e);
  var n = this.graph.container;
  this.dragHandler = mxUtils.bind(this, function (t) {
    this.mouseMove(this.graph, i(t));
  }), this.dropHandler = mxUtils.bind(this, function (t) {
    this.mouseUp(this.graph, i(t));
  }), mxClient.IS_FF && mxEvent.addGestureListeners(document, null, this.dragHandler, this.dropHandler);
}, mxRubberband.prototype.mouseMove = function (t, e) {
  if (!e.isConsumed() && null != this.first) {
    var i = mxUtils.getScrollOrigin(this.graph.container),
        n = mxUtils.getOffset(this.graph.container);
    i.x -= n.x, i.y -= n.y;
    n = e.getX() + i.x, i = e.getY() + i.y;
    var s = this.first.x - n,
        o = this.first.y - i,
        l = this.graph.tolerance;
    (null != this.div || Math.abs(s) > l || Math.abs(o) > l) && (null == this.div && (this.div = this.createShape()), mxUtils.clearSelection(), this.update(n, i), e.consume());
  }
}, mxRubberband.prototype.createShape = function () {
  null == this.sharedDiv && (this.sharedDiv = document.createElement("div"), this.sharedDiv.className = "mxRubberband", mxUtils.setOpacity(this.sharedDiv, this.defaultOpacity)), this.graph.container.appendChild(this.sharedDiv);
  var t = this.sharedDiv;
  return mxClient.IS_SVG && (!mxClient.IS_IE || 10 <= document.documentMode) && this.fadeOut && (this.sharedDiv = null), t;
}, mxRubberband.prototype.isActive = function (t, e) {
  return null != this.div && "none" != this.div.style.display;
}, mxRubberband.prototype.mouseUp = function (t, e) {
  var i = this.isActive();
  this.reset(), i && (this.execute(e.getEvent()), e.consume());
}, mxRubberband.prototype.execute = function (t) {
  var e = new mxRectangle(this.x, this.y, this.width, this.height);
  this.graph.selectRegion(e, t);
}, mxRubberband.prototype.reset = function () {
  if (null != this.div) if (mxClient.IS_SVG && (!mxClient.IS_IE || 10 <= document.documentMode) && this.fadeOut) {
    var t = this.div;
    mxUtils.setPrefixedStyle(t.style, "transition", "all 0.2s linear"), t.style.pointerEvents = "none", t.style.opacity = 0, window.setTimeout(function () {
      t.parentNode.removeChild(t);
    }, 200);
  } else this.div.parentNode.removeChild(this.div);
  mxEvent.removeGestureListeners(document, null, this.dragHandler, this.dropHandler), this.dropHandler = this.dragHandler = null, this.currentY = this.currentX = 0, this.div = this.first = null;
}, mxRubberband.prototype.update = function (t, e) {
  this.currentX = t, this.currentY = e, this.repaint();
}, mxRubberband.prototype.repaint = function () {
  if (null != this.div) {
    var t = this.currentX - this.graph.panDx,
        e = this.currentY - this.graph.panDy;
    this.x = Math.min(this.first.x, t), this.y = Math.min(this.first.y, e), this.width = Math.max(this.first.x, t) - this.x, this.height = Math.max(this.first.y, e) - this.y, t = mxClient.IS_VML ? this.graph.panDy : 0, this.div.style.left = this.x + (mxClient.IS_VML ? this.graph.panDx : 0) + "px", this.div.style.top = this.y + t + "px", this.div.style.width = Math.max(1, this.width) + "px", this.div.style.height = Math.max(1, this.height) + "px";
  }
}, mxRubberband.prototype.destroy = function () {
  this.destroyed || (this.destroyed = !0, this.graph.removeMouseListener(this), this.graph.removeListener(this.forceRubberbandHandler), this.graph.removeListener(this.panHandler), this.reset(), null != this.sharedDiv && (this.sharedDiv = null));
}, mxHandle.prototype.cursor = "default", mxHandle.prototype.image = null, mxHandle.prototype.ignoreGrid = !1, mxHandle.prototype.getPosition = function (t) {}, mxHandle.prototype.setPosition = function (t, e, i) {}, mxHandle.prototype.execute = function () {}, mxHandle.prototype.copyStyle = function (t) {
  this.graph.setCellStyles(t, this.state.style[t], [this.state.cell]);
}, mxHandle.prototype.processEvent = function (t) {
  var e = this.graph.view.scale,
      i = this.graph.view.translate;
  i = new mxPoint(t.getGraphX() / e - i.x, t.getGraphY() / e - i.y);
  null != this.shape && null != this.shape.bounds && (i.x -= this.shape.bounds.width / e / 4, i.y -= this.shape.bounds.height / e / 4);
  e = -mxUtils.toRadians(this.getRotation());
  var n = -mxUtils.toRadians(this.getTotalRotation()) - e;
  i = this.flipPoint(this.rotatePoint(this.snapPoint(this.rotatePoint(i, e), this.ignoreGrid || !this.graph.isGridEnabledEvent(t.getEvent())), n));
  this.setPosition(this.state.getPaintBounds(), i, t), this.positionChanged(), this.redraw();
}, mxHandle.prototype.positionChanged = function () {
  null != this.state.text && this.state.text.apply(this.state), null != this.state.shape && this.state.shape.apply(this.state), this.graph.cellRenderer.redraw(this.state, !0);
}, mxHandle.prototype.getRotation = function () {
  return null != this.state.shape ? this.state.shape.getRotation() : 0;
}, mxHandle.prototype.getTotalRotation = function () {
  return null != this.state.shape ? this.state.shape.getShapeRotation() : 0;
}, mxHandle.prototype.init = function () {
  var t = this.isHtmlRequired();
  null != this.image ? (this.shape = new mxImageShape(new mxRectangle(0, 0, this.image.width, this.image.height), this.image.src), this.shape.preserveImageAspect = !1) : this.shape = this.createShape(t), this.initShape(t);
}, mxHandle.prototype.createShape = function (t) {
  return new mxRectangleShape(new mxRectangle(0, 0, mxConstants.HANDLE_SIZE, mxConstants.HANDLE_SIZE), mxConstants.HANDLE_FILLCOLOR, mxConstants.HANDLE_STROKECOLOR);
}, mxHandle.prototype.initShape = function (t) {
  t && this.shape.isHtmlAllowed() ? (this.shape.dialect = mxConstants.DIALECT_STRICTHTML, this.shape.init(this.graph.container)) : (this.shape.dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_MIXEDHTML : mxConstants.DIALECT_SVG, null != this.cursor && this.shape.init(this.graph.getView().getOverlayPane())), mxEvent.redirectMouseEvents(this.shape.node, this.graph, this.state), this.shape.node.style.cursor = this.cursor;
}, mxHandle.prototype.redraw = function () {
  if (null != this.shape && null != this.state.shape && null != (e = this.getPosition(this.state.getPaintBounds()))) {
    var t = mxUtils.toRadians(this.getTotalRotation()),
        e = this.rotatePoint(this.flipPoint(e), t),
        i = (t = this.graph.view.scale, this.graph.view.translate);
    this.shape.bounds.x = Math.floor((e.x + i.x) * t - this.shape.bounds.width / 2), this.shape.bounds.y = Math.floor((e.y + i.y) * t - this.shape.bounds.height / 2), this.shape.redraw();
  }
}, mxHandle.prototype.isHtmlRequired = function () {
  return null != this.state.text && this.state.text.node.parentNode == this.graph.container;
}, mxHandle.prototype.rotatePoint = function (t, e) {
  var i = new mxPoint((i = this.state.getCellBounds()).getCenterX(), i.getCenterY());
  return mxUtils.getRotatedPoint(t, Math.cos(e), Math.sin(e), i);
}, mxHandle.prototype.flipPoint = function (t) {
  if (null != this.state.shape) {
    var e = this.state.getCellBounds();
    this.state.shape.flipH && (t.x = 2 * e.x + e.width - t.x), this.state.shape.flipV && (t.y = 2 * e.y + e.height - t.y);
  }

  return t;
}, mxHandle.prototype.snapPoint = function (t, e) {
  return e || (t.x = this.graph.snap(t.x), t.y = this.graph.snap(t.y)), t;
}, mxHandle.prototype.setVisible = function (t) {
  null != this.shape && null != this.shape.node && (this.shape.node.style.display = t ? "" : "none");
}, mxHandle.prototype.reset = function () {
  this.setVisible(!0), this.state.style = this.graph.getCellStyle(this.state.cell), this.positionChanged();
}, mxHandle.prototype.destroy = function () {
  null != this.shape && (this.shape.destroy(), this.shape = null);
}, mxVertexHandler.prototype.graph = null, mxVertexHandler.prototype.state = null, mxVertexHandler.prototype.singleSizer = !1, mxVertexHandler.prototype.index = null, mxVertexHandler.prototype.allowHandleBoundsCheck = !0, mxVertexHandler.prototype.handleImage = null, mxVertexHandler.prototype.tolerance = 0, mxVertexHandler.prototype.rotationEnabled = !1, mxVertexHandler.prototype.parentHighlightEnabled = !1, mxVertexHandler.prototype.rotationRaster = !0, mxVertexHandler.prototype.rotationCursor = "crosshair", mxVertexHandler.prototype.livePreview = !1, mxVertexHandler.prototype.manageSizers = !1, mxVertexHandler.prototype.constrainGroupByChildren = !1, mxVertexHandler.prototype.rotationHandleVSpacing = -16, mxVertexHandler.prototype.horizontalOffset = 0, mxVertexHandler.prototype.verticalOffset = 0, mxVertexHandler.prototype.init = function () {
  if (this.graph = this.state.view.graph, this.selectionBounds = this.getSelectionBounds(this.state), this.bounds = new mxRectangle(this.selectionBounds.x, this.selectionBounds.y, this.selectionBounds.width, this.selectionBounds.height), this.selectionBorder = this.createSelectionShape(this.bounds), this.selectionBorder.dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_VML : mxConstants.DIALECT_SVG, this.selectionBorder.pointerEvents = !1, this.selectionBorder.rotation = Number(this.state.style[mxConstants.STYLE_ROTATION] || "0"), this.selectionBorder.init(this.graph.getView().getOverlayPane()), mxEvent.redirectMouseEvents(this.selectionBorder.node, this.graph, this.state), this.graph.isCellMovable(this.state.cell) && this.selectionBorder.setCursor(mxConstants.CURSOR_MOVABLE_VERTEX), 0 >= mxGraphHandler.prototype.maxCells || this.graph.getSelectionCount() < mxGraphHandler.prototype.maxCells) {
    var t = this.graph.isCellResizable(this.state.cell);

    if (this.sizers = [], t || this.graph.isLabelMovable(this.state.cell) && 2 <= this.state.width && 2 <= this.state.height) {
      var e = 0;
      t && (this.singleSizer || (this.sizers.push(this.createSizer("nw-resize", e++)), this.sizers.push(this.createSizer("n-resize", e++)), this.sizers.push(this.createSizer("ne-resize", e++)), this.sizers.push(this.createSizer("w-resize", e++)), this.sizers.push(this.createSizer("e-resize", e++)), this.sizers.push(this.createSizer("sw-resize", e++)), this.sizers.push(this.createSizer("s-resize", e++))), this.sizers.push(this.createSizer("se-resize", e++))), null == (t = this.graph.model.getGeometry(this.state.cell)) || t.relative || this.graph.isSwimlane(this.state.cell) || !this.graph.isLabelMovable(this.state.cell) || (this.labelShape = this.createSizer(mxConstants.CURSOR_LABEL_HANDLE, mxEvent.LABEL_HANDLE, mxConstants.LABEL_HANDLE_SIZE, mxConstants.LABEL_HANDLE_FILLCOLOR), this.sizers.push(this.labelShape));
    } else this.graph.isCellMovable(this.state.cell) && !this.graph.isCellResizable(this.state.cell) && 2 > this.state.width && 2 > this.state.height && (this.labelShape = this.createSizer(mxConstants.CURSOR_MOVABLE_VERTEX, mxEvent.LABEL_HANDLE, null, mxConstants.LABEL_HANDLE_FILLCOLOR), this.sizers.push(this.labelShape));
  }

  this.isRotationHandleVisible() && (this.rotationShape = this.createSizer(this.rotationCursor, mxEvent.ROTATION_HANDLE, mxConstants.HANDLE_SIZE + 3, mxConstants.HANDLE_FILLCOLOR), this.sizers.push(this.rotationShape)), this.customHandles = this.createCustomHandles(), this.redraw(), this.constrainGroupByChildren && this.updateMinBounds();
}, mxVertexHandler.prototype.isRotationHandleVisible = function () {
  return this.graph.isEnabled() && this.rotationEnabled && this.graph.isCellRotatable(this.state.cell) && (0 >= mxGraphHandler.prototype.maxCells || this.graph.getSelectionCount() < mxGraphHandler.prototype.maxCells) && 2 <= this.state.width && 2 <= this.state.height;
}, mxVertexHandler.prototype.isConstrainedEvent = function (t) {
  return mxEvent.isShiftDown(t.getEvent()) || "fixed" == this.state.style[mxConstants.STYLE_ASPECT];
}, mxVertexHandler.prototype.isCenteredEvent = function (t, e) {
  return !1;
}, mxVertexHandler.prototype.createCustomHandles = function () {
  return null;
}, mxVertexHandler.prototype.updateMinBounds = function () {
  if (0 < (t = this.graph.getChildCells(this.state.cell)).length && (this.minBounds = this.graph.view.getBounds(t), null != this.minBounds)) {
    var t = this.state.view.scale,
        e = this.state.view.translate;
    this.minBounds.x -= this.state.x, this.minBounds.y -= this.state.y, this.minBounds.x /= t, this.minBounds.y /= t, this.minBounds.width /= t, this.minBounds.height /= t, this.x0 = this.state.x / t - e.x, this.y0 = this.state.y / t - e.y;
  }
}, mxVertexHandler.prototype.getSelectionBounds = function (t) {
  return new mxRectangle(Math.round(t.x), Math.round(t.y), Math.round(t.width), Math.round(t.height));
}, mxVertexHandler.prototype.createParentHighlightShape = function (t) {
  return this.createSelectionShape(t);
}, mxVertexHandler.prototype.createSelectionShape = function (t) {
  return (t = new mxRectangleShape(t, null, this.getSelectionColor())).strokewidth = this.getSelectionStrokeWidth(), t.isDashed = this.isSelectionDashed(), t;
}, mxVertexHandler.prototype.getSelectionColor = function () {
  return mxConstants.VERTEX_SELECTION_COLOR;
}, mxVertexHandler.prototype.getSelectionStrokeWidth = function () {
  return mxConstants.VERTEX_SELECTION_STROKEWIDTH;
}, mxVertexHandler.prototype.isSelectionDashed = function () {
  return mxConstants.VERTEX_SELECTION_DASHED;
}, mxVertexHandler.prototype.createSizer = function (t, e, i, n) {
  return i = new mxRectangle(0, 0, i = i || mxConstants.HANDLE_SIZE, i), (n = this.createSizerShape(i, e, n)).isHtmlAllowed() && null != this.state.text && this.state.text.node.parentNode == this.graph.container ? (--n.bounds.height, --n.bounds.width, n.dialect = mxConstants.DIALECT_STRICTHTML, n.init(this.graph.container)) : (n.dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_MIXEDHTML : mxConstants.DIALECT_SVG, n.init(this.graph.getView().getOverlayPane())), mxEvent.redirectMouseEvents(n.node, this.graph, this.state), this.graph.isEnabled() && n.setCursor(t), this.isSizerVisible(e) || (n.visible = !1), n;
}, mxVertexHandler.prototype.isSizerVisible = function (t) {
  return !0;
}, mxVertexHandler.prototype.createSizerShape = function (t, e, i) {
  return null != this.handleImage ? ((t = new mxImageShape(t = new mxRectangle(t.x, t.y, this.handleImage.width, this.handleImage.height), this.handleImage.src)).preserveImageAspect = !1, t) : e == mxEvent.ROTATION_HANDLE ? new mxEllipse(t, i || mxConstants.HANDLE_FILLCOLOR, mxConstants.HANDLE_STROKECOLOR) : new mxRectangleShape(t, i || mxConstants.HANDLE_FILLCOLOR, mxConstants.HANDLE_STROKECOLOR);
}, mxVertexHandler.prototype.moveSizerTo = function (t, e, i) {
  null != t && (t.bounds.x = Math.floor(e - t.bounds.width / 2), t.bounds.y = Math.floor(i - t.bounds.height / 2), null != t.node && "none" != t.node.style.display && t.redraw());
}, mxVertexHandler.prototype.getHandleForEvent = function (t) {
  function e(e) {
    return null != e && (t.isSource(e) || null != n && mxUtils.intersects(e.bounds, n) && "none" != e.node.style.display && "hidden" != e.node.style.visibility);
  }

  var i = mxEvent.isMouseEvent(t.getEvent()) ? 1 : this.tolerance,
      n = this.allowHandleBoundsCheck && (mxClient.IS_IE || 0 < i) ? new mxRectangle(t.getGraphX() - i, t.getGraphY() - i, 2 * i, 2 * i) : null;
  if (null != this.customHandles && this.isCustomHandleEvent(t)) for (i = this.customHandles.length - 1; 0 <= i; i--) {
    if (e(this.customHandles[i].shape)) return mxEvent.CUSTOM_HANDLE - i;
  }
  if (e(this.rotationShape)) return mxEvent.ROTATION_HANDLE;
  if (e(this.labelShape)) return mxEvent.LABEL_HANDLE;
  if (null != this.sizers) for (i = 0; i < this.sizers.length; i++) {
    if (e(this.sizers[i])) return i;
  }
  return null;
}, mxVertexHandler.prototype.isCustomHandleEvent = function (t) {
  return !0;
}, mxVertexHandler.prototype.mouseDown = function (t, e) {
  var i = mxEvent.isMouseEvent(e.getEvent()) ? 0 : this.tolerance;
  !e.isConsumed() && this.graph.isEnabled() && (0 < i || e.getState() == this.state) && null != (i = this.getHandleForEvent(e)) && (this.start(e.getGraphX(), e.getGraphY(), i), e.consume());
}, mxVertexHandler.prototype.isLivePreviewBorder = function () {
  return null != this.state.shape && null == this.state.shape.fill && null == this.state.shape.stroke;
}, mxVertexHandler.prototype.start = function (t, e, i) {
  if (this.inTolerance = !0, this.childOffsetY = this.childOffsetX = 0, this.index = i, this.startX = t, this.startY = e, e = (t = this.state.view.graph.model).getParent(this.state.cell), this.state.view.currentRoot != e && (t.isVertex(e) || t.isEdge(e)) && (this.parentState = this.state.view.graph.view.getState(e)), this.selectionBorder.node.style.display = i == mxEvent.ROTATION_HANDLE ? "inline" : "none", this.livePreview && !this.isLivePreviewBorder() || (this.preview = this.createSelectionShape(this.bounds), mxClient.IS_SVG && 0 != Number(this.state.style[mxConstants.STYLE_ROTATION] || "0") || null == this.state.text || this.state.text.node.parentNode != this.graph.container ? (this.preview.dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_VML : mxConstants.DIALECT_SVG, this.preview.init(this.graph.view.getOverlayPane())) : (this.preview.dialect = mxConstants.DIALECT_STRICTHTML, this.preview.init(this.graph.container))), this.livePreview) for (this.hideSizers(), i == mxEvent.ROTATION_HANDLE ? this.rotationShape.node.style.display = "" : i == mxEvent.LABEL_HANDLE ? this.labelShape.node.style.display = "" : null != this.sizers && null != this.sizers[i] ? this.sizers[i].node.style.display = "" : i <= mxEvent.CUSTOM_HANDLE && null != this.customHandles && this.customHandles[mxEvent.CUSTOM_HANDLE - i].setVisible(!0), i = this.graph.getEdges(this.state.cell), this.edgeHandlers = [], t = 0; t < i.length; t++) {
    null != (e = this.graph.selectionCellsHandler.getHandler(i[t])) && this.edgeHandlers.push(e);
  }
}, mxVertexHandler.prototype.setHandlesVisible = function (t) {
  if (null != this.sizers) for (var e = 0; e < this.sizers.length; e++) {
    this.sizers[e].node.style.display = t ? "" : "none";
  }
  if (null != this.customHandles) for (e = 0; e < this.customHandles.length; e++) {
    this.customHandles[e].setVisible(t);
  }
}, mxVertexHandler.prototype.hideSizers = function () {
  this.setHandlesVisible(!1);
}, mxVertexHandler.prototype.checkTolerance = function (t) {
  this.inTolerance && null != this.startX && null != this.startY && (mxEvent.isMouseEvent(t.getEvent()) || Math.abs(t.getGraphX() - this.startX) > this.graph.tolerance || Math.abs(t.getGraphY() - this.startY) > this.graph.tolerance) && (this.inTolerance = !1);
}, mxVertexHandler.prototype.updateHint = function (t) {}, mxVertexHandler.prototype.removeHint = function () {}, mxVertexHandler.prototype.roundAngle = function (t) {
  return Math.round(10 * t) / 10;
}, mxVertexHandler.prototype.roundLength = function (t) {
  return Math.round(t);
}, mxVertexHandler.prototype.mouseMove = function (t, e) {
  e.isConsumed() || null == this.index ? this.graph.isMouseDown || null == this.getHandleForEvent(e) || e.consume(!1) : (this.checkTolerance(e), this.inTolerance || (this.index <= mxEvent.CUSTOM_HANDLE ? null != this.customHandles && (this.customHandles[mxEvent.CUSTOM_HANDLE - this.index].processEvent(e), this.customHandles[mxEvent.CUSTOM_HANDLE - this.index].active = !0) : this.index == mxEvent.LABEL_HANDLE ? this.moveLabel(e) : this.index == mxEvent.ROTATION_HANDLE ? this.rotateVertex(e) : this.resizeVertex(e), this.updateHint(e)), e.consume());
}, mxVertexHandler.prototype.moveLabel = function (t) {
  var e = new mxPoint(t.getGraphX(), t.getGraphY()),
      i = this.graph.view.translate,
      n = this.graph.view.scale;
  this.graph.isGridEnabledEvent(t.getEvent()) && (e.x = (this.graph.snap(e.x / n - i.x) + i.x) * n, e.y = (this.graph.snap(e.y / n - i.y) + i.y) * n), this.moveSizerTo(this.sizers[null != this.rotationShape ? this.sizers.length - 2 : this.sizers.length - 1], e.x, e.y);
}, mxVertexHandler.prototype.rotateVertex = function (t) {
  var e = new mxPoint(t.getGraphX(), t.getGraphY()),
      i = this.state.x + this.state.width / 2 - e.x,
      n = this.state.y + this.state.height / 2 - e.y;
  this.currentAlpha = 0 != i ? 180 * Math.atan(n / i) / Math.PI + 90 : 0 > n ? 180 : 0, 0 < i && (this.currentAlpha -= 180), this.rotationRaster && this.graph.isGridEnabledEvent(t.getEvent()) ? (i = e.x - this.state.getCenterX(), n = e.y - this.state.getCenterY(), t = Math.max(1, 5 * Math.min(3, Math.max(0, Math.round(80 / Math.abs(3 * Math.abs(Math.sqrt(i * i + n * n) - 20)))))), this.currentAlpha = Math.round(this.currentAlpha / t) * t) : this.currentAlpha = this.roundAngle(this.currentAlpha), this.selectionBorder.rotation = this.currentAlpha, this.selectionBorder.redraw(), this.livePreview && this.redrawHandles();
}, mxVertexHandler.prototype.resizeVertex = function (t) {
  var e = new mxPoint(this.state.getCenterX(), this.state.getCenterY()),
      i = mxUtils.toRadians(this.state.style[mxConstants.STYLE_ROTATION] || "0"),
      n = new mxPoint(t.getGraphX(), t.getGraphY()),
      s = this.graph.view.translate,
      o = this.graph.view.scale,
      l = Math.cos(-i),
      r = Math.sin(-i),
      a = r * (h = n.x - this.startX) + l * (n = n.y - this.startY),
      h = l * h - r * n;
  n = a, l = this.graph.getCellGeometry(this.state.cell);
  this.unscaledBounds = this.union(l, h / o, n / o, this.index, this.graph.isGridEnabledEvent(t.getEvent()), 1, new mxPoint(0, 0), this.isConstrainedEvent(t), this.isCenteredEvent(this.state, t)), l.relative || (null != (r = this.graph.getMaximumGraphBounds()) && null != this.parentState && ((r = mxRectangle.fromRectangle(r)).x -= (this.parentState.x - s.x * o) / o, r.y -= (this.parentState.y - s.y * o) / o), this.graph.isConstrainChild(this.state.cell) && null != (h = this.graph.getCellContainmentArea(this.state.cell)) && (0 < (n = this.graph.getOverlap(this.state.cell)) && ((h = mxRectangle.fromRectangle(h)).x -= h.width * n, h.y -= h.height * n, h.width += 2 * h.width * n, h.height += 2 * h.height * n), null == r ? r = h : (r = mxRectangle.fromRectangle(r)).intersect(h)), null != r && (this.unscaledBounds.x < r.x && (this.unscaledBounds.width -= r.x - this.unscaledBounds.x, this.unscaledBounds.x = r.x), this.unscaledBounds.y < r.y && (this.unscaledBounds.height -= r.y - this.unscaledBounds.y, this.unscaledBounds.y = r.y), this.unscaledBounds.x + this.unscaledBounds.width > r.x + r.width && (this.unscaledBounds.width -= this.unscaledBounds.x + this.unscaledBounds.width - r.x - r.width), this.unscaledBounds.y + this.unscaledBounds.height > r.y + r.height && (this.unscaledBounds.height -= this.unscaledBounds.y + this.unscaledBounds.height - r.y - r.height))), this.bounds = new mxRectangle((null != this.parentState ? this.parentState.x : s.x * o) + this.unscaledBounds.x * o, (null != this.parentState ? this.parentState.y : s.y * o) + this.unscaledBounds.y * o, this.unscaledBounds.width * o, this.unscaledBounds.height * o), l.relative && null != this.parentState && (this.bounds.x += this.state.x - this.parentState.x, this.bounds.y += this.state.y - this.parentState.y), l = Math.cos(i), r = Math.sin(i), e = l * (h = (i = new mxPoint(this.bounds.getCenterX(), this.bounds.getCenterY())).x - e.x) - r * (n = i.y - e.y) - h, i = r * h + l * n - n, s = l * (h = this.bounds.x - this.state.x) - r * (n = this.bounds.y - this.state.y), l = r * h + l * n, this.bounds.x += e, this.bounds.y += i, this.unscaledBounds.x = this.roundLength(this.unscaledBounds.x + e / o), this.unscaledBounds.y = this.roundLength(this.unscaledBounds.y + i / o), this.unscaledBounds.width = this.roundLength(this.unscaledBounds.width), this.unscaledBounds.height = this.roundLength(this.unscaledBounds.height), this.graph.isCellCollapsed(this.state.cell) || 0 == e && 0 == i ? this.childOffsetY = this.childOffsetX = 0 : (this.childOffsetX = this.state.x - this.bounds.x + s, this.childOffsetY = this.state.y - this.bounds.y + l), this.livePreview && this.updateLivePreview(t), null != this.preview && this.drawPreview();
}, mxVertexHandler.prototype.updateLivePreview = function (t) {
  var e = this.graph.view.scale,
      i = this.graph.view.translate;
  t = this.state.clone(), this.state.x = this.bounds.x, this.state.y = this.bounds.y, this.state.origin = new mxPoint(this.state.x / e - i.x, this.state.y / e - i.y), this.state.width = this.bounds.width, this.state.height = this.bounds.height, this.state.unscaledWidth = null, new mxPoint((e = this.state.absoluteOffset).x, e.y), this.state.absoluteOffset.x = 0, this.state.absoluteOffset.y = 0, null != (e = this.graph.getCellGeometry(this.state.cell)) && (null == (i = e.offset || this.EMPTY_POINT) || e.relative || (this.state.absoluteOffset.x = this.state.view.scale * i.x, this.state.absoluteOffset.y = this.state.view.scale * i.y), this.state.view.updateVertexLabelOffset(this.state)), this.state.view.graph.cellRenderer.redraw(this.state, !0), this.state.view.invalidate(this.state.cell), this.state.invalid = !1, this.state.view.validate(), this.redrawHandles(), this.state.setState(t);
}, mxVertexHandler.prototype.mouseUp = function (t, e) {
  if (null != this.index && null != this.state) {
    var i = new mxPoint(e.getGraphX(), e.getGraphY());
    this.graph.getModel().beginUpdate();

    try {
      if (this.index <= mxEvent.CUSTOM_HANDLE) null != this.customHandles && (this.customHandles[mxEvent.CUSTOM_HANDLE - this.index].active = !1, this.customHandles[mxEvent.CUSTOM_HANDLE - this.index].execute());else if (this.index == mxEvent.ROTATION_HANDLE) {
        if (null != this.currentAlpha) {
          var n = this.currentAlpha - (this.state.style[mxConstants.STYLE_ROTATION] || 0);
          0 != n && this.rotateCell(this.state.cell, n);
        } else this.rotateClick();
      } else {
        var s = this.graph.isGridEnabledEvent(e.getEvent()),
            o = mxUtils.toRadians(this.state.style[mxConstants.STYLE_ROTATION] || "0"),
            l = Math.cos(-o),
            r = Math.sin(-o),
            a = (i = r * (a = i.x - this.startX) + l * (h = i.y - this.startY), l * a - r * h),
            h = i,
            u = this.graph.view.scale,
            d = this.isRecursiveResize(this.state, e);
        this.resizeCell(this.state.cell, this.roundLength(a / u), this.roundLength(h / u), this.index, s, this.isConstrainedEvent(e), d);
      }
    } finally {
      this.graph.getModel().endUpdate();
    }

    e.consume(), this.reset();
  }
}, mxVertexHandler.prototype.isRecursiveResize = function (t, e) {
  return this.graph.isRecursiveResize(this.state);
}, mxVertexHandler.prototype.rotateClick = function () {}, mxVertexHandler.prototype.rotateCell = function (t, e, i) {
  if (0 != e) {
    var n = this.graph.getModel();

    if (n.isVertex(t) || n.isEdge(t)) {
      var s;
      if (!n.isEdge(t)) null != (s = null != (s = this.graph.view.getState(t)) ? s.style : this.graph.getCellStyle(t)) && this.graph.setCellStyles(mxConstants.STYLE_ROTATION, (s[mxConstants.STYLE_ROTATION] || 0) + e, [t]);

      if (null != (s = this.graph.getCellGeometry(t))) {
        var o = this.graph.getCellGeometry(i);
        if (null == o || n.isEdge(i) || ((s = s.clone()).rotate(e, new mxPoint(o.width / 2, o.height / 2)), n.setGeometry(t, s)), n.isVertex(t) && !s.relative || n.isEdge(t)) for (i = n.getChildCount(t), s = 0; s < i; s++) {
          this.rotateCell(n.getChildAt(t, s), e, t);
        }
      }
    }
  }
}, mxVertexHandler.prototype.reset = function () {
  if (null != this.sizers && null != this.index && null != this.sizers[this.index] && "none" == this.sizers[this.index].node.style.display && (this.sizers[this.index].node.style.display = ""), this.index = this.inTolerance = this.currentAlpha = null, null != this.preview && (this.preview.destroy(), this.preview = null), this.livePreview && null != this.sizers) for (var t = 0; t < this.sizers.length; t++) {
    null != this.sizers[t] && (this.sizers[t].node.style.display = "");
  }
  if (null != this.customHandles) for (t = 0; t < this.customHandles.length; t++) {
    this.customHandles[t].active ? (this.customHandles[t].active = !1, this.customHandles[t].reset()) : this.customHandles[t].setVisible(!0);
  }
  null != this.selectionBorder && (this.selectionBorder.node.style.display = "inline", this.selectionBounds = this.getSelectionBounds(this.state), this.bounds = new mxRectangle(this.selectionBounds.x, this.selectionBounds.y, this.selectionBounds.width, this.selectionBounds.height), this.drawPreview()), this.removeHint(), this.redrawHandles(), this.unscaledBounds = this.edgeHandlers = null;
}, mxVertexHandler.prototype.resizeCell = function (t, e, i, n, s, o, l) {
  null != (s = this.graph.model.getGeometry(t)) && (n == mxEvent.LABEL_HANDLE ? (i = this.graph.view.scale, e = Math.round((this.labelShape.bounds.getCenterX() - this.startX) / i), i = Math.round((this.labelShape.bounds.getCenterY() - this.startY) / i), null == (s = s.clone()).offset ? s.offset = new mxPoint(e, i) : (s.offset.x += e, s.offset.y += i), this.graph.model.setGeometry(t, s)) : null != this.unscaledBounds && (i = this.graph.view.scale, 0 == this.childOffsetX && 0 == this.childOffsetY || this.moveChildren(t, Math.round(this.childOffsetX / i), Math.round(this.childOffsetY / i)), this.graph.resizeCell(t, this.unscaledBounds, l)));
}, mxVertexHandler.prototype.moveChildren = function (t, e, i) {
  for (var n = this.graph.getModel(), s = n.getChildCount(t), o = 0; o < s; o++) {
    var l = n.getChildAt(t, o),
        r = this.graph.getCellGeometry(l);
    null != r && ((r = r.clone()).translate(e, i), n.setGeometry(l, r));
  }
}, mxVertexHandler.prototype.union = function (t, e, i, n, s, o, l, r, a) {
  if (this.singleSizer) return n = t.x + t.width + e, l = t.y + t.height + i, s && (n = this.graph.snap(n / o) * o, l = this.graph.snap(l / o) * o), (o = new mxRectangle(t.x, t.y, 0, 0)).add(new mxRectangle(n, l, 0, 0)), o;
  var h = t.width,
      u = t.height,
      d = t.x - l.x * o,
      p = d + h,
      c = (t = t.y - l.y * o) + u,
      m = d + h / 2,
      g = t + u / 2;
  return 4 < n ? (c += i, s && (c = this.graph.snap(c / o) * o)) : 3 > n && (t += i, s && (t = this.graph.snap(t / o) * o)), 0 == n || 3 == n || 5 == n ? (d += e, s && (d = this.graph.snap(d / o) * o)) : 2 != n && 4 != n && 7 != n || (p += e, s && (p = this.graph.snap(p / o) * o)), s = p - d, i = c - t, r && null != (r = this.graph.getCellGeometry(this.state.cell)) && (r = r.width / r.height, 1 == n || 2 == n || 7 == n || 6 == n ? s = i * r : i = s / r, 0 == n && (d = p - s, t = c - i)), a && (d += m - (d + (s += s - h) / 2), t += g - (t + (i += i - u) / 2)), 0 > s && (d += s, s = Math.abs(s)), 0 > i && (t += i, i = Math.abs(i)), n = new mxRectangle(d + l.x * o, t + l.y * o, s, i), null != this.minBounds && (n.width = Math.max(n.width, this.minBounds.x * o + this.minBounds.width * o + Math.max(0, this.x0 * o - n.x)), n.height = Math.max(n.height, this.minBounds.y * o + this.minBounds.height * o + Math.max(0, this.y0 * o - n.y))), n;
}, mxVertexHandler.prototype.redraw = function () {
  this.selectionBounds = this.getSelectionBounds(this.state), this.bounds = new mxRectangle(this.selectionBounds.x, this.selectionBounds.y, this.selectionBounds.width, this.selectionBounds.height), this.redrawHandles(), this.drawPreview();
}, mxVertexHandler.prototype.getHandlePadding = function () {
  var t = new mxPoint(0, 0),
      e = this.tolerance;
  return null != this.sizers && 0 < this.sizers.length && null != this.sizers[0] && (this.bounds.width < 2 * this.sizers[0].bounds.width + 2 * e || this.bounds.height < 2 * this.sizers[0].bounds.height + 2 * e) && (e /= 2, t.x = this.sizers[0].bounds.width + e, t.y = this.sizers[0].bounds.height + e), t;
}, mxVertexHandler.prototype.redrawHandles = function () {
  var t = this.tolerance;
  this.verticalOffset = this.horizontalOffset = 0;
  var e = this.bounds;

  if (null != this.sizers && 0 < this.sizers.length && null != this.sizers[0]) {
    if (null == this.index && this.manageSizers && 8 <= this.sizers.length) {
      var i = this.getHandlePadding();
      this.horizontalOffset = i.x, this.verticalOffset = i.y, 0 == this.horizontalOffset && 0 == this.verticalOffset || ((e = new mxRectangle(e.x, e.y, e.width, e.height)).x -= this.horizontalOffset / 2, e.width += this.horizontalOffset, e.y -= this.verticalOffset / 2, e.height += this.verticalOffset), 8 <= this.sizers.length && (e.width < 2 * this.sizers[0].bounds.width + 2 * t || e.height < 2 * this.sizers[0].bounds.height + 2 * t ? (this.sizers[0].node.style.display = "none", this.sizers[2].node.style.display = "none", this.sizers[5].node.style.display = "none", this.sizers[7].node.style.display = "none") : (this.sizers[0].node.style.display = "", this.sizers[2].node.style.display = "", this.sizers[5].node.style.display = "", this.sizers[7].node.style.display = ""));
    }

    if (t = e.x + e.width, i = e.y + e.height, this.singleSizer) this.moveSizerTo(this.sizers[0], t, i);else {
      var n = e.x + e.width / 2,
          s = e.y + e.height / 2;

      if (8 <= this.sizers.length) {
        var o = "nw-resize n-resize ne-resize e-resize se-resize s-resize sw-resize w-resize".split(" "),
            l = mxUtils.toRadians(this.state.style[mxConstants.STYLE_ROTATION] || "0"),
            r = Math.cos(l),
            a = Math.sin(l),
            h = (l = Math.round(4 * l / Math.PI), new mxPoint(e.getCenterX(), e.getCenterY())),
            u = mxUtils.getRotatedPoint(new mxPoint(e.x, e.y), r, a, h);
        this.moveSizerTo(this.sizers[0], u.x, u.y), this.sizers[0].setCursor(o[mxUtils.mod(0 + l, o.length)]), u.x = n, u.y = e.y, u = mxUtils.getRotatedPoint(u, r, a, h), this.moveSizerTo(this.sizers[1], u.x, u.y), this.sizers[1].setCursor(o[mxUtils.mod(1 + l, o.length)]), u.x = t, u.y = e.y, u = mxUtils.getRotatedPoint(u, r, a, h), this.moveSizerTo(this.sizers[2], u.x, u.y), this.sizers[2].setCursor(o[mxUtils.mod(2 + l, o.length)]), u.x = e.x, u.y = s, u = mxUtils.getRotatedPoint(u, r, a, h), this.moveSizerTo(this.sizers[3], u.x, u.y), this.sizers[3].setCursor(o[mxUtils.mod(7 + l, o.length)]), u.x = t, u.y = s, u = mxUtils.getRotatedPoint(u, r, a, h), this.moveSizerTo(this.sizers[4], u.x, u.y), this.sizers[4].setCursor(o[mxUtils.mod(3 + l, o.length)]), u.x = e.x, u.y = i, u = mxUtils.getRotatedPoint(u, r, a, h), this.moveSizerTo(this.sizers[5], u.x, u.y), this.sizers[5].setCursor(o[mxUtils.mod(6 + l, o.length)]), u.x = n, u.y = i, u = mxUtils.getRotatedPoint(u, r, a, h), this.moveSizerTo(this.sizers[6], u.x, u.y), this.sizers[6].setCursor(o[mxUtils.mod(5 + l, o.length)]), u.x = t, u.y = i, u = mxUtils.getRotatedPoint(u, r, a, h), this.moveSizerTo(this.sizers[7], u.x, u.y), this.sizers[7].setCursor(o[mxUtils.mod(4 + l, o.length)]), this.moveSizerTo(this.sizers[8], n + this.state.absoluteOffset.x, s + this.state.absoluteOffset.y);
      } else 2 <= this.state.width && 2 <= this.state.height ? this.moveSizerTo(this.sizers[0], n + this.state.absoluteOffset.x, s + this.state.absoluteOffset.y) : this.moveSizerTo(this.sizers[0], this.state.x, this.state.y);
    }
  }

  if (null != this.rotationShape && (l = mxUtils.toRadians(null != this.currentAlpha ? this.currentAlpha : this.state.style[mxConstants.STYLE_ROTATION] || "0"), r = Math.cos(l), a = Math.sin(l), h = new mxPoint(this.state.getCenterX(), this.state.getCenterY()), u = mxUtils.getRotatedPoint(this.getRotationHandlePosition(), r, a, h), null != this.rotationShape.node && (this.moveSizerTo(this.rotationShape, u.x, u.y), this.rotationShape.node.style.visibility = this.state.view.graph.isEditing() ? "hidden" : "")), null != this.selectionBorder && (this.selectionBorder.rotation = Number(this.state.style[mxConstants.STYLE_ROTATION] || "0")), null != this.edgeHandlers) for (e = 0; e < this.edgeHandlers.length; e++) {
    this.edgeHandlers[e].redraw();
  }
  if (null != this.customHandles) for (e = 0; e < this.customHandles.length; e++) {
    t = this.customHandles[e].shape.node.style.display, this.customHandles[e].redraw(), this.customHandles[e].shape.node.style.display = t, this.customHandles[e].shape.node.style.visibility = this.graph.isEditing() ? "hidden" : "";
  }
  this.updateParentHighlight();
}, mxVertexHandler.prototype.getRotationHandlePosition = function () {
  return new mxPoint(this.bounds.x + this.bounds.width / 2, this.bounds.y + this.rotationHandleVSpacing);
}, mxVertexHandler.prototype.updateParentHighlight = function () {
  if (null != this.selectionBorder) if (null != this.parentHighlight) {
    var t = this.graph.model.getParent(this.state.cell);

    if (this.graph.model.isVertex(t)) {
      t = this.graph.view.getState(t);
      var e = this.parentHighlight.bounds;
      null == t || e.x == t.x && e.y == t.y && e.width == t.width && e.height == t.height || (this.parentHighlight.bounds = t, this.parentHighlight.redraw());
    } else this.parentHighlight.destroy(), this.parentHighlight = null;
  } else this.parentHighlightEnabled && (t = this.graph.model.getParent(this.state.cell), this.graph.model.isVertex(t) && null != (t = this.graph.view.getState(t)) && (this.parentHighlight = this.createParentHighlightShape(t), this.parentHighlight.dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_VML : mxConstants.DIALECT_SVG, this.parentHighlight.pointerEvents = !1, this.parentHighlight.rotation = Number(t.style[mxConstants.STYLE_ROTATION] || "0"), this.parentHighlight.init(this.graph.getView().getOverlayPane())));
}, mxVertexHandler.prototype.drawPreview = function () {
  null != this.preview && (this.preview.bounds = this.bounds, this.preview.node.parentNode == this.graph.container && (this.preview.bounds.width = Math.max(0, this.preview.bounds.width - 1), this.preview.bounds.height = Math.max(0, this.preview.bounds.height - 1)), this.preview.rotation = Number(this.state.style[mxConstants.STYLE_ROTATION] || "0"), this.preview.redraw()), this.selectionBorder.bounds = this.bounds, this.selectionBorder.redraw(), null != this.parentHighlight && this.parentHighlight.redraw();
}, mxVertexHandler.prototype.destroy = function () {
  if (null != this.escapeHandler && (this.state.view.graph.removeListener(this.escapeHandler), this.escapeHandler = null), null != this.preview && (this.preview.destroy(), this.preview = null), null != this.parentHighlight && (this.parentHighlight.destroy(), this.parentHighlight = null), null != this.selectionBorder && (this.selectionBorder.destroy(), this.selectionBorder = null), this.labelShape = null, this.removeHint(), null != this.sizers) {
    for (var t = 0; t < this.sizers.length; t++) {
      this.sizers[t].destroy();
    }

    this.sizers = null;
  }

  if (null != this.customHandles) {
    for (t = 0; t < this.customHandles.length; t++) {
      this.customHandles[t].destroy();
    }

    this.customHandles = null;
  }
}, mxEdgeHandler.prototype.graph = null, mxEdgeHandler.prototype.state = null, mxEdgeHandler.prototype.marker = null, mxEdgeHandler.prototype.constraintHandler = null, mxEdgeHandler.prototype.error = null, mxEdgeHandler.prototype.shape = null, mxEdgeHandler.prototype.bends = null, mxEdgeHandler.prototype.labelShape = null, mxEdgeHandler.prototype.cloneEnabled = !0, mxEdgeHandler.prototype.addEnabled = !1, mxEdgeHandler.prototype.removeEnabled = !1, mxEdgeHandler.prototype.dblClickRemoveEnabled = !1, mxEdgeHandler.prototype.mergeRemoveEnabled = !1, mxEdgeHandler.prototype.straightRemoveEnabled = !1, mxEdgeHandler.prototype.virtualBendsEnabled = !1, mxEdgeHandler.prototype.virtualBendOpacity = 20, mxEdgeHandler.prototype.parentHighlightEnabled = !1, mxEdgeHandler.prototype.preferHtml = !1, mxEdgeHandler.prototype.allowHandleBoundsCheck = !0, mxEdgeHandler.prototype.snapToTerminals = !1, mxEdgeHandler.prototype.handleImage = null, mxEdgeHandler.prototype.tolerance = 0, mxEdgeHandler.prototype.outlineConnect = !1, mxEdgeHandler.prototype.manageLabelHandle = !1, mxEdgeHandler.prototype.init = function () {
  if (this.graph = this.state.view.graph, this.marker = this.createMarker(), this.constraintHandler = new mxConstraintHandler(this.graph), this.points = [], this.abspoints = this.getSelectionPoints(this.state), this.shape = this.createSelectionShape(this.abspoints), this.shape.dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_MIXEDHTML : mxConstants.DIALECT_SVG, this.shape.init(this.graph.getView().getOverlayPane()), this.shape.pointerEvents = !1, this.shape.setCursor(mxConstants.CURSOR_MOVABLE_EDGE), mxEvent.redirectMouseEvents(this.shape.node, this.graph, this.state), this.preferHtml = null != this.state.text && this.state.text.node.parentNode == this.graph.container, !this.preferHtml) {
    var t = this.state.getVisibleTerminalState(!0);
    null != t && (this.preferHtml = null != t.text && t.text.node.parentNode == this.graph.container), this.preferHtml || null != (t = this.state.getVisibleTerminalState(!1)) && (this.preferHtml = null != t.text && t.text.node.parentNode == this.graph.container);
  }

  this.parentHighlightEnabled && (t = this.graph.model.getParent(this.state.cell), this.graph.model.isVertex(t) && null != (t = this.graph.view.getState(t)) && (this.parentHighlight = this.createParentHighlightShape(t), this.parentHighlight.dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_VML : mxConstants.DIALECT_SVG, this.parentHighlight.pointerEvents = !1, this.parentHighlight.rotation = Number(t.style[mxConstants.STYLE_ROTATION] || "0"), this.parentHighlight.init(this.graph.getView().getOverlayPane()))), (this.graph.getSelectionCount() < mxGraphHandler.prototype.maxCells || 0 >= mxGraphHandler.prototype.maxCells) && (this.bends = this.createBends(), this.isVirtualBendsEnabled() && (this.virtualBends = this.createVirtualBends())), this.label = new mxPoint(this.state.absoluteOffset.x, this.state.absoluteOffset.y), this.labelShape = this.createLabelHandleShape(), this.initBend(this.labelShape), this.labelShape.setCursor(mxConstants.CURSOR_LABEL_HANDLE), this.customHandles = this.createCustomHandles(), this.redraw();
}, mxEdgeHandler.prototype.createCustomHandles = function () {
  return null;
}, mxEdgeHandler.prototype.isVirtualBendsEnabled = function (t) {
  return this.virtualBendsEnabled && (null == this.state.style[mxConstants.STYLE_EDGE] || this.state.style[mxConstants.STYLE_EDGE] == mxConstants.NONE || 1 == this.state.style[mxConstants.STYLE_NOEDGESTYLE]) && "arrow" != mxUtils.getValue(this.state.style, mxConstants.STYLE_SHAPE, null);
}, mxEdgeHandler.prototype.isAddPointEvent = function (t) {
  return mxEvent.isShiftDown(t);
}, mxEdgeHandler.prototype.isRemovePointEvent = function (t) {
  return mxEvent.isShiftDown(t);
}, mxEdgeHandler.prototype.getSelectionPoints = function (t) {
  return t.absolutePoints;
}, mxEdgeHandler.prototype.createParentHighlightShape = function (t) {
  return (t = new mxRectangleShape(t, null, this.getSelectionColor())).strokewidth = this.getSelectionStrokeWidth(), t.isDashed = this.isSelectionDashed(), t;
}, mxEdgeHandler.prototype.createSelectionShape = function (t) {
  return (t = new this.state.shape.constructor()).outline = !0, t.apply(this.state), t.isDashed = this.isSelectionDashed(), t.stroke = this.getSelectionColor(), t.isShadow = !1, t;
}, mxEdgeHandler.prototype.getSelectionColor = function () {
  return mxConstants.EDGE_SELECTION_COLOR;
}, mxEdgeHandler.prototype.getSelectionStrokeWidth = function () {
  return mxConstants.EDGE_SELECTION_STROKEWIDTH;
}, mxEdgeHandler.prototype.isSelectionDashed = function () {
  return mxConstants.EDGE_SELECTION_DASHED;
}, mxEdgeHandler.prototype.isConnectableCell = function (t) {
  return !0;
}, mxEdgeHandler.prototype.getCellAt = function (t, e) {
  return this.outlineConnect ? null : this.graph.getCellAt(t, e);
}, mxEdgeHandler.prototype.createMarker = function () {
  var t = new mxCellMarker(this.graph),
      e = this;
  return t.getCell = function (t) {
    var i = mxCellMarker.prototype.getCell.apply(this, arguments);

    if (i != e.state.cell && null != i || null == e.currentPoint || (i = e.graph.getCellAt(e.currentPoint.x, e.currentPoint.y)), null != i && !this.graph.isCellConnectable(i)) {
      var n = this.graph.getModel().getParent(i);
      this.graph.getModel().isVertex(n) && this.graph.isCellConnectable(n) && (i = n);
    }

    return n = e.graph.getModel(), (this.graph.isSwimlane(i) && null != e.currentPoint && this.graph.hitsSwimlaneContent(i, e.currentPoint.x, e.currentPoint.y) || !e.isConnectableCell(i) || i == e.state.cell || null != i && !e.graph.connectableEdges && n.isEdge(i) || n.isAncestor(e.state.cell, i)) && (i = null), this.graph.isCellConnectable(i) || (i = null), i;
  }, t.isValidState = function (t) {
    var i = e.graph.getModel();
    i = null != (i = e.graph.view.getTerminalPort(t, e.graph.view.getState(i.getTerminal(e.state.cell, !e.isSource)), !e.isSource)) ? i.cell : null;
    return e.error = e.validateConnection(e.isSource ? t.cell : i, e.isSource ? i : t.cell), null == e.error;
  }, t;
}, mxEdgeHandler.prototype.validateConnection = function (t, e) {
  return this.graph.getEdgeValidationError(this.state.cell, t, e);
}, mxEdgeHandler.prototype.createBends = function () {
  for (var t = this.state.cell, e = [], i = 0; i < this.abspoints.length; i++) {
    if (this.isHandleVisible(i)) {
      var n = i == this.abspoints.length - 1,
          s = 0 == i || n;
      (s || this.graph.isCellBendable(t)) && mxUtils.bind(this, function (t) {
        var n = this.createHandleShape(t);
        this.initBend(n, mxUtils.bind(this, mxUtils.bind(this, function () {
          this.dblClickRemoveEnabled && this.removePoint(this.state, t);
        }))), this.isHandleEnabled(i) && n.setCursor(s ? mxConstants.CURSOR_TERMINAL_HANDLE : mxConstants.CURSOR_BEND_HANDLE), e.push(n), s || (this.points.push(new mxPoint(0, 0)), n.node.style.visibility = "hidden");
      })(i);
    }
  }

  return e;
}, mxEdgeHandler.prototype.createVirtualBends = function () {
  var t = [];
  if (this.graph.isCellBendable(this.state.cell)) for (var e = 1; e < this.abspoints.length; e++) {
    mxUtils.bind(this, function (e) {
      this.initBend(e), e.setCursor(mxConstants.CURSOR_VIRTUAL_BEND_HANDLE), t.push(e);
    })(this.createHandleShape());
  }
  return t;
}, mxEdgeHandler.prototype.isHandleEnabled = function (t) {
  return !0;
}, mxEdgeHandler.prototype.isHandleVisible = function (t) {
  var e = this.state.getVisibleTerminalState(!0),
      i = this.state.getVisibleTerminalState(!1),
      n = this.graph.getCellGeometry(this.state.cell);
  return (null != n ? this.graph.view.getEdgeStyle(this.state, n.points, e, i) : null) != mxEdgeStyle.EntityRelation || 0 == t || t == this.abspoints.length - 1;
}, mxEdgeHandler.prototype.createHandleShape = function (t) {
  return null != this.handleImage ? ((t = new mxImageShape(new mxRectangle(0, 0, this.handleImage.width, this.handleImage.height), this.handleImage.src)).preserveImageAspect = !1, t) : (t = mxConstants.HANDLE_SIZE, this.preferHtml && --t, new mxRectangleShape(new mxRectangle(0, 0, t, t), mxConstants.HANDLE_FILLCOLOR, mxConstants.HANDLE_STROKECOLOR));
}, mxEdgeHandler.prototype.createLabelHandleShape = function () {
  if (null != this.labelHandleImage) {
    var t = new mxImageShape(new mxRectangle(0, 0, this.labelHandleImage.width, this.labelHandleImage.height), this.labelHandleImage.src);
    return t.preserveImageAspect = !1, t;
  }

  return new mxRectangleShape(new mxRectangle(0, 0, t = mxConstants.LABEL_HANDLE_SIZE, t), mxConstants.LABEL_HANDLE_FILLCOLOR, mxConstants.HANDLE_STROKECOLOR);
}, mxEdgeHandler.prototype.initBend = function (t, e) {
  this.preferHtml ? (t.dialect = mxConstants.DIALECT_STRICTHTML, t.init(this.graph.container)) : (t.dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_MIXEDHTML : mxConstants.DIALECT_SVG, t.init(this.graph.getView().getOverlayPane())), mxEvent.redirectMouseEvents(t.node, this.graph, this.state, null, null, null, e), (mxClient.IS_QUIRKS || 8 == document.documentMode) && mxEvent.addListener(t.node, "dragstart", function (t) {
    return mxEvent.consume(t), !1;
  }), mxClient.IS_TOUCH && t.node.setAttribute("pointer-events", "none");
}, mxEdgeHandler.prototype.getHandleForEvent = function (t) {
  function e(e) {
    if (null != e && "none" != e.node.style.display && "hidden" != e.node.style.visibility && (t.isSource(e) || null != n && mxUtils.intersects(e.bounds, n))) {
      var i = t.getGraphX() - e.bounds.getCenterX();
      if (i = i * i + (e = t.getGraphY() - e.bounds.getCenterY()) * e, null == s || i <= s) return s = i, !0;
    }

    return !1;
  }

  var i = mxEvent.isMouseEvent(t.getEvent()) ? 1 : this.tolerance,
      n = this.allowHandleBoundsCheck && (mxClient.IS_IE || 0 < i) ? new mxRectangle(t.getGraphX() - i, t.getGraphY() - i, 2 * i, 2 * i) : null,
      s = null;
  i = null;
  if (null != this.customHandles && this.isCustomHandleEvent(t)) for (var o = this.customHandles.length - 1; 0 <= o; o--) {
    if (e(this.customHandles[o].shape)) return mxEvent.CUSTOM_HANDLE - o;
  }
  if ((t.isSource(this.state.text) || e(this.labelShape)) && (i = mxEvent.LABEL_HANDLE), null != this.bends) for (o = 0; o < this.bends.length; o++) {
    e(this.bends[o]) && (i = o);
  }
  if (null != this.virtualBends && this.isAddVirtualBendEvent(t)) for (o = 0; o < this.virtualBends.length; o++) {
    e(this.virtualBends[o]) && (i = mxEvent.VIRTUAL_HANDLE - o);
  }
  return i;
}, mxEdgeHandler.prototype.isAddVirtualBendEvent = function (t) {
  return !0;
}, mxEdgeHandler.prototype.isCustomHandleEvent = function (t) {
  return !0;
}, mxEdgeHandler.prototype.mouseDown = function (t, e) {
  var i = this.getHandleForEvent(e);

  if (null != this.bends && null != this.bends[i]) {
    var n = this.bends[i].bounds;
    this.snapPoint = new mxPoint(n.getCenterX(), n.getCenterY());
  }

  this.addEnabled && null == i && this.isAddPointEvent(e.getEvent()) ? (this.addPoint(this.state, e.getEvent()), e.consume()) : null != i && !e.isConsumed() && this.graph.isEnabled() && (this.removeEnabled && this.isRemovePointEvent(e.getEvent()) ? this.removePoint(this.state, i) : (i != mxEvent.LABEL_HANDLE || this.graph.isLabelMovable(e.getCell())) && (i <= mxEvent.VIRTUAL_HANDLE && mxUtils.setOpacity(this.virtualBends[mxEvent.VIRTUAL_HANDLE - i].node, 100), this.start(e.getX(), e.getY(), i)), e.consume());
}, mxEdgeHandler.prototype.start = function (t, e, i) {
  if (this.startX = t, this.startY = e, this.isSource = null != this.bends && 0 == i, this.isTarget = null != this.bends && i == this.bends.length - 1, this.isLabel = i == mxEvent.LABEL_HANDLE, this.isSource || this.isTarget ? (t = this.state.cell, (null == (e = this.graph.model.getTerminal(t, this.isSource)) && this.graph.isTerminalPointMovable(t, this.isSource) || null != e && this.graph.isCellDisconnectable(t, e, this.isSource)) && (this.index = i)) : this.index = i, this.index <= mxEvent.CUSTOM_HANDLE && this.index > mxEvent.VIRTUAL_HANDLE && null != this.customHandles) for (i = 0; i < this.customHandles.length; i++) {
    i != mxEvent.CUSTOM_HANDLE - this.index && this.customHandles[i].setVisible(!1);
  }
}, mxEdgeHandler.prototype.clonePreviewState = function (t, e) {
  return this.state.clone();
}, mxEdgeHandler.prototype.getSnapToTerminalTolerance = function () {
  return this.graph.gridSize * this.graph.view.scale / 2;
}, mxEdgeHandler.prototype.updateHint = function (t, e) {}, mxEdgeHandler.prototype.removeHint = function () {}, mxEdgeHandler.prototype.roundLength = function (t) {
  return Math.round(t);
}, mxEdgeHandler.prototype.isSnapToTerminalsEvent = function (t) {
  return this.snapToTerminals && !mxEvent.isAltDown(t.getEvent());
}, mxEdgeHandler.prototype.getPointForEvent = function (t) {
  var e = this.graph.getView(),
      i = e.scale,
      n = new mxPoint(this.roundLength(t.getGraphX() / i) * i, this.roundLength(t.getGraphY() / i) * i),
      s = this.getSnapToTerminalTolerance(),
      o = !1,
      l = !1;

  if (0 < s && this.isSnapToTerminalsEvent(t)) {
    var r = function r(t) {
      null != t && a.call(this, new mxPoint(e.getRoutingCenterX(t), e.getRoutingCenterY(t)));
    },
        a = function a(t) {
      if (null != t) {
        var e = t.x;
        Math.abs(n.x - e) < s && (n.x = e, o = !0), t = t.y, Math.abs(n.y - t) < s && (n.y = t, l = !0);
      }
    };

    if (r.call(this, this.state.getVisibleTerminalState(!0)), r.call(this, this.state.getVisibleTerminalState(!1)), null != this.state.absolutePoints) for (r = 0; r < this.state.absolutePoints.length; r++) {
      a.call(this, this.state.absolutePoints[r]);
    }
  }

  return this.graph.isGridEnabledEvent(t.getEvent()) && (t = e.translate, o || (n.x = (this.graph.snap(n.x / i - t.x) + t.x) * i), l || (n.y = (this.graph.snap(n.y / i - t.y) + t.y) * i)), n;
}, mxEdgeHandler.prototype.getPreviewTerminalState = function (t) {
  return this.constraintHandler.update(t, this.isSource, !0, t.isSource(this.marker.highlight.shape) ? null : this.currentPoint), null != this.constraintHandler.currentFocus && null != this.constraintHandler.currentConstraint ? (null != this.marker.highlight && null != this.marker.highlight.state && this.marker.highlight.state.cell == this.constraintHandler.currentFocus.cell ? "transparent" != this.marker.highlight.shape.stroke && (this.marker.highlight.shape.stroke = "transparent", this.marker.highlight.repaint()) : this.marker.markCell(this.constraintHandler.currentFocus.cell, "transparent"), t = this.graph.getModel(), t = null != (t = this.graph.view.getTerminalPort(this.state, this.graph.view.getState(t.getTerminal(this.state.cell, !this.isSource)), !this.isSource)) ? t.cell : null, this.error = this.validateConnection(this.isSource ? this.constraintHandler.currentFocus.cell : t, this.isSource ? t : this.constraintHandler.currentFocus.cell), t = null, null == this.error ? t = this.constraintHandler.currentFocus : this.constraintHandler.reset(), t) : this.graph.isIgnoreTerminalEvent(t.getEvent()) ? (this.marker.reset(), null) : (this.marker.process(t), null != (t = this.marker.getValidState()) && this.graph.isCellLocked(t.cell) && this.marker.reset(), this.marker.getValidState());
}, mxEdgeHandler.prototype.getPreviewPoints = function (t, e) {
  var i = null != (i = this.graph.getCellGeometry(this.state.cell)).points ? i.points.slice() : null,
      n = new mxPoint(t.x, t.y),
      s = null;
  if (this.isSource || this.isTarget) this.graph.resetEdgesOnConnect && (i = null);else if (this.convertPoint(n, !1), null == i) i = [n];else {
    if (this.index <= mxEvent.VIRTUAL_HANDLE && i.splice(mxEvent.VIRTUAL_HANDLE - this.index, 0, n), !this.isSource && !this.isTarget) {
      for (var o = 0; o < this.bends.length; o++) {
        if (o != this.index) {
          var l = this.bends[o];
          null != l && mxUtils.contains(l.bounds, t.x, t.y) && (this.index <= mxEvent.VIRTUAL_HANDLE ? i.splice(mxEvent.VIRTUAL_HANDLE - this.index, 1) : i.splice(this.index - 1, 1), s = i);
        }
      }

      if (null == s && this.straightRemoveEnabled && (null == e || !mxEvent.isAltDown(e.getEvent()))) {
        o = this.graph.tolerance * this.graph.tolerance, (l = this.state.absolutePoints.slice())[this.index] = t;
        var r = this.state.getVisibleTerminalState(!0);

        if (null != r) {
          var a = this.graph.getConnectionConstraint(this.state, r, !0);
          null != a && null != this.graph.getConnectionPoint(r, a) || (l[0] = new mxPoint(r.view.getRoutingCenterX(r), r.view.getRoutingCenterY(r)));
        }

        null != (r = this.state.getVisibleTerminalState(!1)) && (null == (a = this.graph.getConnectionConstraint(this.state, r, !1)) || null == this.graph.getConnectionPoint(r, a)) && (l[l.length - 1] = new mxPoint(r.view.getRoutingCenterX(r), r.view.getRoutingCenterY(r))), 0 < (a = this.index) && a < l.length - 1 && mxUtils.ptSegDistSq(l[a - 1].x, l[a - 1].y, l[a + 1].x, l[a + 1].y, t.x, t.y) < o && (i.splice(a - 1, 1), s = i);
      }
    }

    null == s && this.index > mxEvent.VIRTUAL_HANDLE && (i[this.index - 1] = n);
  }
  return null != s ? s : i;
}, mxEdgeHandler.prototype.isOutlineConnectEvent = function (t) {
  var e = mxUtils.getOffset(this.graph.container),
      i = t.getEvent(),
      n = mxEvent.getClientX(i),
      s = (i = mxEvent.getClientY(i), document.documentElement),
      o = this.currentPoint.x - this.graph.container.scrollLeft + e.x - ((window.pageXOffset || s.scrollLeft) - (s.clientLeft || 0));
  e = this.currentPoint.y - this.graph.container.scrollTop + e.y - ((window.pageYOffset || s.scrollTop) - (s.clientTop || 0));
  return this.outlineConnect && !mxEvent.isShiftDown(t.getEvent()) && (t.isSource(this.marker.highlight.shape) || mxEvent.isAltDown(t.getEvent()) && null != t.getState() || this.marker.highlight.isHighlightAt(n, i) || (o != n || e != i) && null == t.getState() && this.marker.highlight.isHighlightAt(o, e));
}, mxEdgeHandler.prototype.updatePreviewState = function (t, e, i, n, s) {
  var o = this.isSource ? i : this.state.getVisibleTerminalState(!0),
      l = this.isTarget ? i : this.state.getVisibleTerminalState(!1),
      r = this.graph.getConnectionConstraint(t, o, !0),
      a = this.graph.getConnectionConstraint(t, l, !1),
      h = this.constraintHandler.currentConstraint;

  if (null == h && s && (null != i ? (n.isSource(this.marker.highlight.shape) && (e = new mxPoint(n.getGraphX(), n.getGraphY())), h = this.graph.getOutlineConstraint(e, i, n), this.constraintHandler.setFocus(n, i, this.isSource), this.constraintHandler.currentConstraint = h, this.constraintHandler.currentPoint = e) : h = new mxConnectionConstraint()), this.outlineConnect && null != this.marker.highlight && null != this.marker.highlight.shape) {
    var u = this.graph.view.scale;
    null != this.constraintHandler.currentConstraint && null != this.constraintHandler.currentFocus ? (this.marker.highlight.shape.stroke = s ? mxConstants.OUTLINE_HIGHLIGHT_COLOR : "transparent", this.marker.highlight.shape.strokewidth = mxConstants.OUTLINE_HIGHLIGHT_STROKEWIDTH / u / u, this.marker.highlight.repaint()) : this.marker.hasValidState() && (this.marker.highlight.shape.stroke = this.marker.getValidState() == n.getState() ? mxConstants.DEFAULT_VALID_COLOR : "transparent", this.marker.highlight.shape.strokewidth = mxConstants.HIGHLIGHT_STROKEWIDTH / u / u, this.marker.highlight.repaint());
  }

  this.isSource ? r = h : this.isTarget && (a = h), (this.isSource || this.isTarget) && (null != h && null != h.point ? (t.style[this.isSource ? mxConstants.STYLE_EXIT_X : mxConstants.STYLE_ENTRY_X] = h.point.x, t.style[this.isSource ? mxConstants.STYLE_EXIT_Y : mxConstants.STYLE_ENTRY_Y] = h.point.y) : (delete t.style[this.isSource ? mxConstants.STYLE_EXIT_X : mxConstants.STYLE_ENTRY_X], delete t.style[this.isSource ? mxConstants.STYLE_EXIT_Y : mxConstants.STYLE_ENTRY_Y])), t.setVisibleTerminalState(o, !0), t.setVisibleTerminalState(l, !1), this.isSource && null == o || t.view.updateFixedTerminalPoint(t, o, !0, r), this.isTarget && null == l || t.view.updateFixedTerminalPoint(t, l, !1, a), (this.isSource || this.isTarget) && null == i && (t.setAbsoluteTerminalPoint(e, this.isSource), null == this.marker.getMarkedState() && (this.error = this.graph.allowDanglingEdges ? null : "")), t.view.updatePoints(t, this.points, o, l), t.view.updateFloatingTerminalPoints(t, o, l);
}, mxEdgeHandler.prototype.mouseMove = function (t, e) {
  if (null != this.index && null != this.marker) {
    if (this.currentPoint = this.getPointForEvent(e), this.error = null, !this.graph.isIgnoreTerminalEvent(e.getEvent()) && mxEvent.isShiftDown(e.getEvent()) && null != this.snapPoint && (Math.abs(this.snapPoint.x - this.currentPoint.x) < Math.abs(this.snapPoint.y - this.currentPoint.y) ? this.currentPoint.x = this.snapPoint.x : this.currentPoint.y = this.snapPoint.y), this.index <= mxEvent.CUSTOM_HANDLE && this.index > mxEvent.VIRTUAL_HANDLE) null != this.customHandles && this.customHandles[mxEvent.CUSTOM_HANDLE - this.index].processEvent(e);else if (this.isLabel) this.label.x = this.currentPoint.x, this.label.y = this.currentPoint.y;else {
      this.points = this.getPreviewPoints(this.currentPoint, e);
      var i = this.isSource || this.isTarget ? this.getPreviewTerminalState(e) : null;
      if (null != this.constraintHandler.currentConstraint && null != this.constraintHandler.currentFocus && null != this.constraintHandler.currentPoint) this.currentPoint = this.constraintHandler.currentPoint.clone();else if (this.outlineConnect) {
        var n = !(!this.isSource && !this.isTarget) && this.isOutlineConnectEvent(e);
        n ? i = this.marker.highlight.state : null != i && i != e.getState() && null != this.marker.highlight.shape && (this.marker.highlight.shape.stroke = "transparent", this.marker.highlight.repaint(), i = null);
      }
      null != i && this.graph.isCellLocked(i.cell) && (i = null, this.marker.reset());
      var s = this.clonePreviewState(this.currentPoint, null != i ? i.cell : null);
      this.updatePreviewState(s, this.currentPoint, i, e, n), this.setPreviewColor(null == this.error ? this.marker.validColor : this.marker.invalidColor), this.abspoints = s.absolutePoints, this.active = !0;
    }
    this.updateHint(e, this.currentPoint), this.drawPreview(), mxEvent.consume(e.getEvent()), e.consume();
  } else mxClient.IS_IE && null != this.getHandleForEvent(e) && e.consume(!1);
}, mxEdgeHandler.prototype.mouseUp = function (t, e) {
  if (null != this.index && null != this.marker) {
    var i = this.state.cell;

    if (e.getX() != this.startX || e.getY() != this.startY) {
      var n = !this.graph.isIgnoreTerminalEvent(e.getEvent()) && this.graph.isCloneEvent(e.getEvent()) && this.cloneEnabled && this.graph.isCellsCloneable();
      if (null != this.error) 0 < this.error.length && this.graph.validationAlert(this.error);else if (this.index <= mxEvent.CUSTOM_HANDLE && this.index > mxEvent.VIRTUAL_HANDLE) {
        if (null != this.customHandles) {
          (o = this.graph.getModel()).beginUpdate();

          try {
            this.customHandles[mxEvent.CUSTOM_HANDLE - this.index].execute();
          } finally {
            o.endUpdate();
          }
        }
      } else if (this.isLabel) this.moveLabel(this.state, this.label.x, this.label.y);else if (this.isSource || this.isTarget) {
        var s = null;

        if (null != this.constraintHandler.currentConstraint && null != this.constraintHandler.currentFocus && (s = this.constraintHandler.currentFocus.cell), null == s && this.marker.hasValidState() && null != this.marker.highlight && null != this.marker.highlight.shape && "transparent" != this.marker.highlight.shape.stroke && "white" != this.marker.highlight.shape.stroke && (s = this.marker.validState.cell), null != s) {
          var o,
              l = (o = this.graph.getModel()).getParent(i);
          o.beginUpdate();

          try {
            if (n) {
              var r = o.getGeometry(i);
              n = this.graph.cloneCell(i);
              o.add(l, n, o.getChildCount(l)), null != r && (r = r.clone(), o.setGeometry(n, r));
              var a = o.getTerminal(i, !this.isSource);
              this.graph.connectCell(n, a, !this.isSource), i = n;
            }

            i = this.connect(i, s, this.isSource, n, e);
          } finally {
            o.endUpdate();
          }
        } else this.graph.isAllowDanglingEdges() && ((o = this.abspoints[this.isSource ? 0 : this.abspoints.length - 1]).x = this.roundLength(o.x / this.graph.view.scale - this.graph.view.translate.x), o.y = this.roundLength(o.y / this.graph.view.scale - this.graph.view.translate.y), null != (s = this.graph.getView().getState(this.graph.getModel().getParent(i))) && (o.x -= s.origin.x, o.y -= s.origin.y), o.x -= this.graph.panDx / this.graph.view.scale, o.y -= this.graph.panDy / this.graph.view.scale, i = this.changeTerminalPoint(i, o, this.isSource, n));
      } else this.active ? i = this.changePoints(i, this.points, n) : (this.graph.getView().invalidate(this.state.cell), this.graph.getView().validate(this.state.cell));
    }

    null != this.marker && (this.reset(), i != this.state.cell && this.graph.setSelectionCell(i)), e.consume();
  }
}, mxEdgeHandler.prototype.reset = function () {
  if (this.active && this.refresh(), this.snapPoint = this.points = this.label = this.index = this.error = null, this.active = this.isTarget = this.isSource = this.isLabel = !1, this.livePreview && null != this.sizers) for (var t = 0; t < this.sizers.length; t++) {
    null != this.sizers[t] && (this.sizers[t].node.style.display = "");
  }
  if (null != this.marker && this.marker.reset(), null != this.constraintHandler && this.constraintHandler.reset(), null != this.customHandles) for (t = 0; t < this.customHandles.length; t++) {
    this.customHandles[t].reset();
  }
  this.setPreviewColor(mxConstants.EDGE_SELECTION_COLOR), this.removeHint(), this.redraw();
}, mxEdgeHandler.prototype.setPreviewColor = function (t) {
  null != this.shape && (this.shape.stroke = t);
}, mxEdgeHandler.prototype.convertPoint = function (t, e) {
  var i = this.graph.getView().getScale(),
      n = this.graph.getView().getTranslate();
  return e && (t.x = this.graph.snap(t.x), t.y = this.graph.snap(t.y)), t.x = Math.round(t.x / i - n.x), t.y = Math.round(t.y / i - n.y), null != (i = this.graph.getView().getState(this.graph.getModel().getParent(this.state.cell))) && (t.x -= i.origin.x, t.y -= i.origin.y), t;
}, mxEdgeHandler.prototype.moveLabel = function (t, e, i) {
  var n = this.graph.getModel();

  if (null != (s = n.getGeometry(t.cell))) {
    var s,
        o = this.graph.getView().scale;

    if ((s = s.clone()).relative) {
      var l = this.graph.getView().getRelativePoint(t, e, i);
      s.x = Math.round(1e4 * l.x) / 1e4, s.y = Math.round(l.y), s.offset = new mxPoint(0, 0), l = this.graph.view.getPoint(t, s), s.offset = new mxPoint(Math.round((e - l.x) / o), Math.round((i - l.y) / o));
    } else {
      l = (r = t.absolutePoints)[0];
      var r = r[r.length - 1];
      null != l && null != r && (s.offset = new mxPoint(Math.round((e - (l.x + (r.x - l.x) / 2)) / o), Math.round((i - (l.y + (r.y - l.y) / 2)) / o)), s.x = 0, s.y = 0);
    }

    n.setGeometry(t.cell, s);
  }
}, mxEdgeHandler.prototype.connect = function (t, e, i, n, s) {
  (n = this.graph.getModel()).getParent(t), n.beginUpdate();

  try {
    var o = this.constraintHandler.currentConstraint;
    null == o && (o = new mxConnectionConstraint()), this.graph.connectCell(t, e, i, o);
  } finally {
    n.endUpdate();
  }

  return t;
}, mxEdgeHandler.prototype.changeTerminalPoint = function (t, e, i, n) {
  var s = this.graph.getModel();
  s.beginUpdate();

  try {
    if (n) {
      var o = s.getParent(t),
          l = s.getTerminal(t, !i);
      t = this.graph.cloneCell(t), s.add(o, t, s.getChildCount(o)), s.setTerminal(t, l, !i);
    }

    var r = s.getGeometry(t);
    null != r && ((r = r.clone()).setTerminalPoint(e, i), s.setGeometry(t, r), this.graph.connectCell(t, null, i, new mxConnectionConstraint()));
  } finally {
    s.endUpdate();
  }

  return t;
}, mxEdgeHandler.prototype.changePoints = function (t, e, i) {
  var n = this.graph.getModel();
  n.beginUpdate();

  try {
    if (i) {
      var s = n.getParent(t),
          o = n.getTerminal(t, !0),
          l = n.getTerminal(t, !1);
      t = this.graph.cloneCell(t), n.add(s, t, n.getChildCount(s)), n.setTerminal(t, o, !0), n.setTerminal(t, l, !1);
    }

    var r = n.getGeometry(t);
    null != r && ((r = r.clone()).points = e, n.setGeometry(t, r));
  } finally {
    n.endUpdate();
  }

  return t;
}, mxEdgeHandler.prototype.addPoint = function (t, e) {
  var i = mxUtils.convertPoint(this.graph.container, mxEvent.getClientX(e), mxEvent.getClientY(e)),
      n = this.graph.isGridEnabledEvent(e);
  this.convertPoint(i, n), this.addPointAt(t, i.x, i.y), mxEvent.consume(e);
}, mxEdgeHandler.prototype.addPointAt = function (t, e, i) {
  var n = this.graph.getCellGeometry(t.cell);

  if (e = new mxPoint(e, i), null != n) {
    n = n.clone();
    var s = this.graph.view.translate;
    i = this.graph.view.scale;
    s = new mxPoint(s.x * i, s.y * i);
    var o = this.graph.model.getParent(this.state.cell);
    this.graph.model.isVertex(o) && (s = new mxPoint((s = this.graph.view.getState(o)).x, s.y)), i = mxUtils.findNearestSegment(t, e.x * i + s.x, e.y * i + s.y), null == n.points ? n.points = [e] : n.points.splice(i, 0, e), this.graph.getModel().setGeometry(t.cell, n), this.refresh(), this.redraw();
  }
}, mxEdgeHandler.prototype.removePoint = function (t, e) {
  if (0 < e && e < this.abspoints.length - 1) {
    var i = this.graph.getCellGeometry(this.state.cell);
    null != i && null != i.points && ((i = i.clone()).points.splice(e - 1, 1), this.graph.getModel().setGeometry(t.cell, i), this.refresh(), this.redraw());
  }
}, mxEdgeHandler.prototype.getHandleFillColor = function (t) {
  t = 0 == t;
  var e = this.state.cell,
      i = this.graph.getModel().getTerminal(e, t),
      n = mxConstants.HANDLE_FILLCOLOR;
  return null != i && !this.graph.isCellDisconnectable(e, i, t) || null == i && !this.graph.isTerminalPointMovable(e, t) ? n = mxConstants.LOCKED_HANDLE_FILLCOLOR : null != i && this.graph.isCellDisconnectable(e, i, t) && (n = mxConstants.CONNECT_HANDLE_FILLCOLOR), n;
}, mxEdgeHandler.prototype.redraw = function () {
  this.abspoints = this.state.absolutePoints.slice(), this.redrawHandles();
  var t = this.graph.getModel().getGeometry(this.state.cell).points;

  if (null != this.bends && 0 < this.bends.length && null != t) {
    null == this.points && (this.points = []);

    for (var e = 1; e < this.bends.length - 1; e++) {
      null != this.bends[e] && null != this.abspoints[e] && (this.points[e - 1] = t[e - 1]);
    }
  }

  this.drawPreview();
}, mxEdgeHandler.prototype.redrawHandles = function () {
  var t = this.state.cell,
      e = this.labelShape.bounds;

  if (this.label = new mxPoint(this.state.absoluteOffset.x, this.state.absoluteOffset.y), this.labelShape.bounds = new mxRectangle(Math.round(this.label.x - e.width / 2), Math.round(this.label.y - e.height / 2), e.width, e.height), e = this.graph.getLabel(t), this.labelShape.visible = null != e && 0 < e.length && this.graph.isLabelMovable(t), null != this.bends && 0 < this.bends.length) {
    var i = this.abspoints.length - 1,
        n = (t = this.abspoints[0]).x,
        s = t.y;
    e = this.bends[0].bounds;
    this.bends[0].bounds = new mxRectangle(Math.floor(n - e.width / 2), Math.floor(s - e.height / 2), e.width, e.height), this.bends[0].fill = this.getHandleFillColor(0), this.bends[0].redraw(), this.manageLabelHandle && this.checkLabelHandle(this.bends[0].bounds);
    n = (i = this.abspoints[i]).x, s = i.y;
    var o = this.bends.length - 1;
    e = this.bends[o].bounds;
    this.bends[o].bounds = new mxRectangle(Math.floor(n - e.width / 2), Math.floor(s - e.height / 2), e.width, e.height), this.bends[o].fill = this.getHandleFillColor(o), this.bends[o].redraw(), this.manageLabelHandle && this.checkLabelHandle(this.bends[o].bounds), this.redrawInnerBends(t, i);
  }

  if (null != this.abspoints && null != this.virtualBends && 0 < this.virtualBends.length) for (t = this.abspoints[0], i = 0; i < this.virtualBends.length; i++) {
    null != this.virtualBends[i] && null != this.abspoints[i + 1] && (n = this.abspoints[i + 1], (e = this.virtualBends[i]).bounds = new mxRectangle(Math.floor(t.x + (n.x - t.x) / 2 - e.bounds.width / 2), Math.floor(t.y + (n.y - t.y) / 2 - e.bounds.height / 2), e.bounds.width, e.bounds.height), e.redraw(), mxUtils.setOpacity(e.node, this.virtualBendOpacity), t = n, this.manageLabelHandle && this.checkLabelHandle(e.bounds));
  }
  if (null != this.labelShape && this.labelShape.redraw(), null != this.customHandles) for (i = 0; i < this.customHandles.length; i++) {
    this.customHandles[i].redraw();
  }
}, mxEdgeHandler.prototype.setHandlesVisible = function (t) {
  if (null != this.bends) for (var e = 0; e < this.bends.length; e++) {
    this.bends[e].node.style.display = t ? "" : "none";
  }
  if (null != this.virtualBends) for (e = 0; e < this.virtualBends.length; e++) {
    this.virtualBends[e].node.style.display = t ? "" : "none";
  }
  if (null != this.labelShape && (this.labelShape.node.style.display = t ? "" : "none"), null != this.customHandles) for (e = 0; e < this.customHandles.length; e++) {
    this.customHandles[e].setVisible(t);
  }
}, mxEdgeHandler.prototype.redrawInnerBends = function (t, e) {
  for (var i = 1; i < this.bends.length - 1; i++) {
    if (null != this.bends[i]) if (null != this.abspoints[i]) {
      var n = this.abspoints[i].x,
          s = this.abspoints[i].y,
          o = this.bends[i].bounds;
      this.bends[i].node.style.visibility = "visible", this.bends[i].bounds = new mxRectangle(Math.round(n - o.width / 2), Math.round(s - o.height / 2), o.width, o.height), this.manageLabelHandle ? this.checkLabelHandle(this.bends[i].bounds) : null == this.handleImage && this.labelShape.visible && mxUtils.intersects(this.bends[i].bounds, this.labelShape.bounds) && (w = mxConstants.HANDLE_SIZE + 3, h = mxConstants.HANDLE_SIZE + 3, this.bends[i].bounds = new mxRectangle(Math.round(n - w / 2), Math.round(s - h / 2), w, h)), this.bends[i].redraw();
    } else this.bends[i].destroy(), this.bends[i] = null;
  }
}, mxEdgeHandler.prototype.checkLabelHandle = function (t) {
  if (null != this.labelShape) {
    var e = this.labelShape.bounds;
    mxUtils.intersects(t, e) && (t.getCenterY() < e.getCenterY() ? e.y = t.y + t.height : e.y = t.y - e.height);
  }
}, mxEdgeHandler.prototype.drawPreview = function () {
  if (this.isLabel) {
    var t = this.labelShape.bounds;
    t = new mxRectangle(Math.round(this.label.x - t.width / 2), Math.round(this.label.y - t.height / 2), t.width, t.height);
    this.labelShape.bounds = t, this.labelShape.redraw();
  } else null != this.shape && (this.shape.apply(this.state), this.shape.points = this.abspoints, this.shape.scale = this.state.view.scale, this.shape.isDashed = this.isSelectionDashed(), this.shape.stroke = this.getSelectionColor(), this.shape.strokewidth = this.getSelectionStrokeWidth() / this.shape.scale / this.shape.scale, this.shape.isShadow = !1, this.shape.redraw());

  null != this.parentHighlight && this.parentHighlight.redraw();
}, mxEdgeHandler.prototype.refresh = function () {
  this.abspoints = this.getSelectionPoints(this.state), this.points = [], null != this.shape && (this.shape.points = this.abspoints), null != this.bends && (this.destroyBends(this.bends), this.bends = this.createBends()), null != this.virtualBends && (this.destroyBends(this.virtualBends), this.virtualBends = this.createVirtualBends()), null != this.customHandles && (this.destroyBends(this.customHandles), this.customHandles = this.createCustomHandles()), null != this.labelShape && null != this.labelShape.node && null != this.labelShape.node.parentNode && this.labelShape.node.parentNode.appendChild(this.labelShape.node);
}, mxEdgeHandler.prototype.destroyBends = function (t) {
  if (null != t) for (var e = 0; e < t.length; e++) {
    null != t[e] && t[e].destroy();
  }
}, mxEdgeHandler.prototype.destroy = function () {
  null != this.escapeHandler && (this.state.view.graph.removeListener(this.escapeHandler), this.escapeHandler = null), null != this.marker && (this.marker.destroy(), this.marker = null), null != this.shape && (this.shape.destroy(), this.shape = null), null != this.parentHighlight && (this.parentHighlight.destroy(), this.parentHighlight = null), null != this.labelShape && (this.labelShape.destroy(), this.labelShape = null), null != this.constraintHandler && (this.constraintHandler.destroy(), this.constraintHandler = null), this.destroyBends(this.virtualBends), this.virtualBends = null, this.destroyBends(this.customHandles), this.customHandles = null, this.destroyBends(this.bends), this.bends = null, this.removeHint();
}, mxUtils.extend(mxElbowEdgeHandler, mxEdgeHandler), mxElbowEdgeHandler.prototype.flipEnabled = !0, mxElbowEdgeHandler.prototype.doubleClickOrientationResource = "none" != mxClient.language ? "doubleClickOrientation" : "", mxElbowEdgeHandler.prototype.createBends = function () {
  var t = [],
      e = this.createHandleShape(0);
  return this.initBend(e), e.setCursor(mxConstants.CURSOR_TERMINAL_HANDLE), t.push(e), t.push(this.createVirtualBend(mxUtils.bind(this, function (t) {
    !mxEvent.isConsumed(t) && this.flipEnabled && (this.graph.flipEdge(this.state.cell, t), mxEvent.consume(t));
  }))), this.points.push(new mxPoint(0, 0)), e = this.createHandleShape(2), this.initBend(e), e.setCursor(mxConstants.CURSOR_TERMINAL_HANDLE), t.push(e), t;
}, mxElbowEdgeHandler.prototype.createVirtualBend = function (t) {
  var e = this.createHandleShape();
  return this.initBend(e, t), e.setCursor(this.getCursorForBend()), this.graph.isCellBendable(this.state.cell) || (e.node.style.display = "none"), e;
}, mxElbowEdgeHandler.prototype.getCursorForBend = function () {
  return this.state.style[mxConstants.STYLE_EDGE] == mxEdgeStyle.TopToBottom || this.state.style[mxConstants.STYLE_EDGE] == mxConstants.EDGESTYLE_TOPTOBOTTOM || (this.state.style[mxConstants.STYLE_EDGE] == mxEdgeStyle.ElbowConnector || this.state.style[mxConstants.STYLE_EDGE] == mxConstants.EDGESTYLE_ELBOW) && this.state.style[mxConstants.STYLE_ELBOW] == mxConstants.ELBOW_VERTICAL ? "row-resize" : "col-resize";
}, mxElbowEdgeHandler.prototype.getTooltipForNode = function (t) {
  var e = null;
  return null == this.bends || null == this.bends[1] || t != this.bends[1].node && t.parentNode != this.bends[1].node || (e = this.doubleClickOrientationResource, e = mxResources.get(e) || e), e;
}, mxElbowEdgeHandler.prototype.convertPoint = function (t, e) {
  var i = this.graph.getView().getScale(),
      n = this.graph.getView().getTranslate(),
      s = this.state.origin;
  return e && (t.x = this.graph.snap(t.x), t.y = this.graph.snap(t.y)), t.x = Math.round(t.x / i - n.x - s.x), t.y = Math.round(t.y / i - n.y - s.y), t;
}, mxElbowEdgeHandler.prototype.redrawInnerBends = function (t, e) {
  var i = this.graph.getModel().getGeometry(this.state.cell),
      n = this.state.absolutePoints,
      s = null;
  1 < n.length ? (t = n[1], e = n[n.length - 2]) : null != i.points && 0 < i.points.length && (s = n[0]), s = null == s ? new mxPoint(t.x + (e.x - t.x) / 2, t.y + (e.y - t.y) / 2) : new mxPoint(this.graph.getView().scale * (s.x + this.graph.getView().translate.x + this.state.origin.x), this.graph.getView().scale * (s.y + this.graph.getView().translate.y + this.state.origin.y)), i = (n = this.bends[1].bounds).width, n = n.height, i = new mxRectangle(Math.round(s.x - i / 2), Math.round(s.y - n / 2), i, n), this.manageLabelHandle ? this.checkLabelHandle(i) : null == this.handleImage && this.labelShape.visible && mxUtils.intersects(i, this.labelShape.bounds) && (i = mxConstants.HANDLE_SIZE + 3, n = mxConstants.HANDLE_SIZE + 3, i = new mxRectangle(Math.floor(s.x - i / 2), Math.floor(s.y - n / 2), i, n)), this.bends[1].bounds = i, this.bends[1].redraw(), this.manageLabelHandle && this.checkLabelHandle(this.bends[1].bounds);
}, mxUtils.extend(mxEdgeSegmentHandler, mxElbowEdgeHandler), mxEdgeSegmentHandler.prototype.getCurrentPoints = function () {
  if (null != (i = this.state.absolutePoints)) {
    var t = Math.max(1, this.graph.view.scale);

    if (2 == i.length || 3 == i.length && (Math.abs(i[0].x - i[1].x) < t && Math.abs(i[1].x - i[2].x) < t || Math.abs(i[0].y - i[1].y) < t && Math.abs(i[1].y - i[2].y) < t)) {
      t = i[0].x + (i[i.length - 1].x - i[0].x) / 2;
      var e = i[0].y + (i[i.length - 1].y - i[0].y) / 2,
          i = [i[0], new mxPoint(t, e), new mxPoint(t, e), i[i.length - 1]];
    }
  }

  return i;
}, mxEdgeSegmentHandler.prototype.getPreviewPoints = function (t) {
  if (this.isSource || this.isTarget) return mxElbowEdgeHandler.prototype.getPreviewPoints.apply(this, arguments);
  var e = this.getCurrentPoints(),
      i = this.convertPoint(e[0].clone(), !1);
  t = this.convertPoint(t.clone(), !1);

  for (var n = [], s = 1; s < e.length; s++) {
    var o = this.convertPoint(e[s].clone(), !1);
    s == this.index && (0 == Math.round(i.x - o.x) && (i.x = t.x, o.x = t.x), 0 == Math.round(i.y - o.y) && (i.y = t.y, o.y = t.y)), s < e.length - 1 && n.push(o), i = o;
  }

  if (1 == n.length) {
    e = this.state.getVisibleTerminalState(!0), i = this.state.getVisibleTerminalState(!1), o = this.state.view.getScale();
    var l = this.state.view.getTranslate();
    s = n[0].x * o + l.x, o = n[0].y * o + l.y;
    (null != e && mxUtils.contains(e, s, o) || null != i && mxUtils.contains(i, s, o)) && (n = [t, t]);
  }

  return n;
}, mxEdgeSegmentHandler.prototype.updatePreviewState = function (t, e, i, n) {
  if (mxEdgeHandler.prototype.updatePreviewState.apply(this, arguments), !this.isSource && !this.isTarget) {
    e = this.convertPoint(e.clone(), !1);

    for (var s = (h = t.absolutePoints)[0], o = h[1], l = [], r = 2; r < h.length; r++) {
      var a = h[r];
      0 == Math.round(s.x - o.x) && 0 == Math.round(o.x - a.x) || 0 == Math.round(s.y - o.y) && 0 == Math.round(o.y - a.y) || l.push(this.convertPoint(o.clone(), !1)), s = o, o = a;
    }

    if (s = this.state.getVisibleTerminalState(!0), o = this.state.getVisibleTerminalState(!1), r = this.state.absolutePoints, 0 != l.length || 0 != Math.round(h[0].x - h[h.length - 1].x) && 0 != Math.round(h[0].y - h[h.length - 1].y)) {
      if (5 == h.length && 2 == l.length && null != s && null != o && null != r && 0 == Math.round(r[0].x - r[r.length - 1].x)) {
        r = (l = this.graph.getView()).getScale(), a = l.getTranslate();
        var h = l.getRoutingCenterY(s) / r - a.y,
            u = this.graph.getConnectionConstraint(t, s, !0);
        null != u && null != (u = this.graph.getConnectionPoint(s, u)) && (this.convertPoint(u, !1), h = u.y), l = l.getRoutingCenterY(o) / r - a.y, (r = this.graph.getConnectionConstraint(t, o, !1)) && null != (u = this.graph.getConnectionPoint(o, r)) && (this.convertPoint(u, !1), l = u.y), l = [new mxPoint(e.x, h), new mxPoint(e.x, l)];
      }
    } else l = [e, e];

    this.points = l, t.view.updateFixedTerminalPoints(t, s, o), t.view.updatePoints(t, this.points, s, o), t.view.updateFloatingTerminalPoints(t, s, o);
  }
}, mxEdgeSegmentHandler.prototype.connect = function (t, e, i, n, s) {
  var o = this.graph.getModel(),
      l = o.getGeometry(t),
      r = null;
  if (null != l && null != l.points && 0 < l.points.length) for (var a = this.abspoints, h = a[0], u = a[1], d = (r = [], 2); d < a.length; d++) {
    var p = a[d];
    0 == Math.round(h.x - u.x) && 0 == Math.round(u.x - p.x) || 0 == Math.round(h.y - u.y) && 0 == Math.round(u.y - p.y) || r.push(this.convertPoint(u.clone(), !1)), h = u, u = p;
  }
  o.beginUpdate();

  try {
    null != r && null != (l = o.getGeometry(t)) && ((l = l.clone()).points = r, o.setGeometry(t, l)), t = mxEdgeHandler.prototype.connect.apply(this, arguments);
  } finally {
    o.endUpdate();
  }

  return t;
}, mxEdgeSegmentHandler.prototype.getTooltipForNode = function (t) {
  return null;
}, mxEdgeSegmentHandler.prototype.start = function (t, e, i) {
  mxEdgeHandler.prototype.start.apply(this, arguments), null == this.bends || null == this.bends[i] || this.isSource || this.isTarget || mxUtils.setOpacity(this.bends[i].node, 100);
}, mxEdgeSegmentHandler.prototype.createBends = function () {
  var t = [],
      e = this.createHandleShape(0);
  this.initBend(e), e.setCursor(mxConstants.CURSOR_TERMINAL_HANDLE), t.push(e);
  var i = this.getCurrentPoints();

  if (this.graph.isCellBendable(this.state.cell)) {
    null == this.points && (this.points = []);

    for (var n = 0; n < i.length - 1; n++) {
      e = this.createVirtualBend(), t.push(e);
      var s = 0 == Math.round(i[n].x - i[n + 1].x);
      0 == Math.round(i[n].y - i[n + 1].y) && n < i.length - 2 && (s = 0 == Math.round(i[n].x - i[n + 2].x)), e.setCursor(s ? "col-resize" : "row-resize"), this.points.push(new mxPoint(0, 0));
    }
  }

  return e = this.createHandleShape(i.length), this.initBend(e), e.setCursor(mxConstants.CURSOR_TERMINAL_HANDLE), t.push(e), t;
}, mxEdgeSegmentHandler.prototype.redraw = function () {
  this.refresh(), mxEdgeHandler.prototype.redraw.apply(this, arguments);
}, mxEdgeSegmentHandler.prototype.redrawInnerBends = function (t, e) {
  if (this.graph.isCellBendable(this.state.cell)) {
    var i = this.getCurrentPoints();

    if (null != i && 1 < i.length) {
      var n = !1;
      if (4 == i.length && 0 == Math.round(i[1].x - i[2].x) && 0 == Math.round(i[1].y - i[2].y)) if (n = !0, 0 == Math.round(i[0].y - i[i.length - 1].y)) {
        var s = i[0].x + (i[i.length - 1].x - i[0].x) / 2;
        i[1] = new mxPoint(s, i[1].y), i[2] = new mxPoint(s, i[2].y);
      } else s = i[0].y + (i[i.length - 1].y - i[0].y) / 2, i[1] = new mxPoint(i[1].x, s), i[2] = new mxPoint(i[2].x, s);

      for (s = 0; s < i.length - 1; s++) {
        if (null != this.bends[s + 1]) {
          t = i[s], e = i[s + 1];
          var o = new mxPoint(t.x + (e.x - t.x) / 2, t.y + (e.y - t.y) / 2),
              l = this.bends[s + 1].bounds;
          this.bends[s + 1].bounds = new mxRectangle(Math.floor(o.x - l.width / 2), Math.floor(o.y - l.height / 2), l.width, l.height), this.bends[s + 1].redraw(), this.manageLabelHandle && this.checkLabelHandle(this.bends[s + 1].bounds);
        }
      }

      n && (mxUtils.setOpacity(this.bends[1].node, this.virtualBendOpacity), mxUtils.setOpacity(this.bends[3].node, this.virtualBendOpacity));
    }
  }
}, mxKeyHandler.prototype.graph = null, mxKeyHandler.prototype.target = null, mxKeyHandler.prototype.normalKeys = null, mxKeyHandler.prototype.shiftKeys = null, mxKeyHandler.prototype.controlKeys = null, mxKeyHandler.prototype.controlShiftKeys = null, mxKeyHandler.prototype.enabled = !0, mxKeyHandler.prototype.isEnabled = function () {
  return this.enabled;
}, mxKeyHandler.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxKeyHandler.prototype.bindKey = function (t, e) {
  this.normalKeys[t] = e;
}, mxKeyHandler.prototype.bindShiftKey = function (t, e) {
  this.shiftKeys[t] = e;
}, mxKeyHandler.prototype.bindControlKey = function (t, e) {
  this.controlKeys[t] = e;
}, mxKeyHandler.prototype.bindControlShiftKey = function (t, e) {
  this.controlShiftKeys[t] = e;
}, mxKeyHandler.prototype.isControlDown = function (t) {
  return mxEvent.isControlDown(t);
}, mxKeyHandler.prototype.getFunction = function (t) {
  return null == t || mxEvent.isAltDown(t) ? null : this.isControlDown(t) ? mxEvent.isShiftDown(t) ? this.controlShiftKeys[t.keyCode] : this.controlKeys[t.keyCode] : mxEvent.isShiftDown(t) ? this.shiftKeys[t.keyCode] : this.normalKeys[t.keyCode];
}, mxKeyHandler.prototype.isGraphEvent = function (t) {
  var e = mxEvent.getSource(t);
  return !!(e == this.target || e.parentNode == this.target || null != this.graph.cellEditor && this.graph.cellEditor.isEventSource(t)) || mxUtils.isAncestorNode(this.graph.container, e);
}, mxKeyHandler.prototype.keyDown = function (t) {
  if (this.isEnabledForEvent(t)) if (27 == t.keyCode) this.escape(t);else if (!this.isEventIgnored(t)) {
    var e = this.getFunction(t);
    null != e && (e(t), mxEvent.consume(t));
  }
}, mxKeyHandler.prototype.isEnabledForEvent = function (t) {
  return this.graph.isEnabled() && !mxEvent.isConsumed(t) && this.isGraphEvent(t) && this.isEnabled();
}, mxKeyHandler.prototype.isEventIgnored = function (t) {
  return this.graph.isEditing();
}, mxKeyHandler.prototype.escape = function (t) {
  this.graph.isEscapeEnabled() && this.graph.escape(t);
}, mxKeyHandler.prototype.destroy = function () {
  null != this.target && null != this.keydownHandler && (mxEvent.removeListener(this.target, "keydown", this.keydownHandler), this.keydownHandler = null), this.target = null;
}, mxTooltipHandler.prototype.zIndex = 10005, mxTooltipHandler.prototype.graph = null, mxTooltipHandler.prototype.delay = null, mxTooltipHandler.prototype.ignoreTouchEvents = !0, mxTooltipHandler.prototype.hideOnHover = !1, mxTooltipHandler.prototype.destroyed = !1, mxTooltipHandler.prototype.enabled = !0, mxTooltipHandler.prototype.isEnabled = function () {
  return this.enabled;
}, mxTooltipHandler.prototype.setEnabled = function (t) {
  this.enabled = t;
}, mxTooltipHandler.prototype.isHideOnHover = function () {
  return this.hideOnHover;
}, mxTooltipHandler.prototype.setHideOnHover = function (t) {
  this.hideOnHover = t;
}, mxTooltipHandler.prototype.init = function () {
  null != document.body && (this.div = document.createElement("div"), this.div.className = "mxTooltip", this.div.style.visibility = "hidden", document.body.appendChild(this.div), mxEvent.addGestureListeners(this.div, mxUtils.bind(this, function (t) {
    this.hideTooltip();
  })));
}, mxTooltipHandler.prototype.getStateForEvent = function (t) {
  return t.getState();
}, mxTooltipHandler.prototype.mouseDown = function (t, e) {
  this.reset(e, !1), this.hideTooltip();
}, mxTooltipHandler.prototype.mouseMove = function (t, e) {
  if (e.getX() != this.lastX || e.getY() != this.lastY) {
    this.reset(e, !0);
    var i = this.getStateForEvent(e);
    (this.isHideOnHover() || i != this.state || e.getSource() != this.node && (!this.stateSource || null != i && this.stateSource == (e.isSource(i.shape) || !e.isSource(i.text)))) && this.hideTooltip();
  }

  this.lastX = e.getX(), this.lastY = e.getY();
}, mxTooltipHandler.prototype.mouseUp = function (t, e) {
  this.reset(e, !0), this.hideTooltip();
}, mxTooltipHandler.prototype.resetTimer = function () {
  null != this.thread && (window.clearTimeout(this.thread), this.thread = null);
}, mxTooltipHandler.prototype.reset = function (t, e, i) {
  if ((!this.ignoreTouchEvents || mxEvent.isMouseEvent(t.getEvent())) && (this.resetTimer(), i = null != i ? i : this.getStateForEvent(t), e && this.isEnabled() && null != i && (null == this.div || "hidden" == this.div.style.visibility))) {
    var n = t.getSource(),
        s = t.getX(),
        o = t.getY(),
        l = t.isSource(i.shape) || t.isSource(i.text);
    this.thread = window.setTimeout(mxUtils.bind(this, function () {
      if (!this.graph.isEditing() && !this.graph.popupMenuHandler.isMenuShowing() && !this.graph.isMouseDown) {
        var t = this.graph.getTooltip(i, n, s, o);
        this.show(t, s, o), this.state = i, this.node = n, this.stateSource = l;
      }
    }), this.delay);
  }
}, mxTooltipHandler.prototype.hide = function () {
  this.resetTimer(), this.hideTooltip();
}, mxTooltipHandler.prototype.hideTooltip = function () {
  null != this.div && (this.div.style.visibility = "hidden", this.div.innerHTML = "");
}, mxTooltipHandler.prototype.show = function (t, e, i) {
  if (!this.destroyed && null != t && 0 < t.length) {
    null == this.div && this.init();
    var n = mxUtils.getScrollOrigin();
    this.div.style.zIndex = this.zIndex, this.div.style.left = e + n.x + "px", this.div.style.top = i + mxConstants.TOOLTIP_VERTICAL_OFFSET + n.y + "px", mxUtils.isNode(t) ? (this.div.innerHTML = "", this.div.appendChild(t)) : this.div.innerHTML = t.replace(/\n/g, "<br>"), this.div.style.visibility = "", mxUtils.fit(this.div);
  }
}, mxTooltipHandler.prototype.destroy = function () {
  this.destroyed || (this.graph.removeMouseListener(this), mxEvent.release(this.div), null != this.div && null != this.div.parentNode && this.div.parentNode.removeChild(this.div), this.destroyed = !0, this.div = null);
}, mxUtils.extend(mxCellTracker, mxCellMarker), mxCellTracker.prototype.mouseDown = function (t, e) {}, mxCellTracker.prototype.mouseMove = function (t, e) {
  this.isEnabled() && this.process(e);
}, mxCellTracker.prototype.mouseUp = function (t, e) {}, mxCellTracker.prototype.destroy = function () {
  this.destroyed || (this.destroyed = !0, this.graph.removeMouseListener(this), mxCellMarker.prototype.destroy.apply(this));
}, mxCellHighlight.prototype.keepOnTop = !1, mxCellHighlight.prototype.graph = !0, mxCellHighlight.prototype.state = null, mxCellHighlight.prototype.spacing = 2, mxCellHighlight.prototype.resetHandler = null, mxCellHighlight.prototype.setHighlightColor = function (t) {
  this.highlightColor = t, null != this.shape && (this.shape.stroke = t);
}, mxCellHighlight.prototype.drawHighlight = function () {
  this.shape = this.createShape(), this.repaint(), this.keepOnTop || this.shape.node.parentNode.firstChild == this.shape.node || this.shape.node.parentNode.insertBefore(this.shape.node, this.shape.node.parentNode.firstChild);
}, mxCellHighlight.prototype.createShape = function () {
  var t = this.graph.cellRenderer.createShape(this.state);
  return t.svgStrokeTolerance = this.graph.tolerance, t.points = this.state.absolutePoints, t.apply(this.state), t.stroke = this.highlightColor, t.opacity = this.opacity, t.isDashed = this.dashed, t.isShadow = !1, t.dialect = this.graph.dialect != mxConstants.DIALECT_SVG ? mxConstants.DIALECT_VML : mxConstants.DIALECT_SVG, t.init(this.graph.getView().getOverlayPane()), mxEvent.redirectMouseEvents(t.node, this.graph, this.state), this.graph.dialect != mxConstants.DIALECT_SVG ? t.pointerEvents = !1 : t.svgPointerEvents = "stroke", t;
}, mxCellHighlight.prototype.getStrokeWidth = function (t) {
  return this.strokeWidth;
}, mxCellHighlight.prototype.repaint = function () {
  null != this.state && null != this.shape && (this.shape.scale = this.state.view.scale, this.graph.model.isEdge(this.state.cell) ? (this.shape.strokewidth = this.getStrokeWidth(), this.shape.points = this.state.absolutePoints, this.shape.outline = !1) : (this.shape.bounds = new mxRectangle(this.state.x - this.spacing, this.state.y - this.spacing, this.state.width + 2 * this.spacing, this.state.height + 2 * this.spacing), this.shape.rotation = Number(this.state.style[mxConstants.STYLE_ROTATION] || "0"), this.shape.strokewidth = this.getStrokeWidth() / this.state.view.scale, this.shape.outline = !0), null != this.state.shape && this.shape.setCursor(this.state.shape.getCursor()), (mxClient.IS_QUIRKS || 8 == document.documentMode) && ("transparent" == this.shape.stroke ? (this.shape.stroke = "white", this.shape.opacity = 1) : this.shape.opacity = this.opacity), this.shape.redraw());
}, mxCellHighlight.prototype.hide = function () {
  this.highlight(null);
}, mxCellHighlight.prototype.highlight = function (t) {
  this.state != t && (null != this.shape && (this.shape.destroy(), this.shape = null), this.state = t, null != this.state && this.drawHighlight());
}, mxCellHighlight.prototype.isHighlightAt = function (t, e) {
  var i = !1;
  if (null != this.shape && null != document.elementFromPoint && !mxClient.IS_QUIRKS) for (var n = document.elementFromPoint(t, e); null != n;) {
    if (n == this.shape.node) {
      i = !0;
      break;
    }

    n = n.parentNode;
  }
  return i;
}, mxCellHighlight.prototype.destroy = function () {
  this.graph.getView().removeListener(this.resetHandler), this.graph.getView().removeListener(this.repaintHandler), this.graph.getModel().removeListener(this.repaintHandler), null != this.shape && (this.shape.destroy(), this.shape = null);
}, mxDefaultKeyHandler.prototype.editor = null, mxDefaultKeyHandler.prototype.handler = null, mxDefaultKeyHandler.prototype.bindAction = function (t, e, i) {
  var n = mxUtils.bind(this, function () {
    this.editor.execute(e);
  });
  i ? this.handler.bindControlKey(t, n) : this.handler.bindKey(t, n);
}, mxDefaultKeyHandler.prototype.destroy = function () {
  this.handler.destroy(), this.handler = null;
}, mxDefaultPopupMenu.prototype.imageBasePath = null, mxDefaultPopupMenu.prototype.config = null, mxDefaultPopupMenu.prototype.createMenu = function (t, e, i, n) {
  if (null != this.config) {
    var s = this.createConditions(t, i, n);
    this.addItems(t, e, i, n, s, this.config.firstChild, null);
  }
}, mxDefaultPopupMenu.prototype.addItems = function (t, e, i, n, s, o, l) {
  for (var r = !1; null != o;) {
    if ("add" == o.nodeName) {
      if (null == (a = o.getAttribute("if")) || s[a]) {
        var a = o.getAttribute("as"),
            h = (a = mxResources.get(a) || a, mxUtils.eval(mxUtils.getTextContent(o))),
            u = o.getAttribute("action"),
            d = o.getAttribute("icon"),
            p = o.getAttribute("iconCls"),
            c = null == (c = o.getAttribute("enabled-if")) || s[c];
        r && (e.addSeparator(l), r = !1), null != d && this.imageBasePath && (d = this.imageBasePath + d), a = this.addAction(e, t, a, d, h, u, i, l, p, c), this.addItems(t, e, i, n, s, o.firstChild, a);
      }
    } else "separator" == o.nodeName && (r = !0);

    o = o.nextSibling;
  }
}, mxDefaultPopupMenu.prototype.addAction = function (t, e, i, n, s, o, l, r, a, h) {
  return t.addItem(i, n, function (t) {
    "function" == typeof s && s.call(e, e, l, t), null != o && e.execute(o, l, t);
  }, r, a, h);
}, mxDefaultPopupMenu.prototype.createConditions = function (t, e, i) {
  var n = t.graph.getModel(),
      s = n.getChildCount(e),
      o = [];

  for (o.nocell = null == e, o.ncells = 1 < t.graph.getSelectionCount(), o.notRoot = n.getRoot() != n.getParent(t.graph.getDefaultParent()), o.cell = null != e, n = null != e && 1 == t.graph.getSelectionCount(), o.nonEmpty = n && 0 < s, o.expandable = n && t.graph.isCellFoldable(e, !1), o.collapsable = n && t.graph.isCellFoldable(e, !0), o.validRoot = n && t.graph.isValidRoot(e), o.emptyValidRoot = o.validRoot && 0 == s, o.swimlane = n && t.graph.isSwimlane(e), s = this.config.getElementsByTagName("condition"), n = 0; n < s.length; n++) {
    var l = mxUtils.eval(mxUtils.getTextContent(s[n])),
        r = s[n].getAttribute("name");
    null != r && "function" == typeof l && (o[r] = l(t, e, i));
  }

  return o;
}, mxDefaultToolbar.prototype.editor = null, mxDefaultToolbar.prototype.toolbar = null, mxDefaultToolbar.prototype.resetHandler = null, mxDefaultToolbar.prototype.spacing = 4, mxDefaultToolbar.prototype.connectOnDrop = !1, mxDefaultToolbar.prototype.init = function (t) {
  null != t && (this.toolbar = new mxToolbar(t), this.toolbar.addListener(mxEvent.SELECT, mxUtils.bind(this, function (t, e) {
    var i = e.getProperty("function");
    this.editor.insertFunction = null != i ? mxUtils.bind(this, function () {
      i.apply(this, arguments), this.toolbar.resetMode();
    }) : null;
  })), this.resetHandler = mxUtils.bind(this, function () {
    null != this.toolbar && this.toolbar.resetMode(!0);
  }), this.editor.graph.addListener(mxEvent.DOUBLE_CLICK, this.resetHandler), this.editor.addListener(mxEvent.ESCAPE, this.resetHandler));
}, mxDefaultToolbar.prototype.addItem = function (t, e, i, n) {
  var s = mxUtils.bind(this, function () {
    null != i && 0 < i.length && this.editor.execute(i);
  });
  return this.toolbar.addItem(t, e, s, n);
}, mxDefaultToolbar.prototype.addSeparator = function (t) {
  t = t || mxClient.imageBasePath + "/separator.gif", this.toolbar.addSeparator(t);
}, mxDefaultToolbar.prototype.addCombo = function () {
  return this.toolbar.addCombo();
}, mxDefaultToolbar.prototype.addActionCombo = function (t) {
  return this.toolbar.addActionCombo(t);
}, mxDefaultToolbar.prototype.addActionOption = function (t, e, i) {
  var n = mxUtils.bind(this, function () {
    this.editor.execute(i);
  });
  this.addOption(t, e, n);
}, mxDefaultToolbar.prototype.addOption = function (t, e, i) {
  return this.toolbar.addOption(t, e, i);
}, mxDefaultToolbar.prototype.addMode = function (t, e, i, n, s) {
  var o = mxUtils.bind(this, function () {
    this.editor.setMode(i), null != s && s(this.editor);
  });
  return this.toolbar.addSwitchMode(t, e, o, n);
}, mxDefaultToolbar.prototype.addPrototype = function (t, e, i, n, s, o) {
  var l = mxUtils.bind(this, function () {
    return "function" == typeof i ? i() : null != i ? this.editor.graph.cloneCell(i) : null;
  }),
      r = mxUtils.bind(this, function (t, e) {
    "function" == typeof s ? s(this.editor, l(), t, e) : this.drop(l(), t, e), this.toolbar.resetMode(), mxEvent.consume(t);
  });
  return t = this.toolbar.addMode(t, e, r, n, null, o), this.installDropHandler(t, function (t, e, i) {
    r(e, i);
  }), t;
}, mxDefaultToolbar.prototype.drop = function (t, e, i) {
  var n = this.editor.graph,
      s = n.getModel();
  if (null != i && !s.isEdge(i) && this.connectOnDrop && n.isCellConnectable(i)) this.connect(t, e, i);else {
    for (; null != i && !n.isValidDropTarget(i, [t], e);) {
      i = s.getParent(i);
    }

    this.insert(t, e, i);
  }
}, mxDefaultToolbar.prototype.insert = function (t, e, i) {
  var n = this.editor.graph;

  if (n.canImportCell(t)) {
    var s = mxEvent.getClientX(e),
        o = mxEvent.getClientY(e);
    s = mxUtils.convertPoint(n.container, s, o);
    return n.isSplitEnabled() && n.isSplitTarget(i, [t], e) ? n.splitEdge(i, [t], null, s.x, s.y) : this.editor.addVertex(i, t, s.x, s.y);
  }

  return null;
}, mxDefaultToolbar.prototype.connect = function (t, e, i) {
  var n = (e = this.editor.graph).getModel();

  if (null != i && e.isCellConnectable(t) && e.isEdgeValid(null, i, t)) {
    var s = null;
    n.beginUpdate();

    try {
      var o = n.getGeometry(i),
          l = n.getGeometry(t).clone();
      l.x = o.x + (o.width - l.width) / 2, l.y = o.y + (o.height - l.height) / 2;
      var r = this.spacing * e.gridSize,
          a = 20 * n.getDirectedEdgeCount(i, !0);
      this.editor.horizontalFlow ? l.x += (l.width + o.width) / 2 + r + a : l.y += (l.height + o.height) / 2 + r + a, t.setGeometry(l);
      var h = n.getParent(i);

      if (e.addCell(t, h), e.constrainChild(t), s = this.editor.createEdge(i, t), null == n.getGeometry(s)) {
        var u = new mxGeometry();
        u.relative = !0, n.setGeometry(s, u);
      }

      e.addEdge(s, h, i, t);
    } finally {
      n.endUpdate();
    }

    e.setSelectionCells([t, s]), e.scrollCellToVisible(t);
  }
}, mxDefaultToolbar.prototype.installDropHandler = function (t, e) {
  var i = document.createElement("img");
  i.setAttribute("src", t.getAttribute("src"));
  var n = mxUtils.bind(this, function (s) {
    i.style.width = 2 * t.offsetWidth + "px", i.style.height = 2 * t.offsetHeight + "px", mxUtils.makeDraggable(t, this.editor.graph, e, i), mxEvent.removeListener(i, "load", n);
  });
  mxClient.IS_IE ? n() : mxEvent.addListener(i, "load", n);
}, mxDefaultToolbar.prototype.destroy = function () {
  null != this.resetHandler && (this.editor.graph.removeListener("dblclick", this.resetHandler), this.editor.removeListener("escape", this.resetHandler), this.resetHandler = null), null != this.toolbar && (this.toolbar.destroy(), this.toolbar = null);
}, mxLoadResources ? mxResources.add(mxClient.basePath + "/resources/editor") : mxClient.defaultBundles.push(mxClient.basePath + "/resources/editor"), mxEditor.prototype = new mxEventSource(), mxEditor.prototype.constructor = mxEditor, mxEditor.prototype.askZoomResource = "none" != mxClient.language ? "askZoom" : "", mxEditor.prototype.lastSavedResource = "none" != mxClient.language ? "lastSaved" : "", mxEditor.prototype.currentFileResource = "none" != mxClient.language ? "currentFile" : "", mxEditor.prototype.propertiesResource = "none" != mxClient.language ? "properties" : "", mxEditor.prototype.tasksResource = "none" != mxClient.language ? "tasks" : "", mxEditor.prototype.helpResource = "none" != mxClient.language ? "help" : "", mxEditor.prototype.outlineResource = "none" != mxClient.language ? "outline" : "", mxEditor.prototype.outline = null, mxEditor.prototype.graph = null, mxEditor.prototype.graphRenderHint = null, mxEditor.prototype.toolbar = null, mxEditor.prototype.status = null, mxEditor.prototype.popupHandler = null, mxEditor.prototype.undoManager = null, mxEditor.prototype.keyHandler = null, mxEditor.prototype.actions = null, mxEditor.prototype.dblClickAction = "edit", mxEditor.prototype.swimlaneRequired = !1, mxEditor.prototype.disableContextMenu = !0, mxEditor.prototype.insertFunction = null, mxEditor.prototype.forcedInserting = !1, mxEditor.prototype.templates = null, mxEditor.prototype.defaultEdge = null, mxEditor.prototype.defaultEdgeStyle = null, mxEditor.prototype.defaultGroup = null, mxEditor.prototype.groupBorderSize = null, mxEditor.prototype.filename = null, mxEditor.prototype.linefeed = "&#xa;", mxEditor.prototype.postParameterName = "xml", mxEditor.prototype.escapePostData = !0, mxEditor.prototype.urlPost = null, mxEditor.prototype.urlImage = null, mxEditor.prototype.horizontalFlow = !1, mxEditor.prototype.layoutDiagram = !1, mxEditor.prototype.swimlaneSpacing = 0, mxEditor.prototype.maintainSwimlanes = !1, mxEditor.prototype.layoutSwimlanes = !1, mxEditor.prototype.cycleAttributeValues = null, mxEditor.prototype.cycleAttributeIndex = 0, mxEditor.prototype.cycleAttributeName = "fillColor", mxEditor.prototype.tasks = null, mxEditor.prototype.tasksWindowImage = null, mxEditor.prototype.tasksTop = 20, mxEditor.prototype.help = null, mxEditor.prototype.helpWindowImage = null, mxEditor.prototype.urlHelp = null, mxEditor.prototype.helpWidth = 300, mxEditor.prototype.helpHeight = 260, mxEditor.prototype.propertiesWidth = 240, mxEditor.prototype.propertiesHeight = null, mxEditor.prototype.movePropertiesDialog = !1, mxEditor.prototype.validating = !1, mxEditor.prototype.modified = !1, mxEditor.prototype.isModified = function () {
  return this.modified;
}, mxEditor.prototype.setModified = function (t) {
  this.modified = t;
}, mxEditor.prototype.addActions = function () {
  this.addAction("save", function (t) {
    t.save();
  }), this.addAction("print", function (t) {
    new mxPrintPreview(t.graph, 1).open();
  }), this.addAction("show", function (t) {
    mxUtils.show(t.graph, null, 10, 10);
  }), this.addAction("exportImage", function (t) {
    var e = t.getUrlImage();
    if (null == e || mxClient.IS_LOCAL) t.execute("show");else {
      var i = mxUtils.getViewXml(t.graph, 1);
      i = mxUtils.getXml(i, "\n");
      mxUtils.submit(e, t.postParameterName + "=" + encodeURIComponent(i), document, "_blank");
    }
  }), this.addAction("refresh", function (t) {
    t.graph.refresh();
  }), this.addAction("cut", function (t) {
    t.graph.isEnabled() && mxClipboard.cut(t.graph);
  }), this.addAction("copy", function (t) {
    t.graph.isEnabled() && mxClipboard.copy(t.graph);
  }), this.addAction("paste", function (t) {
    t.graph.isEnabled() && mxClipboard.paste(t.graph);
  }), this.addAction("delete", function (t) {
    t.graph.isEnabled() && t.graph.removeCells();
  }), this.addAction("group", function (t) {
    t.graph.isEnabled() && t.graph.setSelectionCell(t.groupCells());
  }), this.addAction("ungroup", function (t) {
    t.graph.isEnabled() && t.graph.setSelectionCells(t.graph.ungroupCells());
  }), this.addAction("removeFromParent", function (t) {
    t.graph.isEnabled() && t.graph.removeCellsFromParent();
  }), this.addAction("undo", function (t) {
    t.graph.isEnabled() && t.undo();
  }), this.addAction("redo", function (t) {
    t.graph.isEnabled() && t.redo();
  }), this.addAction("zoomIn", function (t) {
    t.graph.zoomIn();
  }), this.addAction("zoomOut", function (t) {
    t.graph.zoomOut();
  }), this.addAction("actualSize", function (t) {
    t.graph.zoomActual();
  }), this.addAction("fit", function (t) {
    t.graph.fit();
  }), this.addAction("showProperties", function (t, e) {
    t.showProperties(e);
  }), this.addAction("selectAll", function (t) {
    t.graph.isEnabled() && t.graph.selectAll();
  }), this.addAction("selectNone", function (t) {
    t.graph.isEnabled() && t.graph.clearSelection();
  }), this.addAction("selectVertices", function (t) {
    t.graph.isEnabled() && t.graph.selectVertices();
  }), this.addAction("selectEdges", function (t) {
    t.graph.isEnabled() && t.graph.selectEdges();
  }), this.addAction("edit", function (t, e) {
    t.graph.isEnabled() && t.graph.isCellEditable(e) && t.graph.startEditingAtCell(e);
  }), this.addAction("toBack", function (t, e) {
    t.graph.isEnabled() && t.graph.orderCells(!0);
  }), this.addAction("toFront", function (t, e) {
    t.graph.isEnabled() && t.graph.orderCells(!1);
  }), this.addAction("enterGroup", function (t, e) {
    t.graph.enterGroup(e);
  }), this.addAction("exitGroup", function (t) {
    t.graph.exitGroup();
  }), this.addAction("home", function (t) {
    t.graph.home();
  }), this.addAction("selectPrevious", function (t) {
    t.graph.isEnabled() && t.graph.selectPreviousCell();
  }), this.addAction("selectNext", function (t) {
    t.graph.isEnabled() && t.graph.selectNextCell();
  }), this.addAction("selectParent", function (t) {
    t.graph.isEnabled() && t.graph.selectParentCell();
  }), this.addAction("selectChild", function (t) {
    t.graph.isEnabled() && t.graph.selectChildCell();
  }), this.addAction("collapse", function (t) {
    t.graph.isEnabled() && t.graph.foldCells(!0);
  }), this.addAction("collapseAll", function (t) {
    if (t.graph.isEnabled()) {
      var e = t.graph.getChildVertices();
      t.graph.foldCells(!0, !1, e);
    }
  }), this.addAction("expand", function (t) {
    t.graph.isEnabled() && t.graph.foldCells(!1);
  }), this.addAction("expandAll", function (t) {
    if (t.graph.isEnabled()) {
      var e = t.graph.getChildVertices();
      t.graph.foldCells(!1, !1, e);
    }
  }), this.addAction("bold", function (t) {
    t.graph.isEnabled() && t.graph.toggleCellStyleFlags(mxConstants.STYLE_FONTSTYLE, mxConstants.FONT_BOLD);
  }), this.addAction("italic", function (t) {
    t.graph.isEnabled() && t.graph.toggleCellStyleFlags(mxConstants.STYLE_FONTSTYLE, mxConstants.FONT_ITALIC);
  }), this.addAction("underline", function (t) {
    t.graph.isEnabled() && t.graph.toggleCellStyleFlags(mxConstants.STYLE_FONTSTYLE, mxConstants.FONT_UNDERLINE);
  }), this.addAction("alignCellsLeft", function (t) {
    t.graph.isEnabled() && t.graph.alignCells(mxConstants.ALIGN_LEFT);
  }), this.addAction("alignCellsCenter", function (t) {
    t.graph.isEnabled() && t.graph.alignCells(mxConstants.ALIGN_CENTER);
  }), this.addAction("alignCellsRight", function (t) {
    t.graph.isEnabled() && t.graph.alignCells(mxConstants.ALIGN_RIGHT);
  }), this.addAction("alignCellsTop", function (t) {
    t.graph.isEnabled() && t.graph.alignCells(mxConstants.ALIGN_TOP);
  }), this.addAction("alignCellsMiddle", function (t) {
    t.graph.isEnabled() && t.graph.alignCells(mxConstants.ALIGN_MIDDLE);
  }), this.addAction("alignCellsBottom", function (t) {
    t.graph.isEnabled() && t.graph.alignCells(mxConstants.ALIGN_BOTTOM);
  }), this.addAction("alignFontLeft", function (t) {
    t.graph.setCellStyles(mxConstants.STYLE_ALIGN, mxConstants.ALIGN_LEFT);
  }), this.addAction("alignFontCenter", function (t) {
    t.graph.isEnabled() && t.graph.setCellStyles(mxConstants.STYLE_ALIGN, mxConstants.ALIGN_CENTER);
  }), this.addAction("alignFontRight", function (t) {
    t.graph.isEnabled() && t.graph.setCellStyles(mxConstants.STYLE_ALIGN, mxConstants.ALIGN_RIGHT);
  }), this.addAction("alignFontTop", function (t) {
    t.graph.isEnabled() && t.graph.setCellStyles(mxConstants.STYLE_VERTICAL_ALIGN, mxConstants.ALIGN_TOP);
  }), this.addAction("alignFontMiddle", function (t) {
    t.graph.isEnabled() && t.graph.setCellStyles(mxConstants.STYLE_VERTICAL_ALIGN, mxConstants.ALIGN_MIDDLE);
  }), this.addAction("alignFontBottom", function (t) {
    t.graph.isEnabled() && t.graph.setCellStyles(mxConstants.STYLE_VERTICAL_ALIGN, mxConstants.ALIGN_BOTTOM);
  }), this.addAction("zoom", function (t) {
    var e = 100 * t.graph.getView().scale;
    e = parseFloat(mxUtils.prompt(mxResources.get(t.askZoomResource) || t.askZoomResource, e)) / 100;
    isNaN(e) || t.graph.getView().setScale(e);
  }), this.addAction("toggleTasks", function (t) {
    null != t.tasks ? t.tasks.setVisible(!t.tasks.isVisible()) : t.showTasks();
  }), this.addAction("toggleHelp", function (t) {
    null != t.help ? t.help.setVisible(!t.help.isVisible()) : t.showHelp();
  }), this.addAction("toggleOutline", function (t) {
    null == t.outline ? t.showOutline() : t.outline.setVisible(!t.outline.isVisible());
  }), this.addAction("toggleConsole", function (t) {
    mxLog.setVisible(!mxLog.isVisible());
  });
}, mxEditor.prototype.configure = function (t) {
  null != t && (new mxCodec(t.ownerDocument).decode(t, this), this.resetHistory());
}, mxEditor.prototype.resetFirstTime = function () {
  document.cookie = "mxgraph=seen; expires=Fri, 27 Jul 2001 02:47:11 UTC; path=/";
}, mxEditor.prototype.resetHistory = function () {
  this.lastSnapshot = new Date().getTime(), this.undoManager.clear(), this.ignoredChanges = 0, this.setModified(!1);
}, mxEditor.prototype.addAction = function (t, e) {
  this.actions[t] = e;
}, mxEditor.prototype.execute = function (t, e, i) {
  var n = this.actions[t];
  if (null != n) try {
    var s = arguments;
    s[0] = this, n.apply(this, s);
  } catch (e) {
    throw mxUtils.error("Cannot execute " + t + ": " + e.message, 280, !0), e;
  } else mxUtils.error("Cannot find action " + t, 280, !0);
}, mxEditor.prototype.addTemplate = function (t, e) {
  this.templates[t] = e;
}, mxEditor.prototype.getTemplate = function (t) {
  return this.templates[t];
}, mxEditor.prototype.createGraph = function () {
  var t = new mxGraph(null, null, this.graphRenderHint);
  return t.setTooltips(!0), t.setPanning(!0), this.installDblClickHandler(t), this.installUndoHandler(t), this.installDrillHandler(t), this.installChangeHandler(t), this.installInsertHandler(t), t.popupMenuHandler.factoryMethod = mxUtils.bind(this, function (t, e, i) {
    return this.createPopupMenu(t, e, i);
  }), t.connectionHandler.factoryMethod = mxUtils.bind(this, function (t, e) {
    return this.createEdge(t, e);
  }), this.createSwimlaneManager(t), this.createLayoutManager(t), t;
}, mxEditor.prototype.createSwimlaneManager = function (t) {
  return (t = new mxSwimlaneManager(t, !1)).isHorizontal = mxUtils.bind(this, function () {
    return this.horizontalFlow;
  }), t.isEnabled = mxUtils.bind(this, function () {
    return this.maintainSwimlanes;
  }), t;
}, mxEditor.prototype.createLayoutManager = function (t) {
  var e = new mxLayoutManager(t),
      i = this;
  return e.getLayout = function (e) {
    var n = null,
        s = i.graph.getModel();
    return null != s.getParent(e) && (i.layoutSwimlanes && t.isSwimlane(e) ? (null == i.swimlaneLayout && (i.swimlaneLayout = i.createSwimlaneLayout()), n = i.swimlaneLayout) : i.layoutDiagram && (t.isValidRoot(e) || null == s.getParent(s.getParent(e))) && (null == i.diagramLayout && (i.diagramLayout = i.createDiagramLayout()), n = i.diagramLayout)), n;
  }, e;
}, mxEditor.prototype.setGraphContainer = function (t) {
  null == this.graph.container && (this.graph.init(t), this.rubberband = new mxRubberband(this.graph), this.disableContextMenu && mxEvent.disableContextMenu(t), mxClient.IS_QUIRKS && new mxDivResizer(t));
}, mxEditor.prototype.installDblClickHandler = function (t) {
  t.addListener(mxEvent.DOUBLE_CLICK, mxUtils.bind(this, function (e, i) {
    var n = i.getProperty("cell");
    null != n && t.isEnabled() && null != this.dblClickAction && (this.execute(this.dblClickAction, n), i.consume());
  }));
}, mxEditor.prototype.installUndoHandler = function (t) {
  var e = mxUtils.bind(this, function (t, e) {
    var i = e.getProperty("edit");
    this.undoManager.undoableEditHappened(i);
  });
  t.getModel().addListener(mxEvent.UNDO, e), t.getView().addListener(mxEvent.UNDO, e), e = function e(_e2, i) {
    var n = i.getProperty("edit").changes;
    t.setSelectionCells(t.getSelectionCellsForChanges(n));
  }, this.undoManager.addListener(mxEvent.UNDO, e), this.undoManager.addListener(mxEvent.REDO, e);
}, mxEditor.prototype.installDrillHandler = function (t) {
  var e = mxUtils.bind(this, function (t) {
    this.fireEvent(new mxEventObject(mxEvent.ROOT));
  });
  t.getView().addListener(mxEvent.DOWN, e), t.getView().addListener(mxEvent.UP, e);
}, mxEditor.prototype.installChangeHandler = function (t) {
  var e = mxUtils.bind(this, function (e, i) {
    this.setModified(!0), 1 == this.validating && t.validateGraph();

    for (var n = i.getProperty("edit").changes, s = 0; s < n.length; s++) {
      var o = n[s];

      if (o instanceof mxRootChange || o instanceof mxValueChange && o.cell == this.graph.model.root || o instanceof mxCellAttributeChange && o.cell == this.graph.model.root) {
        this.fireEvent(new mxEventObject(mxEvent.ROOT));
        break;
      }
    }
  });
  t.getModel().addListener(mxEvent.CHANGE, e);
}, mxEditor.prototype.installInsertHandler = function (t) {
  var e = this;
  t.addMouseListener({
    mouseDown: function mouseDown(t, i) {
      null == e.insertFunction || i.isPopupTrigger() || !e.forcedInserting && null != i.getState() || (e.graph.clearSelection(), e.insertFunction(i.getEvent(), i.getCell()), this.isActive = !0, i.consume());
    },
    mouseMove: function mouseMove(t, e) {
      this.isActive && e.consume();
    },
    mouseUp: function mouseUp(t, e) {
      this.isActive && (this.isActive = !1, e.consume());
    }
  });
}, mxEditor.prototype.createDiagramLayout = function () {
  var t = this.graph.gridSize,
      e = new mxStackLayout(this.graph, !this.horizontalFlow, this.swimlaneSpacing, 2 * t, 2 * t);
  return e.isVertexIgnored = function (t) {
    return !e.graph.isSwimlane(t);
  }, e;
}, mxEditor.prototype.createSwimlaneLayout = function () {
  return new mxCompactTreeLayout(this.graph, this.horizontalFlow);
}, mxEditor.prototype.createToolbar = function () {
  return new mxDefaultToolbar(null, this);
}, mxEditor.prototype.setToolbarContainer = function (t) {
  this.toolbar.init(t), mxClient.IS_QUIRKS && new mxDivResizer(t);
}, mxEditor.prototype.setStatusContainer = function (t) {
  null == this.status && (this.status = t, this.addListener(mxEvent.SAVE, mxUtils.bind(this, function () {
    var t = new Date().toLocaleString();
    this.setStatus((mxResources.get(this.lastSavedResource) || this.lastSavedResource) + ": " + t);
  })), this.addListener(mxEvent.OPEN, mxUtils.bind(this, function () {
    this.setStatus((mxResources.get(this.currentFileResource) || this.currentFileResource) + ": " + this.filename);
  })), mxClient.IS_QUIRKS && new mxDivResizer(t));
}, mxEditor.prototype.setStatus = function (t) {
  null != this.status && null != t && (this.status.innerHTML = t);
}, mxEditor.prototype.setTitleContainer = function (t) {
  this.addListener(mxEvent.ROOT, mxUtils.bind(this, function (e) {
    t.innerHTML = this.getTitle();
  })), mxClient.IS_QUIRKS && new mxDivResizer(t);
}, mxEditor.prototype.treeLayout = function (t, e) {
  null != t && new mxCompactTreeLayout(this.graph, e).execute(t);
}, mxEditor.prototype.getTitle = function () {
  for (var t = "", e = this.graph, i = e.getCurrentRoot(); null != i && null != e.getModel().getParent(e.getModel().getParent(i));) {
    e.isValidRoot(i) && (t = " > " + e.convertValueToString(i) + t), i = e.getModel().getParent(i);
  }

  return this.getRootTitle() + t;
}, mxEditor.prototype.getRootTitle = function () {
  var t = this.graph.getModel().getRoot();
  return this.graph.convertValueToString(t);
}, mxEditor.prototype.undo = function () {
  this.undoManager.undo();
}, mxEditor.prototype.redo = function () {
  this.undoManager.redo();
}, mxEditor.prototype.groupCells = function () {
  var t = null != this.groupBorderSize ? this.groupBorderSize : this.graph.gridSize;
  return this.graph.groupCells(this.createGroup(), t);
}, mxEditor.prototype.createGroup = function () {
  return this.graph.getModel().cloneCell(this.defaultGroup);
}, mxEditor.prototype.open = function (t) {
  if (null != t) {
    var e = mxUtils.load(t).getXml();
    this.readGraphModel(e.documentElement), this.filename = t, this.fireEvent(new mxEventObject(mxEvent.OPEN, "filename", t));
  }
}, mxEditor.prototype.readGraphModel = function (t) {
  new mxCodec(t.ownerDocument).decode(t, this.graph.getModel()), this.resetHistory();
}, mxEditor.prototype.save = function (t, e) {
  if (null != (t = t || this.getUrlPost()) && 0 < t.length) {
    var i = this.writeGraphModel(e);
    this.postDiagram(t, i), this.setModified(!1);
  }

  this.fireEvent(new mxEventObject(mxEvent.SAVE, "url", t));
}, mxEditor.prototype.postDiagram = function (t, e) {
  this.escapePostData && (e = encodeURIComponent(e)), mxUtils.post(t, this.postParameterName + "=" + e, mxUtils.bind(this, function (i) {
    this.fireEvent(new mxEventObject(mxEvent.POST, "request", i, "url", t, "data", e));
  }));
}, mxEditor.prototype.writeGraphModel = function (t) {
  t = null != t ? t : this.linefeed;
  var e = new mxCodec().encode(this.graph.getModel());
  return mxUtils.getXml(e, t);
}, mxEditor.prototype.getUrlPost = function () {
  return this.urlPost;
}, mxEditor.prototype.getUrlImage = function () {
  return this.urlImage;
}, mxEditor.prototype.swapStyles = function (t, e) {
  var i = this.graph.getStylesheet().styles[e];
  this.graph.getView().getStylesheet().putCellStyle(e, this.graph.getStylesheet().styles[t]), this.graph.getStylesheet().putCellStyle(t, i), this.graph.refresh();
}, mxEditor.prototype.showProperties = function (t) {
  if (null == (t = t || this.graph.getSelectionCell()) && null == (t = this.graph.getCurrentRoot()) && (t = this.graph.getModel().getRoot()), null != t) {
    this.graph.stopEditing(!0);
    var e = (i = mxUtils.getOffset(this.graph.container)).x + 10,
        i = i.y;

    if (null == this.properties || this.movePropertiesDialog) {
      var n = this.graph.getCellBounds(t);
      null != n && (e += n.x + Math.min(200, n.width), i += n.y);
    } else e = this.properties.getX(), i = this.properties.getY();

    this.hideProperties(), null != (t = this.createProperties(t)) && (this.properties = new mxWindow(mxResources.get(this.propertiesResource) || this.propertiesResource, t, e, i, this.propertiesWidth, this.propertiesHeight, !1), this.properties.setVisible(!0));
  }
}, mxEditor.prototype.isPropertiesVisible = function () {
  return null != this.properties;
}, mxEditor.prototype.createProperties = function (t) {
  var e = this.graph.getModel(),
      i = e.getValue(t);

  if (mxUtils.isNode(i)) {
    var n = new mxForm("properties");
    n.addText("ID", t.getId()).setAttribute("readonly", "true");
    var s = null,
        o = null,
        l = null,
        r = null,
        a = null;
    e.isVertex(t) && null != (s = e.getGeometry(t)) && (o = n.addText("top", s.y), l = n.addText("left", s.x), r = n.addText("width", s.width), a = n.addText("height", s.height));
    var h = e.getStyle(t),
        u = n.addText("Style", h || ""),
        d = i.attributes,
        p = [];

    for (i = 0; i < d.length; i++) {
      p[i] = n.addTextarea(d[i].nodeName, d[i].value, "label" == d[i].nodeName ? 4 : 2);
    }

    return i = mxUtils.bind(this, function () {
      this.hideProperties(), e.beginUpdate();

      try {
        null != s && ((s = s.clone()).x = parseFloat(l.value), s.y = parseFloat(o.value), s.width = parseFloat(r.value), s.height = parseFloat(a.value), e.setGeometry(t, s)), 0 < u.value.length ? e.setStyle(t, u.value) : e.setStyle(t, null);

        for (var i = 0; i < d.length; i++) {
          var n = new mxCellAttributeChange(t, d[i].nodeName, p[i].value);
          e.execute(n);
        }

        this.graph.isAutoSizeCell(t) && this.graph.updateCellSize(t);
      } finally {
        e.endUpdate();
      }
    }), h = mxUtils.bind(this, function () {
      this.hideProperties();
    }), n.addButtons(i, h), n.table;
  }

  return null;
}, mxEditor.prototype.hideProperties = function () {
  null != this.properties && (this.properties.destroy(), this.properties = null);
}, mxEditor.prototype.showTasks = function () {
  if (null == this.tasks) {
    var t = document.createElement("div");
    t.style.padding = "4px", t.style.paddingLeft = "20px";
    var e = document.body.clientWidth;
    (e = new mxWindow(mxResources.get(this.tasksResource) || this.tasksResource, t, e - 220, this.tasksTop, 200)).setClosable(!0), e.destroyOnClose = !1;
    var i = mxUtils.bind(this, function (e) {
      mxEvent.release(t), t.innerHTML = "", this.createTasks(t);
    });
    this.graph.getModel().addListener(mxEvent.CHANGE, i), this.graph.getSelectionModel().addListener(mxEvent.CHANGE, i), this.graph.addListener(mxEvent.ROOT, i), null != this.tasksWindowImage && e.setImage(this.tasksWindowImage), this.tasks = e, this.createTasks(t);
  }

  this.tasks.setVisible(!0);
}, mxEditor.prototype.refreshTasks = function (t) {
  null != this.tasks && (t = this.tasks.content, mxEvent.release(t), t.innerHTML = "", this.createTasks(t));
}, mxEditor.prototype.createTasks = function (t) {}, mxEditor.prototype.showHelp = function (t) {
  if (null == this.help) {
    var e = document.createElement("iframe");
    e.setAttribute("src", mxResources.get("urlHelp") || this.urlHelp), e.setAttribute("height", "100%"), e.setAttribute("width", "100%"), e.setAttribute("frameBorder", "0"), e.style.backgroundColor = "white", t = document.body.clientWidth;
    var i = document.body.clientHeight || document.documentElement.clientHeight,
        n = new mxWindow(mxResources.get(this.helpResource) || this.helpResource, e, (t - this.helpWidth) / 2, (i - this.helpHeight) / 3, this.helpWidth, this.helpHeight);
    n.setMaximizable(!0), n.setClosable(!0), n.destroyOnClose = !1, n.setResizable(!0), null != this.helpWindowImage && n.setImage(this.helpWindowImage), mxClient.IS_NS && (t = function t(_t3) {
      e.setAttribute("height", n.div.offsetHeight - 26 + "px");
    }, n.addListener(mxEvent.RESIZE_END, t), n.addListener(mxEvent.MAXIMIZE, t), n.addListener(mxEvent.NORMALIZE, t), n.addListener(mxEvent.SHOW, t)), this.help = n;
  }

  this.help.setVisible(!0);
}, mxEditor.prototype.showOutline = function () {
  if (null == this.outline) {
    var t = document.createElement("div");
    t.style.overflow = "hidden", t.style.position = "relative", t.style.width = "100%", t.style.height = "100%", t.style.background = "white", t.style.cursor = "move", 8 == document.documentMode && (t.style.filter = "progid:DXImageTransform.Microsoft.alpha(opacity=100)");
    var e = new mxWindow(mxResources.get(this.outlineResource) || this.outlineResource, t, 600, 480, 200, 200, !1),
        i = new mxOutline(this.graph, t);
    e.setClosable(!0), e.setResizable(!0), e.destroyOnClose = !1, e.addListener(mxEvent.RESIZE_END, function () {
      i.update();
    }), this.outline = e, this.outline.outline = i;
  }

  this.outline.setVisible(!0), this.outline.outline.update(!0);
}, mxEditor.prototype.setMode = function (t) {
  "select" == t ? (this.graph.panningHandler.useLeftButtonForPanning = !1, this.graph.setConnectable(!1)) : "connect" == t ? (this.graph.panningHandler.useLeftButtonForPanning = !1, this.graph.setConnectable(!0)) : "pan" == t && (this.graph.panningHandler.useLeftButtonForPanning = !0, this.graph.setConnectable(!1));
}, mxEditor.prototype.createPopupMenu = function (t, e, i) {
  this.popupHandler.createMenu(this, t, e, i);
}, mxEditor.prototype.createEdge = function (t, e) {
  var i;
  if (null != this.defaultEdge) i = this.graph.getModel().cloneCell(this.defaultEdge);else {
    (i = new mxCell("")).setEdge(!0);
    var n = new mxGeometry();
    n.relative = !0, i.setGeometry(n);
  }
  return null != (n = this.getEdgeStyle()) && i.setStyle(n), i;
}, mxEditor.prototype.getEdgeStyle = function () {
  return this.defaultEdgeStyle;
}, mxEditor.prototype.consumeCycleAttribute = function (t) {
  return null != this.cycleAttributeValues && 0 < this.cycleAttributeValues.length && this.graph.isSwimlane(t) ? this.cycleAttributeValues[this.cycleAttributeIndex++ % this.cycleAttributeValues.length] : null;
}, mxEditor.prototype.cycleAttribute = function (t) {
  if (null != this.cycleAttributeName) {
    var e = this.consumeCycleAttribute(t);
    null != e && t.setStyle(t.getStyle() + ";" + this.cycleAttributeName + "=" + e);
  }
}, mxEditor.prototype.addVertex = function (t, e, i, n) {
  for (var s = this.graph.getModel(); null != t && !this.graph.isValidDropTarget(t);) {
    t = s.getParent(t);
  }

  t = null != t ? t : this.graph.getSwimlaneAt(i, n);
  var o = this.graph.getView().scale,
      l = s.getGeometry(e),
      r = s.getGeometry(t);
  if (this.graph.isSwimlane(e) && !this.graph.swimlaneNesting) t = null;else {
    if (null == t && this.swimlaneRequired) return null;

    if (null != t && null != r) {
      var a = this.graph.getView().getState(t);

      if (null != a) {
        if (i -= a.origin.x * o, n -= a.origin.y * o, this.graph.isConstrainedMoving) {
          r = l.width;
          var h = l.height,
              u = a.x + a.width;
          i + r > u && (i -= i + r - u), n + h > (u = a.y + a.height) && (n -= n + h - u);
        }
      } else null != r && (i -= r.x * o, n -= r.y * o);
    }
  }
  (l = l.clone()).x = this.graph.snap(i / o - this.graph.getView().translate.x - this.graph.gridSize / 2), l.y = this.graph.snap(n / o - this.graph.getView().translate.y - this.graph.gridSize / 2), e.setGeometry(l), null == t && (t = this.graph.getDefaultParent()), this.cycleAttribute(e), this.fireEvent(new mxEventObject(mxEvent.BEFORE_ADD_VERTEX, "vertex", e, "parent", t)), s.beginUpdate();

  try {
    null != (e = this.graph.addCell(e, t)) && (this.graph.constrainChild(e), this.fireEvent(new mxEventObject(mxEvent.ADD_VERTEX, "vertex", e)));
  } finally {
    s.endUpdate();
  }

  return null != e && (this.graph.setSelectionCell(e), this.graph.scrollCellToVisible(e), this.fireEvent(new mxEventObject(mxEvent.AFTER_ADD_VERTEX, "vertex", e))), e;
}, mxEditor.prototype.destroy = function () {
  this.destroyed || (this.destroyed = !0, null != this.tasks && this.tasks.destroy(), null != this.outline && this.outline.destroy(), null != this.properties && this.properties.destroy(), null != this.keyHandler && this.keyHandler.destroy(), null != this.rubberband && this.rubberband.destroy(), null != this.toolbar && this.toolbar.destroy(), null != this.graph && this.graph.destroy(), this.templates = this.status = null);
};
var mxCodecRegistry = {
  codecs: [],
  aliases: [],
  register: function register(t) {
    if (null != t) {
      var e = t.getName();
      mxCodecRegistry.codecs[e] = t;
      var i = mxUtils.getFunctionName(t.template.constructor);
      i != e && mxCodecRegistry.addAlias(i, e);
    }

    return t;
  },
  addAlias: function addAlias(t, e) {
    mxCodecRegistry.aliases[t] = e;
  },
  getCodec: function getCodec(t) {
    var e = null;

    if (null != t) {
      e = mxUtils.getFunctionName(t);
      var i = mxCodecRegistry.aliases[e];
      if (null != i && (e = i), null == (e = mxCodecRegistry.codecs[e])) try {
        e = new mxObjectCodec(new t()), mxCodecRegistry.register(e);
      } catch (t) {}
    }

    return e;
  }
};

function mxCodec(t) {
  this.document = t || mxUtils.createXmlDocument(), this.objects = [];
}

function mxObjectCodec(t, e, i, n) {
  for (var s in this.template = t, this.exclude = null != e ? e : [], this.idrefs = null != i ? i : [], this.mapping = null != n ? n : [], this.reverse = {}, this.mapping) {
    this.reverse[this.mapping[s]] = s;
  }
}

mxCodec.prototype.document = null, mxCodec.prototype.objects = null, mxCodec.prototype.elements = null, mxCodec.prototype.encodeDefaults = !1, mxCodec.prototype.putObject = function (t, e) {
  return this.objects[t] = e;
}, mxCodec.prototype.getObject = function (t) {
  var e = null;
  return null != t && null == (e = this.objects[t]) && null == (e = this.lookup(t)) && null != (t = this.getElementById(t)) && (e = this.decode(t)), e;
}, mxCodec.prototype.lookup = function (t) {
  return null;
}, mxCodec.prototype.getElementById = function (t) {
  return null == this.elements && (this.elements = {}, null != this.document.documentElement && this.addElement(this.document.documentElement)), this.elements[t];
}, mxCodec.prototype.addElement = function (t) {
  if (t.nodeType == mxConstants.NODETYPE_ELEMENT) {
    var e = t.getAttribute("id");
    null != e && null == this.elements[e] && (this.elements[e] = t);
  }

  for (t = t.firstChild; null != t;) {
    this.addElement(t), t = t.nextSibling;
  }
}, mxCodec.prototype.getId = function (t) {
  var e = null;
  return null != t && null == (e = this.reference(t)) && t instanceof mxCell && null == (e = t.getId()) && 0 == (e = mxCellPath.create(t)).length && (e = "root"), e;
}, mxCodec.prototype.reference = function (t) {
  return null;
}, mxCodec.prototype.encode = function (t) {
  var e = null;

  if (null != t && null != t.constructor) {
    var i = mxCodecRegistry.getCodec(t.constructor);
    null != i ? e = i.encode(this, t) : mxUtils.isNode(t) ? e = mxUtils.importNode(this.document, t, !0) : mxLog.warn("mxCodec.encode: No codec for " + mxUtils.getFunctionName(t.constructor));
  }

  return e;
}, mxCodec.prototype.decode = function (t, e) {
  var i = null;

  if (null != t && t.nodeType == mxConstants.NODETYPE_ELEMENT) {
    i = null;

    try {
      i = window[t.nodeName];
    } catch (t) {}

    null != (i = mxCodecRegistry.getCodec(i)) ? i = i.decode(this, t, e) : (i = t.cloneNode(!0)).removeAttribute("as");
  }

  return i;
}, mxCodec.prototype.encodeCell = function (t, e, i) {
  if (e.appendChild(this.encode(t)), null == i || i) {
    i = t.getChildCount();

    for (var n = 0; n < i; n++) {
      this.encodeCell(t.getChildAt(n), e);
    }
  }
}, mxCodec.prototype.isCellCodec = function (t) {
  return null != t && "function" == typeof t.isCellCodec && t.isCellCodec();
}, mxCodec.prototype.decodeCell = function (t, e) {
  e = null == e || e;
  var i = null;

  if (null != t && t.nodeType == mxConstants.NODETYPE_ELEMENT) {
    if (i = mxCodecRegistry.getCodec(t.nodeName), !this.isCellCodec(i)) for (var n = t.firstChild; null != n && !this.isCellCodec(i);) {
      i = mxCodecRegistry.getCodec(n.nodeName), n = n.nextSibling;
    }
    this.isCellCodec(i) || (i = mxCodecRegistry.getCodec(mxCell)), i = i.decode(this, t), e && this.insertIntoGraph(i);
  }

  return i;
}, mxCodec.prototype.insertIntoGraph = function (t) {
  var e = t.parent,
      i = t.getTerminal(!0),
      n = t.getTerminal(!1);
  t.setTerminal(null, !1), t.setTerminal(null, !0), t.parent = null, null != e && e.insert(t), null != i && i.insertEdge(t, !0), null != n && n.insertEdge(t, !1);
}, mxCodec.prototype.setAttribute = function (t, e, i) {
  null != e && null != i && t.setAttribute(e, i);
}, mxObjectCodec.allowEval = !1, mxObjectCodec.prototype.template = null, mxObjectCodec.prototype.exclude = null, mxObjectCodec.prototype.idrefs = null, mxObjectCodec.prototype.mapping = null, mxObjectCodec.prototype.reverse = null, mxObjectCodec.prototype.getName = function () {
  return mxUtils.getFunctionName(this.template.constructor);
}, mxObjectCodec.prototype.cloneTemplate = function () {
  return new this.template.constructor();
}, mxObjectCodec.prototype.getFieldName = function (t) {
  if (null != t) {
    var e = this.reverse[t];
    null != e && (t = e);
  }

  return t;
}, mxObjectCodec.prototype.getAttributeName = function (t) {
  if (null != t) {
    var e = this.mapping[t];
    null != e && (t = e);
  }

  return t;
}, mxObjectCodec.prototype.isExcluded = function (t, e, i, n) {
  return e == mxObjectIdentity.FIELD_NAME || 0 <= mxUtils.indexOf(this.exclude, e);
}, mxObjectCodec.prototype.isReference = function (t, e, i, n) {
  return 0 <= mxUtils.indexOf(this.idrefs, e);
}, mxObjectCodec.prototype.encode = function (t, e) {
  var i = t.document.createElement(this.getName());
  return e = this.beforeEncode(t, e, i), this.encodeObject(t, e, i), this.afterEncode(t, e, i);
}, mxObjectCodec.prototype.encodeObject = function (t, e, i) {
  for (var n in t.setAttribute(i, "id", t.getId(e)), e) {
    var s = n,
        o = e[s];
    null == o || this.isExcluded(e, s, o, !0) || (mxUtils.isInteger(s) && (s = null), this.encodeValue(t, e, s, o, i));
  }
}, mxObjectCodec.prototype.encodeValue = function (t, e, i, n, s) {
  if (null != n) {
    if (this.isReference(e, i, n, !0)) {
      var o = t.getId(n);
      if (null == o) return void mxLog.warn("mxObjectCodec.encode: No ID for " + this.getName() + "." + i + "=" + n);
      n = o;
    }

    o = this.template[i], (null == i || t.encodeDefaults || o != n) && (i = this.getAttributeName(i), this.writeAttribute(t, e, i, n, s));
  }
}, mxObjectCodec.prototype.writeAttribute = function (t, e, i, n, s) {
  "object" != typeof n ? this.writePrimitiveAttribute(t, e, i, n, s) : this.writeComplexAttribute(t, e, i, n, s);
}, mxObjectCodec.prototype.writePrimitiveAttribute = function (t, e, i, n, s) {
  n = this.convertAttributeToXml(t, e, i, n, s), null == i ? (e = t.document.createElement("add"), "function" == typeof n ? e.appendChild(t.document.createTextNode(n)) : t.setAttribute(e, "value", n), s.appendChild(e)) : "function" != typeof n && t.setAttribute(s, i, n);
}, mxObjectCodec.prototype.writeComplexAttribute = function (t, e, i, n, s) {
  null != (t = t.encode(n)) ? (null != i && t.setAttribute("as", i), s.appendChild(t)) : mxLog.warn("mxObjectCodec.encode: No node for " + this.getName() + "." + i + ": " + n);
}, mxObjectCodec.prototype.convertAttributeToXml = function (t, e, i, n) {
  return this.isBooleanAttribute(t, e, i, n) && (n = 1 == n ? "1" : "0"), n;
}, mxObjectCodec.prototype.isBooleanAttribute = function (t, e, i, n) {
  return void 0 === n.length && (1 == n || 0 == n);
}, mxObjectCodec.prototype.convertAttributeFromXml = function (t, e, i) {
  var n = e.value;
  return this.isNumericAttribute(t, e, i) && (n = parseFloat(n), isNaN(n) && (n = 0)), n;
}, mxObjectCodec.prototype.isNumericAttribute = function (t, e, i) {
  return i.constructor == mxGeometry && ("x" == e.name || "y" == e.name || "width" == e.name || "height" == e.name) || i.constructor == mxPoint && ("x" == e.name || "y" == e.name) || mxUtils.isNumeric(e.value);
}, mxObjectCodec.prototype.beforeEncode = function (t, e, i) {
  return e;
}, mxObjectCodec.prototype.afterEncode = function (t, e, i) {
  return i;
}, mxObjectCodec.prototype.decode = function (t, e, i) {
  var n = e.getAttribute("id"),
      s = t.objects[n];
  return null == s && (s = i || this.cloneTemplate(), null != n && t.putObject(n, s)), e = this.beforeDecode(t, e, s), this.decodeNode(t, e, s), this.afterDecode(t, e, s);
}, mxObjectCodec.prototype.decodeNode = function (t, e, i) {
  null != e && (this.decodeAttributes(t, e, i), this.decodeChildren(t, e, i));
}, mxObjectCodec.prototype.decodeAttributes = function (t, e, i) {
  if (null != (e = e.attributes)) for (var n = 0; n < e.length; n++) {
    this.decodeAttribute(t, e[n], i);
  }
}, mxObjectCodec.prototype.isIgnoredAttribute = function (t, e, i) {
  return "as" == e.nodeName || "id" == e.nodeName;
}, mxObjectCodec.prototype.decodeAttribute = function (t, e, i) {
  if (!this.isIgnoredAttribute(t, e, i)) {
    var n = e.nodeName;
    e = this.convertAttributeFromXml(t, e, i);
    var s = this.getFieldName(n);

    if (this.isReference(i, s, e, !1)) {
      if (null == (t = t.getObject(e))) return void mxLog.warn("mxObjectCodec.decode: No object for " + this.getName() + "." + n + "=" + e);
      e = t;
    }

    this.isExcluded(i, n, e, !1) || (i[n] = e);
  }
}, mxObjectCodec.prototype.decodeChildren = function (t, e, i) {
  for (e = e.firstChild; null != e;) {
    var n = e.nextSibling;
    e.nodeType != mxConstants.NODETYPE_ELEMENT || this.processInclude(t, e, i) || this.decodeChild(t, e, i), e = n;
  }
}, mxObjectCodec.prototype.decodeChild = function (t, e, i) {
  var n = this.getFieldName(e.getAttribute("as"));

  if (null == n || !this.isExcluded(i, n, e, !1)) {
    var s = this.getFieldTemplate(i, n, e);
    "add" == e.nodeName ? null == (t = e.getAttribute("value")) && mxObjectCodec.allowEval && (t = mxUtils.eval(mxUtils.getTextContent(e))) : t = t.decode(e, s), this.addObjectValue(i, n, t, s);
  }
}, mxObjectCodec.prototype.getFieldTemplate = function (t, e, i) {
  return (t = t[e]) instanceof Array && 0 < t.length && (t = null), t;
}, mxObjectCodec.prototype.addObjectValue = function (t, e, i, n) {
  null != i && i != n && (null != e && 0 < e.length ? t[e] = i : t.push(i));
}, mxObjectCodec.prototype.processInclude = function (t, e, i) {
  if ("include" == e.nodeName) {
    if (null != (e = e.getAttribute("name"))) try {
      var n = mxUtils.load(e).getDocumentElement();
      null != n && t.decode(n, i);
    } catch (t) {}
    return !0;
  }

  return !1;
}, mxObjectCodec.prototype.beforeDecode = function (t, e, i) {
  return e;
}, mxObjectCodec.prototype.afterDecode = function (t, e, i) {
  return i;
}, mxCodecRegistry.register(function () {
  var t = new mxObjectCodec(new mxCell(), ["children", "edges", "overlays", "mxTransient"], ["parent", "source", "target"]);
  return t.isCellCodec = function () {
    return !0;
  }, t.isNumericAttribute = function (t, e, i) {
    return "value" !== e.nodeName && mxObjectCodec.prototype.isNumericAttribute.apply(this, arguments);
  }, t.isExcluded = function (t, e, i, n) {
    return mxObjectCodec.prototype.isExcluded.apply(this, arguments) || n && "value" == e && i.nodeType == mxConstants.NODETYPE_ELEMENT;
  }, t.afterEncode = function (t, e, i) {
    if (null != e.value && e.value.nodeType == mxConstants.NODETYPE_ELEMENT) {
      var n = i;
      (i = mxUtils.importNode(t.document, e.value, !0)).appendChild(n), t = n.getAttribute("id"), i.setAttribute("id", t), n.removeAttribute("id");
    }

    return i;
  }, t.beforeDecode = function (t, e, i) {
    var n = e.cloneNode(!0),
        s = this.getName();
    if (e.nodeName != s ? (null != (n = e.getElementsByTagName(s)[0]) && n.parentNode == e ? (mxUtils.removeWhitespace(n, !0), mxUtils.removeWhitespace(n, !1), n.parentNode.removeChild(n)) : n = null, i.value = e.cloneNode(!0), null != (e = i.value.getAttribute("id")) && (i.setId(e), i.value.removeAttribute("id"))) : i.setId(e.getAttribute("id")), null != n) for (e = 0; e < this.idrefs.length; e++) {
      s = this.idrefs[e];
      var o = n.getAttribute(s);

      if (null != o) {
        n.removeAttribute(s);
        var l = t.objects[o] || t.lookup(o);
        null == l && null != (o = t.getElementById(o)) && (l = (mxCodecRegistry.codecs[o.nodeName] || this).decode(t, o)), i[s] = l;
      }
    }
    return n;
  }, t;
}()), mxCodecRegistry.register(function () {
  var t = new mxObjectCodec(new mxGraphModel());
  return t.encodeObject = function (t, e, i) {
    var n = t.document.createElement("root");
    t.encodeCell(e.getRoot(), n), i.appendChild(n);
  }, t.decodeChild = function (t, e, i) {
    "root" == e.nodeName ? this.decodeRoot(t, e, i) : mxObjectCodec.prototype.decodeChild.apply(this, arguments);
  }, t.decodeRoot = function (t, e, i) {
    var n = null;

    for (e = e.firstChild; null != e;) {
      var s = t.decodeCell(e);
      null != s && null == s.getParent() && (n = s), e = e.nextSibling;
    }

    null != n && i.setRoot(n);
  }, t;
}()), mxCodecRegistry.register(function () {
  var t = new mxObjectCodec(new mxRootChange(), ["model", "previous", "root"]);
  return t.afterEncode = function (t, e, i) {
    return t.encodeCell(e.root, i), i;
  }, t.beforeDecode = function (t, e, i) {
    if (null != e.firstChild && e.firstChild.nodeType == mxConstants.NODETYPE_ELEMENT) {
      var n = (e = e.cloneNode(!0)).firstChild;

      for (i.root = t.decodeCell(n, !1), i = n.nextSibling, n.parentNode.removeChild(n), n = i; null != n;) {
        i = n.nextSibling, t.decodeCell(n), n.parentNode.removeChild(n), n = i;
      }
    }

    return e;
  }, t.afterDecode = function (t, e, i) {
    return i.previous = i.root, i;
  }, t;
}()), mxCodecRegistry.register(function () {
  var t = new mxObjectCodec(new mxChildChange(), ["model", "child", "previousIndex"], ["parent", "previous"]);
  return t.isReference = function (t, e, i, n) {
    return !("child" != e || null == t.previous && n) || 0 <= mxUtils.indexOf(this.idrefs, e);
  }, t.afterEncode = function (t, e, i) {
    return this.isReference(e, "child", e.child, !0) ? i.setAttribute("child", t.getId(e.child)) : t.encodeCell(e.child, i), i;
  }, t.beforeDecode = function (t, e, i) {
    if (null != e.firstChild && e.firstChild.nodeType == mxConstants.NODETYPE_ELEMENT) {
      var n = (e = e.cloneNode(!0)).firstChild;

      for (i.child = t.decodeCell(n, !1), i = n.nextSibling, n.parentNode.removeChild(n), n = i; null != n;) {
        if (i = n.nextSibling, n.nodeType == mxConstants.NODETYPE_ELEMENT) {
          var s = n.getAttribute("id");
          null == t.lookup(s) && t.decodeCell(n);
        }

        n.parentNode.removeChild(n), n = i;
      }
    } else n = e.getAttribute("child"), i.child = t.getObject(n);

    return e;
  }, t.afterDecode = function (t, e, i) {
    return null != i.child && (null != i.child.parent && null != i.previous && i.child.parent != i.previous && (i.previous = i.child.parent), i.child.parent = i.previous, i.previous = i.parent, i.previousIndex = i.index), i;
  }, t;
}()), mxCodecRegistry.register(function () {
  var t = new mxObjectCodec(new mxTerminalChange(), ["model", "previous"], ["cell", "terminal"]);
  return t.afterDecode = function (t, e, i) {
    return i.previous = i.terminal, i;
  }, t;
}());

var mxGenericChangeCodec = function mxGenericChangeCodec(t, e) {
  var i = new mxObjectCodec(t, ["model", "previous"], ["cell"]);
  return i.afterDecode = function (t, i, n) {
    return mxUtils.isNode(n.cell) && (n.cell = t.decodeCell(n.cell, !1)), n.previous = n[e], n;
  }, i;
};

mxCodecRegistry.register(mxGenericChangeCodec(new mxValueChange(), "value")), mxCodecRegistry.register(mxGenericChangeCodec(new mxStyleChange(), "style")), mxCodecRegistry.register(mxGenericChangeCodec(new mxGeometryChange(), "geometry")), mxCodecRegistry.register(mxGenericChangeCodec(new mxCollapseChange(), "collapsed")), mxCodecRegistry.register(mxGenericChangeCodec(new mxVisibleChange(), "visible")), mxCodecRegistry.register(mxGenericChangeCodec(new mxCellAttributeChange(), "value")), mxCodecRegistry.register(new mxObjectCodec(new mxGraph(), "graphListeners eventListeners view container cellRenderer editor selection".split(" "))), mxCodecRegistry.register(function () {
  var t = new mxObjectCodec(new mxGraphView());
  return t.encode = function (t, e) {
    return this.encodeCell(t, e, e.graph.getModel().getRoot());
  }, t.encodeCell = function (t, e, i) {
    var n = e.graph.getModel(),
        s = e.getState(i),
        o = n.getParent(i);

    if (null == o || null != s) {
      var l = n.getChildCount(i),
          r = e.graph.getCellGeometry(i),
          a = null;

      if (o == n.getRoot() ? a = "layer" : null == o ? a = "graph" : n.isEdge(i) ? a = "edge" : 0 < l && null != r ? a = "group" : n.isVertex(i) && (a = "vertex"), null != a) {
        var h = t.document.createElement(a);

        if (null != e.graph.getLabel(i) && (h.setAttribute("label", e.graph.getLabel(i)), e.graph.isHtmlLabel(i) && h.setAttribute("html", !0)), null == o) {
          var u = e.getGraphBounds();
          null != u && (h.setAttribute("x", Math.round(u.x)), h.setAttribute("y", Math.round(u.y)), h.setAttribute("width", Math.round(u.width)), h.setAttribute("height", Math.round(u.height))), h.setAttribute("scale", e.scale);
        } else if (null != s && null != r) {
          for (u in s.style) {
            "function" == typeof (o = s.style[u]) && "object" == typeof o && (o = mxStyleRegistry.getName(o)), null != o && "function" != typeof o && "object" != typeof o && h.setAttribute(u, o);
          }

          if (null != (o = s.absolutePoints) && 0 < o.length) {
            for (r = Math.round(o[0].x) + "," + Math.round(o[0].y), u = 1; u < o.length; u++) {
              r += " " + Math.round(o[u].x) + "," + Math.round(o[u].y);
            }

            h.setAttribute("points", r);
          } else h.setAttribute("x", Math.round(s.x)), h.setAttribute("y", Math.round(s.y)), h.setAttribute("width", Math.round(s.width)), h.setAttribute("height", Math.round(s.height));

          null != (u = s.absoluteOffset) && (0 != u.x && h.setAttribute("dx", Math.round(u.x)), 0 != u.y && h.setAttribute("dy", Math.round(u.y)));
        }

        for (u = 0; u < l; u++) {
          null != (s = this.encodeCell(t, e, n.getChildAt(i, u))) && h.appendChild(s);
        }
      }
    }

    return h;
  }, t;
}());
var mxStylesheetCodec = mxCodecRegistry.register(function () {
  var t = new mxObjectCodec(new mxStylesheet());
  return t.encode = function (t, e) {
    var i,
        n = t.document.createElement(this.getName());

    for (i in e.styles) {
      var s = e.styles[i],
          o = t.document.createElement("add");

      if (null != i) {
        for (var l in o.setAttribute("as", i), s) {
          var r = this.getStringValue(l, s[l]);

          if (null != r) {
            var a = t.document.createElement("add");
            a.setAttribute("value", r), a.setAttribute("as", l), o.appendChild(a);
          }
        }

        0 < o.childNodes.length && n.appendChild(o);
      }
    }

    return n;
  }, t.getStringValue = function (t, e) {
    var i = typeof e;
    return "function" == i ? e = mxStyleRegistry.getName(style[j]) : "object" == i && (e = null), e;
  }, t.decode = function (t, e, i) {
    i = i || new this.template.constructor();
    var n = e.getAttribute("id");

    for (null != n && (t.objects[n] = i), e = e.firstChild; null != e;) {
      if (!this.processInclude(t, e, i) && "add" == e.nodeName && null != (n = e.getAttribute("as"))) {
        var s = e.getAttribute("extend"),
            o = null != s ? mxUtils.clone(i.styles[s]) : null;

        for (null == o && (null != s && mxLog.warn("mxStylesheetCodec.decode: stylesheet " + s + " not found to extend"), o = {}), s = e.firstChild; null != s;) {
          if (s.nodeType == mxConstants.NODETYPE_ELEMENT) {
            var l = s.getAttribute("as");

            if ("add" == s.nodeName) {
              var r = mxUtils.getTextContent(s);
              null != r && 0 < r.length && mxStylesheetCodec.allowEval ? r = mxUtils.eval(r) : (r = s.getAttribute("value"), mxUtils.isNumeric(r) && (r = parseFloat(r))), null != r && (o[l] = r);
            } else "remove" == s.nodeName && delete o[l];
          }

          s = s.nextSibling;
        }

        i.putCellStyle(n, o);
      }

      e = e.nextSibling;
    }

    return i;
  }, t;
}());
mxStylesheetCodec.allowEval = !0, mxCodecRegistry.register(function () {
  var t = new mxObjectCodec(new mxDefaultKeyHandler());
  return t.encode = function (t, e) {
    return null;
  }, t.decode = function (t, e, i) {
    if (null != i) for (e = e.firstChild; null != e;) {
      if (!this.processInclude(t, e, i) && "add" == e.nodeName) {
        var n = e.getAttribute("as"),
            s = e.getAttribute("action"),
            o = e.getAttribute("control");
        i.bindAction(n, s, o);
      }

      e = e.nextSibling;
    }
    return i;
  }, t;
}());
var mxDefaultToolbarCodec = mxCodecRegistry.register(function () {
  var t = new mxObjectCodec(new mxDefaultToolbar());
  return t.encode = function (t, e) {
    return null;
  }, t.decode = function (t, e, i) {
    if (null != i) {
      var n = i.editor;

      for (e = e.firstChild; null != e;) {
        if (e.nodeType == mxConstants.NODETYPE_ELEMENT && !this.processInclude(t, e, i)) if ("separator" == e.nodeName) i.addSeparator();else if ("br" == e.nodeName) i.toolbar.addBreak();else if ("hr" == e.nodeName) i.toolbar.addLine();else if ("add" == e.nodeName) {
          var s = e.getAttribute("as"),
              o = (s = mxResources.get(s) || s, e.getAttribute("icon")),
              l = e.getAttribute("pressedIcon"),
              r = e.getAttribute("action"),
              a = e.getAttribute("mode"),
              h = e.getAttribute("template"),
              u = "0" != e.getAttribute("toggle"),
              d = mxUtils.getTextContent(e),
              p = null;
          if (null != r) p = i.addItem(s, o, r, l);else if (null != a) {
            var c = mxDefaultToolbarCodec.allowEval ? mxUtils.eval(d) : null;
            p = i.addMode(s, o, a, l, c);
          } else if (null != h || null != d && 0 < d.length) p = n.templates[h], h = e.getAttribute("style"), null != p && null != h && (p = n.graph.cloneCell(p)).setStyle(h), h = null, null != d && 0 < d.length && mxDefaultToolbarCodec.allowEval && (h = mxUtils.eval(d)), p = i.addPrototype(s, o, p, l, h, u);else if (0 < (l = mxUtils.getChildNodes(e)).length) if (null == o) for (h = i.addActionCombo(s), s = 0; s < l.length; s++) {
            "separator" == (u = l[s]).nodeName ? i.addOption(h, "---") : "add" == u.nodeName && (o = u.getAttribute("as"), u = u.getAttribute("action"), i.addActionOption(h, o, u));
          } else {
            var m = null,
                g = i.addPrototype(s, o, function () {
              if (null != (t = n.templates[m.value])) {
                var t = t.clone(),
                    e = m.options[m.selectedIndex].cellStyle;
                return null != e && t.setStyle(e), t;
              }

              return mxLog.warn("Template " + t + " not found"), null;
            }, null, null, u);
            m = i.addCombo();

            for (mxEvent.addListener(m, "change", function () {
              i.toolbar.selectMode(g, function (t) {
                return t = mxUtils.convertPoint(n.graph.container, mxEvent.getClientX(t), mxEvent.getClientY(t)), n.addVertex(null, c(), t.x, t.y);
              }), i.toolbar.noReset = !1;
            }), s = 0; s < l.length; s++) {
              "separator" == (u = l[s]).nodeName ? i.addOption(m, "---") : "add" == u.nodeName && (o = u.getAttribute("as"), d = u.getAttribute("template"), i.addOption(m, o, d || h).cellStyle = u.getAttribute("style"));
            }
          }
          null != p && null != (h = e.getAttribute("id")) && 0 < h.length && p.setAttribute("id", h);
        }
        e = e.nextSibling;
      }
    }

    return i;
  }, t;
}());
mxDefaultToolbarCodec.allowEval = !0, mxCodecRegistry.register(function () {
  var t = new mxObjectCodec(new mxDefaultPopupMenu());
  return t.encode = function (t, e) {
    return null;
  }, t.decode = function (t, e, i) {
    var n = e.getElementsByTagName("include")[0];
    return null != n ? this.processInclude(t, n, i) : null != i && (i.config = e), i;
  }, t;
}()), mxCodecRegistry.register(function () {
  var t = new mxObjectCodec(new mxEditor(), "modified lastSnapshot ignoredChanges undoManager graphContainer toolbarContainer".split(" "));
  return t.afterDecode = function (t, e, i) {
    return null != (t = e.getAttribute("defaultEdge")) && (e.removeAttribute("defaultEdge"), i.defaultEdge = i.templates[t]), null != (t = e.getAttribute("defaultGroup")) && (e.removeAttribute("defaultGroup"), i.defaultGroup = i.templates[t]), i;
  }, t.decodeChild = function (t, e, i) {
    if ("Array" == e.nodeName) {
      if ("templates" == e.getAttribute("as")) return void this.decodeTemplates(t, e, i);
    } else if ("ui" == e.nodeName) return void this.decodeUi(t, e, i);

    mxObjectCodec.prototype.decodeChild.apply(this, arguments);
  }, t.decodeUi = function (t, e, i) {
    for (t = e.firstChild; null != t;) {
      if ("add" == t.nodeName) {
        e = t.getAttribute("as");
        var n = t.getAttribute("element"),
            s = t.getAttribute("style");
        if (null != n) null != (n = document.getElementById(n)) && null != s && (n.style.cssText += ";" + s);else {
          var o = parseInt(t.getAttribute("x")),
              l = parseInt(t.getAttribute("y")),
              r = t.getAttribute("width"),
              a = t.getAttribute("height");
          (n = document.createElement("div")).style.cssText = s, new mxWindow(mxResources.get(e) || e, n, o, l, r, a, !1, !0).setVisible(!0);
        }
        "graph" == e ? i.setGraphContainer(n) : "toolbar" == e ? i.setToolbarContainer(n) : "title" == e ? i.setTitleContainer(n) : "status" == e ? i.setStatusContainer(n) : "map" == e && i.setMapContainer(n);
      } else "resource" == t.nodeName ? mxResources.add(t.getAttribute("basename")) : "stylesheet" == t.nodeName && mxClient.link("stylesheet", t.getAttribute("name"));

      t = t.nextSibling;
    }
  }, t.decodeTemplates = function (t, e, i) {
    null == i.templates && (i.templates = []), e = mxUtils.getChildNodes(e);

    for (var n = 0; n < e.length; n++) {
      for (var s = e[n].getAttribute("as"), o = e[n].firstChild; null != o && 1 != o.nodeType;) {
        o = o.nextSibling;
      }

      null != o && (i.templates[s] = t.decodeCell(o));
    }
  }, t;
}());
var mxLib = (_mxLib = {
  mxClient: mxClient,
  mxUtils: mxUtils,
  mxConstants: mxConstants,
  mxEvent: mxEvent,
  mxPerimeter: mxPerimeter,
  mxEdgeStyle: mxEdgeStyle,
  mxEffects: mxEffects,
  mxResources: mxResources,
  mxCodecRegistry: mxCodecRegistry,
  mxLog: mxLog,
  mxObjectIdentity: mxObjectIdentity,
  mxDictionary: mxDictionary
}, _defineProperty(_mxLib, "mxResources", mxResources), _defineProperty(_mxLib, "mxPoint", mxPoint), _defineProperty(_mxLib, "mxRectangle", mxRectangle), _defineProperty(_mxLib, "mxEffects", mxEffects), _defineProperty(_mxLib, "mxUtils", mxUtils), _defineProperty(_mxLib, "mxConstants", mxConstants), _defineProperty(_mxLib, "mxEventObject", mxEventObject), _defineProperty(_mxLib, "mxMouseEvent", mxMouseEvent), _defineProperty(_mxLib, "mxEventSource", mxEventSource), _defineProperty(_mxLib, "mxXmlRequest", mxXmlRequest), _defineProperty(_mxLib, "mxClipboard", mxClipboard), _defineProperty(_mxLib, "mxWindow", mxWindow), _defineProperty(_mxLib, "mxForm", mxForm), _defineProperty(_mxLib, "mxImage", mxImage), _defineProperty(_mxLib, "mxDivResizer", mxDivResizer), _defineProperty(_mxLib, "mxDragSource", mxDragSource), _defineProperty(_mxLib, "mxToolbar", mxToolbar), _defineProperty(_mxLib, "mxUndoableEdit", mxUndoableEdit), _defineProperty(_mxLib, "mxUndoManager", mxUndoManager), _defineProperty(_mxLib, "mxUrlConverter", mxUrlConverter), _defineProperty(_mxLib, "mxPanningManager", mxPanningManager), _defineProperty(_mxLib, "mxPopupMenu", mxPopupMenu), _defineProperty(_mxLib, "mxAutoSaveManager", mxAutoSaveManager), _defineProperty(_mxLib, "mxAnimation", mxAnimation), _defineProperty(_mxLib, "mxMorphing", mxMorphing), _defineProperty(_mxLib, "mxImageBundle", mxImageBundle), _defineProperty(_mxLib, "mxImageExport", mxImageExport), _defineProperty(_mxLib, "mxAbstractCanvas2D", mxAbstractCanvas2D), _defineProperty(_mxLib, "mxXmlCanvas2D", mxXmlCanvas2D), _defineProperty(_mxLib, "mxSvgCanvas2D", mxSvgCanvas2D), _defineProperty(_mxLib, "mxVmlCanvas2D", mxVmlCanvas2D), _defineProperty(_mxLib, "mxGuide", mxGuide), _defineProperty(_mxLib, "mxStencil", mxStencil), _defineProperty(_mxLib, "mxShape", mxShape), _defineProperty(_mxLib, "mxStencilRegistry", mxStencilRegistry), _defineProperty(_mxLib, "mxMarker", mxMarker), _defineProperty(_mxLib, "mxActor", mxActor), _defineProperty(_mxLib, "mxCloud", mxCloud), _defineProperty(_mxLib, "mxRectangleShape", mxRectangleShape), _defineProperty(_mxLib, "mxEllipse", mxEllipse), _defineProperty(_mxLib, "mxDoubleEllipse", mxDoubleEllipse), _defineProperty(_mxLib, "mxRhombus", mxRhombus), _defineProperty(_mxLib, "mxPolyline", mxPolyline), _defineProperty(_mxLib, "mxArrow", mxArrow), _defineProperty(_mxLib, "mxArrowConnector", mxArrowConnector), _defineProperty(_mxLib, "mxText", mxText), _defineProperty(_mxLib, "mxTriangle", mxTriangle), _defineProperty(_mxLib, "mxHexagon", mxHexagon), _defineProperty(_mxLib, "mxLine", mxLine), _defineProperty(_mxLib, "mxImageShape", mxImageShape), _defineProperty(_mxLib, "mxLabel", mxLabel), _defineProperty(_mxLib, "mxCylinder", mxCylinder), _defineProperty(_mxLib, "mxConnector", mxConnector), _defineProperty(_mxLib, "mxSwimlane", mxSwimlane), _defineProperty(_mxLib, "mxGraphLayout", mxGraphLayout), _defineProperty(_mxLib, "mxStackLayout", mxStackLayout), _defineProperty(_mxLib, "mxPartitionLayout", mxPartitionLayout), _defineProperty(_mxLib, "mxCompactTreeLayout", mxCompactTreeLayout), _defineProperty(_mxLib, "mxRadialTreeLayout", mxRadialTreeLayout), _defineProperty(_mxLib, "mxFastOrganicLayout", mxFastOrganicLayout), _defineProperty(_mxLib, "mxCircleLayout", mxCircleLayout), _defineProperty(_mxLib, "mxParallelEdgeLayout", mxParallelEdgeLayout), _defineProperty(_mxLib, "mxCompositeLayout", mxCompositeLayout), _defineProperty(_mxLib, "mxEdgeLabelLayout", mxEdgeLabelLayout), _defineProperty(_mxLib, "mxGraphAbstractHierarchyCell", mxGraphAbstractHierarchyCell), _defineProperty(_mxLib, "mxGraphHierarchyNode", mxGraphHierarchyNode), _defineProperty(_mxLib, "mxGraphHierarchyEdge", mxGraphHierarchyEdge), _defineProperty(_mxLib, "mxGraphHierarchyModel", mxGraphHierarchyModel), _defineProperty(_mxLib, "mxSwimlaneModel", mxSwimlaneModel), _defineProperty(_mxLib, "mxHierarchicalLayoutStage", mxHierarchicalLayoutStage), _defineProperty(_mxLib, "mxMedianHybridCrossingReduction", mxMedianHybridCrossingReduction), _defineProperty(_mxLib, "mxMinimumCycleRemover", mxMinimumCycleRemover), _defineProperty(_mxLib, "mxCoordinateAssignment", mxCoordinateAssignment), _defineProperty(_mxLib, "mxSwimlaneOrdering", mxSwimlaneOrdering), _defineProperty(_mxLib, "mxHierarchicalLayout", mxHierarchicalLayout), _defineProperty(_mxLib, "mxSwimlaneLayout", mxSwimlaneLayout), _defineProperty(_mxLib, "mxGraphModel", mxGraphModel), _defineProperty(_mxLib, "mxCell", mxCell), _defineProperty(_mxLib, "mxGeometry", mxGeometry), _defineProperty(_mxLib, "mxCellPath", mxCellPath), _defineProperty(_mxLib, "mxPerimeter", mxPerimeter), _defineProperty(_mxLib, "mxPrintPreview", mxPrintPreview), _defineProperty(_mxLib, "mxStylesheet", mxStylesheet), _defineProperty(_mxLib, "mxCellState", mxCellState), _defineProperty(_mxLib, "mxGraphSelectionModel", mxGraphSelectionModel), _defineProperty(_mxLib, "mxCellEditor", mxCellEditor), _defineProperty(_mxLib, "mxCellRenderer", mxCellRenderer), _defineProperty(_mxLib, "mxEdgeStyle", mxEdgeStyle), _defineProperty(_mxLib, "mxStyleRegistry", mxStyleRegistry), _defineProperty(_mxLib, "mxGraphView", mxGraphView), _defineProperty(_mxLib, "mxGraph", mxGraph), _defineProperty(_mxLib, "mxCellOverlay", mxCellOverlay), _defineProperty(_mxLib, "mxOutline", mxOutline), _defineProperty(_mxLib, "mxMultiplicity", mxMultiplicity), _defineProperty(_mxLib, "mxLayoutManager", mxLayoutManager), _defineProperty(_mxLib, "mxSwimlaneManager", mxSwimlaneManager), _defineProperty(_mxLib, "mxTemporaryCellStates", mxTemporaryCellStates), _defineProperty(_mxLib, "mxCellStatePreview", mxCellStatePreview), _defineProperty(_mxLib, "mxConnectionConstraint", mxConnectionConstraint), _defineProperty(_mxLib, "mxGraphHandler", mxGraphHandler), _defineProperty(_mxLib, "mxPanningHandler", mxPanningHandler), _defineProperty(_mxLib, "mxPopupMenuHandler", mxPopupMenuHandler), _defineProperty(_mxLib, "mxCellMarker", mxCellMarker), _defineProperty(_mxLib, "mxSelectionCellsHandler", mxSelectionCellsHandler), _defineProperty(_mxLib, "mxConnectionHandler", mxConnectionHandler), _defineProperty(_mxLib, "mxConstraintHandler", mxConstraintHandler), _defineProperty(_mxLib, "mxRubberband", mxRubberband), _defineProperty(_mxLib, "mxHandle", mxHandle), _defineProperty(_mxLib, "mxVertexHandler", mxVertexHandler), _defineProperty(_mxLib, "mxEdgeHandler", mxEdgeHandler), _defineProperty(_mxLib, "mxElbowEdgeHandler", mxElbowEdgeHandler), _defineProperty(_mxLib, "mxEdgeSegmentHandler", mxEdgeSegmentHandler), _defineProperty(_mxLib, "mxKeyHandler", mxKeyHandler), _defineProperty(_mxLib, "mxTooltipHandler", mxTooltipHandler), _defineProperty(_mxLib, "mxCellTracker", mxCellTracker), _defineProperty(_mxLib, "mxCellHighlight", mxCellHighlight), _defineProperty(_mxLib, "mxDefaultKeyHandler", mxDefaultKeyHandler), _defineProperty(_mxLib, "mxDefaultPopupMenu", mxDefaultPopupMenu), _defineProperty(_mxLib, "mxDefaultToolbar", mxDefaultToolbar), _defineProperty(_mxLib, "mxEditor", mxEditor), _defineProperty(_mxLib, "mxCodecRegistry", mxCodecRegistry), _defineProperty(_mxLib, "mxCodec", mxCodec), _defineProperty(_mxLib, "mxObjectCodec", mxObjectCodec), _defineProperty(_mxLib, "mxValueChange", mxValueChange), _defineProperty(_mxLib, "mxChildChange", mxChildChange), _defineProperty(_mxLib, "mxTerminalChange", mxTerminalChange), _defineProperty(_mxLib, "mxValueChange", mxValueChange), _mxLib);

function _registerLayoutManager(t, e, i) {
  var n = i.mxLayoutManager;
  var s = new n(t);
  return s.getLayout = function (n) {
    var s = null;

    if (null != t.getModel().getParent(n) && n.value) {
      var o = e.findDomainClass(n);
      o && (s = o.getLayout(t, i));
    }

    return s;
  }, t.layoutManager = s, s;
}

function _alignFoldingHandleRight(t) {
  var e = t.mxCellRenderer,
      i = t.mxUtils,
      n = t.mxConstants;

  e.prototype.redrawControl = function (t, e) {
    var s = t.view.graph.getFoldingImage(t);

    if (null != t.control && null != s) {
      var o = this.getControlBounds(t, s.width, s.height);
      o.x = t.x + t.width - (s.width + 10), o.y = t.y + 5;
      var l = this.legacyControlPosition ? i.getValue(t.style, n.STYLE_ROTATION, 0) : t.shape.getTextRotation(),
          r = t.view.scale;
      !e && t.control.scale == r && t.control.bounds.equals(o) && t.control.rotation == l || (t.control.rotation = l, t.control.bounds = o, t.control.scale = r, t.control.redraw());
    }
  };
}

function _fixDecoder(t) {
  var e = t.mxCodec,
      i = t.mxCodecRegistry,
      n = t.mxConstants;

  e.prototype.decode = function (t, e) {
    var s = null;

    if (null != t && t.nodeType == n.NODETYPE_ELEMENT) {
      var o = null;
      o = void 0 !== this.getConstructorForNode ? this.getConstructorForNode(t.nodeName) : window[t.nodeName];
      var l = i.getCodec(o);
      null != l ? s = l.decode(this, t, e) : (s = t.cloneNode(!0)).removeAttribute("as");
    }

    return s;
  };
}

function _fixSelectionModel(t) {
  var e = t.mxGraphSelectionModel;

  e.prototype.setCells = function (t) {
    if (null != t) {
      this.singleSelection && (t = [this.getFirstSelectableCell(t)]);

      for (var e = [], i = 0; i < t.length; i++) {
        this.graph.isCellSelectable(t[i], t) && e.push(t[i]);
      }

      this.changeSelection(e, this.cells);
    }
  };
}

function _fixDynamicTextAlign(t) {
  var e = t.mxText;
  var i = e.prototype.getSpacing;

  e.prototype.getSpacing = function () {
    if (void 0 === this.dynAlign && (this.dynAlign = "center" !== this.align && "middle" !== this.valign && this.state.cell.parent.edge && this.state.cell.geometry.relative, this.dynAlign && "center" !== this.align && (this.origAlign = this.align), this.dynAlign && "middle" !== this.valign && (this.origVAlign = this.valign), this.dynSource = this.state.cell.geometry.x < 0), this.dynAlign) {
      var _t4 = this.state.view.getState(this.state.cell.parent).absolutePoints;

      if (_t4 && _t4.length >= 2) {
        if (this.origVAlign) {
          var _e3 = this.dynSource ? _t4[1].y < _t4[0].y : _t4[_t4.length - 1].y < _t4[_t4.length - 2].y;

          this.flippedVAlign || (this.flippedVAlign = "top" === this.origVAlign ? "bottom" : "top"), this.valign = _e3 ? this.flippedVAlign : this.origVAlign;
        }

        if (this.origAlign) {
          var _e4 = this.dynSource ? _t4[1].x < _t4[0].x : _t4[_t4.length - 1].x < _t4[_t4.length - 2].x;

          this.flippedAlign || (this.flippedAlign = "left" === this.origAlign ? "right" : "left"), this.align = _e4 ? this.flippedAlign : this.origAlign;
        }
      }
    }

    return i.apply(this, arguments);
  };
}

var GraphLib =
/*#__PURE__*/
function () {
  function GraphLib() {
    _classCallCheck(this, GraphLib);

    this.mx = mxLib, this.mxClient.isBrowserSupported() || this.mxUtils.error("Browser is not supported!", 200, !1);
  }

  _createClass(GraphLib, [{
    key: "registerLayoutManager",
    value: function registerLayoutManager(t, e) {
      _registerLayoutManager(t, e, this.mx);
    }
  }, {
    key: "fixDecoder",
    value: function fixDecoder() {
      _fixDecoder(this.mx);
    }
  }, {
    key: "fixSelectionModel",
    value: function fixSelectionModel() {
      _fixSelectionModel(this.mx);
    }
  }, {
    key: "fixDynamicTextAlign",
    value: function fixDynamicTextAlign() {
      _fixDynamicTextAlign(this.mx);
    }
  }, {
    key: "alignFoldingHandleRight",
    value: function alignFoldingHandleRight() {
      _alignFoldingHandleRight(this.mx);
    }
  }, {
    key: "mxClient",
    get: function get() {
      return this.mx.mxClient;
    }
  }, {
    key: "mxUtils",
    get: function get() {
      return this.mx.mxUtils;
    }
  }, {
    key: "mxConstants",
    get: function get() {
      return this.mx.mxConstants;
    }
  }, {
    key: "mxEvent",
    get: function get() {
      return this.mx.mxPoint;
    }
  }, {
    key: "mxPerimeter",
    get: function get() {
      return this.mx.mxPerimeter;
    }
  }, {
    key: "mxEdgeStyle",
    get: function get() {
      return this.mx.mxEdgeStyle;
    }
  }, {
    key: "mxEffects",
    get: function get() {
      return this.mx.mxEffects;
    }
  }, {
    key: "mxResources",
    get: function get() {
      return this.mx.mxResources;
    }
  }, {
    key: "mxCodecRegistry",
    get: function get() {
      return this.mx.mxCodecRegistry;
    }
  }]);

  return GraphLib;
}();

function DialogBuilder(t, e, i, n, s, o) {
  var _e$mx = e.mx,
      l = _e$mx.mxClient,
      r = _e$mx.mxUtils,
      a = _e$mx.mxResources,
      h = _e$mx.mxConstants,
      u = _e$mx.mxEvent,
      d = _e$mx.mxPopupMenu,
      p = _e$mx.mxXmlRequest,
      c = _e$mx.mxGraphModel,
      m = _e$mx.mxCodec,
      g = _e$mx.mxEventObject,
      x = _e$mx.mxForm,
      y = _e$mx.mxWindow,
      f = _e$mx.mxCell,
      v = _e$mx.mxRectangle;

  var C = e.editor.graph.constructor,
      E = function E(t, e) {
    var i = document.createElement("div");
    i.style.textAlign = "right";
    var n = document.createElement("textarea");

    if (n.setAttribute("wrap", "off"), n.setAttribute("spellcheck", "false"), n.setAttribute("autocorrect", "off"), n.setAttribute("autocomplete", "off"), n.setAttribute("autocapitalize", "off"), n.style.overflow = "auto", n.style.resize = "none", n.style.width = "600px", n.style.height = "360px", n.style.marginBottom = "16px", n.value = e ? t.domainModel.exportModel() : r.getPrettyXml(t.editor.getGraphXml()), i.appendChild(n), this.init = function () {
      n.focus();
    }, C.fileSupport) {
      n.addEventListener("dragover", function (t) {
        t.stopPropagation(), t.preventDefault();
      }, !1), n.addEventListener("drop", function (e) {
        if (e.stopPropagation(), e.preventDefault(), e.dataTransfer.files.length > 0) {
          var i = e.dataTransfer.files[0],
              s = new FileReader();
          s.onload = function (t) {
            n.value = t.target.result;
          }, s.readAsText(i);
        } else n.value = t.extractGraphModelFromEvent(e);
      }, !1);
    }

    var s = r.button(a.get("cancel"), function () {
      t.hideDialog();
    });
    s.className = "geBtn", t.editor.cancelFirst && i.appendChild(s);
    var o = document.createElement("select");

    if (o.style.width = "180px", o.className = "geBtn", t.editor.graph.isEnabled()) {
      var l = document.createElement("option");
      l.setAttribute("value", "replace"), r.write(l, a.get("replaceExistingDrawing")), o.appendChild(l);
    }

    var h = document.createElement("option");

    if (h.setAttribute("value", "new"), r.write(h, a.get("openInNewWindow")), E.showNewWindowOption && o.appendChild(h), t.editor.graph.isEnabled()) {
      var u = document.createElement("option");
      u.setAttribute("value", "import"), r.write(u, a.get("addToExistingDrawing")), o.appendChild(u);
    }

    i.appendChild(o);
    var d = r.button(a.get("ok"), function () {
      var e = t.editor.graph.zapGremlins(r.trim(n.value)),
          i = null;
      if ("new" == o.value) t.hideDialog(), t.editor.editAsNew(e);else if ("replace" == o.value) {
        t.editor.graph.model.beginUpdate();

        try {
          t.editor.setGraphXml(r.parseXml(e).documentElement), t.hideDialog();
        } catch (t) {
          i = t;
        } finally {
          t.editor.graph.model.endUpdate();
        }
      } else if ("import" == o.value) {
        t.editor.graph.model.beginUpdate();

        try {
          var s = r.parseXml(e),
              l = new c();
          new m(s).decode(s.documentElement, l);
          var a = l.getChildren(l.getChildAt(l.getRoot(), 0));
          t.editor.graph.setSelectionCells(t.editor.graph.importCells(a)), t.hideDialog();
        } catch (t) {
          i = t;
        } finally {
          t.editor.graph.model.endUpdate();
        }
      }
      null != i && r.alert(i.message);
    });
    d.className = "geBtn gePrimaryBtn", i.appendChild(d), t.editor.cancelFirst || i.appendChild(s), this.container = i;
  };

  E.showNewWindowOption = !0;
  return "OutlineWindow" === t ? new function (t, e, i, n, s) {
    var o = t.editor.graph,
        l = document.createElement("div");
    l.style.position = "absolute", l.style.width = "100%", l.style.height = "100%", l.style.border = "1px solid whiteSmoke", l.style.overflow = "hidden", this.window = new y(a.get("outline"), l, e, i, n, s, !0, !0), this.window.minimumSize = new v(0, 0, 80, 80), this.window.destroyOnClose = !1, this.window.setMaximizable(!1), this.window.setResizable(!0), this.window.setClosable(!0), this.window.setVisible(!0), this.window.setLocation = function (t, e) {
      var i = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
          n = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      t = Math.max(0, Math.min(t, i - this.table.clientWidth)), e = Math.max(0, Math.min(e, n - this.table.clientHeight - 48)), this.getX() == t && this.getY() == e || y.prototype.setLocation.apply(this, arguments);
    };
    var d = r.bind(this, function () {
      var t = this.window.getX(),
          e = this.window.getY();
      this.window.setLocation(t, e);
    });
    u.addListener(window, "resize", d);
    var p = t.createOutline(this.window);
    this.destroy = function () {
      u.removeListener(window, "resize", d), this.window.destroy(), p.destroy();
    }, this.window.addListener(u.RESIZE, r.bind(this, function () {
      p.update(!1), p.outline.sizeDidChange();
    })), this.window.addListener(u.SHOW, r.bind(this, function () {
      p.suspended = !1, p.outline.refresh(), p.update();
    })), this.window.addListener(u.HIDE, r.bind(this, function () {
      p.suspended = !0;
    })), this.window.addListener(u.NORMALIZE, r.bind(this, function () {
      p.suspended = !1, p.update();
    })), this.window.addListener(u.MINIMIZE, r.bind(this, function () {
      p.suspended = !0;
    }));
    var c = p.createGraph;

    function m() {
      p.outline.pageScale = o.pageScale, p.outline.pageFormat = o.pageFormat, p.outline.pageVisible = o.pageVisible, p.outline.background = null == o.background || o.background == h.NONE ? o.defaultPageBackgroundColor : o.background;
      var t = r.getCurrentStyle(o.container);
      l.style.backgroundColor = t.backgroundColor, null != o.view.backgroundPageShape && null != p.outline.view.backgroundPageShape && (p.outline.view.backgroundPageShape.fill = o.view.backgroundPageShape.fill), p.outline.refresh();
    }

    if (p.createGraph = function (t) {
      var e = c.apply(this, arguments);
      e.gridEnabled = !1, e.pageScale = o.pageScale, e.pageFormat = o.pageFormat, e.background = null == o.background || o.background == h.NONE ? o.defaultPageBackgroundColor : o.background, e.pageVisible = o.pageVisible;
      var i = r.getCurrentStyle(o.container);
      return l.style.backgroundColor = i.backgroundColor, e;
    }, p.init(l), t.editor.addListener("resetGraphView", m), t.addListener("pageFormatChanged", m), t.addListener("backgroundColorChanged", m), t.addListener("backgroundImageChanged", m), t.addListener("pageViewChanged", function () {
      m(), p.update(!0);
    }), p.outline.dialect == h.DIALECT_SVG) {
      var g = t.actions.get("zoomIn"),
          x = t.actions.get("zoomOut");
      u.addMouseWheelListener(function (t, e) {
        for (var i = !1, n = u.getSource(t); null != n;) {
          if (n == p.outline.view.canvas.ownerSVGElement) {
            i = !0;
            break;
          }

          n = n.parentNode;
        }

        i && (e ? g.funct() : x.funct(), u.consume(t));
      });
    }
  }(e, i, n, s, o) : "EditDiagramDialog" === t ? new E(e) : "EditModelDialog" === t ? new E(e, !0) : void 0;
}

var Editor$1 = {};

function ActionsBuilder(t) {
  var _t$mx = t.mx,
      e = _t$mx.mxClient,
      i = _t$mx.mxUtils,
      n = _t$mx.mxEventSource,
      s = _t$mx.mxResources,
      o = _t$mx.mxEventObject,
      l = _t$mx.mxConstants,
      r = _t$mx.mxClipboard,
      a = _t$mx.mxEvent,
      h = _t$mx.mxCell,
      u = _t$mx.mxEdgeHandler,
      d = _t$mx.mxRectangle,
      p = _t$mx.mxGeometry;

  function c(t) {
    this.editorUi = t, this.actions = new Object(), this.init();
  }

  function m(t, e, i, n, s) {
    this.mx.mxEventSource.call(this), this.label = t, this.funct = this.createFunction(e), this.enabled = null == i || i, this.iconCls = n, this.shortcut = s, this.visible = !0;
  }

  return Editor$1.ctrlKey = e.IS_MAC ? "Cmd" : "Ctrl", c.prototype.init = function () {
    var t = this.editorUi,
        n = t.editor,
        c = n.graph,
        g = function g() {
      return m.prototype.isEnabled.apply(this, arguments) && c.isEnabled();
    };

    function x(t) {
      c.escape();
      var e = c.getDeletableCells(c.getSelectionCells());

      if (null != e && e.length > 0) {
        var i = c.model.getParents(e);

        if (c.removeCells(e, t), null != i) {
          for (var n = [], s = 0; s < i.length; s++) {
            c.model.contains(i[s]) && (c.model.isVertex(i[s]) || c.model.isEdge(i[s])) && n.push(i[s]);
          }

          c.setSelectionCells(n);
        }
      }
    }

    this.addAction("new...", function () {
      c.openLink(t.getUrl());
    }), this.addAction("open...", function () {
      window.openNew = !0, window.openKey = "open", t.openFile();
    }), this.addAction("import...", function () {
      window.openNew = !1, window.openKey = "import", window.openFile = new OpenFile(i.bind(this, function () {
        t.hideDialog();
      })), window.openFile.setConsumer(i.bind(this, function (t, e) {
        try {
          var o = i.parseXml(t);
          n.graph.setSelectionCells(n.graph.importGraphModel(o.documentElement));
        } catch (t) {
          i.alert(s.get("invalidOrMissingFile") + ": " + t.message);
        }
      })), t.showDialog(new OpenDialog(this).container, 320, 220, !0, !0, function () {
        window.openFile = null;
      });
    }).isEnabled = g, this.addAction("save", function () {
      t.saveFile(!1);
    }, null, null, Editor$1.ctrlKey + "+S").isEnabled = g, this.addAction("saveAs...", function () {
      t.saveFile(!0);
    }, null, null, Editor$1.ctrlKey + "+Shift+S").isEnabled = g, this.addAction("export...", function () {
      t.showDialog(new ExportDialog(t).container, 300, 230, !0, !0);
    }), this.addAction("editDiagram...", function () {
      var e = new DialogBuilder("EditDiagramDialog", t);
      t.showDialog(e.container, 620, 420, !0, !1), e.init();
    }), this.addAction("editModelData...", function () {
      var e = new DialogBuilder("EditModelDialog", t);
      t.showDialog(e.container, 620, 420, !0, !1), e.init();
    }), this.addAction("pageSetup...", function () {
      t.showDialog(new PageSetupDialog(t).container, 320, 220, !0, !0);
    }).isEnabled = g, this.addAction("print...", function () {
      t.showDialog(new PrintDialog(t).container, 300, 180, !0, !0);
    }, null, "sprite-print", Editor$1.ctrlKey + "+P"), this.addAction("preview", function () {
      i.show(c, null, 10, 10);
    }), this.addAction("undo", function () {
      t.undo();
    }, null, "sprite-undo", Editor$1.ctrlKey + "+Z"), this.addAction("redo", function () {
      t.redo();
    }, null, "sprite-redo", e.IS_WIN ? Editor$1.ctrlKey + "+Y" : Editor$1.ctrlKey + "+Shift+Z"), this.addAction("cut", function () {
      r.cut(c);
    }, null, "sprite-cut", Editor$1.ctrlKey + "+X"), this.addAction("copy", function () {
      r.copy(c);
    }, null, "sprite-copy", Editor$1.ctrlKey + "+C"), this.addAction("paste", function () {
      c.isEnabled() && !c.isCellLocked(c.getDefaultParent()) && r.paste(c);
    }, !1, "sprite-paste", Editor$1.ctrlKey + "+V"), this.addAction("pasteHere", function (t) {
      if (c.isEnabled() && !c.isCellLocked(c.getDefaultParent())) {
        c.getModel().beginUpdate();

        try {
          var e = r.paste(c);

          if (null != e) {
            for (var i = !0, n = 0; n < e.length && i; n++) {
              i = i && c.model.isEdge(e[n]);
            }

            var s = c.view.translate,
                o = c.view.scale,
                l = s.x,
                a = s.y,
                h = null;

            if (1 == e.length && i) {
              var u = c.getCellGeometry(e[0]);
              null != u && (h = u.getTerminalPoint(!0));
            }

            if (null != (h = null != h ? h : c.getBoundingBoxFromGeometry(e, i))) {
              var d = Math.round(c.snap(c.popupMenuHandler.triggerX / o - l)),
                  p = Math.round(c.snap(c.popupMenuHandler.triggerY / o - a));
              c.cellsMoved(e, d - h.x, p - h.y);
            }
          }
        } finally {
          c.getModel().endUpdate();
        }
      }
    }), this.addAction("copySize", function (e) {
      var i = c.getSelectionCell();

      if (c.isEnabled() && null != i && c.getModel().isVertex(i)) {
        var n = c.getCellGeometry(i);
        null != n && (t.copiedSize = new d(n.x, n.y, n.width, n.height));
      }
    }, null, null, "Alt+Shit+X"), this.addAction("pasteSize", function (e) {
      if (c.isEnabled() && !c.isSelectionEmpty() && null != t.copiedSize) {
        c.getModel().beginUpdate();

        try {
          for (var i = c.getSelectionCells(), n = 0; n < i.length; n++) {
            if (c.getModel().isVertex(i[n])) {
              var s = c.getCellGeometry(i[n]);
              null != s && ((s = s.clone()).width = t.copiedSize.width, s.height = t.copiedSize.height, c.getModel().setGeometry(i[n], s));
            }
          }
        } finally {
          c.getModel().endUpdate();
        }
      }
    }, null, null, "Alt+Shit+V"), this.addAction("delete", function (t) {
      x(null != t && a.isShiftDown(t));
    }, null, null, "Delete"), this.addAction("deleteAll", function () {
      x(!0);
    }, null, null, Editor$1.ctrlKey + "+Delete"), this.addAction("duplicate", function () {
      c.setSelectionCells(c.duplicateCells());
    }, null, null, Editor$1.ctrlKey + "+D"), this.put("turn", new m(s.get("turn") + " / " + s.get("reverse"), function () {
      c.turnShapes(c.getSelectionCells());
    }, null, null, Editor$1.ctrlKey + "+R")), this.addAction("selectVertices", function () {
      c.selectVertices();
    }, null, null, Editor$1.ctrlKey + "+Shift+I"), this.addAction("selectEdges", function () {
      c.selectEdges();
    }, null, null, Editor$1.ctrlKey + "+Shift+E"), this.addAction("selectAll", function () {
      c.selectAll(null, !0);
    }, null, null, Editor$1.ctrlKey + "+A"), this.addAction("selectNone", function () {
      c.clearSelection();
    }, null, null, Editor$1.ctrlKey + "+Shift+A"), this.addAction("lockUnlock", function () {
      if (!c.isSelectionEmpty()) {
        c.getModel().beginUpdate();

        try {
          var t = c.isCellMovable(c.getSelectionCell()) ? 1 : 0;
          c.toggleCellStyles(l.STYLE_MOVABLE, t), c.toggleCellStyles(l.STYLE_RESIZABLE, t), c.toggleCellStyles(l.STYLE_ROTATABLE, t), c.toggleCellStyles(l.STYLE_DELETABLE, t), c.toggleCellStyles(l.STYLE_EDITABLE, t), c.toggleCellStyles("connectable", t);
        } finally {
          c.getModel().endUpdate();
        }
      }
    }, null, null, Editor$1.ctrlKey + "+L"), this.addAction("home", function () {
      c.home();
    }, null, null, "Home"), this.addAction("exitGroup", function () {
      c.exitGroup();
    }, null, null, Editor$1.ctrlKey + "+Shift+Home"), this.addAction("enterGroup", function () {
      c.enterGroup();
    }, null, null, Editor$1.ctrlKey + "+Shift+End"), this.addAction("collapse", function () {
      c.foldCells(!0);
    }, null, null, Editor$1.ctrlKey + "+Home"), this.addAction("expand", function () {
      c.foldCells(!1);
    }, null, null, Editor$1.ctrlKey + "+End"), this.addAction("toFront", function () {
      c.orderCells(!1);
    }, null, null, Editor$1.ctrlKey + "+Shift+F"), this.addAction("toBack", function () {
      c.orderCells(!0);
    }, null, null, Editor$1.ctrlKey + "+Shift+B"), this.addAction("group", function () {
      1 == c.getSelectionCount() ? c.setCellStyles("container", "1") : c.setSelectionCell(c.groupCells(null, 0));
    }, null, null, Editor$1.ctrlKey + "+G"), this.addAction("ungroup", function () {
      1 == c.getSelectionCount() && 0 == c.getModel().getChildCount(c.getSelectionCell()) ? c.setCellStyles("container", "0") : c.setSelectionCells(c.ungroupCells());
    }, null, null, Editor$1.ctrlKey + "+Shift+U"), this.addAction("removeFromGroup", function () {
      c.removeCellsFromParent();
    }), this.addAction("edit", function () {
      c.isEnabled() && c.startEditingAtCell();
    }, null, null, "F2/Enter"), this.addAction("editData...", function () {
      var e = c.getSelectionCell() || c.getModel().getRoot();
      t.showDataDialog(e);
    }, null, null, Editor$1.ctrlKey + "+M"), this.addAction("editTooltip...", function () {
      var e = t.editor.graph;

      if (e.isEnabled() && !e.isSelectionEmpty()) {
        var n = e.getSelectionCell(),
            o = "";

        if (i.isNode(n.value)) {
          var l = n.value.getAttribute("tooltip");
          null != l && (o = l);
        }

        var r = new TextareaDialog(t, s.get("editTooltip") + ":", o, function (t) {
          e.setTooltipForCell(n, t);
        });
        t.showDialog(r.container, 320, 200, !0, !0), r.init();
      }
    }, null, null, "Alt+Shift+T"), this.addAction("openLink", function () {
      var t = c.getLinkForCell(c.getSelectionCell());
      null != t && c.openLink(t);
    }), this.addAction("editLink...", function () {
      var e = t.editor.graph;

      if (e.isEnabled() && !e.isSelectionEmpty()) {
        var n = e.getSelectionCell(),
            o = e.getLinkForCell(n) || "";
        t.showLinkDialog(o, s.get("apply"), function (t) {
          t = i.trim(t), e.setLinkForCell(n, t.length > 0 ? t : null);
        });
      }
    }, null, null, "Alt+Shift+L"), this.addAction("insertLink...", function () {
      c.isEnabled() && !c.isCellLocked(c.getDefaultParent()) && t.showLinkDialog("", s.get("insert"), function (t, e) {
        if ((t = i.trim(t)).length > 0) {
          var n = null,
              s = c.getLinkTitle(t);
          null != e && e.length > 0 && (n = e[0].iconUrl, (s = (s = e[0].name || e[0].type).charAt(0).toUpperCase() + s.substring(1)).length > 30 && (s = s.substring(0, 30) + "..."));
          var l = c.getFreeInsertPoint(),
              r = new h(s, new p(l.x, l.y, 100, 40), "fontColor=#0000EE;fontStyle=4;rounded=1;overflow=hidden;" + (null != n ? "shape=label;imageWidth=16;imageHeight=16;spacingLeft=26;align=left;image=" + n : "spacing=10;"));
          r.vertex = !0, c.setLinkForCell(r, t), c.cellSizeUpdated(r, !0), c.getModel().beginUpdate();

          try {
            r = c.addCell(r), c.fireEvent(new o("cellsInserted", "cells", [r]));
          } finally {
            c.getModel().endUpdate();
          }

          c.setSelectionCell(r), c.scrollCellToVisible(c.getSelectionCell());
        }
      });
    }).isEnabled = g, this.addAction("link...", i.bind(this, function () {
      var e = t.editor.graph;
      if (e.isEnabled()) if (e.cellEditor.isContentEditing()) {
        var n = e.getSelectedElement(),
            o = e.getParentByName(n, "A", e.cellEditor.textarea),
            l = "";
        if (null == o && null != n && null != n.getElementsByTagName) for (var r = n.getElementsByTagName("a"), a = 0; a < r.length && null == o; a++) {
          r[a].textContent == n.textContent && (e.selectNode(r[a]), o = r[a]);
        }
        null != o && "A" == o.nodeName && (l = o.getAttribute("href") || "");
        var h = e.cellEditor.saveSelection();
        t.showLinkDialog(l, s.get("apply"), i.bind(this, function (t) {
          e.cellEditor.restoreSelection(h), null != t && e.insertLink(t);
        }));
      } else e.isSelectionEmpty() ? this.get("insertLink").funct() : this.get("editLink").funct();
    })).isEnabled = g, this.addAction("autosize", function () {
      var t = c.getSelectionCells();

      if (null != t) {
        c.getModel().beginUpdate();

        try {
          for (var e = 0; e < t.length; e++) {
            var i = t[e];
            if (c.getModel().getChildCount(i)) c.updateGroupBounds([i], 20);else {
              var n = c.view.getState(i),
                  s = c.getCellGeometry(i);
              c.getModel().isVertex(i) && null != n && null != n.text && null != s && c.isWrapping(i) ? ((s = s.clone()).height = n.text.boundingBox.height / c.view.scale, c.getModel().setGeometry(i, s)) : c.updateCellSize(i);
            }
          }
        } finally {
          c.getModel().endUpdate();
        }
      }
    }, null, null, Editor$1.ctrlKey + "+Shift+Y"), this.addAction("formattedText", function () {
      var e = c.getView().getState(c.getSelectionCell());

      if (null != e) {
        var n = "1";
        c.stopEditing(), c.getModel().beginUpdate();

        try {
          if ("1" == e.style.html) {
            n = null;
            var s = c.convertValueToString(e.cell);
            "0" != i.getValue(e.style, "nl2Br", "1") && (s = s.replace(/\n/g, "").replace(/<br\s*.?>/g, "\n"));
            var l = document.createElement("div");
            l.innerHTML = s, s = i.extractTextWithWhitespace(l.childNodes), c.cellLabelChanged(e.cell, s);
          } else {
            s = i.htmlEntities(c.convertValueToString(e.cell), !1);
            "0" != i.getValue(e.style, "nl2Br", "1") && (s = s.replace(/\n/g, "<br/>")), c.cellLabelChanged(e.cell, c.sanitizeHtml(s));
          }

          c.setCellStyles("html", n), t.fireEvent(new o("styleChanged", "keys", ["html"], "values", [null != n ? n : "0"], "cells", c.getSelectionCells()));
        } finally {
          c.getModel().endUpdate();
        }
      }
    }), this.addAction("wordWrap", function () {
      var t = c.getView().getState(c.getSelectionCell()),
          e = "wrap";
      c.stopEditing(), null != t && "wrap" == t.style[l.STYLE_WHITE_SPACE] && (e = null), c.setCellStyles(l.STYLE_WHITE_SPACE, e);
    }), this.addAction("rotation", function () {
      var e = "0",
          i = c.getView().getState(c.getSelectionCell());
      null != i && (e = i.style[l.STYLE_ROTATION] || e);
      var n = new FilenameDialog(t, e, s.get("apply"), function (t) {
        null != t && t.length > 0 && c.setCellStyles(l.STYLE_ROTATION, t);
      }, s.get("enterValue") + " (" + s.get("rotation") + " 0-360)");
      t.showDialog(n.container, 375, 80, !0, !0), n.init();
    }), this.addAction("resetView", function () {
      c.zoomTo(1), t.resetScrollbars();
    }, null, null, Editor$1.ctrlKey + "+H"), this.addAction("zoomIn", function (t) {
      c.zoomIn();
    }, null, null, Editor$1.ctrlKey + " + (Numpad) / Alt+Mousewheel"), this.addAction("zoomOut", function (t) {
      c.zoomOut();
    }, null, null, Editor$1.ctrlKey + " - (Numpad) / Alt+Mousewheel"), this.addAction("fitWindow", function () {
      c.fit();
    }, null, null, Editor$1.ctrlKey + "+Shift+H"), this.addAction("fitPage", i.bind(this, function () {
      c.pageVisible || this.get("pageView").funct();
      var t = c.pageFormat,
          e = c.pageScale,
          n = c.container.clientWidth - 10,
          s = c.container.clientHeight - 10,
          o = Math.floor(20 * Math.min(n / t.width / e, s / t.height / e)) / 20;

      if (c.zoomTo(o), i.hasScrollbars(c.container)) {
        var l = c.getPagePadding();
        c.container.scrollTop = l.y * c.view.scale - 1, c.container.scrollLeft = Math.min(l.x * c.view.scale, (c.container.scrollWidth - c.container.clientWidth) / 2) - 1;
      }
    }), null, null, Editor$1.ctrlKey + "+J"), this.addAction("fitTwoPages", i.bind(this, function () {
      c.pageVisible || this.get("pageView").funct();
      var t = c.pageFormat,
          e = c.pageScale,
          n = c.container.clientWidth - 10,
          s = c.container.clientHeight - 10,
          o = Math.floor(20 * Math.min(n / (2 * t.width) / e, s / t.height / e)) / 20;

      if (c.zoomTo(o), i.hasScrollbars(c.container)) {
        var l = c.getPagePadding();
        c.container.scrollTop = Math.min(l.y, (c.container.scrollHeight - c.container.clientHeight) / 2), c.container.scrollLeft = Math.min(l.x, (c.container.scrollWidth - c.container.clientWidth) / 2);
      }
    }), null, null, Editor$1.ctrlKey + "+Shift+J"), this.addAction("fitPageWidth", i.bind(this, function () {
      c.pageVisible || this.get("pageView").funct();
      var t = c.pageFormat,
          e = c.pageScale,
          n = c.container.clientWidth - 10,
          s = Math.floor(20 * n / t.width / e) / 20;

      if (c.zoomTo(s), i.hasScrollbars(c.container)) {
        var o = c.getPagePadding();
        c.container.scrollLeft = Math.min(o.x * c.view.scale, (c.container.scrollWidth - c.container.clientWidth) / 2);
      }
    })), this.put("customZoom", new m(s.get("custom") + "...", i.bind(this, function () {
      var t = new FilenameDialog(this.editorUi, parseInt(100 * c.getView().getScale()), s.get("apply"), i.bind(this, function (t) {
        var e = parseInt(t);
        !isNaN(e) && e > 0 && c.zoomTo(e / 100);
      }), s.get("zoom") + " (%)");
      this.editorUi.showDialog(t.container, 300, 80, !0, !0), t.init();
    }), null, null, Editor$1.ctrlKey + "+0")), this.addAction("pageScale...", i.bind(this, function () {
      var e = new FilenameDialog(this.editorUi, parseInt(100 * c.pageScale), s.get("apply"), i.bind(this, function (e) {
        var i = parseInt(e);
        !isNaN(i) && i > 0 && t.setPageScale(i / 100);
      }), s.get("pageScale") + " (%)");
      this.editorUi.showDialog(e.container, 300, 80, !0, !0), e.init();
    }));
    var y = null;
    (y = this.addAction("grid", function () {
      c.setGridEnabled(!c.isGridEnabled()), t.fireEvent(new o("gridEnabledChanged"));
    }, null, null, Editor$1.ctrlKey + "+Shift+G")).setToggleAction(!0), y.setSelectedCallback(function () {
      return c.isGridEnabled();
    }), y.setEnabled(!1), (y = this.addAction("guides", function () {
      c.graphHandler.guidesEnabled = !c.graphHandler.guidesEnabled, t.fireEvent(new o("guidesEnabledChanged"));
    })).setToggleAction(!0), y.setSelectedCallback(function () {
      return c.graphHandler.guidesEnabled;
    }), y.setEnabled(!1), (y = this.addAction("tooltips", function () {
      c.tooltipHandler.setEnabled(!c.tooltipHandler.isEnabled());
    })).setToggleAction(!0), y.setSelectedCallback(function () {
      return c.tooltipHandler.isEnabled();
    }), (y = this.addAction("collapseExpand", function () {
      var e = new ChangePageSetup(t);
      e.ignoreColor = !0, e.ignoreImage = !0, e.foldingEnabled = !c.foldingEnabled, c.model.execute(e);
    })).setToggleAction(!0), y.setSelectedCallback(function () {
      return c.foldingEnabled;
    }), y.isEnabled = g, (y = this.addAction("scrollbars", function () {
      t.setScrollbars(!t.hasScrollbars());
    })).setToggleAction(!0), y.setSelectedCallback(function () {
      return c.scrollbars;
    }), (y = this.addAction("pageView", i.bind(this, function () {
      t.setPageVisible(!c.pageVisible);
    }))).setToggleAction(!0), y.setSelectedCallback(function () {
      return c.pageVisible;
    }), (y = this.addAction("connectionArrows", function () {
      c.connectionArrowsEnabled = !c.connectionArrowsEnabled, t.fireEvent(new o("connectionArrowsChanged"));
    }, null, null, "Alt+Shift+A")).setToggleAction(!0), y.setSelectedCallback(function () {
      return c.connectionArrowsEnabled;
    }), (y = this.addAction("connectionPoints", function () {
      c.setConnectable(!c.connectionHandler.isEnabled()), t.fireEvent(new o("connectionPointsChanged"));
    }, null, null, "Alt+Shift+P")).setToggleAction(!0), y.setSelectedCallback(function () {
      return c.connectionHandler.isEnabled();
    }), (y = this.addAction("copyConnect", function () {
      c.connectionHandler.setCreateTarget(!c.connectionHandler.isCreateTarget()), t.fireEvent(new o("copyConnectChanged"));
    })).setToggleAction(!0), y.setSelectedCallback(function () {
      return c.connectionHandler.isCreateTarget();
    }), y.isEnabled = g, (y = this.addAction("autosave", function () {
      t.editor.setAutosave(!t.editor.autosave);
    })).setToggleAction(!0), y.setSelectedCallback(function () {
      return t.editor.autosave;
    }), y.isEnabled = g, y.visible = !1, this.addAction("help", function () {
      var t = "";
      s.isLanguageSupported(e.language) && (t = "_" + e.language), c.openLink(RESOURCES_PATH + "/help" + t + ".html");
    });
    var f = !1;
    this.put("about", new m(s.get("about") + " Graph Editor...", function () {
      f || (t.showDialog(new AboutDialog(t).container, 320, 280, !0, !0, function () {
        f = !1;
      }), f = !0);
    }, null, null, "F1"));
    var v = i.bind(this, function (t, e, i, n) {
      return this.addAction(t, function () {
        if (null != i && c.cellEditor.isContentEditing()) i();else {
          c.stopEditing(!1), c.getModel().beginUpdate();

          try {
            c.toggleCellStyleFlags(l.STYLE_FONTSTYLE, e), (e & l.FONT_BOLD) == l.FONT_BOLD ? c.updateLabelElements(c.getSelectionCells(), function (t) {
              t.style.fontWeight = null, "B" == t.nodeName && c.replaceElement(t);
            }) : (e & l.FONT_ITALIC) == l.FONT_ITALIC ? c.updateLabelElements(c.getSelectionCells(), function (t) {
              t.style.fontStyle = null, "I" == t.nodeName && c.replaceElement(t);
            }) : (e & l.FONT_UNDERLINE) == l.FONT_UNDERLINE && c.updateLabelElements(c.getSelectionCells(), function (t) {
              t.style.textDecoration = null, "U" == t.nodeName && c.replaceElement(t);
            });
          } finally {
            c.getModel().endUpdate();
          }
        }
      }, null, null, n);
    });
    v("bold", l.FONT_BOLD, function () {
      document.execCommand("bold", !1, null);
    }, Editor$1.ctrlKey + "+B"), v("italic", l.FONT_ITALIC, function () {
      document.execCommand("italic", !1, null);
    }, Editor$1.ctrlKey + "+I"), v("underline", l.FONT_UNDERLINE, function () {
      document.execCommand("underline", !1, null);
    }, Editor$1.ctrlKey + "+U"), this.addAction("fontColor...", function () {
      t.menus.pickColor(l.STYLE_FONTCOLOR, "forecolor", "000000");
    }), this.addAction("strokeColor...", function () {
      t.menus.pickColor(l.STYLE_STROKECOLOR);
    }), this.addAction("fillColor...", function () {
      t.menus.pickColor(l.STYLE_FILLCOLOR);
    }), this.addAction("gradientColor...", function () {
      t.menus.pickColor(l.STYLE_GRADIENTCOLOR);
    }), this.addAction("backgroundColor...", function () {
      t.menus.pickColor(l.STYLE_LABEL_BACKGROUNDCOLOR, "backcolor");
    }), this.addAction("borderColor...", function () {
      t.menus.pickColor(l.STYLE_LABEL_BORDERCOLOR);
    }), this.addAction("vertical", function () {
      t.menus.toggleStyle(l.STYLE_HORIZONTAL, !0);
    }), this.addAction("shadow", function () {
      t.menus.toggleStyle(l.STYLE_SHADOW);
    }), this.addAction("solid", function () {
      c.getModel().beginUpdate();

      try {
        c.setCellStyles(l.STYLE_DASHED, null), c.setCellStyles(l.STYLE_DASH_PATTERN, null), t.fireEvent(new o("styleChanged", "keys", [l.STYLE_DASHED, l.STYLE_DASH_PATTERN], "values", [null, null], "cells", c.getSelectionCells()));
      } finally {
        c.getModel().endUpdate();
      }
    }), this.addAction("dashed", function () {
      c.getModel().beginUpdate();

      try {
        c.setCellStyles(l.STYLE_DASHED, "1"), c.setCellStyles(l.STYLE_DASH_PATTERN, null), t.fireEvent(new o("styleChanged", "keys", [l.STYLE_DASHED, l.STYLE_DASH_PATTERN], "values", ["1", null], "cells", c.getSelectionCells()));
      } finally {
        c.getModel().endUpdate();
      }
    }), this.addAction("dotted", function () {
      c.getModel().beginUpdate();

      try {
        c.setCellStyles(l.STYLE_DASHED, "1"), c.setCellStyles(l.STYLE_DASH_PATTERN, "1 4"), t.fireEvent(new o("styleChanged", "keys", [l.STYLE_DASHED, l.STYLE_DASH_PATTERN], "values", ["1", "1 4"], "cells", c.getSelectionCells()));
      } finally {
        c.getModel().endUpdate();
      }
    }), this.addAction("sharp", function () {
      c.getModel().beginUpdate();

      try {
        c.setCellStyles(l.STYLE_ROUNDED, "0"), c.setCellStyles(l.STYLE_CURVED, "0"), t.fireEvent(new o("styleChanged", "keys", [l.STYLE_ROUNDED, l.STYLE_CURVED], "values", ["0", "0"], "cells", c.getSelectionCells()));
      } finally {
        c.getModel().endUpdate();
      }
    }), this.addAction("rounded", function () {
      c.getModel().beginUpdate();

      try {
        c.setCellStyles(l.STYLE_ROUNDED, "1"), c.setCellStyles(l.STYLE_CURVED, "0"), t.fireEvent(new o("styleChanged", "keys", [l.STYLE_ROUNDED, l.STYLE_CURVED], "values", ["1", "0"], "cells", c.getSelectionCells()));
      } finally {
        c.getModel().endUpdate();
      }
    }), this.addAction("toggleRounded", function () {
      if (!c.isSelectionEmpty() && c.isEnabled()) {
        c.getModel().beginUpdate();

        try {
          var e = c.getSelectionCells(),
              n = c.view.getState(e[0]),
              s = null != n ? n.style : c.getCellStyle(e[0]),
              r = "1" == i.getValue(s, l.STYLE_ROUNDED, "0") ? "0" : "1";
          c.setCellStyles(l.STYLE_ROUNDED, r), c.setCellStyles(l.STYLE_CURVED, null), t.fireEvent(new o("styleChanged", "keys", [l.STYLE_ROUNDED, l.STYLE_CURVED], "values", [r, "0"], "cells", c.getSelectionCells()));
        } finally {
          c.getModel().endUpdate();
        }
      }
    }), this.addAction("curved", function () {
      c.getModel().beginUpdate();

      try {
        c.setCellStyles(l.STYLE_ROUNDED, "0"), c.setCellStyles(l.STYLE_CURVED, "1"), t.fireEvent(new o("styleChanged", "keys", [l.STYLE_ROUNDED, l.STYLE_CURVED], "values", ["0", "1"], "cells", c.getSelectionCells()));
      } finally {
        c.getModel().endUpdate();
      }
    }), this.addAction("collapsible", function () {
      var e = c.view.getState(c.getSelectionCell()),
          i = "1";
      null != e && null != c.getFoldingImage(e) && (i = "0"), c.setCellStyles("collapsible", i), t.fireEvent(new o("styleChanged", "keys", ["collapsible"], "values", [i], "cells", c.getSelectionCells()));
    }), this.addAction("editStyle...", i.bind(this, function () {
      var t = c.getSelectionCells();

      if (null != t && t.length > 0) {
        var e = c.getModel(),
            n = new TextareaDialog(this.editorUi, s.get("editStyle") + ":", e.getStyle(t[0]) || "", function (e) {
          null != e && c.setCellStyle(i.trim(e), t);
        }, null, null, 400, 220);
        this.editorUi.showDialog(n.container, 420, 300, !0, !0), n.init();
      }
    }), null, null, Editor$1.ctrlKey + "+E"), this.addAction("setAsDefaultStyle", function () {
      c.isEnabled() && !c.isSelectionEmpty() && t.setDefaultStyle(c.getSelectionCell());
    }, null, null, Editor$1.ctrlKey + "+Shift+D"), this.addAction("clearDefaultStyle", function () {
      c.isEnabled() && t.clearDefaultStyle();
    }, null, null, Editor$1.ctrlKey + "+Shift+R"), this.addAction("addWaypoint", function () {
      var t = c.getSelectionCell();

      if (null != t && c.getModel().isEdge(t)) {
        var e = n.graph.selectionCellsHandler.getHandler(t);

        if (e instanceof u) {
          for (var i = c.view.translate, s = c.view.scale, o = i.x, l = i.y, r = c.getModel().getParent(t), a = c.getCellGeometry(r); c.getModel().isVertex(r) && null != a;) {
            o += a.x, l += a.y, r = c.getModel().getParent(r), a = c.getCellGeometry(r);
          }

          var h = Math.round(c.snap(c.popupMenuHandler.triggerX / s - o)),
              d = Math.round(c.snap(c.popupMenuHandler.triggerY / s - l));
          e.addPointAt(e.state, h, d);
        }
      }
    }), this.addAction("removeWaypoint", function () {
      var e = t.actions.get("removeWaypoint");
      null != e.handler && e.handler.removePoint(e.handler.state, e.index);
    }), this.addAction("clearWaypoints", function () {
      var t = c.getSelectionCells();

      if (null != t) {
        t = c.addAllEdges(t), c.getModel().beginUpdate();

        try {
          for (var e = 0; e < t.length; e++) {
            var i = t[e];

            if (c.getModel().isEdge(i)) {
              var n = c.getCellGeometry(i);
              null != n && ((n = n.clone()).points = null, c.getModel().setGeometry(i, n));
            }
          }
        } finally {
          c.getModel().endUpdate();
        }
      }
    }, null, null, "Alt+Shift+C"), y = this.addAction("subscript", i.bind(this, function () {
      c.cellEditor.isContentEditing() && document.execCommand("subscript", !1, null);
    }), null, null, Editor$1.ctrlKey + "+,"), y = this.addAction("superscript", i.bind(this, function () {
      c.cellEditor.isContentEditing() && document.execCommand("superscript", !1, null);
    }), null, null, Editor$1.ctrlKey + "+."), this.addAction("image...", function () {
      if (c.isEnabled() && !c.isCellLocked(c.getDefaultParent())) {
        var e = s.get("image") + " (" + s.get("url") + "):",
            i = c.getView().getState(c.getSelectionCell()),
            n = "";
        null != i && (n = i.style[l.STYLE_IMAGE] || n);
        var r = c.cellEditor.saveSelection();
        t.showImageDialog(e, n, function (t, e, i) {
          if (c.cellEditor.isContentEditing()) c.cellEditor.restoreSelection(r), c.insertImage(t, e, i);else {
            var n = c.getSelectionCells();

            if (null != t && (t.length > 0 || n.length > 0)) {
              var s = null;
              c.getModel().beginUpdate();

              try {
                if (0 == n.length) {
                  var a = c.getFreeInsertPoint();
                  s = n = [c.insertVertex(c.getDefaultParent(), null, "", a.x, a.y, e, i, "shape=image;imageAspect=0;aspect=fixed;verticalLabelPosition=bottom;verticalAlign=top;")], c.fireEvent(new o("cellsInserted", "cells", s));
                }

                c.setCellStyles(l.STYLE_IMAGE, t.length > 0 ? t : null, n);
                var h = c.view.getState(n[0]),
                    u = null != h ? h.style : c.getCellStyle(n[0]);

                if ("image" != u[l.STYLE_SHAPE] && "label" != u[l.STYLE_SHAPE] ? c.setCellStyles(l.STYLE_SHAPE, "image", n) : 0 == t.length && c.setCellStyles(l.STYLE_SHAPE, null, n), 1 == c.getSelectionCount() && null != e && null != i) {
                  var d = n[0],
                      p = c.getModel().getGeometry(d);
                  null != p && ((p = p.clone()).width = e, p.height = i, c.getModel().setGeometry(d, p));
                }
              } finally {
                c.getModel().endUpdate();
              }

              null != s && (c.setSelectionCells(s), c.scrollCellToVisible(s[0]));
            }
          }
        }, c.cellEditor.isContentEditing(), !c.cellEditor.isContentEditing());
      }
    }).isEnabled = g, this.addAction("insertImage...", function () {
      c.isEnabled() && !c.isCellLocked(c.getDefaultParent()) && (c.clearSelection(), t.actions.get("image").funct());
    }).isEnabled = g, (y = this.addAction("layers", i.bind(this, function () {
      null == this.layersWindow ? (this.layersWindow = new LayersWindow(t, document.body.offsetWidth - 280, 120, 220, 180), this.layersWindow.window.addListener("show", function () {
        t.fireEvent(new o("layers"));
      }), this.layersWindow.window.addListener("hide", function () {
        t.fireEvent(new o("layers"));
      }), this.layersWindow.window.setVisible(!0), t.fireEvent(new o("layers"))) : this.layersWindow.window.setVisible(!this.layersWindow.window.isVisible());
    }), null, null, Editor$1.ctrlKey + "+Shift+L")).setToggleAction(!0), y.setSelectedCallback(i.bind(this, function () {
      return null != this.layersWindow && this.layersWindow.window.isVisible();
    })), (y = this.addAction("formatPanel", i.bind(this, function () {
      t.toggleFormatPanel();
    }), null, null, Editor$1.ctrlKey + "+Shift+P")).setToggleAction(!0), y.setSelectedCallback(i.bind(this, function () {
      return t.formatWidth > 0;
    })), (y = this.addAction("outline", i.bind(this, function () {
      null == this.outlineWindow ? (this.outlineWindow = new DialogBuilder("OutlineWindow", t, document.body.offsetWidth - 260, 100, 180, 180), this.outlineWindow.window.addListener("show", function () {
        t.fireEvent(new o("outline"));
      }), this.outlineWindow.window.addListener("hide", function () {
        t.fireEvent(new o("outline"));
      }), this.outlineWindow.window.setVisible(!0), t.fireEvent(new o("outline"))) : this.outlineWindow.window.setVisible(!this.outlineWindow.window.isVisible());
    }), null, null, Editor$1.ctrlKey + "+Shift+O")).setToggleAction(!0), y.setSelectedCallback(i.bind(this, function () {
      return null != this.outlineWindow && this.outlineWindow.window.isVisible();
    }));
  }, c.prototype.addAction = function (t, e, i, n, o) {
    var l;
    return "..." == t.substring(t.length - 3) ? (t = t.substring(0, t.length - 3), l = s.get(t) + "...") : l = s.get(t), this.put(t, new m(l, e, i, n, o));
  }, c.prototype.put = function (t, e) {
    return this.actions[t] = e, e;
  }, c.prototype.get = function (t) {
    return this.actions[t];
  }, i.extend(m, n), m.prototype.createFunction = function (t) {
    return t;
  }, m.prototype.setEnabled = function (t) {
    this.enabled != t && (this.enabled = t, this.fireEvent(new o("stateChanged")));
  }, m.prototype.isEnabled = function () {
    return this.enabled;
  }, m.prototype.setToggleAction = function (t) {
    this.toggleAction = t;
  }, m.prototype.setSelectedCallback = function (t) {
    this.selectedCallback = t;
  }, m.prototype.isSelected = function () {
    return this.selectedCallback();
  }, new c(t);
}

function ToolbarBuilder(t, e) {
  var _t$mx2 = t.mx,
      i = _t$mx2.mxClient,
      n = _t$mx2.mxUtils,
      s = _t$mx2.mxResources,
      o = _t$mx2.mxConstants,
      l = _t$mx2.mxEvent,
      r = _t$mx2.mxPopupMenu,
      a = t;

  function h(t, e) {
    this.editorUi = t, this.container = e, this.staticElements = [], this.init(), this.gestureHandler = n.bind(this, function (t) {
      null != this.editorUi.currentMenu && l.getSource(t) != this.editorUi.currentMenu.div && this.hideMenu();
    }), l.addGestureListeners(document, this.gestureHandler);
  }

  return h.prototype.dropdownImage = i.IS_SVG ? "data:image/gif;base64,R0lGODlhDQANAIABAHt7e////yH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS4wLWMwNjAgNjEuMTM0Nzc3LCAyMDEwLzAyLzEyLTE3OjMyOjAwICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCREM1NkJFMjE0NEMxMUU1ODk1Q0M5MjQ0MTA4QjNDMSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCREM1NkJFMzE0NEMxMUU1ODk1Q0M5MjQ0MTA4QjNDMSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkQzOUMzMjZCMTQ0QjExRTU4OTVDQzkyNDQxMDhCM0MxIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkQzOUMzMjZDMTQ0QjExRTU4OTVDQzkyNDQxMDhCM0MxIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEAQAAAQAsAAAAAA0ADQAAAhGMj6nL3QAjVHIu6azbvPtWAAA7" : IMAGE_PATH + "/dropdown.gif", h.prototype.dropdownImageHtml = '<img border="0" style="position:absolute;right:4px;top:' + (a.compactUi ? 6 : 8) + 'px;" src="' + h.prototype.dropdownImage + '" valign="middle"/>', h.prototype.selectedBackground = "#d0d0d0", h.prototype.unselectedBackground = "none", h.prototype.staticElements = null, h.prototype.init = function () {
    var t = screen.width;

    if (t -= screen.height > 740 ? 56 : 0, this.editorUi.menus) {
      if (t >= 700) {
        var e = this.addMenu("", s.get("view") + " (" + s.get("panTooltip") + ")", !0, "viewPanels", null, !0);
        this.addDropDownArrow(e, "geSprite-formatpanel", 38, 50, -4, -3, 36, -8), this.addSeparator();
      }

      var r,
          h = this.addMenu("", s.get("zoom") + " (Alt+Mousewheel)", !0, "viewZoom", null, !0);
      if (h.showDisabled = !0, h.style.whiteSpace = "nowrap", h.style.position = "relative", h.style.overflow = "hidden", a.compactUi ? h.style.width = i.IS_QUIRKS ? "58px" : "50px" : h.style.width = i.IS_QUIRKS ? "62px" : "36px", t >= 420) this.addSeparator(), (r = this.addItems(["zoomIn", "zoomOut"]))[0].setAttribute("title", s.get("zoomIn") + " (" + this.editorUi.actions.get("zoomIn").shortcut + ")"), r[1].setAttribute("title", s.get("zoomOut") + " (" + this.editorUi.actions.get("zoomOut").shortcut + ")");
    }

    (this.updateZoom = n.bind(this, function () {
      h && (h.innerHTML = Math.round(100 * this.editorUi.editor.graph.view.scale) + "%" + this.dropdownImageHtml, a.compactUi && (h.getElementsByTagName("img")[0].style.right = "1px", h.getElementsByTagName("img")[0].style.top = "5px"));
    }), this.editorUi.editor.graph.view.addListener(l.EVENT_SCALE, this.updateZoom), this.editorUi.editor.addListener("resetGraphView", this.updateZoom), (r = this.addItems(["-", "undo", "redo"]))[1].setAttribute("title", s.get("undo") + " (" + this.editorUi.actions.get("undo").shortcut + ")"), r[2].setAttribute("title", s.get("redo") + " (" + this.editorUi.actions.get("redo").shortcut + ")"), t >= 320) && (r = this.addItems(["-", "delete"]))[1].setAttribute("title", s.get("delete") + " (" + this.editorUi.actions.get("delete").shortcut + ")");

    if (t >= 550 && this.addItems(["-", "toFront", "toBack"]), t >= 740 && (this.addItems(["-", "fillColor"]), t >= 780 && (this.addItems(["strokeColor"]), t >= 820 && this.addItems(["shadow"]))), this.editorUi.menus) {
      t >= 400 && (this.addSeparator(), t >= 440 && (this.edgeShapeMenu = this.addMenuFunction("", s.get("connection"), !1, n.bind(this, function (t) {
        this.editorUi.menus.edgeStyleChange(t, "", [o.STYLE_SHAPE, "width"], [null, null], "geIcon geSprite geSprite-connection", null, !0).setAttribute("title", s.get("line")), this.editorUi.menus.edgeStyleChange(t, "", [o.STYLE_SHAPE, "width"], ["link", null], "geIcon geSprite geSprite-linkedge", null, !0).setAttribute("title", s.get("link")), this.editorUi.menus.edgeStyleChange(t, "", [o.STYLE_SHAPE, "width"], ["flexArrow", null], "geIcon geSprite geSprite-arrow", null, !0).setAttribute("title", s.get("arrow")), this.editorUi.menus.edgeStyleChange(t, "", [o.STYLE_SHAPE, "width"], ["arrow", null], "geIcon geSprite geSprite-simplearrow", null, !0).setAttribute("title", s.get("simpleArrow"));
      })), this.addDropDownArrow(this.edgeShapeMenu, "geSprite-connection", 44, 50, 0, 0, 22, -4)), this.edgeStyleMenu = this.addMenuFunction("geSprite-orthogonal", s.get("waypoints"), !1, n.bind(this, function (t) {
        this.editorUi.menus.edgeStyleChange(t, "", [o.STYLE_EDGE, o.STYLE_CURVED, o.STYLE_NOEDGESTYLE], [null, null, null], "geIcon geSprite geSprite-straight", null, !0).setAttribute("title", s.get("straight")), this.editorUi.menus.edgeStyleChange(t, "", [o.STYLE_EDGE, o.STYLE_CURVED, o.STYLE_NOEDGESTYLE], ["orthogonalEdgeStyle", null, null], "geIcon geSprite geSprite-orthogonal", null, !0).setAttribute("title", s.get("orthogonal")), this.editorUi.menus.edgeStyleChange(t, "", [o.STYLE_EDGE, o.STYLE_ELBOW, o.STYLE_CURVED, o.STYLE_NOEDGESTYLE], ["elbowEdgeStyle", null, null, null], "geIcon geSprite geSprite-horizontalelbow", null, !0).setAttribute("title", s.get("simple")), this.editorUi.menus.edgeStyleChange(t, "", [o.STYLE_EDGE, o.STYLE_ELBOW, o.STYLE_CURVED, o.STYLE_NOEDGESTYLE], ["elbowEdgeStyle", "vertical", null, null], "geIcon geSprite geSprite-verticalelbow", null, !0).setAttribute("title", s.get("simple")), this.editorUi.menus.edgeStyleChange(t, "", [o.STYLE_EDGE, o.STYLE_ELBOW, o.STYLE_CURVED, o.STYLE_NOEDGESTYLE], ["isometricEdgeStyle", null, null, null], "geIcon geSprite geSprite-horizontalisometric", null, !0).setAttribute("title", s.get("isometric")), this.editorUi.menus.edgeStyleChange(t, "", [o.STYLE_EDGE, o.STYLE_ELBOW, o.STYLE_CURVED, o.STYLE_NOEDGESTYLE], ["isometricEdgeStyle", "vertical", null, null], "geIcon geSprite geSprite-verticalisometric", null, !0).setAttribute("title", s.get("isometric")), this.editorUi.menus.edgeStyleChange(t, "", [o.STYLE_EDGE, o.STYLE_CURVED, o.STYLE_NOEDGESTYLE], ["orthogonalEdgeStyle", "1", null], "geIcon geSprite geSprite-curved", null, !0).setAttribute("title", s.get("curved")), this.editorUi.menus.edgeStyleChange(t, "", [o.STYLE_EDGE, o.STYLE_CURVED, o.STYLE_NOEDGESTYLE], ["entityRelationEdgeStyle", null, null], "geIcon geSprite geSprite-entity", null, !0).setAttribute("title", s.get("entityRelation"));
      })), this.addDropDownArrow(this.edgeStyleMenu, "geSprite-orthogonal", 44, 50, 0, 0, 22, -4)), this.addSeparator();
      var u = this.addMenu("", s.get("insert") + " (" + s.get("doubleClickTooltip") + ")", !0, "insert", null, !0);
      this.addDropDownArrow(u, "geSprite-plus", 38, 48, -4, -3, 36, -8);
    }
  }, h.prototype.addDropDownArrow = function (t, e, n, s, o, l, r, h) {
    r = null != r ? r : 32, o = a.compactUi ? o : h, t.style.whiteSpace = "nowrap", t.style.overflow = "hidden", t.style.position = "relative", t.innerHTML = '<div class="geSprite ' + e + '" style="margin-left:' + o + "px;margin-top:" + l + 'px;"></div>' + this.dropdownImageHtml, t.style.width = i.IS_QUIRKS ? s + "px" : s - r + "px", i.IS_QUIRKS && (t.style.height = a.compactUi ? "24px" : "26px"), a.compactUi && (t.getElementsByTagName("img")[0].style.left = "24px", t.getElementsByTagName("img")[0].style.top = "5px", t.style.width = i.IS_QUIRKS ? n + "px" : n - 10 + "px");
  }, h.prototype.setFontName = function (t) {
    null != this.fontMenu && (this.fontMenu.innerHTML = '<div style="width:60px;overflow:hidden;display:inline-block;">' + n.htmlEntities(t) + "</div>" + this.dropdownImageHtml);
  }, h.prototype.setFontSize = function (t) {
    null != this.sizeMenu && (this.sizeMenu.innerHTML = '<div style="width:24px;overflow:hidden;display:inline-block;">' + t + "</div>" + this.dropdownImageHtml);
  }, h.prototype.createTextToolbar = function () {
    var t = this.editorUi.editor.graph,
        e = this.addMenu("", s.get("style"), !0, "formatBlock");
    e.style.position = "relative", e.style.whiteSpace = "nowrap", e.style.overflow = "hidden", e.innerHTML = s.get("style") + this.dropdownImageHtml, a.compactUi && (e.style.paddingRight = "18px", e.getElementsByTagName("img")[0].style.right = "1px", e.getElementsByTagName("img")[0].style.top = "5px"), this.addSeparator(), this.fontMenu = this.addMenu("", s.get("fontFamily"), !0, "fontFamily"), this.fontMenu.style.position = "relative", this.fontMenu.style.whiteSpace = "nowrap", this.fontMenu.style.overflow = "hidden", this.fontMenu.style.width = i.IS_QUIRKS ? "80px" : "60px", a.compactUi && (this.fontMenu.style.paddingRight = "18px", this.fontMenu.getElementsByTagName("img")[0].style.right = "1px", this.fontMenu.getElementsByTagName("img")[0].style.top = "5px"), this.addSeparator(), a.compactUi && (this.sizeMenu.style.paddingRight = "18px", this.sizeMenu.getElementsByTagName("img")[0].style.right = "1px", this.sizeMenu.getElementsByTagName("img")[0].style.top = "5px");
    var l = this.addItems(["-", "undo", "redo", "-", "bold", "italic", "underline"]);
    l[1].setAttribute("title", s.get("undo") + " (" + this.editorUi.actions.get("undo").shortcut + ")"), l[2].setAttribute("title", s.get("redo") + " (" + this.editorUi.actions.get("redo").shortcut + ")"), l[4].setAttribute("title", s.get("bold") + " (" + this.editorUi.actions.get("bold").shortcut + ")"), l[5].setAttribute("title", s.get("italic") + " (" + this.editorUi.actions.get("italic").shortcut + ")"), l[6].setAttribute("title", s.get("underline") + " (" + this.editorUi.actions.get("underline").shortcut + ")");
    var r = this.addMenuFunction("", s.get("align"), !1, n.bind(this, function (t) {
      (d = t.addItem("", null, n.bind(this, function () {
        document.execCommand("justifyleft", !1, null);
      }), null, "geIcon geSprite geSprite-left")).setAttribute("title", s.get("left")), (d = t.addItem("", null, n.bind(this, function () {
        document.execCommand("justifycenter", !1, null);
      }), null, "geIcon geSprite geSprite-center")).setAttribute("title", s.get("center")), (d = t.addItem("", null, n.bind(this, function () {
        document.execCommand("justifyright", !1, null);
      }), null, "geIcon geSprite geSprite-right")).setAttribute("title", s.get("right")), (d = t.addItem("", null, n.bind(this, function () {
        document.execCommand("justifyfull", !1, null);
      }), null, "geIcon geSprite geSprite-justifyfull")).setAttribute("title", s.get("justifyfull")), (d = t.addItem("", null, n.bind(this, function () {
        document.execCommand("insertorderedlist", !1, null);
      }), null, "geIcon geSprite geSprite-orderedlist")).setAttribute("title", s.get("numberedList")), (d = t.addItem("", null, n.bind(this, function () {
        document.execCommand("insertunorderedlist", !1, null);
      }), null, "geIcon geSprite geSprite-unorderedlist")).setAttribute("title", s.get("bulletedList")), (d = t.addItem("", null, n.bind(this, function () {
        document.execCommand("outdent", !1, null);
      }), null, "geIcon geSprite geSprite-outdent")).setAttribute("title", s.get("decreaseIndent")), (d = t.addItem("", null, n.bind(this, function () {
        document.execCommand("indent", !1, null);
      }), null, "geIcon geSprite geSprite-indent")).setAttribute("title", s.get("increaseIndent"));
    }));
    r.style.position = "relative", r.style.whiteSpace = "nowrap", r.style.overflow = "hidden", r.innerHTML = '<div class="geSprite geSprite-left" style="margin-left:-2px;"></div>' + this.dropdownImageHtml, r.style.width = i.IS_QUIRKS ? "50px" : "30px", a.compactUi && (r.getElementsByTagName("img")[0].style.left = "22px", r.getElementsByTagName("img")[0].style.top = "5px");
    var h = this.addMenuFunction("", s.get("format"), !1, n.bind(this, function (t) {
      (d = t.addItem("", null, this.editorUi.actions.get("subscript").funct, null, "geIcon geSprite geSprite-subscript")).setAttribute("title", s.get("subscript") + " (" + Editor.ctrlKey + "+,)"), (d = t.addItem("", null, this.editorUi.actions.get("superscript").funct, null, "geIcon geSprite geSprite-superscript")).setAttribute("title", s.get("superscript") + " (" + Editor.ctrlKey + "+.)"), (d = t.addItem("", null, this.editorUi.actions.get("fontColor").funct, null, "geIcon geSprite geSprite-fontcolor")).setAttribute("title", s.get("fontColor")), (d = t.addItem("", null, this.editorUi.actions.get("backgroundColor").funct, null, "geIcon geSprite geSprite-fontbackground")).setAttribute("title", s.get("backgroundColor")), (d = t.addItem("", null, n.bind(this, function () {
        document.execCommand("removeformat", !1, null);
      }), null, "geIcon geSprite geSprite-removeformat")).setAttribute("title", s.get("removeFormat"));
    }));
    h.style.position = "relative", h.style.whiteSpace = "nowrap", h.style.overflow = "hidden", h.innerHTML = '<div class="geSprite geSprite-dots" style="margin-left:-2px;"></div>' + this.dropdownImageHtml, h.style.width = i.IS_QUIRKS ? "50px" : "30px", a.compactUi && (h.getElementsByTagName("img")[0].style.left = "22px", h.getElementsByTagName("img")[0].style.top = "5px"), this.addSeparator(), this.addButton("geIcon geSprite geSprite-code", s.get("html"), function () {
      t.cellEditor.toggleViewMode(), t.cellEditor.textarea.innerHTML.length > 0 && ("&nbsp;" != t.cellEditor.textarea.innerHTML || !t.cellEditor.clearOnChange) && window.setTimeout(function () {
        document.execCommand("selectAll", !1, null);
      });
    }), this.addSeparator();
    var u = this.addMenuFunction("", s.get("insert"), !0, n.bind(this, function (t) {
      t.addItem(s.get("insertLink"), null, n.bind(this, function () {
        this.editorUi.actions.get("link").funct();
      })), t.addItem(s.get("insertImage"), null, n.bind(this, function () {
        this.editorUi.actions.get("image").funct();
      })), t.addItem(s.get("insertHorizontalRule"), null, n.bind(this, function () {
        document.execCommand("inserthorizontalrule", !1, null);
      }));
    }));
    u.style.whiteSpace = "nowrap", u.style.overflow = "hidden", u.style.position = "relative", u.innerHTML = '<div class="geSprite geSprite-plus" style="margin-left:-4px;margin-top:-3px;"></div>' + this.dropdownImageHtml, u.style.width = i.IS_QUIRKS ? "36px" : "16px", a.compactUi && (u.getElementsByTagName("img")[0].style.left = "24px", u.getElementsByTagName("img")[0].style.top = "5px", u.style.width = i.IS_QUIRKS ? "50px" : "30px"), this.addSeparator();
    var d = this.addMenuFunction("geIcon geSprite geSprite-table", s.get("table"), !1, n.bind(this, function (e) {
      var i = t.getSelectedElement(),
          l = t.getParentByName(i, "TD", t.cellEditor.text2),
          r = t.getParentByName(i, "TR", t.cellEditor.text2);
      if (null == r) this.editorUi.menus.addInsertTableItem(e);else {
        var a = t.getParentByName(r, "TABLE", t.cellEditor.text2);
        (i = e.addItem("", null, n.bind(this, function () {
          try {
            t.selectNode(t.insertColumn(a, null != l ? l.cellIndex : 0));
          } catch (t) {
            n.alert(s.get("error") + ": " + t.message);
          }
        }), null, "geIcon geSprite geSprite-insertcolumnbefore")).setAttribute("title", s.get("insertColumnBefore")), (i = e.addItem("", null, n.bind(this, function () {
          try {
            t.selectNode(t.insertColumn(a, null != l ? l.cellIndex + 1 : -1));
          } catch (t) {
            n.alert(s.get("error") + ": " + t.message);
          }
        }), null, "geIcon geSprite geSprite-insertcolumnafter")).setAttribute("title", s.get("insertColumnAfter")), (i = e.addItem("Delete column", null, n.bind(this, function () {
          if (null != l) try {
            t.deleteColumn(a, l.cellIndex);
          } catch (t) {
            n.alert(s.get("error") + ": " + t.message);
          }
        }), null, "geIcon geSprite geSprite-deletecolumn")).setAttribute("title", s.get("deleteColumn")), (i = e.addItem("", null, n.bind(this, function () {
          try {
            t.selectNode(t.insertRow(a, r.sectionRowIndex));
          } catch (t) {
            n.alert(s.get("error") + ": " + t.message);
          }
        }), null, "geIcon geSprite geSprite-insertrowbefore")).setAttribute("title", s.get("insertRowBefore")), (i = e.addItem("", null, n.bind(this, function () {
          try {
            t.selectNode(t.insertRow(a, r.sectionRowIndex + 1));
          } catch (t) {
            n.alert(s.get("error") + ": " + t.message);
          }
        }), null, "geIcon geSprite geSprite-insertrowafter")).setAttribute("title", s.get("insertRowAfter")), (i = e.addItem("", null, n.bind(this, function () {
          try {
            t.deleteRow(a, r.sectionRowIndex);
          } catch (t) {
            n.alert(s.get("error") + ": " + t.message);
          }
        }), null, "geIcon geSprite geSprite-deleterow")).setAttribute("title", s.get("deleteRow")), (i = e.addItem("", null, n.bind(this, function () {
          var t = a.style.borderColor.replace(/\brgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g, function (t, e, i, n) {
            return "#" + ("0" + Number(e).toString(16)).substr(-2) + ("0" + Number(i).toString(16)).substr(-2) + ("0" + Number(n).toString(16)).substr(-2);
          });
          this.editorUi.pickColor(t, function (t) {
            null == t || t == o.NONE ? (a.removeAttribute("border"), a.style.border = "", a.style.borderCollapse = "") : (a.setAttribute("border", "1"), a.style.border = "1px solid " + t, a.style.borderCollapse = "collapse");
          });
        }), null, "geIcon geSprite geSprite-strokecolor")).setAttribute("title", s.get("borderColor")), (i = e.addItem("", null, n.bind(this, function () {
          var t = a.style.backgroundColor.replace(/\brgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g, function (t, e, i, n) {
            return "#" + ("0" + Number(e).toString(16)).substr(-2) + ("0" + Number(i).toString(16)).substr(-2) + ("0" + Number(n).toString(16)).substr(-2);
          });
          this.editorUi.pickColor(t, function (t) {
            null == t || t == o.NONE ? a.style.backgroundColor = "" : a.style.backgroundColor = t;
          });
        }), null, "geIcon geSprite geSprite-fillcolor")).setAttribute("title", s.get("backgroundColor")), (i = e.addItem("", null, n.bind(this, function () {
          var t = a.getAttribute("cellPadding") || 0,
              e = new FilenameDialog(this.editorUi, t, s.get("apply"), n.bind(this, function (t) {
            null != t && t.length > 0 ? a.setAttribute("cellPadding", t) : a.removeAttribute("cellPadding");
          }), s.get("spacing"));
          this.editorUi.showDialog(e.container, 300, 80, !0, !0), e.init();
        }), null, "geIcon geSprite geSprite-fit")).setAttribute("title", s.get("spacing")), (i = e.addItem("", null, n.bind(this, function () {
          a.setAttribute("align", "left");
        }), null, "geIcon geSprite geSprite-left")).setAttribute("title", s.get("left")), (i = e.addItem("", null, n.bind(this, function () {
          a.setAttribute("align", "center");
        }), null, "geIcon geSprite geSprite-center")).setAttribute("title", s.get("center")), (i = e.addItem("", null, n.bind(this, function () {
          a.setAttribute("align", "right");
        }), null, "geIcon geSprite geSprite-right")).setAttribute("title", s.get("right"));
      }
    }));
    d.style.position = "relative", d.style.whiteSpace = "nowrap", d.style.overflow = "hidden", d.innerHTML = '<div class="geSprite geSprite-table" style="margin-left:-2px;"></div>' + this.dropdownImageHtml, d.style.width = i.IS_QUIRKS ? "50px" : "30px", a.compactUi && (d.getElementsByTagName("img")[0].style.left = "22px", d.getElementsByTagName("img")[0].style.top = "5px");
  }, h.prototype.hideMenu = function () {
    this.editorUi.hideCurrentMenu();
  }, h.prototype.addMenu = function (t, e, i, n, s, o, l) {
    var r = this.editorUi.menus.get(n),
        a = this.addMenuFunction(t, e, i, function () {
      r.funct.apply(r, arguments);
    }, s, o);
    return l || r.addListener("stateChanged", function () {
      a.setEnabled(r.enabled);
    }), a;
  }, h.prototype.addMenuFunction = function (t, e, i, n, s, o) {
    return this.addMenuFunctionInContainer(null != s ? s : this.container, t, e, i, n, o);
  }, h.prototype.addMenuFunctionInContainer = function (t, e, i, n, s, o) {
    var l = n ? this.createLabel(e) : this.createButton(e);
    return this.initElement(l, i), this.addMenuHandler(l, n, s, o), t.appendChild(l), l;
  }, h.prototype.addSeparator = function (t) {
    t = null != t ? t : this.container;
    var e = document.createElement("div");
    return e.className = "geSeparator", t.appendChild(e), e;
  }, h.prototype.addItems = function (t, e, i) {
    for (var n = [], s = 0; s < t.length; s++) {
      var o = t[s];
      "-" == o ? n.push(this.addSeparator(e)) : n.push(this.addItem("geSprite-" + o.toLowerCase(), o, e, i));
    }

    return n;
  }, h.prototype.addItem = function (t, e, i, n) {
    var s = this.editorUi.actions.get(e),
        o = null;

    if (null != s) {
      var l = s.label;
      null != s.shortcut && (l += " (" + s.shortcut + ")"), o = this.addButton(t, l, s.funct, i), n || (o.setEnabled(s.enabled), s.addListener("stateChanged", function () {
        o.setEnabled(s.enabled);
      }));
    }

    return o;
  }, h.prototype.addButton = function (t, e, i, n) {
    var s = this.createButton(t);
    return n = null != n ? n : this.container, this.initElement(s, e), this.addClickHandler(s, i), n.appendChild(s), s;
  }, h.prototype.initElement = function (t, e) {
    null != e && t.setAttribute("title", e), this.addEnabledState(t);
  }, h.prototype.addEnabledState = function (t) {
    var e = t.className;
    t.setEnabled = function (i) {
      t.enabled = i, t.className = i ? e : e + " mxDisabled";
    }, t.setEnabled(!0);
  }, h.prototype.addClickHandler = function (t, e) {
    null != e && (l.addListener(t, "click", function (i) {
      t.enabled && e(i), l.consume(i);
    }), l.addListener(t, i.IS_POINTER ? "pointerdown" : "mousedown", n.bind(this, function (t) {
      t.preventDefault();
    })));
  }, h.prototype.createButton = function (t) {
    var e = document.createElement("a");
    e.className = "geButton";
    var i = document.createElement("div");
    return null != t && (i.className = "geSprite " + t), e.appendChild(i), e;
  }, h.prototype.createLabel = function (t, e) {
    var i = document.createElement("a");
    return i.className = "geLabel", n.write(i, t), i;
  }, h.prototype.addMenuHandler = function (t, e, s, o) {
    if (null != s) {
      var a = this.editorUi.editor.graph,
          h = null,
          u = !0;
      l.addListener(t, "click", n.bind(this, function (i) {
        if (u && (null == t.enabled || t.enabled)) {
          a.popupMenuHandler.hideMenu(), (h = new r(s)).div.className += " geToolbarMenu", h.showDisabled = o, h.labels = e, h.autoExpand = !0;
          var d = n.getOffset(t);
          h.popup(d.x, d.y + t.offsetHeight, null, i), this.editorUi.setCurrentMenu(h, t), !e && h.div.scrollHeight > h.div.clientHeight && (h.div.style.width = "40px"), h.hideMenu = n.bind(this, function () {
            r.prototype.hideMenu.apply(h, arguments), this.editorUi.resetCurrentMenu(), h.destroy();
          }), h.addListener(l.EVENT_HIDE, n.bind(this, function () {
            this.currentElt = null;
          }));
        }

        u = !0, l.consume(i);
      })), l.addListener(t, i.IS_POINTER ? "pointerdown" : "mousedown", n.bind(this, function (e) {
        u = this.currentElt != t, e.preventDefault();
      }));
    }
  }, h.prototype.destroy = function () {
    null != this.gestureHandler && (l.removeGestureListeners(document, this.gestureHandler), this.gestureHandler = null);
  }, new h(t, e);
}

function MenusBuilder(t) {
  var _t$mx3 = t.mx,
      e = _t$mx3.mxClient,
      i = _t$mx3.mxUtils,
      n = _t$mx3.mxEventSource,
      s = _t$mx3.mxResources,
      o = _t$mx3.mxEventObject,
      l = _t$mx3.mxConstants,
      r = _t$mx3.mxHierarchicalLayout,
      a = _t$mx3.mxEvent,
      h = _t$mx3.mxCircleLayout,
      u = _t$mx3.mxFastOrganicLayout,
      d = _t$mx3.mxCompactTreeLayout,
      p = _t$mx3.mxRadialTreeLayout,
      c = _t$mx3.mxEdgeHandler,
      m = _t$mx3.mxMouseEvent,
      g = _t$mx3.mxPopupMenu;
  var x = t.editor.constructor;

  function y(t) {
    this.editorUi = t, this.menus = new Object(), this.init(), e.IS_SVG || (new Image().src = this.checkmarkImage);
  }

  function f(t, e) {
    this.editorUi = t, this.container = e;
  }

  function v(t, e) {
    n.call(this), this.funct = t, this.enabled = null == e || e;
  }

  return y.prototype.defaultFont = "Helvetica", y.prototype.defaultFontSize = "12", y.prototype.defaultMenuItems = ["file", "edit", "view", "arrange", "extras", "help"], y.prototype.defaultFonts = ["Helvetica", "Verdana", "Times New Roman", "Garamond", "Comic Sans MS", "Courier New", "Georgia", "Lucida Console", "Tahoma"], y.prototype.init = function () {
    var t = this.editorUi.editor.graph,
        e = i.bind(t, t.isEnabled);
    this.customFonts = [], this.customFontSizes = [], this.put("fontFamily", new v(i.bind(this, function (e, n) {
      for (var o = i.bind(this, function (i) {
        this.styleChange(e, i, [l.STYLE_FONTFAMILY], [i], null, n, function () {
          document.execCommand("fontname", !1, i);
        }, function () {
          t.updateLabelElements(t.getSelectionCells(), function (e) {
            e.removeAttribute("face"), e.style.fontFamily = null, "PRE" == e.nodeName && t.replaceElement(e, "div");
          });
        }).firstChild.nextSibling.style.fontFamily = i;
      }), r = 0; r < this.defaultFonts.length; r++) {
        o(this.defaultFonts[r]);
      }

      if (e.addSeparator(n), this.customFonts.length > 0) {
        for (r = 0; r < this.customFonts.length; r++) {
          o(this.customFonts[r]);
        }

        e.addSeparator(n), e.addItem(s.get("reset"), null, i.bind(this, function () {
          this.customFonts = [];
        }), n), e.addSeparator(n);
      }

      this.promptChange(e, s.get("custom") + "...", "", l.DEFAULT_FONTFAMILY, l.STYLE_FONTFAMILY, n, !0, i.bind(this, function (t) {
        this.customFonts.push(t);
      }));
    }))), this.put("formatBlock", new v(i.bind(this, function (e, n) {
      function o(s, o) {
        return e.addItem(s, null, i.bind(this, function () {
          null != t.cellEditor.textarea && (t.cellEditor.textarea.focus(), document.execCommand("formatBlock", !1, "<" + o + ">"));
        }), n);
      }

      o(s.get("normal"), "p"), o("", "h1").firstChild.nextSibling.innerHTML = '<h1 style="margin:0px;">' + s.get("heading") + " 1</h1>", o("", "h2").firstChild.nextSibling.innerHTML = '<h2 style="margin:0px;">' + s.get("heading") + " 2</h2>", o("", "h3").firstChild.nextSibling.innerHTML = '<h3 style="margin:0px;">' + s.get("heading") + " 3</h3>", o("", "h4").firstChild.nextSibling.innerHTML = '<h4 style="margin:0px;">' + s.get("heading") + " 4</h4>", o("", "h5").firstChild.nextSibling.innerHTML = '<h5 style="margin:0px;">' + s.get("heading") + " 5</h5>", o("", "h6").firstChild.nextSibling.innerHTML = '<h6 style="margin:0px;">' + s.get("heading") + " 6</h6>", o("", "pre").firstChild.nextSibling.innerHTML = '<pre style="margin:0px;">' + s.get("formatted") + "</pre>", o("", "blockquote").firstChild.nextSibling.innerHTML = '<blockquote style="margin-top:0px;margin-bottom:0px;">' + s.get("blockquote") + "</blockquote>";
    }))), this.put("fontSize", new v(i.bind(this, function (e, n) {
      for (var o = [6, 8, 9, 10, 11, 12, 14, 18, 24, 36, 48, 72], r = i.bind(this, function (i) {
        this.styleChange(e, i, [l.STYLE_FONTSIZE], [i], null, n, function () {
          document.execCommand("fontSize", !1, "3");

          for (var e = t.cellEditor.textarea.getElementsByTagName("font"), n = 0; n < e.length; n++) {
            if ("3" == e[n].getAttribute("size")) {
              e[n].removeAttribute("size"), e[n].style.fontSize = i + "px";
              break;
            }
          }
        });
      }), a = 0; a < o.length; a++) {
        r(o[a]);
      }

      if (e.addSeparator(n), this.customFontSizes.length > 0) {
        for (a = 0; a < this.customFontSizes.length; a++) {
          r(this.customFontSizes[a]);
        }

        e.addSeparator(n), e.addItem(s.get("reset"), null, i.bind(this, function () {
          this.customFontSizes = [];
        }), n), e.addSeparator(n);
      }

      this.promptChange(e, s.get("custom") + "...", "(pt)", "12", l.STYLE_FONTSIZE, n, !0, i.bind(this, function (t) {
        this.customFontSizes.push(t);
      }));
    }))), this.put("direction", new v(i.bind(this, function (e, i) {
      e.addItem(s.get("flipH"), null, function () {
        t.toggleCellStyles(l.STYLE_FLIPH, !1);
      }, i), e.addItem(s.get("flipV"), null, function () {
        t.toggleCellStyles(l.STYLE_FLIPV, !1);
      }, i), this.addMenuItems(e, ["-", "rotation"], i);
    }))), this.put("align", new v(i.bind(this, function (e, i) {
      e.addItem(s.get("leftAlign"), null, function () {
        t.alignCells(l.ALIGN_LEFT);
      }, i), e.addItem(s.get("center"), null, function () {
        t.alignCells(l.ALIGN_CENTER);
      }, i), e.addItem(s.get("rightAlign"), null, function () {
        t.alignCells(l.ALIGN_RIGHT);
      }, i), e.addSeparator(i), e.addItem(s.get("topAlign"), null, function () {
        t.alignCells(l.ALIGN_TOP);
      }, i), e.addItem(s.get("middle"), null, function () {
        t.alignCells(l.ALIGN_MIDDLE);
      }, i), e.addItem(s.get("bottomAlign"), null, function () {
        t.alignCells(l.ALIGN_BOTTOM);
      }, i);
    }))), this.put("distribute", new v(i.bind(this, function (e, i) {
      e.addItem(s.get("horizontal"), null, function () {
        t.distributeCells(!0);
      }, i), e.addItem(s.get("vertical"), null, function () {
        t.distributeCells(!1);
      }, i);
    }))), this.put("layout", new v(i.bind(this, function (e, n) {
      var o = i.bind(this, function (t, e) {
        var i = new FilenameDialog(this.editorUi, t, s.get("apply"), function (t) {
          e(parseFloat(t));
        }, s.get("spacing"));
        this.editorUi.showDialog(i.container, 300, 80, !0, !0), i.init();
      });
      e.addItem(s.get("horizontalFlow"), null, i.bind(this, function () {
        var e = new r(t, l.DIRECTION_WEST);
        this.editorUi.executeLayout(function () {
          var i = t.getSelectionCells();
          e.execute(t.getDefaultParent(), 0 == i.length ? null : i);
        }, !0);
      }), n), e.addItem(s.get("verticalFlow"), null, i.bind(this, function () {
        var e = new r(t, l.DIRECTION_NORTH);
        this.editorUi.executeLayout(function () {
          var i = t.getSelectionCells();
          e.execute(t.getDefaultParent(), 0 == i.length ? null : i);
        }, !0);
      }), n), e.addSeparator(n), e.addItem(s.get("horizontalTree"), null, i.bind(this, function () {
        var e = t.getSelectionCell(),
            n = null;

        if (null == e || 0 == t.getModel().getChildCount(e) ? 0 == t.getModel().getEdgeCount(e) && (n = t.findTreeRoots(t.getDefaultParent())) : n = t.findTreeRoots(e), null != n && n.length > 0 && (e = n[0]), null != e) {
          var s = new d(t, !0);
          s.edgeRouting = !1, s.levelDistance = 30, o(s.levelDistance, i.bind(this, function (i) {
            s.levelDistance = i, this.editorUi.executeLayout(function () {
              s.execute(t.getDefaultParent(), e);
            }, !0);
          }));
        }
      }), n), e.addItem(s.get("verticalTree"), null, i.bind(this, function () {
        var e = t.getSelectionCell(),
            n = null;

        if (null == e || 0 == t.getModel().getChildCount(e) ? 0 == t.getModel().getEdgeCount(e) && (n = t.findTreeRoots(t.getDefaultParent())) : n = t.findTreeRoots(e), null != n && n.length > 0 && (e = n[0]), null != e) {
          var s = new d(t, !1);
          s.edgeRouting = !1, s.levelDistance = 30, o(s.levelDistance, i.bind(this, function (i) {
            s.levelDistance = i, this.editorUi.executeLayout(function () {
              s.execute(t.getDefaultParent(), e);
            }, !0);
          }));
        }
      }), n), e.addItem(s.get("radialTree"), null, i.bind(this, function () {
        var e = t.getSelectionCell(),
            n = null;

        if (null == e || 0 == t.getModel().getChildCount(e) ? 0 == t.getModel().getEdgeCount(e) && (n = t.findTreeRoots(t.getDefaultParent())) : n = t.findTreeRoots(e), null != n && n.length > 0 && (e = n[0]), null != e) {
          var s = new p(t, !1);
          s.levelDistance = 80, s.autoRadius = !0, o(s.levelDistance, i.bind(this, function (i) {
            s.levelDistance = i, this.editorUi.executeLayout(function () {
              s.execute(t.getDefaultParent(), e), t.isSelectionEmpty() || (e = t.getModel().getParent(e), t.getModel().isVertex(e) && t.updateGroupBounds([e], 2 * t.gridSize, !0));
            }, !0);
          }));
        }
      }), n), e.addSeparator(n), e.addItem(s.get("organic"), null, i.bind(this, function () {
        var e = new u(t);
        o(e.forceConstant, i.bind(this, function (i) {
          e.forceConstant = i, this.editorUi.executeLayout(function () {
            var i = t.getSelectionCell();
            null != i && 0 != t.getModel().getChildCount(i) || (i = t.getDefaultParent()), e.execute(i), t.getModel().isVertex(i) && t.updateGroupBounds([i], 2 * t.gridSize, !0);
          }, !0);
        }));
      }), n), e.addItem(s.get("circle"), null, i.bind(this, function () {
        var e = new h(t);
        this.editorUi.executeLayout(function () {
          var i = t.getSelectionCell();
          null != i && 0 != t.getModel().getChildCount(i) || (i = t.getDefaultParent()), e.execute(i), t.getModel().isVertex(i) && t.updateGroupBounds([i], 2 * t.gridSize, !0);
        }, !0);
      }), n);
    }))), this.put("navigation", new v(i.bind(this, function (t, e) {
      this.addMenuItems(t, ["home", "-", "exitGroup", "enterGroup", "-", "expand", "collapse", "-", "collapsible"], e);
    }))), this.put("arrange", new v(i.bind(this, function (t, e) {
      this.addMenuItems(t, ["toFront", "toBack", "-"], e), this.addSubmenu("direction", t, e), this.addMenuItems(t, ["turn", "-"], e), this.addSubmenu("align", t, e), this.addSubmenu("distribute", t, e), t.addSeparator(e), this.addSubmenu("navigation", t, e), this.addSubmenu("insert", t, e), this.addSubmenu("layout", t, e), this.addMenuItems(t, ["-", "group", "ungroup", "removeFromGroup", "-", "clearWaypoints", "autosize"], e);
    }))).isEnabled = e, this.put("insert", new v(i.bind(this, function (t, e) {
      this.addMenuItems(t, ["insertLink", "insertImage"], e);
    }))), this.put("view", new v(i.bind(this, function (t, e) {
      this.addMenuItems(t, (null != this.editorUi.format ? ["formatPanel"] : []).concat(["outline", "layers", "-", "pageView", "pageScale", "-", "scrollbars", "tooltips", "-", "grid", "guides", "-", "connectionArrows", "connectionPoints", "-", "resetView", "zoomIn", "zoomOut"], e));
    }))), this.put("viewPanels", new v(i.bind(this, function (t, e) {
      null != this.editorUi.format && this.addMenuItems(t, ["formatPanel"], e), this.addMenuItems(t, ["outline", "layers"], e);
    }))), this.put("viewZoom", new v(i.bind(this, function (e, i) {
      this.addMenuItems(e, ["resetView", "-"], i);

      for (var n = [.25, .5, .75, 1, 1.25, 1.5, 2, 3, 4], s = 0; s < n.length; s++) {
        !function (n) {
          e.addItem(100 * n + "%", null, function () {
            t.zoomTo(n);
          }, i);
        }(n[s]);
      }

      this.addMenuItems(e, ["-", "fitWindow", "fitPageWidth", "fitPage", "fitTwoPages", "-", "customZoom"], i);
    }))), this.put("file", new v(i.bind(this, function (t, e) {
      this.addMenuItems(t, ["new", "open", "-", "save", "saveAs", "-", "import", "export", "-", "pageSetup", "print"], e);
    }))), this.put("edit", new v(i.bind(this, function (t, e) {
      this.addMenuItems(t, ["undo", "redo", "-", "cut", "copy", "paste", "delete", "-", "duplicate", "-", "editData", "editTooltip", "editStyle", "-", "edit", "-", "editLink", "openLink", "-", "selectVertices", "selectEdges", "selectAll", "selectNone", "-", "lockUnlock"]);
    }))), this.put("extras", new v(i.bind(this, function (t, e) {
      this.addMenuItems(t, ["copyConnect", "collapseExpand", "-", "editDiagram", "editModelData"]);
    }))), this.put("help", new v(i.bind(this, function (t, e) {
      this.addMenuItems(t, ["help", "-", "about"]);
    })));
  }, y.prototype.put = function (t, e) {
    return this.menus[t] = e, e;
  }, y.prototype.get = function (t) {
    return this.menus[t];
  }, y.prototype.addSubmenu = function (t, e, i, n) {
    var o = this.get(t);

    if (null != o) {
      var l = o.isEnabled();

      if (e.showDisabled || l) {
        var r = e.addItem(n || s.get(t), null, null, i, null, l);
        this.addMenu(t, e, r);
      }
    }
  }, y.prototype.addMenu = function (t, e, i) {
    var n = this.get(t);
    null != n && (e.showDisabled || n.isEnabled()) && this.get(t).execute(e, i);
  }, y.prototype.addInsertTableItem = function (t) {
    var n = this.editorUi.editor.graph;
    var s = t.addItem("", null, i.bind(this, function (t) {
      var e = n.getParentByName(a.getSource(t), "TD");

      if (null != e) {
        for (var i = n.getParentByName(e, "TR"), s = n.cellEditor.textarea.getElementsByTagName("table"), o = [], l = 0; l < s.length; l++) {
          o.push(s[l]);
        }

        n.container.focus(), n.pasteHtmlAtCaret(function (t, e) {
          for (var i = ["<table>"], n = 0; n < t; n++) {
            i.push("<tr>");

            for (var s = 0; s < e; s++) {
              i.push("<td><br></td>");
            }

            i.push("</tr>");
          }

          return i.push("</table>"), i.join("");
        }(i.sectionRowIndex + 1, e.cellIndex + 1));
        var r = n.cellEditor.textarea.getElementsByTagName("table");
        if (r.length == o.length + 1) for (l = r.length - 1; l >= 0; l--) {
          if (0 == l || r[l] != o[l - 1]) {
            n.selectNode(r[l].rows[0].cells[0]);
            break;
          }
        }
      }
    })),
        o = '<img src="' + e.imageBasePath + '/transparent.gif" width="16" height="16"/>';
    s.firstChild.innerHTML = "";

    var l = function (t, i) {
      var n = document.createElement("table");
      n.setAttribute("border", "1"), n.style.borderCollapse = "collapse", e.IS_QUIRKS || n.setAttribute("cellPadding", "8");

      for (var s = 0; s < t; s++) {
        for (var l = n.insertRow(s), r = 0; r < i; r++) {
          var a = l.insertCell(-1);
          e.IS_QUIRKS && (a.innerHTML = o);
        }
      }

      return n;
    }(5, 5);

    s.firstChild.appendChild(l);
    var r = document.createElement("div");
    r.style.padding = "4px", r.style.fontSize = y.prototype.defaultFontSize + "px", r.innerHTML = "1x1", s.firstChild.appendChild(r), a.addListener(l, "mouseover", function (t) {
      var i = n.getParentByName(a.getSource(t), "TD");

      if (null != i) {
        var s = n.getParentByName(i, "TR");
        !function (t, i, n) {
          for (var s = t.rows.length; s < i; s++) {
            for (var l = t.insertRow(s), r = 0; r < t.rows[0].cells.length; r++) {
              var a = l.insertCell(-1);
              e.IS_QUIRKS && (a.innerHTML = o);
            }
          }

          for (s = 0; s < t.rows.length; s++) {
            for (r = (l = t.rows[s]).cells.length; r < n; r++) {
              a = l.insertCell(-1), e.IS_QUIRKS && (a.innerHTML = o);
            }
          }
        }(l, Math.min(20, s.sectionRowIndex + 2), Math.min(20, i.cellIndex + 2)), r.innerHTML = i.cellIndex + 1 + "x" + (s.sectionRowIndex + 1);

        for (var h = 0; h < l.rows.length; h++) {
          for (var u = l.rows[h], d = 0; d < u.cells.length; d++) {
            var p = u.cells[d];
            h <= s.sectionRowIndex && d <= i.cellIndex ? p.style.backgroundColor = "blue" : p.style.backgroundColor = "white";
          }
        }

        a.consume(t);
      }
    });
  }, y.prototype.edgeStyleChange = function (t, e, n, s, l, r, a) {
    return t.addItem(e, null, i.bind(this, function () {
      var t = this.editorUi.editor.graph;
      t.stopEditing(!1), t.getModel().beginUpdate();

      try {
        for (var e = t.getSelectionCells(), i = [], l = 0; l < e.length; l++) {
          var r = e[l];

          if (t.getModel().isEdge(r)) {
            if (a) {
              var h = t.getCellGeometry(r);
              null != h && ((h = h.clone()).points = null, t.getModel().setGeometry(r, h));
            }

            for (var u = 0; u < n.length; u++) {
              t.setCellStyles(n[u], s[u], [r]);
            }

            i.push(r);
          }
        }

        this.editorUi.fireEvent(new o("styleChanged", "keys", n, "values", s, "cells", i));
      } finally {
        t.getModel().endUpdate();
      }
    }), r, l);
  }, y.prototype.styleChange = function (t, e, n, s, o, l, r, a) {
    var h = this.createStyleChangeFunction(n, s);
    return t.addItem(e, null, i.bind(this, function () {
      var t = this.editorUi.editor.graph;
      null != r && t.cellEditor.isContentEditing() ? r() : h(a);
    }), l, o);
  }, y.prototype.createStyleChangeFunction = function (t, e) {
    return i.bind(this, function (i) {
      var n = this.editorUi.editor.graph;
      n.stopEditing(!1), n.getModel().beginUpdate();

      try {
        for (var s = 0; s < t.length; s++) {
          n.setCellStyles(t[s], e[s]);
        }

        null != i && i(), this.editorUi.fireEvent(new o("styleChanged", "keys", t, "values", e, "cells", n.getSelectionCells()));
      } finally {
        n.getModel().endUpdate();
      }
    });
  }, y.prototype.promptChange = function (t, e, n, o, l, r, a, h, u) {
    return t.addItem(e, null, i.bind(this, function () {
      var t = this.editorUi.editor.graph,
          e = o,
          r = t.getView().getState(t.getSelectionCell());
      null != r && (e = r.style[l] || e);
      var a = new FilenameDialog(this.editorUi, e, s.get("apply"), i.bind(this, function (e) {
        if (null != e && e.length > 0) {
          t.getModel().beginUpdate();

          try {
            t.stopEditing(!1), t.setCellStyles(l, e);
          } finally {
            t.getModel().endUpdate();
          }

          null != h && h(e);
        }
      }), s.get("enterValue") + (n.length > 0 ? " " + n : ""));
      this.editorUi.showDialog(a.container, 300, 80, !0, !0), a.init();
    }), r, u, a);
  }, y.prototype.pickColor = function (t, e, n) {
    var s = this.editorUi.editor.graph,
        o = 226 + 17 * (Math.ceil(ColorDialog.prototype.presetColors.length / 12) + Math.ceil(ColorDialog.prototype.defaultColors.length / 12));

    if (null != e && s.cellEditor.isContentEditing()) {
      var r = s.cellEditor.saveSelection(),
          a = new ColorDialog(this.editorUi, n || "000000", i.bind(this, function (t) {
        s.cellEditor.restoreSelection(r), document.execCommand(e, !1, t != l.NONE ? t : "transparent");
      }), function () {
        s.cellEditor.restoreSelection(r);
      });
      this.editorUi.showDialog(a.container, 230, o, !0, !0), a.init();
    } else {
      null == this.colorDialog && (this.colorDialog = new ColorDialog(this.editorUi)), this.colorDialog.currentColorKey = t;
      var h = s.getView().getState(s.getSelectionCell()),
          u = "none";
      null != h && (u = h.style[t] || u), "none" == u ? (u = "ffffff", this.colorDialog.picker.fromString("ffffff"), this.colorDialog.colorInput.value = "none") : this.colorDialog.picker.fromString(u), this.editorUi.showDialog(this.colorDialog.container, 230, o, !0, !0), this.colorDialog.init();
    }
  }, y.prototype.toggleStyle = function (t, e) {
    var i = this.editorUi.editor.graph,
        n = i.toggleCellStyles(t, e);
    this.editorUi.fireEvent(new o("styleChanged", "keys", [t], "values", [n], "cells", i.getSelectionCells()));
  }, y.prototype.addMenuItem = function (t, e, i, n, s, o) {
    var l = this.editorUi.actions.get(e);

    if (null != l && (t.showDisabled || l.isEnabled()) && l.visible) {
      var r = t.addItem(o || l.label, null, function () {
        l.funct(n);
      }, i, s, l.isEnabled());
      return l.toggleAction && l.isSelected() && t.addCheckmark(r, x.checkmarkImage), this.addShortcut(r, l), r;
    }

    return null;
  }, y.prototype.addShortcut = function (t, e) {
    if (null != e.shortcut) {
      var n = t.firstChild.nextSibling.nextSibling,
          s = document.createElement("span");
      s.style.color = "gray", i.write(s, e.shortcut), n.appendChild(s);
    }
  }, y.prototype.addMenuItems = function (t, e, i, n, s) {
    for (var o = 0; o < e.length; o++) {
      "-" == e[o] ? t.addSeparator(i) : this.addMenuItem(t, e[o], i, n, null != s ? s[o] : null);
    }
  }, y.prototype.createPopupMenu = function (t, e, n) {
    var o = this.editorUi.editor.graph;
    if (t.smartSeparators = !0, o.isSelectionEmpty() ? this.addMenuItems(t, ["undo", "redo", "pasteHere"], null, n) : this.addMenuItems(t, ["delete", "-", "cut", "copy", "-", "duplicate"], null, n), o.isSelectionEmpty()) this.addMenuItems(t, ["-", "selectVertices", "selectEdges", "selectAll", "-", "clearDefaultStyle"], null, n);else {
      1 == o.getSelectionCount() && this.addMenuItems(t, ["setAsDefaultStyle"], null, n), t.addSeparator(), e = o.getSelectionCell();
      var r = o.view.getState(e);

      if (null != r) {
        var a = !1;

        if (this.addMenuItems(t, ["toFront", "toBack", "-"], null, n), o.getModel().isEdge(e) && "entityRelationEdgeStyle" != i.getValue(r.style, l.STYLE_EDGE, null) && "arrow" != i.getValue(r.style, l.STYLE_SHAPE, null)) {
          var h = o.selectionCellsHandler.getHandler(e),
              u = !1;

          if (h instanceof c && null != h.bends && h.bends.length > 2) {
            var d = h.getHandleForEvent(o.updateMouseEvent(new m(n))),
                p = this.editorUi.actions.get("removeWaypoint");
            p.handler = h, p.index = d, u = d > 0 && d < h.bends.length - 1;
          }

          t.addSeparator(), this.addMenuItem(t, "turn", null, n, null, s.get("reverse")), this.addMenuItems(t, [u ? "removeWaypoint" : "addWaypoint"], null, n);
          var g = o.getModel().getGeometry(e);
          a = null != g && null != g.points && g.points.length > 0;
        }

        1 == o.getSelectionCount() && (a || o.getModel().isVertex(e) && o.getModel().getEdgeCount(e) > 0) && this.addMenuItems(t, ["clearWaypoints"], null, n), o.getSelectionCount() > 1 ? (t.addSeparator(), this.addMenuItems(t, ["group"], null, n)) : 1 == o.getSelectionCount() && !o.getModel().isEdge(e) && !o.isSwimlane(e) && o.getModel().getChildCount(e) > 0 && (t.addSeparator(), this.addMenuItems(t, ["ungroup"], null, n)), 1 == o.getSelectionCount() && (t.addSeparator(), this.addMenuItems(t, ["editData", "editLink"], null, n), o.getModel().isVertex(e) && null != i.getValue(r.style, l.STYLE_IMAGE, null) && (t.addSeparator(), this.addMenuItem(t, "image", null, n).firstChild.nextSibling.innerHTML = s.get("editImage") + "..."));
      }
    }
  }, y.prototype.createMenubar = function (t) {
    for (var e = new f(this.editorUi, t), n = this.defaultMenuItems, o = 0; o < n.length; o++) {
      i.bind(this, function (t) {
        var l = e.addMenu(s.get(n[o]), i.bind(this, function () {
          t.funct.apply(this, arguments);
        }));
        this.menuCreated(t, l);
      })(this.get(n[o]));
    }

    return e;
  }, y.prototype.menuCreated = function (t, e, i) {
    null != e && (i = null != i ? i : "geItem", t.addListener("stateChanged", function () {
      e.enabled = t.enabled, t.enabled ? (e.className = i, 8 == document.documentMode && (e.style.color = "")) : (e.className = i + " mxDisabled", 8 == document.documentMode && (e.style.color = "#c3c3c3"));
    }));
  }, f.prototype.hideMenu = function () {
    this.editorUi.hideCurrentMenu();
  }, f.prototype.addMenu = function (t, e, n) {
    var s = document.createElement("a");
    return s.className = "geItem", i.write(s, t), this.addMenuHandler(s, e), null != n ? this.container.insertBefore(s, n) : this.container.appendChild(s), s;
  }, f.prototype.addMenuHandler = function (t, n) {
    if (null != n) {
      var s = !0,
          o = i.bind(this, function (e) {
        if (s && null == t.enabled || t.enabled) {
          this.editorUi.editor.graph.popupMenuHandler.hideMenu();
          var o = new g(n);
          o.div.className += " geMenubarMenu", o.smartSeparators = !0, o.showDisabled = !0, o.autoExpand = !0, o.hideMenu = i.bind(this, function () {
            g.prototype.hideMenu.apply(o, arguments), this.editorUi.resetCurrentMenu(), o.destroy();
          });
          var l = i.getOffset(t);
          o.popup(l.x, l.y + t.offsetHeight, null, e), this.editorUi.setCurrentMenu(o, t);
        }

        a.consume(e);
      });
      a.addListener(t, "mousemove", i.bind(this, function (e) {
        null != this.editorUi.currentMenu && this.editorUi.currentMenuElt != t && (this.editorUi.hideCurrentMenu(), o(e));
      })), a.addListener(t, e.IS_POINTER ? "pointerdown" : "mousedown", i.bind(this, function (e) {
        s = this.currentElt != t, e.preventDefault();
      })), a.addListener(t, "click", i.bind(this, function (t) {
        o(t), s = !0;
      }));
    }
  }, f.prototype.destroy = function () {}, i.extend(v, n), v.prototype.isEnabled = function () {
    return this.enabled;
  }, v.prototype.setEnabled = function (t) {
    this.enabled != t && (this.enabled = t, this.fireEvent(new o("stateChanged")));
  }, v.prototype.execute = function (t, e) {
    this.funct(t, e);
  }, new y(t);
}

function GraphBuilder(t, e, i, n, s, o) {
  var l = o.mxClient,
      r = o.mxUtils,
      a = o.mxResources,
      h = o.mxPopupMenu,
      u = o.mxEvent,
      d = o.mxConstants,
      p = o.mxGraph,
      c = o.mxText,
      m = o.mxGraphModel,
      g = o.mxGraphView,
      x = o.mxSvgCanvas2D,
      y = o.mxShape,
      f = o.mxRectangle,
      v = o.mxPoint,
      C = o.mxCellHighlight,
      E = o.mxLayoutManager,
      S = o.mxConnector,
      b = o.mxStencil,
      w = o.mxStencilRegistry,
      T = o.mxVertexHandler,
      A = o.mxEdgeHandler,
      L = o.mxGraphHandler,
      M = o.mxRubberband,
      I = o.mxGuide,
      R = o.mxConnectionHandler,
      P = o.mxConstraintHandler,
      O = o.mxCellEditor,
      H = o.mxPanningHandler,
      N = o.mxDragSource,
      D = o.mxValueChange,
      G = o.mxCellRenderer,
      _ = o.mxPolyline,
      U = o.mxCellState,
      k = o.mxHierarchicalLayout,
      V = o.mxEdgeStyle,
      B = o.mxImage,
      F = o.mxStackLayout,
      Y = o.mxEventObject,
      z = o.mxCodec,
      W = o.mxCell,
      X = o.mxDictionary,
      j = o.mxGeometry,
      Z = o.mxConnectionConstraint,
      K = o.mxCompactTreeLayout,
      Q = o.mxEllipse,
      J = o.mxStyleRegistry,
      q = o.mxImageShape,
      $ = o.mxPopupMenuHandler,
      tt = o.mxElbowEdgeHandler,
      et = o.mxImageExport,
      it = o.mxRectangleShape;

  function nt(t, e, i, n, s) {
    p.call(this, t, e, i, n), this.themes = s || this.defaultThemes, this.currentEdgeStyle = r.clone(this.defaultEdgeStyle), this.currentVertexStyle = r.clone(this.defaultVertexStyle);
    var o = this.baseUrl,
        a = o.indexOf("//");

    if (this.domainUrl = "", this.domainPathUrl = "", a > 0) {
      var c = o.indexOf("/", a + 2);
      c > 0 && (this.domainUrl = o.substring(0, c)), (c = o.lastIndexOf("/")) > 0 && (this.domainPathUrl = o.substring(0, c + 1));
    }

    if (this.isHtmlLabel = function (t) {
      var e = this.view.getState(t),
          i = null != e ? e.style : this.getCellStyle(t);
      return "1" == i.html || "wrap" == i[d.STYLE_WHITE_SPACE];
    }, this.edgeMode) {
      var m = {
        point: null,
        event: null,
        state: null,
        handle: null,
        selected: !1
      };
      this.addListener(u.FIRE_MOUSE_EVENT, r.bind(this, function (t, e) {
        if ("mouseDown" == e.getProperty("eventName") && this.isEnabled()) {
          var i = e.getProperty("event");

          if (!u.isControlDown(i.getEvent()) && !u.isShiftDown(i.getEvent())) {
            var n = i.getState();
            if (null != n && this.model.isEdge(n.cell)) if (m.point = new v(i.getGraphX(), i.getGraphY()), m.selected = this.isCellSelected(n.cell), m.state = n, m.event = i, null != n.text && null != n.text.boundingBox && r.contains(n.text.boundingBox, i.getGraphX(), i.getGraphY())) m.handle = u.LABEL_HANDLE;else {
              var s = this.selectionCellsHandler.getHandler(n.cell);
              null != s && null != s.bends && s.bends.length > 0 && (m.handle = s.getHandleForEvent(i));
            }
          }
        }
      })), this.addMouseListener({
        mouseDown: function mouseDown(t, e) {},
        mouseMove: r.bind(this, function (t, e) {
          var i = this.selectionCellsHandler.handlers.map;

          for (var n in i) {
            if (null != i[n].index) return;
          }

          if (this.isEnabled() && !this.panningHandler.isActive() && !u.isControlDown(e.getEvent()) && !u.isShiftDown(e.getEvent()) && !u.isAltDown(e.getEvent())) {
            var s = this.tolerance;

            if (null != m.point && null != m.state && null != m.event) {
              var o = m.state;

              if (Math.abs(m.point.x - e.getGraphX()) > s || Math.abs(m.point.y - e.getGraphY()) > s) {
                this.isCellSelected(o.cell) || this.setSelectionCell(o.cell);
                var l = this.selectionCellsHandler.getHandler(o.cell);

                if (null != l && null != l.bends && l.bends.length > 0) {
                  var a = l.getHandleForEvent(m.event),
                      h = this.view.getEdgeStyle(o),
                      d = h == V.EntityRelation;
                  if (m.selected || m.handle != u.LABEL_HANDLE || (a = m.handle), d && 0 != a && a != l.bends.length - 1 && a != u.LABEL_HANDLE) !d || null == o.visibleSourceState && null == o.visibleTargetState || (this.graphHandler.reset(), e.consume());else if (a == u.LABEL_HANDLE || 0 == a || null != o.visibleSourceState || a == l.bends.length - 1 || null != o.visibleTargetState) {
                    if (!d && a != u.LABEL_HANDLE) {
                      if (null != (p = o.absolutePoints) && (null == h && null == a || h == V.OrthConnector)) if (null == (a = m.handle)) if ((c = new f(m.point.x, m.point.y)).grow(A.prototype.handleImage.width / 2), r.contains(c, p[0].x, p[0].y)) a = 0;else if (r.contains(c, p[p.length - 1].x, p[p.length - 1].y)) a = l.bends.length - 1;else {
                        null != h && (2 == p.length || 3 == p.length && (0 == Math.round(p[0].x - p[1].x) && 0 == Math.round(p[1].x - p[2].x) || 0 == Math.round(p[0].y - p[1].y) && 0 == Math.round(p[1].y - p[2].y))) ? a = 2 : (a = r.findNearestSegment(o, m.point.x, m.point.y), null == h ? a = u.VIRTUAL_HANDLE - a : a += 1);
                      }
                      null == a && (a = u.VIRTUAL_HANDLE);
                    }

                    l.start(e.getGraphX(), e.getGraphX(), a), m.state = null, m.event = null, m.point = null, m.handle = null, m.selected = !1, e.consume(), this.graphHandler.reset();
                  }
                }
              }
            } else {
              if (null != (o = e.getState()) && this.model.isEdge(o.cell)) {
                var p,
                    c,
                    g = null;
                if (null != (p = o.absolutePoints)) if ((c = new f(e.getGraphX(), e.getGraphY())).grow(A.prototype.handleImage.width / 2), null != o.text && null != o.text.boundingBox && r.contains(o.text.boundingBox, e.getGraphX(), e.getGraphY())) g = "move";else if (r.contains(c, p[0].x, p[0].y) || r.contains(c, p[p.length - 1].x, p[p.length - 1].y)) g = "pointer";else if (null != o.visibleSourceState || null != o.visibleTargetState) {
                  if (g = "crosshair", this.view.getEdgeStyle(o) != V.EntityRelation && this.isOrthogonal(o)) {
                    var x = r.findNearestSegment(o, e.getGraphX(), e.getGraphY());
                    x < p.length - 1 && x >= 0 && (g = 0 == Math.round(p[x].x - p[x + 1].x) ? "col-resize" : "row-resize");
                  }
                }
                null != g && o.setCursor(g);
              }
            }
          }
        }),
        mouseUp: r.bind(this, function (t, e) {
          m.state = null, m.event = null, m.point = null, m.handle = null;
        })
      });
    }

    if (this.cellRenderer.getLabelValue = function (t) {
      var e = G.prototype.getLabelValue.apply(this, arguments);
      return t.view.graph.isHtmlLabel(t.cell) && (e = t.view.graph.sanitizeHtml(e)), e;
    }, void 0 !== T) {
      this.setConnectable(!0), this.setDropEnabled(!0), this.setPanning(!0), this.setTooltips(!0), this.setAllowLoops(!0), this.allowAutoPanning = !0, this.resetEdgesOnConnect = !1, this.constrainChildren = !1, this.constrainRelativeChildren = !0, this.graphHandler.scrollOnMove = !1, this.graphHandler.scaleGrid = !0, this.connectionHandler.setCreateTarget(!1), this.connectionHandler.insertBeforeSource = !0, this.connectionHandler.isValidSource = function (t, e) {
        return !1;
      }, this.alternateEdgeStyle = "vertical", null == n && this.loadStylesheet();
      var g = this.graphHandler.getGuideStates;
      this.graphHandler.getGuideStates = function () {
        var t = g.apply(this, arguments);

        if (this.graph.pageVisible) {
          for (var e = [], i = this.graph.pageFormat, n = this.graph.pageScale, s = i.width * n, o = i.height * n, l = this.graph.view.translate, r = this.graph.view.scale, a = this.graph.getPageLayout(), h = 0; h < a.width; h++) {
            e.push(new f(((a.x + h) * s + l.x) * r, (a.y * o + l.y) * r, s * r, o * r));
          }

          for (var u = 0; u < a.height; u++) {
            e.push(new f((a.x * s + l.x) * r, ((a.y + u) * o + l.y) * r, s * r, o * r));
          }

          t = e.concat(t);
        }

        return t;
      }, N.prototype.dragElementZIndex = h.prototype.zIndex, I.prototype.getGuideColor = function (t, e) {
        return null == t.cell ? "#ffa500" : d.GUIDE_COLOR;
      }, this.graphHandler.createPreviewShape = function (t) {
        return this.previewColor = "#000000" == this.graph.background ? "#ffffff" : L.prototype.previewColor, L.prototype.createPreviewShape.apply(this, arguments);
      }, this.graphHandler.getCells = function (t) {
        for (var e = L.prototype.getCells.apply(this, arguments), i = [], n = 0; n < e.length; n++) {
          var s = this.graph.view.getState(e[n]),
              o = null != s ? s.style : this.graph.getCellStyle(e[n]);

          if ("1" == r.getValue(o, "part", "0")) {
            var l = this.graph.model.getParent(e[n]);
            this.graph.model.isVertex(l) && r.indexOf(e, l) < 0 && i.push(l);
          } else i.push(e[n]);
        }

        return i;
      }, this.connectionHandler.createTargetVertex = function (t, e) {
        var i = this.graph.view.getState(e),
            n = null != i ? i.style : this.graph.getCellStyle(e);

        if (r.getValue(n, "part", !1)) {
          var s = this.graph.model.getParent(e);
          this.graph.model.isVertex(s) && (e = s);
        }

        return R.prototype.createTargetVertex.apply(this, arguments);
      };
      var x = new M(this);

      this.getRubberband = function () {
        return x;
      };

      var y = new Date().getTime(),
          C = 0,
          E = this.connectionHandler.mouseMove;

      this.connectionHandler.mouseMove = function () {
        var t = this.currentState;
        E.apply(this, arguments), t != this.currentState ? (y = new Date().getTime(), C = 0) : C = new Date().getTime() - y;
      };

      var S = this.connectionHandler.isOutlineConnectEvent;

      this.connectionHandler.isOutlineConnectEvent = function (t) {
        return null != this.currentState && t.getState() == this.currentState && C > 2e3 || (null == this.currentState || "0" != r.getValue(this.currentState.style, "outlineConnect", "1")) && S.apply(this, arguments);
      };

      var b = this.isToggleEvent;

      this.isToggleEvent = function (t) {
        return b.apply(this, arguments) || u.isShiftDown(t);
      };

      var w = x.isForceRubberbandEvent;

      x.isForceRubberbandEvent = function (t) {
        return w.apply(this, arguments) || r.hasScrollbars(this.graph.container) && l.IS_FF && l.IS_WIN && null == t.getState() && u.isTouchEvent(t.getEvent());
      };

      var P = null;
      this.panningHandler.addListener(u.PAN_START, r.bind(this, function () {
        this.isEnabled() && (P = this.container.style.cursor, this.container.style.cursor = "move");
      })), this.panningHandler.addListener(u.PAN_END, r.bind(this, function () {
        this.isEnabled() && (this.container.style.cursor = P);
      })), this.popupMenuHandler.autoExpand = !0, this.popupMenuHandler.isSelectOnPopup = function (t) {
        return u.isMouseEvent(t.getEvent());
      };
      var O = this.click;
      this.click = function (t) {
        var e = null == t.state && null != t.sourceState && this.isCellLocked(t.sourceState.cell);
        if (this.isEnabled() && !e || t.isConsumed()) return O.apply(this, arguments);
        var i = e ? t.sourceState.cell : t.getCell();

        if (null != i) {
          var n = this.getLinkForCell(i);
          null != n && (this.isCustomLink(n) ? this.customLinkClicked(n) : this.openLink(n));
        }
      }, this.tooltipHandler.getStateForEvent = function (t) {
        return t.sourceState;
      };
      this.getCursorForMouseEvent;

      this.getCursorForMouseEvent = function (t) {
        var e = null == t.state && null != t.sourceState && this.isCellLocked(t.sourceState.cell);
        return this.getCursorForCell(e ? t.sourceState.cell : t.getCell());
      };

      var H = this.getCursorForCell;
      this.getCursorForCell = function (t) {
        if (!this.isEnabled() || this.isCellLocked(t)) {
          if (null != this.getLinkForCell(t)) return "pointer";
          if (this.isCellLocked(t)) return "default";
        }

        return H.apply(this, arguments);
      }, this.selectRegion = function (t, e) {
        var i = this.getAllCells(t.x, t.y, t.width, t.height);
        return this.selectCellsForEvent(i, e), i;
      }, this.getAllCells = function (t, e, i, n, s, o) {
        if (o = null != o ? o : [], i > 0 || n > 0) {
          var l = this.getModel(),
              a = t + i,
              h = e + n;
          if (null == s && null == (s = this.getCurrentRoot()) && (s = l.getRoot()), null != s) for (var u = l.getChildCount(s), p = 0; p < u; p++) {
            var c = l.getChildAt(s, p),
                m = this.view.getState(c);

            if (null != m && this.isCellVisible(c) && "1" != r.getValue(m.style, "locked", "0")) {
              var g = r.getValue(m.style, d.STYLE_ROTATION) || 0,
                  x = m;
              0 != g && (x = r.getBoundingBox(x, g)), (l.isEdge(c) || l.isVertex(c)) && x.x >= t && x.y + x.height <= h && x.y >= e && x.x + x.width <= a && o.push(c), this.getAllCells(t, e, i, n, c, o);
            }
          }
        }

        return o;
      };
      var D = this.graphHandler.shouldRemoveCellsFromParent;
      this.graphHandler.shouldRemoveCellsFromParent = function (t, e, i) {
        return !this.graph.isCellSelected(t) && D.apply(this, arguments);
      }, this.isCellLocked = function (t) {
        for (var e = this.view.getState(t); null != e;) {
          if ("1" == r.getValue(e.style, "locked", "0")) return !0;
          e = this.view.getState(this.model.getParent(e.cell));
        }

        return !1;
      };
      var _ = null;
      this.addListener(u.FIRE_MOUSE_EVENT, r.bind(this, function (t, e) {
        if ("mouseDown" == e.getProperty("eventName")) {
          var i = e.getProperty("event").getState();
          _ = null == i || this.isSelectionEmpty() || this.isCellSelected(i.cell) ? null : this.getSelectionCells();
        }
      })), this.addListener(u.TAP_AND_HOLD, r.bind(this, function (t, e) {
        if (!u.isMultiTouchEvent(e)) {
          var i = e.getProperty("event"),
              n = e.getProperty("cell");

          if (null == n) {
            var s = r.convertPoint(this.container, u.getClientX(i), u.getClientY(i));
            x.start(s.x, s.y);
          } else null != _ ? this.addSelectionCells(_) : this.getSelectionCount() > 1 && this.isCellSelected(n) && this.removeSelectionCell(n);

          _ = null, e.consume();
        }
      })), this.connectionHandler.selectCells = function (t, e) {
        this.graph.setSelectionCell(e || t);
      }, this.connectionHandler.constraintHandler.isStateIgnored = function (t, e) {
        return e && t.view.graph.isCellSelected(t.cell);
      }, this.selectionModel.addListener(u.CHANGE, r.bind(this, function () {
        var t = this.connectionHandler.constraintHandler;
        null != t.currentFocus && t.isStateIgnored(t.currentFocus, !0) && (t.currentFocus = null, t.constraints = null, t.destroyIcons()), t.destroyFocusHighlight();
      })), nt.touchStyle && this.initTouch();
      var U = this.updateMouseEvent;

      this.updateMouseEvent = function (t) {
        return null != (t = U.apply(this, arguments)).state && this.isCellLocked(t.getCell()) && (t.state = null), t;
      };
    }

    this.currentTranslate = new v(0, 0);
  }

  return d.SHADOW_OPACITY = .25, d.SHADOWCOLOR = "#000000", d.VML_SHADOWCOLOR = "#d0d0d0", p.prototype.pageBreakColor = "#c0c0c0", p.prototype.pageScale = 1, function () {
    try {
      if (null != navigator && null != navigator.language) {
        var t = navigator.language.toLowerCase();
        p.prototype.pageFormat = "en-us" === t || "en-ca" === t || "es-mx" === t ? d.PAGE_FORMAT_LETTER_PORTRAIT : d.PAGE_FORMAT_A4_PORTRAIT;
      }
    } catch (t) {}
  }(), c.prototype.baseSpacingTop = 5, c.prototype.baseSpacingBottom = 1, m.prototype.ignoreRelativeEdgeParent = !1, g.prototype.gridImage = l.IS_SVG ? "data:image/gif;base64,R0lGODlhCgAKAJEAAAAAAP///8zMzP///yH5BAEAAAMALAAAAAAKAAoAAAIJ1I6py+0Po2wFADs=" : IMAGE_PATH + "/grid.gif", g.prototype.gridSteps = 4, g.prototype.minGridSize = 4, g.prototype.gridColor = "#e0e0e0", x.prototype.foAltText = "[Not supported by viewer]", y.prototype.getConstraints = function (t) {
    return null;
  }, nt.touchStyle = l.IS_TOUCH || l.IS_FF && l.IS_WIN || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 || null == window.urlParams || "1" == urlParams.touch, nt.fileSupport = null != window.File && null != window.FileReader && null != window.FileList && (null == window.urlParams || "0" != urlParams.filesupport), nt.lineJumpsEnabled = !0, nt.defaultJumpSize = 6, nt.createSvgImage = function (t, e, i) {
    var n = unescape(encodeURIComponent('<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="' + t + 'px" height="' + e + 'px" version="1.1">' + i + "</svg>"));
    return new B("data:image/svg+xml;base64," + (window.btoa ? btoa(n) : Base64.encode(n, !0)), t, e);
  }, r.extend(nt, p), nt.prototype.minFitScale = null, nt.prototype.maxFitScale = null, nt.prototype.linkPolicy = "frame" == urlParams.target ? "blank" : urlParams.target || "auto", nt.prototype.linkTarget = "frame" == urlParams.target ? "_self" : "_blank", nt.prototype.linkRelation = "nofollow noopener noreferrer", nt.prototype.defaultScrollbars = !l.IS_IOS, nt.prototype.defaultPageVisible = !0, nt.prototype.lightbox = !1, nt.prototype.defaultPageBackgroundColor = "#ffffff", nt.prototype.defaultPageBorderColor = "#ffffff", nt.prototype.scrollTileSize = new f(0, 0, 100, 100), nt.prototype.transparentBackground = !0, nt.prototype.defaultEdgeLength = 80, nt.prototype.edgeMode = !1, nt.prototype.connectionArrowsEnabled = !0, nt.prototype.placeholderPattern = new RegExp("%(date{.*}|[^%^{^}]+)%", "g"), nt.prototype.absoluteUrlPattern = new RegExp("^(?:[a-z]+:)?//", "i"), nt.prototype.defaultThemeName = "default", nt.prototype.defaultThemes = {}, nt.prototype.baseUrl = null != urlParams.base ? decodeURIComponent(urlParams.base) : (window != window.top ? document.referrer : document.location.toString()).split("#")[0], nt.prototype.editAfterInsert = !1, nt.prototype.builtInProperties = ["label", "tooltip", "placeholders", "placeholder"], nt.prototype.init = function (t) {
    p.prototype.init.apply(this, arguments), this.cellRenderer.initializeLabel = function (t, e) {
      G.prototype.initializeLabel.apply(this, arguments);
      var i = t.view.graph.tolerance,
          n = !0,
          s = null,
          o = r.bind(this, function (t) {
        n = !0, s = new v(u.getClientX(t), u.getClientY(t));
      }),
          l = r.bind(this, function (t) {
        n = n && null != s && Math.abs(s.x - u.getClientX(t)) < i && Math.abs(s.y - u.getClientY(t)) < i;
      }),
          a = r.bind(this, function (i) {
        if (n) for (var s = u.getSource(i); null != s && s != e.node;) {
          if ("a" == s.nodeName.toLowerCase()) {
            t.view.graph.labelLinkClicked(t, s, i);
            break;
          }

          s = s.parentNode;
        }
      });
      u.addGestureListeners(e.node, o, l, a), u.addListener(e.node, "click", function (t) {
        u.consume(t);
      });
    }, this.layoutManager || this.initLayoutManager();
  }, nt.prototype.getPrototype = function (t) {}, function () {
    nt.prototype.useCssTransforms = !1, nt.prototype.currentScale = 1, nt.prototype.currentTranslate = new v(0, 0), nt.prototype.isCssTransformsSupported = function () {
      return this.dialect == d.DIALECT_SVG && !l.NO_FO;
    }, nt.prototype.getCellAt = function (t, e, i, n, s, o) {
      return this.useCssTransforms && (t = t / this.currentScale - this.currentTranslate.x, e = e / this.currentScale - this.currentTranslate.y), this.getScaledCellAt.apply(this, arguments);
    }, nt.prototype.getScaledCellAt = function (t, e, i, n, s, o) {
      if (n = null == n || n, s = null == s || s, null == i && null == (i = this.getCurrentRoot()) && (i = this.getModel().getRoot()), null != i) for (var l = this.model.getChildCount(i) - 1; l >= 0; l--) {
        var r = this.model.getChildAt(i, l),
            a = this.getScaledCellAt(t, e, r, n, s, o);
        if (null != a) return a;

        if (this.isCellVisible(r) && (s && this.model.isEdge(r) || n && this.model.isVertex(r))) {
          var h = this.view.getState(r);
          if (null != h && (null == o || !o(h, t, e)) && this.intersects(h, t, e)) return r;
        }
      }
      return null;
    }, C.prototype.getStrokeWidth = function (t) {
      var e = this.strokeWidth;
      return this.graph.useCssTransforms && (e /= this.graph.currentScale), e;
    }, g.prototype.getGraphBounds = function () {
      var t = this.graphBounds;

      if (this.graph.useCssTransforms) {
        var e = this.graph.currentTranslate,
            i = this.graph.currentScale;
        t = new f((t.x + e.x) * i, (t.y + e.y) * i, t.width * i, t.height * i);
      }

      return t;
    }, g.prototype.viewStateChanged = function () {
      this.graph.useCssTransforms ? (this.validate(), this.graph.sizeDidChange()) : (this.revalidate(), this.graph.sizeDidChange());
    };
    var t = g.prototype.validate;
    g.prototype.validate = function (e) {
      this.graph.useCssTransforms && (this.graph.currentScale = this.scale, this.graph.currentTranslate.x = this.translate.x, this.graph.currentTranslate.y = this.translate.y, this.scale = 1, this.translate.x = 0, this.translate.y = 0), t.apply(this, arguments), this.graph.useCssTransforms && (this.graph.updateCssTransform(), this.scale = this.graph.currentScale, this.translate.x = this.graph.currentTranslate.x, this.translate.y = this.graph.currentTranslate.y);
    }, nt.prototype.updateCssTransform = function () {
      var t = this.view.getDrawPane();

      if (null != t) {
        var e = t.parentNode;

        if (this.useCssTransforms) {
          var i = e.getAttribute("transform");
          if (e.setAttribute("transformOrigin", "0 0"), e.setAttribute("transform", "scale(" + this.currentScale + "," + this.currentScale + ")translate(" + this.currentTranslate.x + "," + this.currentTranslate.y + ")"), i != e.getAttribute("transform")) try {
            if (l.IS_EDGE) {
              var n = e.style.display;
              e.style.display = "none", e.getBBox(), e.style.display = n;
            }
          } catch (t) {}
        } else e.removeAttribute("transformOrigin"), e.removeAttribute("transform");
      }
    };
    var e = g.prototype.validateBackgroundPage;

    g.prototype.validateBackgroundPage = function () {
      var t = this.graph.useCssTransforms,
          i = this.scale,
          n = this.translate;
      t && (this.scale = this.graph.currentScale, this.translate = this.graph.currentTranslate), e.apply(this, arguments), t && (this.scale = i, this.translate = n);
    };

    var i = p.prototype.updatePageBreaks;

    p.prototype.updatePageBreaks = function (t, e, n) {
      var s = this.useCssTransforms,
          o = this.view.scale,
          l = this.view.translate;
      s && (this.view.scale = 1, this.view.translate = new v(0, 0), this.useCssTransforms = !1), i.apply(this, arguments), s && (this.view.scale = o, this.view.translate = l, this.useCssTransforms = !0);
    };
  }(), nt.prototype.isLightboxView = function () {
    return this.lightbox;
  }, nt.prototype.labelLinkClicked = function (t, e, i) {
    var n = e.getAttribute("href");

    if (null != n && !this.isCustomLink(n) && u.isLeftMouseButton(i) && !u.isPopupTrigger(i) || u.isTouchEvent(i)) {
      if (!this.isEnabled() || this.isCellLocked(t.cell)) {
        var s = this.isBlankLink(n) ? this.linkTarget : "_top";
        this.openLink(this.getAbsoluteUrl(n), s);
      }

      u.consume(i);
    }
  }, nt.prototype.openLink = function (t, e, i) {
    var n = window;
    if ("_self" == e && window != window.top) window.location.href = t;else if (t.substring(0, this.baseUrl.length) == this.baseUrl && "#" == t.charAt(this.baseUrl.length) && "_top" == e && window == window.top) {
      var s = t.split("#")[1];
      window.location.hash == "#" + s && (window.location.hash = ""), window.location.hash = s;
    } else null == (n = window.open(t, e)) || i || (n.opener = null);
    return n;
  }, nt.prototype.getLinkTitle = function (t) {
    return t.substring(t.lastIndexOf("/") + 1);
  }, nt.prototype.isCustomLink = function (t) {
    return "data:" == t.substring(0, 5);
  }, nt.prototype.customLinkClicked = function (t) {
    return !1;
  }, nt.prototype.isExternalProtocol = function (t) {
    return "mailto:" === t.substring(0, 7);
  }, nt.prototype.isBlankLink = function (t) {
    return !this.isExternalProtocol(t) && ("blank" === this.linkPolicy || "self" !== this.linkPolicy && !this.isRelativeUrl(t) && t.substring(0, this.domainUrl.length) !== this.domainUrl);
  }, nt.prototype.isRelativeUrl = function (t) {
    return null != t && !this.absoluteUrlPattern.test(t) && "data:" !== t.substring(0, 5) && !this.isExternalProtocol(t);
  }, nt.prototype.initLayoutManager = function () {
    this.layoutManager = new E(this), this.layoutManager.getLayout = function (t) {
      var e = this.graph.view.getState(t),
          i = null != e ? e.style : this.graph.getCellStyle(t);

      if (null != i) {
        if ("stackLayout" == i.childLayout) {
          var n = new F(this.graph, !0);
          return n.resizeParentMax = "1" == r.getValue(i, "resizeParentMax", "1"), n.horizontal = "1" == r.getValue(i, "horizontalStack", "1"), n.resizeParent = "1" == r.getValue(i, "resizeParent", "1"), n.resizeLast = "1" == r.getValue(i, "resizeLast", "0"), n.spacing = i.stackSpacing || n.spacing, n.border = i.stackBorder || n.border, n.marginLeft = i.marginLeft || 0, n.marginRight = i.marginRight || 0, n.marginTop = i.marginTop || 0, n.marginBottom = i.marginBottom || 0, n.fill = !0, n;
        }

        if ("treeLayout" == i.childLayout) {
          var s = new K(this.graph);
          return s.horizontal = "1" == r.getValue(i, "horizontalTree", "1"), s.resizeParent = "1" == r.getValue(i, "resizeParent", "1"), s.groupPadding = r.getValue(i, "parentPadding", 20), s.levelDistance = r.getValue(i, "treeLevelDistance", 30), s.maintainParentLocation = !0, s.edgeRouting = !1, s.resetEdges = !1, s;
        }

        if ("flowLayout" == i.childLayout) {
          var o = new k(this.graph, r.getValue(i, "flowOrientation", d.DIRECTION_EAST));
          return o.resizeParent = "1" == r.getValue(i, "resizeParent", "1"), o.parentBorder = r.getValue(i, "parentPadding", 20), o.maintainParentLocation = !0, o.intraCellSpacing = r.getValue(i, "intraCellSpacing", k.prototype.intraCellSpacing), o.interRankCellSpacing = r.getValue(i, "interRankCellSpacing", k.prototype.interRankCellSpacing), o.interHierarchySpacing = r.getValue(i, "interHierarchySpacing", k.prototype.interHierarchySpacing), o.parallelEdgeSpacing = r.getValue(i, "parallelEdgeSpacing", k.prototype.parallelEdgeSpacing), o;
        }
      }

      return null;
    };
  }, nt.prototype.getPageSize = function () {
    return this.pageVisible ? new f(0, 0, this.pageFormat.width * this.pageScale, this.pageFormat.height * this.pageScale) : this.scrollTileSize;
  }, nt.prototype.getPageLayout = function () {
    var t = this.getPageSize(),
        e = this.getGraphBounds();
    if (0 == e.width || 0 == e.height) return new f(0, 0, 1, 1);
    var i = Math.ceil(e.x / this.view.scale - this.view.translate.x),
        n = Math.ceil(e.y / this.view.scale - this.view.translate.y),
        s = Math.floor(e.width / this.view.scale),
        o = Math.floor(e.height / this.view.scale),
        l = Math.floor(i / t.width),
        r = Math.floor(n / t.height),
        a = Math.ceil((i + s) / t.width) - l,
        h = Math.ceil((n + o) / t.height) - r;
    return new f(l, r, a, h);
  }, nt.prototype.sanitizeHtml = function (t, e) {
    return html_sanitize(t, function (t) {
      return null != t && "javascript:" !== t.toString().toLowerCase().substring(0, 11) ? t : null;
    }, function (t) {
      return t;
    });
  }, nt.prototype.updatePlaceholders = function () {
    this.model;
    var t = !1;

    for (var e in this.model.cells) {
      var i = this.model.cells[e];
      this.isReplacePlaceholders(i) && (this.view.invalidate(i, !1, !1), t = !0);
    }

    t && this.view.validate();
  }, nt.prototype.isReplacePlaceholders = function (t) {
    return null != t.value && "object" == typeof t.value && t.value.getAttribute && "1" == t.value.getAttribute("placeholders");
  }, nt.prototype.isZoomWheelEvent = function (t) {
    return u.isAltDown(t) || u.isMetaDown(t) && l.IS_MAC || u.isControlDown(t) && !l.IS_MAC;
  }, nt.prototype.isTransparentClickEvent = function (t) {
    return u.isAltDown(t);
  }, nt.prototype.isIgnoreTerminalEvent = function (t) {
    return u.isShiftDown(t) && u.isControlDown(t);
  }, nt.prototype.isSplitTarget = function (t, e, i) {
    return !this.model.isEdge(e[0]) && !u.isAltDown(i) && !u.isShiftDown(i) && p.prototype.isSplitTarget.apply(this, arguments);
  }, nt.prototype.getLabel = function (t) {
    var e = p.prototype.getLabel.apply(this, arguments);
    return null != e && this.isReplacePlaceholders(t) && null == t.getAttribute("placeholder") && (e = this.replacePlaceholders(t, e)), e;
  }, nt.prototype.isLabelMovable = function (t) {
    var e = this.view.getState(t),
        i = null != e ? e.style : this.getCellStyle(t);
    return !this.isCellLocked(t) && (this.model.isEdge(t) && this.edgeLabelsMovable || this.model.isVertex(t) && (this.vertexLabelsMovable || "1" == r.getValue(i, "labelMovable", "0")));
  }, nt.prototype.setGridSize = function (t) {
    this.gridSize = t, this.fireEvent(new Y("gridSizeChanged"));
  }, nt.prototype.getGlobalVariable = function (t) {
    var e = null;
    if ("date" == t) e = new Date().toLocaleDateString();else if ("time" == t) e = new Date().toLocaleTimeString();else if ("timestamp" == t) e = new Date().toLocaleString();else if ("date{" == t.substring(0, 5)) {
      var i = t.substring(5, t.length - 1);
      e = this.formatDate(new Date(), i);
    }
    return e;
  }, nt.prototype.formatDate = function (t, e, i) {
    null == this.dateFormatCache && (this.dateFormatCache = {
      i18n: {
        dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      },
      masks: {
        default: "ddd mmm dd yyyy HH:MM:ss",
        shortDate: "m/d/yy",
        mediumDate: "mmm d, yyyy",
        longDate: "mmmm d, yyyy",
        fullDate: "dddd, mmmm d, yyyy",
        shortTime: "h:MM TT",
        mediumTime: "h:MM:ss TT",
        longTime: "h:MM:ss TT Z",
        isoDate: "yyyy-mm-dd",
        isoTime: "HH:MM:ss",
        isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
        isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
      }
    });

    var n = this.dateFormatCache,
        s = function s(t, e) {
      for (t = String(t), e = e || 2; t.length < e;) {
        t = "0" + t;
      }

      return t;
    };

    if (1 != arguments.length || "[object String]" != Object.prototype.toString.call(t) || /\d/.test(t) || (e = t, t = void 0), t = t ? new Date(t) : new Date(), isNaN(t)) throw SyntaxError("invalid date");
    "UTC:" == (e = String(n.masks[e] || e || n.masks.default)).slice(0, 4) && (e = e.slice(4), i = !0);
    var o = i ? "getUTC" : "get",
        l = t[o + "Date"](),
        r = t[o + "Day"](),
        a = t[o + "Month"](),
        h = t[o + "FullYear"](),
        u = t[o + "Hours"](),
        d = t[o + "Minutes"](),
        p = t[o + "Seconds"](),
        c = t[o + "Milliseconds"](),
        m = i ? 0 : t.getTimezoneOffset(),
        g = {
      d: l,
      dd: s(l),
      ddd: n.i18n.dayNames[r],
      dddd: n.i18n.dayNames[r + 7],
      m: a + 1,
      mm: s(a + 1),
      mmm: n.i18n.monthNames[a],
      mmmm: n.i18n.monthNames[a + 12],
      yy: String(h).slice(2),
      yyyy: h,
      h: u % 12 || 12,
      hh: s(u % 12 || 12),
      H: u,
      HH: s(u),
      M: d,
      MM: s(d),
      s: p,
      ss: s(p),
      l: s(c, 3),
      L: s(c > 99 ? Math.round(c / 10) : c),
      t: u < 12 ? "a" : "p",
      tt: u < 12 ? "am" : "pm",
      T: u < 12 ? "A" : "P",
      TT: u < 12 ? "AM" : "PM",
      Z: i ? "UTC" : (String(t).match(/\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g) || [""]).pop().replace(/[^-+\dA-Z]/g, ""),
      o: (m > 0 ? "-" : "+") + s(100 * Math.floor(Math.abs(m) / 60) + Math.abs(m) % 60, 4),
      S: ["th", "st", "nd", "rd"][l % 10 > 3 ? 0 : (l % 100 - l % 10 != 10) * l % 10]
    };
    return e.replace(/d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g, function (t) {
      return t in g ? g[t] : t.slice(1, t.length - 1);
    });
  }, nt.prototype.createLayersDialog = function () {
    var t = document.createElement("div");
    t.style.position = "absolute";

    for (var e = this.getModel(), i = e.getChildCount(e.root), n = 0; n < i; n++) {
      r.bind(this, function (i) {
        var n = document.createElement("div");
        n.style.overflow = "hidden", n.style.textOverflow = "ellipsis", n.style.padding = "2px", n.style.whiteSpace = "nowrap";
        var s = document.createElement("input");
        s.style.display = "inline-block", s.setAttribute("type", "checkbox"), e.isVisible(i) && (s.setAttribute("checked", "checked"), s.defaultChecked = !0), n.appendChild(s);
        var o = this.convertValueToString(i) || a.get("background") || "Background";
        n.setAttribute("title", o), r.write(n, o), t.appendChild(n), u.addListener(s, "click", function () {
          null != s.getAttribute("checked") ? s.removeAttribute("checked") : s.setAttribute("checked", "checked"), e.setVisible(i, s.checked);
        });
      })(e.getChildAt(e.root, n));
    }

    return t;
  }, nt.prototype.replacePlaceholders = function (t, e) {
    var i,
        n = [];

    if (null != e) {
      for (var s = 0; i = this.placeholderPattern.exec(e);) {
        var o = i[0];

        if (o.length > 2 && "%label%" != o && "%tooltip%" != o) {
          var l = null;
          if (i.index > s && "%" == e.charAt(i.index - 1)) l = o.substring(1);else {
            var r = o.substring(1, o.length - 1);
            if (r.indexOf("{") < 0) for (var a = t; null == l && null != a;) {
              null != a.value && "object" == typeof a.value && (l = a.hasAttribute(r) ? null != a.getAttribute(r) ? a.getAttribute(r) : "" : null), a = this.model.getParent(a);
            }
            null == l && (l = this.getGlobalVariable(r));
          }
          n.push(e.substring(s, i.index) + (null != l ? l : o)), s = i.index + o.length;
        }
      }

      n.push(e.substring(s));
    }

    return n.join("");
  }, nt.prototype.restoreSelection = function (t) {
    if (null != t && t.length > 0) {
      for (var e = [], i = 0; i < t.length; i++) {
        var n = this.model.getCell(t[i].id);
        null != n && e.push(n);
      }

      this.setSelectionCells(e);
    } else this.clearSelection();
  }, nt.prototype.selectCellsForConnectVertex = function (t, e, i) {
    2 == t.length && this.model.isVertex(t[1]) ? (this.setSelectionCell(t[1]), null != i && (u.isTouchEvent(e) ? i.update(i.getState(this.view.getState(t[1]))) : i.reset()), this.scrollCellToVisible(t[1])) : this.setSelectionCells(t);
  }, nt.prototype.connectVertex = function (t, e, i, n, s, o) {
    o = o || !1;
    var l = t.geometry.relative && null != t.parent.geometry ? new v(t.parent.geometry.width * t.geometry.x, t.parent.geometry.height * t.geometry.y) : new v(t.geometry.x, t.geometry.y);
    e == d.DIRECTION_NORTH ? (l.x += t.geometry.width / 2, l.y -= i) : e == d.DIRECTION_SOUTH ? (l.x += t.geometry.width / 2, l.y += t.geometry.height + i) : e == d.DIRECTION_WEST ? (l.x -= i, l.y += t.geometry.height / 2) : (l.x += t.geometry.width + i, l.y += t.geometry.height / 2);
    var a = this.view.getState(this.model.getParent(t)),
        h = this.view.scale,
        p = this.view.translate,
        c = p.x * h,
        m = p.y * h;
    this.model.isVertex(a.cell) && (c = a.x, m = a.y), this.model.isVertex(t.parent) && t.geometry.relative && (l.x += t.parent.geometry.x, l.y += t.parent.geometry.y);
    var g = o || u.isControlDown(n) && !s ? null : this.getCellAt(c + l.x * h, m + l.y * h);
    this.model.isAncestor(g, t) && (g = null);

    for (var x = g; null != x;) {
      if (this.isCellLocked(x)) {
        g = null;
        break;
      }

      x = this.model.getParent(x);
    }

    if (null != g) {
      var y = this.view.getState(t),
          f = this.view.getState(g);
      null != y && null != f && r.intersects(y, f) && (g = null);
    }

    var C = !u.isShiftDown(n) || s;

    if (C && (e == d.DIRECTION_NORTH ? l.y -= t.geometry.height / 2 : e == d.DIRECTION_SOUTH ? l.y += t.geometry.height / 2 : e == d.DIRECTION_WEST ? l.x -= t.geometry.width / 2 : l.x += t.geometry.width / 2), null != g && !this.isCellConnectable(g)) {
      var E = this.getModel().getParent(g);
      this.getModel().isVertex(E) && this.isCellConnectable(E) && (g = E);
    }

    g != t && !this.model.isEdge(g) && this.isCellConnectable(g) || (g = null);
    var S = [];
    this.model.beginUpdate();

    try {
      var b = g;

      if (null == b && C) {
        for (var w = t, T = this.getCellGeometry(t); null != T && T.relative;) {
          w = this.getModel().getParent(w), T = this.getCellGeometry(w);
        }

        var A = this.view.getState(w),
            L = null != A ? A.style : this.getCellStyle(w);

        if (r.getValue(L, "part", !1)) {
          var M = this.model.getParent(w);
          this.model.isVertex(M) && (w = M);
        }

        b = this.duplicateCells([w], !1, !0)[0], null != (T = this.getCellGeometry(b)) && (T.x = l.x - T.width / 2, T.y = l.y - T.height / 2);
      }

      var I = null;
      null != this.layoutManager && (I = this.layoutManager.getLayout(this.model.getParent(t)));
      var R = u.isControlDown(n) && C || null == g && null != I && I.constructor == F ? null : this.insertEdge(this.model.getParent(t), null, "", t, b, this.createCurrentEdgeStyle());

      if (null != R && this.connectionHandler.insertBeforeSource) {
        for (var P = null, O = t; null != O.parent && null != O.geometry && O.geometry.relative && O.parent != R.parent;) {
          O = this.model.getParent(O);
        }

        if (null != O && null != O.parent && O.parent == R.parent) {
          P = O.parent.getIndex(O);
          this.model.add(O.parent, R, P);
        }
      }

      if (null == g && null != b && null != I && null != t.parent && I.constructor == F && e == d.DIRECTION_WEST) {
        P = t.parent.getIndex(t);
        this.model.add(t.parent, b, P);
      }

      null != R && S.push(R), null == g && null != b && S.push(b), null == b && null != R && R.geometry.setTerminalPoint(l, !1), null != R && this.fireEvent(new Y("cellsInserted", "cells", [R]));
    } finally {
      this.model.endUpdate();
    }

    return S;
  }, nt.prototype.getIndexableText = function () {
    var t = document.createElement("div"),
        e = [],
        i = "";

    for (var n in this.model.cells) {
      var s = this.model.cells[n];
      (this.model.isVertex(s) || this.model.isEdge(s)) && (this.isHtmlLabel(s) ? (t.innerHTML = this.getLabel(s), i = r.extractTextWithWhitespace([t])) : i = this.getLabel(s), (i = r.trim(i.replace("/[\0--]|s+/g", " "))).length > 0 && e.push(i));
    }

    return e.join(" ");
  }, nt.prototype.convertValueToString = function (t) {
    if (null != t.value && "object" == typeof t.value) {
      if (this.isReplacePlaceholders(t) && null != t.getAttribute("placeholder")) {
        for (var e = t.getAttribute("placeholder"), i = t, n = null; null == n && null != i;) {
          null != i.value && "object" == typeof i.value && (n = i.hasAttribute(e) ? null != i.getAttribute(e) ? i.getAttribute(e) : "" : null), i = this.model.getParent(i);
        }

        return n || "";
      }

      return t.value.getAttribute("label") || "";
    }

    return p.prototype.convertValueToString.apply(this, arguments);
  }, nt.prototype.getLinksForState = function (t) {
    return null != t && null != t.text && null != t.text.node ? t.text.node.getElementsByTagName("a") : null;
  }, nt.prototype.getLinkForCell = function (t) {
    if (null != t.value && "object" == typeof t.value && t.value.getAttribute) {
      var e = t.value.getAttribute("link");
      return null != e && "javascript:" === e.toLowerCase().substring(0, 11) && (e = e.substring(11)), e;
    }

    return null;
  }, nt.prototype.getCellStyle = function (t) {
    var e = p.prototype.getCellStyle.apply(this, arguments);

    if (null != t && null != this.layoutManager) {
      var i = this.model.getParent(t);

      if (this.model.isVertex(i) && this.isCellCollapsed(t)) {
        var n = this.layoutManager.getLayout(i);
        null != n && n.constructor == F && (e[d.STYLE_HORIZONTAL] = !n.horizontal);
      }
    }

    return e;
  }, nt.prototype.updateAlternateBounds = function (t, e, i) {
    if (null != t && null != e && null != this.layoutManager && null != e.alternateBounds) {
      var n = this.layoutManager.getLayout(this.model.getParent(t));
      null != n && n.constructor == F && (n.horizontal ? e.alternateBounds.height = 0 : e.alternateBounds.width = 0);
    }

    p.prototype.updateAlternateBounds.apply(this, arguments);
  }, nt.prototype.isMoveCellsEvent = function (t) {
    return u.isShiftDown(t);
  }, nt.prototype.foldCells = function (t, e, i, n, s) {
    if (e = null != e && e, null == i && (i = this.getFoldableCells(this.getSelectionCells(), t)), null != i) {
      this.model.beginUpdate();

      try {
        if (p.prototype.foldCells.apply(this, arguments), null != this.layoutManager) for (var o = 0; o < i.length; o++) {
          var l = this.view.getState(i[o]),
              r = this.getCellGeometry(i[o]);

          if (null != l && null != r) {
            var a = Math.round(r.width - l.width / this.view.scale),
                h = Math.round(r.height - l.height / this.view.scale);

            if (0 != h || 0 != a) {
              var d = this.model.getParent(i[o]),
                  c = this.layoutManager.getLayout(d);
              null == c ? null != s && this.isMoveCellsEvent(s) && this.moveSiblings(l, d, a, h) : null != s && u.isAltDown(s) || c.constructor != F || c.resizeLast || this.resizeParentStacks(d, c, a, h);
            }
          }
        }
      } finally {
        this.model.endUpdate();
      }

      this.isEnabled() && this.setSelectionCells(i);
    }
  }, nt.prototype.moveSiblings = function (t, e, i, n) {
    this.model.beginUpdate();

    try {
      for (var s = this.getCellsBeyond(t.x, t.y, e, !0, !0), o = 0; o < s.length; o++) {
        if (s[o] != t.cell) {
          var l = this.view.getState(s[o]),
              r = this.getCellGeometry(s[o]);
          null != l && null != r && ((r = r.clone()).translate(Math.round(i * Math.max(0, Math.min(1, (l.x - t.x) / t.width))), Math.round(n * Math.max(0, Math.min(1, (l.y - t.y) / t.height)))), this.model.setGeometry(s[o], r));
        }
      }
    } finally {
      this.model.endUpdate();
    }
  }, nt.prototype.resizeParentStacks = function (t, e, i, n) {
    if (null != this.layoutManager && null != e && e.constructor == F && !e.resizeLast) {
      this.model.beginUpdate();

      try {
        for (var s = e.horizontal; null != t && null != e && e.constructor == F && e.horizontal == s && !e.resizeLast;) {
          var o = this.getCellGeometry(t),
              l = this.view.getState(t);
          null != l && null != o && (o = o.clone(), e.horizontal ? o.width += i + Math.min(0, l.width / this.view.scale - o.width) : o.height += n + Math.min(0, l.height / this.view.scale - o.height), this.model.setGeometry(t, o)), t = this.model.getParent(t), e = this.layoutManager.getLayout(t);
        }
      } finally {
        this.model.endUpdate();
      }
    }
  }, nt.prototype.isContainer = function (t) {
    var e = this.view.getState(t),
        i = null != e ? e.style : this.getCellStyle(t);
    return this.isSwimlane(t) ? "0" != i.container : "1" == i.container;
  }, nt.prototype.isCellConnectable = function (t) {
    var e = this.view.getState(t),
        i = null != e ? e.style : this.getCellStyle(t);
    return null != i.connectable ? "0" != i.connectable : p.prototype.isCellConnectable.apply(this, arguments);
  }, nt.prototype.selectAll = function (t) {
    t = t || this.getDefaultParent(), this.isCellLocked(t) || p.prototype.selectAll.apply(this, arguments);
  }, nt.prototype.selectCells = function (t, e, i) {
    i = i || this.getDefaultParent(), this.isCellLocked(i) || p.prototype.selectCells.apply(this, arguments);
  }, nt.prototype.getSwimlaneAt = function (t, e, i) {
    return i = i || this.getDefaultParent(), this.isCellLocked(i) ? null : p.prototype.getSwimlaneAt.apply(this, arguments);
  }, nt.prototype.isCellFoldable = function (t) {
    var e = this.view.getState(t),
        i = null != e ? e.style : this.getCellStyle(t);
    return this.foldingEnabled && !this.isCellLocked(t) && (this.isContainer(t) && "0" != i.collapsible || !this.isContainer(t) && "1" == i.collapsible);
  }, nt.prototype.reset = function () {
    this.isEditing() && this.stopEditing(!0), this.escape(), this.isSelectionEmpty() || this.clearSelection();
  }, nt.prototype.zoom = function (t, e) {
    t = Math.max(.01, Math.min(this.view.scale * t, 160)) / this.view.scale, p.prototype.zoom.apply(this, arguments);
  }, nt.prototype.zoomIn = function () {
    this.view.scale < .15 ? this.zoom((this.view.scale + .01) / this.view.scale) : this.zoom(Math.round(this.view.scale * this.zoomFactor * 20) / 20 / this.view.scale);
  }, nt.prototype.zoomOut = function () {
    this.view.scale <= .15 ? this.zoom((this.view.scale - .01) / this.view.scale) : this.zoom(Math.round(this.view.scale * (1 / this.zoomFactor) * 20) / 20 / this.view.scale);
  }, nt.prototype.getTooltipForCell = function (t) {
    var e = "";

    if (r.isNode(t.value)) {
      var i = t.value.getAttribute("tooltip");
      if (null != i) null != i && this.isReplacePlaceholders(t) && (i = this.replacePlaceholders(t, i)), e = this.sanitizeHtml(i);else {
        var n = this.builtInProperties,
            s = t.value.attributes,
            o = [];
        this.isEnabled() && n.push("link");

        for (var a = 0; a < s.length; a++) {
          r.indexOf(n, s[a].nodeName) < 0 && s[a].nodeValue.length > 0 && o.push({
            name: s[a].nodeName,
            value: s[a].nodeValue
          });
        }

        o.sort(function (t, e) {
          return t.name < e.name ? -1 : t.name > e.name ? 1 : 0;
        });

        for (a = 0; a < o.length; a++) {
          "link" == o[a].name && this.isCustomLink(o[a].value) || (e += ("link" != o[a].name ? "<b>" + o[a].name + ":</b> " : "") + r.htmlEntities(o[a].value) + "\n");
        }

        e.length > 0 && (e = e.substring(0, e.length - 1), l.IS_SVG && (e = '<div style="max-width:360px;">' + e + "</div>"));
      }
    }

    return e;
  }, nt.prototype.stringToBytes = function (t) {
    for (var e = new Array(t.length), i = 0; i < t.length; i++) {
      e[i] = t.charCodeAt(i);
    }

    return e;
  }, nt.prototype.bytesToString = function (t) {
    for (var e = new Array(t.length), i = 0; i < t.length; i++) {
      e[i] = String.fromCharCode(t[i]);
    }

    return e.join("");
  }, nt.prototype.compressNode = function (t) {
    return this.compress(this.zapGremlins(r.getXml(t)));
  }, nt.prototype.compress = function (t) {
    if (null == t || 0 == t.length || "undefined" == typeof pako) return t;
    var e = this.bytesToString(pako.deflateRaw(encodeURIComponent(t)));
    return window.btoa ? btoa(e) : Base64.encode(e, !0);
  }, nt.prototype.decompress = function (t) {
    if (null == t || 0 == t.length || "undefined" == typeof pako) return t;
    var e = window.atob ? atob(t) : Base64.decode(t, !0);
    return this.zapGremlins(decodeURIComponent(this.bytesToString(pako.inflateRaw(e))));
  }, nt.prototype.zapGremlins = function (t) {
    for (var e = [], i = 0; i < t.length; i++) {
      var n = t.charCodeAt(i);
      (n >= 32 || 9 == n || 10 == n || 13 == n) && e.push(t.charAt(i));
    }

    return e.join("");
  }, function () {
    var t = g.prototype.resetValidationState;

    g.prototype.resetValidationState = function () {
      t.apply(this, arguments), this.validEdges = [];
    };

    var e = g.prototype.validateCellState;

    g.prototype.validateCellState = function (t, i) {
      var n = this.getState(t);
      return null != n && this.graph.model.isEdge(n.cell) && null != n.style && 1 != n.style[d.STYLE_CURVED] && !n.invalid && this.updateLineJumps(n) && this.graph.cellRenderer.redraw(n, !1, this.isRendering()), null != (n = e.apply(this, arguments)) && this.graph.model.isEdge(n.cell) && 1 != n.style[d.STYLE_CURVED] && this.validEdges.push(n), n;
    };

    var i = G.prototype.isShapeInvalid;

    G.prototype.isShapeInvalid = function (t, e) {
      return i.apply(this, arguments) || null != t.routedPoints && null != e.routedPoints && !r.equalPoints(e.routedPoints, t.routedPoints);
    };

    var n = g.prototype.updateCellState;
    g.prototype.updateCellState = function (t) {
      n.apply(this, arguments), this.graph.model.isEdge(t.cell) && 1 != t.style[d.STYLE_CURVED] && this.updateLineJumps(t);
    }, g.prototype.updateLineJumps = function (t) {
      var e = t.absolutePoints;

      if (nt.lineJumpsEnabled) {
        var i = null != t.routedPoints,
            n = null;

        if (null != e && null != this.validEdges && "none" !== r.getValue(t.style, "jumpStyle", "none")) {
          var _o = function _o(e, i, s) {
            var o = new v(i, s);
            o.type = e, n.push(o);
            var l = null != t.routedPoints ? t.routedPoints[n.length - 1] : null;
            return null == l || l.type != e || l.x != i || l.y != s;
          };

          var s = .5 * this.scale;
          i = !1, n = [];

          for (var l = 0; l < e.length - 1; l++) {
            for (var a = e[l + 1], h = e[l], u = [], d = e[l + 2]; l < e.length - 2 && r.ptSegDistSq(h.x, h.y, d.x, d.y, a.x, a.y) < 1 * this.scale * this.scale;) {
              a = d, d = e[++l + 2];
            }

            i = _o(0, h.x, h.y) || i;

            for (var p = 0; p < this.validEdges.length; p++) {
              var c = this.validEdges[p],
                  m = c.absolutePoints;
              if (null != m && r.intersects(t, c) && "1" != c.style.noJump) for (var g = 0; g < m.length - 1; g++) {
                var x,
                    y = m[g + 1],
                    f = m[g];

                for (d = m[g + 2]; g < m.length - 2 && r.ptSegDistSq(f.x, f.y, d.x, d.y, y.x, y.y) < 1 * this.scale * this.scale;) {
                  y = d, d = m[++g + 2];
                }

                if (null != (x = r.intersection(h.x, h.y, a.x, a.y, f.x, f.y, y.x, y.y)) && (Math.abs(x.x - f.x) > s || Math.abs(x.y - f.y) > s) && (Math.abs(x.x - y.x) > s || Math.abs(x.y - y.y) > s)) {
                  for (var C = x.x - h.x, E = x.y - h.y, S = {
                    distSq: C * C + E * E,
                    x: x.x,
                    y: x.y
                  }, b = 0; b < u.length; b++) {
                    if (u[b].distSq > S.distSq) {
                      u.splice(b, 0, S), S = null;
                      break;
                    }
                  }

                  null == S || 0 != u.length && u[u.length - 1].x === S.x && u[u.length - 1].y === S.y || u.push(S);
                }
              }
            }

            for (g = 0; g < u.length; g++) {
              i = _o(1, u[g].x, u[g].y) || i;
            }
          }

          i = _o(0, (x = e[e.length - 1]).x, x.y) || i;
        }

        return t.routedPoints = n, i;
      }

      return !1;
    };
    var s = S.prototype.paintLine;

    S.prototype.paintLine = function (t, e, i) {
      if (this.routedPoints = null != this.state ? this.state.routedPoints : null, this.outline || null == this.state || null == this.style || null == this.state.routedPoints || 0 == this.state.routedPoints.length) s.apply(this, arguments);else {
        var n = r.getValue(this.style, d.STYLE_ARCSIZE, d.LINE_ARCSIZE) / 2,
            o = (parseInt(r.getValue(this.style, "jumpSize", nt.defaultJumpSize)) - 2) / 2 + this.strokewidth,
            l = r.getValue(this.style, "jumpStyle", "none"),
            a = Editor.jumpSizeRatio,
            h = !0,
            u = null,
            p = null,
            c = [],
            m = null;
        t.begin();

        for (var g = 0; g < this.state.routedPoints.length; g++) {
          var x = this.state.routedPoints[g],
              y = new v(x.x / this.scale, x.y / this.scale);
          0 == g ? y = e[0] : g == this.state.routedPoints.length - 1 && (y = e[e.length - 1]);
          var f = !1;

          if (null != u && 1 == x.type) {
            var C,
                E,
                S = this.state.routedPoints[g + 1],
                b = (C = S.x / this.scale - y.x) * C + (E = S.y / this.scale - y.y) * E;
            if (null == m && (m = new v(y.x - u.x, y.y - u.y), p = Math.sqrt(m.x * m.x + m.y * m.y), m.x = m.x * o / p, m.y = m.y * o / p), b > o * o && p > 0) if ((b = (C = u.x - y.x) * C + (E = u.y - y.y) * E) > o * o) {
              var w = new v(y.x - m.x, y.y - m.y),
                  T = new v(y.x + m.x, y.y + m.y);
              c.push(w), this.addPoints(t, c, i, n, !1, null, h);
              a = Math.round(m.x) < 0 || 0 == Math.round(m.x) && Math.round(m.y) <= 0 ? 1 : -1;
              h = !1, "sharp" == l ? (t.lineTo(w.x - m.y * a, w.y + m.x * a), t.lineTo(T.x - m.y * a, T.y + m.x * a), t.lineTo(T.x, T.y)) : "arc" == l ? (a *= 1.3, t.curveTo(w.x - m.y * a, w.y + m.x * a, T.x - m.y * a, T.y + m.x * a, T.x, T.y)) : (t.moveTo(T.x, T.y), h = !0), c = [T], f = !0;
            }
          } else m = null;

          f || (c.push(y), u = y);
        }

        this.addPoints(t, c, i, n, !1, null, h), t.stroke();
      }
    };

    var o = g.prototype.updateFloatingTerminalPoint;
    g.prototype.updateFloatingTerminalPoint = function (t, e, i, n) {
      if (null == e || null == t || "1" != e.style.snapToPoint && "1" != t.style.snapToPoint) o.apply(this, arguments);else {
        e = this.getTerminalPort(t, e, n);
        var s = this.getNextPoint(t, i, n),
            l = this.graph.isOrthogonal(t),
            a = r.toRadians(Number(e.style[d.STYLE_ROTATION] || "0")),
            h = new v(e.getCenterX(), e.getCenterY());

        if (0 != a) {
          var u = Math.cos(-a),
              p = Math.sin(-a);
          s = r.getRotatedPoint(s, u, p, h);
        }

        var c = parseFloat(t.style[d.STYLE_PERIMETER_SPACING] || 0);
        c += parseFloat(t.style[n ? d.STYLE_SOURCE_PERIMETER_SPACING : d.STYLE_TARGET_PERIMETER_SPACING] || 0);
        var m = this.getPerimeterPoint(e, s, 0 == a && l, c);

        if (0 != a) {
          u = Math.cos(a), p = Math.sin(a);
          m = r.getRotatedPoint(m, u, p, h);
        }

        t.setAbsoluteTerminalPoint(this.snapToAnchorPoint(t, e, i, n, m), n);
      }
    }, g.prototype.snapToAnchorPoint = function (t, e, i, n, s) {
      if (null != e && null != t) {
        var o = this.graph.getAllConnectionConstraints(e),
            l = null,
            r = null;
        if (null != o) for (var a = 0; a < o.length; a++) {
          var h = this.graph.getConnectionPoint(e, o[a]);

          if (null != h) {
            var u = (h.x - s.x) * (h.x - s.x) + (h.y - s.y) * (h.y - s.y);
            (null == r || u < r) && (l = h, r = u);
          }
        }
        null != l && (s = l);
      }

      return s;
    };
    var l = b.prototype.evaluateTextAttribute;

    b.prototype.evaluateTextAttribute = function (t, e, i) {
      var n = l.apply(this, arguments);
      return "1" == t.getAttribute("placeholders") && null != i.state && (n = i.state.view.graph.replacePlaceholders(i.state.cell, n)), n;
    };

    var a = G.prototype.createShape;

    G.prototype.createShape = function (t) {
      if (null != t.style && "undefined" != typeof pako) {
        var e = r.getValue(t.style, d.STYLE_SHAPE, null);
        if (null != e && "stencil(" == e.substring(0, 8)) try {
          var i = e.substring(8, e.length - 1),
              n = r.parseXml(t.view.graph.decompress(i));
          return new y(new b(n.documentElement));
        } catch (t) {
          null != window.console && console.log("Error in shape: " + t);
        }
      }

      return a.apply(this, arguments);
    };
  }(), w.libraries = {}, w.dynamicLoading = !0, w.allowEval = !0, w.packages = [], w.getStencil = function (t) {
    var e = w.stencils[t],
        i = G.defaultShapes;

    if (null == e && null == i[t] && w.dynamicLoading) {
      var n = w.getBasenameForStencil(t);

      if (null != n) {
        var s = w.libraries[n];

        if (null != s) {
          if (null == w.packages[n]) {
            for (var o = 0; o < s.length; o++) {
              var l = s[o];
              if (".xml" == l.toLowerCase().substring(l.length - 4, l.length)) w.loadStencilSet(l, null);else if (".js" == l.toLowerCase().substring(l.length - 3, l.length)) try {
                if (w.allowEval) {
                  var a = r.load(l);
                  null != a && a.getStatus() >= 200 && a.getStatus() <= 299 && eval.call(window, a.getText());
                }
              } catch (t) {
                null != window.console && console.log("error in getStencil:", l, t);
              }
            }

            w.packages[n] = 1;
          }
        } else n = n.replace("_-_", "_"), w.loadStencilSet(STENCIL_PATH + "/" + n + ".xml", null);

        e = w.stencils[t];
      }
    }

    return e;
  }, w.getBasenameForStencil = function (t) {
    var e = null;

    if (null != t) {
      var i = t.split(".");

      if (i.length > 0 && "mxgraph" == i[0]) {
        e = i[1];

        for (var n = 2; n < i.length - 1; n++) {
          e += "/" + i[n];
        }
      }
    }

    return e;
  }, w.loadStencilSet = function (t, e, i, n) {
    i = null != i && i;
    var s = w.packages[t];

    if (i || null == s) {
      var o = !1;
      if (null == s) try {
        if (n) return void w.loadStencil(t, r.bind(this, function (i) {
          null != i && null != i.documentElement && (w.packages[t] = i, o = !0, w.parseStencilSet(i.documentElement, e, o));
        }));
        s = w.loadStencil(t), w.packages[t] = s, o = !0;
      } catch (e) {
        null != window.console && console.log("error in loadStencilSet:", t, e);
      }
      null != s && null != s.documentElement && w.parseStencilSet(s.documentElement, e, o);
    }
  }, w.loadStencil = function (t, e) {
    if (null == e) return r.load(t).getXml();
    r.get(t, r.bind(this, function (t) {
      e(t.getStatus() >= 200 && t.getStatus() <= 299 ? t.getXml() : null);
    }));
  }, w.parseStencilSets = function (t) {
    for (var e = 0; e < t.length; e++) {
      w.parseStencilSet(r.parseXml(t[e]).documentElement);
    }
  }, w.parseStencilSet = function (t, e, i) {
    if ("stencils" == t.nodeName) for (var n = t.firstChild; null != n;) {
      "shapes" == n.nodeName && w.parseStencilSet(n, e, i), n = n.nextSibling;
    } else {
      i = null == i || i;
      var s = t.firstChild,
          o = "",
          l = t.getAttribute("name");

      for (null != l && (o = l + "."); null != s;) {
        if (s.nodeType == d.NODETYPE_ELEMENT && null != (l = s.getAttribute("name"))) {
          o = o.toLowerCase();
          var r = l.replace(/ /g, "_");

          if (i && w.addStencil(o + r.toLowerCase(), new b(s)), null != e) {
            var a = s.getAttribute("w"),
                h = s.getAttribute("h");
            e(o, r, l, a = null == a ? 80 : parseInt(a, 10), h = null == h ? 80 : parseInt(h, 10));
          }
        }

        s = s.nextSibling;
      }
    }
  }, void 0 !== T && function () {
    d.HANDLE_FILLCOLOR = "#29b6f2", d.HANDLE_STROKECOLOR = "#0088cf", d.VERTEX_SELECTION_COLOR = "#00a8ff", d.OUTLINE_COLOR = "#00a8ff", d.OUTLINE_HANDLE_FILLCOLOR = "#99ccff", d.OUTLINE_HANDLE_STROKECOLOR = "#00a8ff", d.CONNECT_HANDLE_FILLCOLOR = "#cee7ff", d.EDGE_SELECTION_COLOR = "#00a8ff", d.DEFAULT_VALID_COLOR = "#00a8ff", d.LABEL_HANDLE_FILLCOLOR = "#cee7ff", d.GUIDE_COLOR = "#0088cf", d.HIGHLIGHT_OPACITY = 30, d.HIGHLIGHT_SIZE = 5, A.prototype.snapToTerminals = !0, L.prototype.guidesEnabled = !0, M.prototype.fadeOut = !0, I.prototype.isEnabledForEvent = function (t) {
      return !u.isAltDown(t);
    };
    var t = R.prototype.isCreateTarget;
    R.prototype.isCreateTarget = function (e) {
      return u.isControlDown(e) || t.apply(this, arguments);
    }, P.prototype.createHighlightShape = function () {
      var t = new Q(null, this.highlightColor, this.highlightColor, 0);
      return t.opacity = d.HIGHLIGHT_OPACITY, t;
    }, R.prototype.livePreview = !0, R.prototype.cursor = "crosshair", R.prototype.createEdgeState = function (t) {
      var e = this.graph.createCurrentEdgeStyle(),
          i = this.graph.createEdge(null, null, null, null, null, e),
          n = new U(this.graph.view, i, this.graph.getCellStyle(i));

      for (var s in this.graph.currentEdgeStyle) {
        n.style[s] = this.graph.currentEdgeStyle[s];
      }

      return n;
    };
    var e = R.prototype.createShape;
    R.prototype.createShape = function () {
      var t = e.apply(this, arguments);
      return t.isDashed = "1" == this.graph.currentEdgeStyle[d.STYLE_DASHED], t;
    }, R.prototype.updatePreview = function (t) {};
    var i = R.prototype.createMarker;
    R.prototype.createMarker = function () {
      var t = i.apply(this, arguments),
          e = t.getCell;
      return t.getCell = r.bind(this, function (t) {
        var i = e.apply(this, arguments);
        return this.error = null, i;
      }), t;
    }, R.prototype.isCellEnabled = function (t) {
      return !this.graph.isCellLocked(t);
    }, nt.prototype.defaultVertexStyle = {}, nt.prototype.defaultEdgeStyle = {
      edgeStyle: "orthogonalEdgeStyle",
      rounded: "0",
      jettySize: "auto",
      orthogonalLoop: "1"
    }, nt.prototype.createCurrentEdgeStyle = function () {
      var t = "edgeStyle=" + (this.currentEdgeStyle.edgeStyle || "none") + ";";
      return null != this.currentEdgeStyle.shape && (t += "shape=" + this.currentEdgeStyle.shape + ";"), null != this.currentEdgeStyle.curved && (t += "curved=" + this.currentEdgeStyle.curved + ";"), null != this.currentEdgeStyle.rounded && (t += "rounded=" + this.currentEdgeStyle.rounded + ";"), null != this.currentEdgeStyle.comic && (t += "comic=" + this.currentEdgeStyle.comic + ";"), null != this.currentEdgeStyle.jumpStyle && (t += "jumpStyle=" + this.currentEdgeStyle.jumpStyle + ";"), null != this.currentEdgeStyle.jumpSize && (t += "jumpSize=" + this.currentEdgeStyle.jumpSize + ";"), "elbowEdgeStyle" == this.currentEdgeStyle.edgeStyle && null != this.currentEdgeStyle.elbow && (t += "elbow=" + this.currentEdgeStyle.elbow + ";"), null != this.currentEdgeStyle.html ? t += "html=" + this.currentEdgeStyle.html + ";" : t += "html=1;", t;
    }, nt.prototype.getPagePadding = function () {
      return new v(0, 0);
    }, nt.prototype.loadStylesheet = function () {
      var t = null != this.themes ? this.themes[this.defaultThemeName] : J.dynamicLoading ? r.load(STYLE_PATH + "/default.xml").getDocumentElement() : null;
      null != t && new z(t.ownerDocument).decode(t, this.getStylesheet());
    }, nt.prototype.importGraphModel = function (t, e, i, n) {
      e = null != e ? e : 0, i = null != i ? i : 0;
      var s = new z(t.ownerDocument),
          o = new m();
      s.decode(t, o);
      var l = [],
          r = o.getChildren(this.cloneCell(o.root, this.isCloneInvalidEdges()));

      if (null != r) {
        r = r.slice(), this.model.beginUpdate();

        try {
          if (1 != r.length || this.isCellLocked(this.getDefaultParent())) for (var a = 0; a < r.length; a++) {
            l = l.concat(this.model.getChildren(this.moveCells([r[a]], e, i, !1, this.model.getRoot())[0]));
          } else l = this.moveCells(o.getChildren(r[0]), e, i, !1, this.getDefaultParent());

          if (n) {
            this.isGridEnabled() && (e = this.snap(e), i = this.snap(i));
            var h = this.getBoundingBoxFromGeometry(l, !0);
            null != h && this.moveCells(l, e - h.x, i - h.y);
          }
        } finally {
          this.model.endUpdate();
        }
      }

      return l;
    }, nt.prototype.getAllConnectionConstraints = function (t, e) {
      if (null != t) {
        var i = null != t.shape ? t.shape.getConstraints(t.style) : null;
        if (null != i) return i;

        if (null != (i = r.getValue(t.style, "points", null))) {
          var n = [];

          try {
            for (var s = JSON.parse(i), o = 0; o < s.length; o++) {
              var l = s[o];
              n.push(new Z(new v(l[0], l[1]), !(l.length > 2) || "0" != l[2]));
            }
          } catch (t) {}

          return n;
        }

        if (null != t.shape) if (null != t.shape.stencil) {
          if (null != t.shape.stencil) return t.shape.stencil.constraints;
        } else if (null != t.shape.constraints) return t.shape.constraints;
      }

      return null;
    }, nt.prototype.flipEdge = function (t) {
      if (null != t) {
        var e = this.view.getState(t),
            i = null != e ? e.style : this.getCellStyle(t);

        if (null != i) {
          var n = r.getValue(i, d.STYLE_ELBOW, d.ELBOW_HORIZONTAL) == d.ELBOW_HORIZONTAL ? d.ELBOW_VERTICAL : d.ELBOW_HORIZONTAL;
          this.setCellStyles(d.STYLE_ELBOW, n, [t]);
        }
      }
    }, nt.prototype.isValidRoot = function (t) {
      for (var e = this.model.getChildCount(t), i = 0, n = 0; n < e; n++) {
        var s = this.model.getChildAt(t, n);

        if (this.model.isVertex(s)) {
          var o = this.getCellGeometry(s);
          null == o || o.relative || i++;
        }
      }

      return i > 0 || this.isContainer(t);
    }, nt.prototype.isValidDropTarget = function (t) {
      var e = this.view.getState(t),
          i = null != e ? e.style : this.getCellStyle(t);
      return "1" != r.getValue(i, "part", "0") && (this.isContainer(t) || p.prototype.isValidDropTarget.apply(this, arguments) && "0" != r.getValue(i, "dropTarget", "1"));
    }, nt.prototype.createGroupCell = function () {
      var t = p.prototype.createGroupCell.apply(this, arguments);
      return t.setStyle("group"), t;
    }, nt.prototype.isExtendParentsOnAdd = function (t) {
      var e = p.prototype.isExtendParentsOnAdd.apply(this, arguments);

      if (e && null != t && null != this.layoutManager) {
        var i = this.model.getParent(t);

        if (null != i) {
          var n = this.layoutManager.getLayout(i);
          null != n && n.constructor == F && (e = !1);
        }
      }

      return e;
    }, nt.prototype.getPreferredSizeForCell = function (t) {
      var e = p.prototype.getPreferredSizeForCell.apply(this, arguments);
      return null != e && (e.width += 10, e.height += 4, this.gridEnabled && (e.width = this.snap(e.width), e.height = this.snap(e.height))), e;
    }, nt.prototype.turnShapes = function (t) {
      var e = this.getModel(),
          i = [];
      e.beginUpdate();

      try {
        for (var n = 0; n < t.length; n++) {
          var s = t[n];

          if (e.isEdge(s)) {
            var o = e.getTerminal(s, !0),
                l = e.getTerminal(s, !1);

            if (e.setTerminal(s, l, !0), e.setTerminal(s, o, !1), null != (g = e.getGeometry(s))) {
              null != (g = g.clone()).points && g.points.reverse();
              var r = g.getTerminalPoint(!0),
                  a = g.getTerminalPoint(!1);
              g.setTerminalPoint(r, !1), g.setTerminalPoint(a, !0), e.setGeometry(s, g);
              var h = this.view.getState(s),
                  u = this.view.getState(o),
                  p = this.view.getState(l);

              if (null != h) {
                var c = null != u ? this.getConnectionConstraint(h, u, !0) : null,
                    m = null != p ? this.getConnectionConstraint(h, p, !1) : null;
                this.setConnectionConstraint(s, o, !0, m), this.setConnectionConstraint(s, l, !1, c);
              }

              i.push(s);
            }
          } else if (e.isVertex(s)) {
            var g;

            if (null != (g = this.getCellGeometry(s))) {
              (g = g.clone()).x += g.width / 2 - g.height / 2, g.y += g.height / 2 - g.width / 2;
              var x = g.width;
              g.width = g.height, g.height = x, e.setGeometry(s, g);
              var y = this.view.getState(s);

              if (null != y) {
                var f = y.style[d.STYLE_DIRECTION] || "east";
                "east" == f ? f = "south" : "south" == f ? f = "west" : "west" == f ? f = "north" : "north" == f && (f = "east"), this.setCellStyles(d.STYLE_DIRECTION, f, [s]);
              }

              i.push(s);
            }
          }
        }
      } finally {
        e.endUpdate();
      }

      return i;
    }, nt.prototype.stencilHasPlaceholders = function (t) {
      if (null != t && null != t.fgNode) for (var e = t.fgNode.firstChild; null != e;) {
        if ("text" == e.nodeName && "1" == e.getAttribute("placeholders")) return !0;
        e = e.nextSibling;
      }
      return !1;
    }, nt.prototype.processChange = function (t) {
      if (p.prototype.processChange.apply(this, arguments), t instanceof D && null != t.cell && null != t.cell.value && "object" == typeof t.cell.value) {
        var e = this.model.getDescendants(t.cell);
        if (e.length > 0) for (var i = 0; i < e.length; i++) {
          var n = this.view.getState(e[i]);
          null != n && null != n.shape && null != n.shape.stencil && this.stencilHasPlaceholders(n.shape.stencil) ? this.removeStateForCell(e[i]) : this.isReplacePlaceholders(e[i]) && this.view.invalidate(e[i], !1, !1);
        }
      }
    }, nt.prototype.replaceElement = function (t, e) {
      for (var i, n = t.ownerDocument.createElement(null != e ? e : "span"), s = Array.prototype.slice.call(t.attributes); i = s.pop();) {
        n.setAttribute(i.nodeName, i.nodeValue);
      }

      n.innerHTML = t.innerHTML, t.parentNode.replaceChild(n, t);
    }, nt.prototype.updateLabelElements = function (t, e, i) {
      t = null != t ? t : this.getSelectionCells();

      for (var n = document.createElement("div"), s = 0; s < t.length; s++) {
        if (this.isHtmlLabel(t[s])) {
          var o = this.convertValueToString(t[s]);

          if (null != o && o.length > 0) {
            n.innerHTML = o;

            for (var l = n.getElementsByTagName(null != i ? i : "*"), r = 0; r < l.length; r++) {
              e(l[r]);
            }

            n.innerHTML != o && this.cellLabelChanged(t[s], n.innerHTML);
          }
        }
      }
    }, nt.prototype.cellsRemoved = function (t) {
      if (null != t) {
        for (var e = new X(), i = 0; i < t.length; i++) {
          e.put(t[i], !0);
        }

        var n = [];

        for (i = 0; i < t.length; i++) {
          var s = this.model.getParent(t[i]);
          null == s || e.get(s) || (e.put(s, !0), n.push(s));
        }

        for (i = 0; i < n.length; i++) {
          var o = this.view.getState(n[i]);

          if (null != o && (this.model.isEdge(o.cell) || this.model.isVertex(o.cell)) && this.isCellDeletable(o.cell)) {
            var l = r.getValue(o.style, d.STYLE_STROKECOLOR, d.NONE),
                a = r.getValue(o.style, d.STYLE_FILLCOLOR, d.NONE);

            if (l == d.NONE && a == d.NONE) {
              for (var h = !0, u = 0; u < this.model.getChildCount(o.cell) && h; u++) {
                e.get(this.model.getChildAt(o.cell, u)) || (h = !1);
              }

              h && t.push(o.cell);
            }
          }
        }
      }

      p.prototype.cellsRemoved.apply(this, arguments);
    }, nt.prototype.removeCellsAfterUngroup = function (t) {
      for (var e = [], i = 0; i < t.length; i++) {
        if (this.isCellDeletable(t[i])) {
          var n = this.view.getState(t[i]);

          if (null != n) {
            var s = r.getValue(n.style, d.STYLE_STROKECOLOR, d.NONE),
                o = r.getValue(n.style, d.STYLE_FILLCOLOR, d.NONE);
            s == d.NONE && o == d.NONE && e.push(t[i]);
          }
        }
      }

      t = e, p.prototype.removeCellsAfterUngroup.apply(this, arguments);
    }, nt.prototype.setLinkForCell = function (t, e) {
      this.setAttributeForCell(t, "link", e);
    }, nt.prototype.setTooltipForCell = function (t, e) {
      this.setAttributeForCell(t, "tooltip", e);
    }, nt.prototype.setAttributeForCell = function (t, e, i) {
      var n = null;
      null != t.value && "object" == typeof t.value ? n = t.value.cloneNode(!0) : (n = r.createXmlDocument().createElement("UserObject")).setAttribute("label", t.value || "");
      null != i && i.length > 0 ? n.setAttribute(e, i) : n.removeAttribute(e), this.model.setValue(t, n);
    }, nt.prototype.getDropTarget = function (t, e, i, n) {
      this.getModel();
      if (u.isAltDown(e)) return null;

      for (var s = 0; s < t.length; s++) {
        if (this.model.isEdge(this.model.getParent(t[s]))) return null;
      }

      return p.prototype.getDropTarget.apply(this, arguments);
    }, nt.prototype.click = function (t) {
      p.prototype.click.call(this, t), this.firstClickState = t.getState(), this.firstClickSource = t.getSource();
    }, nt.prototype.dblClick = function (t, e) {
      if (this.isEnabled()) {
        var i = r.convertPoint(this.container, u.getClientX(t), u.getClientY(t));

        if (null != t && !this.model.isVertex(e)) {
          var n = this.model.isEdge(e) ? this.view.getState(e) : null,
              s = u.getSource(t);
          this.firstClickState == n && this.firstClickSource == s && (null != n && null != n.text && null != n.text.node && (r.contains(n.text.boundingBox, i.x, i.y) || r.isAncestorNode(n.text.node, u.getSource(t))) || (null == n && !this.isCellLocked(this.getDefaultParent()) || null != n && !this.isCellLocked(n.cell)) && (null != n || l.IS_VML && s == this.view.getCanvas() || l.IS_SVG && s == this.view.getCanvas().ownerSVGElement) && (e = this.addText(i.x, i.y, n)));
        }

        p.prototype.dblClick.call(this, t, e);
      }
    }, nt.prototype.getInsertPoint = function () {
      var t = this.getGridSize(),
          e = this.container.scrollLeft / this.view.scale - this.view.translate.x,
          i = this.container.scrollTop / this.view.scale - this.view.translate.y;

      if (this.pageVisible) {
        var n = this.getPageLayout(),
            s = this.getPageSize();
        e = Math.max(e, n.x * s.width), i = Math.max(i, n.y * s.height);
      }

      return new v(this.snap(e + t), this.snap(i + t));
    }, nt.prototype.getFreeInsertPoint = function () {
      var t = this.view,
          e = this.getGraphBounds(),
          i = this.getInsertPoint(),
          n = this.snap(Math.round(Math.max(i.x, e.x / t.scale - t.translate.x + (0 == e.width ? 2 * this.gridSize : 0)))),
          s = this.snap(Math.round(Math.max(i.y, (e.y + e.height) / t.scale - t.translate.y + 2 * this.gridSize)));
      return new v(n, s);
    }, nt.prototype.isMouseInsertPoint = function () {
      return !1;
    }, nt.prototype.addText = function (t, e, i) {
      var n = new W();

      if (n.value = "Text", n.style = "text;html=1;resizable=0;points=[];", n.geometry = new j(0, 0, 0, 0), n.vertex = !0, null != i) {
        n.style += "align=center;verticalAlign=middle;labelBackgroundColor=#ffffff;", n.geometry.relative = !0, n.connectable = !1;
        var s = this.view.getRelativePoint(i, t, e);
        n.geometry.x = Math.round(1e4 * s.x) / 1e4, n.geometry.y = Math.round(s.y), n.geometry.offset = new v(0, 0), s = this.view.getPoint(i, n.geometry);
        var o = this.view.scale;
        n.geometry.offset = new v(Math.round((t - s.x) / o), Math.round((e - s.y) / o));
      } else {
        n.style += "autosize=1;align=left;verticalAlign=top;spacingTop=-4;";
        var l = this.view.translate;
        n.geometry.width = 40, n.geometry.height = 20, n.geometry.x = Math.round(t / this.view.scale) - l.x, n.geometry.y = Math.round(e / this.view.scale) - l.y;
      }

      this.getModel().beginUpdate();

      try {
        this.addCells([n], null != i ? i.cell : null), this.fireEvent(new Y("textInserted", "cells", [n])), this.autoSizeCell(n);
      } finally {
        this.getModel().endUpdate();
      }

      return n;
    }, nt.prototype.getAbsoluteUrl = function (t) {
      return null != t && this.isRelativeUrl(t) && (t = "#" == t.charAt(0) ? this.baseUrl + t : "/" == t.charAt(0) ? this.domainUrl + t : this.domainPathUrl + t), t;
    }, nt.prototype.addClickHandler = function (t, e, i) {
      var n = r.bind(this, function () {
        var t = this.container.getElementsByTagName("a");
        if (null != t) for (var i = 0; i < t.length; i++) {
          var n = this.getAbsoluteUrl(t[i].getAttribute("href"));
          null != n && (t[i].setAttribute("rel", this.linkRelation), t[i].setAttribute("href", n), null != e && u.addGestureListeners(t[i], null, null, e));
        }
      });
      this.model.addListener(u.CHANGE, n), n();
      var s = this.container.style.cursor,
          o = this.getTolerance(),
          l = this,
          a = {
        currentState: null,
        currentLink: null,
        highlight: null != t && "" != t && t != d.NONE ? new C(l, t, 4) : null,
        startX: 0,
        startY: 0,
        scrollLeft: 0,
        scrollTop: 0,
        updateCurrentState: function updateCurrentState(t) {
          var e = t.sourceState;

          if (null == e || null == l.getLinkForCell(e.cell)) {
            var i = l.getCellAt(t.getGraphX(), t.getGraphY(), null, null, null, function (t, e, i) {
              return null == l.getLinkForCell(t.cell);
            });
            e = l.view.getState(i);
          }

          e != this.currentState && (null != this.currentState && this.clear(), this.currentState = e, null != this.currentState && this.activate(this.currentState));
        },
        mouseDown: function mouseDown(t, e) {
          this.startX = e.getGraphX(), this.startY = e.getGraphY(), this.scrollLeft = l.container.scrollLeft, this.scrollTop = l.container.scrollTop, null == this.currentLink && "auto" == l.container.style.overflow && (l.container.style.cursor = "move"), this.updateCurrentState(e);
        },
        mouseMove: function mouseMove(t, e) {
          if (l.isMouseDown) {
            if (null != this.currentLink) {
              var i = Math.abs(this.startX - e.getGraphX()),
                  n = Math.abs(this.startY - e.getGraphY());
              (i > o || n > o) && this.clear();
            }
          } else {
            for (var s = e.getSource(); null != s && "a" != s.nodeName.toLowerCase();) {
              s = s.parentNode;
            }

            if (null != s) this.clear();else {
              if (null != l.tooltipHandler && null != this.currentLink && null != this.currentState && l.tooltipHandler.reset(e, !0, this.currentState), null != this.currentState && (e.getState() == this.currentState || null == e.sourceState) && l.intersects(this.currentState, e.getGraphX(), e.getGraphY())) return;
              this.updateCurrentState(e);
            }
          }
        },
        mouseUp: function mouseUp(t, n) {
          for (var s = n.getSource(), r = n.getEvent(), a = s; null != a && "a" != a.nodeName.toLowerCase();) {
            a = a.parentNode;
          }

          if (null == a && Math.abs(this.scrollLeft - l.container.scrollLeft) < o && Math.abs(this.scrollTop - l.container.scrollTop) < o && (null == n.sourceState || !n.isSource(n.sourceState.control)) && ((u.isLeftMouseButton(r) || u.isMiddleMouseButton(r)) && !u.isPopupTrigger(r) || u.isTouchEvent(r))) if (null != this.currentLink) {
            var h = l.isBlankLink(this.currentLink);

            if ("data:" !== this.currentLink.substring(0, 5) && h || null == e || e(r, this.currentLink), !u.isConsumed(r)) {
              var d = u.isMiddleMouseButton(r) ? "_blank" : h ? l.linkTarget : "_top";
              l.openLink(this.currentLink, d), n.consume();
            }
          } else null != i && !n.isConsumed() && Math.abs(this.scrollLeft - l.container.scrollLeft) < o && Math.abs(this.scrollTop - l.container.scrollTop) < o && Math.abs(this.startX - n.getGraphX()) < o && Math.abs(this.startY - n.getGraphY()) < o && i(n.getEvent());
          this.clear();
        },
        activate: function activate(t) {
          this.currentLink = l.getAbsoluteUrl(l.getLinkForCell(t.cell)), null != this.currentLink && (l.container.style.cursor = "pointer", null != this.highlight && this.highlight.highlight(t));
        },
        clear: function clear() {
          null != l.container && (l.container.style.cursor = s), this.currentState = null, this.currentLink = null, null != this.highlight && this.highlight.hide(), null != l.tooltipHandler && l.tooltipHandler.hide();
        }
      };
      l.click = function (t) {}, l.addMouseListener(a), u.addListener(document, "mouseleave", function (t) {
        a.clear();
      });
    }, nt.prototype.duplicateCells = function (t, e, i) {
      t = null != t ? t : this.getSelectionCells(), e = null == e || e, t = this.model.getTopmostCells(t);
      var n = this.getModel(),
          s = this.gridSize,
          o = [];
      n.beginUpdate();

      try {
        for (var l = i && 1 === t.length ? this.getPrototype(t[0]) : void 0, r = l ? [l] : this.cloneCells(t, !1, null, !0), a = 0; a < t.length; a++) {
          var h = n.getParent(t[a]),
              u = this.moveCells([r[a]], s, s, !1)[0];
          if (o.push(u), e) n.add(h, r[a]);else {
            var d = h.getIndex(t[a]);
            n.add(h, r[a], d + 1);
          }
        }
      } finally {
        n.endUpdate();
      }

      return o;
    }, nt.prototype.insertImage = function (t, e, i) {
      if (null != t) {
        for (var n = this.cellEditor.textarea.getElementsByTagName("img"), s = [], o = 0; o < n.length; o++) {
          s.push(n[o]);
        }

        document.execCommand("insertimage", !1, t);
        var l = this.cellEditor.textarea.getElementsByTagName("img");
        if (l.length == s.length + 1) for (o = l.length - 1; o >= 0; o--) {
          if (0 == o || l[o] != s[o - 1]) {
            l[o].setAttribute("width", e), l[o].setAttribute("height", i);
            break;
          }
        }
      }
    }, nt.prototype.insertLink = function (t) {
      if (0 == t.length) document.execCommand("unlink", !1);else if (l.IS_FF) {
        for (var e = this.cellEditor.textarea.getElementsByTagName("a"), i = [], n = 0; n < e.length; n++) {
          i.push(e[n]);
        }

        document.execCommand("createlink", !1, r.trim(t));
        var s = this.cellEditor.textarea.getElementsByTagName("a");
        if (s.length == i.length + 1) for (n = s.length - 1; n >= 0; n--) {
          if (s[n] != i[n - 1]) {
            for (e = s[n].getElementsByTagName("a"); e.length > 0;) {
              for (var o = e[0].parentNode; null != e[0].firstChild;) {
                o.insertBefore(e[0].firstChild, e[0]);
              }

              o.removeChild(e[0]);
            }

            break;
          }
        }
      } else document.execCommand("createlink", !1, r.trim(t));
    }, nt.prototype.isCellResizable = function (t) {
      var e = p.prototype.isCellResizable.apply(this, arguments),
          i = this.view.getState(t),
          n = null != i ? i.style : this.getCellStyle(t);
      return e || "0" != r.getValue(n, d.STYLE_RESIZABLE, "1") && "wrap" == n[d.STYLE_WHITE_SPACE];
    }, nt.prototype.distributeCells = function (t, e) {
      if (null == e && (e = this.getSelectionCells()), null != e && e.length > 1) {
        for (var i = [], n = null, s = null, o = 0; o < e.length; o++) {
          if (this.getModel().isVertex(e[o])) {
            var l = this.view.getState(e[o]);

            if (null != l) {
              var r = t ? l.getCenterX() : l.getCenterY();
              n = null != n ? Math.max(n, r) : r, s = null != s ? Math.min(s, r) : r, i.push(l);
            }
          }
        }

        if (i.length > 2) {
          i.sort(function (e, i) {
            return t ? e.x - i.x : e.y - i.y;
          });
          var a = this.view.translate,
              h = this.view.scale;
          s = s / h - (t ? a.x : a.y), n = n / h - (t ? a.x : a.y), this.getModel().beginUpdate();

          try {
            var u = (n - s) / (i.length - 1),
                d = s;

            for (o = 1; o < i.length - 1; o++) {
              var p = this.view.getState(this.model.getParent(i[o].cell)),
                  c = this.getCellGeometry(i[o].cell);
              d += u, null != c && null != p && (c = c.clone(), t ? c.x = Math.round(d - c.width / 2) - p.origin.x : c.y = Math.round(d - c.height / 2) - p.origin.y, this.getModel().setGeometry(i[o].cell, c));
            }
          } finally {
            this.getModel().endUpdate();
          }
        }
      }

      return e;
    }, nt.prototype.isCloneEvent = function (t) {
      return l.IS_MAC && u.isMetaDown(t) || u.isControlDown(t);
    }, nt.prototype.encodeCells = function (t) {
      for (var e = this.cloneCells(t), i = new X(), n = 0; n < t.length; n++) {
        i.put(t[n], !0);
      }

      for (n = 0; n < e.length; n++) {
        var s = this.view.getState(t[n]);

        if (null != s) {
          var o = this.getCellGeometry(e[n]);
          null == o || !o.relative || this.model.isEdge(t[n]) || i.get(this.model.getParent(t[n])) || (o.relative = !1, o.x = s.x / s.view.scale - s.view.translate.x, o.y = s.y / s.view.scale - s.view.translate.y);
        }
      }

      var l = new z(),
          r = new m(),
          a = r.getChildAt(r.getRoot(), 0);

      for (n = 0; n < t.length; n++) {
        r.add(a, e[n]);
      }

      return l.encode(r);
    }, nt.prototype.createSvgImageExport = function () {
      var t = new et();
      return t.getLinkForCellState = r.bind(this, function (t, e) {
        return this.getLinkForCell(t.cell);
      }), t;
    }, nt.prototype.getSvg = function (t, e, i, n, s, o, l, h, u, p) {
      var c = this.useCssTransforms;
      c && (this.useCssTransforms = !1, this.view.revalidate(), this.sizeDidChange());

      try {
        e = null != e ? e : 1, i = null != i ? i : 0, s = null == s || s, l = null == l || l;
        var m = (o = null == o || o) || n ? this.getGraphBounds() : this.getBoundingBox(this.getSelectionCells());
        if (null == m) throw Error(a.get("drawingEmpty"));
        var g = this.view.scale,
            x = r.createXmlDocument(),
            y = null != x.createElementNS ? x.createElementNS(d.NS_SVG, "svg") : x.createElement("svg");
        null != t && (null != y.style ? y.style.backgroundColor = t : y.setAttribute("style", "background-color:" + t)), null == x.createElementNS ? (y.setAttribute("xmlns", d.NS_SVG), y.setAttribute("xmlns:xlink", d.NS_XLINK)) : y.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", d.NS_XLINK);
        var v = e / g,
            C = Math.max(1, Math.ceil(m.width * v) + 2 * i) + (p ? 5 : 0),
            E = Math.max(1, Math.ceil(m.height * v) + 2 * i) + (p ? 5 : 0);
        y.setAttribute("version", "1.1"), y.setAttribute("width", C + "px"), y.setAttribute("height", E + "px"), y.setAttribute("viewBox", (s ? "-0.5 -0.5" : "0 0") + " " + C + " " + E), x.appendChild(y);
        var S = this.createSvgCanvas(y);
        S.foOffset = s ? -.5 : 0, S.textOffset = s ? -.5 : 0, S.imageOffset = s ? -.5 : 0, S.translate(Math.floor((i / e - m.x) / g), Math.floor((i / e - m.y) / g));
        var b = document.createElement("textarea"),
            w = S.createAlternateContent;

        S.createAlternateContent = function (t, e, i, n, s, o, l, r, a, h, u, p, c) {
          var m = this.state;
          if (null == this.foAltText || !(0 == n || 0 != m.fontSize && o.length < 5 * n / m.fontSize)) return w.apply(this, arguments);
          var g = this.createElement("text");
          g.setAttribute("x", Math.round(n / 2)), g.setAttribute("y", Math.round((s + m.fontSize) / 2)), g.setAttribute("fill", m.fontColor || "black"), g.setAttribute("text-anchor", "middle"), g.setAttribute("font-size", Math.round(m.fontSize) + "px"), g.setAttribute("font-family", m.fontFamily), (m.fontStyle & d.FONT_BOLD) == d.FONT_BOLD && g.setAttribute("font-weight", "bold"), (m.fontStyle & d.FONT_ITALIC) == d.FONT_ITALIC && g.setAttribute("font-style", "italic"), (m.fontStyle & d.FONT_UNDERLINE) == d.FONT_UNDERLINE && g.setAttribute("text-decoration", "underline");

          try {
            return b.innerHTML = o, g.textContent = b.value, g;
          } catch (t) {
            return w.apply(this, arguments);
          }
        };

        var T = this.backgroundImage;

        if (null != T) {
          var A = g / e,
              L = this.view.translate,
              M = new f(L.x * A, L.y * A, T.width * A, T.height * A);
          r.intersects(m, M) && S.image(L.x, L.y, T.width, T.height, T.src, !0);
        }

        S.scale(v), S.textEnabled = l;
        var I = (h = null != h ? h : this.createSvgImageExport()).drawCellState;
        return h.drawCellState = function (t, e) {
          for (var i = t.view.graph, n = i.isCellSelected(t.cell), s = i.model.getParent(t.cell); !o && !n && null != s;) {
            n = i.isCellSelected(s), s = i.model.getParent(s);
          }

          (o || n) && I.apply(this, arguments);
        }, h.drawState(this.getView().getState(this.model.root), S), this.updateSvgLinks(y, u, !0), y;
      } finally {
        c && (this.useCssTransforms = !0, this.view.revalidate(), this.sizeDidChange());
      }
    }, nt.prototype.updateSvgLinks = function (t, e, i) {
      for (var n = t.getElementsByTagName("a"), s = 0; s < n.length; s++) {
        var o = n[s].getAttribute("href");
        null == o && (o = n[s].getAttribute("xlink:href")), null != o && (null != e && /^https?:\/\//.test(o) ? n[s].setAttribute("target", e) : i && this.isCustomLink(o) && n[s].setAttribute("href", "javascript:void(0);"));
      }
    }, nt.prototype.createSvgCanvas = function (t) {
      return new x(t);
    }, nt.prototype.getSelectedElement = function () {
      var t = null;

      if (window.getSelection) {
        var e = window.getSelection();
        if (e.getRangeAt && e.rangeCount) t = e.getRangeAt(0).commonAncestorContainer;
      } else document.selection && (t = document.selection.createRange().parentElement());

      return t;
    }, nt.prototype.getParentByName = function (t, e, i) {
      for (; null != t;) {
        if (t.nodeName == e) return t;
        if (t == i) return null;
        t = t.parentNode;
      }

      return t;
    }, nt.prototype.selectNode = function (t) {
      var e = null;
      if (window.getSelection) (e = window.getSelection()).getRangeAt && e.rangeCount && ((i = document.createRange()).selectNode(t), e.removeAllRanges(), e.addRange(i));else if ((e = document.selection) && "Control" != e.type) {
        var i,
            n = e.createRange();
        n.collapse(!0), (i = e.createRange()).setEndPoint("StartToStart", n), i.select();
      }
    }, nt.prototype.insertRow = function (t, e) {
      for (var i = t.tBodies[0], n = i.rows[0].cells, s = 0, o = 0; o < n.length; o++) {
        var l = n[o].getAttribute("colspan");
        s += null != l ? parseInt(l) : 1;
      }

      var a = i.insertRow(e);

      for (o = 0; o < s; o++) {
        r.br(a.insertCell(-1));
      }

      return a.cells[0];
    }, nt.prototype.deleteRow = function (t, e) {
      t.tBodies[0].deleteRow(e);
    }, nt.prototype.insertColumn = function (t, e) {
      var i = t.tHead;
      if (null != i) for (var n = 0; n < i.rows.length; n++) {
        var s = document.createElement("th");
        i.rows[n].appendChild(s), r.br(s);
      }

      for (var o = t.tBodies[0], l = 0; l < o.rows.length; l++) {
        var a = o.rows[l].insertCell(e);
        r.br(a);
      }

      return o.rows[0].cells[e >= 0 ? e : o.rows[0].cells.length - 1];
    }, nt.prototype.deleteColumn = function (t, e) {
      if (e >= 0) for (var i = t.tBodies[0].rows, n = 0; n < i.length; n++) {
        i[n].cells.length > e && i[n].deleteCell(e);
      }
    }, nt.prototype.pasteHtmlAtCaret = function (t) {
      var e, i;

      if (window.getSelection) {
        if ((e = window.getSelection()).getRangeAt && e.rangeCount) {
          (i = e.getRangeAt(0)).deleteContents();
          var n = document.createElement("div");
          n.innerHTML = t;

          for (var s, o = document.createDocumentFragment(); s = n.firstChild;) {
            o.appendChild(s);
          }

          i.insertNode(o);
        }
      } else (e = document.selection) && "Control" != e.type && e.createRange().pasteHTML(t);
    }, nt.prototype.createLinkForHint = function (t, e) {
      function i(t, e) {
        return t.length > e && (t = t.substring(0, Math.round(e / 2)) + "..." + t.substring(t.length - Math.round(e / 4))), t;
      }

      t = null != t ? t : "javascript:void(0);", null != e && 0 != e.length || (e = this.isCustomLink(t) ? this.getLinkTitle(t) : t);
      var n = document.createElement("a");
      return n.setAttribute("rel", this.linkRelation), n.setAttribute("href", this.getAbsoluteUrl(t)), n.setAttribute("title", i(this.isCustomLink(t) ? this.getLinkTitle(t) : t, 80)), null != this.linkTarget && n.setAttribute("target", this.linkTarget), r.write(n, i(e, 40)), this.isCustomLink(t) && u.addListener(n, "click", r.bind(this, function (e) {
        this.customLinkClicked(t), u.consume(e);
      })), n;
    }, nt.prototype.initTouch = function () {
      this.connectionHandler.marker.isEnabled = function () {
        return null != this.graph.connectionHandler.first;
      }, this.addListener(u.START_EDITING, function (t, e) {
        this.popupMenuHandler.hideMenu();
      });
      var t = this.updateMouseEvent;

      this.updateMouseEvent = function (e) {
        if (e = t.apply(this, arguments), u.isTouchEvent(e.getEvent()) && null == e.getState()) {
          var i = this.getCellAt(e.graphX, e.graphY);
          null != i && this.isSwimlane(i) && this.hitsSwimlaneContent(i, e.graphX, e.graphY) ? i = null : (e.state = this.view.getState(i), null != e.state && null != e.state.shape && (this.container.style.cursor = e.state.shape.node.style.cursor));
        }

        return null == e.getState() && this.isEnabled() && (this.container.style.cursor = "default"), e;
      };

      var e = !1,
          i = !1,
          n = !1,
          s = this.fireMouseEvent;
      this.fireMouseEvent = function (t, o, l) {
        t == u.MOUSE_DOWN && (o = this.updateMouseEvent(o), e = this.isCellSelected(o.getCell()), i = this.isSelectionEmpty(), n = this.popupMenuHandler.isMenuShowing()), s.apply(this, arguments);
      }, this.popupMenuHandler.mouseUp = r.bind(this, function (t, s) {
        this.popupMenuHandler.popupTrigger = !this.isEditing() && this.isEnabled() && (null == s.getState() || !s.isSource(s.getState().control)) && (this.popupMenuHandler.popupTrigger || !n && !u.isMouseEvent(s.getEvent()) && (i && null == s.getCell() && this.isSelectionEmpty() || e && this.isCellSelected(s.getCell()))), $.prototype.mouseUp.apply(this.popupMenuHandler, arguments);
      });
    }, O.prototype.isContentEditing = function () {
      var t = this.graph.view.getState(this.editingCell);
      return null != t && 1 == t.style.html;
    }, O.prototype.saveSelection = function () {
      if (window.getSelection) {
        var t = window.getSelection();

        if (t.getRangeAt && t.rangeCount) {
          for (var e = [], i = 0, n = t.rangeCount; i < n; ++i) {
            e.push(t.getRangeAt(i));
          }

          return e;
        }
      } else if (document.selection && document.selection.createRange) return document.selection.createRange();

      return null;
    }, O.prototype.restoreSelection = function (t) {
      try {
        if (t) if (window.getSelection) {
          var e = window.getSelection();
          e.removeAllRanges();

          for (var i = 0, n = t.length; i < n; ++i) {
            e.addRange(t[i]);
          }
        } else document.selection && t.select && t.select();
      } catch (t) {}
    };
    var n = G.prototype.initializeLabel;

    G.prototype.initializeLabel = function (t) {
      null != t.text && (t.text.replaceLinefeeds = "0" != r.getValue(t.style, "nl2Br", "1")), n.apply(this, arguments);
    };

    var s = P.prototype.update;
    P.prototype.update = function (t, e) {
      this.isKeepFocusEvent(t) || !u.isAltDown(t.getEvent()) ? s.apply(this, arguments) : this.reset();
    }, I.prototype.createGuideShape = function (t) {
      return new _([], d.GUIDE_COLOR, d.GUIDE_STROKEWIDTH);
    }, O.prototype.escapeCancelsEditing = !1;
    var o = O.prototype.startEditing;

    O.prototype.startEditing = function (t, e) {
      o.apply(this, arguments);
      var i = this.graph.view.getState(t);
      null != i && 1 == i.style.html ? this.textarea.className = "mxCellEditor geContentEditable" : this.textarea.className = "mxCellEditor mxPlainTextEditor", this.codeViewMode = !1, this.switchSelectionState = null, this.graph.setSelectionCell(t);
      var n = this.graph.getModel().getParent(t),
          s = this.graph.getCellGeometry(t);
      this.graph.getModel().isEdge(n) && null != s && s.relative || this.graph.getModel().isEdge(t) ? l.IS_QUIRKS ? this.textarea.style.border = "gray dotted 1px" : l.IS_IE || l.IS_IE11 || l.IS_FF && l.IS_WIN ? this.textarea.style.outline = "gray dotted 1px" : this.textarea.style.outline = "" : l.IS_QUIRKS && (this.textarea.style.outline = "none", this.textarea.style.border = "");
    };

    var h = O.prototype.installListeners;
    O.prototype.installListeners = function (t) {
      function e(t) {
        for (var i = t.firstChild; null != i;) {
          var n = i.nextSibling;
          e(i), i = n;
        }

        1 == t.nodeType && ("BR" === t.nodeName || null != t.firstChild) || 3 == t.nodeType && 0 != r.trim(r.getTextContent(t)).length ? (3 == t.nodeType && r.setTextContent(t, r.getTextContent(t).replace(/\n|\r/g, "")), 1 == t.nodeType && (t.removeAttribute("style"), t.removeAttribute("class"), t.removeAttribute("width"), t.removeAttribute("cellpadding"), t.removeAttribute("cellspacing"), t.removeAttribute("border"))) : t.parentNode.removeChild(t);
      }

      h.apply(this, arguments), l.IS_QUIRKS || 7 === document.documentMode || 8 === document.documentMode || u.addListener(this.textarea, "paste", r.bind(this, function (t) {
        var i = function t(e, i) {
          i.originalNode = e, e = e.firstChild;

          for (var n = i.firstChild; null != e && null != n;) {
            t(e, n), e = e.nextSibling, n = n.nextSibling;
          }

          return i;
        }(this.textarea, this.textarea.cloneNode(!0));

        window.setTimeout(r.bind(this, function () {
          !function t(i, n) {
            if (null != i) if (n.originalNode != i) e(i);else for (i = i.firstChild, n = n.firstChild; null != i;) {
              var s = i.nextSibling;
              null == n ? e(i) : (t(i, n), n = n.nextSibling), i = s;
            }
          }(this.textarea, i);
        }), 0);
      }));
    }, O.prototype.toggleViewMode = function () {
      var t = this.graph.view.getState(this.editingCell),
          e = null != t && "0" != r.getValue(t.style, "nl2Br", "1"),
          i = this.saveSelection();

      if (this.codeViewMode) {
        (u = r.extractTextWithWhitespace(this.textarea.childNodes)).length > 0 && "\n" == u.charAt(u.length - 1) && (u = u.substring(0, u.length - 1)), u = this.graph.sanitizeHtml(e ? u.replace(/\n/g, "<br/>") : u, !0), this.textarea.className = "mxCellEditor geContentEditable";
        p = r.getValue(t.style, d.STYLE_FONTSIZE, d.DEFAULT_FONTSIZE);
        var n = r.getValue(t.style, d.STYLE_FONTFAMILY, d.DEFAULT_FONTFAMILY),
            s = r.getValue(t.style, d.STYLE_ALIGN, d.ALIGN_LEFT),
            o = (r.getValue(t.style, d.STYLE_FONTSTYLE, 0) & d.FONT_BOLD) == d.FONT_BOLD,
            a = (r.getValue(t.style, d.STYLE_FONTSTYLE, 0) & d.FONT_ITALIC) == d.FONT_ITALIC,
            h = (r.getValue(t.style, d.STYLE_FONTSTYLE, 0) & d.FONT_UNDERLINE) == d.FONT_UNDERLINE;
        this.textarea.style.lineHeight = d.ABSOLUTE_LINE_HEIGHT ? Math.round(p * d.LINE_HEIGHT) + "px" : d.LINE_HEIGHT, this.textarea.style.fontSize = Math.round(p) + "px", this.textarea.style.textDecoration = h ? "underline" : "", this.textarea.style.fontWeight = o ? "bold" : "normal", this.textarea.style.fontStyle = a ? "italic" : "", this.textarea.style.fontFamily = n, this.textarea.style.textAlign = s, this.textarea.style.padding = "0px", this.textarea.innerHTML != u && (this.textarea.innerHTML = u, 0 == this.textarea.innerHTML.length && (this.textarea.innerHTML = this.getEmptyLabelText(), this.clearOnChange = this.textarea.innerHTML.length > 0)), this.codeViewMode = !1;
      } else {
        this.clearOnChange && this.textarea.innerHTML == this.getEmptyLabelText() && (this.clearOnChange = !1, this.textarea.innerHTML = "");
        var u = r.htmlEntities(this.textarea.innerHTML);
        l.IS_QUIRKS || 8 == document.documentMode || (u = r.replaceTrailingNewlines(u, "<div><br></div>")), u = this.graph.sanitizeHtml(e ? u.replace(/\n/g, "").replace(/&lt;br\s*.?&gt;/g, "<br>") : u, !0), this.textarea.className = "mxCellEditor mxPlainTextEditor";
        var p = d.DEFAULT_FONTSIZE;
        this.textarea.style.lineHeight = d.ABSOLUTE_LINE_HEIGHT ? Math.round(p * d.LINE_HEIGHT) + "px" : d.LINE_HEIGHT, this.textarea.style.fontSize = Math.round(p) + "px", this.textarea.style.textDecoration = "", this.textarea.style.fontWeight = "normal", this.textarea.style.fontStyle = "", this.textarea.style.fontFamily = d.DEFAULT_FONTFAMILY, this.textarea.style.textAlign = "left", this.textarea.style.padding = "2px", this.textarea.innerHTML != u && (this.textarea.innerHTML = u), this.codeViewMode = !0;
      }

      this.textarea.focus(), null != this.switchSelectionState && this.restoreSelection(this.switchSelectionState), this.switchSelectionState = i, this.resize();
    };
    var c = O.prototype.resize;

    O.prototype.resize = function (t, e) {
      if (null != this.textarea) {
        t = this.graph.getView().getState(this.editingCell);

        if (this.codeViewMode && null != t) {
          var i = t.view.scale;

          if (this.bounds = f.fromRectangle(t), 0 == this.bounds.width && 0 == this.bounds.height) {
            this.bounds.width = 160 * i, this.bounds.height = 60 * i;
            var n = null != t.text ? t.text.margin : null;
            null == n && (n = r.getAlignmentAsPoint(r.getValue(t.style, d.STYLE_ALIGN, d.ALIGN_CENTER), r.getValue(t.style, d.STYLE_VERTICAL_ALIGN, d.ALIGN_MIDDLE))), this.bounds.x += n.x * this.bounds.width, this.bounds.y += n.y * this.bounds.height;
          }

          this.textarea.style.width = Math.round((this.bounds.width - 4) / i) + "px", this.textarea.style.height = Math.round((this.bounds.height - 4) / i) + "px", this.textarea.style.overflow = "auto", this.textarea.clientHeight < this.textarea.offsetHeight && (this.textarea.style.height = Math.round(this.bounds.height / i) + (this.textarea.offsetHeight - this.textarea.clientHeight) + "px", this.bounds.height = parseInt(this.textarea.style.height) * i), this.textarea.clientWidth < this.textarea.offsetWidth && (this.textarea.style.width = Math.round(this.bounds.width / i) + (this.textarea.offsetWidth - this.textarea.clientWidth) + "px", this.bounds.width = parseInt(this.textarea.style.width) * i), this.textarea.style.left = Math.round(this.bounds.x) + "px", this.textarea.style.top = Math.round(this.bounds.y) + "px", l.IS_VML ? this.textarea.style.zoom = i : r.setPrefixedStyle(this.textarea.style, "transform", "scale(" + i + "," + i + ")");
        } else this.textarea.style.height = "", this.textarea.style.overflow = "", c.apply(this, arguments);
      }
    };

    var g = O.prototype.getInitialValue;

    O.prototype.getInitialValue = function (t, e) {
      if ("0" == r.getValue(t.style, "html", "0")) return g.apply(this, arguments);
      var i = this.graph.getEditingValue(t.cell, e);
      return "1" == r.getValue(t.style, "nl2Br", "1") && (i = i.replace(/\n/g, "<br/>")), i = this.graph.sanitizeHtml(i, !0);
    };

    var E = O.prototype.getCurrentValue;

    O.prototype.getCurrentValue = function (t) {
      if ("0" == r.getValue(t.style, "html", "0")) return E.apply(this, arguments);
      var e = this.graph.sanitizeHtml(this.textarea.innerHTML, !0);
      return e = "1" == r.getValue(t.style, "nl2Br", "1") ? e.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>") : e.replace(/\r\n/g, "").replace(/\n/g, "");
    };

    var S = O.prototype.stopEditing;
    O.prototype.stopEditing = function (t) {
      this.codeViewMode && this.toggleViewMode(), S.apply(this, arguments), this.focusContainer();
    }, O.prototype.focusContainer = function () {
      try {
        this.graph.container.focus();
      } catch (t) {}
    };
    var b = O.prototype.applyValue;
    O.prototype.applyValue = function (t, e) {
      this.graph.getModel().beginUpdate();

      try {
        if (b.apply(this, arguments), this.graph.isCellDeletable(t.cell) && 0 == this.graph.model.getChildCount(t.cell)) {
          var i = r.getValue(t.style, d.STYLE_STROKECOLOR, d.NONE),
              n = r.getValue(t.style, d.STYLE_FILLCOLOR, d.NONE);
          "" == e && i == d.NONE && n == d.NONE && this.graph.removeCells([t.cell], !1);
        }
      } finally {
        this.graph.getModel().endUpdate();
      }
    }, O.prototype.getBackgroundColor = function (t) {
      var e = null;
      (this.graph.getModel().isEdge(t.cell) || this.graph.getModel().isEdge(this.graph.getModel().getParent(t.cell))) && (e = r.getValue(t.style, d.STYLE_LABEL_BACKGROUNDCOLOR, null)) == d.NONE && (e = null);
      return e;
    }, O.prototype.getMinimumSize = function (t) {
      var e = this.graph.getView().scale;
      return new f(0, 0, null == t.text ? 30 : t.text.size * e + 20, 30);
    };
    var w = L.prototype.moveCells;

    function N() {
      var t = document.createElement("div");
      return t.className = "geHint", t.style.whiteSpace = "nowrap", t.style.position = "absolute", t;
    }

    L.prototype.moveCells = function (t, e, i, n, s, o) {
      if (u.isAltDown(o) && (s = null), this.graph.checkDropTarget && !this.graph.checkDropTarget(t, s, o)) return null;
      w.apply(this, arguments);
    }, L.prototype.updateHint = function (t) {
      if (null != this.shape) {
        null == this.hint && (this.hint = N(), this.graph.container.appendChild(this.hint));
        var e = this.graph.view.translate,
            i = this.graph.view.scale,
            n = this.roundLength((this.bounds.x + this.currentDx) / i - e.x),
            s = this.roundLength((this.bounds.y + this.currentDy) / i - e.y);
        this.hint.innerHTML = n + ", " + s, this.hint.style.left = this.shape.bounds.x + Math.round((this.shape.bounds.width - this.hint.clientWidth) / 2) + "px", this.hint.style.top = this.shape.bounds.y + this.shape.bounds.height + 12 + "px";
      }
    }, L.prototype.removeHint = function () {
      null != this.hint && (this.hint.parentNode.removeChild(this.hint), this.hint = null);
    }, T.prototype.isRecursiveResize = function (t, e) {
      return !this.graph.isSwimlane(t.cell) && this.graph.model.getChildCount(t.cell) > 0 && !u.isControlDown(e.getEvent()) && !this.graph.isCellCollapsed(t.cell) && "1" == r.getValue(t.style, "recursiveResize", "1") && null == r.getValue(t.style, "childLayout", null);
    }, T.prototype.isCenteredEvent = function (t, e) {
      return !(!this.graph.isSwimlane(t.cell) && this.graph.model.getChildCount(t.cell) > 0 && !this.graph.isCellCollapsed(t.cell) && "1" == r.getValue(t.style, "recursiveResize", "1") && null == r.getValue(t.style, "childLayout", null)) && u.isControlDown(e.getEvent()) || u.isMetaDown(e.getEvent());
    };
    var k = T.prototype.getHandlePadding;

    if (T.prototype.getHandlePadding = function () {
      var t = new v(0, 0),
          e = this.tolerance;
      return this.graph.cellEditor.getEditingCell() == this.state.cell && null != this.sizers && this.sizers.length > 0 && null != this.sizers[0] ? (e /= 2, t.x = this.sizers[0].bounds.width + e, t.y = this.sizers[0].bounds.height + e) : t = k.apply(this, arguments), t;
    }, T.prototype.updateHint = function (t) {
      if (this.index != u.LABEL_HANDLE) {
        if (null == this.hint && (this.hint = N(), this.state.view.graph.container.appendChild(this.hint)), this.index == u.ROTATION_HANDLE) this.hint.innerHTML = this.currentAlpha + "&deg;";else {
          var e = this.state.view.scale;
          this.hint.innerHTML = this.roundLength(this.bounds.width / e) + " x " + this.roundLength(this.bounds.height / e);
        }
        var i = null != this.currentAlpha ? this.currentAlpha : this.state.style[d.STYLE_ROTATION] || "0",
            n = r.getBoundingBox(this.bounds, i);
        null == n && (n = this.bounds), this.hint.style.left = n.x + Math.round((n.width - this.hint.clientWidth) / 2) + "px", this.hint.style.top = n.y + n.height + 12 + "px", null != this.linkHint && (this.linkHint.style.display = "none");
      }
    }, T.prototype.removeHint = function () {
      L.prototype.removeHint.apply(this, arguments), null != this.linkHint && (this.linkHint.style.display = "");
    }, A.prototype.updateHint = function (t, e) {
      null == this.hint && (this.hint = N(), this.state.view.graph.container.appendChild(this.hint));
      var i = this.graph.view.translate,
          n = this.graph.view.scale,
          s = this.roundLength(e.x / n - i.x),
          o = this.roundLength(e.y / n - i.y);
      if (this.hint.innerHTML = s + ", " + o, this.hint.style.visibility = "visible", this.isSource || this.isTarget) if (null != this.constraintHandler.currentConstraint && null != this.constraintHandler.currentFocus) {
        var l = this.constraintHandler.currentConstraint.point;
        this.hint.innerHTML = "[" + Math.round(100 * l.x) + "%, " + Math.round(100 * l.y) + "%]";
      } else this.marker.hasValidState() && (this.hint.style.visibility = "hidden");
      this.hint.style.left = Math.round(t.getGraphX() - this.hint.clientWidth / 2) + "px", this.hint.style.top = Math.max(t.getGraphY(), e.y) + this.state.view.graph.gridSize + "px", null != this.linkHint && (this.linkHint.style.display = "none");
    }, A.prototype.removeHint = T.prototype.removeHint, T.prototype.rotationEnabled = !0, T.prototype.manageSizers = !0, T.prototype.livePreview = !0, M.prototype.defaultOpacity = 30, R.prototype.outlineConnect = !0, C.prototype.keepOnTop = !0, T.prototype.parentHighlightEnabled = !0, T.prototype.rotationHandleVSpacing = -20, A.prototype.parentHighlightEnabled = !0, A.prototype.dblClickRemoveEnabled = !0, A.prototype.straightRemoveEnabled = !0, A.prototype.virtualBendsEnabled = !0, A.prototype.mergeRemoveEnabled = !0, A.prototype.manageLabelHandle = !0, A.prototype.outlineConnect = !0, A.prototype.isAddVirtualBendEvent = function (t) {
      return !u.isShiftDown(t.getEvent());
    }, A.prototype.isCustomHandleEvent = function (t) {
      return !u.isShiftDown(t.getEvent());
    }, nt.touchStyle) {
      (l.IS_TOUCH || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) && (y.prototype.svgStrokeTolerance = 18, T.prototype.tolerance = 12, A.prototype.tolerance = 12, nt.prototype.tolerance = 12, T.prototype.rotationHandleVSpacing = -24, P.prototype.getTolerance = function (t) {
        return u.isMouseEvent(t.getEvent()) ? 4 : this.graph.getTolerance();
      }), H.prototype.isPanningTrigger = function (t) {
        var e = t.getEvent();
        return null == t.getState() && !u.isMouseEvent(e) || u.isPopupTrigger(e) && (null == t.getState() || u.isControlDown(e) || u.isShiftDown(e));
      };
      var V = L.prototype.mouseDown;

      L.prototype.mouseDown = function (t, e) {
        V.apply(this, arguments), u.isTouchEvent(e.getEvent()) && this.graph.isCellSelected(e.getCell()) && this.graph.getSelectionCount() > 1 && (this.delayedSelection = !1);
      };
    } else H.prototype.isPanningTrigger = function (t) {
      var e = t.getEvent();
      return u.isLeftMouseButton(e) && (this.useLeftButtonForPanning && null == t.getState() || u.isControlDown(e) && !u.isShiftDown(e)) || this.usePopupTrigger && u.isPopupTrigger(e);
    };

    M.prototype.isSpaceEvent = function (t) {
      return this.graph.isEnabled() && !this.graph.isCellLocked(this.graph.getDefaultParent()) && u.isControlDown(t.getEvent()) && u.isShiftDown(t.getEvent());
    }, M.prototype.mouseUp = function (t, e) {
      var i = null != this.div && "none" != this.div.style.display,
          n = null,
          s = null,
          o = null,
          l = null;

      if (null != this.first && null != this.currentX && null != this.currentY && (n = this.first.x, s = this.first.y, o = (this.currentX - n) / this.graph.view.scale, l = (this.currentY - s) / this.graph.view.scale, u.isAltDown(e.getEvent()) || (o = this.graph.snap(o), l = this.graph.snap(l), this.graph.isGridEnabled() || (Math.abs(o) < this.graph.tolerance && (o = 0), Math.abs(l) < this.graph.tolerance && (l = 0)))), this.reset(), i) {
        if (u.isAltDown(e.getEvent()) && this.graph.isToggleEvent(e.getEvent())) {
          var r = new f(this.x, this.y, this.width, this.height),
              a = this.graph.getCells(r.x, r.y, r.width, r.height);
          this.graph.removeSelectionCells(a);
        } else if (this.isSpaceEvent(e)) {
          this.graph.model.beginUpdate();

          try {
            a = this.graph.getCellsBeyond(n, s, this.graph.getDefaultParent(), !0, !0);

            for (var h = 0; h < a.length; h++) {
              if (this.graph.isCellMovable(a[h])) {
                var d = this.graph.view.getState(a[h]),
                    p = this.graph.getCellGeometry(a[h]);
                null != d && null != p && ((p = p.clone()).translate(o, l), this.graph.model.setGeometry(a[h], p));
              }
            }
          } finally {
            this.graph.model.endUpdate();
          }
        } else {
          r = new f(this.x, this.y, this.width, this.height);
          this.graph.selectRegion(r, e.getEvent());
        }

        e.consume();
      }
    }, M.prototype.mouseMove = function (t, e) {
      if (!e.isConsumed() && null != this.first) {
        var i = r.getScrollOrigin(this.graph.container),
            n = r.getOffset(this.graph.container);
        i.x -= n.x, i.y -= n.y;
        var s = e.getX() + i.x,
            o = e.getY() + i.y,
            l = this.first.x - s,
            a = this.first.y - o,
            h = this.graph.tolerance;

        if (null != this.div || Math.abs(l) > h || Math.abs(a) > h) {
          if (null == this.div && (this.div = this.createShape()), r.clearSelection(), this.update(s, o), this.isSpaceEvent(e)) {
            var d = this.x + this.width,
                p = this.y + this.height,
                c = this.graph.view.scale;
            u.isAltDown(e.getEvent()) || (this.width = this.graph.snap(this.width / c) * c, this.height = this.graph.snap(this.height / c) * c, this.graph.isGridEnabled() || (this.width < this.graph.tolerance && (this.width = 0), this.height < this.graph.tolerance && (this.height = 0)), this.x < this.first.x && (this.x = d - this.width), this.y < this.first.y && (this.y = p - this.height)), this.div.style.borderStyle = "dashed", this.div.style.backgroundColor = "white", this.div.style.left = this.x + "px", this.div.style.top = this.y + "px", this.div.style.width = Math.max(0, this.width) + "px", this.div.style.height = this.graph.container.clientHeight + "px", this.div.style.borderWidth = this.width <= 0 ? "0px 1px 0px 0px" : "0px 1px 0px 1px", null == this.secondDiv && (this.secondDiv = this.div.cloneNode(!0), this.div.parentNode.appendChild(this.secondDiv)), this.secondDiv.style.left = this.x + "px", this.secondDiv.style.top = this.y + "px", this.secondDiv.style.width = this.graph.container.clientWidth + "px", this.secondDiv.style.height = Math.max(0, this.height) + "px", this.secondDiv.style.borderWidth = this.height <= 0 ? "1px 0px 0px 0px" : "1px 0px 1px 0px";
          } else this.div.style.backgroundColor = "", this.div.style.borderWidth = "", this.div.style.borderStyle = "", null != this.secondDiv && (this.secondDiv.parentNode.removeChild(this.secondDiv), this.secondDiv = null);

          e.consume();
        }
      }
    };
    var B = M.prototype.reset;

    M.prototype.reset = function () {
      null != this.secondDiv && (this.secondDiv.parentNode.removeChild(this.secondDiv), this.secondDiv = null), B.apply(this, arguments);
    };

    var K = new Date().getTime(),
        st = 0,
        ot = A.prototype.updatePreviewState;

    A.prototype.updatePreviewState = function (t, e, i, n) {
      ot.apply(this, arguments), i != this.currentTerminalState ? (K = new Date().getTime(), st = 0) : st = new Date().getTime() - K, this.currentTerminalState = i;
    };

    var lt = A.prototype.isOutlineConnectEvent;
    A.prototype.isOutlineConnectEvent = function (t) {
      return null != this.currentTerminalState && t.getState() == this.currentTerminalState && st > 2e3 || (null == this.currentTerminalState || "0" != r.getValue(this.currentTerminalState.style, "outlineConnect", "1")) && lt.apply(this, arguments);
    }, T.prototype.isCustomHandleEvent = function (t) {
      return !u.isShiftDown(t.getEvent());
    }, A.prototype.createHandleShape = function (t, e) {
      var i = null != t && 0 == t,
          n = this.state.getVisibleTerminalState(i),
          s = null != t && (0 == t || t >= this.state.absolutePoints.length - 1 || this.constructor == tt && 2 == t) ? this.graph.getConnectionConstraint(this.state, n, i) : null,
          o = null != (null != s ? this.graph.getConnectionPoint(this.state.getVisibleTerminalState(i), s) : null) ? this.fixedHandleImage : null != s && null != n ? this.terminalHandleImage : this.handleImage;

      if (null != o) {
        var l = new q(new f(0, 0, o.width, o.height), o.src);
        return l.preserveImageAspect = !1, l;
      }

      var r = d.HANDLE_SIZE;
      return this.preferHtml && (r -= 1), new it(new f(0, 0, r, r), d.HANDLE_FILLCOLOR, d.HANDLE_STROKECOLOR);
    };
    var rt = L.prototype.getBoundingBox;

    L.prototype.getBoundingBox = function (t) {
      if (null != t && 1 == t.length) {
        var e = this.graph.getModel(),
            i = e.getParent(t[0]),
            n = this.graph.getCellGeometry(t[0]);

        if (e.isEdge(i) && null != n && n.relative) {
          var s = this.graph.view.getState(t[0]);
          if (null != s && s.width < 2 && s.height < 2 && null != s.text && null != s.text.boundingBox) return f.fromRectangle(s.text.boundingBox);
        }
      }

      return rt.apply(this, arguments);
    };

    var at = T.prototype.getSelectionBounds;

    T.prototype.getSelectionBounds = function (t) {
      var e = this.graph.getModel(),
          i = e.getParent(t.cell),
          n = this.graph.getCellGeometry(t.cell);

      if (e.isEdge(i) && null != n && n.relative && t.width < 2 && t.height < 2 && null != t.text && null != t.text.boundingBox) {
        var s = t.text.unrotatedBoundingBox || t.text.boundingBox;
        return new f(Math.round(s.x), Math.round(s.y), Math.round(s.width), Math.round(s.height));
      }

      return at.apply(this, arguments);
    };

    var ht = T.prototype.mouseDown;
    T.prototype.mouseDown = function (t, e) {
      var i = this.graph.getModel(),
          n = i.getParent(this.state.cell),
          s = this.graph.getCellGeometry(this.state.cell);
      (this.getHandleForEvent(e) == u.ROTATION_HANDLE || !i.isEdge(n) || null == s || !s.relative || null == this.state || this.state.width >= 2 || this.state.height >= 2) && ht.apply(this, arguments);
    }, T.prototype.isRotationHandleVisible = function () {
      return this.graph.isEnabled() && this.rotationEnabled && this.graph.isCellRotatable(this.state.cell) && (L.prototype.maxCells <= 0 || this.graph.getSelectionCount() < L.prototype.maxCells);
    }, T.prototype.rotateClick = function () {
      this.state.view.graph.turnShapes([this.state.cell]);
    };
    var ut = T.prototype.mouseMove;

    T.prototype.mouseMove = function (t, e) {
      ut.apply(this, arguments), null != this.graph.graphHandler.first && null != this.rotationShape && null != this.rotationShape.node && (this.rotationShape.node.style.display = "none");
    };

    var dt = T.prototype.mouseUp;

    T.prototype.mouseUp = function (t, e) {
      dt.apply(this, arguments), null != this.rotationShape && null != this.rotationShape.node && (this.rotationShape.node.style.display = 1 == this.graph.getSelectionCount() ? "" : "none");
    };

    var pt = T.prototype.init;
    T.prototype.init = function () {
      pt.apply(this, arguments);
      var t = !1;
      null != this.rotationShape && this.rotationShape.node.setAttribute("title", a.get("rotateTooltip"));
      var e = r.bind(this, function () {
        null != this.rotationShape && null != this.rotationShape.node && (this.rotationShape.node.style.display = 1 == this.graph.getSelectionCount() ? "" : "none"), null != this.specialHandle && (this.specialHandle.node.style.display = this.graph.isEnabled() && this.graph.getSelectionCount() < this.graph.graphHandler.maxCells ? "" : "none"), this.redrawHandles();
      });
      this.selectionHandler = r.bind(this, function (t, i) {
        e();
      }), this.graph.getSelectionModel().addListener(u.CHANGE, this.selectionHandler), this.changeHandler = r.bind(this, function (t, i) {
        this.updateLinkHint(this.graph.getLinkForCell(this.state.cell), this.graph.getLinksForState(this.state)), e();
      }), this.graph.getModel().addListener(u.CHANGE, this.changeHandler), this.editingHandler = r.bind(this, function (t, e) {
        this.redrawHandles();
      }), this.graph.addListener(u.EDITING_STOPPED, this.editingHandler);
      var i = this.graph.getLinkForCell(this.state.cell),
          n = this.graph.getLinksForState(this.state);
      this.updateLinkHint(i, n), (null != i || null != n && n.length > 0) && (t = !0), t && this.redrawHandles();
    }, T.prototype.updateLinkHint = function (t, e) {
      if (null == t && (null == e || 0 == e.length) || this.graph.getSelectionCount() > 1) null != this.linkHint && (this.linkHint.parentNode.removeChild(this.linkHint), this.linkHint = null);else if (null != t || null != e && e.length > 0) {
        if (null == this.linkHint && (this.linkHint = N(), this.linkHint.style.padding = "6px 8px 6px 8px", this.linkHint.style.opacity = "1", this.linkHint.style.filter = "", this.graph.container.appendChild(this.linkHint)), this.linkHint.innerHTML = "", null != t && (this.linkHint.appendChild(this.graph.createLinkForHint(t)), this.graph.isEnabled() && "function" == typeof this.graph.editLink)) {
          var i = document.createElement("img");
          i.setAttribute("src", Editor.editImage), i.setAttribute("title", a.get("editLink")), i.setAttribute("width", "11"), i.setAttribute("height", "11"), i.style.marginLeft = "10px", i.style.marginBottom = "-1px", i.style.cursor = "pointer", this.linkHint.appendChild(i), u.addListener(i, "click", r.bind(this, function (t) {
            this.graph.setSelectionCell(this.state.cell), this.graph.editLink(), u.consume(t);
          }));
          var n = document.createElement("img");
          n.setAttribute("src", Dialog.prototype.clearImage), n.setAttribute("title", a.get("removeIt", [a.get("link")])), n.setAttribute("width", "13"), n.setAttribute("height", "10"), n.style.marginLeft = "4px", n.style.marginBottom = "-1px", n.style.cursor = "pointer", this.linkHint.appendChild(n), u.addListener(n, "click", r.bind(this, function (t) {
            this.graph.setLinkForCell(this.state.cell, null), u.consume(t);
          }));
        }

        if (null != e) for (var s = 0; s < e.length; s++) {
          var o = document.createElement("div");
          o.style.marginTop = null != t || s > 0 ? "6px" : "0px", o.appendChild(this.graph.createLinkForHint(e[s].getAttribute("href"), r.getTextContent(e[s]))), this.linkHint.appendChild(o);
        }
      }
    }, A.prototype.updateLinkHint = T.prototype.updateLinkHint;
    var ct = A.prototype.init;

    A.prototype.init = function () {
      ct.apply(this, arguments), this.constraintHandler.isEnabled = r.bind(this, function () {
        return this.state.view.graph.connectionHandler.isEnabled();
      });
      var t = r.bind(this, function () {
        null != this.linkHint && (this.linkHint.style.display = 1 == this.graph.getSelectionCount() ? "" : "none"), null != this.labelShape && (this.labelShape.node.style.display = this.graph.isEnabled() && this.graph.getSelectionCount() < this.graph.graphHandler.maxCells ? "" : "none");
      });
      this.selectionHandler = r.bind(this, function (e, i) {
        t();
      }), this.graph.getSelectionModel().addListener(u.CHANGE, this.selectionHandler), this.changeHandler = r.bind(this, function (e, i) {
        this.updateLinkHint(this.graph.getLinkForCell(this.state.cell), this.graph.getLinksForState(this.state)), t(), this.redrawHandles();
      }), this.graph.getModel().addListener(u.CHANGE, this.changeHandler);
      var e = this.graph.getLinkForCell(this.state.cell),
          i = this.graph.getLinksForState(this.state);
      (null != e || null != i && i.length > 0) && (this.updateLinkHint(e, i), this.redrawHandles());
    };

    var mt = R.prototype.init;

    R.prototype.init = function () {
      mt.apply(this, arguments), this.constraintHandler.isEnabled = r.bind(this, function () {
        return this.graph.connectionHandler.isEnabled();
      });
    };

    var gt = T.prototype.redrawHandles;

    T.prototype.redrawHandles = function () {
      if (gt.apply(this), null != this.state && null != this.linkHint) {
        var t = new v(this.state.getCenterX(), this.state.getCenterY()),
            e = new f(this.state.x, this.state.y - 22, this.state.width + 24, this.state.height + 22),
            i = r.getBoundingBox(e, this.state.style[d.STYLE_ROTATION] || "0", t),
            n = null != i ? r.getBoundingBox(this.state, this.state.style[d.STYLE_ROTATION] || "0") : this.state,
            s = null != this.state.text ? this.state.text.boundingBox : null;
        null == i && (i = this.state);
        var o = i.y + i.height;
        null != s && (o = Math.max(o, s.y + s.height)), this.linkHint.style.left = Math.max(0, Math.round(n.x + (n.width - this.linkHint.clientWidth) / 2)) + "px", this.linkHint.style.top = Math.round(o + this.verticalOffset / 2 + 6 + this.state.view.graph.tolerance) + "px";
      }
    };

    var xt = T.prototype.reset;

    T.prototype.reset = function () {
      xt.apply(this, arguments), null != this.rotationShape && null != this.rotationShape.node && (this.rotationShape.node.style.display = 1 == this.graph.getSelectionCount() ? "" : "none");
    };

    var yt = T.prototype.destroy;

    T.prototype.destroy = function () {
      yt.apply(this, arguments), null != this.linkHint && (this.linkHint.parentNode.removeChild(this.linkHint), this.linkHint = null), null != this.selectionHandler && (this.graph.getSelectionModel().removeListener(this.selectionHandler), this.selectionHandler = null), null != this.changeHandler && (this.graph.getModel().removeListener(this.changeHandler), this.changeHandler = null), null != this.editingHandler && (this.graph.removeListener(this.editingHandler), this.editingHandler = null);
    };

    var ft = A.prototype.redrawHandles;

    A.prototype.redrawHandles = function () {
      if (null != this.marker && (ft.apply(this), null != this.state && null != this.linkHint)) {
        var t = this.state;
        null != this.state.text && null != this.state.text.bounds && (t = new f(t.x, t.y, t.width, t.height)).add(this.state.text.bounds), this.linkHint.style.left = Math.max(0, Math.round(t.x + (t.width - this.linkHint.clientWidth) / 2)) + "px", this.linkHint.style.top = Math.round(t.y + t.height + 6 + this.state.view.graph.tolerance) + "px";
      }
    };

    var vt = A.prototype.reset;

    A.prototype.reset = function () {
      vt.apply(this, arguments), null != this.linkHint && (this.linkHint.style.visibility = "");
    };

    var Ct = A.prototype.destroy;

    A.prototype.destroy = function () {
      Ct.apply(this, arguments), null != this.linkHint && (this.linkHint.parentNode.removeChild(this.linkHint), this.linkHint = null), null != this.selectionHandler && (this.graph.getSelectionModel().removeListener(this.selectionHandler), this.selectionHandler = null), null != this.changeHandler && (this.graph.getModel().removeListener(this.changeHandler), this.changeHandler = null);
    };
  }(), new nt(t, e, i, n, s);
}

function EditorBuilder(t, e, i, n, s, o) {
  var l = o.mxClient,
      r = o.mxUtils,
      a = o.mxEventSource,
      h = o.mxResources,
      u = o.mxPopupMenu,
      d = o.mxEvent,
      p = o.mxConstants,
      c = o.mxGraph,
      m = o.mxGraphView,
      g = o.mxGraphHandler,
      x = o.mxConnectionHandler,
      y = o.mxPopupMenuHandler,
      f = o.mxUndoManager,
      v = o.mxRectangle,
      C = o.mxCellRenderer,
      E = o.mxRectangleShape,
      S = o.mxEventObject,
      b = o.mxPoint,
      w = o.mxCodec,
      T = o.mxDivResizer,
      A = o.mxMouseEvent,
      L = o.mxPolyline,
      M = o.mxCellMarker,
      I = o.mxPrintPreview;

  function R(t, e, i, n, s) {
    a.call(this), this.chromeless = null != t ? t : this.chromeless, this.initStencilRegistry(), this.graph = n || this.createGraph(e, i), this.editable = null != s ? s : !t, this.undoManager = this.createUndoManager(), this.status = "", this.getOrCreateFilename = function () {
      return this.filename || h.get("drawing", [R.pageCounter]) + ".xml";
    }, this.getFilename = function () {
      return this.filename;
    }, this.setStatus = function (t) {
      this.status = t, this.fireEvent(new S("statusChanged"));
    }, this.getStatus = function () {
      return this.status;
    }, this.graphChangeListener = function (t, e) {
      var i = null != e ? e.getProperty("edit") : null;
      null != i && i.ignoreEdit || this.setModified(!0);
    }, this.graph.getModel().addListener(d.CHANGE, r.bind(this, function () {
      this.graphChangeListener.apply(this, arguments);
    })), this.graph.resetViewOnRootChange = !1, this.init();
  }

  return R.pageCounter = 0, function () {
    try {
      for (var t = window; null != t.opener && void 0 !== t.opener.Editor && !isNaN(t.opener.Editor.pageCounter) && t.opener != t;) {
        t = t.opener;
      }

      null != t && (t.Editor.pageCounter++, R.pageCounter = t.Editor.pageCounter);
    } catch (t) {}
  }(), R.useLocalStorage = "undefined" != typeof Storage && l.IS_IOS, R.helpImage = l.IS_SVG ? "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDB6Ii8+PHBhdGggZD0iTTExIDE4aDJ2LTJoLTJ2MnptMS0xNkM2LjQ4IDIgMiA2LjQ4IDIgMTJzNC40OCAxMCAxMCAxMCAxMC00LjQ4IDEwLTEwUzE3LjUyIDIgMTIgMnptMCAxOGMtNC40MSAwLTgtMy41OS04LThzMy41OS04IDgtOCA4IDMuNTkgOCA4LTMuNTkgOC04IDh6bTAtMTRjLTIuMjEgMC00IDEuNzktNCA0aDJjMC0xLjEuOS0yIDItMnMyIC45IDIgMmMwIDItMyAxLjc1LTMgNWgyYzAtMi4yNSAzLTIuNSAzLTUgMC0yLjIxLTEuNzktNC00LTR6Ii8+PC9zdmc+" : IMAGE_PATH + "/help.png", R.checkmarkImage = l.IS_SVG ? "data:image/gif;base64,R0lGODlhFQAVAMQfAGxsbHx8fIqKioaGhvb29nJycvr6+sDAwJqamltbW5OTk+np6YGBgeTk5Ly8vJiYmP39/fLy8qWlpa6ursjIyOLi4vj4+N/f3+3t7fT09LCwsHZ2dubm5r6+vmZmZv///yH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS4wLWMwNjAgNjEuMTM0Nzc3LCAyMDEwLzAyLzEyLTE3OjMyOjAwICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEY4NTZERTQ5QUFBMTFFMUE5MTVDOTM5MUZGMTE3M0QiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEY4NTZERTU5QUFBMTFFMUE5MTVDOTM5MUZGMTE3M0QiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4Rjg1NkRFMjlBQUExMUUxQTkxNUM5MzkxRkYxMTczRCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4Rjg1NkRFMzlBQUExMUUxQTkxNUM5MzkxRkYxMTczRCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgH//v38+/r5+Pf29fTz8vHw7+7t7Ovq6ejn5uXk4+Lh4N/e3dzb2tnY19bV1NPS0dDPzs3My8rJyMfGxcTDwsHAv769vLu6ubi3trW0s7KxsK+urayrqqmop6alpKOioaCfnp2cm5qZmJeWlZSTkpGQj46NjIuKiYiHhoWEg4KBgH9+fXx7enl4d3Z1dHNycXBvbm1sa2ppaGdmZWRjYmFgX15dXFtaWVhXVlVUU1JRUE9OTUxLSklIR0ZFRENCQUA/Pj08Ozo5ODc2NTQzMjEwLy4tLCsqKSgnJiUkIyIhIB8eHRwbGhkYFxYVFBMSERAPDg0MCwoJCAcGBQQDAgEAACH5BAEAAB8ALAAAAAAVABUAAAVI4CeOZGmeaKqubKtylktSgCOLRyLd3+QJEJnh4VHcMoOfYQXQLBcBD4PA6ngGlIInEHEhPOANRkaIFhq8SuHCE1Hb8Lh8LgsBADs=" : IMAGE_PATH + "/checkmark.gif", R.maximizeImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVBAMAAABbObilAAAAElBMVEUAAAAAAAAAAAAAAAAAAAAAAADgKxmiAAAABXRSTlMA758vX1Pw3BoAAABJSURBVAjXY8AJQkODGBhUQ0MhbAUGBiYY24CBgRnGFmZgMISwgwwDGRhEhVVBbAVmEQYGRwMmBjIAQi/CTIRd6G5AuA3dzYQBAHj0EFdHkvV4AAAAAElFTkSuQmCC", R.zoomOutImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVBAMAAABbObilAAAAElBMVEUAAAAAAAAsLCxxcXEhISFgYGChjTUxAAAAAXRSTlMAQObYZgAAAEdJREFUCNdjIAMwCQrB2YKCggJQJqMwA7MglK1owMBgqABVApITgLJZXFxgbIQ4Qj3CHIT5ggoIe5kgNkM1KSDYKBKqxPkDAPo5BAZBE54hAAAAAElFTkSuQmCC", R.zoomInImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVBAMAAABbObilAAAAElBMVEUAAAAAAAAsLCwhISFxcXFgYGBavKaoAAAAAXRSTlMAQObYZgAAAElJREFUCNdjIAMwCQrB2YKCggJQJqMIA4sglK3owMzgqABVwsDMwCgAZTMbG8PYCHGEeoQ5CPMFFRD2MkFshmpSQLBRJFSJ8wcAEqcEM2uhl2MAAAAASUVORK5CYII=", R.zoomFitImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVBAMAAABbObilAAAAD1BMVEUAAAAAAAAwMDBwcHBgYGC1xl09AAAAAXRSTlMAQObYZgAAAEFJREFUCNdjIAMwCQrB2YKCggJQJqMwA7MglK1owMBgqABVApITwMdGqEeYgzBfUAFhLxPEZqgmBQQbRUKFOH8AAK5OA3lA+FFOAAAAAElFTkSuQmCC", R.layersImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAAaVBMVEUAAAAgICAICAgdHR0PDw8WFhYICAgLCwsXFxcvLy8ODg4uLi4iIiIqKiokJCQYGBgKCgonJycFBQUCAgIqKiocHBwcHBwODg4eHh4cHBwnJycJCQkUFBQqKiojIyMuLi4ZGRkgICAEBATOWYXAAAAAGnRSTlMAD7+fnz8/H7/ff18/77+vr5+fn39/b28fH2xSoKsAAACQSURBVBjTrYxJEsMgDARZZMAY73sgCcn/HxnhKtnk7j6oRq0psfuoyndZ/SuODkHPLzfVT6KeyPePnJ7KrnkRjWMXTn4SMnN8mXe2SSM3ts8L/ZUxxrbAULSYJJULE0Iw9pjpenoICcgcX61mGgTgtCv9Be99pzCoDhNQWQnchD1mup5++CYGcoQexajZbfwAj/0MD8ZOaUgAAAAASUVORK5CYII=", R.previousImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QA/wD/AP+gvaeTAAAAh0lEQVQ4je3UsQnCUBCA4U8hpa1NsoEjpHQJS0dxADdwEMuMIJkgA1hYChbGQgMi+JC8q4L/AB/vDu7x74cWWEZhJU44RmA1zujR5GIbXF9YNrjD/Q0bDRY4fEBZ4P4LlgTnCbAf84pUM8/9hY08tMUtEoQ1LpEgrNBFglChFXR6Q6GfwwR6AGKJMF74Vtt3AAAAAElFTkSuQmCC", R.nextImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QA/wD/AP+gvaeTAAAAi0lEQVQ4jeXUIQ7CUAwA0MeGxWI2yylwnALJUdBcgYvM7QYLmjOQIAkIPmJZghiIvypoUtX0tfnJL38X5ZfaEgUeUcManFBHgS0SLlhHggk3bCPBhCf2keCQR8wjwYTDp6YiZxJmOU1jGw7vGALescuBxsArNlOwd/CM1VSM/ut1qCIw+uOwiMJ+OF4CQzBCXm3hyAAAAABJRU5ErkJggg==", R.editImage = l.IS_SVG ? "data:image/gif;base64,R0lGODlhCwALAIABAFdXV////yH5BAEAAAEALAAAAAALAAsAAAIZjB8AiKuc4jvLOGqzrjX6zmkWyChXaUJBAQA7" : IMAGE_PATH + "/edit.gif", R.zoomOutLargeImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAilBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////2N2iNAAAALXRSTlMA+vTcKMM96GRBHwXxi0YaX1HLrKWhiHpWEOnOr52Vb2xKSDcT19PKv5l/Ngdk8+viAAABJklEQVQ4y4WT2XaDMAxEvWD2nSSUNEnTJN3r//+9Sj7ILAY6L0ijC4ONYVZRpo6cByrz2YKSUGorGTpz71lPVHvT+avoB5wIkU/mxk8veceSuNoLg44IzziXjvpih72wKQnm8yc2UoiP/LAd8jQfe2Xf4Pq+2EyYIvv9wbzHHCgwxDdlBtWZOdqDfTCVgqpygQpsZaojVAVc9UjQxnAJDIBhiQv84tq3gMQCAVTxVoSibXJf8tMuc7e1TB/DCmejBNg/w1Y3c+AM5vv4w7xM59/oXamrHaLVqPQ+OTCnmMZxgz0SdL5zji0/ld6j88qGa5KIiBB6WeJGKfUKwSMKLuXgvl1TW0tm5R9UQL/efSDYsnzxD8CinhBsTTdugJatKpJwf8v+ADb8QmvW7AeAAAAAAElFTkSuQmCC", R.zoomInLargeImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAilBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////2N2iNAAAALXRSTlMA+vTcKMM96GRBHwXxi0YaX1HLrKWhiHpWEOnOr52Vb2xKSDcT19PKv5l/Ngdk8+viAAABKElEQVQ4y4WT6WKCMBCENwkBwn2oFKvWqr3L+79es4EkQIDOH2d3Pxk2ABiJlB8JCXjqw4LikHVGLHTm3nM3UeVN5690GBBN0GwyV/3kkrUQR+WeKnREeKpzaXWd77CmJiXGfPIEI4V4yQ9TIW/ntlcMBe731Vts9w5TWG8F5j3mQI4hvrKpdGeYA7CX9qAcl650gVJartxRuhyHVghF8idQAIbFLvCLu28BsQEC6aKtCK6Pyb3JT7PmbmtNH8Ny56CotD/2qOs5cJbuffxgXmCib+xddVU5RNOhkvvkhTlFehzVWCOh3++MYElOhfdovaImnRYVmqDdsuhNp1QrBBE6uGC2+3ZNjGdg5B94oD+9uyVgWT79BwAxEBTWdOu3bWBVgsn/N/AHUD9IC01Oe40AAAAASUVORK5CYII=", R.actualSizeLargeImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAilBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////2N2iNAAAALXRSTlMA+vTcKMM96GRBHwXxi0YaX1HLrKWhiHpWEOnOr52Vb2xKSDcT19PKv5l/Ngdk8+viAAABIUlEQVQ4y4WT2XqDIBCFBxDc9yTWNEnTJN3r+79eGT4BEbXnaubMr8dBBaM450dCQp4LWFAascGIRd48eB4cNYE7f6XjgGiCFs5c+dml6CFN6j1V6IQIlHPpdV/usKcmJcV88gQTRXjLD9Mhb+fWq8YG9/uCmTCFjeeDeY85UGKIUGUuqzN42kv7oCouq9oHamlzVR1lVfpAIu1QVRiW+sAv7r4FpAYIZZVsRXB9TP5Dfpo1d1trCgzz1iiptH/sUbdz4CzN9+mLeXHn3+hdddd4RDegsrvzwZwSs2GLPRJidAqCLTlVwaMPqpYMWjTWBB2WRW86pVkhSKyDK2bdt2tmagZG4sBD/evdLQHLEvQfAOKRoLCmG1FAB6uKmby+gz+REDn7O5+EwQAAAABJRU5ErkJggg==", R.printLargeImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAXVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9RKvvlAAAAHnRSTlMAydnl77qbMLT093H7K4Nd4Ktn082+lYt5bkklEgP44nQSAAAApUlEQVQ4y73P2Q6DIBRF0cOgbRHHzhP//5m9mBAQKjG1cT0Yc7ITAMu1LNQgUZiQ2DYoNQ0sCQb6qgHAfRx48opq3J9AZ6xuF7uOew8Ik1OsCZRS2UAC9V+D9a+QZYxNA45YFQftPtSkATOhw7dAc0vPBwKWiIOjP0JZ0yMuQJ27g36DipOUsqRAM0dR8KD1/ILHaHSE/w8DIx09E3g/BTce6rHUB5sAPKvfF+JdAAAAAElFTkSuQmCC", R.layersLargeImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAmVBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+/v7///+bnZkkAAAAMnRSTlMABPr8ByiD88KsTi/rvJb272mjeUA1CuPe1M/KjVxYHxMP6KZ0S9nYzGRGGRaznpGIbzaGUf0AAAHESURBVDjLbZLZYoIwEEVDgLCjbKIgAlqXqt3m/z+uNwu1rcyDhjl3ktnYL7OY254C0VX3yWFZfzDrOClbbgKxi0YDHjwl4jbnRkXxJS/C1YP3DbBhD1n7Ex4uaAqdVDb3yJ/4J/3nJD2to/ngQz/DfUvzMp4JJ5sSCaF5oXmemgQDfDxzbi+Kq4sU+vNcuAmx94JtyOP2DD4Epz2asWSCz4Z/4fECxyNj9zC9xNLHcdPEO+awDKeSaUu0W4twZQiO2hYVisTR3RCtK/c1X6t4xMEpiGqXqVntEBLolkZZsKY4QtwH6jzq67dEHlJysB1aNOD3XT7n1UkasQN59L4yC2RELMDSeCRtz3yV22Ub3ozIUTknYx8JWqDdQxbUes98cR2kZtUSveF/bAhcedwEWmlxIkpZUy4XOCb6VBjjxHvbwo/1lBAHHi2JCr0NI570QhyHq/DhJoE2lLgyA4RVe6KmZ47O/3b86MCP0HWa73A8/C3SUc5Qc1ajt6fgpXJ+RGpMvDSchepZDOOQRcZVIKcK90x2D7etqtI+56+u6n3sPriO6nfphitR4+O2m3EbM7lh3me1FM1o+LMI887rN+s3/wZdTFlpNVJiOAAAAABJRU5ErkJggg==", R.closeLargeImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAUVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////8IN+deAAAAGnRSTlMAuvAIg/dDM/QlOeuFhj0S5s4vKgzjxJRQNiLSey0AAADNSURBVDjLfZLbEoMgDEQjRRRs1XqX///QNmOHJSnjPkHOGR7IEmeoGtJZstnwjqbRfIsmgEdtPCqe9Ynz7ZSc07rE2QiSc+qv8TvjRXA2PDUm3dpe82iJhOEUfxJJo3aCv+jKmRmH4lcCjCjeh9GWOdL/GZZkXH3PYYDrHBnfc4D/RVZf5sjoC1was+Y6HQxwaUxFvq/a0Pv343VCTxfBSRiB+ab3M3eiQZXmMNBJ3Y8pGRZtYQ7DgHMXJEdPLTaN/qBjzJOBc3nmNcbsA16bMR0oLqf+AAAAAElFTkSuQmCC", R.editLargeImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAgVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9d3yJTAAAAKnRSTlMA+hzi3nRQWyXzkm0h2j3u54gzEgSXjlYoTBgJxL2loGpAOS3Jt7Wxm35Ga7gRAAAA6UlEQVQ4y63Q2XaCMBSF4Q0JBasoQ5DJqbXjfv8HbCK2BZNwo/8FXHx7rcMC7lQu0iX8qU/qtvAWCpoqH8dYzS0SwaV5eK/UAf8X9pd2CWKzuF5Jrftp1owXwnIGLUaL3PYndOHf4kNNXWrXK/m7CHunk7K8LE6YtBpcknwG9GKxnroY+ylBXcx4xKyx/u/EuXi509cP9V7OO1oyHnzrdFTcqLG/4ibBA5pIMr/4xvKzuQDkVy9wW8SgBFD6HDvuzMvrZcC9QlkfMzI7w64m+b4PqBMNHB05lH21PVxJo2/fBXxV4hB38PcD+5AkI4FuETsAAAAASUVORK5CYII=", R.previousLargeImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAPFBMVEUAAAD////////////////////////////////////////////////////////////////////////////YSWgTAAAAE3RSTlMA7fci493c0MW8uJ6CZks4MxQHEZL6ewAAAFZJREFUOMvdkskRgDAMA4lDwg2B7b9XOlge/KKvdsa25KFb5XlRvxXC/DNBEv8IFNjBgGdDgXtFgTyhwDXiQAUHCvwa4Uv6mR6UR+1led2mVonvl+tML45qCQNQLIx7AAAAAElFTkSuQmCC", R.nextLargeImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAPFBMVEUAAAD////////////////////////////////////////////////////////////////////////////YSWgTAAAAE3RSTlMA7fci493c0MW8uJ6CZks4MxQHEZL6ewAAAFRJREFUOMvd0skRgCAQBVEFwQ0V7fxzNQP6wI05v6pZ/kyj1b7FNgik2gQzzLcAwiUAigHOTwDHK4A1CmB5BJANJG1hQ9qafYcqFlZP3IFc9eVGrR+iIgkDQRUXIAAAAABJRU5ErkJggg==", R.ctrlKey = l.IS_MAC ? "Cmd" : "Ctrl", R.popupsAllowed = !0, r.extend(R, a), R.prototype.originalNoForeignObject = l.NO_FO, R.prototype.transparentImage = l.IS_SVG ? "data:image/gif;base64,R0lGODlhMAAwAIAAAP///wAAACH5BAEAAAAALAAAAAAwADAAAAIxhI+py+0Po5y02ouz3rz7D4biSJbmiabqyrbuC8fyTNf2jef6zvf+DwwKh8Si8egpAAA7" : IMAGE_PATH + "/transparent.gif", R.prototype.extendCanvas = !0, R.prototype.chromeless = !1, R.prototype.cancelFirst = !0, R.prototype.enabled = !0, R.prototype.filename = null, R.prototype.modified = !1, R.prototype.autosave = !0, R.prototype.initialTopSpacing = 0, R.prototype.appName = document.title, R.prototype.editBlankUrl = window.location.protocol + "//" + window.location.host + "/", R.prototype.init = function () {}, R.prototype.isChromelessView = function () {
    return this.chromeless;
  }, R.prototype.setAutosave = function (t) {
    this.autosave = t, this.fireEvent(new S("autosaveChanged"));
  }, R.prototype.getEditBlankUrl = function (t) {
    return this.editBlankUrl + t;
  }, R.prototype.editAsNew = function (t, e) {
    var i = null != e ? "?title=" + encodeURIComponent(e) : "";
    null != urlParams.ui && (i += (i.length > 0 ? "&" : "?") + "ui=" + urlParams.ui), null == this.editorWindow || this.editorWindow.closed ? void 0 !== window.postMessage && (null == document.documentMode || document.documentMode >= 10) ? (null == this.editorWindow && d.addListener(window, "message", r.bind(this, function (e) {
      "ready" == e.data && e.source == this.editorWindow && this.editorWindow.postMessage(t, "*");
    })), this.editorWindow = this.graph.openLink(this.getEditBlankUrl(i + (i.length > 0 ? "&" : "?") + "client=1"), null, !0)) : this.editorWindow = this.graph.openLink(this.getEditBlankUrl(i) + "#R" + encodeURIComponent(t)) : this.editorWindow.focus();
  }, R.prototype.createGraph = function (t, e) {
    var i = new GraphBuilder(null, e, null, null, t, this.mx);
    return i.transparentBackground = !1, this.chromeless || (i.isBlankLink = function (t) {
      return !this.isExternalProtocol(t);
    }), i;
  }, R.prototype.resetGraph = function () {
    this.graph.gridEnabled = !this.isChromelessView() || "1" == urlParams.grid, this.graph.graphHandler.guidesEnabled = !0, this.graph.setTooltips(!0), this.graph.setConnectable(!0), this.graph.foldingEnabled = !0, this.graph.scrollbars = this.graph.defaultScrollbars, this.graph.pageVisible = this.graph.defaultPageVisible, this.graph.pageBreaksVisible = this.graph.pageVisible, this.graph.preferPageSize = this.graph.pageBreaksVisible, this.graph.background = null, this.graph.pageScale = c.prototype.pageScale, this.graph.pageFormat = c.prototype.pageFormat, this.graph.currentScale = 1, this.graph.currentTranslate.x = 0, this.graph.currentTranslate.y = 0, this.updateGraphComponents(), this.graph.view.setScale(1);
  }, R.prototype.readGraphState = function (t) {
    this.graph.gridEnabled = "0" != t.getAttribute("grid") && (!this.isChromelessView() || "1" == urlParams.grid), this.graph.gridSize = parseFloat(t.getAttribute("gridSize")) || c.prototype.gridSize, this.graph.graphHandler.guidesEnabled = "0" != t.getAttribute("guides"), this.graph.setTooltips("0" != t.getAttribute("tooltips")), this.graph.setConnectable("0" != t.getAttribute("connect")), this.graph.connectionArrowsEnabled = "0" != t.getAttribute("arrows"), this.graph.foldingEnabled = "0" != t.getAttribute("fold"), this.isChromelessView() && this.graph.foldingEnabled && (this.graph.foldingEnabled = "1" == urlParams.nav, this.graph.cellRenderer.forceControlClickHandler = this.graph.foldingEnabled);
    var e = parseFloat(t.getAttribute("pageScale"));
    if (!isNaN(e) && e > 0 ? this.graph.pageScale = e : this.graph.pageScale = c.prototype.pageScale, this.graph.isLightboxView()) this.graph.pageVisible = !1;else {
      var i = t.getAttribute("page");
      this.graph.pageVisible = null != i ? "0" != i : this.graph.defaultPageVisible;
    }
    this.graph.pageBreaksVisible = this.graph.pageVisible, this.graph.preferPageSize = this.graph.pageBreaksVisible;
    var n = parseFloat(t.getAttribute("pageWidth")),
        s = parseFloat(t.getAttribute("pageHeight"));
    isNaN(n) || isNaN(s) || (this.graph.pageFormat = new v(0, 0, n, s));
    var o = t.getAttribute("background");
    null != o && o.length > 0 ? this.graph.background = o : this.graph.background = null;
  }, R.prototype.setGraphXml = function (t) {
    if (null != t) {
      var e = new w(t.ownerDocument);

      if ("mxGraphModel" == t.nodeName) {
        this.graph.model.beginUpdate();

        try {
          this.graph.model.clear(), this.graph.view.scale = 1, this.updateGraphComponents(), e.decode(t, this.graph.getModel());
        } finally {
          this.graph.model.endUpdate();
        }

        this.fireEvent(new S("resetGraphView"));
      } else {
        if ("root" != t.nodeName) throw {
          message: h.get("cannotOpenFile"),
          node: t,
          toString: function toString() {
            return this.message;
          }
        };
        this.resetGraph();
        var i = e.document.createElement("mxGraphModel");
        i.appendChild(t), e.decode(i, this.graph.getModel()), this.updateGraphComponents(), this.fireEvent(new S("resetGraphView"));
      }
    } else this.resetGraph(), this.graph.model.clear(), this.fireEvent(new S("resetGraphView"));
  }, R.prototype.getGraphXml = function (t) {
    var e = null;

    if (t = null == t || t) {
      var i = new w(r.createXmlDocument());
      e = i.encode(this.graph.getModel()), i.document.appendChild(e);
    } else e = this.graph.encodeCells(r.sortCells(this.graph.model.getTopmostCells(this.graph.getSelectionCells())));

    return e;
  }, R.prototype.updateGraphComponents = function () {
    var t = this.graph;
    null != t.container && (t.view.validateBackground(), t.container.style.overflow = t.scrollbars ? "auto" : "hidden", this.fireEvent(new S("updateGraphComponents")));
  }, R.prototype.setModified = function (t) {
    this.modified = t;
  }, R.prototype.setFilename = function (t) {
    this.filename = t;
  }, R.prototype.createUndoManager = function () {
    var t = this.graph,
        e = new f();

    this.undoListener = function (t, i) {
      e.undoableEditHappened(i.getProperty("edit"));
    };

    var i = r.bind(this, function (t, e) {
      this.undoListener.apply(this, arguments);
    });
    t.getModel().addListener(d.UNDO, i), t.getView().addListener(d.UNDO, i);

    var n = function n(e, i) {
      var n = i.getProperty("edit").changes,
          s = n.find(function (t) {
        return "PropertyChange" === t.constructor.name;
      }),
          o = [];
      s ? o.push(s.viewModel.view) : o = t.getSelectionCellsForChanges(n);
      t.getModel();

      for (var l = [], r = void 0, a = 0; a < o.length; a++) {
        null != t.view.getState(o[a]) && (l.push(o[a]), void 0 === r ? r = o[a] : r != o[a].parent && (r = r.parent == o[a].parent || o[a] == r.parent ? r.parent : null));
      }

      t.setSelectionCells(r ? [r] : l);
    };

    return e.addListener(d.UNDO, n), e.addListener(d.REDO, n), e;
  }, R.prototype.initStencilRegistry = function () {}, R.prototype.destroy = function () {
    null != this.graph && (this.graph.destroy(), this.graph = null);
  }, function () {
    m.prototype.validateBackgroundPage = function () {
      var t = this.graph;

      if (null != t.container && !t.transparentBackground) {
        if (t.pageVisible) {
          var e = this.getBackgroundPageBounds();

          if (null == this.backgroundPageShape) {
            for (var i = t.container.firstChild; null != i && i.nodeType != p.NODETYPE_ELEMENT;) {
              i = i.nextSibling;
            }

            null != i && (this.backgroundPageShape = this.createBackgroundPageShape(e), this.backgroundPageShape.scale = 1, this.backgroundPageShape.isShadow = !l.IS_QUIRKS, this.backgroundPageShape.dialect = p.DIALECT_STRICTHTML, this.backgroundPageShape.init(t.container), i.style.position = "absolute", t.container.insertBefore(this.backgroundPageShape.node, i), this.backgroundPageShape.redraw(), this.backgroundPageShape.node.className = "geBackgroundPage", d.addListener(this.backgroundPageShape.node, "dblclick", r.bind(this, function (e) {
              t.dblClick(e);
            })), d.addGestureListeners(this.backgroundPageShape.node, r.bind(this, function (e) {
              t.fireMouseEvent(d.MOUSE_DOWN, new A(e));
            }), r.bind(this, function (e) {
              null != t.tooltipHandler && t.tooltipHandler.isHideOnHover() && t.tooltipHandler.hide(), t.isMouseDown && !d.isConsumed(e) && t.fireMouseEvent(d.MOUSE_MOVE, new A(e));
            }), r.bind(this, function (e) {
              t.fireMouseEvent(d.MOUSE_UP, new A(e));
            })));
          } else this.backgroundPageShape.scale = 1, this.backgroundPageShape.bounds = e, this.backgroundPageShape.redraw();
        } else null != this.backgroundPageShape && (this.backgroundPageShape.destroy(), this.backgroundPageShape = null);

        this.validateBackgroundStyles();
      }
    }, m.prototype.validateBackgroundStyles = function () {
      var t = this.graph,
          e = null == t.background || t.background == p.NONE ? t.defaultPageBackgroundColor : t.background,
          i = null != e && this.gridColor != e.toLowerCase() ? this.gridColor : "#ffffff",
          n = "none",
          s = "";

      if (t.isGridEnabled()) {
        var o = 10;
        l.IS_SVG ? (n = unescape(encodeURIComponent(this.createSvgGrid(i))), n = "url(data:image/svg+xml;base64," + (n = window.btoa ? btoa(n) : Base64.encode(n, !0)) + ")", o = t.gridSize * this.scale * this.gridSteps) : n = "url(" + this.gridImage + ")";
        var a = 0,
            h = 0;

        if (null != t.view.backgroundPageShape) {
          var u = this.getBackgroundPageBounds();
          a = 1 + u.x, h = 1 + u.y;
        }

        s = -Math.round(o - r.mod(this.translate.x * this.scale - a, o)) + "px " + -Math.round(o - r.mod(this.translate.y * this.scale - h, o)) + "px";
      }

      var d = t.view.canvas;
      null != d.ownerSVGElement && (d = d.ownerSVGElement), null != t.view.backgroundPageShape ? (t.view.backgroundPageShape.node.style.backgroundPosition = s, t.view.backgroundPageShape.node.style.backgroundImage = n, t.view.backgroundPageShape.node.style.backgroundColor = e, t.container.className = "geDiagramContainer geDiagramBackdrop", d.style.backgroundImage = "none", d.style.backgroundColor = "") : (t.container.className = "geDiagramContainer", d.style.backgroundPosition = s, d.style.backgroundColor = e, d.style.backgroundImage = n);
    }, m.prototype.createSvgGrid = function (t) {
      for (var e = this.graph.gridSize * this.scale; e < this.minGridSize;) {
        e *= 2;
      }

      for (var i = this.gridSteps * e, n = [], s = 1; s < this.gridSteps; s++) {
        var o = s * e;
        n.push("M 0 " + o + " L " + i + " " + o + " M " + o + " 0 L " + o + " " + i);
      }

      return '<svg width="' + i + '" height="' + i + '" xmlns="' + p.NS_SVG + '"><defs><pattern id="grid" width="' + i + '" height="' + i + '" patternUnits="userSpaceOnUse"><path d="' + n.join(" ") + '" fill="none" stroke="' + t + '" opacity="0.2" stroke-width="1"/><path d="M ' + i + " 0 L 0 0 0 " + i + '" fill="none" stroke="' + t + '" stroke-width="1"/></pattern></defs><rect width="100%" height="100%" fill="url(#grid)"/></svg>';
    };
    var t = c.prototype.panGraph;
    c.prototype.panGraph = function (e, i) {
      if (t.apply(this, arguments), null != this.shiftPreview1) {
        var n = this.view.canvas;
        null != n.ownerSVGElement && (n = n.ownerSVGElement);
        var s = this.gridSize * this.view.scale * this.view.gridSteps,
            o = -Math.round(s - r.mod(this.view.translate.x * this.view.scale + e, s)) + "px " + -Math.round(s - r.mod(this.view.translate.y * this.view.scale + i, s)) + "px";
        n.style.backgroundPosition = o;
      }
    }, c.prototype.updatePageBreaks = function (t, e, i) {
      var n = this.view.scale,
          s = this.view.translate,
          o = this.pageFormat,
          l = n * this.pageScale,
          a = this.view.getBackgroundPageBounds();
      e = a.width, i = a.height;
      var h = new v(n * s.x, n * s.y, o.width * l, o.height * l),
          u = (t = t && Math.min(h.width, h.height) > this.minPageBreakDist) ? Math.ceil(i / h.height) - 1 : 0,
          d = t ? Math.ceil(e / h.width) - 1 : 0,
          p = a.x + e,
          c = a.y + i;
      null == this.horizontalPageBreaks && u > 0 && (this.horizontalPageBreaks = []), null == this.verticalPageBreaks && d > 0 && (this.verticalPageBreaks = []);
      var m = r.bind(this, function (t) {
        if (null != t) {
          for (var e = t == this.horizontalPageBreaks ? u : d, i = 0; i <= e; i++) {
            var n = t == this.horizontalPageBreaks ? [new b(Math.round(a.x), Math.round(a.y + (i + 1) * h.height)), new b(Math.round(p), Math.round(a.y + (i + 1) * h.height))] : [new b(Math.round(a.x + (i + 1) * h.width), Math.round(a.y)), new b(Math.round(a.x + (i + 1) * h.width), Math.round(c))];
            if (null != t[i]) t[i].points = n, t[i].redraw();else {
              var s = new L(n, this.pageBreakColor);
              s.dialect = this.dialect, s.isDashed = this.pageBreakDashed, s.pointerEvents = !1, s.init(this.view.backgroundPane), s.redraw(), t[i] = s;
            }
          }

          for (i = e; i < t.length; i++) {
            t[i].destroy();
          }

          t.splice(e, t.length - e);
        }
      });
      m(this.horizontalPageBreaks), m(this.verticalPageBreaks);
    };
    var e = g.prototype.shouldRemoveCellsFromParent;

    g.prototype.shouldRemoveCellsFromParent = function (t, i, n) {
      for (var s = 0; s < i.length; s++) {
        if (this.graph.getModel().isVertex(i[s])) {
          var o = this.graph.getCellGeometry(i[s]);
          if (null != o && o.relative) return !1;
        }
      }

      return e.apply(this, arguments);
    };

    var i = x.prototype.createMarker;
    x.prototype.createMarker = function () {
      var t = i.apply(this, arguments);
      return t.intersects = r.bind(this, function (e, i) {
        return !!this.isConnecting() || M.prototype.intersects.apply(t, arguments);
      }), t;
    }, m.prototype.createBackgroundPageShape = function (t) {
      return new E(t, "#ffffff", this.graph.defaultPageBorderColor);
    }, m.prototype.getBackgroundPageBounds = function () {
      var t = this.getGraphBounds(),
          e = t.width > 0 ? t.x / this.scale - this.translate.x : 0,
          i = t.height > 0 ? t.y / this.scale - this.translate.y : 0,
          n = t.width / this.scale,
          s = t.height / this.scale,
          o = this.graph.pageFormat,
          l = this.graph.pageScale,
          r = o.width * l,
          a = o.height * l,
          h = Math.floor(Math.min(0, e) / r),
          u = Math.floor(Math.min(0, i) / a),
          d = Math.ceil(Math.max(1, e + n) / r) - h,
          p = Math.ceil(Math.max(1, i + s) / a) - u;
      return new v(this.scale * (this.translate.x + h * r), this.scale * (this.translate.y + u * a), this.scale * d * r, this.scale * p * a);
    };
    var n = c.prototype.panGraph;

    c.prototype.panGraph = function (t, e) {
      n.apply(this, arguments), this.dialect == p.DIALECT_SVG || null == this.view.backgroundPageShape || this.useScrollbarsForPanning && r.hasScrollbars(this.container) || (this.view.backgroundPageShape.node.style.marginLeft = t + "px", this.view.backgroundPageShape.node.style.marginTop = e + "px");
    };

    var s = u.prototype.addItem;

    u.prototype.addItem = function (t, e, i, n, o, l) {
      var r = s.apply(this, arguments);
      return null == l || l || d.addListener(r, "mousedown", function (t) {
        d.consume(t);
      }), r;
    };

    var o = g.prototype.getInitialCellForEvent;

    g.prototype.getInitialCellForEvent = function (t) {
      var e = this.graph.getModel(),
          i = e.getParent(this.graph.getSelectionCell()),
          n = o.apply(this, arguments),
          s = e.getParent(n);
      if (null == i || i != n && i != s) for (; !this.graph.isCellSelected(n) && !this.graph.isCellSelected(s) && e.isVertex(s) && !this.graph.isContainer(s);) {
        n = s, s = this.graph.getModel().getParent(n);
      }
      return n;
    };

    var a = g.prototype.isDelayedSelection;
    g.prototype.isDelayedSelection = function (t, e) {
      var i = a.apply(this, arguments);
      if (!i) for (var n = this.graph.getModel(), s = n.getParent(t); null != s;) {
        if (this.graph.isCellSelected(s) && n.isVertex(s)) {
          i = !0;
          break;
        }

        s = n.getParent(s);
      }
      return i;
    }, g.prototype.selectDelayed = function (t) {
      if (!this.graph.popupMenuHandler.isPopupTrigger(t)) {
        var e = t.getCell();
        null == e && (e = this.cell);
        var i = this.graph.view.getState(e);
        if (null != i && t.isSource(i.control)) this.graph.selectCellForEvent(e, t.getEvent());else {
          for (var n = this.graph.getModel(), s = n.getParent(e); !this.graph.isCellSelected(s) && n.isVertex(s);) {
            e = s, s = n.getParent(e);
          }

          this.graph.selectCellForEvent(e, t.getEvent());
        }
      }
    }, y.prototype.getCellForPopupEvent = function (t) {
      for (var e = t.getCell(), i = this.graph.getModel(), n = i.getParent(e); i.isVertex(n) && !this.graph.isContainer(n);) {
        this.graph.isCellSelected(n) && (e = n), n = i.getParent(n);
      }

      return e;
    };
  }(), new R(t, e, i, n, s);
}

function Dialog$1(t, e, i, n, s, o, l, r, a) {
  var _t$mx4 = t.mx,
      h = _t$mx4.mxClient,
      u = _t$mx4.mxUtils,
      d = _t$mx4.mxEventSource,
      p = _t$mx4.mxResources,
      c = _t$mx4.mxPopupMenu,
      m = _t$mx4.mxEvent,
      g = _t$mx4.mxConstants,
      x = _t$mx4.mxGraph,
      y = _t$mx4.mxGraphView,
      f = _t$mx4.mxGraphHandler,
      v = _t$mx4.mxConnectionHandler,
      C = _t$mx4.mxPopupMenuHandler,
      E = _t$mx4.mxUndoManager,
      S = _t$mx4.mxRectangle,
      b = _t$mx4.mxRectangleShape,
      w = _t$mx4.mxEventObject,
      T = _t$mx4.mxPoint,
      A = _t$mx4.mxCodec,
      L = _t$mx4.mxDivResizer,
      M = _t$mx4.mxMouseEvent,
      I = _t$mx4.mxPolyline,
      R = _t$mx4.mxCellMarker,
      P = _t$mx4.mxPrintPreview;

  function O(t, e, i, n, s, o, l, r, a) {
    var d = 0;
    h.IS_VML && (null == document.documentMode || document.documentMode < 8) && (d = 80);
    var c = i += d,
        g = n += d,
        x = document.documentElement.clientHeight > 0 ? document.documentElement.clientHeight : Math.max(document.body.clientHeight || 0, document.documentElement.clientHeight),
        y = Math.max(1, Math.round((document.body.clientWidth - i - 64) / 2)),
        f = Math.max(1, Math.round((x - n - t.footerHeight) / 3));
    h.IS_QUIRKS || (e.style.maxHeight = "100%"), i = Math.min(i, document.body.scrollWidth - 64), n = Math.min(n, x - 64), t.dialogs.length > 0 && (this.zIndex += 2 * t.dialogs.length), null == this.bg && (this.bg = t.createDiv("background"), this.bg.style.position = "absolute", this.bg.style.background = O.backdropColor, this.bg.style.height = x + "px", this.bg.style.right = "0px", this.bg.style.zIndex = this.zIndex - 2, u.setOpacity(this.bg, this.bgOpacity), h.IS_QUIRKS && new L(this.bg));
    var v = u.getDocumentScrollOrigin(document);
    this.bg.style.left = v.x + "px", this.bg.style.top = v.y + "px", y += v.x, f += v.y, s && document.body.appendChild(this.bg);
    var C = t.createDiv(a ? "geTransDialog" : "geDialog"),
        E = this.getPosition(y, f, i, n);

    if (y = E.x, f = E.y, C.style.width = i + "px", C.style.height = n + "px", C.style.left = y + "px", C.style.top = f + "px", C.style.zIndex = this.zIndex, C.appendChild(e), document.body.appendChild(C), !r && e.clientHeight > C.clientHeight - 64 && (e.style.overflowY = "auto"), o) {
      var S = document.createElement("img");
      S.setAttribute("src", O.prototype.closeImage), S.setAttribute("title", p.get("close")), S.className = "geDialogClose", S.style.top = f + 14 + "px", S.style.left = y + i + 38 - d + "px", S.style.zIndex = this.zIndex, m.addListener(S, "click", u.bind(this, function () {
        t.hideDialog(!0);
      })), document.body.appendChild(S), this.dialogImg = S, m.addGestureListeners(this.bg, null, null, u.bind(this, function (e) {
        t.hideDialog(!0);
      }));
    }

    this.resizeListener = u.bind(this, function () {
      x = Math.max(document.body.clientHeight, document.documentElement.clientHeight), this.bg.style.height = x + "px", y = Math.max(1, Math.round((document.body.clientWidth - i - 64) / 2)), f = Math.max(1, Math.round((x - n - t.footerHeight) / 3)), i = Math.min(c, document.body.scrollWidth - 64), n = Math.min(g, x - 64);
      var s = this.getPosition(y, f, i, n);
      y = s.x, f = s.y, C.style.left = y + "px", C.style.top = f + "px", C.style.width = i + "px", C.style.height = n + "px", !r && e.clientHeight > C.clientHeight - 64 && (e.style.overflowY = "auto"), null != this.dialogImg && (this.dialogImg.style.top = f + 14 + "px", this.dialogImg.style.left = y + i + 38 - d + "px");
    }), m.addListener(window, "resize", this.resizeListener), this.onDialogClose = l, this.container = C, t.editor.fireEvent(new w("showDialog"));
  }

  return O.backdropColor = "white", O.prototype.zIndex = c.prototype.zIndex - 1, O.prototype.noColorImage = h.IS_SVG ? "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkEzRDlBMUUwODYxMTExRTFCMzA4RDdDMjJBMEMxRDM3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkEzRDlBMUUxODYxMTExRTFCMzA4RDdDMjJBMEMxRDM3Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QTNEOUExREU4NjExMTFFMUIzMDhEN0MyMkEwQzFEMzciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QTNEOUExREY4NjExMTFFMUIzMDhEN0MyMkEwQzFEMzciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5xh3fmAAAABlBMVEX////MzMw46qqDAAAAGElEQVR42mJggAJGKGAYIIGBth8KAAIMAEUQAIElnLuQAAAAAElFTkSuQmCC" : IMAGE_PATH + "/nocolor.png", O.prototype.closeImage = h.IS_SVG ? "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEV7mr3///+wksspAAAAAnRSTlP/AOW3MEoAAAAdSURBVAgdY9jXwCDDwNDRwHCwgeExmASygSL7GgB12QiqNHZZIwAAAABJRU5ErkJggg==" : IMAGE_PATH + "/close.png", O.prototype.clearImage = h.IS_SVG ? "data:image/gif;base64,R0lGODlhDQAKAIABAMDAwP///yH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS4wLWMwNjAgNjEuMTM0Nzc3LCAyMDEwLzAyLzEyLTE3OjMyOjAwICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OUIzOEM1NzI4NjEyMTFFMUEzMkNDMUE3NjZERDE2QjIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OUIzOEM1NzM4NjEyMTFFMUEzMkNDMUE3NjZERDE2QjIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5QjM4QzU3MDg2MTIxMUUxQTMyQ0MxQTc2NkREMTZCMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5QjM4QzU3MTg2MTIxMUUxQTMyQ0MxQTc2NkREMTZCMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgH//v38+/r5+Pf29fTz8vHw7+7t7Ovq6ejn5uXk4+Lh4N/e3dzb2tnY19bV1NPS0dDPzs3My8rJyMfGxcTDwsHAv769vLu6ubi3trW0s7KxsK+urayrqqmop6alpKOioaCfnp2cm5qZmJeWlZSTkpGQj46NjIuKiYiHhoWEg4KBgH9+fXx7enl4d3Z1dHNycXBvbm1sa2ppaGdmZWRjYmFgX15dXFtaWVhXVlVUU1JRUE9OTUxLSklIR0ZFRENCQUA/Pj08Ozo5ODc2NTQzMjEwLy4tLCsqKSgnJiUkIyIhIB8eHRwbGhkYFxYVFBMSERAPDg0MCwoJCAcGBQQDAgEAACH5BAEAAAEALAAAAAANAAoAAAIXTGCJebD9jEOTqRlttXdrB32PJ2ncyRQAOw==" : IMAGE_PATH + "/clear.gif", O.prototype.lockedImage = h.IS_SVG ? "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzdDMDZCODExNzIxMTFFNUI0RTk5NTg4OTcyMUUyODEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MzdDMDZCODIxNzIxMTFFNUI0RTk5NTg4OTcyMUUyODEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozN0MwNkI3RjE3MjExMUU1QjRFOTk1ODg5NzIxRTI4MSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDozN0MwNkI4MDE3MjExMUU1QjRFOTk1ODg5NzIxRTI4MSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PvqMCFYAAAAVUExURZmZmb+/v7KysqysrMzMzLGxsf///4g8N1cAAAAHdFJOU////////wAaSwNGAAAAPElEQVR42lTMQQ4AIQgEwUa0//9kTQirOweYOgDqAMbZUr10AGlAwx4/BJ2QJ4U0L5brYjovvpv32xZgAHZaATFtMbu4AAAAAElFTkSuQmCC" : IMAGE_PATH + "/locked.png", O.prototype.unlockedImage = h.IS_SVG ? "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzdDMDZCN0QxNzIxMTFFNUI0RTk5NTg4OTcyMUUyODEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MzdDMDZCN0UxNzIxMTFFNUI0RTk5NTg4OTcyMUUyODEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozN0MwNkI3QjE3MjExMUU1QjRFOTk1ODg5NzIxRTI4MSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDozN0MwNkI3QzE3MjExMUU1QjRFOTk1ODg5NzIxRTI4MSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PkKMpVwAAAAYUExURZmZmbKysr+/v6ysrOXl5czMzLGxsf///zHN5lwAAAAIdFJOU/////////8A3oO9WQAAADxJREFUeNpUzFESACAEBNBVsfe/cZJU+8Mzs8CIABCidtfGOndnYsT40HDSiCcbPdoJo10o9aI677cpwACRoAF3dFNlswAAAABJRU5ErkJggg==" : IMAGE_PATH + "/unlocked.png", O.prototype.bgOpacity = 80, O.prototype.getPosition = function (t, e) {
    return new T(t, e);
  }, O.prototype.close = function (t) {
    null != this.onDialogClose && (this.onDialogClose(t), this.onDialogClose = null), null != this.dialogImg && (this.dialogImg.parentNode.removeChild(this.dialogImg), this.dialogImg = null), null != this.bg && null != this.bg.parentNode && this.bg.parentNode.removeChild(this.bg), m.removeListener(window, "resize", this.resizeListener), this.container.parentNode.removeChild(this.container);
  }, new O(t, e, i, n, s, o, l, r, a);
}

function HoverIconsBuilder(t, e) {
  var i = e.mxClient,
      n = e.mxUtils,
      s = e.mxResources,
      o = e.mxEvent,
      l = e.mxImage,
      r = e.mxConstraintHandler,
      a = e.mxVertexHandler,
      h = e.mxEdgeHandler,
      u = e.mxOutline,
      d = e.mxRectangle,
      p = e.mxConstants;

  var c = function c(t, e, i) {
    var n = unescape(encodeURIComponent('<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="' + t + 'px" height="' + e + 'px" version="1.1">' + i + "</svg>"));
    return new l("data:image/svg+xml;base64," + (window.btoa ? btoa(n) : Base64.encode(n, !0)), t, e);
  },
      m = a.prototype.createSizerShape;

  function g(t) {
    this.graph = t, this.init();
  }

  return a.prototype.createSizerShape = function (t, e, i) {
    return this.handleImage = e == o.ROTATION_HANDLE ? g.prototype.rotationHandle : e == o.LABEL_HANDLE ? this.secondaryHandleImage : this.handleImage, m.apply(this, arguments);
  }, g.prototype.arrowSpacing = 2, g.prototype.updateDelay = 500, g.prototype.activationDelay = 140, g.prototype.currentState = null, g.prototype.activeArrow = null, g.prototype.inactiveOpacity = 15, g.prototype.cssCursor = "copy", g.prototype.checkCollisions = !0, g.prototype.arrowFill = "#29b6f2", g.prototype.triangleUp = i.IS_SVG ? c(18, 28, '<path d="m 6 26 L 12 26 L 12 12 L 18 12 L 9 1 L 1 12 L 6 12 z" stroke="#fff" fill="' + g.prototype.arrowFill + '"/>') : new l(IMAGE_PATH + "/triangle-up.png", 26, 14), g.prototype.triangleRight = i.IS_SVG ? c(26, 18, '<path d="m 1 6 L 14 6 L 14 1 L 26 9 L 14 18 L 14 12 L 1 12 z" stroke="#fff" fill="' + g.prototype.arrowFill + '"/>') : new l(IMAGE_PATH + "/triangle-right.png", 14, 26), g.prototype.triangleDown = i.IS_SVG ? c(18, 26, '<path d="m 6 1 L 6 14 L 1 14 L 9 26 L 18 14 L 12 14 L 12 1 z" stroke="#fff" fill="' + g.prototype.arrowFill + '"/>') : new l(IMAGE_PATH + "/triangle-down.png", 26, 14), g.prototype.triangleLeft = i.IS_SVG ? c(28, 18, '<path d="m 1 9 L 12 1 L 12 6 L 26 6 L 26 12 L 12 12 L 12 18 z" stroke="#fff" fill="' + g.prototype.arrowFill + '"/>') : new l(IMAGE_PATH + "/triangle-left.png", 14, 26), g.prototype.roundDrop = i.IS_SVG ? c(26, 26, '<circle cx="13" cy="13" r="12" stroke="#fff" fill="' + g.prototype.arrowFill + '"/>') : new l(IMAGE_PATH + "/round-drop.png", 26, 26), g.prototype.refreshTarget = new l(i.IS_SVG ? "data:image/png;base64,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" : IMAGE_PATH + "/refresh.png", 38, 38), g.prototype.mainHandle = i.IS_SVG ? c(18, 18, '<circle cx="9" cy="9" r="5" stroke="#fff" fill="' + g.prototype.arrowFill + '" stroke-width="1"/>') : new l(IMAGE_PATH + "/handle-main.png", 17, 17), g.prototype.secondaryHandle = i.IS_SVG ? c(16, 16, '<path d="m 8 3 L 13 8 L 8 13 L 3 8 z" stroke="#fff" fill="#fca000"/>') : new l(IMAGE_PATH + "/handle-secondary.png", 17, 17), g.prototype.fixedHandle = i.IS_SVG ? c(18, 18, '<circle cx="9" cy="9" r="5" stroke="#fff" fill="' + g.prototype.arrowFill + '" stroke-width="1"/><path d="m 7 7 L 11 11 M 7 11 L 11 7" stroke="#fff"/>') : new l(IMAGE_PATH + "/handle-fixed.png", 17, 17), g.prototype.terminalHandle = i.IS_SVG ? c(18, 18, '<circle cx="9" cy="9" r="5" stroke="#fff" fill="' + g.prototype.arrowFill + '" stroke-width="1"/><circle cx="9" cy="9" r="2" stroke="#fff" fill="transparent"/>') : new l(IMAGE_PATH + "/handle-terminal.png", 17, 17), g.prototype.rotationHandle = new l(i.IS_SVG ? "data:image/png;base64,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" : IMAGE_PATH + "/handle-rotate.png", 19, 21), i.IS_SVG && (r.prototype.pointImage = c(5, 5, '<path d="m 0 0 L 5 5 M 0 5 L 5 0" stroke="' + g.prototype.arrowFill + '"/>')), a.prototype.handleImage = g.prototype.mainHandle, a.prototype.secondaryHandleImage = g.prototype.secondaryHandle, h.prototype.handleImage = g.prototype.mainHandle, h.prototype.terminalHandleImage = g.prototype.terminalHandle, h.prototype.fixedHandleImage = g.prototype.fixedHandle, h.prototype.labelHandleImage = g.prototype.secondaryHandle, u.prototype.sizerImage = g.prototype.mainHandle, g.prototype.tolerance = i.IS_TOUCH ? 6 : 0, g.prototype.init = function () {
    this.arrowUp = this.createArrow(this.triangleUp, s.get("plusTooltip")), this.arrowRight = this.createArrow(this.triangleRight, s.get("plusTooltip")), this.arrowDown = this.createArrow(this.triangleDown, s.get("plusTooltip")), this.arrowLeft = this.createArrow(this.triangleLeft, s.get("plusTooltip")), this.elts = [this.arrowUp, this.arrowRight, this.arrowDown, this.arrowLeft], this.repaintHandler = n.bind(this, function () {
      this.repaint();
    }), this.graph.selectionModel.addListener(o.CHANGE, this.repaintHandler), this.graph.model.addListener(o.CHANGE, this.repaintHandler), this.graph.view.addListener(o.SCALE_AND_TRANSLATE, this.repaintHandler), this.graph.view.addListener(o.TRANSLATE, this.repaintHandler), this.graph.view.addListener(o.SCALE, this.repaintHandler), this.graph.view.addListener(o.DOWN, this.repaintHandler), this.graph.view.addListener(o.UP, this.repaintHandler), this.graph.addListener(o.ROOT, this.repaintHandler), this.graph.addListener(o.ESCAPE, n.bind(this, function () {
      this.mouseDownPoint = null;
    })), o.addListener(this.graph.container, "mouseleave", n.bind(this, function (t) {
      null != t.relatedTarget && o.getSource(t) == this.graph.container && this.setDisplay("none");
    })), this.graph.addListener(o.START_EDITING, n.bind(this, function (t) {
      this.reset();
    }));
    var t = this.graph.click;
    this.graph.click = n.bind(this, function (e) {
      t.apply(this.graph, arguments), null == this.currentState || this.graph.isCellSelected(this.currentState.cell) || !o.isTouchEvent(e.getEvent()) || this.graph.model.isVertex(e.getCell()) || this.reset();
    });
    var e = !1;
    this.graph.addMouseListener({
      mouseDown: n.bind(this, function (t, i) {
        e = !1;
        var n = i.getEvent();
        if (this.isResetEvent(n)) this.reset();else if (!this.isActive()) {
          var s = this.getState(i.getState());
          null == s && o.isTouchEvent(n) || this.update(s);
        }
        this.setDisplay("none");
      }),
      mouseMove: n.bind(this, function (t, i) {
        var n = i.getEvent();
        this.isResetEvent(n) ? this.reset() : this.graph.isMouseDown || o.isTouchEvent(n) || this.update(this.getState(i.getState()), i.getGraphX(), i.getGraphY()), null != this.graph.connectionHandler && null != this.graph.connectionHandler.shape && (e = !0);
      }),
      mouseUp: n.bind(this, function (t, i) {
        var s = i.getEvent();
        n.convertPoint(this.graph.container, o.getClientX(s), o.getClientY(s));
        this.isResetEvent(s) ? this.reset() : this.isActive() && !e && null != this.mouseDownPoint ? this.click(this.currentState, this.getDirection(), i) : this.isActive() ? 1 == this.graph.getSelectionCount() && this.graph.model.isEdge(this.graph.getSelectionCell()) ? this.reset() : this.update(this.getState(this.graph.view.getState(this.graph.getCellAt(i.getGraphX(), i.getGraphY())))) : o.isTouchEvent(s) || null != this.bbox && n.contains(this.bbox, i.getGraphX(), i.getGraphY()) ? (this.setDisplay(""), this.repaint()) : o.isTouchEvent(s) || this.reset(), e = !1, this.resetActiveArrow();
      })
    });
  }, g.prototype.isResetEvent = function (t, e) {
    return o.isAltDown(t) || null == this.activeArrow && o.isShiftDown(t) || o.isMetaDown(t) || o.isPopupTrigger(t) && !o.isControlDown(t);
  }, g.prototype.createArrow = function (t, e) {
    var s = null;
    return i.IS_IE && !i.IS_SVG ? (i.IS_IE6 && "CSS1Compat" != document.compatMode ? ((s = document.createElement(i.VML_PREFIX + ":image")).setAttribute("src", t.src), s.style.borderStyle = "none") : ((s = document.createElement("div")).style.backgroundImage = "url(" + t.src + ")", s.style.backgroundPosition = "center", s.style.backgroundRepeat = "no-repeat"), s.style.width = t.width + 4 + "px", s.style.height = t.height + 4 + "px", s.style.display = i.IS_QUIRKS ? "inline" : "inline-block") : ((s = n.createImage(t.src)).style.width = t.width + "px", s.style.height = t.height + "px", s.style.padding = this.tolerance + "px"), null != e && s.setAttribute("title", e), s.style.position = "absolute", s.style.cursor = this.cssCursor, o.addGestureListeners(s, n.bind(this, function (t) {
      null == this.currentState || this.isResetEvent(t) || (this.mouseDownPoint = n.convertPoint(this.graph.container, o.getClientX(t), o.getClientY(t)), this.drag(t, this.mouseDownPoint.x, this.mouseDownPoint.y), this.activeArrow = s, this.setDisplay("none"), o.consume(t));
    })), o.redirectMouseEvents(s, this.graph, this.currentState), o.addListener(s, "mouseenter", n.bind(this, function (t) {
      o.isMouseEvent(t) && (null != this.activeArrow && this.activeArrow != s && n.setOpacity(this.activeArrow, this.inactiveOpacity), this.graph.connectionHandler.constraintHandler.reset(), n.setOpacity(s, 100), this.activeArrow = s);
    })), o.addListener(s, "mouseleave", n.bind(this, function (t) {
      this.graph.isMouseDown || this.resetActiveArrow();
    })), s;
  }, g.prototype.resetActiveArrow = function () {
    null != this.activeArrow && (n.setOpacity(this.activeArrow, this.inactiveOpacity), this.activeArrow = null);
  }, g.prototype.getDirection = function () {
    var t = p.DIRECTION_EAST;
    return this.activeArrow == this.arrowUp ? t = p.DIRECTION_NORTH : this.activeArrow == this.arrowDown ? t = p.DIRECTION_SOUTH : this.activeArrow == this.arrowLeft && (t = p.DIRECTION_WEST), t;
  }, g.prototype.visitNodes = function (t) {
    for (var e = 0; e < this.elts.length; e++) {
      null != this.elts[e] && t(this.elts[e]);
    }
  }, g.prototype.removeNodes = function () {
    this.visitNodes(function (t) {
      null != t.parentNode && t.parentNode.removeChild(t);
    });
  }, g.prototype.setDisplay = function (t) {
    this.visitNodes(function (e) {
      e.style.display = t;
    });
  }, g.prototype.isActive = function () {
    return null != this.activeArrow && null != this.currentState;
  }, g.prototype.drag = function (t, e, i) {
    if (this.graph.popupMenuHandler.hideMenu(), this.graph.stopEditing(!1), null != this.currentState) {
      this.graph.connectionHandler.start(this.currentState, e, i), this.graph.isMouseTrigger = o.isMouseEvent(t), this.graph.isMouseDown = !0;
      var s = this.graph.selectionCellsHandler.getHandler(this.currentState.cell);
      null != s && s.setHandlesVisible(!1);
      var l = this.graph.connectionHandler.edgeState;

      if (null != t && o.isShiftDown(t) && o.isControlDown(t) && null != l && "orthogonalEdgeStyle" === n.getValue(l.style, p.STYLE_EDGE, null)) {
        var r = this.getDirection();
        l.cell.style = n.setStyle(l.cell.style, "sourcePortConstraint", r), l.style.sourcePortConstraint = r;
      }
    }
  }, g.prototype.getStateAt = function (t, e, i) {
    return this.graph.view.getState(this.graph.getCellAt(e, i));
  }, g.prototype.click = function (t, e, i) {
    var n = i.getEvent(),
        s = i.getGraphX(),
        l = i.getGraphY(),
        r = this.getStateAt(t, s, l);

    if (null == r || !this.graph.model.isEdge(r.cell) || o.isControlDown(n) || r.getVisibleTerminalState(!0) != t && r.getVisibleTerminalState(!1) != t) {
      if (null != t) {
        var a = this.graph.connectVertex(t.cell, e, this.graph.defaultEdgeLength, n);
        this.graph.selectCellsForConnectVertex(a, n, this), 2 == a.length && this.graph.model.isVertex(a[1]) ? (this.graph.setSelectionCell(a[1]), o.isTouchEvent(n) ? this.update(this.getState(this.graph.view.getState(a[1]))) : this.reset(), this.graph.scrollCellToVisible(a[1])) : this.graph.setSelectionCells(a);
      }
    } else this.graph.setSelectionCell(r.cell), this.reset();

    i.consume();
  }, g.prototype.reset = function (t) {
    (t = null == t || t) && null != this.updateThread && window.clearTimeout(this.updateThread), this.mouseDownPoint = null, this.currentState = null, this.activeArrow = null, this.removeNodes(), this.bbox = null;
  }, g.prototype.repaint = function () {
    if (this.bbox = null, null != this.currentState) {
      if (this.currentState = this.getState(this.currentState), null != this.currentState && this.graph.model.isVertex(this.currentState.cell) && this.graph.isCellConnectable(this.currentState.cell)) {
        var t = d.fromRectangle(this.currentState);
        null != this.currentState.shape && null != this.currentState.shape.boundingBox && (t = d.fromRectangle(this.currentState.shape.boundingBox)), t.grow(this.graph.tolerance), t.grow(this.arrowSpacing);
        var e = this.graph.selectionCellsHandler.getHandler(this.currentState.cell);

        if (null != e && (t.x -= e.horizontalOffset / 2, t.y -= e.verticalOffset / 2, t.width += e.horizontalOffset, t.height += e.verticalOffset, null != e.rotationShape && null != e.rotationShape.node && "hidden" != e.rotationShape.node.style.visibility && "none" != e.rotationShape.node.style.display && null != e.rotationShape.boundingBox && t.add(e.rotationShape.boundingBox)), this.arrowUp.style.left = Math.round(this.currentState.getCenterX() - this.triangleUp.width / 2 - this.tolerance) + "px", this.arrowUp.style.top = Math.round(t.y - this.triangleUp.height - this.tolerance) + "px", n.setOpacity(this.arrowUp, this.inactiveOpacity), this.arrowRight.style.left = Math.round(t.x + t.width - this.tolerance) + "px", this.arrowRight.style.top = Math.round(this.currentState.getCenterY() - this.triangleRight.height / 2 - this.tolerance) + "px", n.setOpacity(this.arrowRight, this.inactiveOpacity), this.arrowDown.style.left = this.arrowUp.style.left, this.arrowDown.style.top = Math.round(t.y + t.height - this.tolerance) + "px", n.setOpacity(this.arrowDown, this.inactiveOpacity), this.arrowLeft.style.left = Math.round(t.x - this.triangleLeft.width - this.tolerance) + "px", this.arrowLeft.style.top = this.arrowRight.style.top, n.setOpacity(this.arrowLeft, this.inactiveOpacity), this.checkCollisions) {
          var i = this.graph.getCellAt(t.x + t.width + this.triangleRight.width / 2, this.currentState.getCenterY()),
              o = this.graph.getCellAt(t.x - this.triangleLeft.width / 2, this.currentState.getCenterY()),
              l = this.graph.getCellAt(this.currentState.getCenterX(), t.y - this.triangleUp.height / 2),
              r = this.graph.getCellAt(this.currentState.getCenterX(), t.y + t.height + this.triangleDown.height / 2);
          null != i && i == o && o == l && l == r && (i = null, o = null, l = null, r = null);
          var a = this.graph.getCellGeometry(this.currentState.cell),
              h = n.bind(this, function (t, e) {
            var i = this.graph.model.isVertex(t) && this.graph.getCellGeometry(t);
            null != t && !this.graph.model.isAncestor(t, this.currentState.cell) && (null == i || null == a || i.height < 6 * a.height && i.width < 6 * a.width) ? e.style.visibility = "hidden" : e.style.visibility = "visible";
          });
          h(i, this.arrowRight), h(o, this.arrowLeft), h(l, this.arrowUp), h(r, this.arrowDown);
        } else this.arrowLeft.style.visibility = "visible", this.arrowRight.style.visibility = "visible", this.arrowUp.style.visibility = "visible", this.arrowDown.style.visibility = "visible";

        this.graph.tooltipHandler.isEnabled() ? (this.arrowLeft.setAttribute("title", s.get("plusTooltip")), this.arrowRight.setAttribute("title", s.get("plusTooltip")), this.arrowUp.setAttribute("title", s.get("plusTooltip")), this.arrowDown.setAttribute("title", s.get("plusTooltip"))) : (this.arrowLeft.removeAttribute("title"), this.arrowRight.removeAttribute("title"), this.arrowUp.removeAttribute("title"), this.arrowDown.removeAttribute("title"));
      } else this.reset();

      null != this.currentState && (this.bbox = this.computeBoundingBox(), null != this.bbox && this.bbox.grow(10));
    }
  }, g.prototype.computeBoundingBox = function () {
    var t = this.graph.model.isEdge(this.currentState.cell) ? null : d.fromRectangle(this.currentState);
    return this.visitNodes(function (e) {
      if (null != e.parentNode) {
        var i = new d(e.offsetLeft, e.offsetTop, e.offsetWidth, e.offsetHeight);
        null == t ? t = i : t.add(i);
      }
    }), t;
  }, g.prototype.getState = function (t) {
    if (null != t) {
      var e = t.cell;

      if (this.graph.getModel().isVertex(e) && !this.graph.isCellConnectable(e)) {
        var i = this.graph.getModel().getParent(e);
        this.graph.getModel().isVertex(i) && this.graph.isCellConnectable(i) && (e = i);
      }

      (this.graph.isCellLocked(e) || this.graph.model.isEdge(e)) && (e = null), t = this.graph.view.getState(e);
    }

    return t;
  }, g.prototype.update = function (t, e, i) {
    if (this.graph.connectionArrowsEnabled) {
      var s = null;
      this.prev != t || this.isActive() ? (this.startTime = new Date().getTime(), this.prev = t, s = 0, null != this.updateThread && window.clearTimeout(this.updateThread), null != t && (this.updateThread = window.setTimeout(n.bind(this, function () {
        this.isActive() || this.graph.isMouseDown || this.graph.panningHandler.isActive() || (this.prev = t, this.update(t, e, i));
      }), this.updateDelay + 10))) : null != this.startTime && (s = new Date().getTime() - this.startTime), this.setDisplay(""), null != this.currentState && this.currentState != t && s < this.activationDelay && null != this.bbox && !n.contains(this.bbox, e, i) ? this.reset(!1) : (null != this.currentState || s > this.activationDelay) && this.currentState != t && (s > this.updateDelay && null != t || null == this.bbox || null == e || null == i || !n.contains(this.bbox, e, i)) && (null != t && this.graph.isEnabled() ? (this.removeNodes(), this.setCurrentState(t), this.repaint(), this.graph.connectionHandler.constraintHandler.currentFocus != t && this.graph.connectionHandler.constraintHandler.reset()) : this.reset());
    } else this.reset();
  }, g.prototype.setCurrentState = function (t) {
    "eastwest" != t.style.portConstraint && (this.graph.container.appendChild(this.arrowUp), this.graph.container.appendChild(this.arrowDown)), this.graph.container.appendChild(this.arrowRight), this.graph.container.appendChild(this.arrowLeft), this.currentState = t;
  }, new g(t);
}

function EditorDslBuilder(t, e, i, n, s, o) {
  var _t$mx5 = t.mx,
      l = _t$mx5.mxClient,
      r = _t$mx5.mxUtils,
      a = _t$mx5.mxEventSource,
      h = _t$mx5.mxObjectCodec,
      u = _t$mx5.mxCodecRegistry,
      d = _t$mx5.mxResources,
      p = _t$mx5.mxPopupMenu,
      c = _t$mx5.mxEvent,
      m = _t$mx5.mxKeyHandler,
      g = _t$mx5.mxConstants,
      x = _t$mx5.mxClipboard,
      y = _t$mx5.mxPoint,
      f = _t$mx5.mxRectangle,
      v = _t$mx5.mxEventObject,
      C = _t$mx5.mxStackLayout,
      E = _t$mx5.mxOutline,
      S = _t$mx5.mxImage,
      b = _t$mx5.mxMorphing,
      w = _t$mx5.mxXmlRequest,
      T = t.graph.constructor;
  var A,
      L = t.constructor;

  function M(t, e, i, n, s, o) {
    this.mx.mxEventSource.call(this), this.destroyFunctions = [], this.editor = t, this.container = e, this.diagramContainer = i, this.toolbarContainer = n, this.menubarContainer = s;
    var a = this.editor.graph;

    if (a.lightbox = o, a.useCssTransforms && (this.lazyZoomDelay = 0), this.mx.mxPopupMenu.prototype.submenuImage = "data:image/gif;base64,R0lGODlhCQAJAIAAAP///zMzMyH5BAEAAAAALAAAAAAJAAkAAAIPhI8WebHsHopSOVgb26AAADs=", this.editor.chromeless && !this.editor.editable && (this.footerHeight = 0, a.isEnabled = function () {
      return !1;
    }, a.panningHandler.isForcePanningEvent = function (t) {
      return !c.isPopupTrigger(t.getEvent());
    }), this.actions = new ActionsBuilder(this), this.menus = this.createMenus(), a.init(this.diagramContainer), l.IS_SVG && null != a.view.getDrawPane()) {
      var h = a.view.getDrawPane().ownerSVGElement;
      null != h && (h.style.position = "absolute");
    }

    this.hoverIcons = this.createHoverIcons(), this.createUi(), this.refresh();
    var u = r.bind(this, function (t) {
      return null == t && (t = window.event), this.isSelectionAllowed(t) || a.isEditing();
    });

    if (this.container == document.body && (this.menubarContainer.onselectstart = u, this.menubarContainer.onmousedown = u, this.toolbarContainer.onselectstart = u, this.toolbarContainer.onmousedown = u, this.diagramContainer.onselectstart = u, this.diagramContainer.onmousedown = u, this.sidebarContainer.onselectstart = u, this.sidebarContainer.onmousedown = u, this.formatContainer.onselectstart = u, this.formatContainer.onmousedown = u, this.footerContainer.onselectstart = u, this.footerContainer.onmousedown = u, null != this.tabContainer && (this.tabContainer.onselectstart = u)), !this.editor.chromeless || this.editor.editable) {
      var p = function p(t) {
        var e = c.getSource(t);
        if ("A" == e.nodeName) for (; null != e;) {
          if ("geHint" == e.className) return !0;
          e = e.parentNode;
        }
        return u(t);
      };

      l.IS_IE && (void 0 === document.documentMode || document.documentMode < 9) ? c.addListener(this.diagramContainer, "contextmenu", p) : this.diagramContainer.oncontextmenu = p;
    } else a.panningHandler.usePopupTrigger = !1;

    c.addListener(this.diagramContainer, "mousemove", r.bind(this, function (t) {
      var e = r.getOffset(this.diagramContainer);
      c.getClientX(t) - e.x - this.diagramContainer.clientWidth > 0 || c.getClientY(t) - e.y - this.diagramContainer.clientHeight > 0 ? this.diagramContainer.setAttribute("title", d.get("panTooltip")) : this.diagramContainer.removeAttribute("title");
    }));
    var m = !1,
        x = this.hoverIcons.isResetEvent;
    this.hoverIcons.isResetEvent = function (t, e) {
      return m || x.apply(this, arguments);
    }, this.keydownHandler = r.bind(this, function (t) {
      32 == t.which ? (m = !0, this.hoverIcons.reset(), a.container.style.cursor = "move", a.isEditing() || c.getSource(t) != a.container || c.consume(t)) : c.isConsumed(t) || 27 != t.keyCode || this.hideDialog();
    }), c.addListener(document, "keydown", this.keydownHandler), this.keyupHandler = r.bind(this, function (t) {
      a.container.style.cursor = "", m = !1;
    }), c.addListener(document, "keyup", this.keyupHandler);
    var y = a.panningHandler.isForcePanningEvent;

    a.panningHandler.isForcePanningEvent = function (t) {
      return y.apply(this, arguments) || m || c.isMouseEvent(t.getEvent()) && (this.usePopupTrigger || !c.isPopupTrigger(t.getEvent())) && (!c.isControlDown(t.getEvent()) && c.isRightMouseButton(t.getEvent()) || c.isMiddleMouseButton(t.getEvent()));
    };

    var f = a.cellEditor.isStopEditingEvent;

    a.cellEditor.isStopEditingEvent = function (t) {
      return f.apply(this, arguments) || 13 == t.keyCode && (!l.IS_SF && c.isControlDown(t) || l.IS_MAC && c.isMetaDown(t) || l.IS_SF && c.isShiftDown(t));
    };

    var C = !1,
        E = null,
        S = null,
        b = null,
        w = r.bind(this, function () {
      if (null != this.toolbar && C != a.cellEditor.isContentEditing()) {
        for (var t = this.toolbar.container.firstChild, e = []; null != t;) {
          var i = t.nextSibling;
          r.indexOf(this.toolbar.staticElements, t) < 0 && (t.parentNode.removeChild(t), e.push(t)), t = i;
        }

        var n = this.toolbar.fontMenu,
            s = this.toolbar.sizeMenu;
        if (null == b) this.toolbar.createTextToolbar();else {
          for (var o = 0; o < b.length; o++) {
            this.toolbar.container.appendChild(b[o]);
          }

          this.toolbar.fontMenu = E, this.toolbar.sizeMenu = S;
        }
        C = a.cellEditor.isContentEditing(), E = n, S = s, b = e;
      }
    }),
        T = this,
        A = a.cellEditor.startEditing;

    a.cellEditor.startEditing = function () {
      if (A.apply(this, arguments), w(), a.cellEditor.isContentEditing()) {
        var t = !1,
            e = function e() {
          t || (t = !0, window.setTimeout(function () {
            for (var e = a.getSelectedElement(); null != e && e.nodeType != g.NODETYPE_ELEMENT;) {
              e = e.parentNode;
            }

            if (null != e) {
              var i = r.getCurrentStyle(e);

              if (null != i && null != T.toolbar) {
                var n = i.fontFamily;
                "'" == n.charAt(0) && (n = n.substring(1)), "'" == n.charAt(n.length - 1) && (n = n.substring(0, n.length - 1)), T.toolbar.setFontName(n), T.toolbar.setFontSize(parseInt(i.fontSize));
              }
            }

            t = !1;
          }, 0));
        };

        c.addListener(a.cellEditor.textarea, "input", e), c.addListener(a.cellEditor.textarea, "touchend", e), c.addListener(a.cellEditor.textarea, "mouseup", e), c.addListener(a.cellEditor.textarea, "keyup", e), e();
      }
    };

    var L = a.cellEditor.stopEditing;
    if (a.cellEditor.stopEditing = function (t, e) {
      L.apply(this, arguments), w();
    }, a.container.setAttribute("tabindex", "0"), a.container.style.cursor = "default", window.self === window.top && null != a.container.parentNode) try {
      a.container.focus();
    } catch (t) {}
    var M = a.fireMouseEvent;
    a.fireMouseEvent = function (t, e, i) {
      t == c.MOUSE_DOWN && this.container.focus(), M.apply(this, arguments);
    }, a.popupMenuHandler.autoExpand = !0, null != this.menus && (a.popupMenuHandler.factoryMethod = r.bind(this, function (t, e, i) {
      this.menus.createPopupMenu(t, e, i);
    })), c.addGestureListeners(document, r.bind(this, function (t) {
      a.popupMenuHandler.hideMenu();
    })), this.keyHandler = this.createKeyHandler(t), this.getKeyHandler = function () {
      return this.keyHandler;
    };
    var I = ["rounded", "shadow", "glass", "dashed", "dashPattern", "comic", "labelBackgroundColor"],
        R = ["shape", "edgeStyle", "curved", "rounded", "elbow", "comic", "jumpStyle", "jumpSize"];
    this.setDefaultStyle = function (t) {
      var e = a.view.getState(t);

      if (null != e) {
        var i = t.clone();
        i.style = "";
        var n = a.getCellStyle(i),
            s = [],
            o = [];

        for (var l in e.style) {
          n[l] != e.style[l] && (s.push(e.style[l]), o.push(l));
        }

        for (var r = a.getModel().getStyle(e.cell), h = null != r ? r.split(";") : [], u = 0; u < h.length; u++) {
          var d = h[u],
              p = d.indexOf("=");

          if (p >= 0) {
            l = d.substring(0, p);
            var c = d.substring(p + 1);
            null != n[l] && "none" == c && (s.push(c), o.push(l));
          }
        }

        a.getModel().isEdge(e.cell) ? a.currentEdgeStyle = {} : a.currentVertexStyle = {}, this.fireEvent(new v("styleChanged", "keys", o, "values", s, "cells", [e.cell]));
      }
    }, this.clearDefaultStyle = function () {
      a.currentEdgeStyle = r.clone(a.defaultEdgeStyle), a.currentVertexStyle = r.clone(a.defaultVertexStyle), this.fireEvent(new v("styleChanged", "keys", [], "values", [], "cells", []));
    };

    for (var P = ["fontFamily", "fontSize", "fontColor"], O = ["edgeStyle", "startArrow", "startFill", "startSize", "endArrow", "endFill", "endSize", "jettySize", "orthogonalLoop"], H = [["startArrow", "startFill", "startSize", "sourcePerimeterSpacing", "endArrow", "endFill", "endSize", "targetPerimeterSpacing", "jettySize", "orthogonalLoop"], ["strokeColor", "strokeWidth"], ["fillColor", "gradientColor"], P, ["opacity"], ["align"], ["html"]], N = 0; N < H.length; N++) {
      for (var D = 0; D < H[N].length; D++) {
        I.push(H[N][D]);
      }
    }

    for (N = 0; N < R.length; N++) {
      r.indexOf(I, R[N]) < 0 && I.push(R[N]);
    }

    var G = function G(t, e) {
      var i = a.getModel();
      i.beginUpdate();

      try {
        if (e) for (var n = (S = i.isEdge(u)) ? a.currentEdgeStyle : a.currentVertexStyle, s = ["fontSize", "fontFamily", "fontColor"], o = 0; o < s.length; o++) {
          var l = n[s[o]];
          null != l && a.setCellStyles(s[o], l, t);
        } else for (var h = 0; h < t.length; h++) {
          var u = t[h],
              d = i.getStyle(u),
              p = null != d ? d.split(";") : [],
              c = I.slice();

          for (o = 0; o < p.length; o++) {
            var m = p[o],
                g = m.indexOf("=");

            if (g >= 0) {
              var x = m.substring(0, g),
                  y = r.indexOf(c, x);
              y >= 0 && c.splice(y, 1);

              for (var f = 0; f < H.length; f++) {
                var v = H[f];
                if (r.indexOf(v, x) >= 0) for (var C = 0; C < v.length; C++) {
                  var E = r.indexOf(c, v[C]);
                  E >= 0 && c.splice(E, 1);
                }
              }
            }
          }

          n = (S = i.isEdge(u)) ? a.currentEdgeStyle : a.currentVertexStyle;
          var S,
              b = i.getStyle(u);

          for (o = 0; o < c.length; o++) {
            var w = n[x = c[o]];
            null == w || "shape" == x && !S || (!S || r.indexOf(R, x) < 0) && (b = r.setStyle(b, x, w));
          }

          i.setStyle(u, b);
        }
      } finally {
        i.endUpdate();
      }
    };

    if (a.addListener("cellsInserted", function (t, e) {
      G(e.getProperty("cells"));
    }), a.addListener("textInserted", function (t, e) {
      G(e.getProperty("cells"), !0);
    }), a.connectionHandler.addListener(c.CONNECT, function (t, e) {
      var i = [e.getProperty("cell")];
      e.getProperty("terminalInserted") && i.push(e.getProperty("terminal")), G(i);
    }), this.addListener("styleChanged", r.bind(this, function (t, e) {
      var i = e.getProperty("cells"),
          n = !1,
          s = !1;
      if (i.length > 0) for (var o = 0; o < i.length && (n = a.getModel().isVertex(i[o]) || n, !(s = a.getModel().isEdge(i[o]) || s) || !n); o++) {
        ;
      } else n = !0, s = !0;
      var l = e.getProperty("keys"),
          h = e.getProperty("values");

      for (o = 0; o < l.length; o++) {
        var u = r.indexOf(P, l[o]) >= 0;
        ("strokeColor" != l[o] || null != h[o] && "none" != h[o]) && (r.indexOf(R, l[o]) >= 0 ? s || r.indexOf(O, l[o]) >= 0 ? null == h[o] ? delete a.currentEdgeStyle[l[o]] : a.currentEdgeStyle[l[o]] = h[o] : n && r.indexOf(I, l[o]) >= 0 && (null == h[o] ? delete a.currentVertexStyle[l[o]] : a.currentVertexStyle[l[o]] = h[o]) : r.indexOf(I, l[o]) >= 0 && ((n || u) && (null == h[o] ? delete a.currentVertexStyle[l[o]] : a.currentVertexStyle[l[o]] = h[o]), (s || u || r.indexOf(O, l[o]) >= 0) && (null == h[o] ? delete a.currentEdgeStyle[l[o]] : a.currentEdgeStyle[l[o]] = h[o])));
      }

      if (null != this.toolbar) {
        if (this.toolbar.setFontName(a.currentVertexStyle.fontFamily || MenusBuilder.prototype.defaultFont), this.toolbar.setFontSize(a.currentVertexStyle.fontSize || MenusBuilder.prototype.defaultFontSize), null != this.toolbar.edgeStyleMenu) {
          var d = this.toolbar.edgeStyleMenu.getElementsByTagName("div")[0];
          "orthogonalEdgeStyle" == a.currentEdgeStyle.edgeStyle && "1" == a.currentEdgeStyle.curved ? d.className = "geSprite geSprite-curved" : "straight" == a.currentEdgeStyle.edgeStyle || "none" == a.currentEdgeStyle.edgeStyle || null == a.currentEdgeStyle.edgeStyle ? d.className = "geSprite geSprite-straight" : "entityRelationEdgeStyle" == a.currentEdgeStyle.edgeStyle ? d.className = "geSprite geSprite-entity" : "elbowEdgeStyle" == a.currentEdgeStyle.edgeStyle ? d.className = "geSprite geSprite-" + ("vertical" == a.currentEdgeStyle.elbow ? "verticalelbow" : "horizontalelbow") : "isometricEdgeStyle" == a.currentEdgeStyle.edgeStyle ? d.className = "geSprite geSprite-" + ("vertical" == a.currentEdgeStyle.elbow ? "verticalisometric" : "horizontalisometric") : d.className = "geSprite geSprite-orthogonal";
        }

        if (null != this.toolbar.edgeShapeMenu) {
          var p = this.toolbar.edgeShapeMenu.getElementsByTagName("div")[0];
          "link" == a.currentEdgeStyle.shape ? p.className = "geSprite geSprite-linkedge" : "flexArrow" == a.currentEdgeStyle.shape ? p.className = "geSprite geSprite-arrow" : "arrow" == a.currentEdgeStyle.shape ? p.className = "geSprite geSprite-simplearrow" : p.className = "geSprite geSprite-connection";
        }

        if (null != this.toolbar.lineStartMenu) this.toolbar.lineStartMenu.getElementsByTagName("div")[0].className = this.getCssClassForMarker("start", a.currentEdgeStyle.shape, a.currentEdgeStyle[g.STYLE_STARTARROW], r.getValue(a.currentEdgeStyle, "startFill", "1"));
        if (null != this.toolbar.lineEndMenu) this.toolbar.lineEndMenu.getElementsByTagName("div")[0].className = this.getCssClassForMarker("end", a.currentEdgeStyle.shape, a.currentEdgeStyle[g.STYLE_ENDARROW], r.getValue(a.currentEdgeStyle, "endFill", "1"));
      }
    })), null != this.toolbar) {
      var _ = r.bind(this, function () {
        var t = a.currentVertexStyle.fontFamily || "Helvetica",
            e = String(a.currentVertexStyle.fontSize || "12"),
            i = a.getView().getState(a.getSelectionCell());
        null != i && (t = i.style[g.STYLE_FONTFAMILY] || t, e = i.style[g.STYLE_FONTSIZE] || e, t.length > 10 && (t = t.substring(0, 8) + "...")), this.toolbar.setFontName(t), this.toolbar.setFontSize(e);
      });

      a.getSelectionModel().addListener(c.CHANGE, _), a.getModel().addListener(c.CHANGE, _);
    }

    a.addListener(c.CELLS_ADDED, function (t, e) {
      var i = e.getProperty("cells"),
          n = e.getProperty("parent");
      a.getModel().isLayer(n) && !a.isCellVisible(n) && null != i && i.length > 0 && a.getModel().setVisible(n, !0);
    }), this.gestureHandler = r.bind(this, function (t) {
      null != this.currentMenu && c.getSource(t) != this.currentMenu.div && this.hideCurrentMenu();
    }), c.addGestureListeners(document, this.gestureHandler), this.resizeHandler = r.bind(this, function () {
      window.setTimeout(r.bind(this, function () {
        null != this.editor.graph && this.refresh();
      }), 0);
    }), c.addListener(window, "resize", this.resizeHandler), this.orientationChangeHandler = r.bind(this, function () {
      this.refresh();
    }), c.addListener(window, "orientationchange", this.orientationChangeHandler), l.IS_IOS && !window.navigator.standalone && (this.scrollHandler = r.bind(this, function () {
      window.scrollTo(0, 0);
    }), c.addListener(window, "scroll", this.scrollHandler)), this.editor.addListener("resetGraphView", r.bind(this, function () {
      this.resetScrollbars();
    })), this.addListener("gridEnabledChanged", r.bind(this, function () {
      a.view.validateBackground();
    })), this.addListener("backgroundColorChanged", r.bind(this, function () {
      a.view.validateBackground();
    })), a.addListener("gridSizeChanged", r.bind(this, function () {
      a.isGridEnabled() && a.view.validateBackground();
    })), this.isGraphEditor && this.editor.resetGraph(), this.init(), this.open();
  }

  function I(t, e, i, n) {
    this.ui = t, this.color = e, this.previousColor = e, this.image = i, this.previousImage = i, this.format = n, this.previousFormat = n, this.ignoreColor = !1, this.ignoreImage = !1;
  }

  return r.extend(M, a), M.compactUi = !0, M.prototype.menubarHeight = 30, M.prototype.formatEnabled = !0, M.prototype.formatWidth = 240, M.prototype.toolbarHeight = 34, M.prototype.footerHeight = 28, M.prototype.sidebarFooterHeight = 34, M.prototype.splitSize = l.IS_TOUCH || l.IS_POINTER ? 12 : 8, M.prototype.hsplitPosition = screen.width <= 640 ? 118 : 208, M.prototype.allowAnimation = !0, M.prototype.lightboxMaxFitScale = 2, M.prototype.lightboxVerticalDivider = 4, M.prototype.hsplitClickEnabled = !1, M.prototype.init = function () {
    var t = this.editor.graph;
    c.addListener(t.container, "keydown", r.bind(this, function (t) {
      this.onKeyDown(t);
    })), c.addListener(t.container, "keypress", r.bind(this, function (t) {
      this.onKeyPress(t);
    })), this.addUndoListener(), this.addBeforeUnloadListener(), t.getSelectionModel().addListener(c.CHANGE, r.bind(this, function () {
      this.updateActionStates();
    })), t.getModel().addListener(c.CHANGE, r.bind(this, function () {
      this.updateActionStates();
    }));
    var e = t.setDefaultParent,
        i = this;
    this.editor.graph.setDefaultParent = function () {
      e.apply(this, arguments), i.updateActionStates();
    }, t.editLink = i.actions.get("editLink").funct, this.updateActionStates(), this.initClipboard(), this.initCanvas(), null != this.format && this.format.init();
  }, M.prototype.loadModel = function (e, i) {
    var _this = this;

    r.getAll([e, i], function (e) {
      try {
        var i = r.parseXml(e[0].getText()),
            n = JSON.parse(e[1].getText());

        _this.domainModel.import(n, t, i.documentElement);
      } catch (t) {
        r.alert(d.get("invalidOrMissingFile") + ": " + (t.message ? t.message : t));
      }
    });
  }, M.prototype.onKeyDown = function (t) {
    var e = this.editor.graph;
    9 == t.which && e.isEnabled() && !c.isAltDown(t) && (e.isEditing() ? e.stopEditing(!1) : e.selectCell(!c.isShiftDown(t)), c.consume(t));
  }, M.prototype.onKeyPress = function (t) {
    var e = this.editor.graph;

    if (this.isImmediateEditingEvent(t) && !e.isEditing() && !e.isSelectionEmpty() && 0 !== t.which && !c.isAltDown(t) && !c.isControlDown(t) && !c.isMetaDown(t) && (e.escape(), e.startEditing(), l.IS_FF)) {
      var i = e.cellEditor;
      i.textarea.innerHTML = String.fromCharCode(t.which);
      var n = document.createRange();
      n.selectNodeContents(i.textarea), n.collapse(!1);
      var s = window.getSelection();
      s.removeAllRanges(), s.addRange(n);
    }
  }, M.prototype.isImmediateEditingEvent = function (t) {
    return !0;
  }, M.prototype.getCssClassForMarker = function (t, e, i, n) {
    return "flexArrow" == e ? null != i && i != g.NONE ? "geSprite geSprite-" + t + "blocktrans" : "geSprite geSprite-noarrow" : i == g.ARROW_CLASSIC ? "1" == n ? "geSprite geSprite-" + t + "classic" : "geSprite geSprite-" + t + "classictrans" : i == g.ARROW_CLASSIC_THIN ? "1" == n ? "geSprite geSprite-" + t + "classicthin" : "geSprite geSprite-" + t + "classicthintrans" : i == g.ARROW_OPEN ? "geSprite geSprite-" + t + "open" : i == g.ARROW_OPEN_THIN ? "geSprite geSprite-" + t + "openthin" : i == g.ARROW_BLOCK ? "1" == n ? "geSprite geSprite-" + t + "block" : "geSprite geSprite-" + t + "blocktrans" : i == g.ARROW_BLOCK_THIN ? "1" == n ? "geSprite geSprite-" + t + "blockthin" : "geSprite geSprite-" + t + "blockthintrans" : i == g.ARROW_OVAL ? "1" == n ? "geSprite geSprite-" + t + "oval" : "geSprite geSprite-" + t + "ovaltrans" : i == g.ARROW_DIAMOND ? "1" == n ? "geSprite geSprite-" + t + "diamond" : "geSprite geSprite-" + t + "diamondtrans" : i == g.ARROW_DIAMOND_THIN ? "1" == n ? "geSprite geSprite-" + t + "thindiamond" : "geSprite geSprite-" + t + "thindiamondtrans" : "openAsync" == i ? "geSprite geSprite-" + t + "openasync" : "dash" == i ? "geSprite geSprite-" + t + "dash" : "cross" == i ? "geSprite geSprite-" + t + "cross" : "async" == i ? "1" == n ? "geSprite geSprite-" + t + "async" : "geSprite geSprite-" + t + "asynctrans" : "circle" == i || "circlePlus" == i ? "1" == n || "circle" == i ? "geSprite geSprite-" + t + "circle" : "geSprite geSprite-" + t + "circleplus" : "ERone" == i ? "geSprite geSprite-" + t + "erone" : "ERmandOne" == i ? "geSprite geSprite-" + t + "eronetoone" : "ERmany" == i ? "geSprite geSprite-" + t + "ermany" : "ERoneToMany" == i ? "geSprite geSprite-" + t + "eronetomany" : "ERzeroToOne" == i ? "geSprite geSprite-" + t + "eroneopt" : "ERzeroToMany" == i ? "geSprite geSprite-" + t + "ermanyopt" : "geSprite geSprite-noarrow";
  }, M.prototype.createMenus = function () {
    return new MenusBuilder(this);
  }, M.prototype.updatePasteActionStates = function () {
    var t = this.editor.graph,
        e = this.actions.get("paste"),
        i = this.actions.get("pasteHere");
    e.setEnabled(this.editor.graph.cellEditor.isContentEditing() || !x.isEmpty() && t.isEnabled() && !t.isCellLocked(t.getDefaultParent())), i.setEnabled(e.isEnabled());
  }, M.prototype.initClipboard = function () {
    var t = this,
        e = x.cut;

    x.cut = function (i) {
      i.cellEditor.isContentEditing() ? document.execCommand("cut", !1, null) : e.apply(this, arguments), t.updatePasteActionStates();
    };

    var i = x.copy;

    x.copy = function (e) {
      e.cellEditor.isContentEditing() ? document.execCommand("copy", !1, null) : i.apply(this, arguments), t.updatePasteActionStates();
    };

    var n = x.paste;

    x.paste = function (e) {
      var i = null;
      return e.cellEditor.isContentEditing() ? document.execCommand("paste", !1, null) : i = n.apply(this, arguments), t.updatePasteActionStates(), i;
    };

    var s = this.editor.graph.cellEditor.startEditing;

    this.editor.graph.cellEditor.startEditing = function () {
      s.apply(this, arguments), t.updatePasteActionStates();
    };

    var o = this.editor.graph.cellEditor.stopEditing;
    this.editor.graph.cellEditor.stopEditing = function (e, i) {
      o.apply(this, arguments), t.updatePasteActionStates();
    }, this.updatePasteActionStates();
  }, M.prototype.lazyZoomDelay = 20, M.prototype.initCanvas = function () {
    var t = this.editor.graph;
    t.timerAutoScroll = !0, t.getPagePadding = function () {
      return this.pageVisible ? new y(Math.max(0, Math.round((t.container.offsetWidth - 34) / t.view.scale)), Math.max(0, Math.round((t.container.offsetHeight - 34) / t.view.scale))) : new y();
    }, t.view.getBackgroundPageBounds = function () {
      var t = this.graph.getPageLayout(),
          e = this.graph.getPageSize();
      return new f(this.scale * (this.translate.x + t.x * e.width), this.scale * (this.translate.y + t.y * e.height), this.scale * t.width * e.width, this.scale * t.height * e.height);
    }, t.getPreferredPageSize = function (t, e, i) {
      var n = this.getPageLayout(),
          s = this.getPageSize();
      return new f(0, 0, n.width * s.width, n.height * s.height);
    };
    var e = null,
        i = this;

    if (this.isGraphEditor && this.editor.isChromelessView()) {
      e = r.bind(this, function (e, i, n, s) {
        if (null != t.container) {
          n = null != n ? n : 0, s = null != s ? s : 0;
          var o = t.pageVisible ? t.view.getBackgroundPageBounds() : t.getGraphBounds(),
              a = r.hasScrollbars(t.container),
              h = t.view.translate,
              u = t.view.scale,
              d = f.fromRectangle(o);
          d.x = d.x / u - h.x, d.y = d.y / u - h.y, d.width /= u, d.height /= u;
          var p = t.container.scrollTop,
              c = t.container.scrollLeft,
              m = l.IS_QUIRKS || document.documentMode >= 8 ? 20 : 14;
          8 != document.documentMode && 9 != document.documentMode || (m += 3);
          var g = t.container.offsetWidth - m,
              x = t.container.offsetHeight - m,
              y = e ? Math.max(.3, Math.min(i || 1, g / d.width)) : u,
              v = (g - y * d.width) / 2 / y,
              C = 0 == this.lightboxVerticalDivider ? 0 : (x - y * d.height) / this.lightboxVerticalDivider / y;
          if (a && (v = Math.max(v, 0), C = Math.max(C, 0)), a || o.width < g || o.height < x) t.view.scaleAndTranslate(y, Math.floor(v - d.x), Math.floor(C - d.y)), t.container.scrollTop = p * y / u, t.container.scrollLeft = c * y / u;else if (0 != n || 0 != s) {
            var E = t.view.translate;
            t.view.setTranslate(Math.floor(E.x + n / u), Math.floor(E.y + s / u));
          }
        }
      }), this.chromelessResize = e, this.chromelessWindowResize = r.bind(this, function () {
        this.chromelessResize(!1);
      });
      var n = r.bind(this, function () {
        this.chromelessWindowResize(!1);
      });

      if (c.addListener(window, "resize", n), this.destroyFunctions.push(function () {
        c.removeListener(window, "resize", n);
      }), this.editor.addListener("resetGraphView", r.bind(this, function () {
        this.chromelessResize(!0);
      })), this.actions.get("zoomIn").funct = r.bind(this, function (e) {
        t.zoomIn(), this.chromelessResize(!1);
      }), this.actions.get("zoomOut").funct = r.bind(this, function (e) {
        t.zoomOut(), this.chromelessResize(!1);
      }), "0" != urlParams.toolbar) {
        this.chromelessToolbar = document.createElement("div"), this.chromelessToolbar.style.position = "fixed", this.chromelessToolbar.style.overflow = "hidden", this.chromelessToolbar.style.boxSizing = "border-box", this.chromelessToolbar.style.whiteSpace = "nowrap", this.chromelessToolbar.style.backgroundColor = "#000000", this.chromelessToolbar.style.padding = "10px 10px 8px 10px", this.chromelessToolbar.style.left = "50%", l.IS_VML || (r.setPrefixedStyle(this.chromelessToolbar.style, "borderRadius", "20px"), r.setPrefixedStyle(this.chromelessToolbar.style, "transition", "opacity 600ms ease-in-out"));
        var s = r.bind(this, function () {
          var e = r.getCurrentStyle(t.container);
          this.chromelessToolbar.style.bottom = (null != e ? parseInt(e["margin-bottom"] || 0) : 0) + (null != this.tabContainer ? 20 + parseInt(this.tabContainer.style.height) : 20) + "px";
        });
        this.editor.addListener("resetGraphView", s), s();
        var o = r.bind(this, function (t, e, i) {
          var n = document.createElement("span");
          n.style.paddingLeft = "8px", n.style.paddingRight = "8px", n.style.cursor = "pointer", c.addListener(n, "click", t), null != i && n.setAttribute("title", i);
          var s = document.createElement("img");
          return s.setAttribute("border", "0"), s.setAttribute("src", e), n.appendChild(s), this.chromelessToolbar.appendChild(n), n;
        }),
            a = o(r.bind(this, function (t) {
          this.actions.get("previousPage").funct(), c.consume(t);
        }), L.previousLargeImage, d.get("previousPage")),
            h = document.createElement("div");
        h.style.display = "inline-block", h.style.verticalAlign = "top", h.style.fontFamily = "Helvetica,Arial", h.style.marginTop = "8px", h.style.fontSize = "14px", h.style.color = "#ffffff", this.chromelessToolbar.appendChild(h);
        var u = o(r.bind(this, function (t) {
          this.actions.get("nextPage").funct(), c.consume(t);
        }), L.nextLargeImage, d.get("nextPage")),
            p = r.bind(this, function () {
          null != this.pages && this.pages.length > 1 && null != this.currentPage && (h.innerHTML = "", r.write(h, r.indexOf(this.pages, this.currentPage) + 1 + " / " + this.pages.length));
        });
        a.style.paddingLeft = "0px", a.style.paddingRight = "4px", u.style.paddingLeft = "4px", u.style.paddingRight = "0px";
        var m = r.bind(this, function () {
          null != this.pages && this.pages.length > 1 && null != this.currentPage ? (u.style.display = "", a.style.display = "", h.style.display = "inline-block") : (u.style.display = "none", a.style.display = "none", h.style.display = "none"), p();
        });
        this.editor.addListener("resetGraphView", m), this.editor.addListener("pageSelected", p), o(r.bind(this, function (t) {
          this.actions.get("zoomOut").funct(), c.consume(t);
        }), L.zoomOutLargeImage, d.get("zoomOut") + " (Alt+Mousewheel)"), o(r.bind(this, function (t) {
          this.actions.get("zoomIn").funct(), c.consume(t);
        }), L.zoomInLargeImage, d.get("zoomIn") + " (Alt+Mousewheel)"), o(r.bind(this, function (e) {
          t.isLightboxView() ? (1 == t.view.scale ? this.lightboxFit() : t.zoomTo(1), this.chromelessResize(!1)) : this.chromelessResize(!0), c.consume(e);
        }), L.actualSizeLargeImage, d.get("fit"));
        var g = null,
            x = null,
            v = r.bind(this, function (t) {
          null != g && (window.clearTimeout(g), this.fadeThead = null), null != x && (window.clearTimeout(x), this.fadeThead2 = null), g = window.setTimeout(r.bind(this, function () {
            r.setOpacity(this.chromelessToolbar, 0), g = null, x = window.setTimeout(r.bind(this, function () {
              this.chromelessToolbar.style.display = "none", x = null;
            }), 600);
          }), t || 200);
        }),
            C = r.bind(this, function (t) {
          null != g && (window.clearTimeout(g), this.fadeThead = null), null != x && (window.clearTimeout(x), this.fadeThead2 = null), this.chromelessToolbar.style.display = "", r.setOpacity(this.chromelessToolbar, t || 30);
        });

        if ("1" == urlParams.layers) {
          this.layersDialog = null;
          var E = o(r.bind(this, function (e) {
            if (null != this.layersDialog) this.layersDialog.parentNode.removeChild(this.layersDialog), this.layersDialog = null;else {
              this.layersDialog = t.createLayersDialog(), c.addListener(this.layersDialog, "mouseleave", r.bind(this, function () {
                this.layersDialog.parentNode.removeChild(this.layersDialog), this.layersDialog = null;
              }));
              var i = E.getBoundingClientRect();
              r.setPrefixedStyle(this.layersDialog.style, "borderRadius", "5px"), this.layersDialog.style.position = "fixed", this.layersDialog.style.fontFamily = "Helvetica,Arial", this.layersDialog.style.backgroundColor = "#000000", this.layersDialog.style.width = "160px", this.layersDialog.style.padding = "4px 2px 4px 2px", this.layersDialog.style.color = "#ffffff", r.setOpacity(this.layersDialog, 70), this.layersDialog.style.left = i.left + "px", this.layersDialog.style.bottom = parseInt(this.chromelessToolbar.style.bottom) + this.chromelessToolbar.offsetHeight + 4 + "px";
              var n = r.getCurrentStyle(this.editor.graph.container);
              this.layersDialog.style.zIndex = n.zIndex, document.body.appendChild(this.layersDialog);
            }
            c.consume(e);
          }), L.layersLargeImage, d.get("layers")),
              S = t.getModel();
          S.addListener(c.CHANGE, function () {
            E.style.display = S.getChildCount(S.root) > 1 ? "" : "none";
          });
        }

        if (this.addChromelessToolbarItems(o), null == this.editor.editButtonLink && null == this.editor.editButtonFunc || o(r.bind(this, function (e) {
          null != this.editor.editButtonFunc ? this.editor.editButtonFunc() : "_blank" == this.editor.editButtonLink ? this.editor.editAsNew(this.getEditBlankXml()) : t.openLink(this.editor.editButtonLink, "editWindow"), c.consume(e);
        }), L.editLargeImage, d.get("edit")), null != this.lightboxToolbarActions) for (var b = 0; b < this.lightboxToolbarActions.length; b++) {
          var w = this.lightboxToolbarActions[b];
          o(w.fn, w.icon, w.tooltip);
        }
        !t.lightbox || "1" != urlParams.close && this.container == document.body || o(r.bind(this, function (t) {
          "1" == urlParams.close ? window.close() : (this.destroy(), c.consume(t));
        }), L.closeLargeImage, d.get("close") + " (Escape)"), this.chromelessToolbar.style.display = "none", r.setPrefixedStyle(this.chromelessToolbar.style, "transform", "translate(-50%,0)"), t.container.appendChild(this.chromelessToolbar), c.addListener(t.container, l.IS_POINTER ? "pointermove" : "mousemove", r.bind(this, function (t) {
          c.isTouchEvent(t) || (c.isShiftDown(t) || C(30), v());
        })), c.addListener(this.chromelessToolbar, l.IS_POINTER ? "pointermove" : "mousemove", function (t) {
          c.consume(t);
        }), c.addListener(this.chromelessToolbar, "mouseenter", r.bind(this, function (t) {
          c.isShiftDown(t) ? v() : C(100);
        })), c.addListener(this.chromelessToolbar, "mousemove", r.bind(this, function (t) {
          c.isShiftDown(t) ? v() : C(100), c.consume(t);
        })), c.addListener(this.chromelessToolbar, "mouseleave", r.bind(this, function (t) {
          c.isTouchEvent(t) || C(30);
        }));
        var T = t.getTolerance();
        t.addMouseListener({
          startX: 0,
          startY: 0,
          scrollLeft: 0,
          scrollTop: 0,
          mouseDown: function mouseDown(e, i) {
            this.startX = i.getGraphX(), this.startY = i.getGraphY(), this.scrollLeft = t.container.scrollLeft, this.scrollTop = t.container.scrollTop;
          },
          mouseMove: function mouseMove(t, e) {},
          mouseUp: function mouseUp(e, n) {
            c.isTouchEvent(n.getEvent()) && Math.abs(this.scrollLeft - t.container.scrollLeft) < T && Math.abs(this.scrollTop - t.container.scrollTop) < T && Math.abs(this.startX - n.getGraphX()) < T && Math.abs(this.startY - n.getGraphY()) < T && (parseFloat(i.chromelessToolbar.style.opacity || 0) > 0 ? v() : C(30));
          }
        });
      }

      this.editor.editable || this.addChromelessClickHandler();
    } else if (this.editor.extendCanvas) {
      var A = t.view.validate;

      t.view.validate = function () {
        if (this.pageVisible && null != this.graph.container && r.hasScrollbars(this.graph.container)) {
          var t = this.graph.getPagePadding(),
              e = this.graph.getPageSize();
          this.translate.x, this.translate.y;
          this.translate.x = t.x - (this.x0 || 0) * e.width, this.translate.y = t.y - (this.y0 || 0) * e.height;
        }

        A.apply(this, arguments);
      };

      var M = t.sizeDidChange;

      t.sizeDidChange = function () {
        if (null != this.container && r.hasScrollbars(this.container)) {
          var e = this.getPageLayout(),
              i = this.getPagePadding(),
              n = this.getPageSize(),
              s = Math.ceil(2 * i.x + e.width * n.width),
              o = Math.ceil(2 * i.y + e.height * n.height),
              l = t.minimumGraphSize;
          null != l && l.width == s && l.height == o || (t.minimumGraphSize = new f(0, 0, s, o));

          var _r = t.getGraphBounds();

          if (this.pageVisible || _r.x < 0 || _r.y < 0) {
            var a = i.x - e.x * n.width,
                h = i.y - e.y * n.height;

            if (!this.autoTranslate && (this.view.translate.x != a || this.view.translate.y != h)) {
              this.autoTranslate = !0, this.view.x0 = e.x, this.view.y0 = e.y;
              var u = t.view.translate.x,
                  d = t.view.translate.y;
              return t.view.setTranslate(a, h), t.container.scrollLeft += Math.round((a - u) * t.view.scale), t.container.scrollTop += Math.round((h - d) * t.view.scale), void (this.autoTranslate = !1);
            }
          }

          M.apply(this, arguments);
        }
      };
    }

    t.updateZoomTimeout = null, t.cumulativeZoomFactor = 1;
    var I = null;
    t.lazyZoom = function (n) {
      null != this.updateZoomTimeout && window.clearTimeout(this.updateZoomTimeout), n ? this.view.scale * this.cumulativeZoomFactor < .15 ? this.cumulativeZoomFactor = (this.view.scale + .01) / this.view.scale : (this.cumulativeZoomFactor *= this.zoomFactor, this.cumulativeZoomFactor = Math.round(this.view.scale * this.cumulativeZoomFactor * 20) / 20 / this.view.scale) : this.view.scale * this.cumulativeZoomFactor <= .15 ? this.cumulativeZoomFactor = (this.view.scale - .01) / this.view.scale : (this.cumulativeZoomFactor /= this.zoomFactor, this.cumulativeZoomFactor = Math.round(this.view.scale * this.cumulativeZoomFactor * 20) / 20 / this.view.scale), this.cumulativeZoomFactor = Math.max(.01, Math.min(this.view.scale * this.cumulativeZoomFactor, 160) / this.view.scale), this.updateZoomTimeout = window.setTimeout(r.bind(this, function () {
        var n = r.getOffset(t.container),
            s = 0,
            o = 0;
        null != I && (s = t.container.offsetWidth / 2 - I.x + n.x, o = t.container.offsetHeight / 2 - I.y + n.y);
        var l = this.view.scale;
        this.zoom(this.cumulativeZoomFactor), this.view.scale != l && (null != e && i.chromelessResize(!1, null, s * (this.cumulativeZoomFactor - 1), o * (this.cumulativeZoomFactor - 1)), !r.hasScrollbars(t.container) || 0 == s && 0 == o || (t.container.scrollLeft -= s * (this.cumulativeZoomFactor - 1), t.container.scrollTop -= o * (this.cumulativeZoomFactor - 1))), this.cumulativeZoomFactor = 1, this.updateZoomTimeout = null;
      }), this.lazyZoomDelay);
    }, c.addMouseWheelListener(r.bind(this, function (e, i) {
      if ((null == this.dialogs || 0 == this.dialogs.length) && t.isZoomWheelEvent(e)) for (var n = c.getSource(e); null != n;) {
        if (n == t.container) return I = new y(c.getClientX(e), c.getClientY(e)), t.lazyZoom(i), void c.consume(e);
        n = n.parentNode;
      }
    }));
  }, M.prototype.addChromelessToolbarItems = function (t) {
    t(r.bind(this, function (t) {
      this.actions.get("print").funct(), c.consume(t);
    }), L.printLargeImage, d.get("print"));
  }, M.prototype.createTemporaryGraph = function (t) {
    var e = new T(document.createElement("div"), null, null, t);
    return e.resetViewOnRootChange = !1, e.setConnectable(!1), e.gridEnabled = !1, e.autoScroll = !1, e.setTooltips(!1), e.setEnabled(!1), e.container.style.visibility = "hidden", e.container.style.position = "absolute", e.container.style.overflow = "hidden", e.container.style.height = "1px", e.container.style.width = "1px", e;
  }, M.prototype.addChromelessClickHandler = function () {
    var t = urlParams.highlight;
    null != t && t.length > 0 && (t = "#" + t), this.editor.graph.addClickHandler(t);
  }, M.prototype.toggleFormatPanel = function (t) {
    this.formatWidth = t || this.formatWidth > 0 ? 0 : 240, this.formatContainer.style.display = t || this.formatWidth > 0 ? "" : "none", this.refresh(), this.format.refresh(), this.fireEvent(new v("formatWidthChanged"));
  }, M.prototype.lightboxFit = function (t) {
    if (this.isDiagramEmpty()) this.editor.graph.view.setScale(1);else {
      var e = urlParams.border,
          i = 60;
      null != e && (i = parseInt(e)), this.editor.graph.maxFitScale = this.lightboxMaxFitScale, this.editor.graph.fit(i, null, null, null, null, null, t), this.editor.graph.maxFitScale = null;
    }
  }, M.prototype.isDiagramEmpty = function () {
    var t = this.editor.graph.getModel();
    return 1 == t.getChildCount(t.root) && 0 == t.getChildCount(t.getChildAt(t.root, 0));
  }, M.prototype.isSelectionAllowed = function (t) {
    return "SELECT" == c.getSource(t).nodeName || "INPUT" == c.getSource(t).nodeName && r.isAncestorNode(this.formatContainer, c.getSource(t));
  }, M.prototype.addBeforeUnloadListener = function () {
    window.onbeforeunload = r.bind(this, function () {
      if (!this.editor.isChromelessView()) return this.onBeforeUnload();
    });
  }, M.prototype.onBeforeUnload = function () {
    if (this.editor.modified) return d.get("allChangesLost");
  }, M.prototype.open = function () {
    try {
      null != window.opener && null != window.opener.openFile && window.opener.openFile.setConsumer(r.bind(this, function (t, e) {
        try {
          var i = r.parseXml(t);
          return this.editor.setGraphXml(i.documentElement), this.editor.setModified(!1), this.editor.undoManager.clear(), void (null != e && (this.editor.setFilename(e), this.updateDocumentTitle()));
        } catch (t) {
          r.alert(d.get("invalidOrMissingFile") + ": " + t.message);
        }
      }));
    } catch (t) {}

    this.editor.graph.view.validate(), this.editor.graph.sizeDidChange(), this.editor.fireEvent(new v("resetGraphView"));
  }, M.prototype.setCurrentMenu = function (t, e) {
    this.currentMenuElt = e, this.currentMenu = t;
  }, M.prototype.resetCurrentMenu = function () {
    this.currentMenuElt = null, this.currentMenu = null;
  }, M.prototype.hideCurrentMenu = function () {
    null != this.currentMenu && (this.currentMenu.hideMenu(), this.resetCurrentMenu());
  }, M.prototype.updateDocumentTitle = function () {
    var t = this.editor.getOrCreateFilename();
    null != this.editor.appName && (t += " - " + this.editor.appName), document.title = t;
  }, M.prototype.createHoverIcons = function () {
    return new HoverIconsBuilder(this.editor.graph, this.mx);
  }, M.prototype.redo = function () {
    try {
      this.editor.graph.isEditing() ? document.execCommand("redo", !1, null) : this.editor.undoManager.redo();
    } catch (t) {}
  }, M.prototype.undo = function () {
    try {
      var t = this.editor.graph;

      if (t.isEditing()) {
        var e = t.cellEditor.textarea.innerHTML;
        document.execCommand("undo", !1, null), e == t.cellEditor.textarea.innerHTML && (t.stopEditing(!0), this.editor.undoManager.undo());
      } else this.editor.undoManager.undo();
    } catch (t) {
      console.log("EditorUi.undo", t);
    }
  }, M.prototype.canRedo = function () {
    return this.editor.graph.isEditing() || this.editor.undoManager.canRedo();
  }, M.prototype.canUndo = function () {
    return this.editor.graph.isEditing() || this.editor.undoManager.canUndo();
  }, M.prototype.getEditBlankXml = function () {
    return r.getXml(this.editor.getGraphXml());
  }, M.prototype.getUrl = function (t) {
    var e = null != t ? t : window.location.pathname,
        i = e.indexOf("?") > 0 ? 1 : 0;

    for (var n in urlParams) {
      e += 0 == i ? "?" : "&", e += n + "=" + urlParams[n], i++;
    }

    return e;
  }, M.prototype.setScrollbars = function (t) {
    var e = this.editor.graph,
        i = e.container.style.overflow;
    if (e.scrollbars = t, this.editor.updateGraphComponents(), i != e.container.style.overflow) if ("hidden" == e.container.style.overflow) {
      var n = e.view.translate;
      e.view.setTranslate(n.x - e.container.scrollLeft / e.view.scale, n.y - e.container.scrollTop / e.view.scale), e.container.scrollLeft = 0, e.container.scrollTop = 0, e.minimumGraphSize = null, e.sizeDidChange();
    } else {
      var s = e.view.translate.x,
          o = e.view.translate.y;
      e.view.translate.x = 0, e.view.translate.y = 0, e.sizeDidChange(), e.container.scrollLeft -= Math.round(s * e.view.scale), e.container.scrollTop -= Math.round(o * e.view.scale);
    }
    this.fireEvent(new v("scrollbarsChanged"));
  }, M.prototype.hasScrollbars = function () {
    return this.editor.graph.scrollbars;
  }, M.prototype.resetScrollbars = function () {
    var t = this.editor.graph;

    if (this.editor.extendCanvas) {
      if (!this.editor.isChromelessView()) if (r.hasScrollbars(t.container)) {
        if (t.pageVisible) {
          var e = t.getPagePadding();
          t.container.scrollTop = Math.floor(e.y - this.editor.initialTopSpacing) - 1, t.container.scrollLeft = Math.floor(Math.min(e.x, (t.container.scrollWidth - t.container.clientWidth) / 2)) - 1, (i = t.getGraphBounds()).width > 0 && i.height > 0 && (i.x > t.container.scrollLeft + .9 * t.container.clientWidth && (t.container.scrollLeft = Math.min(i.x + i.width - t.container.clientWidth, i.x - 10)), i.y > t.container.scrollTop + .9 * t.container.clientHeight && (t.container.scrollTop = Math.min(i.y + i.height - t.container.clientHeight, i.y - 10)));
        } else {
          var i = t.getGraphBounds(),
              n = Math.max(i.width, t.scrollTileSize.width * t.view.scale),
              s = Math.max(i.height, t.scrollTileSize.height * t.view.scale);
          t.container.scrollTop = Math.floor(Math.max(0, i.y - Math.max(20, (t.container.clientHeight - s) / 4))), t.container.scrollLeft = Math.floor(Math.max(0, i.x - Math.max(0, (t.container.clientWidth - n) / 2)));
        }
      } else if (t.pageVisible) {
        var o = t.view.getBackgroundPageBounds();
        t.view.setTranslate(Math.floor(Math.max(0, (t.container.clientWidth - o.width) / 2) - o.x), Math.floor(Math.max(0, (t.container.clientHeight - o.height) / 2) - o.y));
      } else {
        i = t.getGraphBounds();
        t.view.setTranslate(Math.floor(Math.max(0, Math.max(0, (t.container.clientWidth - i.width) / 2) - i.x)), Math.floor(Math.max(0, Math.max(20, (t.container.clientHeight - i.height) / 4)) - i.y));
      }
    } else t.container.scrollTop = 0, t.container.scrollLeft = 0, r.hasScrollbars(t.container) || t.view.setTranslate(0, 0);
  }, M.prototype.setPageVisible = function (t) {
    var e = this.editor.graph,
        i = r.hasScrollbars(e.container),
        n = 0,
        s = 0;

    if (i && (n = e.view.translate.x * e.view.scale - e.container.scrollLeft, s = e.view.translate.y * e.view.scale - e.container.scrollTop), e.pageVisible = t, e.pageBreaksVisible = t, e.preferPageSize = t, e.view.validateBackground(), i) {
      var o = e.getSelectionCells();
      e.clearSelection(), e.setSelectionCells(o);
    }

    t ? e.sizeDidChange() : (e.view.translate = new y(), console.log("bound", e.getGraphBounds()), e.maxFitScale = 1, e.fit(), e.maxFitScale = null, e.view.viewStateChanged()), i && (e.container.scrollLeft = e.view.translate.x * e.view.scale - n, e.container.scrollTop = e.view.translate.y * e.view.scale - s), this.fireEvent(new v("pageViewChanged"));
  }, I.prototype.execute = function () {
    var t = this.ui.editor.graph;

    if (!this.ignoreColor) {
      this.color = this.previousColor;
      var e = t.background;
      this.ui.setBackgroundColor(this.previousColor), this.previousColor = e;
    }

    if (!this.ignoreImage) {
      this.image = this.previousImage;
      e = t.backgroundImage;
      this.ui.setBackgroundImage(this.previousImage), this.previousImage = e;
    }

    if (null != this.previousFormat) {
      this.format = this.previousFormat;
      e = t.pageFormat;
      this.previousFormat.width == e.width && this.previousFormat.height == e.height || (this.ui.setPageFormat(this.previousFormat), this.previousFormat = e);
    }

    null != this.foldingEnabled && this.foldingEnabled != this.ui.editor.graph.foldingEnabled && (this.ui.setFoldingEnabled(this.foldingEnabled), this.foldingEnabled = !this.foldingEnabled);
  }, (A = new h(new I(), ["ui", "previousColor", "previousImage", "previousFormat"])).afterDecode = function (t, e, i) {
    return i.previousColor = i.color, i.previousImage = i.image, i.previousFormat = i.format, null != i.foldingEnabled && (i.foldingEnabled = !i.foldingEnabled), i;
  }, u.register(A), M.prototype.setBackgroundColor = function (t) {
    this.editor.graph.background = t, this.editor.graph.view.validateBackground(), this.fireEvent(new v("backgroundColorChanged"));
  }, M.prototype.setFoldingEnabled = function (t) {
    this.editor.graph.foldingEnabled = t, this.editor.graph.view.revalidate(), this.fireEvent(new v("foldingEnabledChanged"));
  }, M.prototype.setPageFormat = function (t) {
    this.editor.graph.pageFormat = t, this.editor.graph.pageVisible ? (this.editor.graph.view.validateBackground(), this.editor.graph.sizeDidChange()) : this.actions.get("pageView").funct(), this.fireEvent(new v("pageFormatChanged"));
  }, M.prototype.setPageScale = function (t) {
    this.editor.graph.pageScale = t, this.editor.graph.pageVisible ? (this.editor.graph.view.validateBackground(), this.editor.graph.sizeDidChange()) : this.actions.get("pageView").funct(), this.fireEvent(new v("pageScaleChanged"));
  }, M.prototype.setGridColor = function (t) {
    this.editor.graph.view.gridColor = t, this.editor.graph.view.validateBackground(), this.fireEvent(new v("gridColorChanged"));
  }, M.prototype.addUndoListener = function () {
    var t = this.actions.get("undo"),
        e = this.actions.get("redo"),
        i = this.editor.undoManager,
        n = r.bind(this, function () {
      t.setEnabled(this.canUndo()), e.setEnabled(this.canRedo());
    });
    i.addListener(c.ADD, n), i.addListener(c.UNDO, n), i.addListener(c.REDO, n), i.addListener(c.CLEAR, n);
    var s = this.editor.graph.cellEditor.startEditing;

    this.editor.graph.cellEditor.startEditing = function () {
      s.apply(this, arguments), n();
    };

    var o = this.editor.graph.cellEditor.stopEditing;
    this.editor.graph.cellEditor.stopEditing = function (t, e) {
      o.apply(this, arguments), n();
    }, n();
  }, M.prototype.updateActionStates = function () {
    var t = this.editor.graph,
        e = !t.isSelectionEmpty(),
        i = !1,
        n = !1,
        s = t.getSelectionCells();
    if (null != s) for (var o = 0; o < s.length; o++) {
      var l = s[o];
      if (t.getModel().isEdge(l) && (n = !0), t.getModel().isVertex(l) && (i = !0), n && i) break;
    }
    var r = ["cut", "copy", "bold", "italic", "underline", "delete", "duplicate", "editStyle", "editTooltip", "editLink", "backgroundColor", "borderColor", "edit", "toFront", "toBack", "lockUnlock", "solid", "dashed", "pasteSize", "dotted", "fillColor", "gradientColor", "shadow", "fontColor", "formattedText", "rounded", "toggleRounded", "sharp", "strokeColor"];

    for (o = 0; o < r.length; o++) {
      this.actions.get(r[o]).setEnabled(e);
    }

    this.actions.get("setAsDefaultStyle").setEnabled(1 == t.getSelectionCount()), this.actions.get("clearWaypoints").setEnabled(!t.isSelectionEmpty()), this.actions.get("copySize").setEnabled(1 == t.getSelectionCount()), this.actions.get("turn").setEnabled(!t.isSelectionEmpty()), this.actions.get("curved").setEnabled(n), this.actions.get("rotation").setEnabled(i), this.actions.get("wordWrap").setEnabled(i), this.actions.get("autosize").setEnabled(i);
    var a = i && 1 == t.getSelectionCount();
    this.actions.get("group").setEnabled(t.getSelectionCount() > 1 || a && !t.isContainer(t.getSelectionCell())), this.actions.get("ungroup").setEnabled(1 == t.getSelectionCount() && (t.getModel().getChildCount(t.getSelectionCell()) > 0 || a && t.isContainer(t.getSelectionCell()))), this.actions.get("removeFromGroup").setEnabled(a && t.getModel().isVertex(t.getModel().getParent(t.getSelectionCell())));
    t.view.getState(t.getSelectionCell());
    this.menus && this.menus.get("navigation").setEnabled(e || null != t.view.currentRoot), this.actions.get("collapsible").setEnabled(i && (t.isContainer(t.getSelectionCell()) || t.model.getChildCount(t.getSelectionCell()) > 0)), this.actions.get("home").setEnabled(null != t.view.currentRoot), this.actions.get("exitGroup").setEnabled(null != t.view.currentRoot), this.actions.get("enterGroup").setEnabled(1 == t.getSelectionCount() && t.isValidRoot(t.getSelectionCell()));
    var h = 1 == t.getSelectionCount() && t.isCellFoldable(t.getSelectionCell());
    this.actions.get("expand").setEnabled(h), this.actions.get("collapse").setEnabled(h), this.actions.get("editLink").setEnabled(1 == t.getSelectionCount()), this.actions.get("openLink").setEnabled(1 == t.getSelectionCount() && null != t.getLinkForCell(t.getSelectionCell())), this.actions.get("guides").setEnabled(t.isEnabled()), this.actions.get("grid").setEnabled(!this.editor.chromeless || this.editor.editable);
    var u = t.isEnabled() && !t.isCellLocked(t.getDefaultParent());
    this.menus && (this.menus.get("layout").setEnabled(u), this.menus.get("insert").setEnabled(u), this.menus.get("direction").setEnabled(u && i), this.menus.get("align").setEnabled(u && i && t.getSelectionCount() > 1), this.menus.get("distribute").setEnabled(u && i && t.getSelectionCount() > 1)), this.actions.get("selectVertices").setEnabled(u), this.actions.get("selectEdges").setEnabled(u), this.actions.get("selectAll").setEnabled(u), this.actions.get("selectNone").setEnabled(u), this.updatePasteActionStates();
  }, M.prototype.refresh = function (t) {
    (t = null == t || t) && this.editor.graph.sizeDidChange();
  }, M.prototype.createTabContainer = function () {
    return null;
  }, M.prototype.createDivs = function () {
    this.menubarContainer = this.createDiv("geMenubarContainer"), this.toolbarContainer = this.createDiv("geToolbarContainer"), this.sidebarContainer = this.createDiv("geSidebarContainer"), this.formatContainer = this.createDiv("geSidebarContainer geFormatContainer"), this.diagramContainer = this.createDiv("geDiagramContainer"), this.footerContainer = this.createDiv("geFooterContainer"), this.hsplit = this.createDiv("geHsplit"), this.hsplit.setAttribute("title", d.get("collapseExpand")), this.menubarContainer.style.top = "0px", this.menubarContainer.style.left = "0px", this.menubarContainer.style.right = "0px", this.toolbarContainer.style.left = "0px", this.toolbarContainer.style.right = "0px", this.sidebarContainer.style.left = "0px", this.formatContainer.style.right = "0px", this.formatContainer.style.zIndex = "1", this.diagramContainer.style.right = (null != this.format ? this.formatWidth : 0) + "px", this.footerContainer.style.left = "0px", this.footerContainer.style.right = "0px", this.footerContainer.style.bottom = "0px", this.footerContainer.style.zIndex = p.prototype.zIndex - 2, this.hsplit.style.width = this.splitSize + "px", this.sidebarFooterContainer = this.createSidebarFooterContainer(), this.sidebarFooterContainer && (this.sidebarFooterContainer.style.left = "0px"), this.editor.chromeless ? this.diagramContainer.style.border = "none" : this.tabContainer = this.createTabContainer();
  }, M.prototype.createSidebarFooterContainer = function () {
    return null;
  }, M.prototype.handleError = function (t) {
    throw t;
  }, M.prototype.createUi = function () {
    this.menubar = !this.editor.chromeless && this.menus && this.menubarContainer ? this.menus.createMenubar(this.createDiv("geMenubar")) : null, null != this.menubar && this.menubarContainer.appendChild(this.menubar.container), this.format = (!this.editor.chromeless && this.formatEnabled && this.sidebar, null), null != this.format && this.container.appendChild(this.formatContainer), this.toolbar = this.editor.chromeless || !this.toolbarContainer ? null : this.createToolbar(this.createDiv("geToolbar")), null != this.toolbar && this.toolbarContainer.appendChild(this.toolbar.container);
  }, M.prototype.createStatusContainer = function () {
    var t = document.createElement("a");
    return t.className = "geItem geStatus", screen.width < 420 && (t.style.maxWidth = Math.max(20, screen.width - 320) + "px", t.style.overflow = "hidden"), t;
  }, M.prototype.setStatusText = function (t) {
    this.statusContainer.innerHTML = t;
  }, M.prototype.createToolbar = function (t) {
    return new ToolbarBuilder(this, t);
  }, M.prototype.createSidebar = function (t) {
    return null;
  }, M.prototype.createFormat = function (t) {
    return new Format(this, t);
  }, M.prototype.createFooter = function () {
    return this.createDiv("geFooter");
  }, M.prototype.createDiv = function (t) {
    var e = document.createElement("div");
    return e.className = t, e;
  }, M.prototype.addSplitHandler = function (t, e, i, n) {
    var s = null,
        o = null,
        a = !0,
        h = null;
    l.IS_POINTER && (t.style.touchAction = "none");
    var u = r.bind(this, function () {
      var n = parseInt(e ? t.style.left : t.style.bottom);
      return e || (n = n + i - this.footerHeight), n;
    });

    function d(t) {
      if (null != s) {
        var l = new y(c.getClientX(t), c.getClientY(t));
        n(Math.max(0, o + (e ? l.x - s.x : s.y - l.y) - i)), c.consume(t), o != u() && (a = !0, h = null);
      }
    }

    function p(t) {
      d(t), o = null, s = null;
    }

    c.addGestureListeners(t, function (t) {
      s = new y(c.getClientX(t), c.getClientY(t)), o = u(), a = !1, c.consume(t);
    }), c.addListener(t, "click", r.bind(this, function (t) {
      if (!a && this.hsplitClickEnabled) {
        var e = null != h ? h - i : 0;
        h = u(), n(e), c.consume(t);
      }
    })), c.addGestureListeners(document, null, d, p), this.destroyFunctions.push(function () {
      c.removeGestureListeners(document, null, d, p);
    });
  }, M.prototype.showDialog = function (t, e, i, n, s, o, l, r) {
    this.editor.graph.tooltipHandler.hideTooltip(), null == this.dialogs && (this.dialogs = []), this.dialog = new Dialog$1(this, t, e, i, n, s, o, l, r), this.dialogs.push(this.dialog);
  }, M.prototype.hideDialog = function (t) {
    null != this.dialogs && this.dialogs.length > 0 && (this.dialogs.pop().close(t), this.dialog = this.dialogs.length > 0 ? this.dialogs[this.dialogs.length - 1] : null, null == this.dialog && "hidden" != this.editor.graph.container.style.visibility && this.editor.graph.container.focus(), r.clearSelection(), this.editor.fireEvent(new v("hideDialog")));
  }, M.prototype.pickColor = function (t, e) {
    var i = this.editor.graph,
        n = i.cellEditor.saveSelection(),
        s = 226 + 17 * (Math.ceil(ColorDialog.prototype.presetColors.length / 12) + Math.ceil(ColorDialog.prototype.defaultColors.length / 12)),
        o = new ColorDialog(this, t || "none", function (t) {
      i.cellEditor.restoreSelection(n), e(t);
    }, function () {
      i.cellEditor.restoreSelection(n);
    });
    this.showDialog(o.container, 230, s, !0, !1), o.init();
  }, M.prototype.openFile = function () {
    window.openFile = new OpenFile(r.bind(this, function (t) {
      this.hideDialog(t);
    })), this.showDialog(new OpenDialog(this).container, L.useLocalStorage ? 640 : 320, L.useLocalStorage ? 480 : 220, !0, !0, function () {
      window.openFile = null;
    });
  }, M.prototype.extractGraphModelFromHtml = function (t) {
    var e = null;

    try {
      var i = t.indexOf("&lt;mxGraphModel ");

      if (i >= 0) {
        var n = t.lastIndexOf("&lt;/mxGraphModel&gt;");
        n > i && (e = t.substring(i, n + 21).replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/\\&quot;/g, '"').replace(/\n/g, ""));
      }
    } catch (t) {}

    return e;
  }, M.prototype.extractGraphModelFromEvent = function (t) {
    var e = null,
        i = null;

    if (null != t) {
      var n = null != t.dataTransfer ? t.dataTransfer : t.clipboardData;

      if (null != n && (10 == document.documentMode || 11 == document.documentMode ? i = n.getData("Text") : (i = r.indexOf(n.types, "text/html") >= 0 ? n.getData("text/html") : null, r.indexOf(n.types, null == i || 0 == i.length) && (i = n.getData("text/plain"))), null != i)) {
        i = this.editor.graph.zapGremlins(r.trim(i));
        var s = this.extractGraphModelFromHtml(i);
        null != s && (i = s);
      }
    }

    return null != i && this.isCompatibleString(i) && (e = i), e;
  }, M.prototype.isCompatibleString = function (t) {
    return !1;
  }, M.prototype.saveFile = function (t) {
    if (t || null == this.editor.filename) {
      var e = new FilenameDialog(this, this.editor.getOrCreateFilename(), d.get("save"), r.bind(this, function (t) {
        this.save(t);
      }), null, r.bind(this, function (t) {
        return null != t && t.length > 0 || (r.confirm(d.get("invalidName")), !1);
      }));
      this.showDialog(e.container, 300, 100, !0, !0), e.init();
    } else this.save(this.editor.getOrCreateFilename());
  }, M.prototype.save = function (t) {
    if (null != t) {
      this.editor.graph.isEditing() && this.editor.graph.stopEditing();
      var e = r.getXml(this.editor.getGraphXml());

      try {
        if (L.useLocalStorage) {
          if (null != localStorage.getItem(t) && !r.confirm(d.get("replaceIt", [t]))) return;
          localStorage.setItem(t, e), this.editor.setStatus(r.htmlEntities(d.get("saved")) + " " + new Date());
        } else {
          if (!(e.length < MAX_REQUEST_SIZE)) return r.alert(d.get("drawingTooLarge")), void r.popup(e);
          new w(SAVE_URL, "filename=" + encodeURIComponent(t) + "&xml=" + encodeURIComponent(e)).simulate(document, "_blank");
        }

        this.editor.setModified(!1), this.editor.setFilename(t), this.updateDocumentTitle();
      } catch (t) {
        this.editor.setStatus(r.htmlEntities(d.get("errorSavingFile")));
      }
    }
  }, M.prototype.executeLayout = function (t, e, i) {
    var n = this.editor.graph;

    if (n.isEnabled()) {
      n.getModel().beginUpdate();

      try {
        t();
      } catch (t) {
        throw t;
      } finally {
        if (this.allowAnimation && e && navigator.userAgent.indexOf("Camino") < 0) {
          var s = new b(n);
          s.addListener(c.DONE, r.bind(this, function () {
            n.getModel().endUpdate(), null != i && i();
          })), s.startAnimation();
        } else n.getModel().endUpdate(), null != i && i();
      }
    }
  }, M.prototype.showImageDialog = function (t, e, i, n) {
    var s = this.editor.graph.cellEditor,
        o = s.saveSelection(),
        l = r.prompt(t, e);

    if (s.restoreSelection(o), null != l && l.length > 0) {
      var a = new Image();
      a.onload = function () {
        i(l, a.width, a.height);
      }, a.onerror = function () {
        i(null), r.alert(d.get("fileNotFound"));
      }, a.src = l;
    } else i(null);
  }, M.prototype.showLinkDialog = function (t, e, i) {
    var n = new LinkDialog(this, t, e, i);
    this.showDialog(n.container, 420, 90, !0, !0), n.init();
  }, M.prototype.showDataDialog = function (t) {
    if (null != t) {
      var e = new EditDataDialog(this, t);
      this.showDialog(e.container, 340, 340, !0, !1, null, !1), e.init();
    }
  }, M.prototype.showBackgroundImageDialog = function (t) {
    t = null != t ? t : r.bind(this, function (t) {
      var e = new I(this, null, t);
      e.ignoreColor = !0, this.editor.graph.model.execute(e);
    });
    var e = r.prompt(d.get("backgroundImage"), "");

    if (null != e && e.length > 0) {
      var i = new Image();
      i.onload = function () {
        t(new S(e, i.width, i.height));
      }, i.onerror = function () {
        t(null), r.alert(d.get("fileNotFound"));
      }, i.src = e;
    } else t(null);
  }, M.prototype.setBackgroundImage = function (t) {
    this.editor.graph.setBackgroundImage(t), this.editor.graph.view.validateBackgroundImage(), this.fireEvent(new v("backgroundImageChanged"));
  }, M.prototype.confirm = function (t, e, i) {
    r.confirm(t) ? null != e && e() : null != i && i();
  }, M.prototype.createOutline = function (t) {
    var e = new E(this.editor.graph);
    return e.border = 20, c.addListener(window, "resize", function () {
      e.update();
    }), this.addListener("pageFormatChanged", function () {
      e.update();
    }), e;
  }, M.prototype.altShiftActions = {
    67: "clearWaypoints",
    65: "connectionArrows",
    76: "editLink",
    80: "connectionPoints",
    84: "editTooltip",
    86: "pasteSize",
    88: "copySize"
  }, M.prototype.createKeyHandler = function (t) {
    var e = this,
        i = this.editor.graph,
        n = new m(i),
        s = n.isEventIgnored;
    n.isEventIgnored = function (t) {
      return (!this.isControlDown(t) || c.isShiftDown(t) || 90 != t.keyCode && 89 != t.keyCode && 188 != t.keyCode && 190 != t.keyCode && 85 != t.keyCode) && (66 != t.keyCode && 73 != t.keyCode || !this.isControlDown(t) || this.graph.cellEditor.isContentEditing() && !l.IS_FF && !l.IS_SF) && s.apply(this, arguments);
    }, n.isEnabledForEvent = function (t) {
      return !c.isConsumed(t) && this.isGraphEvent(t) && this.isEnabled() && (null == e.dialogs || 0 == e.dialogs.length);
    }, n.isControlDown = function (t) {
      return c.isControlDown(t) || l.IS_MAC && t.metaKey;
    };
    var o = [],
        a = null;

    function h(t, e, n) {
      o.push(function () {
        if (!i.isSelectionEmpty() && i.isEnabled()) if (e = null != e ? e : 1, n) {
          i.getModel().beginUpdate();

          try {
            for (var s = i.getSelectionCells(), o = 0; o < s.length; o++) {
              if (i.getModel().isVertex(s[o]) && i.isCellResizable(s[o])) {
                var l = i.getCellGeometry(s[o]);
                null != l && (l = l.clone(), 37 == t ? l.width = Math.max(0, l.width - e) : 38 == t ? l.height = Math.max(0, l.height - e) : 39 == t ? l.width += e : 40 == t && (l.height += e), i.getModel().setGeometry(s[o], l));
              }
            }
          } finally {
            i.getModel().endUpdate();
          }
        } else {
          var r = i.getSelectionCell(),
              a = i.model.getParent(r),
              h = null;

          if (1 == i.getSelectionCount() && i.model.isVertex(r) && null != i.layoutManager && !i.isCellLocked(r) && (h = i.layoutManager.getLayout(a)), null != h && h.constructor == C) {
            var u = a.getIndex(r);
            37 == t || 38 == t ? i.model.add(a, r, Math.max(0, u - 1)) : 39 != t && 40 != t || i.model.add(a, r, Math.min(i.model.getChildCount(a), u + 1));
          } else {
            var d = 0,
                p = 0;
            37 == t ? d = -e : 38 == t ? p = -e : 39 == t ? d = e : 40 == t && (p = e), i.moveCells(i.getMovableCells(i.getSelectionCells()), d, p);
          }
        }
      }), null != a && window.clearTimeout(a), a = window.setTimeout(function () {
        if (o.length > 0) {
          i.getModel().beginUpdate();

          try {
            for (var t = 0; t < o.length; t++) {
              o[t]();
            }

            o = [];
          } finally {
            i.getModel().endUpdate();
          }

          i.scrollCellToVisible(i.getSelectionCell());
        }
      }, 200);
    }

    var u = {
      37: g.DIRECTION_WEST,
      38: g.DIRECTION_NORTH,
      39: g.DIRECTION_EAST,
      40: g.DIRECTION_SOUTH
    },
        d = n.getFunction;
    m.prototype.getFunction = function (t) {
      if (i.isEnabled()) {
        if (c.isShiftDown(t) && c.isAltDown(t)) {
          var n = e.actions.get(e.altShiftActions[t.keyCode]);
          if (null != n) return n.funct;
        }

        if (9 == t.keyCode && c.isAltDown(t)) return c.isShiftDown(t) ? function () {
          i.selectParentCell();
        } : function () {
          i.selectChildCell();
        };

        if (null != u[t.keyCode] && !i.isSelectionEmpty()) {
          if (!c.isShiftDown(t) || !c.isAltDown(t)) return this.isControlDown(t) ? function () {
            h(t.keyCode, c.isShiftDown(t) ? i.gridSize : null, !0);
          } : function () {
            h(t.keyCode, c.isShiftDown(t) ? i.gridSize : null);
          };
          if (i.model.isVertex(i.getSelectionCell())) return function () {
            var n = i.connectVertex(i.getSelectionCell(), u[t.keyCode], i.defaultEdgeLength, t, !0);
            null != n && n.length > 0 && (1 == n.length && i.model.isEdge(n[0]) ? i.setSelectionCell(i.model.getTerminal(n[0], !1)) : i.setSelectionCell(n[n.length - 1]), i.scrollCellToVisible(i.getSelectionCell()), null != e.hoverIcons && e.hoverIcons.update(i.view.getState(i.getSelectionCell())));
          };
        }
      }

      return d.apply(this, arguments);
    }, n.bindAction = r.bind(this, function (t, e, i, s) {
      var o = this.actions.get(i);

      if (null != o) {
        var l = function l() {
          o.isEnabled() && o.funct();
        };

        e ? s ? n.bindControlShiftKey(t, l) : n.bindControlKey(t, l) : s ? n.bindShiftKey(t, l) : n.bindKey(t, l);
      }
    });
    var p = n.escape;
    return n.escape = function (t) {
      p.apply(this, arguments);
    }, n.enter = function () {}, n.bindControlShiftKey(36, function () {
      i.exitGroup();
    }), n.bindControlShiftKey(35, function () {
      i.enterGroup();
    }), n.bindKey(36, function () {
      i.home();
    }), n.bindKey(35, function () {
      i.refresh();
    }), n.bindAction(107, !0, "zoomIn"), n.bindAction(109, !0, "zoomOut"), n.bindAction(80, !0, "print"), n.bindAction(79, !0, "outline", !0), n.bindAction(112, !1, "about"), this.editor.chromeless && !this.editor.editable || (n.bindControlKey(36, function () {
      i.isEnabled() && i.foldCells(!0);
    }), n.bindControlKey(35, function () {
      i.isEnabled() && i.foldCells(!1);
    }), n.bindControlKey(13, function () {
      i.isEnabled() && i.setSelectionCells(i.duplicateCells(i.getSelectionCells(), !1));
    }), n.bindAction(8, !1, "delete"), n.bindAction(8, !0, "deleteAll"), n.bindAction(46, !1, "delete"), n.bindAction(46, !0, "deleteAll"), n.bindAction(72, !0, "resetView"), n.bindAction(72, !0, "fitWindow", !0), n.bindAction(74, !0, "fitPage"), n.bindAction(74, !0, "fitTwoPages", !0), n.bindAction(48, !0, "customZoom"), n.bindAction(82, !0, "turn"), n.bindAction(82, !0, "clearDefaultStyle", !0), n.bindAction(83, !0, "save"), n.bindAction(83, !0, "saveAs", !0), n.bindAction(65, !0, "selectAll"), n.bindAction(65, !0, "selectNone", !0), n.bindAction(73, !0, "selectVertices", !0), n.bindAction(69, !0, "selectEdges", !0), n.bindAction(69, !0, "editStyle"), n.bindAction(66, !0, "bold"), n.bindAction(66, !0, "toBack", !0), n.bindAction(70, !0, "toFront", !0), n.bindAction(68, !0, "duplicate"), n.bindAction(68, !0, "setAsDefaultStyle", !0), n.bindAction(90, !0, "undo"), n.bindAction(89, !0, "autosize", !0), n.bindAction(88, !0, "cut"), n.bindAction(67, !0, "copy"), n.bindAction(86, !0, "paste"), n.bindAction(71, !0, "group"), n.bindAction(77, !0, "editData"), n.bindAction(71, !0, "grid", !0), n.bindAction(73, !0, "italic"), n.bindAction(76, !0, "lockUnlock"), n.bindAction(76, !0, "layers", !0), n.bindAction(80, !0, "formatPanel", !0), n.bindAction(85, !0, "underline"), n.bindAction(85, !0, "ungroup", !0), n.bindAction(190, !0, "superscript"), n.bindAction(188, !0, "subscript"), n.bindKey(13, function () {
      i.isEnabled() && i.startEditingAtCell();
    }), n.bindKey(113, function () {
      i.isEnabled() && i.startEditingAtCell();
    })), l.IS_WIN ? n.bindAction(89, !0, "redo") : n.bindAction(90, !0, "redo", !0), n;
  }, M.prototype.destroy = function () {
    if (null != this.editor && (this.editor.destroy(), this.editor = null), null != this.menubar && (this.menubar.destroy(), this.menubar = null), null != this.toolbar && (this.toolbar.destroy(), this.toolbar = null), null != this.sidebar && (this.sidebar.destroy(), this.sidebar = null), null != this.keyHandler && (this.keyHandler.destroy(), this.keyHandler = null), null != this.keydownHandler && (c.removeListener(document, "keydown", this.keydownHandler), this.keydownHandler = null), null != this.keyupHandler && (c.removeListener(document, "keyup", this.keyupHandler), this.keyupHandler = null), null != this.resizeHandler && (c.removeListener(window, "resize", this.resizeHandler), this.resizeHandler = null), null != this.gestureHandler && (c.removeGestureListeners(document, this.gestureHandler), this.gestureHandler = null), null != this.orientationChangeHandler && (c.removeListener(window, "orientationchange", this.orientationChangeHandler), this.orientationChangeHandler = null), null != this.scrollHandler && (c.removeListener(window, "scroll", this.scrollHandler), this.scrollHandler = null), null != this.destroyFunctions) {
      for (var t = 0; t < this.destroyFunctions.length; t++) {
        this.destroyFunctions[t]();
      }

      this.destroyFunctions = null;
    }

    var e = [this.menubarContainer, this.toolbarContainer, this.sidebarContainer, this.formatContainer, this.diagramContainer, this.footerContainer, this.chromelessToolbar, this.hsplit, this.sidebarFooterContainer, this.layersDialog];

    for (t = 0; t < e.length; t++) {
      null != e[t] && null != e[t].parentNode && e[t].parentNode.removeChild(e[t]);
    }
  }, new M(t, e, i, n, s, o);
}

var GraphLib$1 = GraphLib,
    EditorDsl = EditorDslBuilder,
    Editor$2 = EditorBuilder;
export { Editor$2 as Editor, EditorDsl, GraphLib$1 as GraphLib };